import{useState,useEffect,useRef,useCallback}from"react";
import{t,LANGUAGES,getCurrentLanguage,setLanguage}from"./translations";
// eslint-disable-next-line no-unused-vars
import{saveOrderToDb,fetchOrders,updateOrderStatus as dbUpdateOrderStatus,submitReview as dbSubmitReview,fetchReviews as dbFetchReviews,fetchMenu as dbFetchMenu,saveMenuItem as dbSaveMenuItem,deleteMenuItem as dbDeleteMenuItem,fetchCategories as dbFetchCategories,saveCategory as dbSaveCategory,deleteCategory as dbDeleteCategory,fetchSetMeals as dbFetchSetMeals,saveSetMeal as dbSaveSetMeal,deleteSetMeal as dbDeleteSetMeal,fetchOpeningHours as dbFetchHours,saveOpeningHours as dbSaveHours,saveReservation as dbSaveReservation,fetchReservations as dbFetchReservations,updateReservationStatus as dbUpdateReservationStatus,fetchTables as dbFetchTables,updateTableStatus as dbUpdateTableStatus,saveTable as dbSaveTable,deleteTable as dbDeleteTable,updateOrderPayment as dbUpdateOrderPayment,registerCustomer as dbRegisterCustomer,loginCustomer as dbLoginCustomer,fetchAllDeliverySettings as dbFetchAllDelivery,saveDeliverySettings as dbSaveDelivery,fetchDiscountCodes as dbFetchCodes,saveDiscountCode as dbSaveCode,deleteDiscountCode as dbDeleteCode,fetchAutoDiscounts as dbFetchAutoDiscounts,saveAutoDiscount as dbSaveAutoDiscount,fetchCustomers as dbFetchCustomers,saveCustomer as dbSaveCustomer,updateCustomerStats as dbUpdateCustomerStats,deleteAutoDiscount as dbDeleteAutoDiscount,fetchStations as dbFetchStations,saveStation as dbSaveStation,deleteStation as dbDeleteStation,updateStationProgress as dbUpdateStationProgress,verifyDeliveryCode as dbVerifyCode,recordCashCollected as dbRecordCash,fetchCashHandovers as dbFetchHandovers,recordCashHandover as dbRecordHandover,fetchCustomerLoyalty as dbFetchLoyalty,awardLoyaltyPoints as dbAwardPoints,redeemLoyaltyPoints as dbRedeemPoints,fetchLoyaltyHistory as dbLoyaltyHistory,fetchDietaryPrefs as dbFetchPrefs,saveDietaryPrefs as dbSavePrefs,fetchSchedules as dbFetchSchedules,saveSchedule as dbSaveSchedule,deleteSchedule as dbDeleteSchedule,clockIn as dbClockIn,clockOut as dbClockOut,fetchClockRecords as dbFetchClockRecords,fetchCurrentlyClockedIn as dbFetchClockedIn,fetchBranchHours as dbFetchBranchHours,saveBranchHours as dbSaveBranchHours,deleteBranchHours as dbDeleteBranchHours,fetchBranchHolidays as dbFetchHolidays,saveBranchHoliday as dbSaveHoliday,deleteBranchHoliday as dbDeleteHoliday,fetchBranchHoursConfig as dbFetchHoursConfig,saveBranchHoursConfig as dbSaveHoursConfig,recordPayment as dbRecordPayment,openShift as dbOpenShift,closeShift as dbCloseShift,fetchOpenShift as dbFetchOpenShift,fetchShifts as dbFetchShifts,updateShiftSales as dbUpdateShiftSales,recordVoid as dbRecordVoid,verifyManagerPin as dbVerifyPin,recordDrawerEvent as dbRecordDrawer,fetchExpenseCategories as dbFetchExpenseCats,saveExpenseCategory as dbSaveExpenseCat,deleteExpenseCategory as dbDeleteExpenseCat,fetchExpenses as dbFetchExpenses,saveExpense as dbSaveExpense,deleteExpense as dbDeleteExpense,fetchRecurringExpenses as dbFetchRecurring,saveRecurringExpense as dbSaveRecurring,deleteRecurringExpense as dbDeleteRecurring,updateRecurringLastGenerated as dbUpdateRecurringDate,fetchRestaurant as dbFetchRestaurant,autoDetectMyRestaurant,signupRestaurant as dbSignup,loginRestaurant as dbLogin,verifyEmail as dbVerifyEmail,resendVerification as dbResendVer,getCurrentOwner as dbGetOwner,saveCurrentOwner as dbSaveOwner,logoutSaaS as dbLogoutSaaS,getCurrentSaasRestaurant as dbGetSaasRest,switchRestaurant as dbSwitchRest,fetchAllRestaurants as dbFetchAllRests,updateRestaurant as dbUpdateRestaurant,detectRestaurantFromUrl as dbDetectFromUrl,fetchPublicRestaurants as dbFetchPublicRests,updateRestaurantOrderTypes as dbUpdateOrderTypes,isSuperAdmin as dbIsSuperAdmin,fetchAllRestaurantsWithStats as dbFetchAllRestStats,fetchPlatformStats as dbFetchPlatStats,fetchPlatformActivity as dbFetchPlatActivity,updateRestaurantPlan as dbUpdatePlan,toggleRestaurantActive as dbToggleActive,impersonateRestaurant as dbImpersonate,stopImpersonation as dbStopImpersonate,isImpersonating as dbIsImpersonating,adminCreateRestaurant as dbAdminCreate,adminUpdateRestaurant as dbAdminUpdate,adminDeleteRestaurant as dbAdminDelete,adminResetOwnerPassword as dbAdminResetPwd,fetchStaffMembers as dbFetchStaff,fetchStaffMember as dbFetchOneStaff,fetchDrivers as dbFetchDrivers,createStaffMember as dbCreateStaff,updateStaffMember as dbUpdateStaff,deleteStaffMember as dbDeleteStaff,employeeClockIn as dbStaffClockIn,employeeClockOut as dbStaffClockOut,fetchEmployeeClockRecords as dbFetchClock,fetchCurrentlyClocked as dbFetchCurrentClocked,fetchStaffSchedules as dbFetchSchedules2,saveStaffSchedule as dbSaveSchedule2,deleteStaffSchedule as dbDeleteSchedule2,calculatePayroll as dbCalcPayroll,saveStaffPayroll as dbSavePayroll,fetchPayrollHistory as dbFetchPayroll,verifyStaffPIN as dbVerifyStaffPIN,setActiveStaff as dbSetActiveStaff,getActiveStaff as dbGetActiveStaff,clearActiveStaff as dbClearActiveStaff,staffHasPermission as dbStaffHasPerm,hasFeature,hasService,getFeatureLimit,updateServiceTypes as dbUpdateServiceTypes,updateAddonFeatures as dbUpdateAddonFeats,getFeatureLockState,canOwnerToggle,updateFeatureLocks as dbUpdateLocks,checkSubscriptionStatus,uploadMenuImage as dbUploadMenuImage,deleteMenuImage as dbDeleteMenuImage,fetchAllReps as dbFetchAllReps,fetchRepPerformance as dbFetchRepPerf,createRep as dbCreateRep,updateRep as dbUpdateRep,deleteRep as dbDeleteRep,loginRep as dbLoginRep,saveCurrentRep as dbSaveRep,getCurrentRep as dbGetRep,logoutRep as dbLogoutRep,fetchRepSubscriptions as dbFetchRepSubs,fetchRepCommissions as dbFetchRepComm,fetchAllCommissions as dbFetchAllComm,createCommission as dbCreateComm,markCommissionPaid as dbMarkCommPaid,calculateSignupCommission,assignRepToRestaurant as dbAssignRep,fetchCredits as dbFetchCredits,buyCredits as dbBuyCredits,completePurchase as dbCompletePurchase,fetchPurchases as dbFetchPurchases,fetchCampaigns as dbFetchCampaigns,createCampaign as dbCreateCampaign,deleteCampaign as dbDeleteCampaign,sendCampaign as dbSendCampaign,getAudienceCount as dbGetAudienceCount,getAudienceCustomers as dbGetAudienceCustomers,createStripeCheckout as dbStripeCheckout,recordManualPayment as dbManualPayment,approveManualPayment as dbApproveManual,sendSmsCampaignReal as dbSendSmsReal,sendEmailCampaignReal as dbSendEmailReal,fetchAllPendingPurchases as dbFetchPendingPurchases,fetchAllPurchases as dbFetchAllPurchases,rejectManualPayment as dbRejectManual,loginDriverByEmail as dbDriverEmail,loginDriverByPin as dbDriverPin,saveCurrentDriver as dbSaveDriver,getCurrentDriver as dbGetDriver,logoutDriver as dbLogoutDriver,fetchDriverOrders as dbFetchDriverOrders,claimOrder as dbClaimOrder,unclaimOrder as dbUnclaimOrder,startDelivery as dbStartDelivery,recordDriverCashCollection as dbDriverCash,markOrderDelivered as dbMarkDelivered,setCurrentRestaurantId as dbSetRestaurantId,getDriverCashToHandover as dbCashToHandover,initiateHandover as dbInitiateHandover,getDriverPendingHandover as dbPendingHandover,cancelHandover as dbCancelHandover,getHandoverHistory as dbHandoverHistory,getPendingHandovers as dbGetPendingHandovers,confirmHandover as dbConfirmHandover,sendTeamMessage as dbSendTeamMsg,fetchTeamMessages as dbFetchTeamMsgs,getRestaurantCommission as dbGetRestCommission,getAllCommissions as dbGetAllCommissions,markRestaurantCommissionPaid as dbMarkRestCommPaid,saveRestaurantLogo as dbSaveLogo,saveRestaurantLogoSize as dbSaveLogoSize,updateMenuItem as dbUpdateMenuItem,SMS_PACKAGES,EMAIL_PACKAGES,PLAN_FEATURES}from"./supabaseClient";

//  OFFLINE STORAGE 
// Safe localStorage wrappers - fail silently in sandboxed environments
var LS={
  get:k=>{try{var v=localStorage.getItem(k);return v?JSON.parse(v):null;}catch(e){return null;}},
  set:(k,v)=>{try{localStorage.setItem(k,JSON.stringify(v));return true;}catch(e){return false;}},
  del:k=>{try{localStorage.removeItem(k);}catch(e){}},
};

// Detect online status
var isOnline=()=>typeof navigator!=="undefined"&&navigator.onLine!==false;

// Offline order queue - stored until internet returns
var OFFLINE_QUEUE_KEY="latavola_offline_queue";
var OFFLINE_MENU_KEY="latavola_offline_menu";
var queueOffline=order=>{
  var q=LS.get(OFFLINE_QUEUE_KEY)||[];
  q.push({...order,queuedAt:Date.now()});
  LS.set(OFFLINE_QUEUE_KEY,q);
  return q.length;
};
var getQueue=()=>LS.get(OFFLINE_QUEUE_KEY)||[];
var clearQueue=()=>LS.del(OFFLINE_QUEUE_KEY);

// Cache critical data for offline use
var cacheForOffline=(key,data)=>{LS.set(key,{data,cachedAt:Date.now()});};
var getCached=(key)=>{var c=LS.get(key);return c?c.data:null;};

// String.fromCharCode with surrogate pairs - CONFIRMED WORKING in emoji-test.jsx
var EM={
  // Original
  squid:String.fromCharCode(0xD83E,0xDD91),tomato:String.fromCharCode(0xD83C,0xDF45),
  soup:String.fromCharCode(0xD83C,0xDF72),pizza:String.fromCharCode(0xD83C,0xDF55),
  burger:String.fromCharCode(0xD83C,0xDF54),fish:String.fromCharCode(0xD83D,0xDC1F),
  pasta:String.fromCharCode(0xD83C,0xDF5D),fries:String.fromCharCode(0xD83C,0xDF5F),
  salad:String.fromCharCode(0xD83E,0xDD57),coffee:String.fromCharCode(0x2615),
  choc:String.fromCharCode(0xD83C,0xDF6B),drink:String.fromCharCode(0xD83E,0xDD64),
  water:String.fromCharCode(0xD83D,0xDCA7),cart:String.fromCharCode(0xD83D,0xDED2),
  pin:String.fromCharCode(0xD83D,0xDCCD),cal:String.fromCharCode(0xD83D,0xDCC5),
  star:String.fromCharCode(0x2B50),person:String.fromCharCode(0xD83D,0xDC64),
  chat:String.fromCharCode(0xD83D,0xDCAC),cook:String.fromCharCode(0xD83C,0xDF73),
  gear:String.fromCharCode(0x2699),chart:String.fromCharCode(0xD83D,0xDCCA),
  party:String.fromCharCode(0xD83C,0xDF89),bag:String.fromCharCode(0xD83D,0xDECD),
  wave:String.fromCharCode(0xD83D,0xDC4B),pound:String.fromCharCode(0x00A3),
  // Indian / South Asian food
  curry:String.fromCharCode(0xD83C,0xDF5B),       // rice curry
  rice:String.fromCharCode(0xD83C,0xDF5A),        // cooked rice
  ricebowl:String.fromCharCode(0xD83C,0xDF5A),
  naan:String.fromCharCode(0xD83E,0xDED3),        // flatbread
  flatbread:String.fromCharCode(0xD83E,0xDED3),
  samosa:String.fromCharCode(0xD83E,0xDD60),       // dumpling (closest)
  dumpling:String.fromCharCode(0xD83E,0xDD5F),
  falafel:String.fromCharCode(0xD83E,0xDDC6),
  shawarma:String.fromCharCode(0xD83E,0xDD59),     // stuffed flatbread
  kebab:String.fromCharCode(0xD83C,0xDF62),        // oden (skewer)
  skewer:String.fromCharCode(0xD83C,0xDF62),
  chicken:String.fromCharCode(0xD83C,0xDF57),      // chicken leg
  chickenleg:String.fromCharCode(0xD83C,0xDF57),
  meat:String.fromCharCode(0xD83E,0xDD69),         // cut of meat
  bacon:String.fromCharCode(0xD83E,0xDD53),
  egg:String.fromCharCode(0xD83E,0xDD5A),          // egg
  friedegg:String.fromCharCode(0xD83C,0xDF73),     // cooking
  cheese:String.fromCharCode(0xD83E,0xDDC0),
  // Rice dishes
  bento:String.fromCharCode(0xD83C,0xDF71),        // looks like thali
  thali:String.fromCharCode(0xD83C,0xDF71),        // bento box - works for thali
  // Breads / starters
  bread:String.fromCharCode(0xD83C,0xDF5E),        // bread loaf
  bagel:String.fromCharCode(0xD83E,0xDD6F),
  croissant:String.fromCharCode(0xD83E,0xDD50),
  pretzel:String.fromCharCode(0xD83E,0xDD68),
  // Mains
  sushi:String.fromCharCode(0xD83C,0xDF63),
  noodles:String.fromCharCode(0xD83C,0xDF5C),
  ramen:String.fromCharCode(0xD83C,0xDF5C),
  steak:String.fromCharCode(0xD83E,0xDD69),
  bowl:String.fromCharCode(0xD83E,0xDD58),         // shallow bowl with spoon
  pot:String.fromCharCode(0xD83C,0xDF72),          // pot of food
  // Sides
  corn:String.fromCharCode(0xD83C,0xDF3D),
  carrot:String.fromCharCode(0xD83E,0xDD55),
  potato:String.fromCharCode(0xD83E,0xDD54),
  broccoli:String.fromCharCode(0xD83E,0xDD66),
  onion:String.fromCharCode(0xD83E,0xDDC5),
  garlic:String.fromCharCode(0xD83E,0xDDC4),
  chili:String.fromCharCode(0xD83C,0xDF36),        // hot pepper
  pepper:String.fromCharCode(0xD83C,0xDF36),
  // Desserts
  cake:String.fromCharCode(0xD83C,0xDF70),
  shortcake:String.fromCharCode(0xD83C,0xDF70),
  cupcake:String.fromCharCode(0xD83E,0xDDC1),
  donut:String.fromCharCode(0xD83C,0xDF69),
  cookie:String.fromCharCode(0xD83C,0xDF6A),
  icecream:String.fromCharCode(0xD83C,0xDF68),
  sweet:String.fromCharCode(0xD83C,0xDF6C),        // candy
  pudding:String.fromCharCode(0xD83C,0xDF6E),      // custard/flan
  honey:String.fromCharCode(0xD83C,0xDF6F),
  lolly:String.fromCharCode(0xD83C,0xDF6D),
  // Drinks
  tea:String.fromCharCode(0xD83C,0xDF75),          // teacup - perfect for chai
  chai:String.fromCharCode(0xD83C,0xDF75),
  milk:String.fromCharCode(0xD83E,0xDD5B),
  beer:String.fromCharCode(0xD83C,0xDF7A),
  wine:String.fromCharCode(0xD83C,0xDF77),
  cocktail:String.fromCharCode(0xD83C,0xDF78),
  tropical:String.fromCharCode(0xD83C,0xDF79),     // tropical drink
  champagne:String.fromCharCode(0xD83C,0xDF7E),
  bottle:String.fromCharCode(0xD83C,0xDF7E),
  sake:String.fromCharCode(0xD83C,0xDF76),
  juice:String.fromCharCode(0xD83E,0xDDC3),        // beverage box
  bubbletea:String.fromCharCode(0xD83E,0xDDCB),
  matcha:String.fromCharCode(0xD83C,0xDF75),
  // Fruits
  apple:String.fromCharCode(0xD83C,0xDF4E),
  banana:String.fromCharCode(0xD83C,0xDF4C),
  mango:String.fromCharCode(0xD83E,0xDD6D),        // mango
  coconut:String.fromCharCode(0xD83E,0xDD65),
  lemon:String.fromCharCode(0xD83C,0xDF4B),
  orange:String.fromCharCode(0xD83C,0xDF4A),
  grape:String.fromCharCode(0xD83C,0xDF47),
  watermelon:String.fromCharCode(0xD83C,0xDF49),
  strawberry:String.fromCharCode(0xD83C,0xDF53),
  pineapple:String.fromCharCode(0xD83C,0xDF4D),
  // Nuts & seeds
  peanuts:String.fromCharCode(0xD83E,0xDD5C),
  // Halal / dietary indicator icons
  fire:String.fromCharCode(0xD83D,0xDD25),         // spicy
  spicy:String.fromCharCode(0xD83C,0xDF36),        // hot pepper
  leaf:String.fromCharCode(0xD83C,0xDF43),         // vegetarian
  veg:String.fromCharCode(0xD83C,0xDF31),          // seedling
  money:String.fromCharCode(0xD83D,0xDCB0),
  phone:String.fromCharCode(0xD83D,0xDCDE),
  clock:String.fromCharCode(0xD83D,0xDD52),        // 3 o'clock
  check:String.fromCharCode(0x2705),
  cross:String.fromCharCode(0x274C),
};
var fmt=n=>{var v=Number(n);return EM.pound+(isNaN(v)?"0.00":v.toFixed(2));};
var nowT=()=>new Date().toLocaleTimeString("en-GB",{hour:"2-digit",minute:"2-digit"});
var uid=()=>"ORD-"+Math.floor(Math.random()*90000+10000);
var rid=()=>"RES-"+Math.floor(Math.random()*9000+1000);

// eslint-disable-next-line no-unused-vars
var MENU=[
  {id:1,cat:"Starters",name:"Crispy Calamari",price:8.99,desc:"Lightly breaded with aioli",icon:"squid",avail:true,stock:20},
  {id:2,cat:"Starters",name:"Bruschetta",price:6.49,desc:"Tomato, basil and mozzarella",icon:"tomato",avail:true,stock:15},
  {id:3,cat:"Starters",name:"Soup of the Day",price:5.99,desc:"Rotating seasonal selection",icon:"soup",avail:true,stock:8},
  {id:4,cat:"Mains",name:"Margherita Pizza",price:13.99,desc:"San Marzano tomato, fior di latte",icon:"pizza",avail:true,stock:25},
  {id:5,cat:"Mains",name:"Beef Burger",price:14.99,desc:"6oz patty, cheddar, lettuce, tomato",icon:"burger",avail:true,stock:18},
  {id:6,cat:"Mains",name:"Grilled Salmon",price:18.99,desc:"Lemon butter, seasonal veg",icon:"fish",avail:true,stock:10},
  {id:7,cat:"Mains",name:"Pasta Carbonara",price:12.99,desc:"Pancetta, egg, pecorino",icon:"pasta",avail:true,stock:20},
  {id:8,cat:"Sides",name:"Truffle Fries",price:4.99,desc:"Parmesan and truffle oil",icon:"fries",avail:true,stock:30},
  {id:9,cat:"Sides",name:"Garden Salad",price:4.49,desc:"Mixed leaves, cucumber, tomato",icon:"salad",avail:true,stock:20},
  {id:10,cat:"Desserts",name:"Tiramisu",price:6.99,desc:"Espresso and mascarpone",icon:"coffee",avail:true,stock:12},
  {id:11,cat:"Desserts",name:"Choc Lava Cake",price:7.49,desc:"Warm centre, vanilla ice cream",icon:"choc",avail:true,stock:10},
  {id:12,cat:"Drinks",name:"Soft Drink",price:2.99,desc:"Cola, Lemonade, OJ",icon:"drink",avail:true,stock:50},
  {id:13,cat:"Drinks",name:"Sparkling Water",price:1.99,desc:"500ml bottle",icon:"water",avail:true,stock:40},
];
var BRANCHES=[
  {id:"b1",name:"City Centre",addr:"12 King Street, London EC2A",phone:"020 7123 4567",lat:51.5195,lng:-0.0876,
    delivery:{enabled:true,method:"postcode",postcodes:["EC1","EC2","EC3","EC4","E1","E14","N1"],radius:0,zones:[],flatFee:2.50,freeOver:25,minOrder:15},
    cod:{enabled:true,minOrder:15,maxMiles:3}},
  {id:"b2",name:"Canary Wharf",addr:"One Canada Square, London E14",phone:"020 7987 6543",lat:51.5049,lng:-0.0195,
    delivery:{enabled:true,method:"radius",postcodes:[],radius:3,zones:[],flatFee:0,freeOver:0,minOrder:10},
    cod:{enabled:false,minOrder:20,maxMiles:2}},
  {id:"b3",name:"Shoreditch",addr:"45 Brick Lane, London E1",phone:"020 3456 7890",lat:51.5209,lng:-0.0717,
    delivery:{enabled:true,method:"zone",postcodes:[],radius:0,
      zones:[{id:"z1",name:"Zone 1",maxMiles:3,fee:0},{id:"z2",name:"Zone 2",maxMiles:5,fee:2.50},{id:"z3",name:"Zone 3",maxMiles:7,fee:4.50}],
      flatFee:0,freeOver:35,minOrder:20},
    cod:{enabled:true,minOrder:20,maxMiles:3}},
];

// Check if COD is allowed for this branch + order
// Check if QR table session is valid (not expired, table still active)
// Returns {valid, table, branch, reason}
function getQrSession(){
  if(typeof window==="undefined")return{valid:false};
  var params=new URLSearchParams(window.location.search);
  var qrTable=params.get("table");
  var qrBranch=params.get("branch");
  if(!qrTable||!qrBranch)return{valid:false};
  // Check session start time - expires after 2 hours
  var sessionKey="qr_session_"+qrBranch+"_"+qrTable;
  var savedStart=null;
  try{savedStart=localStorage.getItem(sessionKey);}catch(e){}
  var now=Date.now();
  var TWO_HOURS=2*60*60*1000;
  if(!savedStart){
    // First visit - set start time
    try{localStorage.setItem(sessionKey,now.toString());}catch(e){}
    return{valid:true,table:qrTable,branch:qrBranch,fresh:true};
  }
  var started=parseInt(savedStart);
  if(isNaN(started)||now-started>TWO_HOURS){
    // Expired - clear
    try{localStorage.removeItem(sessionKey);}catch(e){}
    return{valid:false,reason:"expired"};
  }
  return{valid:true,table:qrTable,branch:qrBranch};
}

function clearQrSession(){
  if(typeof window==="undefined")return;
  var params=new URLSearchParams(window.location.search);
  var qrTable=params.get("table");
  var qrBranch=params.get("branch");
  if(qrTable&&qrBranch){
    try{localStorage.removeItem("qr_session_"+qrBranch+"_"+qrTable);}catch(e){}
  }
  // Also remove from URL
  if(window.history&&window.history.replaceState){
    window.history.replaceState({},"",window.location.pathname);
  }
}

// Get the right price for a menu item based on order type
// Falls back to base price if specific not set
function getItemPrice(item,orderType){
  if(!item)return 0;
  var base=parseFloat(item.price)||0;
  // Helper - returns null if value is empty/zero/invalid, otherwise the parsed number
  var p=v=>{var n=parseFloat(v);return(isNaN(n)||n<=0)?null:n;};
  if(orderType==="dine-in"||orderType==="eatin"){
    var v=p(item.priceDineIn);
    return v!==null?v:base;
  }
  if(orderType==="collection"||orderType==="takeaway"){
    var v2=p(item.priceTakeaway);
    return v2!==null?v2:base;
  }
  if(orderType==="delivery"){
    var v3=p(item.priceDelivery);
    return v3!==null?v3:base;
  }
  return base;
}

// Check if item is available for the order type
function isItemAvailable(item,orderType){
  if(!item)return false;
  if(item.avail===false)return false; // master availability
  if(orderType==="dine-in"||orderType==="eatin"){
    return item.availDineIn!==false;
  }
  if(orderType==="collection"||orderType==="takeaway"){
    return item.availTakeaway!==false;
  }
  if(orderType==="delivery"){
    return item.availDelivery!==false;
  }
  return true;
}

// eslint-disable-next-line no-unused-vars
function checkCOD(branch,orderTotal,distance){
  var c=branch?.cod;
  if(!c||!c.enabled)return{ok:false,reason:"Cash on delivery not accepted here"};
  if(c.minOrder&&orderTotal<c.minOrder)return{ok:false,reason:"Min order "+(c.minOrder)+" for cash on delivery"};
  if(c.maxMiles&&distance!=null&&distance>c.maxMiles)return{ok:false,reason:"Cash on delivery only within "+c.maxMiles+" miles"};
  return{ok:true};
}

// ---- KITCHEN PRINTING -------------------------------------------------------
// Build HTML for a print ticket
function buildTicketHtml(order,station,branch,format){
  var isThermal=format==="thermal";
  var w=isThermal?"80mm":"210mm";
  var p=isThermal?"4mm":"15mm";
  var fontSize=isThermal?"11px":"13px";
  var headerSize=isThermal?"14px":"22px";
  var stationName=station?station.name:"";
  var items=order.items||[];
  // Filter items if station_only
  var content=station?(station.printContent||"station_only"):"full_order";
  var displayItems=items;
  var showAllSummary=false;
  if(station&&content==="station_only"){
    // We don't have menu lookup here, so this is best-effort filter via items[].station if set
    displayItems=items.filter(it=>!it.station||it.station===station.name);
  }else if(station&&content==="station_with_full_summary"){
    showAllSummary=true;
  }
  var typeLabel=order.type==="dine-in"?"DINE-IN":order.type==="delivery"?"DELIVERY":order.type==="collection"?"COLLECTION":(order.type||"ORDER").toUpperCase();
  var copies=parseInt(station?.copies)||1;
  var copyText=copies>1?" ("+copies+" copies)":"";
  var html="<html><head><title>Order "+order.id+"</title><style>"+
    "@media print{@page{size:"+w+" auto;margin:0}body{margin:0}}"+
    "body{font-family:'Courier New',monospace;font-size:"+fontSize+";padding:"+p+";width:"+w+";color:#000}"+
    "h1{font-size:"+headerSize+";text-align:center;margin:0 0 8px}"+
    ".divider{border-top:1px dashed #000;margin:6px 0}"+
    ".big{font-size:"+(isThermal?"16px":"18px")+";font-weight:bold}"+
    ".item{display:flex;justify-content:space-between;margin:2px 0}"+
    ".section{font-weight:bold;text-decoration:underline;margin:6px 0 3px;text-transform:uppercase}"+
    "</style></head><body>";
  html+="<h1>"+(branch?branch.name:(typeof window!=="undefined"&&window.__currentRestaurant?window.__currentRestaurant.name:"La Tavola"))+"</h1>";
  if(stationName)html+="<div style='text-align:center;font-weight:bold;font-size:"+(isThermal?"13px":"16px")+"'>"+stationName.toUpperCase()+" STATION"+copyText+"</div>";
  html+="<div class='divider'></div>";
  html+="<div class='big'>ORDER "+order.id+"</div>";
  html+="<div>"+order.time+" - "+typeLabel+"</div>";
  if(order.tableId)html+="<div class='big'>TABLE "+order.tableId+"</div>";
  if(order.customer)html+="<div>Customer: "+order.customer+"</div>";
  if(order.phone)html+="<div>Phone: "+order.phone+"</div>";
  if(order.address)html+="<div>Address: "+(typeof order.address==="string"?order.address:(order.address.line1||"")+" "+(order.address.postcode||""))+"</div>";
  if(order.slot)html+="<div>Collect at: "+order.slot+"</div>";
  html+="<div class='divider'></div>";
  if(stationName&&content==="station_only"){
    html+="<div class='section'>"+stationName+" Items</div>";
  }else{
    html+="<div class='section'>Items</div>";
  }
  displayItems.forEach(it=>{
    html+="<div class='item'><span class='big'>"+(it.qty||1)+"x "+it.name+"</span></div>";
    if(it.notes)html+="<div style='padding-left:20px;font-style:italic'>Note: "+it.notes+"</div>";
    if(it.size)html+="<div style='padding-left:20px'>Size: "+it.size+"</div>";
  });
  if(showAllSummary){
    html+="<div class='divider'></div><div class='section'>Full Order Summary</div>";
    items.forEach(it=>{html+="<div class='item'><span>"+(it.qty||1)+"x "+it.name+"</span></div>";});
  }
  html+="<div class='divider'></div>";
  if(order.total)html+="<div class='item big'><span>TOTAL</span><span>"+(order.total?"\u00A3"+order.total.toFixed(2):"")+"</span></div>";
  if(order.payMethod==="cod")html+="<div style='text-align:center;font-weight:bold;border:2px solid #000;padding:4px;margin-top:6px'>** CASH ON DELIVERY **<br>COLLECT \u00A3"+(order.total||0).toFixed(2)+"</div>";
  if(!order.paid&&order.payMethod!=="cod")html+="<div style='text-align:center;font-weight:bold'>** UNPAID - COLLECT PAYMENT **</div>";
  html+="<div class='divider'></div>";
  html+="<div style='text-align:center;font-size:10px;margin-top:8px'>"+new Date().toLocaleString("en-GB")+"</div>";
  html+="</body></html>";
  return html;
}

// Print using browser
function printTicket(order,station,branch){
  var format=station?(station.printerFormat||"thermal"):"thermal";
  var html=buildTicketHtml(order,station,branch,format);
  var win=window.open("","print_"+order.id,"width=400,height=600");
  if(!win){alert("Pop-up blocked! Allow pop-ups to print.");return false;}
  win.document.write(html);
  win.document.close();
  // Trigger print after small delay so styles load
  setTimeout(()=>{try{win.focus();win.print();setTimeout(()=>win.close(),500);}catch(e){console.log("Print error:",e);}},250);
  return true;
}

// PrintNode integration (requires server-side or CORS proxy in real use)
function printViaPrintNode(order,station,branch,apiKey){
  // Note: PrintNode API requires HTTP Basic Auth, browser CORS may block direct calls.
  // For production, route through a server endpoint to avoid exposing apiKey.
  if(!station.printnodeId||!apiKey){
    alert("PrintNode not configured. Set printer ID and API key in Admin > Stations.");
    return false;
  }
  var format=station.printerFormat||"thermal";
  var html=buildTicketHtml(order,station,branch,format);
  // Convert HTML to base64
  var b64=btoa(unescape(encodeURIComponent(html)));
  var payload={
    printerId:parseInt(station.printnodeId),
    title:"Order "+order.id,
    contentType:"raw_base64",
    content:b64,
    source:"La Tavola POS",
    options:{copies:parseInt(station.copies)||1},
  };
  fetch("https://api.printnode.com/printjobs",{
    method:"POST",
    headers:{"Authorization":"Basic "+btoa(apiKey+":"),"Content-Type":"application/json"},
    body:JSON.stringify(payload),
  }).then(r=>r.json()).then(data=>{
    console.log("PrintNode result:",data);
  }).catch(e=>{
    console.log("PrintNode failed (likely CORS):",e);
    alert("PrintNode call failed. Production setup requires server-side proxy.");
  });
  return true;
}

// Main print dispatcher - routes to correct method based on station config
function dispatchPrint(order,station,branch){
  if(!station)return printTicket(order,null,branch);
  var method=station.printerMethod||"browser";
  if(method==="none")return false;
  if(method==="printnode"){
    var apiKey=null;
    try{apiKey=localStorage.getItem("printnode_api_key");}catch(e){}
    return printViaPrintNode(order,station,branch,apiKey);
  }
  // Default: browser print
  return printTicket(order,station,branch);
}

// Delivery helper - checks if an address is deliverable and returns fee
function checkDelivery(branch,address,orderTotal){
  var d=branch.delivery;
  if(!d||!d.enabled)return{ok:false,reason:"No delivery from this branch"};
  if(d.minOrder&&orderTotal<d.minOrder)return{ok:false,reason:"Min order "+fmt(d.minOrder)+" for delivery"};
  var fee=d.flatFee||0,zone=null,distance=null;

  if(d.method==="postcode"){
    var pc=(address.postcode||"").toUpperCase().replace(/\s+/g,"");
    var match=d.postcodes.find(p=>pc.startsWith(p.replace(/\s+/g,"").toUpperCase()));
    if(!match)return{ok:false,reason:"Out of delivery area - postcode not covered"};
  }else if(d.method==="radius"){
    distance=address.distance||0;
    if(distance>d.radius)return{ok:false,reason:"Too far - max "+d.radius+" miles"};
  }else if(d.method==="zone"){
    distance=address.distance||0;
    zone=d.zones.find(z=>distance<=z.maxMiles);
    if(!zone)return{ok:false,reason:"Out of all delivery zones"};
    fee=zone.fee;
  }

  if(d.freeOver&&orderTotal>=d.freeOver)fee=0;
  return{ok:true,fee,zone:zone?.name,distance};
}

var HOURS={
  b1:{Mon:[11,22],Tue:[11,22],Wed:[11,22],Thu:[11,23],Fri:[11,23],Sat:[10,23],Sun:[10,21]},
  b2:{Mon:[7,22],Tue:[7,22],Wed:[7,22],Thu:[7,22],Fri:[7,23],Sat:[9,23],Sun:[10,20]},
  b3:{Mon:[12,22],Tue:[12,22],Wed:[12,23],Thu:[12,23],Fri:[12,24],Sat:[11,24],Sun:[11,21]},
};
var DAYS=["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
var isOpenNow=id=>{var h=HOURS[id];if(!h)return true;var d=DAYS[new Date().getDay()],hrs=h[d];if(!hrs)return false;var c=new Date().getHours()+new Date().getMinutes()/60;return c>=hrs[0]&&c<hrs[1];};
// Not used in UI but kept for potential future use
// eslint-disable-next-line no-unused-vars
var isOpen=id=>true;
// eslint-disable-next-line no-unused-vars
var USERS=[
  {id:"u1",name:"Alex Johnson",email:"alex@example.com",pw:"pass123",avatar:"AJ",role:"customer"},
  {id:"u2",name:"Sarah Lee",email:"sarah@example.com",pw:"pass123",avatar:"SL",role:"customer"},
  {id:"s1",name:"Marco Rossi",email:"marco@staff.com",pw:"staff123",avatar:"MR",role:"owner"},
  {id:"s2",name:"Chef Paolo",email:"chef@staff.com",pw:"chef123",avatar:"CP",role:"kitchen"},
];
// eslint-disable-next-line no-unused-vars
var DISCOUNTS=[
  {code:"WELCOME10",type:"percent",value:10,desc:"10% off",active:true,uses:0,max:100},
  {code:"FLAT5",type:"fixed",value:5,desc:"5 off orders over 25",active:true,uses:0,max:500,minOrder:25},
];
// eslint-disable-next-line no-unused-vars
var ORDERS0=[
  {id:"ORD-1001",branchId:"b1",userId:"u1",customer:"Table 3",items:[{id:4,name:"Margherita Pizza",qty:2,price:13.99},{id:8,name:"Truffle Fries",qty:1,price:4.99}],total:32.97,status:"preparing",time:"12:45",type:"dine-in",paid:true,slot:null},
  {id:"ORD-1002",branchId:"b1",userId:"u2",customer:"John Smith",items:[{id:5,name:"Beef Burger",qty:1,price:14.99},{id:12,name:"Soft Drink",qty:2,price:2.99}],total:20.97,status:"ready",time:"12:50",type:"takeaway",paid:true,slot:null},
  {id:"ORD-1003",branchId:"b2",userId:"u1",customer:"Table 7",items:[{id:6,name:"Grilled Salmon",qty:1,price:18.99}],total:18.99,status:"pending",time:"13:02",type:"collection",paid:false,slot:"13:30"},
];
var SL={pending:"Pending",preparing:"Preparing",ready:"Ready",out_for_delivery:"Out for Delivery",delivered:"Delivered",collected:"Collected",cancelled:"Cancelled"};
var SC={pending:"#d97706",preparing:"#2563eb",ready:"#059669",out_for_delivery:"#0891b2",delivered:"#6b7280",collected:"#7c3aed",cancelled:"#dc2626"};
var SB={pending:"#fef3c7",preparing:"#eff6ff",ready:"#d1fae5",out_for_delivery:"#cffafe",delivered:"#f3f4f6",collected:"#f5f3ff",cancelled:"#fee2e2"};
var TIERS=[{name:"Bronze",min:0,color:"#b45309",bg:"#fef3c7"},{name:"Silver",min:200,color:"#6b7280",bg:"#f3f4f6"},{name:"Gold",min:500,color:"#d4952a",bg:"#fffbeb"},{name:"Platinum",min:1000,color:"#7c3aed",bg:"#f5f3ff"}];
var getTier=pts=>[...TIERS].reverse().find(t=>pts>=t.min)||TIERS[0];
var getSlots=()=>{var s=[],now=new Date(),st=new Date(now);st.setMinutes(Math.ceil(st.getMinutes()/15)*15+15,0,0);for(var i=0;i<10;i++){var t=new Date(st.getTime()+i*15*60000);s.push(("0"+t.getHours()).slice(-2)+":"+("0"+t.getMinutes()).slice(-2));}return s;};
var applyDisc=(ds,code,sub)=>{var d=ds.find(d=>d.code===code.toUpperCase()&&d.active);if(!d)return{err:"Invalid code."};if(d.minOrder&&sub<d.minOrder)return{err:"Min order "+fmt(d.minOrder)};var sv=d.type==="percent"?sub*(d.value/100):d.value;return{saving:Math.min(sv,sub),desc:d.desc,code:d.code};};

var CSS=`
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Inter:wght@400;500;600;700&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
body{font-family:'Inter',sans-serif;background:#f7f3ee;color:#1a1208;-webkit-font-smoothing:antialiased}
h1,h2,h3{font-family:'Playfair Display',serif}
button{cursor:pointer;border:none;background:none;font-family:inherit}
input,select,textarea{font-family:inherit;font-size:14px}
::-webkit-scrollbar{width:4px;height:4px}::-webkit-scrollbar-thumb{background:#d4c9b8;border-radius:4px}
@keyframes fadeUp{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
@keyframes pulse{0%,100%{opacity:1}50%{opacity:.4}}
@keyframes flashPulse{0%,100%{box-shadow:0 0 0 2px #dc2626,0 0 0 0 rgba(220,38,38,.5)}50%{box-shadow:0 0 0 2px #dc2626,0 0 0 10px rgba(220,38,38,0)}}
@keyframes flashGreen{0%{background:#d1fae5;transform:scale(1)}30%{background:#a7f3d0;transform:scale(1.03)}100%{background:transparent;transform:scale(1)}}
@keyframes slideInTop{0%{opacity:0;transform:translateY(-20px);background:#d1fae5}100%{opacity:1;transform:translateY(0);background:transparent}}
.flash{animation:flashGreen .6s ease both}
.cart-item-new{animation:slideInTop .4s ease-out both}
.fadeup{animation:fadeUp .3s ease both}
.card{background:#fff;border-radius:14px;padding:16px;box-shadow:0 2px 12px rgba(0,0,0,.07);border:1px solid #ede8de}
.btn{display:inline-flex;align-items:center;justify-content:center;gap:6px;padding:10px 20px;border-radius:9px;font-weight:600;font-size:14px;cursor:pointer;border:none;transition:all .18s}
.btn-r{background:#bf4626;color:#fff}.btn-r:hover{background:#a33a1e;transform:translateY(-1px)}
.btn-d{background:#1a1208;color:#fff}.btn-d:hover{background:#2e2218}
.btn-p{background:#7c3aed;color:#fff}
.btn-o{border:2px solid #e8e0d4;color:#1a1208;background:#fff}.btn-o:hover{background:#1a1208;color:#fff;border-color:#1a1208}
.btn-g{color:#8a8078;padding:8px 12px}.btn-g:hover{background:#f0ebe3;border-radius:8px}
.btn:disabled{opacity:.4;cursor:not-allowed;transform:none!important}
.field{width:100%;padding:10px 13px;border:2px solid #e8e0d4;border-radius:9px;font-size:14px;background:#fff;color:#1a1208;outline:none;transition:border-color .15s}
.field:focus{border-color:#bf4626}
.lbl{display:block;font-size:11px;font-weight:700;color:#8a8078;letter-spacing:.07em;text-transform:uppercase;margin-bottom:5px}
.bdg{display:inline-flex;align-items:center;padding:3px 9px;border-radius:20px;font-size:11px;font-weight:700}
.page{max-width:940px;margin:0 auto;padding:20px 14px}
.g2{display:grid;grid-template-columns:1fr 1fr;gap:12px}
.g3{display:grid;grid-template-columns:1fr 1fr 1fr;gap:12px}
.ag{display:grid;grid-template-columns:repeat(auto-fill,minmax(240px,1fr));gap:14px}
.hr{height:1px;background:#ede8de;margin:12px 0}
.nav{background:#1a1208;height:58px;display:flex;align-items:center;padding:0 16px;position:sticky;top:0;z-index:500;gap:8px;box-shadow:0 2px 16px rgba(0,0,0,.3)}
.nlogo{font-family:'Playfair Display',serif;font-size:19px;font-weight:700;color:#d4952a;flex-shrink:0}
.ntabs{display:flex;gap:2px;flex:1;justify-content:center;overflow-x:auto}
.ntabs::-webkit-scrollbar{display:none}
.ntab{padding:6px 12px;border-radius:7px;font-size:12px;font-weight:600;color:#888;background:transparent;border:none;white-space:nowrap;cursor:pointer;transition:all .18s}
.ntab.on{background:#bf4626;color:#fff}
.ntab:hover:not(.on){color:#fff;background:rgba(255,255,255,.1)}
.nright{display:flex;align-items:center;gap:6px;flex-shrink:0}
.av{background:#bf4626;color:#fff;border-radius:50%;width:28px;height:28px;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;flex-shrink:0}
.mnav{display:none}.hmob{display:flex}
@media(max-width:680px){
  .mnav{display:flex;position:fixed;bottom:0;left:0;right:0;background:#1a1208;border-top:1px solid #2e2218;z-index:400;overflow-x:auto;padding-bottom:env(safe-area-inset-bottom,0px)}
  .mnav::-webkit-scrollbar{display:none}
  .mbtn{flex:0 0 auto;display:flex;flex-direction:column;align-items:center;gap:2px;padding:8px 16px;font-size:10px;font-weight:600;color:#555;border:none;background:transparent;cursor:pointer;white-space:nowrap;transition:color .15s}
  .mbtn.on{color:#d4952a}.mico{font-size:22px;line-height:1.1}
  .hmob{display:none!important}.ntabs{display:none!important}
  main{padding-bottom:72px!important}
}
@media(max-width:560px){.g2,.g3{grid-template-columns:1fr}.ag{grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:10px}}
.kbg{background:#0a0a0a;min-height:100vh;padding:14px}
.lbar{height:7px;background:#ede8de;border-radius:4px;overflow:hidden}
.lfill{height:100%;border-radius:4px;transition:width .8s}

/* POS responsive layout - LOCKED TO VIEWPORT so cart footer stays visible */
.pos-wrap{height:calc(100vh - 58px);background:#f0ebe0;display:flex;flex-direction:column;overflow:hidden}
.pos-body{display:flex;flex:1;overflow:hidden;min-height:0}
.pos-menu{flex:1 1 60%;padding:12px;overflow-y:auto;min-height:0}
.pos-cart{flex:1 1 40%;background:#fff;display:flex;flex-direction:column;border-left:1px solid #ede8de;max-width:400px;min-width:300px;min-height:0}
.pos-cart-items{flex:1;overflow-y:auto;padding:8px 12px;min-height:0}
.pos-cart-footer{padding:12px;border-top:1px solid #ede8de;background:#f7f3ee;flex-shrink:0}
.pos-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(120px,1fr));gap:8px}

/* Phone: stack vertically, cart slides over menu */
@media(max-width:700px){
  .pos-wrap{height:auto;min-height:calc(100vh - 58px);overflow:visible}
  .pos-body{flex-direction:column;overflow:visible}
  .pos-cart{max-width:100%;min-width:0;border-left:none;border-top:2px solid #ede8de}
  .pos-cart-items{max-height:35vh}
  .pos-grid{grid-template-columns:repeat(auto-fill,minmax(95px,1fr));gap:6px}
}

/* Tablet portrait: smaller cart, bigger menu buttons */
@media(min-width:701px) and (max-width:1024px){
  .pos-cart{flex:0 0 340px;max-width:340px}
  .pos-grid{grid-template-columns:repeat(auto-fill,minmax(130px,1fr));gap:10px}
}

/* Desktop / large tablet: balanced layout */
@media(min-width:1025px) and (max-width:1440px){
  .pos-cart{flex:0 0 380px;max-width:380px}
  .pos-grid{grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:10px}
}

/* Large EPOS / monitor: maximum menu density */
@media(min-width:1441px){
  .pos-cart{flex:0 0 440px;max-width:440px}
  .pos-grid{grid-template-columns:repeat(auto-fill,minmax(160px,1fr));gap:12px}
}

/* Landscape phone: side-by-side */
@media(max-width:900px) and (orientation:landscape) and (max-height:500px){
  .pos-body{flex-direction:row}
  .pos-cart{max-width:280px;min-width:260px;max-height:none;border-top:none;border-left:1px solid #ede8de}
  .pos-grid{grid-template-columns:repeat(auto-fill,minmax(90px,1fr));gap:5px}
}

/* ============================================================ */
/* TOUCH-FRIENDLY UI - bigger buttons, inputs, spacing           */
/* Optimised for touchscreen EPOS terminals                     */
/* ============================================================ */

/* Bigger base buttons */
.btn{padding:14px 26px;font-size:15px;border-radius:11px;min-height:50px}

/* Bigger form fields - easier to tap */
.field{padding:14px 16px;font-size:15px;border-radius:11px;min-height:50px}
.lbl{font-size:12px;margin-bottom:7px}

/* Bigger cards with more breathing room */
.card{padding:18px;border-radius:16px}

/* Bigger nav tabs - easier to hit */
.ntab{padding:10px 18px;font-size:13px;border-radius:9px;min-height:42px}
.nav{min-height:64px;height:auto;padding:6px 18px}
.nlogo{font-size:21px}

/* Bigger avatar */
.av{width:36px;height:36px;font-size:13px}

/* Bigger badges */
.bdg{padding:5px 12px;font-size:12px}

/* All buttons get a minimum touch target of 44px (Apple/Google guideline) */
button{min-height:44px}
.btn-g{min-height:44px;padding:10px 16px}

/* Selects easier to tap */
select{min-height:48px;font-size:15px;padding:10px 14px}

/* Inputs easier to tap */
input[type=text],input[type=number],input[type=email],input[type=tel],input[type=password],input[type=search],textarea{
  min-height:46px;font-size:15px
}

/* Generic small action buttons in admin - make them bigger */
.touch-btn{padding:12px 18px!important;font-size:14px!important;min-height:48px!important;border-radius:10px!important}

/* Mobile bottom nav - bigger touch targets */
@media(max-width:680px){
  .mbtn{padding:10px 18px;font-size:11px}
  .mico{font-size:25px}
}

/* On large touchscreens (EPOS), make everything even more generous */
@media(min-width:1025px){
  .btn{padding:16px 30px;font-size:16px;min-height:54px}
  .field{padding:15px 18px;font-size:16px;min-height:54px}
  .ntab{padding:11px 20px;font-size:14px}
}

/* Smooth tap feedback - buttons press down slightly */
button:active{transform:scale(0.97)}
.btn:active{transform:scale(0.97)}

/* Hide controls when printing an invoice */
@media print{
  .no-print{display:none!important}
  body *{visibility:hidden}
  .print-area,.print-area *{visibility:visible}
}

/* Remove tap highlight flash on mobile, use our own feedback */
button,a,.card{-webkit-tap-highlight-color:transparent}
`;

// Apply saved UI scale (touchscreen display size preference)
// Note: applied to main content area only (not nav) to avoid layout breaks
function getUIScale(){
  try{
    var saved=localStorage.getItem("ui_scale");
    if(saved){
      var z=parseInt(saved)/100;
      if(z<0.9)z=0.9;
      if(z>1.15)z=1.15;
      return z;
    }
  }catch(e){}
  return 1;
}

// Get receipt settings from localStorage
function getReceiptSettings(){
  try{
    // SAAS: Use current restaurant's VAT info if available
    var rest=(typeof window!=="undefined")?window.__currentRestaurant:null;
    if(rest&&rest.vat_rate!==null&&rest.vat_rate!==undefined){
      return {
        showVAT:localStorage.getItem("show_vat")!=="0"&&parseFloat(rest.vat_rate)>0,
        vatRate:parseFloat(rest.vat_rate)||0,
        vatNumber:rest.vat_number||"",
      };
    }
    return {
      showVAT:localStorage.getItem("show_vat")!=="0",
      vatRate:parseFloat(localStorage.getItem("vat_rate"))||20,
      vatNumber:localStorage.getItem("vat_number")||"GB 123 4567 89",
    };
  }catch(e){return {showVAT:true,vatRate:20,vatNumber:""};}
}

// Format date+time nicely
function formatReceiptDate(o){
  try{
    var ts=o.created_at||o.time||"";
    if(/^\d{1,2}:\d{2}/.test(String(o.time||""))&&!o.created_at){
      return new Date().toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"})+" "+o.time;
    }
    var d=new Date(ts);
    if(isNaN(d.getTime()))return o.time||"";
    return d.toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"})+" "+d.toLocaleTimeString("en-GB",{hour:"2-digit",minute:"2-digit"});
  }catch(e){return o.time||"";}
}

// Build payment section HTML
function buildPaymentSection(o,thermal){
  if(!o.paid){
    return thermal
      ? `<p style="text-align:center;font-weight:700;margin:8px 0;color:#dc2626">UNPAID${o.deliveryCode?" - Cash on Delivery":""}</p>`
      : `<div style="padding:12px;background:#fee2e2;border-radius:8px;text-align:center;font-weight:700;color:#991b1b;margin:14px 0">UNPAID${o.deliveryCode?" - Cash on Delivery":""}</div>`;
  }
  // ITEM SPLIT - multi-customer payment
  if(o.itemSplit&&o.itemSplit.payments){
    var custColors=["#dc2626","#0891b2","#059669","#d4952a","#7c3aed","#ea580c","#be185d","#0d9488"];
    if(thermal){
      var rows=o.itemSplit.payments.map(p=>{
        var label="Customer #"+p.customerNum+": "+(p.method==="cash"?"Cash":"Card")+" "+fmt(p.amount);
        if(p.method==="cash"&&p.cashGiven)label+=" (given "+fmt(p.cashGiven)+", change "+fmt(p.change||0)+")";
        return `<tr><td colspan="2" style="font-size:11px">${label}</td></tr>`;
      }).join("");
      return `<table style="width:100%;border-top:2px dashed #ccc;margin-top:10px;padding-top:6px">
        <tr><td colspan="2" style="font-weight:700;text-align:center;padding:4px 0">PAYMENT: ITEM SPLIT (${o.itemSplit.customerCount} customers)</td></tr>
        ${rows}
        <tr style="border-top:1px dashed #ccc"><td><b>Total Paid</b></td><td style="text-align:right;font-weight:700">${fmt(o.total)}</td></tr>
      </table>`;
    }
    var rowsA4=o.itemSplit.payments.map((p,i)=>{
      var color=custColors[(p.customerNum-1)%custColors.length];
      var label=p.method==="cash"?"Cash":"Card";
      var detail=p.method==="cash"&&p.cashGiven?" (given "+fmt(p.cashGiven)+", change "+fmt(p.change||0)+")":(p.method==="card"?" Approved":"");
      return `<tr><td style="border-left:4px solid ${color};padding:6px 10px"><b>Customer #${p.customerNum}</b></td><td style="padding:6px">${label}${detail}</td><td style="text-align:right;font-weight:700;padding:6px">${fmt(p.amount)}</td></tr>`;
    }).join("");
    return `<div style="border-top:2px solid #1a1208;margin-top:14px;padding-top:11px">
      <p style="font-weight:700;margin-bottom:7px">PAYMENT: SPLIT BY ITEMS (${o.itemSplit.customerCount} customers)</p>
      <table style="width:100%;border-collapse:collapse">${rowsA4}<tr style="border-top:2px solid #1a1208"><td colspan="2"><b>Total Paid</b></td><td style="text-align:right;font-weight:700">${fmt(o.total)}</td></tr></table>
    </div>`;
  }
  var method=(o.payMethod||"").toLowerCase();
  // Split payment
  if(o.paymentSplit){
    var s=o.paymentSplit;
    if(thermal){
      return `<table style="width:100%;border-top:2px dashed #ccc;margin-top:10px;padding-top:6px">
        <tr><td colspan="2" style="font-weight:700;text-align:center;padding:4px 0">PAYMENT: SPLIT</td></tr>
        <tr><td>* Cash</td><td style="text-align:right">${fmt(s.cash)}</td></tr>
        <tr><td>* Card</td><td style="text-align:right">${fmt(s.card)} (Approved)</td></tr>
        <tr style="border-top:1px dashed #ccc"><td><b>Total Paid</b></td><td style="text-align:right;font-weight:700">${fmt(parseFloat(s.cash)+parseFloat(s.card))}</td></tr>
      </table>`;
    }
    return `<div style="border-top:2px solid #1a1208;margin-top:14px;padding-top:11px">
      <p style="font-weight:700;margin-bottom:7px">PAYMENT: SPLIT</p>
      <table style="width:100%">
        <tr><td>Cash</td><td style="text-align:right">${fmt(s.cash)}</td></tr>
        <tr><td>Card (Approved)</td><td style="text-align:right">${fmt(s.card)}</td></tr>
        <tr style="border-top:1px solid #ccc"><td><b>Total Paid</b></td><td style="text-align:right;font-weight:700">${fmt(parseFloat(s.cash)+parseFloat(s.card))}</td></tr>
      </table>
    </div>`;
  }
  // Cash with given/change
  if(method.includes("cash")&&o.cashGiven){
    if(thermal){
      return `<table style="width:100%;border-top:2px dashed #ccc;margin-top:10px;padding-top:6px">
        <tr><td colspan="2" style="font-weight:700;text-align:center;padding:4px 0">PAYMENT: CASH</td></tr>
        <tr><td>Amount Given</td><td style="text-align:right">${fmt(o.cashGiven)}</td></tr>
        <tr><td>Total</td><td style="text-align:right">${fmt(o.total)}</td></tr>
        <tr><td><b>Change</b></td><td style="text-align:right;font-weight:700">${fmt(o.changeReturn||0)}</td></tr>
      </table>`;
    }
    return `<div style="border-top:2px solid #1a1208;margin-top:14px;padding-top:11px">
      <p style="font-weight:700;margin-bottom:7px">PAYMENT: CASH</p>
      <table style="width:100%">
        <tr><td>Amount Given</td><td style="text-align:right">${fmt(o.cashGiven)}</td></tr>
        <tr><td>Total</td><td style="text-align:right">${fmt(o.total)}</td></tr>
        <tr><td><b>Change Returned</b></td><td style="text-align:right;font-weight:700;color:#059669">${fmt(o.changeReturn||0)}</td></tr>
      </table>
    </div>`;
  }
  // Simple paid
  return thermal
    ? `<p style="text-align:center;font-weight:700;margin:8px 0;color:#059669">PAID - ${o.payMethod||"OK"}</p>`
    : `<div style="padding:12px;background:#d1fae5;border-radius:8px;text-align:center;font-weight:700;color:#065f46;margin:14px 0">PAID - ${o.payMethod||"OK"}</div>`;
}

// Build VAT section
function buildVATSection(o,thermal){
  var s=getReceiptSettings();
  if(!s.showVAT)return "";
  var vatTotal=parseFloat(o.total||0);
  // VAT-inclusive: VAT amount = total * (rate / (100 + rate))
  var vatAmt=vatTotal*(s.vatRate/(100+s.vatRate));
  var netAmt=vatTotal-vatAmt;
  if(thermal){
    return `<div style="border-top:1px dashed #ccc;margin-top:8px;padding-top:6px;font-size:11px;color:#666">
      <table style="width:100%">
        <tr><td>Net (excl VAT)</td><td style="text-align:right">${fmt(netAmt)}</td></tr>
        <tr><td>VAT @ ${s.vatRate}%</td><td style="text-align:right">${fmt(vatAmt)}</td></tr>
      </table>
      <p style="margin-top:4px;font-size:10px">VAT No: ${s.vatNumber}</p>
    </div>`;
  }
  return `<div style="margin-top:14px;padding:11px;background:#fafaf5;border-radius:7px;font-size:12px;color:#666">
    <table style="width:100%">
      <tr><td>Net Amount (excl VAT)</td><td style="text-align:right">${fmt(netAmt)}</td></tr>
      <tr><td>VAT @ ${s.vatRate}%</td><td style="text-align:right">${fmt(vatAmt)}</td></tr>
    </table>
    <p style="margin-top:4px">VAT Registration: ${s.vatNumber}</p>
  </div>`;
}

// THERMAL RECEIPT - for in-store (dine-in, takeaway, collection)
function printThermalReceipt(o,b){
  var w=window.open("","_blank","width=380,height=700");if(!w)return;
  var rows=(o.items||[]).map(i=>{
    var line=`<tr><td>${i.name} x${i.qty}</td><td style="text-align:right">${fmt(i.price*i.qty)}</td></tr>`;
    if(i.note)line+=`<tr><td colspan="2" style="font-size:10px;color:#666;font-style:italic;padding-left:8px">> ${i.note}</td></tr>`;
    return line;
  }).join("");
  var sub=parseFloat(o.subtotal||o.total||0);
  var disc=parseFloat(o.discount||0);
  var serviceCharge=parseFloat(o.serviceCharge||0);
  var tip=parseFloat(o.tip||0);
  var deliveryFee=parseFloat(o.deliveryFee||0);
  var breakdown=`<tr><td>Subtotal</td><td style="text-align:right">${fmt(sub)}</td></tr>`;
  if(disc>0)breakdown+=`<tr><td>Discount${o.discReason?" ("+o.discReason+")":""}</td><td style="text-align:right">-${fmt(disc)}</td></tr>`;
  if(serviceCharge>0)breakdown+=`<tr><td>Service Charge</td><td style="text-align:right">+${fmt(serviceCharge)}</td></tr>`;
  if(deliveryFee>0)breakdown+=`<tr><td>Delivery</td><td style="text-align:right">+${fmt(deliveryFee)}</td></tr>`;
  if(tip>0)breakdown+=`<tr><td>Tip</td><td style="text-align:right">+${fmt(tip)}</td></tr>`;
  
  var paymentSection=buildPaymentSection(o,true);
  var vatSection=buildVATSection(o,true);
  var split=o.splitN>1?`<p style="text-align:center;color:#7c3aed;font-weight:700;margin:8px 0">Split ${o.splitN} ways = ${fmt(o.total/o.splitN)} each</p>`:"";
  var deliveryCodeSection=o.deliveryCode?`<div style="border:2px dashed #7c3aed;padding:10px;text-align:center;margin:12px 0;border-radius:6px"><p style="font-size:10px;color:#7c3aed;font-weight:700;letter-spacing:2px;margin:0">DELIVERY CODE</p><p style="font-size:32px;font-weight:700;letter-spacing:8px;font-family:'Courier New',monospace;color:#7c3aed;margin:5px 0">${o.deliveryCode}</p><p style="font-size:9px;color:#666;margin:0">Required for cash payment on delivery</p></div>`:"";
  var orderNotes=o.notes?`<div style="border:1px dashed #d97706;padding:8px;margin:8px 0;font-size:11px;color:#92400e;background:#fef3c7"><b>NOTE:</b> ${o.notes}</div>`:"";
  var customerInfo=o.address?`<p style="font-size:11px;color:#666">Address: ${typeof o.address==="object"?(o.address.line1||"")+", "+(o.address.postcode||""):o.address}</p>`:"";
  
  var js="window.onload=function(){window.print()}";
  w.document.write(`<!DOCTYPE html><html><head><title>Receipt ${o.id}</title><style>
    body{font-family:'Courier New',monospace;padding:14px;font-size:13px;max-width:320px;margin:0 auto;color:#000}
    h2{color:#bf4626;margin:0 0 4px;text-align:center;font-size:18px}
    p{margin:3px 0}
    table{width:100%;border-collapse:collapse;margin:8px 0}
    td{padding:3px 0}
    .header{text-align:center;border-bottom:2px solid #000;padding-bottom:8px;margin-bottom:8px}
    .header p{font-size:11px;color:#666;margin:1px 0}
    .order-info{border-bottom:1px dashed #999;padding-bottom:8px;margin-bottom:8px;font-size:12px}
    .items td{border-bottom:1px dotted #ddd;padding:4px 0}
    .total{font-weight:700;font-size:16px;color:#bf4626;border-top:2px solid #bf4626;padding-top:6px!important}
    .footer{text-align:center;color:#999;margin-top:14px;font-size:10px;border-top:1px dashed #ccc;padding-top:8px}
  </style></head><body>
    <div class="header">
      <h2>${(b?b.name:(typeof window!=="undefined"&&window.__currentRestaurant?window.__currentRestaurant.name:"Restaurant")).toUpperCase()}</h2>
      ${b?`<p>${b.addr||""}</p><p>Tel: ${b.phone||""}</p>`:""}
    </div>
    <div class="order-info">
      <p><b>Order:</b> ${o.id}</p>
      <p><b>Date:</b> ${formatReceiptDate(o)}</p>
      <p><b>Type:</b> ${(o.type||"").toUpperCase()}${o.tableId?" - TABLE "+o.tableId:""}</p>
      ${o.customer?`<p><b>Customer:</b> ${o.customer}</p>`:""}
      ${o.phone?`<p><b>Phone:</b> ${o.phone}</p>`:""}
      ${customerInfo}
      ${o.takenBy?`<p><b>Served by:</b> ${o.takenBy}</p>`:""}
      ${o.slot?`<p><b>Collect at:</b> ${o.slot}</p>`:""}
    </div>
    <table class="items">${rows}</table>
    ${orderNotes}
    <table>${breakdown}<tr class="total"><td>TOTAL</td><td style="text-align:right">${fmt(o.total)}</td></tr></table>
    ${split}
    ${paymentSection}
    ${vatSection}
    ${deliveryCodeSection}
    <div class="footer">
      <p>Thank you for your order!</p>
      ${(typeof window!=="undefined"&&window.__currentRestaurant&&window.__currentRestaurant.slug!=="la-tavola")?"":'<p>www.latavola.co.uk</p>'}
    </div>
  </body></html>`);
  var s=w.document.createElement("script");s.textContent=js;w.document.body.appendChild(s);
  w.document.close();
}

// A4 INVOICE - for delivery (more space, professional)
function printA4Invoice(o,b){
  var w=window.open("","_blank","width=800,height=1100");if(!w)return;
  var rows=(o.items||[]).map(i=>{
    var lineTotal=i.price*i.qty;
    var line=`<tr><td>${i.name}${i.note?'<br><span style="font-size:11px;color:#666;font-style:italic">Note: '+i.note+'</span>':""}</td><td style="text-align:center">${i.qty}</td><td style="text-align:right">${fmt(i.price)}</td><td style="text-align:right">${fmt(lineTotal)}</td></tr>`;
    return line;
  }).join("");
  var sub=parseFloat(o.subtotal||o.total||0);
  var disc=parseFloat(o.discount||0);
  var serviceCharge=parseFloat(o.serviceCharge||0);
  var tip=parseFloat(o.tip||0);
  var deliveryFee=parseFloat(o.deliveryFee||0);
  
  var paymentSection=buildPaymentSection(o,false);
  var vatSection=buildVATSection(o,false);
  var orderNotes=o.notes?`<div style="padding:11px 14px;background:#fef3c7;border-left:4px solid #d97706;margin:14px 0;font-size:13px;color:#92400e"><b>Customer Note:</b> ${o.notes}</div>`:"";
  var addrText=o.address?(typeof o.address==="object"?[o.address.line1,o.address.postcode].filter(Boolean).join(", "):o.address):"";
  var deliveryCodeSection=o.deliveryCode?`<div style="margin-top:18px;padding:18px;border:3px dashed #7c3aed;border-radius:11px;text-align:center;background:#f5f3ff"><p style="font-size:13px;color:#7c3aed;font-weight:700;letter-spacing:3px;margin:0">DELIVERY CODE</p><p style="font-size:54px;font-weight:700;letter-spacing:14px;font-family:'Courier New',monospace;color:#7c3aed;margin:8px 0">${o.deliveryCode}</p><p style="font-size:11px;color:#666;margin:0">Customer: please give this code to the driver if paying by cash</p></div>`:"";
  
  var js="window.onload=function(){window.print()}";
  w.document.write(`<!DOCTYPE html><html><head><title>Invoice ${o.id}</title><style>
    body{font-family:Arial,sans-serif;padding:36px;color:#1a1208;max-width:720px;margin:0 auto;font-size:14px}
    h1{color:#bf4626;margin:0;font-size:32px}
    h2{font-size:18px;margin:16px 0 6px}
    .header{display:flex;justify-content:space-between;border-bottom:3px solid #bf4626;padding-bottom:18px;margin-bottom:18px}
    .header-left h1{margin-bottom:6px}
    .header-left p{margin:1px 0;font-size:12px;color:#666}
    .header-right{text-align:right}
    .header-right h2{color:#bf4626;font-size:24px;margin:0}
    .header-right p{margin:1px 0;font-size:12px}
    .info-grid{display:grid;grid-template-columns:1fr 1fr;gap:18px;margin-bottom:18px;padding:14px;background:#fafaf5;border-radius:9px}
    .info-grid h3{font-size:11px;color:#666;letter-spacing:2px;font-weight:700;margin:0 0 5px}
    .info-grid p{margin:1px 0;font-size:13px}
    table.items{width:100%;border-collapse:collapse;margin:14px 0}
    table.items th{background:#1a1208;color:#fff;padding:11px;text-align:left;font-size:12px;letter-spacing:1px}
    table.items th:nth-child(2){text-align:center}
    table.items th:nth-child(3),table.items th:nth-child(4){text-align:right}
    table.items td{padding:10px 11px;border-bottom:1px solid #ede8de}
    .totals{margin-top:14px;display:flex;justify-content:flex-end}
    .totals table{min-width:300px;border-collapse:collapse}
    .totals td{padding:6px 14px}
    .totals .total-row{border-top:3px solid #1a1208;font-weight:700;font-size:18px;color:#bf4626}
    .footer{margin-top:36px;padding-top:14px;border-top:1px solid #ccc;text-align:center;color:#999;font-size:11px}
  </style></head><body>
    <div class="header">
      <div class="header-left">
        <h1>${(b?b.name:(typeof window!=="undefined"&&window.__currentRestaurant?window.__currentRestaurant.name:"Restaurant")).toUpperCase()}</h1>
        ${b?`<p>${b.addr||""}</p><p>Tel: ${b.phone||""}</p>`:""}
      </div>
      <div class="header-right">
        <h2>INVOICE</h2>
        <p><b>${o.id}</b></p>
        <p>${formatReceiptDate(o)}</p>
        <p style="margin-top:8px"><b>${(o.type||"").toUpperCase()}</b></p>
      </div>
    </div>
    
    <div class="info-grid">
      <div>
        <h3>BILL TO</h3>
        <p><b>${o.customer||"Customer"}</b></p>
        ${o.phone?`<p>${o.phone}</p>`:""}
        ${addrText?`<p>${addrText}</p>`:""}
      </div>
      <div>
        <h3>ORDER DETAILS</h3>
        <p>Order #: <b>${o.id}</b></p>
        ${o.takenBy?`<p>Taken by: ${o.takenBy}</p>`:""}
        ${o.slot?`<p>Delivery time: ${o.slot}</p>`:""}
      </div>
    </div>
    
    <table class="items">
      <thead><tr><th>ITEM</th><th>QTY</th><th>PRICE</th><th>SUBTOTAL</th></tr></thead>
      <tbody>${rows}</tbody>
    </table>
    
    ${orderNotes}
    
    <div class="totals">
      <table>
        <tr><td>Subtotal:</td><td style="text-align:right">${fmt(sub)}</td></tr>
        ${disc>0?`<tr><td>Discount${o.discReason?" ("+o.discReason+")":""}:</td><td style="text-align:right;color:#059669">-${fmt(disc)}</td></tr>`:""}
        ${serviceCharge>0?`<tr><td>Service Charge:</td><td style="text-align:right">+${fmt(serviceCharge)}</td></tr>`:""}
        ${deliveryFee>0?`<tr><td>Delivery Fee:</td><td style="text-align:right">+${fmt(deliveryFee)}</td></tr>`:""}
        ${tip>0?`<tr><td>Tip:</td><td style="text-align:right">+${fmt(tip)}</td></tr>`:""}
        <tr class="total-row"><td>TOTAL:</td><td style="text-align:right">${fmt(o.total)}</td></tr>
      </table>
    </div>
    
    ${paymentSection}
    ${vatSection}
    ${deliveryCodeSection}
    
    <div class="footer">
      <p>Thank you for choosing ${(b?b.name:(typeof window!=="undefined"&&window.__currentRestaurant?window.__currentRestaurant.name:"us"))}!</p>
      ${(typeof window!=="undefined"&&window.__currentRestaurant&&window.__currentRestaurant.slug!=="la-tavola")?"":'<p>www.latavola.co.uk</p>'}
    </div>
  </body></html>`);
  var s=w.document.createElement("script");s.textContent=js;w.document.body.appendChild(s);
  w.document.close();
}

// KITCHEN TICKET - no prices, just items + table/customer
function printKitchenTicket(o,b){
  var w=window.open("","_blank","width=380,height=600");if(!w)return;
  var rows=(o.items||[]).map(i=>{
    var line=`<tr><td style="font-size:18px;font-weight:700;padding:8px 0">${i.qty} x ${i.name}</td></tr>`;
    if(i.note)line+=`<tr><td style="font-size:13px;color:#bf4626;font-weight:700;font-style:italic;padding-left:14px;padding-bottom:8px">> ${i.note}</td></tr>`;
    return line;
  }).join("");
  var orderNotes=o.notes?`<div style="border:2px dashed #dc2626;padding:11px;margin:11px 0;font-size:14px;color:#991b1b;font-weight:700;text-align:center">SPECIAL: ${o.notes}</div>`:"";
  var js="window.onload=function(){window.print()}";
  w.document.write(`<!DOCTYPE html><html><head><title>Kitchen ${o.id}</title><style>
    body{font-family:'Courier New',monospace;padding:14px;font-size:14px;max-width:320px;margin:0 auto;color:#000}
    h2{margin:0 0 4px;text-align:center;font-size:22px;letter-spacing:2px}
    p{margin:3px 0}
    table{width:100%;border-collapse:collapse;margin:8px 0}
    td{padding:3px 0}
    .header{text-align:center;border-bottom:3px double #000;padding-bottom:11px;margin-bottom:11px}
    .order-info{font-size:14px;margin-bottom:11px}
    .items td{border-bottom:1px dotted #ddd}
    .footer{text-align:center;color:#666;margin-top:14px;font-size:11px;border-top:1px dashed #ccc;padding-top:8px}
  </style></head><body>
    <div class="header">
      <h2>*** KITCHEN ***</h2>
      <p style="font-size:14px">${b?b.name:""}</p>
    </div>
    <div class="order-info">
      <p><b>Order:</b> ${o.id}</p>
      <p><b>Time:</b> ${formatReceiptDate(o)}</p>
      <p><b>Type:</b> <span style="font-size:16px;font-weight:700">${(o.type||"").toUpperCase()}</span></p>
      ${o.tableId?`<p><b>Table:</b> <span style="font-size:18px;font-weight:700">${o.tableId}</span>${o.guests?" ("+o.guests+" guests)":""}</p>`:""}
      ${o.customer&&!o.tableId?`<p><b>For:</b> ${o.customer}</p>`:""}
      ${o.takenBy?`<p><b>Server:</b> ${o.takenBy}</p>`:""}
    </div>
    <hr>
    <p style="font-size:11px;color:#666;letter-spacing:2px;text-align:center">ITEMS TO PREPARE</p>
    <table class="items">${rows}</table>
    ${orderNotes}
    <div class="footer">
      <p>--- END OF TICKET ---</p>
    </div>
  </body></html>`);
  var s=w.document.createElement("script");s.textContent=js;w.document.body.appendChild(s);
  w.document.close();
}

// Smart receipt - auto-picks thermal vs A4 based on order type
// Print individual customer receipts for item-split orders
function printItemSplitReceipts(o,b){
  if(!o.itemSplit||!o.itemSplit.payments){
    printR(o,b);
    return;
  }
  // Build flat item units
  var itemUnits=[];
  (o.items||[]).forEach((item,idx)=>{
    for(var q=0;q<item.qty;q++){
      itemUnits.push({uid:idx+"_"+q,name:item.name,price:item.price,note:item.note});
    }
  });
  
  var sharedItems=(o.itemSplit.customerItems&&o.itemSplit.customerItems.shared)?o.itemSplit.customerItems.shared.map(uid=>itemUnits.find(u=>u.uid===uid)).filter(Boolean):[];
  var sharedTotal=sharedItems.reduce((s,u)=>s+u.price,0);
  var sharedPerCust=o.itemSplit.customerCount>0?sharedTotal/o.itemSplit.customerCount:0;
  
  // Print one receipt per customer
  o.itemSplit.payments.forEach((p,i)=>{
    var custItemIds=(o.itemSplit.customerItems&&o.itemSplit.customerItems[p.customerNum])?o.itemSplit.customerItems[p.customerNum]:[];
    var custItems=custItemIds.map(uid=>itemUnits.find(u=>u.uid===uid)).filter(Boolean);
    
    // Aggregate same items
    var itemMap={};
    custItems.forEach(u=>{
      if(itemMap[u.name])itemMap[u.name].qty++;
      else itemMap[u.name]={name:u.name,price:u.price,qty:1,note:u.note};
    });
    var aggItems=Object.values(itemMap);
    
    // Build a per-customer order object
    var custOrder={
      ...o,
      id:o.id+"-C"+p.customerNum,
      items:aggItems,
      subtotal:custItems.reduce((s,u)=>s+u.price,0),
      total:p.amount,
      payMethod:p.method,
      cashGiven:p.cashGiven,
      changeReturn:p.change,
      paymentSplit:null,
      itemSplit:null, // don't recurse
      customer:"Customer #"+p.customerNum,
      // Add shared portion as a line
      sharedItems:sharedItems,
      sharedPerCust:sharedPerCust,
      paid:true,
    };
    setTimeout(()=>printThermalReceipt(custOrder,b),i*200); // stagger to avoid popup blockers
  });
}

// THERMAL REFUND RECEIPT - HMRC compliant credit note
function printRefundThermal(o,b){
  var w=window.open("","_blank","width=380,height=700");if(!w)return;
  var s=getReceiptSettings();
  var refundAmt=parseFloat(o.voidAmount||o.total||0);
  var voidType=o.voidType||"refund";
  var voidLabel=voidType==="void"?"VOID":(voidType==="partial-refund"?"PARTIAL REFUND":"FULL REFUND");
  
  // Items section - show ALL items with refund highlighting
  var rows=(o.items||[]).map(i=>{
    var line=`<tr><td>${i.name} x${i.qty}</td><td style="text-align:right">${fmt(i.price*i.qty)}</td></tr>`;
    if(i.note)line+=`<tr><td colspan="2" style="font-size:10px;color:#666;font-style:italic;padding-left:8px">> ${i.note}</td></tr>`;
    return line;
  }).join("");
  
  // VAT breakdown of refund
  var vatSection="";
  if(s.showVAT){
    var vatAmt=refundAmt*(s.vatRate/(100+s.vatRate));
    var netAmt=refundAmt-vatAmt;
    vatSection=`<div style="border-top:1px dashed #ccc;margin-top:8px;padding-top:6px;font-size:11px">
      <p style="font-weight:700;margin-bottom:4px;color:#dc2626">REFUND VAT BREAKDOWN:</p>
      <table style="width:100%">
        <tr><td>Net refund (excl VAT)</td><td style="text-align:right">-${fmt(netAmt)}</td></tr>
        <tr><td>VAT @ ${s.vatRate}% refund</td><td style="text-align:right">-${fmt(vatAmt)}</td></tr>
      </table>
      <p style="margin-top:4px;font-size:10px">VAT No: ${s.vatNumber}</p>
    </div>`;
  }
  
  var refundDate=new Date().toLocaleString("en-GB",{day:"numeric",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit"});
  var origDate=formatReceiptDate(o);
  
  var js="window.onload=function(){window.print()}";
  w.document.write(`<!DOCTYPE html><html><head><title>Refund Receipt ${o.id}</title><style>
    body{font-family:'Courier New',monospace;padding:14px;font-size:13px;max-width:320px;margin:0 auto;color:#000}
    h2{color:#dc2626;margin:0 0 4px;text-align:center;font-size:18px}
    p{margin:3px 0}
    table{width:100%;border-collapse:collapse;margin:8px 0}
    td{padding:3px 0}
    .header{text-align:center;border-bottom:3px double #dc2626;padding-bottom:8px;margin-bottom:8px}
    .header p{font-size:11px;color:#666;margin:1px 0}
    .refund-banner{background:#dc2626;color:#fff;padding:10px;text-align:center;margin:8px 0;border-radius:4px}
    .refund-banner h3{font-size:18px;margin:0;letter-spacing:3px}
    .order-info{border-bottom:1px dashed #999;padding-bottom:8px;margin-bottom:8px;font-size:12px}
    .items td{border-bottom:1px dotted #ddd;padding:4px 0}
    .refund-amount{font-weight:700;font-size:18px;color:#dc2626;border-top:3px double #dc2626;padding-top:8px!important;margin-top:8px}
    .reason-box{background:#fef3c7;border:1px dashed #d97706;padding:8px;margin:8px 0;font-size:11px}
    .footer{text-align:center;color:#666;margin-top:14px;font-size:10px;border-top:1px dashed #ccc;padding-top:8px}
    .signature-line{margin-top:18px;padding-top:8px;border-top:1px solid #000;text-align:center;font-size:10px;color:#666}
  </style></head><body>
    <div class="header">
      <h2>${(b?b.name:(typeof window!=="undefined"&&window.__currentRestaurant?window.__currentRestaurant.name:"Restaurant")).toUpperCase()}</h2>
      ${b?`<p>${b.addr||""}</p><p>Tel: ${b.phone||""}</p>`:""}
    </div>
    
    <div class="refund-banner">
      <h3>${voidLabel}</h3>
      <p style="font-size:11px;margin-top:4px">Credit Note / Refund Receipt</p>
    </div>
    
    <div class="order-info">
      <p><b>Refund Ref:</b> REF-${o.id}</p>
      <p><b>Refund Date:</b> ${refundDate}</p>
      <p><b>Original Order:</b> ${o.id}</p>
      <p><b>Original Date:</b> ${origDate}</p>
      <p><b>Type:</b> ${(o.type||"").toUpperCase()}${o.tableId?" - TABLE "+o.tableId:""}</p>
      ${o.customer?`<p><b>Customer:</b> ${o.customer}</p>`:""}
      ${o.takenBy?`<p><b>Original staff:</b> ${o.takenBy}</p>`:""}
    </div>
    
    <p style="font-size:11px;color:#666;letter-spacing:1px;text-align:center;margin-bottom:5px">ORIGINAL ITEMS</p>
    <table class="items">${rows}</table>
    <table>
      <tr><td>Original Total</td><td style="text-align:right">${fmt(o.total)}</td></tr>
    </table>
    
    <div class="reason-box">
      <p style="font-weight:700;margin-bottom:3px;color:#92400e">REFUND REASON:</p>
      <p style="font-style:italic">${o.voidReason||"Not specified"}</p>
      <p style="margin-top:6px;font-size:10px"><b>Approved by:</b> ${o.voidApprovedBy||"Manager"}</p>
    </div>
    
    <table>
      <tr class="refund-amount"><td>${voidType==="partial-refund"?"PARTIAL REFUND":"REFUND AMOUNT"}</td><td style="text-align:right;color:#dc2626">-${fmt(refundAmt)}</td></tr>
    </table>
    
    ${vatSection}
    
    <div class="signature-line">
      <p>Customer signature</p>
      <br>
      <p>_______________________________</p>
    </div>
    
    <div class="footer">
      <p style="font-weight:700;color:#dc2626">${String.fromCharCode(0x2713)} REFUND PROCESSED</p>
      <p style="margin-top:6px">Keep this receipt for your records</p>
      ${(typeof window!=="undefined"&&window.__currentRestaurant&&window.__currentRestaurant.slug!=="la-tavola")?"":'<p>www.latavola.co.uk</p>'}
    </div>
  </body></html>`);
  var sc=w.document.createElement("script");sc.textContent=js;w.document.body.appendChild(sc);
  w.document.close();
}

// A4 REFUND INVOICE - HMRC compliant credit note
function printRefundA4(o,b){
  var w=window.open("","_blank","width=800,height=1100");if(!w)return;
  var s=getReceiptSettings();
  var refundAmt=parseFloat(o.voidAmount||o.total||0);
  var voidType=o.voidType||"refund";
  var voidLabel=voidType==="void"?"VOID":(voidType==="partial-refund"?"PARTIAL REFUND":"FULL REFUND");
  
  var rows=(o.items||[]).map(i=>{
    var lineTotal=i.price*i.qty;
    return `<tr><td>${i.name}${i.note?'<br><span style="font-size:11px;color:#666;font-style:italic">Note: '+i.note+'</span>':""}</td><td style="text-align:center">${i.qty}</td><td style="text-align:right">${fmt(i.price)}</td><td style="text-align:right">${fmt(lineTotal)}</td></tr>`;
  }).join("");
  
  // VAT breakdown
  var vatSection="";
  if(s.showVAT){
    var vatAmt=refundAmt*(s.vatRate/(100+s.vatRate));
    var netAmt=refundAmt-vatAmt;
    vatSection=`<div style="margin-top:14px;padding:13px;background:#fee2e2;border-left:4px solid #dc2626;border-radius:7px">
      <p style="font-weight:700;color:#991b1b;margin-bottom:7px;font-size:13px">REFUND VAT BREAKDOWN (HMRC)</p>
      <table style="width:100%;font-size:13px">
        <tr><td>Net refund (excl VAT)</td><td style="text-align:right">-${fmt(netAmt)}</td></tr>
        <tr><td>VAT @ ${s.vatRate}% refund</td><td style="text-align:right">-${fmt(vatAmt)}</td></tr>
        <tr style="border-top:1px solid #dc2626;font-weight:700"><td style="padding-top:5px">Total refund</td><td style="text-align:right;padding-top:5px">-${fmt(refundAmt)}</td></tr>
      </table>
      <p style="margin-top:8px;font-size:11px;color:#666">VAT Registration: ${s.vatNumber}</p>
    </div>`;
  }
  
  var refundDate=new Date().toLocaleString("en-GB",{day:"numeric",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit"});
  var origDate=formatReceiptDate(o);
  var addrText=o.address?(typeof o.address==="object"?[o.address.line1,o.address.postcode].filter(Boolean).join(", "):o.address):"";
  
  var js="window.onload=function(){window.print()}";
  w.document.write(`<!DOCTYPE html><html><head><title>Refund ${o.id}</title><style>
    body{font-family:Arial,sans-serif;padding:36px;color:#1a1208;max-width:720px;margin:0 auto;font-size:14px}
    h1{color:#dc2626;margin:0;font-size:32px}
    h2{font-size:18px;margin:16px 0 6px}
    .header{display:flex;justify-content:space-between;border-bottom:4px solid #dc2626;padding-bottom:18px;margin-bottom:18px}
    .header-left h1{margin-bottom:6px}
    .header-left p{margin:1px 0;font-size:12px;color:#666}
    .header-right{text-align:right}
    .header-right h2{color:#dc2626;font-size:24px;margin:0;letter-spacing:2px}
    .header-right p{margin:1px 0;font-size:12px}
    .credit-banner{background:linear-gradient(135deg,#dc2626,#991b1b);color:#fff;padding:18px;text-align:center;margin-bottom:18px;border-radius:9px}
    .credit-banner h2{font-size:28px;margin:0;letter-spacing:3px}
    .credit-banner p{margin-top:5px;font-size:13px;opacity:.9}
    .info-grid{display:grid;grid-template-columns:1fr 1fr;gap:18px;margin-bottom:18px;padding:14px;background:#fef3c7;border-radius:9px;border:2px solid #d97706}
    .info-grid h3{font-size:11px;color:#92400e;letter-spacing:2px;font-weight:700;margin:0 0 5px}
    .info-grid p{margin:1px 0;font-size:13px}
    .reason-box{padding:14px;background:#fee2e2;border-left:5px solid #dc2626;margin:14px 0;border-radius:7px}
    .reason-box p{margin:0;font-size:13px}
    .reason-box .label{font-size:11px;color:#991b1b;letter-spacing:2px;font-weight:700;margin-bottom:4px}
    table.items{width:100%;border-collapse:collapse;margin:14px 0}
    table.items th{background:#1a1208;color:#fff;padding:11px;text-align:left;font-size:12px;letter-spacing:1px}
    table.items th:nth-child(2){text-align:center}
    table.items th:nth-child(3),table.items th:nth-child(4){text-align:right}
    table.items td{padding:10px 11px;border-bottom:1px solid #ede8de}
    .totals{margin-top:14px;display:flex;justify-content:flex-end}
    .totals table{min-width:340px;border-collapse:collapse}
    .totals td{padding:7px 14px;font-size:14px}
    .totals .refund-row{border-top:3px solid #dc2626;border-bottom:3px solid #dc2626;font-weight:700;font-size:22px;color:#dc2626;background:#fef2f2}
    .signature-section{margin-top:36px;display:grid;grid-template-columns:1fr 1fr;gap:36px}
    .sig-box{padding-top:22px;border-top:1px solid #1a1208;text-align:center;font-size:12px;color:#666}
    .footer{margin-top:36px;padding-top:14px;border-top:1px solid #ccc;text-align:center;color:#666;font-size:11px}
  </style></head><body>
    <div class="header">
      <div class="header-left">
        <h1>${(b?b.name:(typeof window!=="undefined"&&window.__currentRestaurant?window.__currentRestaurant.name:"Restaurant")).toUpperCase()}</h1>
        ${b?`<p>${b.addr||""}</p><p>Tel: ${b.phone||""}</p>`:""}
      </div>
      <div class="header-right">
        <h2>CREDIT NOTE</h2>
        <p><b>REF-${o.id}</b></p>
        <p>${refundDate}</p>
        <p style="margin-top:8px;color:#dc2626;font-weight:700">${voidLabel}</p>
      </div>
    </div>
    
    <div class="credit-banner">
      <h2>${voidLabel}</h2>
      <p>Refund Receipt / Credit Note for HMRC Records</p>
    </div>
    
    <div class="info-grid">
      <div>
        <h3>ORIGINAL ORDER</h3>
        <p>Order #: <b>${o.id}</b></p>
        <p>Date: ${origDate}</p>
        <p>Type: <b>${(o.type||"").toUpperCase()}</b></p>
        ${o.payMethod?`<p>Payment: ${o.payMethod}</p>`:""}
        <p>Original Total: <b>${fmt(o.total)}</b></p>
      </div>
      <div>
        <h3>CUSTOMER</h3>
        <p><b>${o.customer||"Customer"}</b></p>
        ${o.phone?`<p>${o.phone}</p>`:""}
        ${addrText?`<p>${addrText}</p>`:""}
        ${o.takenBy?`<p style="margin-top:8px;font-size:11px;color:#666">Original staff: ${o.takenBy}</p>`:""}
      </div>
    </div>
    
    <h3 style="margin-top:18px;font-size:13px;color:#666;letter-spacing:2px">ORIGINAL ITEMS</h3>
    <table class="items">
      <thead><tr><th>ITEM</th><th>QTY</th><th>PRICE</th><th>SUBTOTAL</th></tr></thead>
      <tbody>${rows}</tbody>
    </table>
    
    <div class="reason-box">
      <p class="label">REFUND REASON</p>
      <p style="font-style:italic;font-size:14px;margin-bottom:8px">${o.voidReason||"Not specified"}</p>
      <p><b>Approved by:</b> ${o.voidApprovedBy||"Manager"}</p>
      <p><b>Processed by:</b> Restaurant staff</p>
    </div>
    
    <div class="totals">
      <table>
        <tr><td>Original total:</td><td style="text-align:right">${fmt(o.total)}</td></tr>
        <tr class="refund-row"><td>${voidType==="partial-refund"?"PARTIAL REFUND":"REFUND AMOUNT"}:</td><td style="text-align:right">-${fmt(refundAmt)}</td></tr>
      </table>
    </div>
    
    ${vatSection}
    
    <div class="signature-section">
      <div class="sig-box">Manager Signature</div>
      <div class="sig-box">Customer Signature</div>
    </div>
    
    <div class="footer">
      <p style="font-weight:700;color:#dc2626;font-size:13px">${String.fromCharCode(0x2713)} REFUND PROCESSED - Keep for HMRC Records</p>
      <p style="margin-top:6px">This is a credit note. Please retain for accounting purposes.</p>
      ${(typeof window!=="undefined"&&window.__currentRestaurant&&window.__currentRestaurant.slug!=="la-tavola")?"":'<p>www.latavola.co.uk</p>'}
    </div>
  </body></html>`);
  var sc=w.document.createElement("script");sc.textContent=js;w.document.body.appendChild(sc);
  w.document.close();
}

// Smart refund receipt - auto-picks thermal vs A4
// THERMAL VOUCHER RECEIPT
function printVoucherThermal(o,b){
  var w=window.open("","_blank","width=380,height=700");if(!w)return;
  var voucherAmt=parseFloat(o.voidAmount||0);
  var code=o.voucherCode||"";
  var issued=new Date();
  var expires=new Date();
  expires.setDate(expires.getDate()+90);
  var expiresStr=expires.toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"});
  var issuedStr=issued.toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"});

  var js="window.onload=function(){window.print()}";
  w.document.write(`<!DOCTYPE html><html><head><title>Voucher ${code}</title><style>
    body{font-family:'Courier New',monospace;padding:14px;font-size:13px;max-width:320px;margin:0 auto;color:#000}
    h2{color:#7c3aed;margin:0 0 4px;text-align:center;font-size:18px}
    p{margin:3px 0}
    .header{text-align:center;border-bottom:3px double #7c3aed;padding-bottom:8px;margin-bottom:8px}
    .header p{font-size:11px;color:#666;margin:1px 0}
    .voucher-banner{background:#7c3aed;color:#fff;padding:14px;text-align:center;margin:8px 0;border-radius:6px}
    .voucher-banner h3{font-size:20px;margin:0;letter-spacing:3px}
    .voucher-amount{font-size:36px;font-weight:700;color:#7c3aed;text-align:center;margin:14px 0;font-family:'Courier New',monospace}
    .code-box{border:3px dashed #7c3aed;padding:14px;text-align:center;margin:14px 0;border-radius:8px;background:#faf5ff}
    .code-text{font-size:42px;font-weight:700;letter-spacing:8px;color:#7c3aed;font-family:'Courier New',monospace;margin:6px 0}
    .info-box{background:#fef3c7;border-left:4px solid #d97706;padding:8px;margin:8px 0;font-size:11px;color:#92400e}
    .footer{text-align:center;color:#666;margin-top:14px;font-size:10px;border-top:1px dashed #ccc;padding-top:8px}
  </style></head><body>
    <div class="header">
      <h2>${(b?b.name:(typeof window!=="undefined"&&window.__currentRestaurant?window.__currentRestaurant.name:"Restaurant")).toUpperCase()}</h2>
      ${b?`<p>${b.addr||""}</p><p>Tel: ${b.phone||""}</p>`:""}
    </div>
    
    <div class="voucher-banner">
      <h3>GIFT VOUCHER</h3>
      <p style="font-size:11px;margin-top:4px">Goodwill Gesture from La Tavola</p>
    </div>
    
    <div class="voucher-amount">${fmt(voucherAmt)}</div>
    
    <div class="code-box">
      <p style="font-size:10px;color:#7c3aed;letter-spacing:2px;font-weight:700;margin:0">YOUR VOUCHER CODE</p>
      <div class="code-text">${code}</div>
      <p style="font-size:10px;color:#666;margin:0">Tell staff or enter at checkout</p>
    </div>
    
    <table style="width:100%;font-size:12px;margin-top:10px">
      <tr><td>Issued:</td><td style="text-align:right"><b>${issuedStr}</b></td></tr>
      <tr><td>Expires:</td><td style="text-align:right;color:#dc2626"><b>${expiresStr}</b></td></tr>
      <tr><td>Valid for:</td><td style="text-align:right">90 days</td></tr>
      ${o.id?`<tr><td>Reference:</td><td style="text-align:right">${o.id}</td></tr>`:""}
    </table>
    
    <div class="info-box">
      <p style="font-weight:700;margin-bottom:3px">HOW TO USE:</p>
      <p>- Tell staff your code at next visit</p>
      <p>- Or enter code at online checkout</p>
      <p>- Code can only be used ONCE</p>
      <p>- Cannot be exchanged for cash</p>
    </div>
    
    ${o.voidReason?`<div style="border:1px dashed #999;padding:7px;margin:8px 0;font-size:10px;color:#666;text-align:center"><b>Issued for:</b> ${o.voidReason}</div>`:""}
    
    <div class="footer">
      <p style="font-weight:700;color:#7c3aed">${String.fromCharCode(0x2713)} VOUCHER ISSUED</p>
      <p style="margin-top:6px">Thank you for your patience!</p>
      ${(typeof window!=="undefined"&&window.__currentRestaurant&&window.__currentRestaurant.slug!=="la-tavola")?"":'<p>www.latavola.co.uk</p>'}
    </div>
  </body></html>`);
  var sc=w.document.createElement("script");sc.textContent=js;w.document.body.appendChild(sc);
  w.document.close();
}

// A4 VOUCHER RECEIPT (for delivery customers, more formal)
function printVoucherA4(o,b){
  var w=window.open("","_blank","width=800,height=1100");if(!w)return;
  var voucherAmt=parseFloat(o.voidAmount||0);
  var code=o.voucherCode||"";
  var issued=new Date();
  var expires=new Date();
  expires.setDate(expires.getDate()+90);
  var expiresStr=expires.toLocaleDateString("en-GB",{day:"numeric",month:"long",year:"numeric"});
  var issuedStr=issued.toLocaleDateString("en-GB",{day:"numeric",month:"long",year:"numeric"});

  var js="window.onload=function(){window.print()}";
  w.document.write(`<!DOCTYPE html><html><head><title>Voucher ${code}</title><style>
    body{font-family:Arial,sans-serif;padding:36px;color:#1a1208;max-width:720px;margin:0 auto;font-size:14px}
    h1{color:#7c3aed;margin:0;font-size:32px}
    .header{display:flex;justify-content:space-between;border-bottom:4px solid #7c3aed;padding-bottom:18px;margin-bottom:18px}
    .header-left p{margin:1px 0;font-size:12px;color:#666}
    .header-right{text-align:right}
    .header-right h2{color:#7c3aed;font-size:24px;margin:0;letter-spacing:2px}
    .voucher-card{background:linear-gradient(135deg,#7c3aed,#a855f7);color:#fff;padding:30px;border-radius:14px;margin:22px 0;text-align:center;box-shadow:0 8px 30px rgba(124,58,237,.3)}
    .voucher-card h2{font-size:32px;margin:0;letter-spacing:4px}
    .voucher-card .amount{font-size:64px;font-weight:700;font-family:'Courier New',monospace;margin:14px 0;text-shadow:0 2px 8px rgba(0,0,0,.3)}
    .voucher-card .code{background:#fff;color:#7c3aed;padding:14px 22px;display:inline-block;border-radius:10px;font-size:36px;font-weight:700;font-family:'Courier New',monospace;letter-spacing:8px;margin-top:14px}
    .info-grid{display:grid;grid-template-columns:1fr 1fr;gap:18px;margin:22px 0;padding:18px;background:#faf5ff;border-radius:11px;border:2px solid #7c3aed}
    .info-grid h3{font-size:11px;color:#7c3aed;letter-spacing:2px;font-weight:700;margin:0 0 5px}
    .info-grid p{margin:1px 0;font-size:14px}
    .how-to-use{padding:18px;background:#fef3c7;border-left:5px solid #d97706;margin:14px 0;border-radius:7px}
    .how-to-use h3{font-size:13px;color:#92400e;margin:0 0 9px;letter-spacing:1px}
    .how-to-use ul{margin:0;padding-left:20px;font-size:13px;color:#1a1208}
    .how-to-use li{margin:4px 0}
    .footer{margin-top:36px;padding-top:14px;border-top:1px solid #ccc;text-align:center;color:#666;font-size:11px}
  </style></head><body>
    <div class="header">
      <div class="header-left">
        <h1>${(b?b.name:(typeof window!=="undefined"&&window.__currentRestaurant?window.__currentRestaurant.name:"Restaurant")).toUpperCase()}</h1>
        ${b?`<p>${b.addr||""}</p><p>Tel: ${b.phone||""}</p>`:""}
      </div>
      <div class="header-right">
        <h2>GIFT VOUCHER</h2>
        <p style="margin-top:5px">${issuedStr}</p>
        ${o.id?`<p style="font-size:11px;color:#666">Ref: ${o.id}</p>`:""}
      </div>
    </div>
    
    <div class="voucher-card">
      <h2>GIFT VOUCHER</h2>
      <div class="amount">${fmt(voucherAmt)}</div>
      <p style="font-size:13px;opacity:.9;margin-bottom:5px">YOUR VOUCHER CODE</p>
      <div class="code">${code}</div>
    </div>
    
    <div class="info-grid">
      <div>
        <h3>VOUCHER VALUE</h3>
        <p style="font-size:18px;font-weight:700;color:#7c3aed">${fmt(voucherAmt)}</p>
      </div>
      <div>
        <h3>EXPIRES</h3>
        <p style="font-size:14px;font-weight:700;color:#dc2626">${expiresStr}</p>
        <p style="font-size:11px;color:#666;margin-top:3px">90 days from issue date</p>
      </div>
    </div>
    
    <div class="how-to-use">
      <h3>HOW TO USE YOUR VOUCHER</h3>
      <ul>
        <li>Visit any La Tavola branch and tell staff your voucher code</li>
        <li>Or enter the code <b>${code}</b> at online checkout</li>
        <li>Voucher must be used in a single transaction</li>
        <li>Cannot be exchanged for cash</li>
        <li>Cannot be combined with other promotions</li>
        <li>Code can only be used ONCE - keep this receipt safe</li>
      </ul>
    </div>
    
    ${o.voidReason?`<div style="padding:14px;background:#fafaf5;border-radius:9px;margin:14px 0;font-size:13px"><b>Issued for:</b> ${o.voidReason}</div>`:""}
    
    <div class="footer">
      <p style="font-weight:700;color:#7c3aed;font-size:14px">Thank you for your patience and understanding!</p>
      <p style="margin-top:6px">We look forward to welcoming you back to La Tavola.</p>
      ${(typeof window!=="undefined"&&window.__currentRestaurant&&window.__currentRestaurant.slug!=="la-tavola")?"":'<p style="margin-top:9px">www.latavola.co.uk</p>'}
    </div>
  </body></html>`);
  var sc=w.document.createElement("script");sc.textContent=js;w.document.body.appendChild(sc);
  w.document.close();
}

// Smart voucher receipt - auto-picks thermal vs A4
function printVoucherReceipt(o,b){
  if(o.type==="delivery"){
    printVoucherA4(o,b);
  }else{
    printVoucherThermal(o,b);
  }
}

function printRefundReceipt(o,b){
  if(o.type==="delivery"){
    printRefundA4(o,b);
  }else{
    printRefundThermal(o,b);
  }
}

function printR(o,b){
  // Delivery orders get A4 invoice (more professional, customer keeps it)
  // All other types get thermal receipt
  if(o.type==="delivery"){
    printA4Invoice(o,b);
  }else{
    printThermalReceipt(o,b);
  }
}

function Toasts({list,dismiss}){
  return <div style={{position:"fixed",top:64,right:10,zIndex:9999,display:"flex",flexDirection:"column",gap:8,maxWidth:340,width:"calc(100% - 20px)"}}>
    {list.map(n=>{
      var icon=n.icon||(n.color==="#dc2626"?String.fromCharCode(0x26A0,0xFE0F):n.color==="#059669"?String.fromCharCode(0x2705):n.color==="#d97706"?String.fromCharCode(0x26A1):String.fromCharCode(0x1F389,0xFE0F));
      return <div key={n.id} className="fadeup" style={{background:"#fff",borderRadius:12,padding:"12px 14px",boxShadow:"0 8px 24px rgba(0,0,0,.15)",borderLeft:"5px solid "+(n.color||"#bf4626"),display:"flex",gap:10,alignItems:"flex-start"}}>
        <span style={{fontSize:22,lineHeight:1,flexShrink:0}}>{icon}</span>
        <div style={{flex:1,minWidth:0}}>
          <p style={{fontWeight:700,fontSize:13,marginBottom:2,color:"#1a1208"}}>{n.title}</p>
          {n.body&&<p style={{fontSize:12,color:"#6b6359",lineHeight:1.4,wordBreak:"break-word"}}>{n.body}</p>}
        </div>
        <button onClick={()=>dismiss(n.id)} style={{color:"#bbb",fontSize:18,lineHeight:1,border:"none",background:"transparent",cursor:"pointer",padding:0,flexShrink:0}}>{String.fromCharCode(0x00D7)}</button>
      </div>;
    })}
  </div>;
}

// =================================================================
// MODAL DIALOGS - Alert & Confirm replacements for window.alert/confirm
// =================================================================
function AlertModal({title,message,onClose,type}){
  var colors={info:"#0891b2",success:"#059669",warning:"#d97706",error:"#dc2626"};
  var icons={info:String.fromCharCode(0x2139,0xFE0F),success:String.fromCharCode(0x2705),warning:String.fromCharCode(0x26A0,0xFE0F),error:String.fromCharCode(0x274C)};
  var color=colors[type||"info"];
  var icon=icons[type||"info"];
  return <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(15,10,5,.7)",backdropFilter:"blur(4px)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:18,animation:"fadeIn .15s ease-out"}}>
    <div onClick={e=>e.stopPropagation()} className="card fadeup" style={{maxWidth:380,width:"100%",padding:0,overflow:"hidden",boxShadow:"0 25px 50px rgba(0,0,0,.4)"}}>
      <div style={{padding:"22px 24px 16px",textAlign:"center",borderBottom:"1px solid #ede8de"}}>
        <div style={{width:64,height:64,borderRadius:"50%",background:color+"20",border:"3px solid "+color+"40",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 12px",fontSize:30}}>{icon}</div>
        <h3 style={{fontSize:18,fontWeight:700,color:"#1a1208",marginBottom:6}}>{title}</h3>
        {message&&<p style={{fontSize:13,color:"#6b6359",lineHeight:1.5}}>{message}</p>}
      </div>
      <div style={{padding:"14px 18px"}}>
        <button onClick={onClose} style={{width:"100%",padding:"12px",background:color,color:"#fff",border:"none",borderRadius:9,fontSize:14,fontWeight:700,cursor:"pointer"}}>Got it</button>
      </div>
    </div>
  </div>;
}

function ConfirmModal({title,message,confirmText,cancelText,onConfirm,onCancel,type,destructive}){
  var colors={info:"#0891b2",warning:"#d97706",danger:"#dc2626"};
  var icons={info:String.fromCharCode(0x2753),warning:String.fromCharCode(0x26A0,0xFE0F),danger:String.fromCharCode(0x1F5D1,0xFE0F)};
  var color=colors[type||(destructive?"danger":"warning")];
  var icon=icons[type||(destructive?"danger":"warning")];
  return <div onClick={onCancel} style={{position:"fixed",inset:0,background:"rgba(15,10,5,.7)",backdropFilter:"blur(4px)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:18,animation:"fadeIn .15s ease-out"}}>
    <div onClick={e=>e.stopPropagation()} className="card fadeup" style={{maxWidth:380,width:"100%",padding:0,overflow:"hidden",boxShadow:"0 25px 50px rgba(0,0,0,.4)"}}>
      <div style={{padding:"22px 24px 16px",textAlign:"center",borderBottom:"1px solid #ede8de"}}>
        <div style={{width:64,height:64,borderRadius:"50%",background:color+"20",border:"3px solid "+color+"40",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 12px",fontSize:30}}>{icon}</div>
        <h3 style={{fontSize:18,fontWeight:700,color:"#1a1208",marginBottom:6}}>{title}</h3>
        {message&&<p style={{fontSize:13,color:"#6b6359",lineHeight:1.5}}>{message}</p>}
      </div>
      <div style={{padding:"14px 18px",display:"flex",gap:9}}>
        <button onClick={onCancel} style={{flex:1,padding:"12px",background:"#fff",color:"#1a1208",border:"2px solid #ede8de",borderRadius:9,fontSize:13,fontWeight:700,cursor:"pointer"}}>{cancelText||"Cancel"}</button>
        <button onClick={onConfirm} style={{flex:1,padding:"12px",background:color,color:"#fff",border:"none",borderRadius:9,fontSize:13,fontWeight:700,cursor:"pointer"}}>{confirmText||"Confirm"}</button>
      </div>
    </div>
  </div>;
}

function Auth({onLogin,onClose}){
  var [tab,setTab]=useState("in"),[em,setEm]=useState(""),[pw,setPw]=useState(""),[nm,setNm]=useState(""),[ph,setPh]=useState(""),[err,setErr]=useState(""),[loading,setLoading]=useState(false);
  var login=async()=>{
    setErr("");setLoading(true);
    // Customer login ONLY - staff/owners use the main login screen
    var r=await dbLoginCustomer(em,pw);
    if(r.error){setErr(r.error.message||"Invalid email or password");setLoading(false);return;}
    var u=r.data;
    onLogin({
      id:u.id,
      name:u.name,
      email:u.email,
      phone:u.phone,
      avatar:(u.name||"U").split(" ").map(w=>w[0]).join("").toUpperCase().slice(0,2),
      role:"customer",
    });
    onClose();setLoading(false);
  };
  var reg=async()=>{
    if(!nm||!em||!pw){setErr("Name, email, and password required.");return;}
    if(pw.length<6){setErr("Password must be at least 6 characters.");return;}
    setErr("");setLoading(true);
    var r=await dbRegisterCustomer(nm,em,pw,ph);
    if(r.error){setErr(r.error.message||"Registration failed");setLoading(false);return;}
    var u=r.data;
    onLogin({
      id:u.id,
      name:u.name,
      email:u.email,
      phone:u.phone,
      avatar:nm.split(" ").map(w=>w[0]).join("").toUpperCase().slice(0,2),
      role:"customer",
    });
    onClose();setLoading(false);
  };
  return <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:8000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
    <div onClick={e=>e.stopPropagation()} className="card" style={{width:"100%",maxWidth:370,padding:24}}>
      <h2 style={{fontSize:22,marginBottom:4}}>Welcome</h2>
      <p style={{color:"#8a8078",fontSize:13,marginBottom:16}}>La Tavola member portal</p>
      <div style={{display:"flex",gap:4,marginBottom:16,background:"#f7f3ee",borderRadius:9,padding:3}}>
        {[["in","Sign In"],["up","Sign Up"]].map(([k,l])=><button key={k} onClick={()=>{setTab(k);setErr("");}} style={{flex:1,padding:"9px",borderRadius:7,fontWeight:700,fontSize:13,background:tab===k?"#fff":"transparent",color:tab===k?"#1a1208":"#8a8078",border:"none",cursor:"pointer"}}>{l}</button>)}
      </div>
      {tab==="up"&&<>
        <div style={{marginBottom:9}}><label className="lbl">Full Name</label><input className="field" value={nm} onChange={e=>setNm(e.target.value)} placeholder="Alex Johnson"/></div>
        <div style={{marginBottom:9}}><label className="lbl">Phone (optional)</label><input type="tel" className="field" value={ph} onChange={e=>setPh(e.target.value)} placeholder="07700 900000"/></div>
      </>}
      <div style={{marginBottom:9}}><label className="lbl">Email</label><input type="email" className="field" value={em} onChange={e=>setEm(e.target.value)} placeholder="you@example.com"/></div>
      <div style={{marginBottom:12}}><label className="lbl">Password {tab==="up"&&<span style={{color:"#8a8078",fontWeight:400}}>(min 6 chars)</span>}</label><input type="password" className="field" value={pw} onChange={e=>setPw(e.target.value)} placeholder="password"/></div>
      {err&&<p style={{color:"#dc2626",fontSize:12,marginBottom:9,fontWeight:600,padding:"8px 10px",background:"#fee2e2",borderRadius:6}}>{EM.cross} {err}</p>}
      <button className="btn btn-r" style={{width:"100%",padding:"12px"}} disabled={loading} onClick={tab==="in"?login:reg}>{loading?"Please wait...":(tab==="in"?"Sign In":"Create Account")}</button>
      {tab==="in"&&<p style={{fontSize:10,color:"#8a8078",marginTop:8,textAlign:"center",lineHeight:1.5}}>Sign in to track your orders and earn loyalty points.<br/>New here? Create an account above.</p>}
      {tab==="up"&&<p style={{fontSize:10,color:"#8a8078",marginTop:8,textAlign:"center"}}>By signing up you agree to receive order updates</p>}
    </div>
  </div>;
}

function Pay({amount,onSuccess,onClose}){
  var [step,setStep]=useState("form"),[card,setCard]=useState(""),[exp,setExp]=useState(""),[cvc,setCvc]=useState(""),[nm,setNm]=useState(""),[err,setErr]=useState("");
  var go=()=>{if(card.replace(/\s/g,"").length<16){setErr("Enter card number.");return;}if(exp.length<5){setErr("Enter expiry.");return;}if(cvc.length<3){setErr("Enter CVC.");return;}setErr("");setStep("processing");setTimeout(()=>{setStep("done");setTimeout(onSuccess,1200);},1800);};
  var fc=v=>v.replace(/\D/g,"").slice(0,16).replace(/(.{4})/g,"$1 ").trim();
  var fe=v=>{var d=v.replace(/\D/g,"").slice(0,4);return d.length>2?d.slice(0,2)+"/"+d.slice(2):d;};
  return <div onClick={step==="form"?onClose:null} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:8500,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
    <div onClick={e=>e.stopPropagation()} className="card" style={{width:"100%",maxWidth:380,padding:22}}>
      {step==="processing"&&<div style={{textAlign:"center",padding:"24px 0"}}><p style={{fontSize:16,animation:"pulse 1s infinite"}}>Processing...</p></div>}
      {step==="done"&&<div style={{textAlign:"center",padding:"24px 0"}}><p style={{fontSize:26,color:"#059669",fontWeight:700}}>Payment Successful!</p><p style={{color:"#8a8078",marginTop:6}}>{fmt(amount)} charged</p></div>}
      {step==="form"&&<>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}><div><h3 style={{fontSize:18,marginBottom:2}}>Secure Payment</h3><p style={{color:"#8a8078",fontSize:12}}>SSL encrypted</p></div><div style={{background:"#1a1208",color:"#d4952a",borderRadius:9,padding:"6px 12px",fontWeight:700,fontSize:16}}>{fmt(amount)}</div></div>
        <div style={{background:"#1a1208",borderRadius:10,padding:"14px 16px",marginBottom:12,color:"#fff"}}><p style={{fontSize:16,letterSpacing:3,fontFamily:"monospace",marginBottom:8}}>{card||".... .... .... ...."}</p><div style={{display:"flex",justifyContent:"space-between",fontSize:11,opacity:.6}}><span>{nm||"CARDHOLDER"}</span><span>{exp||"MM/YY"}</span></div></div>
        <div style={{marginBottom:8}}><input className="field" value={nm} onChange={e=>setNm(e.target.value.toUpperCase())} placeholder="Name on card"/></div>
        <div style={{marginBottom:8}}><input className="field" value={card} onChange={e=>setCard(fc(e.target.value))} placeholder="Card number" maxLength={19}/></div>
        <div style={{display:"flex",gap:8,marginBottom:10}}><input className="field" value={exp} onChange={e=>setExp(fe(e.target.value))} placeholder="MM/YY" maxLength={5}/><input className="field" value={cvc} onChange={e=>setCvc(e.target.value.replace(/\D/g,"").slice(0,3))} placeholder="CVC"/></div>
        {err&&<p style={{color:"#dc2626",fontSize:12,marginBottom:8,fontWeight:600}}>{err}</p>}
        <button className="btn btn-r" style={{width:"100%",padding:"11px"}} onClick={go}>Pay {fmt(amount)}</button>
        <p style={{fontSize:11,color:"#8a8078",textAlign:"center",marginTop:6}}>Test: 4242 4242 4242 4242</p>
      </>}
    </div>
  </div>;
}

function BranchSel({onSelect,restaurant}){
  // SAAS: For now, each restaurant = single branch using their info
  // For La Tavola, use 'b3' (existing branch_id) for backwards compat
  var displayBranches=restaurant?[
    {
      id:restaurant.slug==="la-tavola"?"b3":"main",
      name:restaurant.name||"Main",
      addr:restaurant.address||"",
      phone:restaurant.phone||"",
      postcode:restaurant.postcode||"",
      lat:parseFloat(restaurant.lat)||51.5,
      lng:parseFloat(restaurant.lng)||-0.1,
      delivery:{enabled:true,method:"radius",postcodes:[],radius:5,zones:[],flatFee:2.50,freeOver:25,minOrder:15},
      cod:{enabled:true,minOrder:15,maxMiles:5}
    }
  ]:BRANCHES; // fallback to hardcoded if no restaurant
  
  // Auto-select if only 1 branch
  useEffect(()=>{
    if(displayBranches.length===1){
      onSelect(displayBranches[0]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  
  return <div className="page" style={{maxWidth:560}}>
    <h2 style={{fontSize:26,marginBottom:4,textAlign:"center"}}>{restaurant?.name||"Choose Your Branch"}</h2>
    <p style={{color:"#8a8078",textAlign:"center",marginBottom:20,fontSize:14}}>Loading...</p>
    <div style={{display:"flex",flexDirection:"column",gap:10}}>
      {displayBranches.map(b=><button key={b.id} onClick={()=>onSelect(b)} style={{textAlign:"left",background:"#fff",borderRadius:13,padding:"15px 16px",border:"2px solid #ede8de",boxShadow:"0 2px 10px rgba(0,0,0,.06)",cursor:"pointer",width:"100%",transition:"all .2s"}} onMouseEnter={e=>e.currentTarget.style.borderColor="#bf4626"} onMouseLeave={e=>e.currentTarget.style.borderColor="#ede8de"}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}><div><p style={{fontWeight:700,fontSize:15,marginBottom:2}}>{b.name}</p>{b.addr&&<p style={{color:"#8a8078",fontSize:13,marginBottom:1}}>{b.addr}</p>}{b.phone&&<p style={{color:"#8a8078",fontSize:13}}>{b.phone}</p>}</div><span className="bdg" style={{background:"#d1fae5",color:"#059669"}}>Open</span></div>
      </button>)}
    </div>
  </div>;
}

function MenuV({menu,user,branch,onOrder,push,discounts,restaurant}){
  var cats=[...new Set(menu.filter(i=>i.avail).map(i=>i.cat))];
  var [cat,setCat]=useState(cats[0]),[cart,setCart]=useState({}),[step,setStep]=useState("menu");
  // Auto-select first category when menu data loads from DB
  useEffect(()=>{
    if(!cat&&cats.length>0)setCat(cats[0]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[cats.length]);
  var [type,setType]=useState(()=>{
    var sess=getQrSession();
    if(sess.valid)return "eatin";
    return "delivery";
  }),[cname,setCname]=useState(user?.name||""),[table,setTable]=useState("");
  var [addr,setAddr]=useState({line1:"",postcode:"",notes:""});
  var [codeMethod,setCodeMethod]=useState("both");
  var [serviceChargeOpt,setServiceChargeOpt]=useState(true);
  var [dbCodes,setDbCodes]=useState([]);

  // Ensure type stays "eatin" while QR session is active (handles edge cases)
  useEffect(()=>{
    var sess=getQrSession();
    if(sess.valid&&type!=="eatin"){
      setType("eatin");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  // Load promo codes from DB
  useEffect(()=>{
    dbFetchCodes().then(list=>setDbCodes(list||[]));
  },[]);
  var [postcodeData,setPostcodeData]=useState(null); // {valid, distance, fee}
  var [checkingPc,setCheckingPc]=useState(false);
  var [dbDelivery,setDbDelivery]=useState(null); // delivery settings from DB
  var [slot,setSlot]=useState(null),[code,setCode]=useState(""),[disc,setDisc]=useState(null),[derr,setDerr]=useState("");
  var [last,setLast]=useState(null),[showPay,setPay]=useState(false);

  // Auto-clear QR session if table is no longer occupied (paid/cleared by staff)
  useEffect(()=>{
    var sess=getQrSession();
    if(!sess.valid||!branch||branch.id!==sess.branch)return;
    // Check table status every 30 sec - if available, customer has left
    var checkInterval=setInterval(()=>{
      dbFetchTables().then(dbTables=>{
        var myTable=(dbTables||[]).find(t=>(t.branch_id===sess.branch)&&(String(t.table_number)===String(sess.table)||String(t.id)===String(sess.table)));
        if(myTable&&myTable.status==="available"){
          // Staff cleared this table - customer must have left
          clearQrSession();
          push({title:"Session ended",body:"Your table session has ended. Thanks for visiting!",color:"#059669"});
          setType("delivery");
        }
      }).catch(e=>{});
    },30000);
    return()=>clearInterval(checkInterval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[branch]);

  // Load delivery settings from DB for this branch
  useEffect(()=>{
    if(!branch)return;
    dbFetchAllDelivery().then(list=>{
      var s=(list||[]).find(x=>x.branch_id===branch.id);
      if(s){
        setDbDelivery({
          method:s.method,enabled:s.enabled,
          minOrder:parseFloat(s.min_order||0),freeOver:parseFloat(s.free_over||0),
          flatFee:parseFloat(s.flat_fee||0),maxRadius:s.max_radius||3,
          zones:s.zones||[],postcodes:s.postcodes||[],
          codEnabled:s.cod_enabled,
          codMinOrder:parseFloat(s.cod_min_order||15),
          codMaxMiles:s.cod_max_miles||3,
          serviceChargeEnabled:s.service_charge_enabled||false,
          serviceChargePercent:parseFloat(s.service_charge_percent||12.5),
          serviceChargeMandatory:s.service_charge_mandatory||false,
          serviceChargeGroupSize:s.service_charge_group_size||6,
        });
      }
    });
  },[branch]);

  // Check UK postcode and compute distance/fee when user enters it
  var checkPostcode=async(pc)=>{
    if(!pc||pc.length<5){setPostcodeData(null);return;}
    setCheckingPc(true);
    try{
      var clean=pc.replace(/\s+/g,"").toUpperCase();
      console.log("Checking postcode:",clean,"for branch:",branch?.name,"at",branch?.lat,branch?.lng);
      var res=await fetch("https://api.postcodes.io/postcodes/"+encodeURIComponent(clean));
      var data=await res.json();
      console.log("Postcode API response:",data);
      if(!data||data.status!==200||!data.result){
        // Try outcode lookup as fallback (just first part like E14)
        var outcode=clean.replace(/\d[A-Z]{2}$/,"");
        if(outcode&&outcode.length>=2){
          console.log("Trying outcode fallback:",outcode);
          var res2=await fetch("https://api.postcodes.io/outcodes/"+encodeURIComponent(outcode));
          var data2=await res2.json();
          if(data2&&data2.status===200&&data2.result){
            // Use outcode location
            data={status:200,result:{latitude:data2.result.latitude,longitude:data2.result.longitude,outcode:outcode}};
            console.log("Using outcode location:",data2.result);
          }else{
            setPostcodeData({valid:false,reason:"Postcode not found - please check spelling"});
            setCheckingPc(false);
            return;
          }
        }else{
          setPostcodeData({valid:false,reason:"Postcode not found"});
          setCheckingPc(false);
          return;
        }
      }
      var custLat=data.result.latitude,custLng=data.result.longitude;
      if(!branch||!branch.lat||!branch.lng){
        setPostcodeData({valid:false,reason:"Restaurant location not set - cannot calculate distance"});
        setCheckingPc(false);
        return;
      }
      // Calculate distance using Haversine
      var R=3958.8; // miles
      var dLat=(custLat-branch.lat)*Math.PI/180;
      var dLng=(custLng-branch.lng)*Math.PI/180;
      var a=Math.sin(dLat/2)**2+Math.cos(branch.lat*Math.PI/180)*Math.cos(custLat*Math.PI/180)*Math.sin(dLng/2)**2;
      var c=2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));
      var miles=R*c;
      console.log("Distance to customer:",miles.toFixed(2),"miles");
      // Determine fee based on delivery method
      var d=dbDelivery;
      if(!d||!d.enabled){setPostcodeData({valid:false,reason:"Delivery not available from this branch"});setCheckingPc(false);return;}
      var fee=0,reason="",valid=true;
      if(d.method==="radius"){
        if(miles>d.maxRadius){valid=false;reason="Too far - we only deliver within "+d.maxRadius+" miles";}
        else fee=d.flatFee||0;
      }else if(d.method==="postcode"){
        var pcEntry=(d.postcodes||[]).find(p=>clean.startsWith(p.prefix.toUpperCase()));
        if(!pcEntry){valid=false;reason="We don't deliver to "+clean+" area";}
        else fee=parseFloat(pcEntry.fee)||0;
      }else if(d.method==="zone"){
        var zone=(d.zones||[]).sort((a,b)=>(+a.maxMiles)-(+b.maxMiles)).find(z=>miles<=+z.maxMiles);
        if(!zone){valid=false;reason="Too far - outside all zones";}
        else fee=parseFloat(zone.fee)||0;
      }
      // Free over threshold
      if(valid&&d.freeOver>0&&sub>=d.freeOver)fee=0;
      setPostcodeData({valid,reason,fee,miles:miles.toFixed(1),town:data.result.admin_district||data.result.admin_ward,postcode:clean});
    }catch(err){setPostcodeData({valid:false,reason:"Could not verify postcode"});}
    setCheckingPc(false);
  };
  var slots=getSlots(),busy=[slots[2],slots[5]];
  var items=Object.keys(cart).map(id=>{
    var m=menu.find(m=>String(m.id)===String(id));
    if(!m)return null;
    var typePrice=getItemPrice(m,type);
    return {...m,qty:cart[id],price:typePrice,basePrice:m.price};
  }).filter(Boolean);
  var sub=items.reduce((s,i)=>s+(+i.price||0)*i.qty,0),saving=disc?.saving||0;
  // Service charge: only on dine-in/eat-in if enabled in branch settings
  var isDineInLike=type==="dine-in"||type==="eatin";
  var serviceChargeApplies=isDineInLike&&dbDelivery&&dbDelivery.serviceChargeEnabled;
  var canRemove=serviceChargeApplies&&!dbDelivery.serviceChargeMandatory;
  var includeCharge=serviceChargeApplies&&(serviceChargeOpt||!canRemove);
  var serviceCharge=includeCharge?Math.max(0,sub-saving)*((dbDelivery.serviceChargePercent||0)/100):0;
  var total=Math.max(0,sub-saving)+serviceCharge,count=items.reduce((s,i)=>s+i.qty,0);
  var add=id=>setCart(c=>({...c,[id]:(c[id]||0)+1}));
  var rem=id=>setCart(c=>{var n={...c};n[id]>1?n[id]--:delete n[id];return n;});
  var applyCode=()=>{
    var entered=code.toUpperCase().trim();
    if(!entered){setDerr("Enter a code");setDisc(null);return;}
    // First try DB codes (admin-managed)
    var dbCode=dbCodes.find(c=>c.code&&c.code.toUpperCase()===entered);
    if(dbCode){
      // Validate DB code
      if(!dbCode.active){setDerr("This code is no longer active");setDisc(null);return;}
      if(dbCode.expires_at&&new Date(dbCode.expires_at)<new Date()){setDerr("This code has expired");setDisc(null);return;}
      if(dbCode.uses>=dbCode.max_uses){setDerr("This code has reached its usage limit");setDisc(null);return;}
      if(dbCode.min_order&&sub<dbCode.min_order){setDerr("Min order "+fmt(dbCode.min_order)+" required for this code");setDisc(null);return;}
      // First-order-only check
      if(dbCode.first_order_only&&user&&user.id){
        // Note: simple check - in production, query user's order history
      }
      // Calculate savings
      var sv=0,desc=dbCode.description||entered;
      if(dbCode.type==="percent")sv=sub*(parseFloat(dbCode.value)/100);
      else if(dbCode.type==="fixed")sv=parseFloat(dbCode.value);
      else if(dbCode.type==="free_delivery"){
        sv=0; // savings shown as 0, but we'll mark for free delivery
        desc=dbCode.description||"Free delivery";
      }
      sv=Math.min(sv,sub);
      setDisc({saving:sv,desc:desc,code:entered,freeDelivery:dbCode.type==="free_delivery"});
      setDerr("");
      return;
    }
    // Fall back to legacy hardcoded codes
    var r=applyDisc(discounts,code,sub);
    if(r.err){setDerr(r.err);setDisc(null);}
    else{setDisc(r);setDerr("");}
  };
  var finalize=paid=>{
    var sess=getQrSession();
    var qrTable=sess.valid?sess.table:null;
    var customer=type==="eatin"&&qrTable?"Table "+qrTable:(cname||"Guest");
    var phone=type==="delivery"?(table||null):null;
    var tableId=type==="eatin"&&qrTable?parseInt(qrTable):null;
    var effectiveType=type==="eatin"?"dine-in":type;
    var deliveryFee=type==="delivery"&&postcodeData?postcodeData.fee:0;
    if(disc&&disc.freeDelivery)deliveryFee=0; // Free delivery promo applied
    var finalTotal=total+deliveryFee;
    var address=type==="delivery"?{line1:addr.line1,postcode:addr.postcode,notes:addr.notes}:null;
    // Generate 4-digit delivery code for delivery orders
    var deliveryCode=type==="delivery"?String(Math.floor(1000+Math.random()*9000)):null;
    var payMethod=null;
    if(!paid){
      if(type==="delivery")payMethod="cod";
      else if(type==="collection")payMethod="cash-at-counter";
      else if(type==="eatin")payMethod="pay-at-table";
    }
    var o={
      id:uid(),
      branchId:branch?.id,
      userId:user?.id||"guest",
      customer,
      phone,
      tableId,
      address,
      items:items.map(i=>({id:i.id,name:i.name,qty:i.qty,price:i.price})),
      subtotal:sub,
      discount:saving,
      serviceCharge:serviceCharge,
      deliveryFee,
      total:finalTotal,
      status:"pending",
      time:nowT(),
      type:effectiveType,
      paid,
      payMethod,
      slot:type==="collection"?slot:null,
      discCode:disc?.code||null,
      source:type==="eatin"?"qr-table":"online",
      deliveryCode,
      codeMethod:type==="delivery"?codeMethod:null,
    };
    onOrder(o);
    setLast(o);
    setCart({});
    // Save order ID to localStorage so customer can find it in Track tab even as guest
    try{
      var recent=JSON.parse(localStorage.getItem("my_orders")||"[]");
      if(!recent.includes(o.id))recent.unshift(o.id);
      localStorage.setItem("my_orders",JSON.stringify(recent.slice(0,20)));
    }catch(e){}
    push({title:"Order placed!",body:o.id+" - "+(paid?"Paid online":payMethod==="cod"?"Cash on delivery":"Pay later")+" - "+fmt(finalTotal),color:paid?"#059669":"#d4952a"});
    setStep(type==="collection"?"cdone":"done");
  };

  if(step==="cdone"&&last) return <div className="page fadeup" style={{maxWidth:420,textAlign:"center"}}>
    <p style={{fontSize:48,marginBottom:12}}>{EM.bag}</p>
    <h2 style={{fontSize:24,marginBottom:5}}>Collection Confirmed!</h2>
    <div style={{background:"linear-gradient(135deg,#7c3aed,#a855f7)",borderRadius:12,padding:"16px 20px",margin:"16px auto",color:"#fff",display:"inline-block",minWidth:180}}><p style={{fontSize:10,opacity:.7,letterSpacing:2,marginBottom:3}}>COLLECT AT</p><p style={{fontFamily:"'Playfair Display',serif",fontSize:38,fontWeight:700}}>{last.slot}</p></div>
    <div style={{display:"flex",gap:8,justifyContent:"center",marginTop:14}}><button className="btn btn-r" onClick={()=>{setStep("menu");setSlot(null);setDisc(null);setCode("");}}>Order Again</button><button className="btn btn-o" onClick={()=>printR(last,branch)}>Receipt</button></div>
  </div>;

  if(step==="done") return <div className="page fadeup" style={{maxWidth:480,textAlign:"center"}}>
    {/* Success animation */}
    <div style={{display:"inline-block",padding:"24px",background:"linear-gradient(135deg,#22c55e,#16a34a)",borderRadius:"50%",marginBottom:14,boxShadow:"0 8px 24px rgba(34,197,94,.3)"}}>
      <p style={{fontSize:48,color:"#fff",margin:0,lineHeight:1}}>{String.fromCharCode(0x2713)}</p>
    </div>
    <h2 style={{fontSize:26,marginBottom:5,fontWeight:700}}>Order Confirmed!</h2>
    <p style={{color:"#8a8078",marginBottom:14,fontSize:14}}>Thank you, {last?.customer}!</p>
    
    {/* Order ID + Time */}
    <div style={{display:"flex",justifyContent:"center",gap:14,marginBottom:14,fontSize:12,color:"#8a8078"}}>
      <span>{String.fromCharCode(0xD83D,0xDCCB)} <strong style={{color:"#1a1208"}}>{last?.id}</strong></span>
      <span>{String.fromCharCode(0x23F0)} <strong style={{color:"#1a1208"}}>{last?.time}</strong></span>
    </div>
    
    {/* Estimated time */}
    <div style={{padding:"14px 18px",background:"#fef3c7",borderRadius:11,marginBottom:14,border:"1px solid #fde68a"}}>
      <p style={{fontSize:11,letterSpacing:2,color:"#92400e",fontWeight:700,marginBottom:5}}>{String.fromCharCode(0x23F1,0xFE0F)} {last?.type==="delivery"?"ESTIMATED DELIVERY":(last?.type==="dine-in"||last?.type==="eatin")?"FOOD READY IN":"ESTIMATED COLLECTION"}</p>
      <p style={{fontSize:24,color:"#1a1208",fontWeight:700,fontFamily:"'Playfair Display',serif"}}>{last?.type==="delivery"?"30-45 min":"15-20 min"}</p>
      {(last?.type==="dine-in"||last?.type==="eatin")&&<p style={{fontSize:11,color:"#92400e",marginTop:5}}>{String.fromCharCode(0xD83C,0xDF7D,0xFE0F)} A staff member will bring your food to your table</p>}
    </div>
    
    {/* Delivery Code (if delivery) */}
    {last?.deliveryCode&&<div style={{background:"linear-gradient(135deg,#1e40af,#2563eb)",color:"#fff",borderRadius:14,padding:"20px 16px",margin:"14px auto",maxWidth:320,boxShadow:"0 8px 24px rgba(30,64,175,.3)"}}>
      <p style={{fontSize:11,letterSpacing:2,fontWeight:700,marginBottom:7,opacity:.85}}>{String.fromCharCode(0xD83D,0xDD12)} DELIVERY CODE</p>
      <p style={{fontSize:44,fontWeight:700,letterSpacing:9,fontFamily:"'Courier New',monospace",marginBottom:7}}>{last.deliveryCode}</p>
      <p style={{fontSize:11,opacity:.85}}>Show this to driver on arrival</p>
    </div>}
    {last?.deliveryCode&&last?.codeMethod&&last.codeMethod!=="app"&&<p style={{fontSize:11,color:"#8a8078",marginBottom:9,fontStyle:"italic"}}>{String.fromCharCode(0xD83D,0xDCE7)} {last.codeMethod==="sms"?"Sent by SMS":last.codeMethod==="email"?"Sent by email":"Sent by SMS and email"} (when available)</p>}
    
    {/* Order summary */}
    <div style={{padding:"14px",background:"#fafaf5",borderRadius:11,marginBottom:14,textAlign:"left",border:"1px solid #ede8de"}}>
      <p style={{fontSize:11,letterSpacing:2,color:"#8a8078",fontWeight:700,marginBottom:9}}>YOUR ORDER</p>
      {last?.items?.map((it,i)=><div key={i} style={{display:"flex",justifyContent:"space-between",fontSize:13,marginBottom:5}}>
        <span>{it.qty}x {it.name}</span>
        <span style={{color:"#8a8078"}}>{fmt(it.price*it.qty)}</span>
      </div>)}
      <div style={{display:"flex",justifyContent:"space-between",marginTop:7,paddingTop:7,borderTop:"1px solid #ede8de",fontWeight:700,fontSize:14}}>
        <span>Total</span>
        <span style={{color:"#bf4626"}}>{fmt(last?.total||0)}</span>
      </div>
      <div style={{marginTop:7,padding:"7px 9px",background:last?.paid?"#d1fae5":"#fef3c7",borderRadius:7,fontSize:12,fontWeight:700,color:last?.paid?"#065f46":"#92400e",textAlign:"center"}}>
        {last?.paid?String.fromCharCode(0x2713)+" Paid Online":(
          last?.type==="delivery"?String.fromCharCode(0xD83D,0xDCB5)+" Cash on Delivery":
          (last?.type==="dine-in"||last?.type==="eatin")?String.fromCharCode(0xD83D,0xDCB5)+" Pay at the Table":
          String.fromCharCode(0xD83D,0xDCB5)+" Pay on Collection"
        )}
      </div>
    </div>
    
    {/* Actions */}
    <div style={{display:"flex",gap:9,justifyContent:"center",flexWrap:"wrap"}}>
      <button className="btn btn-r" onClick={()=>setStep("menu")} style={{padding:"11px 22px"}}>{String.fromCharCode(0xD83D,0xDD04)} Order Again</button>
      <button className="btn btn-o" onClick={()=>printR(last,branch)} style={{padding:"11px 22px"}}>{String.fromCharCode(0xD83D,0xDDB0,0xFE0F)} Receipt</button>
    </div>
    
    <p style={{fontSize:11,color:"#8a8078",marginTop:18,fontStyle:"italic"}}>{String.fromCharCode(0xD83D,0xDCA1)} Save this page or take a screenshot for reference</p>
  </div>;

  if(step==="checkout") return <>
    {showPay&&<Pay amount={total} onSuccess={()=>{setPay(false);finalize(true);}} onClose={()=>setPay(false)}/>}
    <div className="page fadeup" style={{maxWidth:500}}>
      <button className="btn btn-g" onClick={()=>setStep("menu")} style={{marginBottom:10,fontSize:13}}>{String.fromCharCode(0x2190)} Back to menu</button>
      
      {/* Progress steps */}
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:14,padding:"10px 14px",background:"#fff",borderRadius:9,border:"1px solid #ede8de"}}>
        {[["1","Cart","#22c55e"],["2","Details",type==="delivery"&&postcodeData&&postcodeData.valid?"#22c55e":(cname?"#bf4626":"#ccc")],["3","Pay","#ccc"]].map((s,i,arr)=><div key={i} style={{display:"flex",alignItems:"center",flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:5,flex:1}}>
            <div style={{width:24,height:24,borderRadius:"50%",background:s[2],color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700}}>{s[0]}</div>
            <span style={{fontSize:11,fontWeight:700,color:s[2]==="#ccc"?"#8a8078":"#1a1208"}}>{s[1]}</span>
          </div>
          {i<arr.length-1 && <div style={{height:2,flex:1,background:"#ede8de",marginRight:5}}/>}
        </div>)}
      </div>
      
      <h2 style={{fontSize:22,marginBottom:14}}>Checkout</h2>
      <div className="card" style={{marginBottom:10}}>
        <p style={{fontWeight:700,marginBottom:9,fontSize:14}}>How would you like your order?</p>
        <div className="g3" style={{marginBottom:12}}>{[["delivery",t("delivery")],["collection",t("collection")],["eatin",t("eatIn")]].filter(([tp])=>{
          // Filter based on restaurant service types
          if(!restaurant)return true;
          if(tp==="delivery"&&!hasService(restaurant,"delivery"))return false;
          if(tp==="collection"&&!hasService(restaurant,"collection"))return false;
          if(tp==="eatin"&&!hasService(restaurant,"dine_in"))return false;
          return true;
        }).map(([tp,lb])=><button key={tp} onClick={()=>{setType(tp);setSlot(null);}} style={{padding:"12px 4px",borderRadius:9,fontWeight:700,fontSize:12,border:"2px solid "+(type===tp?"#bf4626":"#ede8de"),background:type===tp?"#fff5f3":"#fff",color:type===tp?"#bf4626":"#1a1208",cursor:"pointer"}}>{lb}</button>)}</div>
        {type==="eatin"&&<div style={{padding:"14px 16px",background:"#fffbeb",borderRadius:9,border:"2px solid #fde68a"}}>
          <p style={{fontSize:13,fontWeight:700,color:"#92400e",marginBottom:5}}>{EM.cart} At the restaurant?</p>
          <p style={{fontSize:12,color:"#92400e",marginBottom:8}}>Scan the QR code on your table to order. A staff member can also take your order at the table.</p>
          {(()=>{var sess=getQrSession();if(sess.valid){return <div>
            <p style={{fontSize:13,fontWeight:700,color:"#059669",padding:"8px 10px",background:"#d1fae5",borderRadius:6,marginBottom:8}}>{EM.check} You are at Table {sess.table}. Your order will be delivered here.</p>
            <button onClick={()=>{if(window.confirm("End your table session? If you have finished eating and are leaving, this will clear your QR session."))clearQrSession();window.location.reload();}} style={{width:"100%",padding:"7px",fontSize:11,background:"#f5f0eb",color:"#8a8078",border:"1px solid #ede8de",borderRadius:6,cursor:"pointer"}}>I'm leaving the restaurant</button>
          </div>;}return <button onClick={()=>setType("collection")} style={{width:"100%",padding:"10px",background:"#bf4626",color:"#fff",border:"none",borderRadius:7,cursor:"pointer",fontWeight:700,fontSize:13}}>Switch to Collection Instead</button>;})()}
        </div>}
        {type==="delivery"&&<div style={{marginBottom:5}}>
          <div style={{marginBottom:9}}><label className="lbl">Your Name</label><input className="field" value={cname} onChange={e=>setCname(e.target.value)} placeholder="Alex Smith"/></div>
          <div style={{marginBottom:9}}><label className="lbl">Phone</label><input className="field" type="tel" value={table} onChange={e=>setTable(e.target.value)} placeholder="07700 900000"/></div>
          {/* POSTCODE FIRST - so customer sees if we deliver before typing more */}
          <div style={{marginBottom:9}}><label className="lbl">{String.fromCharCode(0xD83D,0xDCCD)} Postcode (enter this first)</label>
            <div style={{display:"flex",gap:6}}>
              <input className="field" value={addr.postcode} onChange={e=>{
                var v=e.target.value.toUpperCase();
                setAddr({...addr,postcode:v});
                setPostcodeData(null);
                // Auto-check when full UK postcode format reached (e.g. "E1 6QL" or "E16QL")
                var clean=v.replace(/\s+/g,"");
                if(/^[A-Z]{1,2}[0-9][A-Z0-9]?[0-9][A-Z]{2}$/.test(clean)){
                  checkPostcode(v);
                }
              }} onBlur={()=>{if(addr.postcode&&addr.postcode.length>=5)checkPostcode(addr.postcode);}} placeholder="E1 6QL" style={{flex:1,fontSize:16}}/>
              <button onClick={()=>checkPostcode(addr.postcode)} disabled={!addr.postcode||checkingPc} style={{padding:"9px 14px",fontSize:12,fontWeight:700,background:"#1a1208",color:"#fff",border:"none",borderRadius:8,cursor:"pointer"}}>{checkingPc?"Checking...":"Check"}</button>
            </div>
            <p style={{fontSize:10,color:"#8a8078",marginTop:4}}>{String.fromCharCode(0xD83D,0xDCA1)} We'll auto-check if we deliver to your area</p>
          </div>
          {postcodeData&&postcodeData.valid&&<div style={{padding:"10px 12px",background:"#d1fae5",borderRadius:7,fontSize:12,color:"#065f46",marginBottom:9}}>
            <strong>{EM.check} We deliver here!</strong><br/>
            {postcodeData.miles} miles - {postcodeData.fee>0?"Delivery fee "+fmt(postcodeData.fee):"FREE delivery"}
            {postcodeData.town&&<><br/>{String.fromCharCode(0xD83D,0xDCCD)} Area: {postcodeData.town}</>}
          </div>}
          {postcodeData&&!postcodeData.valid&&<div style={{padding:"10px 12px",background:"#fee2e2",borderRadius:7,fontSize:12,color:"#991b1b",marginBottom:9}}>
            <strong>{EM.cross}</strong> {postcodeData.reason}
          </div>}
          {/* Street - shown after postcode validated */}
          <div style={{marginBottom:9}}><label className="lbl">House Number & Street</label><input className="field" value={addr.line1} onChange={e=>setAddr({...addr,line1:e.target.value})} placeholder="123 Brick Lane"/></div>
          <div style={{marginBottom:9}}><label className="lbl">Delivery notes (optional)</label><input className="field" value={addr.notes} onChange={e=>setAddr({...addr,notes:e.target.value})} placeholder="Ring bell, flat 2..."/></div>
          {dbDelivery&&dbDelivery.minOrder&&sub<dbDelivery.minOrder&&<div style={{padding:"9px 11px",background:"#fffbeb",borderRadius:7,fontSize:12,color:"#92400e",marginBottom:9}}>
            Minimum order for delivery: {fmt(dbDelivery.minOrder)} - add {fmt(dbDelivery.minOrder-sub)} more
          </div>}
          <div style={{padding:"10px 12px",background:"#eff6ff",borderRadius:7,marginBottom:9}}>
            <p style={{fontSize:12,fontWeight:700,color:"#1e40af",marginBottom:6}}>How to receive delivery code?</p>
            <p style={{fontSize:10,color:"#1e3a8a",marginBottom:7}}>4-digit code to give the driver - proves correct delivery</p>
            <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:5}}>
              {[["sms","Text (SMS)"],["email","Email"],["both","Both"],["app","Show in app only"]].map(([k,l])=><button key={k} onClick={()=>setCodeMethod(k)} style={{padding:"8px 4px",fontSize:11,fontWeight:700,background:codeMethod===k?"#2563eb":"#fff",color:codeMethod===k?"#fff":"#1e3a8a",border:"2px solid "+(codeMethod===k?"#2563eb":"#bfdbfe"),borderRadius:6,cursor:"pointer"}}>{l}</button>)}
            </div>
          </div>
        </div>}
        {type==="collection"&&<div><div style={{marginBottom:9}}><label className="lbl">Your Name</label><input className="field" value={cname} onChange={e=>setCname(e.target.value)} placeholder="Alex Smith"/></div><label className="lbl">Collection Time</label><div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:5,marginTop:4}}>{slots.map(s=><button key={s} disabled={busy.includes(s)} onClick={()=>setSlot(s)} style={{padding:"8px 4px",borderRadius:7,fontWeight:700,fontSize:12,border:"2px solid "+(slot===s?"#7c3aed":"#ede8de"),background:slot===s?"#f5f0ff":"#fff",color:slot===s?"#7c3aed":busy.includes(s)?"#ccc":"#1a1208",opacity:busy.includes(s)?.4:1,cursor:busy.includes(s)?"not-allowed":"pointer"}}>{s}</button>)}</div></div>}
      </div>
      <div className="card" style={{marginBottom:10}}>
        <p style={{fontWeight:700,marginBottom:9,fontSize:14}}>Order Summary</p>
        {items.map(i=><div key={i.id} style={{display:"flex",justifyContent:"space-between",padding:"5px 0",borderBottom:"1px solid #ede8de",fontSize:13}}><span>{i.name} x{i.qty}</span><span style={{fontWeight:600}}>{fmt(i.price*i.qty)}</span></div>)}
        <div style={{marginTop:9}}><div style={{display:"flex",gap:7,marginBottom:4}}><input className="field" value={code} onChange={e=>{setCode(e.target.value.toUpperCase());setDerr("");setDisc(null);}} placeholder="Discount code" style={{flex:1}}/><button className="btn btn-o" onClick={applyCode} style={{padding:"0 12px",flexShrink:0}}>Apply</button></div>{derr&&<p style={{fontSize:11,color:"#dc2626",fontWeight:600}}>{derr}</p>}{disc&&<p style={{fontSize:11,color:"#059669",fontWeight:600}}>Applied: {disc.desc} - saving {fmt(disc.saving)}</p>}</div>
        <div className="hr"/>
        <div style={{display:"flex",justifyContent:"space-between",fontSize:13,color:"#8a8078",marginBottom:3}}><span>Subtotal</span><span>{fmt(sub)}</span></div>
        {saving>0&&<div style={{display:"flex",justifyContent:"space-between",fontSize:13,color:"#059669",marginBottom:3}}><span>Discount</span><span>- {fmt(saving)}</span></div>}
        {serviceChargeApplies&&includeCharge&&<div style={{display:"flex",justifyContent:"space-between",fontSize:13,color:"#7c3aed",marginBottom:3,alignItems:"center"}}>
          <span>Service charge ({dbDelivery.serviceChargePercent}%){canRemove&&<button onClick={()=>setServiceChargeOpt(false)} style={{marginLeft:6,fontSize:10,color:"#dc2626",background:"none",border:"none",cursor:"pointer",textDecoration:"underline"}}>Remove</button>}</span>
          <span>+ {fmt(serviceCharge)}</span>
        </div>}
        {serviceChargeApplies&&!includeCharge&&canRemove&&<div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"#8a8078",marginBottom:3}}>
          <span>Service charge removed</span>
          <button onClick={()=>setServiceChargeOpt(true)} style={{fontSize:10,color:"#7c3aed",background:"none",border:"none",cursor:"pointer",textDecoration:"underline"}}>Add back</button>
        </div>}
        <div style={{display:"flex",justifyContent:"space-between",fontWeight:700,fontSize:16}}><span>Total</span><span style={{color:"#bf4626"}}>{fmt(total)}</span></div>
      </div>
      {(()=>{
        var sess=getQrSession();
        var qrTable=sess.valid?sess.table:null;
        var isEatInAtTable=type==="eatin"&&qrTable;
        if(type==="eatin"&&!qrTable){
          return <div style={{padding:"14px",background:"#fef3c7",borderRadius:9,textAlign:"center",fontSize:13,color:"#92400e",fontWeight:600}}>Please scan the QR code at your table, or switch to Delivery/Collection above.</div>;
        }
        if(type==="delivery"){
          if(!cname||!table){return <button disabled style={{width:"100%",padding:"12px",background:"#ccc",color:"#fff",border:"none",borderRadius:8,fontWeight:700,cursor:"not-allowed"}}>Enter name and phone to continue</button>;}
          if(!addr.line1||!addr.postcode){return <button disabled style={{width:"100%",padding:"12px",background:"#ccc",color:"#fff",border:"none",borderRadius:8,fontWeight:700,cursor:"not-allowed"}}>Enter delivery address and postcode</button>;}
          if(!postcodeData){return <button disabled style={{width:"100%",padding:"12px",background:"#ccc",color:"#fff",border:"none",borderRadius:8,fontWeight:700,cursor:"not-allowed"}}>Click "Check" to verify postcode</button>;}
          if(!postcodeData.valid){return <div style={{padding:"12px",background:"#fee2e2",color:"#991b1b",borderRadius:8,textAlign:"center",fontWeight:700}}>{postcodeData.reason}</div>;}
          if(dbDelivery&&dbDelivery.minOrder&&sub<dbDelivery.minOrder){return <button disabled style={{width:"100%",padding:"12px",background:"#ccc",color:"#fff",border:"none",borderRadius:8,fontWeight:700,cursor:"not-allowed"}}>Minimum {fmt(dbDelivery.minOrder)} required</button>;}
          // Check COD using DB settings
          var codOk=false,codReason="Cash on delivery not accepted";
          if(dbDelivery&&dbDelivery.codEnabled){
            if(total<dbDelivery.codMinOrder){codReason="Min "+fmt(dbDelivery.codMinOrder)+" for cash on delivery";}
            else if(postcodeData.miles&&parseFloat(postcodeData.miles)>dbDelivery.codMaxMiles){codReason="COD only within "+dbDelivery.codMaxMiles+" miles";}
            else codOk=true;
          }
          var actualFee=disc&&disc.freeDelivery?0:(postcodeData.fee||0);
          var finalTotal=total+actualFee;
          return <div>
            <div style={{padding:"10px 12px",background:"#fafaf5",borderRadius:7,marginBottom:9,fontSize:13}}>
              <div style={{display:"flex",justifyContent:"space-between"}}><span>Subtotal</span><span>{fmt(total)}</span></div>
              <div style={{display:"flex",justifyContent:"space-between"}}><span>Delivery{disc&&disc.freeDelivery?" (Promo)":""}</span><span style={{color:actualFee===0?"#059669":"#1a1208",fontWeight:700}}>{actualFee===0?"FREE":fmt(actualFee)}</span></div>
              <div style={{display:"flex",justifyContent:"space-between",fontWeight:700,fontSize:15,marginTop:4,paddingTop:4,borderTop:"1px solid #ede8de"}}><span>Total</span><span style={{color:"#bf4626"}}>{fmt(finalTotal)}</span></div>
            </div>
            <button className="btn btn-r" onClick={()=>setPay(true)} style={{width:"100%",padding:"12px",fontSize:14,marginBottom:7}}>{EM.star} Pay Online - {fmt(finalTotal)}</button>
            {codOk?<button className="btn btn-o" onClick={()=>finalize(false)} style={{width:"100%",padding:"12px",fontSize:13}}>{EM.pound} Cash on Delivery - {fmt(finalTotal)}</button>:<div style={{padding:"9px 11px",background:"#f5f0eb",borderRadius:7,fontSize:11,color:"#8a8078",textAlign:"center"}}>{EM.pound} Cash on Delivery: {codReason}</div>}
          </div>;
        }
        if(type==="collection"){
          if(!cname){return <button disabled style={{width:"100%",padding:"12px",background:"#ccc",color:"#fff",border:"none",borderRadius:8,fontWeight:700,cursor:"not-allowed"}}>Enter your name to continue</button>;}
          if(!slot){return <button disabled style={{width:"100%",padding:"12px",background:"#ccc",color:"#fff",border:"none",borderRadius:8,fontWeight:700,cursor:"not-allowed"}}>Select a collection time</button>;}
          return <div style={{display:"flex",gap:8}}><button className="btn btn-p" onClick={()=>setPay(true)} style={{flex:1,padding:"12px"}}>Pay Online - {fmt(total)}</button><button className="btn btn-o" onClick={()=>finalize(false)} style={{flex:1,padding:"12px"}}>Pay at Collection</button></div>;
        }
        if(isEatInAtTable){
          return <div style={{display:"flex",gap:8}}><button className="btn btn-r" onClick={()=>setPay(true)} style={{flex:1,padding:"12px"}}>Pay Now - {fmt(total)}</button><button className="btn btn-o" onClick={()=>finalize(false)} style={{flex:1,padding:"12px"}}>Ask Staff for Bill</button></div>;
        }
        return null;
      })()}
    </div>
  </>;

  return <div className="page">
    {(()=>{var sess=getQrSession();if(!sess.valid)return null;return <div style={{background:"linear-gradient(135deg,#d1fae5,#a7f3d0)",border:"2px solid #059669",borderRadius:12,padding:"11px 14px",marginBottom:12,display:"flex",alignItems:"center",justifyContent:"space-between",gap:10,flexWrap:"wrap"}}>
      <div>
        <p style={{fontSize:13,fontWeight:700,color:"#065f46",marginBottom:2}}>{EM.check} Seated at Table {sess.table}</p>
        <p style={{fontSize:11,color:"#047857"}}>Dine-in prices apply - your order comes to your table</p>
      </div>
      <button onClick={()=>{if(window.confirm("End your table session? Only click this if you have finished eating and are leaving the restaurant."))clearQrSession();window.location.reload();}} style={{padding:"7px 12px",fontSize:11,background:"#fff",color:"#065f46",border:"1px solid #059669",borderRadius:7,cursor:"pointer",fontWeight:700}}>End Session / Leaving</button>
    </div>;})()}
    <div style={{background:"linear-gradient(135deg,#1a1208,#2e1f10)",borderRadius:16,padding:"22px 24px",marginBottom:16,position:"relative",overflow:"hidden"}}>
      <div style={{position:"absolute",inset:0,background:"radial-gradient(ellipse at 80% 50%,rgba(212,149,42,.12),transparent 70%)"}}/>
      <div style={{position:"relative",zIndex:1}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:4}}>
          <div>
            <p style={{color:"#d4952a",fontSize:10,letterSpacing:3,fontWeight:700,textTransform:"uppercase",marginBottom:4}}>Welcome to</p>
            <h1 style={{color:"#fff",fontSize:30,marginBottom:4}}>{restaurant?.name||"La Tavola"}</h1>
          </div>
          <LanguagePicker compact={true}/>
        </div>
        {branch&&<div style={{display:"flex",alignItems:"center",gap:10,marginTop:6,flexWrap:"wrap"}}>
          <p style={{color:"rgba(255,255,255,.5)",fontSize:13}}>{EM.pin} {branch.addr}</p>
        </div>}
        {user&&<p style={{color:"#d4952a",fontSize:13,marginTop:6}}>{EM.wave} Hello, {user.name.split(" ")[0]}!</p>}
      </div>
    </div>
    <div style={{display:"flex",gap:6,overflowX:"auto",paddingBottom:4,marginBottom:12}}>
      {cats.map(c=><button key={c} onClick={()=>setCat(c)} style={{whiteSpace:"nowrap",padding:"7px 14px",borderRadius:50,fontWeight:600,fontSize:12,border:"2px solid "+(cat===c?"#bf4626":"#ede8de"),background:cat===c?"#bf4626":"#fff",color:cat===c?"#fff":"#1a1208",flexShrink:0,cursor:"pointer",transition:"all .18s"}}>{c}</button>)}
    </div>
    <div className="ag" style={{marginBottom:88}}>
      {(()=>{var seen=new Set();return menu.filter(i=>i.cat===cat&&i.avail&&isItemAvailable(i,type)).filter(i=>{var key=(i.name||"").toLowerCase().trim()+"|"+(i.cat||"");if(seen.has(key))return false;seen.add(key);return true;}).map(item=>{var displayPrice=getItemPrice(item,type);return <div key={item.dbId||item.id} className="card" style={{display:"flex",flexDirection:"column",gap:7,opacity:item.stock===0?.5:1,overflow:"hidden",padding:item.image_url?0:14}}>
        {/* Image (if available) */}
        {item.image_url && <div style={{width:"100%",height:140,position:"relative",overflow:"hidden",background:"#f7f3ee"}}>
          <img src={item.image_url} alt={item.name} style={{width:"100%",height:"100%",objectFit:"cover"}} onError={e=>{e.target.style.display="none";}}/>
          <div style={{position:"absolute",top:7,right:7}}>
            {item.stock>0&&item.stock<=5&&<span className="bdg" style={{background:"#fef3c7",color:"#d97706",fontSize:10}}>Low stock</span>}
            {item.stock===0&&<span className="bdg" style={{background:"#fee2e2",color:"#dc2626",fontSize:10}}>Sold out</span>}
          </div>
        </div>}
        <div style={{padding:item.image_url?14:0,display:"flex",flexDirection:"column",gap:7,flex:1}}>
        {!item.image_url && <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
          <span style={{fontSize:32,lineHeight:1}}>{EM[item.icon]||""}</span>
          <div>{item.stock>0&&item.stock<=5&&<span className="bdg" style={{background:"#fef3c7",color:"#d97706",fontSize:10}}>Low stock</span>}{item.stock===0&&<span className="bdg" style={{background:"#fee2e2",color:"#dc2626",fontSize:10}}>Sold out</span>}</div>
        </div>}
        <h3 style={{fontSize:14,fontFamily:"'Inter',sans-serif",fontWeight:700}}>{item.name}</h3>
        <p style={{fontSize:12,color:"#8a8078",lineHeight:1.5,flex:1}}>{item.desc}</p>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span style={{fontSize:15,fontWeight:700,color:"#bf4626"}}>{fmt(displayPrice)}</span>
          {item.stock>0&&(cart[item.id]?<div style={{display:"flex",alignItems:"center",gap:8,background:"#f7f3ee",borderRadius:50,padding:"3px 12px",border:"1px solid #ede8de"}}><button onClick={()=>rem(item.id)} style={{fontWeight:700,fontSize:20,color:"#bf4626",lineHeight:1,border:"none",background:"none",cursor:"pointer"}}>-</button><span style={{fontWeight:700,minWidth:14,textAlign:"center"}}>{cart[item.id]}</span><button onClick={()=>add(item.id)} style={{fontWeight:700,fontSize:20,color:"#bf4626",lineHeight:1,border:"none",background:"none",cursor:"pointer"}}>+</button></div>:<button onClick={()=>add(item.id)} style={{background:"#1a1208",color:"#fff",borderRadius:"50%",width:32,height:32,fontSize:18,display:"flex",alignItems:"center",justifyContent:"center",border:"none",cursor:"pointer",flexShrink:0}} onMouseEnter={e=>e.currentTarget.style.background="#bf4626"} onMouseLeave={e=>e.currentTarget.style.background="#1a1208"}>+</button>)}
        </div>
        </div>
      </div>;});})()}
    </div>
    {count>0&&<div style={{position:"fixed",bottom:80,left:"50%",transform:"translateX(-50%)",zIndex:300}}>
      <button className="btn btn-d" onClick={()=>setStep("checkout")} style={{padding:"12px 24px",borderRadius:50,fontSize:13,boxShadow:"0 8px 28px rgba(0,0,0,.3)",gap:8,minWidth:190}}>
        <span style={{background:"#bf4626",borderRadius:"50%",width:22,height:22,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,flexShrink:0}}>{count}</span>
        <span style={{flex:1,textAlign:"center"}}>{t("viewCart")}</span>
        <span style={{color:"#d4952a",fontWeight:700}}>{fmt(total)}</span>
      </button>
    </div>}
  </div>;
}

function TrackV({orders,branches,user}){
  var [q,setQ]=useState(""),[found,setFound]=useState(null),[tried,setTried]=useState(false);
  // Auto-update displayed order as orders prop changes (real-time status sync)
  useEffect(()=>{
    if(found&&orders){
      var updated=orders.find(o=>o.id===found.id);
      if(updated)setFound(updated);
    }
  },[orders,found]);
  var search=()=>{
    var ord=orders.find(o=>o.id.toLowerCase()===q.trim().toLowerCase())||null;
    setFound(ord);
    setTried(true);
    // Save searched order ID to recent list so it persists
    if(ord){
      try{
        var recent=JSON.parse(localStorage.getItem("my_orders")||"[]");
        if(!recent.includes(ord.id))recent.unshift(ord.id);
        localStorage.setItem("my_orders",JSON.stringify(recent.slice(0,20)));
      }catch(e){}
    }
  };

  // Get recent order IDs from localStorage (works for guest QR orders too)
  var [recentIds,setRecentIds]=useState(()=>{
    try{return JSON.parse(localStorage.getItem("my_orders")||"[]");}catch(e){return [];}
  });
  // Re-check localStorage on mount + when orders change (in case order placed in another tab)
  useEffect(()=>{
    try{setRecentIds(JSON.parse(localStorage.getItem("my_orders")||"[]"));}catch(e){}
  },[orders]);

  // Filter active orders to ONLY this user's orders (privacy)
  var myActiveOrders=orders.filter(o=>{
    if(!["pending","preparing","ready"].includes(o.status))return false;
    // Match logged-in user
    if(user){
      if(user.id&&o.userId===user.id)return true;
      if(user.phone&&o.phone===user.phone)return true;
    }
    // Match recent order IDs from localStorage (works for guest users)
    if(recentIds.includes(o.id))return true;
    return false;
  });
  var fb=found?branches.find(b=>b.id===found.branchId):null;
  var stepsN=["pending","preparing","ready","delivered"],stepsC=["pending","preparing","ready","collected"];
  var steps=found?.type==="collection"?stepsC:stepsN,si=found?steps.indexOf(found.status):-1;
  var pct=si<0?0:Math.round((si/(steps.length-1))*100);
  return <div className="page" style={{maxWidth:500}}>
    <h2 style={{fontSize:24,marginBottom:4}}>Track Your Order</h2>
    <p style={{color:"#8a8078",fontSize:13,marginBottom:16}}>Enter your order ID</p>
    <div style={{display:"flex",gap:8,marginBottom:18}}><input className="field" value={q} onChange={e=>setQ(e.target.value)} onKeyDown={e=>e.key==="Enter"&&search()} placeholder="e.g. ORD-12345" style={{flex:1}}/><button className="btn btn-r" onClick={search}>Search</button></div>
    {tried&&!found&&<div className="card" style={{textAlign:"center",padding:20}}><p style={{fontWeight:700}}>Order not found</p></div>}
    {found&&<div className="card fadeup" style={{marginBottom:14}}>
      <div style={{display:"flex",justifyContent:"space-between",marginBottom:12,flexWrap:"wrap",gap:8}}>
        <div><p style={{fontWeight:700,fontSize:15}}>{found.id}</p><p style={{color:"#8a8078",fontSize:12}}>{found.customer} - {found.time} - {found.type}</p></div>
        <div style={{textAlign:"right"}}><span className="bdg" style={{background:SB[found.status],color:SC[found.status]}}>{SL[found.status]}</span>{found.slot&&<div style={{background:"#f5f0ff",borderRadius:7,padding:"5px 10px",marginTop:4}}><p style={{fontSize:9,color:"#7c3aed",fontWeight:700}}>COLLECT AT</p><p style={{fontSize:18,fontWeight:700,color:"#7c3aed"}}>{found.slot}</p></div>}</div>
      </div>
      <div style={{background:"#1a1208",borderRadius:10,padding:14,marginBottom:12,color:"#fff"}}>
        <div style={{height:3,background:"rgba(255,255,255,.1)",borderRadius:2,overflow:"hidden",marginBottom:10}}><div style={{height:"100%",background:"#4ade80",width:pct+"%",borderRadius:2,transition:"width .8s"}}/></div>
        <div style={{display:"flex",justifyContent:"space-between"}}>{steps.map((s,i)=><div key={s} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:3,flex:1}}><div style={{width:18,height:18,borderRadius:"50%",background:i<=si?"#4ade80":"rgba(255,255,255,.1)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:10}}>{i<=si?"v":""}</div><span style={{fontSize:8,color:i<=si?"#4ade80":"#555",textAlign:"center",fontWeight:600}}>{SL[s]}</span></div>)}</div>
      </div>
      {found.items.map((it,i)=><div key={i} style={{display:"flex",justifyContent:"space-between",padding:"5px 0",borderBottom:"1px solid #ede8de",fontSize:13}}><span>{it.name} x{it.qty}</span><span style={{fontWeight:600}}>{fmt(it.price*it.qty)}</span></div>)}
      <div style={{display:"flex",justifyContent:"space-between",marginTop:8,fontWeight:700,fontSize:15}}><span>Total</span><span style={{color:"#bf4626"}}>{fmt(found.total)}</span></div>
      <button onClick={()=>printR(found,fb)} className="btn btn-o" style={{width:"100%",marginTop:9,padding:"8px",fontSize:13}}>Print Receipt</button>
    </div>}
    <h3 style={{fontSize:16,marginBottom:9}}>Your Active Orders</h3>
    {!user&&myActiveOrders.length===0&&<div className="card" style={{padding:14,textAlign:"center",background:"#fffbeb",borderLeft:"4px solid #d97706"}}>
      <p style={{fontSize:12,color:"#92400e",marginBottom:6}}>{EM.star} Sign in to see all your orders</p>
      <p style={{fontSize:11,color:"#92400e"}}>Or enter your order ID above to track</p>
    </div>}
    {user&&myActiveOrders.length===0&&<div className="card" style={{padding:14,textAlign:"center"}}>
      <p style={{fontSize:13,color:"#8a8078"}}>You have no active orders right now</p>
    </div>}
    {myActiveOrders.map(o=><button key={o.id} onClick={()=>{setQ(o.id);setFound(o);setTried(true);}} style={{width:"100%",textAlign:"left",background:"#fff",borderRadius:9,padding:"10px 12px",marginBottom:6,boxShadow:"0 2px 8px rgba(0,0,0,.06)",border:"1px solid #ede8de",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",transition:"transform .15s"}} onMouseEnter={e=>e.currentTarget.style.transform="translateX(4px)"} onMouseLeave={e=>e.currentTarget.style.transform="translateX(0)"}><div><p style={{fontWeight:700,fontSize:13}}>{o.id}</p><p style={{color:"#8a8078",fontSize:11}}>{o.customer} - {o.time}</p></div><span className="bdg" style={{background:SB[o.status],color:SC[o.status]}}>{SL[o.status]}</span></button>)}
  </div>;
}

function BookV({reservations,setReservations,user,onAuth,branches,push}){
  var [step,setStep]=useState("form");
  var defaultBranch=branches&&branches[0]?branches[0].id:"main";
  var [form,setF]=useState({name:user?.name||"",email:user?.email||"",phone:"",date:"",time:"",guests:"2",branchId:defaultBranch,notes:""});
  var [conf,setConf]=useState(null);
  var [hours,setHours]=useState([]);
  var [branchTables,setBranchTables]=useState([]);
  var [slotsLoading,setSlotsLoading]=useState(false);
  var [availSlots,setAvailSlots]=useState([]);
  var [submitting,setSubmitting]=useState(false);
  var [errors,setErrors]=useState({});
  var today=new Date().toISOString().split("T")[0];

  // Load hours + tables when branch changes
  useEffect(()=>{
    if(!form.branchId)return;
    dbFetchHours(form.branchId).then(h=>setHours(h||[]));
    dbFetchTables(form.branchId).then(t=>setBranchTables(t||[]));
  },[form.branchId]);

  // Generate slots whenever date/guests/branch changes
  useEffect(()=>{
    if(!form.date||!form.branchId){setAvailSlots([]);return;}
    setSlotsLoading(true);
    var slots=[];
    var d=new Date(form.date+"T00:00:00");
    var dow=d.getDay();
    var todayHours=hours.find(h=>h.day_of_week===dow);
    
    // FALLBACK: If no hours configured, use default 12:00-22:00
    var openTime, closeTime;
    if(todayHours){
      if(todayHours.is_closed){
        setAvailSlots([]);
        setSlotsLoading(false);
        return;
      }
      openTime=todayHours.open_time;
      closeTime=todayHours.close_time;
    } else {
      // Default hours if none set (12:00 - 22:00)
      openTime="12:00:00";
      closeTime="22:00:00";
    }
    
    // Generate 30-min slots from open to close-90min
    var toMin=t=>{var p=t.split(":");return +p[0]*60+(+p[1]);};
    var toStr=m=>{var h=Math.floor(m/60),mm=m%60;return(h<10?"0":"")+h+":"+(mm<10?"0":"")+mm;};
    var openM=toMin(openTime);
    var closeM=toMin(closeTime);
    if(closeM<openM)closeM+=24*60; // past midnight
    // Last booking 90min before close
    for(var m=openM;m<=closeM-90;m+=30){slots.push(toStr(m%(24*60)));}
    
    // Fetch existing bookings for that date and filter out full slots
    dbFetchReservations(form.branchId,form.date,form.date).then(existingRes=>{
      var party=parseInt(form.guests)||2;
      
      // FALLBACK: If no tables configured, allow all slots (restaurant manages manually)
      if(!branchTables||branchTables.length===0){
        setAvailSlots(slots);
        setSlotsLoading(false);
        return;
      }
      
      // For each slot, check if there are enough tables that fit party
      var validSlots=slots.filter(slot=>{
        // Count tables that fit party size
        var fitsTables=branchTables.filter(t=>t.seats>=party);
        if(fitsTables.length===0)return false;
        // Count existing bookings at this slot (within 90min window)
        var slotM=toMin(slot);
        var booked=(existingRes||[]).filter(r=>{
          if(r.status==="cancelled")return false;
          var rM=toMin(r.reservation_time.slice(0,5));
          return Math.abs(rM-slotM)<90;
        });
        // If booked count >= tables that fit, slot is full
        return booked.length<fitsTables.length;
      });
      setAvailSlots(validSlots);
      setSlotsLoading(false);
    });
  },[form.date,form.branchId,form.guests,hours,branchTables]);

  var validate=()=>{
    var errs={};
    if(!form.name||form.name.trim().length<2)errs.name="Please enter your name";
    if(!form.email)errs.email="Email is required";
    else if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))errs.email="Invalid email format";
    if(!form.phone||form.phone.replace(/\D/g,"").length<7)errs.phone="Phone number is required";
    if(!form.date)errs.date="Please select a date";
    if(!form.time)errs.time="Please select a time";
    if(!form.branchId)errs.branchId="Please select a branch";
    return errs;
  };

  var submit=async ()=>{
    var errs=validate();
    setErrors(errs);
    if(Object.keys(errs).length>0){
      var msgs=Object.values(errs).join(", ");
      push&&push({title:"Please complete the form",body:msgs,color:"#dc2626"});
      // Scroll to first error if possible
      return;
    }
    
    setSubmitting(true);
    var r={...form,id:rid(),guests:+form.guests,status:"confirmed",userId:user?.id||null};
    
    try {
      var result = await dbSaveReservation(r);
      if(result.error){
        console.error("RESERVATION SAVE ERROR:",result.error);
        push&&push({title:"Booking failed",body:result.error.message||"Please try again",color:"#dc2626"});
        setSubmitting(false);
        return;
      }
      
      // Success!
      if(result.data){
        console.log("RESERVATION SAVED:",result.data);
        r.dbId = result.data.id;
      }
      setReservations(rs=>[r,...rs]);
      setConf(r);
      setStep("done");
      push&&push({title:"Booking confirmed!",body:form.date+" at "+form.time,color:"#059669"});
    } catch(err) {
      console.error("RESERVATION EXCEPTION:",err);
      push&&push({title:"Booking failed",body:err.message||"Please try again",color:"#dc2626"});
    }
    setSubmitting(false);
  };

  var dayHours=form.date?hours.find(h=>h.day_of_week===new Date(form.date+"T00:00:00").getDay()):null;

  if(step==="done"&&conf) return <div className="page fadeup" style={{maxWidth:420,textAlign:"center"}}>
    <p style={{fontSize:48,marginBottom:10}}>{EM.party}</p>
    <h2 style={{fontSize:24,marginBottom:5}}>Reservation Confirmed!</h2>
    <p style={{color:"#8a8078",fontSize:13,marginBottom:14}}>We look forward to seeing you</p>
    <div className="card" style={{textAlign:"left",marginBottom:14}}>{[["Branch",(branches.find(b=>b.id===conf.branchId)||{}).name],["Date",conf.date],["Time",conf.time],["Guests",conf.guests+" people"],["Name",conf.name]].map(([k,v])=><div key={k} style={{display:"flex",justifyContent:"space-between",padding:"5px 0",borderBottom:"1px solid #ede8de",fontSize:13}}><span style={{color:"#8a8078"}}>{k}</span><span style={{fontWeight:700}}>{v}</span></div>)}</div>
    <button className="btn btn-r" onClick={()=>{setStep("form");setConf(null);setF({name:user?.name||"",email:user?.email||"",phone:"",date:"",time:"",guests:"2",branchId:"b1",notes:""});}}>Book Again</button>
  </div>;

  return <div className="page" style={{maxWidth:520}}>
    <h2 style={{fontSize:24,marginBottom:4}}>Book a Table</h2>
    <p style={{color:"#8a8078",fontSize:13,marginBottom:18}}>Reserve your spot at La Tavola</p>
    <div className="card" style={{marginBottom:10}}>
      <p style={{fontWeight:700,marginBottom:9,fontSize:14}}>Choose Branch</p>
      {branches.map(b=><button key={b.id} onClick={()=>setF(f=>({...f,branchId:b.id,time:""}))} style={{width:"100%",textAlign:"left",padding:"9px 11px",borderRadius:8,border:"2px solid "+(form.branchId===b.id?"#bf4626":"#ede8de"),background:form.branchId===b.id?"#fff5f3":"#fff",marginBottom:5,cursor:"pointer"}}><p style={{fontWeight:700,fontSize:13}}>{b.name}</p><p style={{color:"#8a8078",fontSize:11}}>{b.addr}</p></button>)}
    </div>
    <div className="card" style={{marginBottom:10}}>
      <div className="g2" style={{marginBottom:9}}>
        <div><label className="lbl">Date</label><input type="date" className="field" value={form.date} min={today} onChange={e=>setF(f=>({...f,date:e.target.value,time:""}))}/></div>
        <div><label className="lbl">Guests</label><select className="field" value={form.guests} onChange={e=>setF(f=>({...f,guests:e.target.value,time:""}))}>{[1,2,3,4,5,6,7,8,10,12].map(n=><option key={n}>{n}</option>)}</select></div>
      </div>
      {form.date&&dayHours&&dayHours.is_closed&&<div style={{padding:"11px 14px",background:"#fee2e2",borderRadius:8,marginBottom:9,fontSize:13,color:"#991b1b",fontWeight:600}}>Sorry, this branch is closed on {new Date(form.date+"T00:00:00").toLocaleDateString("en-GB",{weekday:"long"})}s. Please pick another day.</div>}
      {form.date&&dayHours&&!dayHours.is_closed&&<div style={{padding:"9px 12px",background:"#f0fdf4",borderRadius:8,marginBottom:9,fontSize:12,color:"#065f46"}}><strong>Open {dayHours.open_time?.slice(0,5)} - {dayHours.close_time?.slice(0,5)}</strong> on selected day</div>}
      {form.date&&!slotsLoading&&availSlots.length===0&&dayHours&&!dayHours.is_closed&&<div style={{padding:"11px 14px",background:"#fffbeb",borderRadius:8,marginBottom:9,fontSize:13,color:"#92400e"}}>{EM.cross} No tables available for {form.guests} guests on this date. Try a different date or smaller party size.</div>}
      {form.date&&slotsLoading&&<p style={{fontSize:12,color:"#8a8078",textAlign:"center",padding:10}}>Checking availability...</p>}
      {availSlots.length>0&&<>
        <label className="lbl">Available Times</label>
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:5,marginBottom:9}}>
          {availSlots.map(tm=><button key={tm} onClick={()=>setF(f=>({...f,time:tm}))} style={{padding:"9px 4px",borderRadius:7,fontWeight:700,fontSize:12,border:"2px solid "+(form.time===tm?"#bf4626":"#ede8de"),background:form.time===tm?"#fff5f3":"#fff",color:form.time===tm?"#bf4626":"#1a1208",cursor:"pointer"}}>{tm}</button>)}
        </div>
      </>}
      <div style={{marginBottom:7}}><label className="lbl">Name <span style={{color:"#dc2626"}}>*</span></label><input className="field" value={form.name} onChange={e=>{setF(f=>({...f,name:e.target.value}));setErrors(er=>({...er,name:null}));}} placeholder="Alex Johnson" style={errors.name?{borderColor:"#dc2626"}:{}}/>{errors.name&&<p style={{fontSize:11,color:"#dc2626",marginTop:3}}>{errors.name}</p>}</div>
      <div style={{marginBottom:7}}><label className="lbl">Email <span style={{color:"#dc2626"}}>*</span></label><input className="field" type="email" value={form.email} onChange={e=>{setF(f=>({...f,email:e.target.value}));setErrors(er=>({...er,email:null}));}} placeholder="alex@example.com" style={errors.email?{borderColor:"#dc2626"}:{}}/>{errors.email&&<p style={{fontSize:11,color:"#dc2626",marginTop:3}}>{errors.email}</p>}</div>
      <div style={{marginBottom:7}}><label className="lbl">Phone <span style={{color:"#dc2626"}}>*</span></label><input className="field" type="tel" value={form.phone} onChange={e=>{setF(f=>({...f,phone:e.target.value}));setErrors(er=>({...er,phone:null}));}} placeholder="07700 900000" style={errors.phone?{borderColor:"#dc2626"}:{}}/>{errors.phone&&<p style={{fontSize:11,color:"#dc2626",marginTop:3}}>{errors.phone}</p>}</div>
      <div><label className="lbl">Special Requests</label><textarea className="field" value={form.notes} onChange={e=>setF(f=>({...f,notes:e.target.value}))} rows={2} style={{resize:"vertical"}} placeholder="Window table, birthday..."/></div>
    </div>
    {Object.keys(errors).length>0&&<div style={{padding:"10px 14px",background:"#fee2e2",border:"1px solid #fca5a5",borderRadius:8,marginBottom:9,fontSize:12,color:"#991b1b"}}><strong>Please complete:</strong> {Object.values(errors).join(", ")}</div>}
    <button className="btn btn-r" disabled={submitting} onClick={submit} style={{width:"100%",padding:"14px",fontSize:14,fontWeight:700,opacity:submitting?.5:1,cursor:submitting?"not-allowed":"pointer"}}>{submitting?"Booking...":"Confirm Reservation"}</button>
  </div>;
}


function ReviewsV({reviews,setReviews,user,onAuth}){
  var [show,setShow]=useState(false),[rat,setRat]=useState(5),[com,setCom]=useState("");
  var avg=reviews.length?(reviews.reduce((s,r)=>s+r.rating,0)/reviews.length).toFixed(1):"N/A";
  var stars=(n,sz=14)=>Array.from({length:5}).map((_,i)=><span key={i} style={{color:i<n?"#d4952a":"#ddd",fontSize:sz}}>*</span>);
  var submit=()=>{if(!com.trim())return;var newR={id:"r"+Date.now(),userId:user?.id,name:user?.name||"Guest",rating:rat,comment:com,date:"Just now",helpful:0};setReviews(rs=>[newR,...rs]);dbSubmitReview({customer:newR.name,rating:newR.rating,comment:newR.comment}).catch(e=>console.log("Review DB save:",e));setShow(false);setCom("");setRat(5);};
  return <div className="page" style={{maxWidth:600}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:16,flexWrap:"wrap",gap:8}}>
      <div><h2 style={{fontSize:24,marginBottom:4}}>Reviews</h2><div style={{display:"flex",alignItems:"center",gap:7}}>{stars(Math.round(parseFloat(avg)||0))}<span style={{fontWeight:700,fontSize:17}}>{avg}</span><span style={{color:"#8a8078",fontSize:13}}>({reviews.length})</span></div></div>
      {user?<button className="btn btn-r" onClick={()=>setShow(s=>!s)} style={{padding:"8px 16px"}}>Write a Review</button>:<button className="btn btn-o" onClick={onAuth} style={{padding:"8px 16px"}}>Sign in to review</button>}
    </div>
    {show&&<div className="card fadeup" style={{marginBottom:12,border:"2px solid #bf4626"}}>
      <h3 style={{fontSize:16,marginBottom:10}}>Your Review</h3>
      <div style={{marginBottom:9}}><label className="lbl">Rating</label><div style={{display:"flex",gap:3}}>{[1,2,3,4,5].map(i=><button key={i} onClick={()=>setRat(i)} style={{fontSize:26,color:i<=rat?"#d4952a":"#ddd",border:"none",background:"none",cursor:"pointer"}}>*</button>)}</div></div>
      <div style={{marginBottom:10}}><label className="lbl">Comment</label><textarea className="field" value={com} onChange={e=>setCom(e.target.value)} rows={3} style={{resize:"vertical"}} placeholder="Tell us about your experience..."/></div>
      <div style={{display:"flex",gap:8}}><button className="btn btn-r" onClick={submit} style={{flex:1}}>Submit</button><button className="btn btn-o" onClick={()=>setShow(false)} style={{flex:1}}>Cancel</button></div>
    </div>}
    {reviews.map(r=><div key={r.id} className="card fadeup" style={{marginBottom:9}}>
      <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}><div style={{display:"flex",alignItems:"center",gap:7}}><div style={{background:"#bf4626",color:"#fff",borderRadius:"50%",width:30,height:30,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:11}}>{r.name.slice(0,2).toUpperCase()}</div><div><p style={{fontWeight:700,fontSize:13}}>{r.name}</p><p style={{color:"#8a8078",fontSize:11}}>{r.date}</p></div></div><div>{stars(r.rating)}</div></div>
      <p style={{fontSize:13,lineHeight:1.6,marginBottom:6}}>{r.comment}</p>
      <button onClick={()=>setReviews(rs=>rs.map(x=>x.id===r.id?{...x,helpful:x.helpful+1}:x))} style={{fontSize:11,color:"#8a8078",border:"none",background:"none",cursor:"pointer"}}>Helpful ({r.helpful})</button>
    </div>)}
  </div>;
}

function AccountV({user,orders,reviews,reservations,onAuth,branches}){
  var [tab,setTab]=useState("orders");
  var [diet,setDiet]=useState([]);
  var [loyaltyData,setLoyaltyData]=useState({points:0,tier:"bronze"});
  var [loyaltyHistory,setLoyaltyHistory]=useState([]);
  
  // If a staff member is PIN-logged-in, show THEIR profile instead of the owner's
  var activeStaff=(typeof window!=="undefined")?dbGetActiveStaff():null;
  
  // Load dietary prefs + loyalty data when user logs in
  useEffect(()=>{
    if(!user||!user.id)return;
    dbFetchPrefs(user.id).then(p=>setDiet(p||[]));
    dbFetchLoyalty(user.id).then(d=>{
      setLoyaltyData({points:d.loyalty_points||0,tier:d.loyalty_tier||"bronze"});
    });
    dbLoyaltyHistory(user.id).then(h=>setLoyaltyHistory(h||[]));
  },[user]);

  var toggleDiet=(id)=>{
    var newDiet=diet.includes(id)?diet.filter(x=>x!==id):[...diet,id];
    setDiet(newDiet);
    if(user&&user.id)dbSavePrefs(user.id,newDiet);
  };
  
  // STAFF PROFILE VIEW - when a staff is logged in via PIN
  if(activeStaff){
    var p=activeStaff.permissions||{};
    var allowed=[];
    if(p.take_orders===true)allowed.push("Take Orders");
    if(p.view_reports===true)allowed.push("View Reports");
    if(p.view_finance===true)allowed.push("View Finance");
    if(p.manage_menu===true)allowed.push("Manage Menu");
    if(p.manage_staff===true)allowed.push("Manage Staff");
    if(p.manage_settings===true)allowed.push("Manage Settings");
    if(p.process_refunds===true)allowed.push("Process Refunds");
    var posColor={manager:"#7c3aed",waiter:"#0891b2",chef:"#d97706",driver:"#059669",kitchen:"#dc2626"}[activeStaff.position]||"#1a1208";
    
    return <div className="page" style={{maxWidth:600}}>
      <div style={{background:"linear-gradient(135deg,"+posColor+",#1a1208)",borderRadius:16,padding:"22px 20px",marginBottom:14,display:"flex",gap:14,alignItems:"center"}}>
        <div style={{width:60,height:60,borderRadius:"50%",background:"rgba(255,255,255,.2)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:24,fontWeight:700,color:"#fff"}}>{(activeStaff.full_name||"S").charAt(0).toUpperCase()}</div>
        <div style={{flex:1}}>
          <h2 style={{fontSize:20,color:"#fff",marginBottom:2}}>{activeStaff.full_name}</h2>
          <p style={{color:"rgba(255,255,255,.7)",fontSize:13,textTransform:"capitalize"}}>{activeStaff.position||"Staff"}</p>
        </div>
      </div>
      
      <div className="card" style={{marginBottom:12}}>
        <p style={{fontSize:13,fontWeight:700,marginBottom:9}}>{String.fromCharCode(0xD83D,0xDD11)} My Access</p>
        {allowed.length===0?
          <p style={{fontSize:12,color:"#8a8078"}}>No special access assigned. Contact your manager.</p>
          :
          <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
            {allowed.map(a=><span key={a} style={{padding:"5px 11px",background:"#ecfdf5",color:"#065f46",borderRadius:7,fontSize:11,fontWeight:700,border:"1px solid #a7f3d0"}}>{String.fromCharCode(0x2705)} {a}</span>)}
          </div>
        }
      </div>
      
      <div className="card">
        <p style={{fontSize:13,fontWeight:700,marginBottom:9}}>{String.fromCharCode(0x2139,0xFE0F)} Staff Info</p>
        <div style={{display:"grid",gap:7,fontSize:12}}>
          {activeStaff.employee_id&&<div style={{display:"flex",justifyContent:"space-between"}}><span style={{color:"#8a8078"}}>Employee ID</span><span style={{fontWeight:700}}>{activeStaff.employee_id}</span></div>}
          <div style={{display:"flex",justifyContent:"space-between"}}><span style={{color:"#8a8078"}}>Role</span><span style={{fontWeight:700,textTransform:"capitalize"}}>{activeStaff.position||"Staff"}</span></div>
        </div>
        <p style={{fontSize:11,color:"#8a8078",marginTop:11,paddingTop:9,borderTop:"1px solid #ede8de"}}>{String.fromCharCode(0xD83D,0xDCA1)} To switch user or sign out, use the buttons in the colored bar at the top of the screen.</p>
      </div>
    </div>;
  }

  if(!user) return <div className="page" style={{maxWidth:360,textAlign:"center",paddingTop:50}}>
    <p style={{fontSize:48,marginBottom:10}}>{EM.person}</p>
    <h2 style={{fontSize:24,marginBottom:6}}>Your Account</h2>
    <p style={{color:"#8a8078",marginBottom:18,fontSize:13}}>Sign in to view orders and loyalty points.</p>
    <button className="btn btn-r" onClick={onAuth} style={{padding:"11px 28px"}}>Sign In</button>
  </div>;
  var mine=orders.filter(o=>o.userId===user.id),spent=mine.filter(o=>o.paid).reduce((s,o)=>s+o.total,0);
  // Use DB loyalty points if available, otherwise calculate
  var pts=loyaltyData.points>0?loyaltyData.points:Math.floor(spent*10);
  var tier=getTier(pts),next=TIERS.find(t=>t.min>pts),prog=next?Math.round(((pts-tier.min)/(next.min-tier.min))*100):100;
  return <div className="page" style={{maxWidth:600}}>
    <div style={{background:"linear-gradient(135deg,#1a1208,#3d2e22)",borderRadius:16,padding:"18px 20px",marginBottom:14,display:"flex",gap:12,alignItems:"center"}}>
      <div className="av" style={{width:50,height:50,fontSize:18}}>{user.avatar}</div>
      <div style={{flex:1}}><h2 style={{fontSize:18,color:"#fff",marginBottom:1}}>{user.name}</h2><p style={{color:"rgba(255,255,255,.5)",fontSize:12}}>{user.email}</p></div>
      <div style={{textAlign:"center"}}><span className="bdg" style={{background:tier.bg,color:tier.color,fontSize:12}}>{tier.name}</span><p style={{color:"#d4952a",fontSize:17,fontWeight:700,marginTop:3}}>{pts.toLocaleString()} pts</p></div>
    </div>
    <div className="card" style={{marginBottom:12}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}><p style={{fontWeight:700,fontSize:14}}>Loyalty Points</p><span className="bdg" style={{background:tier.bg,color:tier.color}}>{tier.name}</span></div>
      {next&&<><div className="lbar" style={{marginBottom:5}}><div className="lfill" style={{width:prog+"%",background:tier.color}}/></div><div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:"#8a8078"}}><span>{pts} pts</span><span>{next.min-pts} pts to {next.name}</span></div></>}
      <p style={{fontSize:11,color:"#8a8078",marginTop:8}}>Earn 10 points per {EM.pound}1 spent. Redeem 100 points for {EM.pound}1 off any order.</p>
    </div>
    <div className="g3" style={{marginBottom:12}}>{[["Orders",mine.length,"#bf4626"],["Spent",fmt(spent),"#059669"],["Points",pts.toLocaleString(),"#d4952a"]].map(([l,v,c])=><div key={l} style={{background:"#fff",borderRadius:12,padding:"12px 8px",textAlign:"center",border:"1px solid #ede8de"}}><div style={{fontWeight:700,fontSize:17,color:c}}>{v}</div><div style={{fontSize:10,color:"#8a8078",fontWeight:600,textTransform:"uppercase"}}>{l}</div></div>)}</div>
    <div style={{display:"flex",gap:5,marginBottom:12,overflowX:"auto",paddingBottom:2}}>{[["orders","Orders"],["reviews","Reviews"],["book","Bookings"],["dietary","Dietary"],["loyalty","Loyalty"]].map(([k,l])=><button key={k} onClick={()=>setTab(k)} style={{padding:"6px 14px",borderRadius:8,fontWeight:600,fontSize:12,border:"2px solid",borderColor:tab===k?"#1a1208":"#ede8de",background:tab===k?"#1a1208":"#fff",color:tab===k?"#fff":"#1a1208",cursor:"pointer",flexShrink:0,whiteSpace:"nowrap"}}>{l}</button>)}</div>
    {tab==="orders"&&<>{mine.length===0&&<div className="card" style={{textAlign:"center",padding:24,color:"#8a8078"}}>No orders yet!</div>}{mine.map(o=><div key={o.id} className="card fadeup" style={{marginBottom:9}}><div style={{display:"flex",justifyContent:"space-between",marginBottom:5}}><div><p style={{fontWeight:700,fontSize:13}}>{o.id}</p><p style={{color:"#8a8078",fontSize:11}}>{o.time} - {o.type}</p></div><div style={{textAlign:"right"}}><p style={{fontWeight:700,color:"#bf4626"}}>{fmt(o.total)}</p><span className="bdg" style={{background:SB[o.status],color:SC[o.status],marginTop:2}}>{SL[o.status]}</span></div></div><p style={{fontSize:11,color:"#8a8078"}}>{o.items.map(i=>i.name+" x"+i.qty).join(", ")}</p></div>)}</>}
    {tab==="reviews"&&<>{reviews.filter(r=>r.userId===user.id).length===0&&<div className="card" style={{textAlign:"center",padding:24,color:"#8a8078"}}>No reviews yet</div>}{reviews.filter(r=>r.userId===user.id).map(r=><div key={r.id} className="card fadeup" style={{marginBottom:9}}><p style={{fontSize:13}}>{r.comment}</p><p style={{fontSize:11,color:"#8a8078",marginTop:3}}>{r.date}</p></div>)}</>}
    {tab==="book"&&<>{reservations.filter(r=>r.userId===user.id).length===0&&<div className="card" style={{textAlign:"center",padding:24,color:"#8a8078"}}>No reservations yet</div>}{reservations.filter(r=>r.userId===user.id).map(r=><div key={r.id} className="card fadeup" style={{marginBottom:9,borderLeft:"4px solid #059669"}}><p style={{fontWeight:700,fontSize:13,marginBottom:1}}>{(branches.find(b=>b.id===r.branchId)||{}).name}</p><p style={{color:"#8a8078",fontSize:12}}>{r.date} at {r.time} - {r.guests} guests</p></div>)}</>}
    {tab==="dietary"&&<div className="card" style={{padding:14}}>
      <p style={{fontWeight:700,fontSize:14,marginBottom:5}}>Dietary Preferences & Allergies</p>
      <p style={{fontSize:11,color:"#8a8078",marginBottom:12}}>Tap your dietary needs. Menu items containing your allergens will show warnings.</p>
      <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
        {[["al-gluten","Gluten Free","#dc2626"],["al-dairy","Dairy Free","#2563eb"],["al-nuts","Nut Free","#d97706"],["al-shellfish","Shellfish Free","#7c3aed"],["al-veggie","Vegetarian","#059669"],["al-vegan","Vegan","#10b981"]].map(([id,label,color])=><button key={id} onClick={()=>toggleDiet(id)} style={{padding:"9px 14px",borderRadius:9,fontWeight:700,fontSize:12,background:diet.includes(id)?color:"#fff",color:diet.includes(id)?"#fff":color,border:"2px solid "+color,cursor:"pointer"}}>{diet.includes(id)?EM.check+" ":""}{label}</button>)}
      </div>
      {diet.length>0&&<p style={{fontSize:11,color:"#059669",marginTop:11,fontWeight:700}}>{EM.check} Saved - menu will respect your preferences</p>}
    </div>}
    {tab==="loyalty"&&<div>
      <div className="card" style={{padding:14,marginBottom:9,background:"linear-gradient(135deg,"+tier.color+",#d4952a)",color:"#fff"}}>
        <p style={{fontSize:11,opacity:.85,letterSpacing:2,fontWeight:700,marginBottom:4}}>{tier.name.toUpperCase()} TIER</p>
        <p style={{fontSize:32,fontWeight:700,marginBottom:3}}>{pts.toLocaleString()} points</p>
        <p style={{fontSize:11,opacity:.9}}>= {EM.pound}{(pts/100).toFixed(2)} potential discount</p>
      </div>
      <p style={{fontSize:13,fontWeight:700,marginBottom:6}}>Recent Activity</p>
      {loyaltyHistory.length===0?<div className="card" style={{textAlign:"center",padding:24,color:"#8a8078"}}>No loyalty activity yet</div>:loyaltyHistory.map(h=><div key={h.id} className="card" style={{padding:"10px 12px",marginBottom:5,display:"flex",justifyContent:"space-between",alignItems:"center"}}><div><p style={{fontSize:12,fontWeight:600}}>{h.description||(h.type==="earn"?"Order rewards":"Discount redeemed")}</p><p style={{fontSize:10,color:"#8a8078"}}>{new Date(h.created_at).toLocaleDateString("en-GB")}{h.order_id?" - "+h.order_id:""}</p></div><p style={{fontWeight:700,color:h.points>0?"#059669":"#dc2626",fontSize:14}}>{h.points>0?"+":""}{h.points}</p></div>)}
    </div>}
  </div>;
}

function ChatV({messages,setMessages,user,onAuth}){
  var [text,setText]=useState("");
  var [msgs,setMsgs]=useState([]);
  var [loading,setLoading]=useState(true);
  var [sending,setSending]=useState(false);
  var bottom=useRef(null);
  
  // Who is sending? Active staff (PIN) or owner
  var activeStaff=(typeof window!=="undefined")?dbGetActiveStaff():null;
  var senderName=activeStaff?.full_name||user?.name||"Staff";
  var senderRole=activeStaff?.position||user?.role||"staff";
  
  var loadMessages=async()=>{
    try{
      var data=await dbFetchTeamMsgs();
      setMsgs(data||[]);
      setLoading(false);
    }catch(e){console.error("Load messages:",e);setLoading(false);}
  };
  
  useEffect(()=>{
    loadMessages();
    var interval=setInterval(loadMessages,8000); // refresh every 8s
    return()=>clearInterval(interval);
  },[]);
  
  useEffect(()=>{bottom.current?.scrollIntoView({behavior:"smooth"});},[msgs]);
  
  var send=async()=>{
    if(!text.trim()||sending)return;
    setSending(true);
    var msgText=text.trim();
    setText("");
    var result=await dbSendTeamMsg(senderName,senderRole,msgText);
    setSending(false);
    if(result.error){
      if(window.showAlert)window.showAlert("Couldn't send","Message failed to send. Try again.","error");
      setText(msgText); // restore
      return;
    }
    loadMessages();
  };
  
  var roleColor={owner:"#bf4626",manager:"#7c3aed",kitchen:"#059669",chef:"#d97706",waiter:"#0891b2",driver:"#ea580c"};
  
  return <div style={{maxWidth:560,margin:"0 auto",height:"calc(100vh - 130px)",display:"flex",flexDirection:"column",padding:"0 14px"}}>
    <div style={{padding:"12px 0 8px",borderBottom:"1px solid #ede8de",display:"flex",alignItems:"center",gap:7}}>
      <h2 style={{fontSize:20}}>{String.fromCharCode(0xD83D,0xDCAC)} Team Chat</h2>
      <span style={{width:7,height:7,borderRadius:"50%",background:"#10b981",display:"inline-block"}}/>
      <span style={{color:"#8a8078",fontSize:12}}>Staff only</span>
    </div>
    
    <div style={{flex:1,overflowY:"auto",padding:"12px 0",display:"flex",flexDirection:"column",gap:8}}>
      {loading?
        <p style={{textAlign:"center",color:"#8a8078",fontSize:12,padding:20}}>Loading messages...</p>
        :msgs.length===0?
        <div style={{textAlign:"center",padding:30}}>
          <div style={{fontSize:40,marginBottom:8}}>{String.fromCharCode(0xD83D,0xDCAC)}</div>
          <p style={{fontSize:13,fontWeight:700,marginBottom:3}}>No messages yet</p>
          <p style={{fontSize:11,color:"#8a8078"}}>Send the first message to your team!</p>
        </div>
        :msgs.map(m=>{
          var isMe=m.sender_name===senderName;
          var rc=roleColor[m.sender_role]||"#6b7280";
          return <div key={m.id} style={{display:"flex",flexDirection:"column",alignItems:isMe?"flex-end":"flex-start",gap:2}}>
            {!isMe&&<span style={{fontSize:11,fontWeight:700,color:rc,paddingLeft:10}}>{m.sender_name} <span style={{opacity:.6,textTransform:"capitalize",fontWeight:400}}>{String.fromCharCode(0x2022)} {m.sender_role}</span></span>}
            <div style={{padding:"9px 13px",maxWidth:"78%",fontSize:14,lineHeight:1.4,borderRadius:isMe?"14px 14px 4px 14px":"14px 14px 14px 4px",background:isMe?"#bf4626":"#fff",color:isMe?"#fff":"#1a1208",border:isMe?"none":"1px solid #ede8de"}}>{m.message}</div>
            <span style={{fontSize:10,color:"#bbb",paddingLeft:isMe?0:10,paddingRight:isMe?10:0}}>{m.created_at?new Date(m.created_at).toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"}):""}</span>
          </div>;
        })}
      <div ref={bottom}/>
    </div>
    
    <div style={{padding:"9px 0",borderTop:"1px solid #ede8de",display:"flex",gap:7}}>
      <input className="field" value={text} onChange={e=>setText(e.target.value)} onKeyDown={e=>e.key==="Enter"&&!e.shiftKey&&send()} placeholder="Message your team..." style={{flex:1,borderRadius:50,padding:"9px 15px"}}/>
      <button className="btn btn-r" onClick={send} disabled={sending} style={{borderRadius:50,padding:"9px 16px",flexShrink:0}}>{sending?"...":"Send"}</button>
    </div>
  </div>;
}

function KitchenV({orders,setOrders,push,stations,menu}){
  // Persisted in localStorage: chef's selected station view
  var [view,setView]=useState(()=>{try{return localStorage.getItem("kitchen_view")||"";}catch(e){return "";}});
  var changeView=v=>{setView(v);try{localStorage.setItem("kitchen_view",v);}catch(e){}};

  var activeStations=(stations||[]).filter(s=>s.active!==false);
  // Kitchen only shows ACCEPTED orders (preparing). Pending orders are awaiting staff acceptance in Incoming.
  // EXCEPTION: Show pending orders that are NOT from "online" or "qr-table" sources (those need staff acceptance via Incoming)
  // Staff/phone orders go straight to preparing, but if any pending staff orders exist, they should still show
  var allOrders=orders.filter(o=>{
    if(o.status==="preparing")return true;
    if(o.status==="pending"&&o.source!=="online"&&o.source!=="qr-table")return true;
    return false;
  });

  // Helper: find station for menu item
  var stationForItem=(itemId,itemName)=>{
    var m=menu.find(x=>String(x.id)===String(itemId)||x.name===itemName);
    return m?.station||null;
  };

  // Filter items per view
  var getOrderItems=(o,filterStation)=>{
    if(!filterStation||filterStation==="all"||filterStation==="manager")return o.items;
    return (o.items||[]).filter(it=>stationForItem(it.id,it.name)===filterStation);
  };

  // Mark a station's items ready for an order
  var markStationReady=(orderId,stationName)=>{
    var order=orders.find(o=>o.id===orderId);
    if(!order)return;
    var progress={...(order.stationProgress||{})};
    progress[stationName]=true;
    setOrders(os=>os.map(o=>o.id===orderId?{...o,stationProgress:progress}:o));
    dbUpdateStationProgress(orderId,stationName,true).catch(e=>console.log("Station progress save:",e));
    // Check if ALL stations needed by this order are now ready
    var stationsInOrder=new Set();
    (order.items||[]).forEach(it=>{var st=stationForItem(it.id,it.name);if(st)stationsInOrder.add(st);});
    var allReady=[...stationsInOrder].every(st=>progress[st]);
    if(allReady&&stationsInOrder.size>0){
      setOrders(os=>os.map(o=>o.id===orderId?{...o,status:"ready"}:o));
      dbUpdateOrderStatus(orderId,"ready").catch(e=>{});
      push({title:"Order Ready!",body:orderId+" - all stations done",color:"#059669"});
    }else{
      push({title:stationName+" done",body:orderId,color:"#2563eb"});
    }
  };

  var startAll=id=>{
    setOrders(os=>os.map(o=>o.id===id?{...o,status:"preparing"}:o));
    dbUpdateOrderStatus(id,"preparing").catch(e=>{});
    push({title:id,body:"-> preparing",color:"#2563eb"});
  };
  var cancel=id=>{
    setOrders(os=>os.map(x=>x.id===id?{...x,status:"cancelled"}:x));
    dbUpdateOrderStatus(id,"cancelled").catch(e=>{});
  };

  // STATION PICKER (first time)
  if(!view&&activeStations.length>0){
    return <div className="kbg" style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{maxWidth:600,width:"100%"}}>
        <h1 style={{color:"#fff",fontSize:28,marginBottom:6,textAlign:"center"}}>Kitchen Display</h1>
        <p style={{color:"#888",fontSize:14,marginBottom:24,textAlign:"center"}}>Choose your station</p>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))",gap:10,marginBottom:14}}>
          {activeStations.map(s=><button key={s.dbId} onClick={()=>changeView(s.name)} style={{padding:"24px 14px",background:s.color,color:"#fff",border:"none",borderRadius:14,cursor:"pointer",fontWeight:700,fontSize:16,boxShadow:"0 4px 14px rgba(0,0,0,.3)"}}>{s.name}</button>)}
        </div>
        <button onClick={()=>changeView("manager")} style={{width:"100%",padding:"16px",background:"#1a1208",color:"#d4952a",border:"2px solid #d4952a",borderRadius:12,cursor:"pointer",fontWeight:700,fontSize:14}}>Manager View - See All Stations</button>
        <button onClick={()=>changeView("all")} style={{width:"100%",padding:"12px",background:"transparent",color:"#888",border:"none",cursor:"pointer",fontWeight:600,fontSize:12,marginTop:6}}>Or show everything (legacy mode)</button>
      </div>
    </div>;
  }

  // MANAGER MODE - shows all stations grouped per order
  if(view==="manager"){
    return <div className="kbg"><div style={{maxWidth:1200,margin:"0 auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:8}}>
        <div>
          <h2 style={{color:"#fff",fontSize:18}}>Manager Kitchen View</h2>
          <p style={{color:"#666",fontSize:11}}>{allOrders.length} active orders - all stations</p>
        </div>
        <button onClick={()=>changeView("")} style={{padding:"6px 12px",background:"transparent",color:"#888",border:"1px solid #444",borderRadius:6,cursor:"pointer",fontSize:11,fontWeight:700}}>Change Station</button>
      </div>
      {allOrders.length===0?<div style={{textAlign:"center",padding:"40px 0",color:"#444"}}><p style={{fontSize:32,marginBottom:7}}>OK</p><p>All caught up!</p></div>:<div className="ag">
        {allOrders.map(o=>{
          var prog=o.stationProgress||{};
          var stationsInOrder=new Set();
          (o.items||[]).forEach(it=>{var st=stationForItem(it.id,it.name);if(st)stationsInOrder.add(st);else stationsInOrder.add("Unassigned");});
          return <div key={o.id} style={{background:"#0f0a06",border:"2px solid #d97706",borderRadius:12,padding:14}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:10}}>
              <div><p style={{color:"#fff",fontWeight:700,fontSize:15}}>{o.id}</p><p style={{color:"#888",fontSize:11}}>{o.customer} - {o.time}</p></div>
              <span className="bdg" style={{background:SB[o.status],color:SC[o.status]}}>{SL[o.status]}</span>
            </div>
            {[...stationsInOrder].map(stName=>{
              var stItems=(o.items||[]).filter(it=>(stationForItem(it.id,it.name)||"Unassigned")===stName);
              var stObj=activeStations.find(s=>s.name===stName);
              var ready=prog[stName];
              return <div key={stName} style={{borderLeft:"3px solid "+(stObj?.color||"#666"),paddingLeft:9,marginBottom:8}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:3}}>
                  <p style={{color:stObj?.color||"#888",fontSize:11,fontWeight:700,letterSpacing:1}}>{stName.toUpperCase()}</p>
                  <span style={{fontSize:10,color:ready?"#10b981":"#666",fontWeight:700}}>{ready?"READY":"WAITING"}</span>
                </div>
                {stItems.map((it,i)=><div key={i} style={{display:"flex",justifyContent:"space-between",fontSize:13,color:"#fff",padding:"2px 0"}}><span>{it.name}</span><span style={{color:"#f59e0b",fontWeight:700}}>x{it.qty}</span></div>)}
              </div>;
            })}
            <div style={{display:"flex",gap:5,marginTop:9}}>
              {o.status==="pending"&&<button onClick={()=>startAll(o.id)} style={{flex:1,padding:"7px",borderRadius:7,fontSize:11,fontWeight:700,background:"#2563eb",color:"#fff",border:"none",cursor:"pointer"}}>Start All</button>}
              <button onClick={()=>cancel(o.id)} style={{padding:"7px 12px",borderRadius:7,border:"1px solid #dc2626",color:"#dc2626",background:"transparent",fontWeight:700,fontSize:11,cursor:"pointer"}}>Cancel</button>
            </div>
          </div>;
        })}
      </div>}
    </div></div>;
  }

  // STATION OR ALL VIEW
  var stationFilter=view==="all"?null:view;
  var relevantOrders=allOrders.filter(o=>{
    if(!stationFilter)return true;
    return (o.items||[]).some(it=>stationForItem(it.id,it.name)===stationFilter);
  });
  var stationObj=activeStations.find(s=>s.name===view);

  return <div className="kbg"><div style={{maxWidth:940,margin:"0 auto"}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:8}}>
      <div style={{display:"flex",alignItems:"center",gap:10}}>
        {stationObj&&<div style={{width:10,height:30,background:stationObj.color,borderRadius:3}}/>}
        <div>
          <h2 style={{color:"#fff",fontSize:18}}>{view==="all"?"All Items":(stationObj?.name||view)+" Station"}</h2>
          <p style={{color:"#666",fontSize:11}}>{relevantOrders.length} orders need attention</p>
        </div>
      </div>
      <button onClick={()=>changeView("")} style={{padding:"6px 12px",background:"transparent",color:"#888",border:"1px solid #444",borderRadius:6,cursor:"pointer",fontSize:11,fontWeight:700}}>Change Station</button>
    </div>
    {relevantOrders.length===0&&<div style={{textAlign:"center",padding:"40px 0",color:"#444"}}><p style={{fontSize:32,marginBottom:7}}>OK</p><p style={{fontSize:14}}>No items for {view==="all"?"any station":view} right now</p></div>}
    <div className="ag">{relevantOrders.map(o=>{
      var myItems=getOrderItems(o,stationFilter);
      if(myItems.length===0&&stationFilter)return null;
      var alreadyReady=stationFilter&&(o.stationProgress||{})[stationFilter];
      return <div key={o.id} style={{background:o.status==="pending"?"#1a0a06":"#06101a",border:"2px solid "+(alreadyReady?"#10b981":(o.status==="pending"?"#d97706":"#2563eb")),borderRadius:12,padding:13,opacity:alreadyReady?.5:1}}>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
          <div><p style={{color:"#fff",fontWeight:700,fontSize:14}}>{o.id}</p><p style={{color:"#666",fontSize:10}}>{o.customer} - {o.time}{o.slot?" | "+o.slot:""}{o.tableId?" | Table "+o.tableId:""}</p></div>
          <span className="bdg" style={{background:SB[o.status],color:SC[o.status]}}>{alreadyReady?"DONE":SL[o.status]}</span>
        </div>
        {myItems.map((it,i)=><div key={i} style={{display:"flex",justifyContent:"space-between",padding:"4px 0",borderBottom:"1px solid rgba(255,255,255,.07)",fontSize:13}}><span style={{color:"#fff",fontWeight:600}}>{it.name}</span><span style={{color:"#f59e0b",fontWeight:700,fontSize:15}}>x{it.qty}</span></div>)}
        <div style={{display:"flex",gap:5,marginTop:10}}>
          {!alreadyReady&&stationFilter&&stationFilter!=="all"&&<button onClick={()=>markStationReady(o.id,stationFilter)} style={{flex:1,padding:"8px",borderRadius:7,fontSize:12,fontWeight:700,background:"#059669",color:"#fff",border:"none",cursor:"pointer"}}>{EM.check} {stationFilter} Ready</button>}
          {(!stationFilter||view==="all")&&<button onClick={()=>{
            var order=orders.find(x=>x.id===o.id);
            var next=order.status==="pending"?"preparing":"ready";
            setOrders(os=>os.map(x=>x.id===o.id?{...x,status:next}:x));
            dbUpdateOrderStatus(o.id,next).catch(e=>{});
          }} style={{flex:1,padding:"7px",borderRadius:7,fontSize:11,fontWeight:700,background:o.status==="pending"?"#2563eb":"#059669",color:"#fff",border:"none",cursor:"pointer"}}>{o.status==="pending"?"Start":"Mark Ready"}</button>}
          <button onClick={()=>cancel(o.id)} style={{padding:"7px 9px",borderRadius:7,border:"1px solid #dc2626",color:"#dc2626",background:"transparent",fontWeight:700,fontSize:11,cursor:"pointer"}}>X</button>
        </div>
      </div>;
    })}</div>
  </div></div>;
}

// -- CATEGORIES ----------------------------------------------------------------
// eslint-disable-next-line no-unused-vars
var CATEGORIES0=[
  {id:"cat1",name:"Starters",icon:"soup",order:1},
  {id:"cat2",name:"Mains",icon:"pizza",order:2},
  {id:"cat3",name:"Sides",icon:"fries",order:3},
  {id:"cat4",name:"Desserts",icon:"choc",order:4},
  {id:"cat5",name:"Drinks",icon:"drink",order:5},
];

// -- SET MEALS / COMBOS --------------------------------------------------------
// eslint-disable-next-line no-unused-vars
var SETMEALS0=[
  {id:"sm1",name:"Burger Combo",desc:"Any burger + fries + soft drink",price:19.99,itemIds:[5,8,12],avail:true,icon:"burger"},
  {id:"sm2",name:"Pizza Night",desc:"Pizza + salad + drink",price:18.99,itemIds:[4,9,12],avail:true,icon:"pizza"},
  {id:"sm3",name:"Italian Feast",desc:"Pasta + bruschetta + tiramisu",price:22.99,itemIds:[7,2,10],avail:true,icon:"pasta"},
];

// -- MODIFIERS (size/extras/allergens) -----------------------------------------
var MODIFIERS0={
  size:[
    {id:"sz-reg",name:"Regular",priceAdj:0},
    {id:"sz-lg",name:"Large",priceAdj:3.00},
  ],
  cooking:[
    {id:"ck-rare",name:"Rare",priceAdj:0},
    {id:"ck-med",name:"Medium",priceAdj:0},
    {id:"ck-well",name:"Well Done",priceAdj:0},
  ],
  extras:[
    {id:"ex-cheese",name:"Extra Cheese",priceAdj:1.50},
    {id:"ex-bacon",name:"Add Bacon",priceAdj:2.00},
    {id:"ex-egg",name:"Add Egg",priceAdj:1.00},
    {id:"ex-mushroom",name:"Mushrooms",priceAdj:1.00},
  ],
  allergens:[
    {id:"al-gluten",name:"Contains Gluten"},
    {id:"al-dairy",name:"Contains Dairy"},
    {id:"al-nuts",name:"Contains Nuts"},
    {id:"al-shellfish",name:"Contains Shellfish"},
    {id:"al-veggie",name:"Vegetarian"},
    {id:"al-vegan",name:"Vegan"},
    {id:"al-gf",name:"Gluten Free"},
  ],
};

// Icon picker - organized by category for easy browsing
var ICON_KEYS=[
  // Indian / South Asian
  "curry","rice","naan","samosa","kebab","chicken","tea","thali","bowl","pot",
  // Meat & Protein
  "chickenleg","meat","steak","fish","egg","cheese","bacon","squid","shawarma","falafel",
  // Mains
  "pizza","burger","pasta","noodles","ramen","sushi","dumpling","salad","bento",
  // Sides & Veg
  "fries","bread","bagel","croissant","corn","carrot","potato","broccoli","onion","garlic",
  // Desserts & Sweets
  "cake","cupcake","donut","cookie","icecream","choc","sweet","pudding","honey","lolly",
  // Drinks
  "coffee","drink","water","milk","juice","bubbletea","beer","wine","cocktail","tropical","champagne",
  // Fruits
  "apple","banana","mango","coconut","lemon","orange","grape","watermelon","strawberry","pineapple","tomato",
  // Labels / Indicators
  "fire","spicy","leaf","veg","star","party","cook","chili",
  // Utility
  "cart","pin","cal","person","chat","gear","chart","bag","wave","phone","clock","check","cross"
];

// -- MENU ITEM EDITOR MODAL ----------------------------------------------------
function MenuEditor({item,onSave,onClose,onDelete,modifiers,categories,stations}){
  var isNew=!item||!item.id;
  // Use first available category as default, fallback to "Starters"
  var defaultCat=(categories&&categories.length>0)?categories[0].name:"Starters";
  var [f,setF]=useState({
    id:item?.id||Date.now(),
    dbId:item?.dbId, // CRITICAL: preserve database ID when editing
    name:item?.name||"",
    price:item?.price||0,
    desc:item?.desc||"",
    cat:item?.cat||defaultCat,
    icon:item?.icon||"cart",
    avail:item?.avail!==false,
    stock:item?.stock??20,
    station:item?.station||"",
    priceDineIn:item?.priceDineIn||"",
    priceTakeaway:item?.priceTakeaway||"",
    priceDelivery:item?.priceDelivery||"",
    availDineIn:item?.availDineIn!==false,
    availTakeaway:item?.availTakeaway!==false,
    availDelivery:item?.availDelivery!==false,
    allergens:item?.allergens||[],
    sizes:item?.sizes||[],
    extras:item?.extras||[],
    cookingOpts:item?.cookingOpts||[],
    image_url:item?.image_url||"",
  });
  var [confirmDel,setConfirmDel]=useState(false);
  var [uploading,setUploading]=useState(false);
  var [imageMode,setImageMode]=useState(item?.image_url?"current":"none"); // "current","upload","url","none"
  var [urlInput,setUrlInput]=useState("");
  
  // Validate cat - if user's saved cat doesn't exist in categories list, default to first available
  useEffect(()=>{
    if(categories&&categories.length>0){
      var valid=categories.some(c=>c.name===f.cat);
      if(!valid){
        // Current cat is not in available categories, switch to first available
        setF(prev=>({...prev,cat:categories[0].name}));
      }
    }
  },[categories]); // eslint-disable-line react-hooks/exhaustive-deps
  
  var update=(k,v)=>setF(x=>({...x,[k]:v}));
  
  var handleFileUpload=async(e)=>{
    var file=e.target.files?.[0];
    if(!file)return;
    setUploading(true);
    var rid=window.__currentRestaurant?.id||"shared";
    var result=await dbUploadMenuImage(file,rid);
    setUploading(false);
    if(result.error){
      alert("Upload failed: "+(result.error.message||"Unknown error"));
      return;
    }
    update("image_url",result.url);
    setImageMode("current");
  };
  
  var handleUrlSubmit=()=>{
    var url=urlInput.trim();
    if(!url){alert("Please paste a URL");return;}
    if(!url.startsWith("http")){alert("URL must start with http:// or https://");return;}
    
    // Common URL conversions
    // Unsplash: https://unsplash.com/photos/xyz → suggest direct URL
    if(url.includes("unsplash.com/photos/")){
      alert("This is the Unsplash webpage URL, not the image URL.\n\nTo get the image URL:\n1. Click 'Download' on the photo\n2. Right-click the downloaded image\n3. Open it in a new tab\n4. Copy THAT URL (will start with 'images.unsplash.com')\n\nOr use Pexels.com / Pixabay.com instead - just right-click any image and 'Copy Image Address'.");
      return;
    }
    
    // Validate it looks like an image URL
    var imageExtensions=[".jpg",".jpeg",".png",".webp",".gif"];
    var hasImageExt=imageExtensions.some(ext=>url.toLowerCase().includes(ext));
    var isImageHost=url.includes("images.unsplash.com")||url.includes("imgur.com")||url.includes("googleusercontent.com")||url.includes("pexels.com/photos/")||url.includes("pixabay.com")||url.includes("supabase.co/storage");
    
    if(!hasImageExt && !isImageHost){
      var proceed=window.confirm("This URL doesn't look like a direct image link.\n\nIt should end with .jpg, .png, .webp, or .gif\n\nDo you want to try it anyway?");
      if(!proceed)return;
    }
    
    update("image_url",url);
    setImageMode("current");
    setUrlInput("");
  };
  
  var removeImage=()=>{
    update("image_url","");
    setImageMode("none");
  };
  
  var save=()=>{
    if(!f.name.trim()){alert("Name is required");return;}
    if(!f.price||f.price<=0){alert("Valid price is required");return;}
    onSave({...f,price:+f.price,stock:+f.stock});
    onClose();
  };

  return <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:8000,display:"flex",alignItems:"flex-start",justifyContent:"center",padding:16,overflowY:"auto"}}>
    <div onClick={e=>e.stopPropagation()} className="card" style={{width:"100%",maxWidth:500,padding:22,marginTop:20,marginBottom:40}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <h2 style={{fontSize:22}}>{isNew?"Add Menu Item":"Edit Item"}</h2>
        <button onClick={onClose} style={{color:"#999",fontSize:22,border:"none",background:"none",cursor:"pointer"}}>x</button>
      </div>

      {/* IMAGE UPLOAD/URL */}
      <div style={{marginBottom:14,padding:14,background:"linear-gradient(135deg,#fffbeb,#fef3c7)",border:"2px solid #fde68a",borderRadius:9}}>
        <label className="lbl" style={{marginBottom:7,display:"block"}}>{String.fromCharCode(0xD83D,0xDCF7)} Food Photo (Optional)</label>
        
        {/* Current image preview */}
        {f.image_url && imageMode==="current" && <div style={{marginBottom:9}}>
          <div style={{position:"relative",display:"inline-block",borderRadius:9,overflow:"hidden",border:"2px solid #ede8de"}}>
            <img src={f.image_url} alt="Menu" style={{width:200,height:150,objectFit:"cover",display:"block"}} onError={e=>{e.target.style.display="none";alert("Image failed to load. URL might be invalid.");}}/>
            <button onClick={removeImage} style={{position:"absolute",top:5,right:5,width:28,height:28,borderRadius:"50%",background:"rgba(220,38,38,.9)",color:"#fff",border:"none",cursor:"pointer",fontWeight:700,fontSize:14}}>{String.fromCharCode(0x00D7)}</button>
          </div>
        </div>}
        
        {/* Mode selector */}
        {(!f.image_url||imageMode!=="current") && <>
          <div style={{display:"flex",gap:5,marginBottom:9}}>
            <button onClick={()=>setImageMode("upload")} style={{flex:1,padding:"8px 10px",background:imageMode==="upload"?"#bf4626":"#fff",color:imageMode==="upload"?"#fff":"#1a1208",border:"2px solid "+(imageMode==="upload"?"#bf4626":"#ede8de"),borderRadius:7,cursor:"pointer",fontWeight:700,fontSize:11}}>{String.fromCharCode(0xD83D,0xDCC1)} Upload File</button>
            <button onClick={()=>setImageMode("url")} style={{flex:1,padding:"8px 10px",background:imageMode==="url"?"#bf4626":"#fff",color:imageMode==="url"?"#fff":"#1a1208",border:"2px solid "+(imageMode==="url"?"#bf4626":"#ede8de"),borderRadius:7,cursor:"pointer",fontWeight:700,fontSize:11}}>{String.fromCharCode(0xD83C,0xDF10)} Paste URL</button>
            <button onClick={()=>setImageMode("none")} style={{flex:1,padding:"8px 10px",background:imageMode==="none"?"#1a1208":"#fff",color:imageMode==="none"?"#fff":"#1a1208",border:"2px solid "+(imageMode==="none"?"#1a1208":"#ede8de"),borderRadius:7,cursor:"pointer",fontWeight:700,fontSize:11}}>{String.fromCharCode(0xD83D,0xDE00)} Use Icon</button>
          </div>
          
          {imageMode==="upload" && <div style={{padding:14,background:"#fff",borderRadius:7,border:"2px dashed #fde68a",textAlign:"center"}}>
            <input type="file" accept="image/*" onChange={handleFileUpload} disabled={uploading} style={{display:"none"}} id="menu-img-upload"/>
            <label htmlFor="menu-img-upload" style={{cursor:uploading?"wait":"pointer",display:"block"}}>
              <p style={{fontSize:36,marginBottom:5}}>{uploading?String.fromCharCode(0x23F3):String.fromCharCode(0xD83D,0xDCF7)}</p>
              <p style={{fontSize:13,fontWeight:700,marginBottom:3}}>{uploading?"Uploading...":"Click to choose photo"}</p>
              <p style={{fontSize:11,color:"#8a8078"}}>JPG, PNG, WebP - Max 5MB</p>
            </label>
          </div>}
          
          {imageMode==="url" && <div>
            <input value={urlInput} onChange={e=>setUrlInput(e.target.value)} placeholder="https://example.com/photo.jpg" style={{width:"100%",padding:"10px",border:"2px solid #ede8de",borderRadius:7,fontSize:12,marginBottom:7,boxSizing:"border-box"}}/>
            <button onClick={handleUrlSubmit} style={{width:"100%",padding:"10px",background:"#bf4626",color:"#fff",border:"none",borderRadius:7,fontWeight:700,fontSize:12,cursor:"pointer",marginBottom:9}}>Use This URL</button>
            <div style={{padding:9,background:"#fff",borderRadius:7,fontSize:11,color:"#92400e",border:"1px solid #fde68a"}}>
              <p style={{fontWeight:700,marginBottom:5}}>{String.fromCharCode(0xD83D,0xDCA1)} How to get a working image URL:</p>
              <p style={{marginBottom:5}}><strong>Easy way:</strong> Visit <strong>pexels.com</strong> or <strong>pixabay.com</strong></p>
              <p style={{marginBottom:5}}>1. Search for food photos</p>
              <p style={{marginBottom:5}}>2. <strong>Right-click</strong> any image</p>
              <p style={{marginBottom:5}}>3. Click <strong>"Copy Image Address"</strong></p>
              <p style={{marginBottom:9}}>4. Paste here</p>
              <p style={{marginBottom:5,paddingTop:5,borderTop:"1px solid #fde68a"}}><strong>{String.fromCharCode(0x26A0,0xFE0F)} Don't paste:</strong> Webpage URLs (like unsplash.com/photos/xxx)</p>
              <p><strong>{String.fromCharCode(0x2705)} Paste:</strong> Direct image URLs (ending in .jpg, .png, .webp)</p>
            </div>
          </div>}
          
          {imageMode==="none" && <p style={{fontSize:11,color:"#92400e",fontStyle:"italic"}}>{String.fromCharCode(0x2139,0xFE0F)} Customers will see the icon (chosen below) instead of a photo</p>}
        </>}
      </div>

      {/* Icon picker */}
      <div style={{marginBottom:14}}>
        <label className="lbl">Icon ({f.icon})</label>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(45px,1fr))",gap:4,maxHeight:200,overflowY:"auto",padding:8,background:"#f7f3ee",borderRadius:8,border:"1px solid #ede8de"}}>
          {ICON_KEYS.map(k=><button key={k} onClick={()=>update("icon",k)} title={k} style={{padding:8,borderRadius:7,fontSize:22,background:f.icon===k?"#bf4626":"#fff",border:"2px solid "+(f.icon===k?"#bf4626":"#ede8de"),cursor:"pointer",aspectRatio:"1/1"}}>{EM[k]||""}</button>)}
        </div>
      </div>

      <div className="g2" style={{marginBottom:12}}>
        <div><label className="lbl">Name *</label><input className="field" value={f.name} onChange={e=>update("name",e.target.value)} placeholder="Margherita Pizza"/></div>
        <div><label className="lbl">Price (GBP) *</label><input type="number" step="0.01" className="field" value={f.price} onChange={e=>update("price",e.target.value)} placeholder="9.99"/></div>
      </div>

      <div style={{marginBottom:12}}><label className="lbl">Description</label><textarea className="field" value={f.desc} onChange={e=>update("desc",e.target.value)} rows={2} style={{resize:"vertical"}} placeholder="San Marzano tomato, fior di latte, basil"/></div>

      <div className="g2" style={{marginBottom:12}}>
        <div><label className="lbl">Category</label>
          <select className="field" value={f.cat} onChange={e=>update("cat",e.target.value)}>
            {(categories&&categories.length>0?categories:[{name:"Starters"},{name:"Mains"},{name:"Sides"},{name:"Desserts"},{name:"Drinks"}]).map(c=><option key={c.id||c.name} value={c.name}>{c.name}</option>)}
          </select>
        </div>
        <div><label className="lbl">Stock</label><input type="number" className="field" value={f.stock} onChange={e=>update("stock",e.target.value)}/></div>
      </div>
      <div style={{marginBottom:12}}>
        <label className="lbl">Kitchen Station <span style={{color:"#8a8078",fontWeight:400}}>(which chef makes this?)</span></label>
        <select className="field" value={f.station||""} onChange={e=>update("station",e.target.value)}>
          <option value="">-- Not assigned --</option>
          {(stations||[]).filter(s=>s.active!==false).map(s=><option key={s.dbId} value={s.name}>{s.name}</option>)}
        </select>
      </div>

      <div style={{padding:"11px 13px",background:"#fafaf5",borderRadius:9,marginBottom:12,border:"1px solid #ede8de"}}>
        <p style={{fontWeight:700,fontSize:13,marginBottom:6}}>Per-Type Pricing</p>
        <p style={{fontSize:10,color:"#8a8078",marginBottom:9}}>Leave blank to use the base price ({EM.pound}{f.price||"0.00"}) for that order type</p>
        <div className="g3" style={{gap:6}}>
          <div>
            <label className="lbl" style={{fontSize:10}}>Dine-in {EM.pound}</label>
            <input type="number" step="0.01" className="field" value={f.priceDineIn} onChange={e=>update("priceDineIn",e.target.value)} placeholder={f.price||"0.00"}/>
          </div>
          <div>
            <label className="lbl" style={{fontSize:10}}>Takeaway {EM.pound}</label>
            <input type="number" step="0.01" className="field" value={f.priceTakeaway} onChange={e=>update("priceTakeaway",e.target.value)} placeholder={f.price||"0.00"}/>
          </div>
          <div>
            <label className="lbl" style={{fontSize:10}}>Delivery {EM.pound}</label>
            <input type="number" step="0.01" className="field" value={f.priceDelivery} onChange={e=>update("priceDelivery",e.target.value)} placeholder={f.price||"0.00"}/>
          </div>
        </div>
        <p style={{fontWeight:700,fontSize:13,marginTop:11,marginBottom:6}}>Available For</p>
        <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
          {[["availDineIn","Dine-in"],["availTakeaway","Takeaway / Collection"],["availDelivery","Delivery"]].map(([k,l])=><button key={k} onClick={()=>update(k,!f[k])} style={{padding:"7px 11px",fontSize:11,fontWeight:700,background:f[k]?"#059669":"#fee2e2",color:f[k]?"#fff":"#991b1b",border:"none",borderRadius:7,cursor:"pointer"}}>{f[k]?EM.check:EM.cross} {l}</button>)}
        </div>
      </div>

      {/* SIZES - Custom per item */}
      <div style={{marginBottom:14,padding:12,background:"#fef3c7",borderRadius:9,border:"1px solid #fde68a"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:7}}>
          <label className="lbl" style={{margin:0}}>{String.fromCharCode(0xD83D,0xDCCF)} Sizes & Pricing</label>
          <button type="button" onClick={()=>{
            var name=prompt("Size name (e.g. Small, Medium, Large):");
            if(!name||!name.trim())return;
            var priceAdj=prompt("Price adjustment (+/- £):","0");
            update("sizes",[...(f.sizes||[]),{id:"sz_"+Date.now(),name:name.trim(),priceAdj:parseFloat(priceAdj)||0}]);
          }} style={{padding:"5px 10px",fontSize:11,background:"#d97706",color:"#fff",border:"none",borderRadius:5,fontWeight:700,cursor:"pointer"}}>+ Add Size</button>
        </div>
        {(!f.sizes||f.sizes.length===0)?<p style={{fontSize:11,color:"#92400e",fontStyle:"italic"}}>No sizes added. Click "+ Add Size" to add (e.g. Small £0, Large +£3)</p>:
        <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
          {f.sizes.map((s,i)=>typeof s==="object"?
            <div key={s.id||i} style={{display:"flex",alignItems:"center",gap:5,padding:"5px 7px",background:"#fff",borderRadius:6,border:"1px solid #ede8de"}}>
              <span style={{fontSize:11,fontWeight:700}}>{s.name}</span>
              <span style={{fontSize:10,color:"#8a8078"}}>{s.priceAdj>0?"+"+fmt(s.priceAdj):s.priceAdj<0?fmt(s.priceAdj):"+£0"}</span>
              <button type="button" onClick={()=>update("sizes",f.sizes.filter((_,idx)=>idx!==i))} style={{background:"#dc2626",color:"#fff",border:"none",borderRadius:"50%",width:18,height:18,fontSize:11,cursor:"pointer",lineHeight:1}}>{String.fromCharCode(0x00D7)}</button>
            </div>
            :null
          )}
        </div>}
      </div>

      {/* COOKING PREFERENCES - Custom per item */}
      <div style={{marginBottom:14,padding:12,background:"#fed7aa",borderRadius:9,border:"1px solid #fdba74"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:7}}>
          <label className="lbl" style={{margin:0}}>{String.fromCharCode(0xD83D,0xDD25)} Cooking / Spice Preferences</label>
          <button type="button" onClick={()=>{
            var name=prompt("Preference name (e.g. Mild, Medium Spicy, Extra Hot):");
            if(!name||!name.trim())return;
            update("cookingOpts",[...(f.cookingOpts||[]),{id:"ck_"+Date.now(),name:name.trim()}]);
          }} style={{padding:"5px 10px",fontSize:11,background:"#c2410c",color:"#fff",border:"none",borderRadius:5,fontWeight:700,cursor:"pointer"}}>+ Add Option</button>
        </div>
        {(!f.cookingOpts||f.cookingOpts.length===0)?<p style={{fontSize:11,color:"#7c2d12",fontStyle:"italic"}}>No options. Add e.g. "Mild", "Medium", "Extra Spicy" for curry dishes</p>:
        <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
          {f.cookingOpts.map((c,i)=>typeof c==="object"?
            <div key={c.id||i} style={{display:"flex",alignItems:"center",gap:5,padding:"5px 7px",background:"#fff",borderRadius:6,border:"1px solid #ede8de"}}>
              <span style={{fontSize:11,fontWeight:700}}>{c.name}</span>
              <button type="button" onClick={()=>update("cookingOpts",f.cookingOpts.filter((_,idx)=>idx!==i))} style={{background:"#dc2626",color:"#fff",border:"none",borderRadius:"50%",width:18,height:18,fontSize:11,cursor:"pointer",lineHeight:1}}>{String.fromCharCode(0x00D7)}</button>
            </div>
            :null
          )}
        </div>}
      </div>

      {/* EXTRAS / ADD-ONS - Custom per item */}
      <div style={{marginBottom:14,padding:12,background:"#d1fae5",borderRadius:9,border:"1px solid #6ee7b7"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:7}}>
          <label className="lbl" style={{margin:0}}>{String.fromCharCode(0x2728)} Extras / Add-ons (with prices)</label>
          <button type="button" onClick={()=>{
            var name=prompt("Extra/Add-on name (e.g. Extra Cheese, Extra Sauce):");
            if(!name||!name.trim())return;
            var priceAdj=prompt("Extra price £:","1.00");
            update("extras",[...(f.extras||[]),{id:"ex_"+Date.now(),name:name.trim(),priceAdj:parseFloat(priceAdj)||0}]);
          }} style={{padding:"5px 10px",fontSize:11,background:"#059669",color:"#fff",border:"none",borderRadius:5,fontWeight:700,cursor:"pointer"}}>+ Add Extra</button>
        </div>
        {(!f.extras||f.extras.length===0)?<p style={{fontSize:11,color:"#065f46",fontStyle:"italic"}}>No extras. Add toppings/sides customers can pay extra for</p>:
        <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
          {f.extras.map((x,i)=>typeof x==="object"?
            <div key={x.id||i} style={{display:"flex",alignItems:"center",gap:5,padding:"5px 7px",background:"#fff",borderRadius:6,border:"1px solid #ede8de"}}>
              <span style={{fontSize:11,fontWeight:700}}>{x.name}</span>
              <span style={{fontSize:10,color:"#059669",fontWeight:700}}>+{fmt(x.priceAdj)}</span>
              <button type="button" onClick={()=>update("extras",f.extras.filter((_,idx)=>idx!==i))} style={{background:"#dc2626",color:"#fff",border:"none",borderRadius:"50%",width:18,height:18,fontSize:11,cursor:"pointer",lineHeight:1}}>{String.fromCharCode(0x00D7)}</button>
            </div>
            :null
          )}
        </div>}
      </div>

      {/* ALLERGENS / DIETARY - Custom per item */}
      <div style={{marginBottom:14,padding:12,background:"#ede9fe",borderRadius:9,border:"1px solid #c4b5fd"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:7}}>
          <label className="lbl" style={{margin:0}}>{String.fromCharCode(0x26A0,0xFE0F)} Allergens / Dietary Info</label>
          <button type="button" onClick={()=>{
            var name=prompt("Allergen or dietary info (e.g. Contains Gluten, Vegetarian, Halal):");
            if(!name||!name.trim())return;
            update("allergens",[...(f.allergens||[]),{id:"al_"+Date.now(),name:name.trim()}]);
          }} style={{padding:"5px 10px",fontSize:11,background:"#7c3aed",color:"#fff",border:"none",borderRadius:5,fontWeight:700,cursor:"pointer"}}>+ Add Info</button>
        </div>
        <p style={{fontSize:10,color:"#5b21b6",marginBottom:5,fontStyle:"italic"}}>Tip: Quick add common ones:</p>
        <div style={{display:"flex",gap:5,flexWrap:"wrap",marginBottom:7}}>
          {["Contains Gluten","Contains Dairy","Contains Nuts","Vegetarian","Vegan","Gluten Free","Halal","Spicy"].map(quick=>{
            var alreadyAdded=(f.allergens||[]).some(a=>(typeof a==="object"?a.name:"")===quick);
            if(alreadyAdded)return null;
            return <button key={quick} type="button" onClick={()=>update("allergens",[...(f.allergens||[]),{id:"al_"+Date.now()+Math.random(),name:quick}])} style={{padding:"3px 7px",fontSize:10,background:"#fff",color:"#7c3aed",border:"1px dashed #c4b5fd",borderRadius:5,cursor:"pointer"}}>+ {quick}</button>;
          })}
        </div>
        {(!f.allergens||f.allergens.length===0)?<p style={{fontSize:11,color:"#5b21b6",fontStyle:"italic"}}>No allergen info added</p>:
        <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
          {f.allergens.map((a,i)=>typeof a==="object"?
            <div key={a.id||i} style={{display:"flex",alignItems:"center",gap:5,padding:"5px 7px",background:"#fff",borderRadius:6,border:"1px solid #ede8de"}}>
              <span style={{fontSize:11,fontWeight:700}}>{a.name}</span>
              <button type="button" onClick={()=>update("allergens",f.allergens.filter((_,idx)=>idx!==i))} style={{background:"#dc2626",color:"#fff",border:"none",borderRadius:"50%",width:18,height:18,fontSize:11,cursor:"pointer",lineHeight:1}}>{String.fromCharCode(0x00D7)}</button>
            </div>
            :null
          )}
        </div>}
      </div>

      <div style={{marginBottom:16}}>
        <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer"}}>
          <input type="checkbox" checked={f.avail} onChange={e=>update("avail",e.target.checked)}/>
          <span style={{fontSize:13,fontWeight:600}}>Available to order</span>
        </label>
      </div>

      {confirmDel?<div style={{padding:14,background:"#fee2e2",borderRadius:9,marginBottom:12}}>
        <p style={{fontSize:13,fontWeight:700,color:"#991b1b",marginBottom:8}}>Delete this item permanently?</p>
        <div style={{display:"flex",gap:8}}>
          <button className="btn btn-o" onClick={()=>setConfirmDel(false)} style={{flex:1}}>Cancel</button>
          <button onClick={()=>{onDelete(f.id);onClose();}} style={{flex:1,padding:"10px",background:"#dc2626",color:"#fff",border:"none",borderRadius:9,fontWeight:700,cursor:"pointer"}}>Delete Forever</button>
        </div>
      </div>:<div style={{display:"flex",gap:8}}>
        <button className="btn btn-r" onClick={save} style={{flex:2,padding:"12px"}}>{isNew?"Add Item":"Save Changes"}</button>
        {!isNew&&<button onClick={()=>setConfirmDel(true)} style={{flex:1,padding:"12px",background:"#fff",color:"#dc2626",border:"2px solid #dc2626",borderRadius:9,fontWeight:700,cursor:"pointer"}}>Delete</button>}
      </div>}
    </div>
  </div>;
}

// -- AI MENU IMPORT MODAL -----------------------------------------------------
function MenuImportModal({onClose,onImport,categories}){
  var [file,setFile]=useState(null);
  var [preview,setPreview]=useState(null);
  var [parsedMenu,setParsedMenu]=useState(null);
  var [loading,setLoading]=useState(false);
  var [error,setError]=useState("");
  var [selectedItems,setSelectedItems]=useState({});

  var fileChange=e=>{
    var f=e.target.files[0];
    if(!f)return;
    if(f.size>10*1024*1024){setError("File too big - max 10MB");return;}
    setFile(f);setError("");setParsedMenu(null);
    // Preview image files
    if(f.type.startsWith("image/")){
      var reader=new FileReader();
      reader.onload=ev=>setPreview(ev.target.result);
      reader.readAsDataURL(f);
    }else{
      setPreview(null);
    }
  };

  var parseFile=async()=>{
    if(!file)return;
    setLoading(true);setError("");
    try{
      // Convert file to base64
      var reader=new FileReader();
      reader.onload=async ev=>{
        var base64=ev.target.result.split(",")[1];
        try{
          var res=await fetch("/api/parse-menu",{
            method:"POST",
            headers:{"Content-Type":"application/json"},
            body:JSON.stringify({fileBase64:base64,fileType:file.type,fileName:file.name}),
          });
          var data=await res.json();
          if(!res.ok){setError(data.error||"Failed to parse");setLoading(false);return;}
          setParsedMenu(data.menu);
          // Select all items by default
          var sel={};
          (data.menu.categories||[]).forEach((c,ci)=>(c.items||[]).forEach((it,ii)=>sel[ci+"-"+ii]=true));
          setSelectedItems(sel);
        }catch(err){setError("Network error: "+err.message);}
        setLoading(false);
      };
      reader.onerror=()=>{setError("Failed to read file");setLoading(false);};
      reader.readAsDataURL(file);
    }catch(err){setError(err.message);setLoading(false);}
  };

  var toggleItem=(ci,ii)=>{var k=ci+"-"+ii;setSelectedItems(s=>({...s,[k]:!s[k]}));};
  var toggleCategory=ci=>{
    if(!parsedMenu)return;
    var items=parsedMenu.categories[ci].items||[];
    var allSelected=items.every((_,ii)=>selectedItems[ci+"-"+ii]);
    setSelectedItems(s=>{var ns={...s};items.forEach((_,ii)=>ns[ci+"-"+ii]=!allSelected);return ns;});
  };

  var importAll=()=>{
    var newCats=[],newItems=[];
    (parsedMenu.categories||[]).forEach((c,ci)=>{
      var cat={id:"cat"+Date.now()+ci,name:c.name,icon:c.icon||"star",order:c.order||ci+1};
      var hasItems=false;
      (c.items||[]).forEach((it,ii)=>{
        if(!selectedItems[ci+"-"+ii])return;
        hasItems=true;
        newItems.push({id:Date.now()+ci*1000+ii,name:it.name,desc:it.description||"",price:parseFloat(it.price)||0,cat:c.name,icon:it.icon||"cart",stock:20,avail:true,allergens:it.allergens||[],sizes:[],extras:[],cookingOpts:[]});
      });
      if(hasItems){
        // Only add category if it's not already in database
        var exists=categories.find(ec=>ec.name.toLowerCase()===c.name.toLowerCase());
        if(!exists)newCats.push(cat);
      }
    });
    onImport(newCats,newItems);
    onClose();
  };

  var selectedCount=Object.values(selectedItems).filter(v=>v).length;

  return <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",zIndex:8500,display:"flex",alignItems:"flex-start",justifyContent:"center",padding:16,overflowY:"auto"}}>
    <div onClick={e=>e.stopPropagation()} className="card" style={{width:"100%",maxWidth:650,padding:22,marginTop:20,marginBottom:40}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <div>
          <h2 style={{fontSize:22,display:"flex",alignItems:"center",gap:8}}>{EM.party} AI Menu Import</h2>
          <p style={{fontSize:12,color:"#8a8078",marginTop:3}}>Upload any menu (PDF, image, photo) - AI extracts everything</p>
        </div>
        <button onClick={onClose} style={{color:"#999",fontSize:24,border:"none",background:"none",cursor:"pointer"}}>x</button>
      </div>

      {!parsedMenu&&<>
        {/* Upload Zone */}
        <label style={{display:"block",border:"3px dashed "+(file?"#059669":"#ede8de"),borderRadius:12,padding:"30px 20px",textAlign:"center",cursor:"pointer",background:file?"#f0fdf4":"#fafaf8",transition:"all .2s"}}>
          <input type="file" accept="image/*,application/pdf,.pdf,.jpg,.jpeg,.png,.webp,.heic" onChange={fileChange} style={{display:"none"}}/>
          {!file&&<>
            <p style={{fontSize:40,marginBottom:8}}>{EM.cart}</p>
            <p style={{fontSize:15,fontWeight:700,marginBottom:4}}>Tap to select menu file</p>
            <p style={{fontSize:12,color:"#8a8078"}}>PDF, JPG, PNG, HEIC - max 10MB</p>
          </>}
          {file&&<>
            <p style={{fontSize:30,marginBottom:6}}>{EM.check}</p>
            <p style={{fontSize:14,fontWeight:700,marginBottom:3}}>{file.name}</p>
            <p style={{fontSize:11,color:"#8a8078"}}>{(file.size/1024).toFixed(0)} KB - Tap to change</p>
          </>}
        </label>

        {preview&&<img src={preview} alt="Preview" style={{width:"100%",maxHeight:200,objectFit:"contain",marginTop:12,borderRadius:8,background:"#f7f3ee"}}/>}

        {error&&<div style={{padding:"10px 12px",background:"#fee2e2",borderRadius:8,marginTop:12,fontSize:13,color:"#991b1b"}}>{EM.cross} {error}</div>}

        <button className="btn btn-r" onClick={parseFile} disabled={!file||loading} style={{width:"100%",padding:"13px",fontSize:15,marginTop:14}}>
          {loading?"AI is reading your menu... (10-30 seconds)":"Parse Menu with AI"}
        </button>

        <div style={{marginTop:14,padding:"10px 12px",background:"#fffbeb",borderRadius:8,fontSize:11,color:"#92400e"}}>
          <strong>Tip:</strong> Clear photos work best. Make sure text is readable and the whole menu is visible.
        </div>
      </>}

      {parsedMenu&&<>
        <div style={{padding:"12px 14px",background:"#d1fae5",borderRadius:9,marginBottom:14,border:"2px solid #059669"}}>
          <p style={{fontSize:14,fontWeight:700,color:"#065f46"}}>{EM.check} Parsed Successfully!</p>
          <p style={{fontSize:12,color:"#065f46",marginTop:3}}>Found {parsedMenu.categories?.length||0} categories, {selectedCount} items selected</p>
        </div>

        <div style={{maxHeight:"50vh",overflowY:"auto",border:"1px solid #ede8de",borderRadius:10,padding:10}}>
          {parsedMenu.categories?.map((c,ci)=>{
            var items=c.items||[];
            var allChecked=items.every((_,ii)=>selectedItems[ci+"-"+ii]);
            var someChecked=items.some((_,ii)=>selectedItems[ci+"-"+ii]);
            return <div key={ci} style={{marginBottom:14,padding:10,background:"#fafaf8",borderRadius:8}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8,paddingBottom:6,borderBottom:"2px solid #ede8de"}}>
                <input type="checkbox" checked={allChecked} ref={el=>{if(el)el.indeterminate=someChecked&&!allChecked;}} onChange={()=>toggleCategory(ci)} style={{width:18,height:18,cursor:"pointer"}}/>
                <span style={{fontSize:22}}>{EM[c.icon]||EM.star}</span>
                <p style={{fontWeight:700,fontSize:15,flex:1}}>{c.name}</p>
                <p style={{fontSize:11,color:"#8a8078"}}>{items.length} items</p>
              </div>
              {items.map((it,ii)=><label key={ii} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 4px",cursor:"pointer",borderRadius:6}} onMouseEnter={e=>e.currentTarget.style.background="#fff"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                <input type="checkbox" checked={selectedItems[ci+"-"+ii]||false} onChange={()=>toggleItem(ci,ii)} style={{width:16,height:16,cursor:"pointer"}}/>
                <span style={{fontSize:18}}>{EM[it.icon]||EM.cart}</span>
                <div style={{flex:1,minWidth:0}}>
                  <p style={{fontSize:13,fontWeight:600}}>{it.name}</p>
                  {it.description&&<p style={{fontSize:11,color:"#8a8078",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{it.description}</p>}
                  {it.allergens&&it.allergens.length>0&&<div style={{display:"flex",gap:3,marginTop:2,flexWrap:"wrap"}}>{it.allergens.map((a,i)=><span key={i} style={{fontSize:9,padding:"1px 6px",borderRadius:8,background:"#f5f0ff",color:"#7c3aed",fontWeight:700}}>{typeof a==="object"?a.name:a}</span>)}</div>}
                </div>
                <p style={{fontSize:14,fontWeight:700,color:"#bf4626"}}>{fmt(it.price)}</p>
              </label>)}
            </div>;
          })}
        </div>

        <div style={{display:"flex",gap:8,marginTop:14}}>
          <button className="btn btn-o" onClick={()=>{setParsedMenu(null);setFile(null);setPreview(null);}} style={{flex:1,padding:"12px"}}>Start Over</button>
          <button className="btn btn-r" onClick={importAll} disabled={selectedCount===0} style={{flex:2,padding:"12px"}}>Import {selectedCount} Items</button>
        </div>
      </>}
    </div>
  </div>;
}

// -- SET MEAL EDITOR MODAL -----------------------------------------------------
function SetMealEditor({meal,menu,onSave,onClose,onDelete}){
  var isNew=!meal||!meal.id;
  var [f,setF]=useState({
    id:meal?.id||"sm"+Date.now(),
    name:meal?.name||"",
    desc:meal?.desc||"",
    price:meal?.price||0,
    itemIds:meal?.itemIds||[],
    icon:meal?.icon||"party",
    avail:meal?.avail!==false,
  });
  var [confirmDel,setConfirmDel]=useState(false);
  var update=(k,v)=>setF(x=>({...x,[k]:v}));
  var toggleItem=id=>setF(x=>({...x,itemIds:x.itemIds.includes(id)?x.itemIds.filter(i=>i!==id):[...x.itemIds,id]}));
  var regularTotal=f.itemIds.reduce((s,id)=>{var m=menu.find(m=>m.id===id);return s+(m?.price||0);},0);
  var saving=regularTotal-f.price;
  var save=()=>{
    if(!f.name.trim()){alert("Name is required");return;}
    if(!f.price||f.price<=0){alert("Valid price is required");return;}
    if(!f.itemIds.length){alert("Select at least one item");return;}
    onSave({...f,price:+f.price});
    onClose();
  };

  return <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:8000,display:"flex",alignItems:"flex-start",justifyContent:"center",padding:16,overflowY:"auto"}}>
    <div onClick={e=>e.stopPropagation()} className="card" style={{width:"100%",maxWidth:500,padding:22,marginTop:20,marginBottom:40}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <h2 style={{fontSize:22}}>{isNew?"Create Set Meal":"Edit Set Meal"}</h2>
        <button onClick={onClose} style={{color:"#999",fontSize:22,border:"none",background:"none",cursor:"pointer"}}>x</button>
      </div>

      <div style={{marginBottom:12}}>
        <label className="lbl">Icon</label>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(45px,1fr))",gap:5,padding:6,background:"#f7f3ee",borderRadius:8,maxHeight:90,overflowY:"auto"}}>
          {ICON_KEYS.map(k=><button key={k} onClick={()=>update("icon",k)} style={{padding:6,borderRadius:6,fontSize:20,background:f.icon===k?"#7c3aed":"#fff",border:"2px solid "+(f.icon===k?"#7c3aed":"#ede8de"),cursor:"pointer"}}>{EM[k]||""}</button>)}
        </div>
      </div>

      <div style={{marginBottom:10}}><label className="lbl">Combo Name *</label><input className="field" value={f.name} onChange={e=>update("name",e.target.value)} placeholder="Burger Combo"/></div>
      <div style={{marginBottom:10}}><label className="lbl">Description</label><textarea className="field" value={f.desc} onChange={e=>update("desc",e.target.value)} rows={2} style={{resize:"vertical"}} placeholder="Any burger + fries + drink"/></div>
      <div style={{marginBottom:12}}><label className="lbl">Combo Price (GBP) *</label><input type="number" step="0.01" className="field" value={f.price} onChange={e=>update("price",e.target.value)} placeholder="19.99"/></div>

      <div style={{marginBottom:12}}>
        <label className="lbl">Items Included ({f.itemIds.length} selected)</label>
        <div style={{maxHeight:180,overflowY:"auto",border:"1px solid #ede8de",borderRadius:8,padding:4}}>
          {menu.filter(m=>m.avail).map(m=><button key={m.id} onClick={()=>toggleItem(m.id)} style={{width:"100%",textAlign:"left",padding:"8px 10px",borderRadius:6,background:f.itemIds.includes(m.id)?"#f5f0ff":"#fff",border:"2px solid "+(f.itemIds.includes(m.id)?"#7c3aed":"transparent"),cursor:"pointer",marginBottom:3,display:"flex",alignItems:"center",gap:8}}>
            <span style={{fontSize:18}}>{EM[m.icon]||""}</span>
            <span style={{flex:1,fontSize:12,fontWeight:600}}>{m.name}</span>
            <span style={{fontSize:11,color:"#bf4626",fontWeight:700}}>{fmt(m.price)}</span>
          </button>)}
        </div>
      </div>

      {f.itemIds.length>0&&f.price>0&&<div style={{padding:"10px 12px",background:saving>0?"#d1fae5":"#fef3c7",borderRadius:8,marginBottom:12}}>
        <div style={{display:"flex",justifyContent:"space-between",fontSize:12}}>
          <span>Regular total:</span><span style={{fontWeight:700}}>{fmt(regularTotal)}</span>
        </div>
        <div style={{display:"flex",justifyContent:"space-between",fontSize:12}}>
          <span>Combo price:</span><span style={{fontWeight:700}}>{fmt(f.price)}</span>
        </div>
        <div style={{display:"flex",justifyContent:"space-between",fontSize:13,fontWeight:700,color:saving>0?"#059669":"#d97706",marginTop:4,paddingTop:4,borderTop:"1px solid rgba(0,0,0,.08)"}}>
          <span>{saving>0?"Customer saves:":"Warning - no saving"}</span>
          <span>{fmt(Math.abs(saving))}</span>
        </div>
      </div>}

      <div style={{marginBottom:14}}>
        <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer"}}>
          <input type="checkbox" checked={f.avail} onChange={e=>update("avail",e.target.checked)}/>
          <span style={{fontSize:13,fontWeight:600}}>Available to order</span>
        </label>
      </div>

      {confirmDel?<div style={{padding:14,background:"#fee2e2",borderRadius:9,marginBottom:12}}>
        <p style={{fontSize:13,fontWeight:700,color:"#991b1b",marginBottom:8}}>Delete this combo permanently?</p>
        <div style={{display:"flex",gap:8}}>
          <button className="btn btn-o" onClick={()=>setConfirmDel(false)} style={{flex:1}}>Cancel</button>
          <button onClick={()=>{onDelete(f.id);onClose();}} style={{flex:1,padding:"10px",background:"#dc2626",color:"#fff",border:"none",borderRadius:9,fontWeight:700,cursor:"pointer"}}>Delete Forever</button>
        </div>
      </div>:<div style={{display:"flex",gap:8}}>
        <button className="btn btn-r" onClick={save} style={{flex:2,padding:"12px"}}>{isNew?"Create Combo":"Save Changes"}</button>
        {!isNew&&<button onClick={()=>setConfirmDel(true)} style={{flex:1,padding:"12px",background:"#fff",color:"#dc2626",border:"2px solid #dc2626",borderRadius:9,fontWeight:700,cursor:"pointer"}}>Delete</button>}
      </div>}
    </div>
  </div>;
}

// -- CATEGORY EDITOR MODAL -----------------------------------------------------
function CategoryEditor({cat,onSave,onClose,onDelete,menu}){
  var isNew=!cat||!cat.id;
  var [f,setF]=useState({
    id:cat?.id||"cat"+Date.now(),
    name:cat?.name||"",
    icon:cat?.icon||"star",
    order:cat?.order||99,
  });
  var [confirmDel,setConfirmDel]=useState(false);
  var update=(k,v)=>setF(x=>({...x,[k]:v}));
  var usedBy=!isNew?menu.filter(m=>m.cat===cat.name).length:0;
  var save=()=>{
    if(!f.name.trim()){alert("Name is required");return;}
    onSave({...f,order:+f.order});
    onClose();
  };

  return <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:8000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
    <div onClick={e=>e.stopPropagation()} className="card" style={{width:"100%",maxWidth:420,padding:22}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
        <h2 style={{fontSize:20}}>{isNew?"Add Category":"Edit Category"}</h2>
        <button onClick={onClose} style={{color:"#999",fontSize:22,border:"none",background:"none",cursor:"pointer"}}>x</button>
      </div>

      <div style={{marginBottom:12}}>
        <label className="lbl">Icon</label>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(45px,1fr))",gap:5,padding:6,background:"#f7f3ee",borderRadius:8,maxHeight:120,overflowY:"auto"}}>
          {ICON_KEYS.map(k=><button key={k} onClick={()=>update("icon",k)} style={{padding:6,borderRadius:6,fontSize:20,background:f.icon===k?"#d4952a":"#fff",border:"2px solid "+(f.icon===k?"#d4952a":"#ede8de"),cursor:"pointer"}}>{EM[k]||""}</button>)}
        </div>
      </div>

      <div style={{marginBottom:10}}><label className="lbl">Category Name *</label><input className="field" value={f.name} onChange={e=>update("name",e.target.value)} placeholder="e.g. Breakfast, Specials, Kids Menu"/></div>
      <div style={{marginBottom:14}}><label className="lbl">Display Order</label><input type="number" className="field" value={f.order} onChange={e=>update("order",e.target.value)} placeholder="1-99 (lower shows first)"/><p style={{fontSize:11,color:"#8a8078",marginTop:4}}>Lower numbers appear first in the menu</p></div>

      {!isNew&&usedBy>0&&<div style={{padding:"10px 12px",background:"#fef3c7",borderRadius:8,marginBottom:12,fontSize:12,color:"#92400e"}}>
        This category is used by {usedBy} menu item{usedBy!==1?"s":""}. Renaming it will update them automatically.
      </div>}

      {confirmDel?<div style={{padding:14,background:"#fee2e2",borderRadius:9,marginBottom:12}}>
        <p style={{fontSize:13,fontWeight:700,color:"#991b1b",marginBottom:8}}>Delete this category?</p>
        {usedBy>0&&<p style={{fontSize:12,color:"#991b1b",marginBottom:8}}>Cannot delete - {usedBy} item(s) still use it. Move them to another category first.</p>}
        <div style={{display:"flex",gap:8}}>
          <button className="btn btn-o" onClick={()=>setConfirmDel(false)} style={{flex:1}}>Cancel</button>
          <button onClick={()=>{onDelete(f.id);onClose();}} disabled={usedBy>0} style={{flex:1,padding:"10px",background:usedBy>0?"#ccc":"#dc2626",color:"#fff",border:"none",borderRadius:9,fontWeight:700,cursor:usedBy>0?"not-allowed":"pointer"}}>Delete</button>
        </div>
      </div>:<div style={{display:"flex",gap:8}}>
        <button className="btn btn-r" onClick={save} style={{flex:2,padding:"12px"}}>{isNew?"Add Category":"Save Changes"}</button>
        {!isNew&&<button onClick={()=>setConfirmDel(true)} style={{flex:1,padding:"12px",background:"#fff",color:"#dc2626",border:"2px solid #dc2626",borderRadius:9,fontWeight:700,cursor:"pointer"}}>Delete</button>}
      </div>}
    </div>
  </div>;
}

// -- TABLE EDITOR MODAL -----------------------------------------------------
function TableEditor({table,onSave,onClose,existingTables}){
  var [form,setForm]=useState({
    id:table.id||1,
    seats:table.seats||4,
    x:table.x||60,
    y:table.y||60,
    dbId:table.dbId,
    branchId:table.branchId,
    status:table.status||"free",
    shape:table.shape||"rectangle",
  });
  var isNew=!table.dbId;
  var numberTaken=isNew&&existingTables.some(t=>+t.id===+form.id);
  var save=()=>{
    if(numberTaken){alert("Table number "+form.id+" is already used in this branch");return;}
    if(form.seats<1||form.seats>20){alert("Seats must be between 1 and 20");return;}
    onSave(form);
  };
  
  return <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:8500,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
    <div onClick={e=>e.stopPropagation()} className="card" style={{width:"100%",maxWidth:420,padding:22,maxHeight:"90vh",overflow:"auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <h2 style={{fontSize:20}}>{isNew?"Add Table":"Edit Table "+table.id}</h2>
        <button onClick={onClose} style={{color:"#999",fontSize:22,border:"none",background:"none",cursor:"pointer"}}>x</button>
      </div>
      
      <div style={{marginBottom:14}}>
        <label className="lbl">Table Number</label>
        <input type="number" className="field" value={form.id} onChange={e=>setForm(f=>({...f,id:+e.target.value}))} min="1"/>
        {numberTaken&&<p style={{color:"#dc2626",fontSize:11,marginTop:3}}>This number is already taken in this branch</p>}
      </div>
      
      <div style={{marginBottom:14}}>
        <label className="lbl">Number of Seats</label>
        <div style={{display:"grid",gridTemplateColumns:"repeat(6,1fr)",gap:5}}>
          {[2,4,6,8,10,12].map(n=><button key={n} onClick={()=>setForm(f=>({...f,seats:n}))} style={{padding:"10px 4px",fontSize:13,fontWeight:700,background:form.seats===n?"#bf4626":"#fff",color:form.seats===n?"#fff":"#1a1208",border:"2px solid "+(form.seats===n?"#bf4626":"#ede8de"),borderRadius:7,cursor:"pointer"}}>{n}</button>)}
        </div>
        <input type="number" className="field" value={form.seats} onChange={e=>setForm(f=>({...f,seats:Math.max(1,+e.target.value)}))} min="1" max="20" style={{marginTop:6}} placeholder="Or enter custom seats"/>
      </div>
      
      <div style={{marginBottom:14}}>
        <label className="lbl">Table Shape</label>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:7}}>
          {[
            ["rectangle","Rectangle",String.fromCharCode(0x2B1B)],
            ["square","Square",String.fromCharCode(0x25A0)],
            ["round","Round",String.fromCharCode(0x25CF)]
          ].map(([sh,nm,ico])=><button key={sh} onClick={()=>setForm(f=>({...f,shape:sh}))} style={{padding:"11px 5px",fontSize:12,fontWeight:700,background:form.shape===sh?"#bf4626":"#fff",color:form.shape===sh?"#fff":"#1a1208",border:"2px solid "+(form.shape===sh?"#bf4626":"#ede8de"),borderRadius:7,cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:3}}>
            <span style={{fontSize:18}}>{ico}</span>
            <span>{nm}</span>
          </button>)}
        </div>
      </div>
      
      <div style={{padding:"10px 12px",background:"#fffbeb",borderRadius:8,marginBottom:14,fontSize:11,color:"#92400e"}}>
        <strong>{String.fromCharCode(0xD83D,0xDCA1)} Tip:</strong> After saving, drag the table on the floor plan to position it.
      </div>
      
      <div style={{display:"flex",gap:7}}>
        <button className="btn btn-o" onClick={onClose} style={{flex:1,padding:"11px"}}>Cancel</button>
        <button className="btn btn-r" onClick={save} disabled={numberTaken} style={{flex:2,padding:"11px"}}>{isNew?"Add Table":"Save"}</button>
      </div>
    </div>
  </div>;
}

// ============================================================
// EXPENSE FORM - add or edit an expense
// ============================================================
function ExpenseForm({categories,branch,user,editing,onCancel,onSave}){
  var [amount,setAmount]=useState(editing?String(editing.amount):"");
  var [categoryId,setCategoryId]=useState(editing?editing.category_id:(categories[0]?.id||""));
  var [description,setDescription]=useState(editing?editing.description:"");
  var [expenseDate,setExpenseDate]=useState(editing?editing.expense_date:new Date().toISOString().split("T")[0]);
  var [photoUrl,setPhotoUrl]=useState(editing?editing.receipt_photo_url||"":"");
  var [notes,setNotes]=useState(editing?editing.notes||"":"");
  var [isRecurring,setIsRecurring]=useState(false);
  var [recurringFreq,setRecurringFreq]=useState("monthly");
  var [recurringDay,setRecurringDay]=useState(1);
  var [submitting,setSubmitting]=useState(false);
  var [showPhotoInput,setShowPhotoInput]=useState(false);
  
  var activeCats=categories.filter(c=>c.active!==false);
  var selectedCat=activeCats.find(c=>c.id===categoryId);
  
  var save=()=>{
    if(!amount||parseFloat(amount)<=0){alert("Enter a valid amount");return;}
    if(!description.trim()){alert("Enter a description");return;}
    if(!categoryId){alert("Select a category");return;}
    setSubmitting(true);
    
    var expense={
      id:editing?editing.id:undefined,
      branchId:branch?.id,
      categoryId:categoryId,
      categoryName:selectedCat?.name||"Other",
      amount:parseFloat(amount),
      description:description.trim(),
      expenseDate:expenseDate,
      recordedBy:user?.name||"Staff",
      recordedByRole:user?.role==="owner"||user?.role==="manager"?"manager":"staff",
      receiptPhotoUrl:photoUrl||null,
      notes:notes||null,
      isRecurring:false,
    };
    
    dbSaveExpense(expense).then(r=>{
      if(r.error){alert("Failed: "+JSON.stringify(r.error));setSubmitting(false);return;}
      // If user wants this to be recurring, also save a recurring template
      if(isRecurring){
        dbSaveRecurring({
          branchId:branch?.id,
          categoryId:categoryId,
          categoryName:selectedCat?.name||"Other",
          amount:parseFloat(amount),
          description:description.trim(),
          frequency:recurringFreq,
          dayOfMonth:recurringDay,
          startDate:expenseDate,
          notes:"Auto-generated from expense "+(r.data?.id||""),
        }).catch(e=>console.log("Recurring save fail:",e));
      }
      setSubmitting(false);
      onSave(r.data);
    }).catch(e=>{
      setSubmitting(false);
      alert("Error: "+e.message);
    });
  };
  
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",zIndex:9400,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
    <div style={{background:"#fafaf5",color:"#1a1208",borderRadius:14,maxWidth:540,width:"100%",maxHeight:"96vh",overflow:"hidden",display:"flex",flexDirection:"column",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
      <div style={{background:"linear-gradient(135deg,#dc2626,#991b1b)",color:"#fff",padding:"15px 20px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <p style={{fontSize:11,opacity:.85,fontWeight:700,letterSpacing:2}}>FINANCE</p>
          <h2 style={{fontSize:18,fontWeight:700}}>{editing?"Edit Expense":"Add Expense"}</h2>
        </div>
        <button onClick={onCancel} style={{width:34,height:34,borderRadius:"50%",background:"rgba(255,255,255,.15)",color:"#fff",border:"none",cursor:"pointer",fontSize:16,fontWeight:700}}>x</button>
      </div>
      
      <div style={{flex:1,overflowY:"auto",padding:18}}>
        {/* Amount */}
        <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>AMOUNT (REQUIRED)</p>
        <input type="number" step="0.01" value={amount} onChange={e=>setAmount(e.target.value)} placeholder="0.00" autoFocus style={{width:"100%",padding:"14px",border:"3px solid #dc2626",borderRadius:9,fontSize:24,fontWeight:700,fontFamily:"'Courier New',monospace",textAlign:"right",marginBottom:11,boxSizing:"border-box"}}/>
        
        {/* Category */}
        <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>CATEGORY (REQUIRED)</p>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:5,marginBottom:11}}>
          {activeCats.map(c=><button key={c.id} onClick={()=>setCategoryId(c.id)} style={{padding:"10px",background:categoryId===c.id?c.color:"#fff",color:categoryId===c.id?"#fff":"#1a1208",border:"2px solid "+(categoryId===c.id?c.color:"#ede8de"),borderRadius:7,fontSize:11,fontWeight:700,cursor:"pointer",textAlign:"left",display:"flex",alignItems:"center",gap:6}}>
            <span style={{fontSize:18}}>{c.icon||String.fromCharCode(0xD83D,0xDCDD)}</span>
            <span>{c.name}</span>
          </button>)}
        </div>
        
        {/* Description */}
        <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>DESCRIPTION (REQUIRED)</p>
        <input value={description} onChange={e=>setDescription(e.target.value)} placeholder="What is this expense for?" style={{width:"100%",padding:"11px",border:"2px solid #ede8de",borderRadius:7,fontSize:13,marginBottom:11,boxSizing:"border-box"}}/>
        
        {/* Date */}
        <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>DATE</p>
        <input type="date" value={expenseDate} max={new Date().toISOString().split("T")[0]} onChange={e=>setExpenseDate(e.target.value)} style={{width:"100%",padding:"11px",border:"2px solid #ede8de",borderRadius:7,fontSize:13,marginBottom:11,boxSizing:"border-box"}}/>
        
        {/* Receipt photo */}
        <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>RECEIPT PHOTO (OPTIONAL)</p>
        {!showPhotoInput?<button onClick={()=>setShowPhotoInput(true)} style={{width:"100%",padding:"11px",background:"#fff",border:"2px dashed #d4952a",color:"#d4952a",borderRadius:7,fontWeight:700,fontSize:12,cursor:"pointer",marginBottom:11}}>{String.fromCharCode(0xD83D,0xDCF7)} Add Receipt Photo URL</button>:<>
          <input value={photoUrl} onChange={e=>setPhotoUrl(e.target.value)} placeholder="https://..." style={{width:"100%",padding:"11px",border:"2px solid #d4952a",borderRadius:7,fontSize:12,marginBottom:5,boxSizing:"border-box"}}/>
          <p style={{fontSize:10,color:"#8a8078",marginBottom:11,fontStyle:"italic"}}>Paste a URL of the receipt photo (upload to Imgur, Google Drive, etc.)</p>
        </>}
        
        {/* Notes */}
        <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>NOTES (OPTIONAL)</p>
        <textarea value={notes} onChange={e=>setNotes(e.target.value)} placeholder="Additional notes..." rows={2} style={{width:"100%",padding:"10px",border:"2px solid #ede8de",borderRadius:7,fontSize:12,fontFamily:"inherit",resize:"vertical",marginBottom:11,boxSizing:"border-box"}}/>
        
        {/* Recurring toggle */}
        {!editing&&<div style={{padding:11,background:"#fff",borderRadius:7,border:"2px solid #ede8de",marginBottom:11}}>
          <label style={{display:"flex",alignItems:"center",gap:7,cursor:"pointer"}}>
            <input type="checkbox" checked={isRecurring} onChange={e=>setIsRecurring(e.target.checked)} style={{width:18,height:18,cursor:"pointer"}}/>
            <span style={{fontWeight:700,fontSize:13}}>{String.fromCharCode(0xD83D,0xDD04)} Make this a recurring expense</span>
          </label>
          {isRecurring&&<div style={{marginTop:9,padding:9,background:"#f7f3ee",borderRadius:6}}>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:7}}>
              <div>
                <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3}}>FREQUENCY</p>
                <select value={recurringFreq} onChange={e=>setRecurringFreq(e.target.value)} className="field" style={{padding:"7px 9px",fontSize:12}}>
                  <option value="weekly">Weekly</option>
                  <option value="monthly">Monthly</option>
                  <option value="quarterly">Quarterly</option>
                  <option value="yearly">Yearly</option>
                </select>
              </div>
              {recurringFreq==="monthly"&&<div>
                <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3}}>DAY OF MONTH</p>
                <input type="number" min="1" max="28" value={recurringDay} onChange={e=>setRecurringDay(parseInt(e.target.value)||1)} className="field" style={{padding:"7px 9px",fontSize:12}}/>
              </div>}
            </div>
            <p style={{fontSize:10,color:"#8a8078",marginTop:5,fontStyle:"italic"}}>This expense will auto-create on the schedule.</p>
          </div>}
        </div>}
      </div>
      
      <div style={{padding:11,background:"#fff",borderTop:"1px solid #ede8de",display:"flex",gap:6}}>
        <button onClick={onCancel} style={{flex:1,padding:"14px",background:"#fff",border:"2px solid #ede8de",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>Cancel</button>
        <button onClick={save} disabled={submitting||!amount||!description.trim()||!categoryId} style={{flex:2,padding:"14px",background:submitting||!amount||!description.trim()||!categoryId?"#9ca3af":"linear-gradient(135deg,#dc2626,#991b1b)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:14,cursor:submitting?"not-allowed":"pointer"}}>{submitting?"Saving...":(String.fromCharCode(0x2713)+" Save Expense")}</button>
      </div>
    </div>
  </div>;
}

// ============================================================
// CATEGORY MANAGER - add/edit/delete custom expense categories
// ============================================================
function CategoryManager({categories,branch,onClose,onUpdate,push}){
  var [list,setList]=useState(categories);
  var [editing,setEditing]=useState(null);
  var [showAdd,setShowAdd]=useState(false);
  
  var emptyCategory={name:"",icon:"",color:"#bf4626",description:""};
  var [formCat,setFormCat]=useState(emptyCategory);
  
  var icons=[String.fromCharCode(0xD83D,0xDC68,0x200D,0xD83C,0xDF73),String.fromCharCode(0xD83C,0xDFE0),String.fromCharCode(0xD83E,0xDD58),String.fromCharCode(0xD83D,0xDCA1),String.fromCharCode(0xD83D,0xDCDE),String.fromCharCode(0xD83D,0xDD27),String.fromCharCode(0xD83E,0xDDF9),String.fromCharCode(0xD83D,0xDCE2),String.fromCharCode(0xD83D,0xDEE1,0xFE0F),String.fromCharCode(0xD83D,0xDCDD),String.fromCharCode(0xD83D,0xDCB3),String.fromCharCode(0xD83D,0xDED2),String.fromCharCode(0xD83D,0xDE9A),String.fromCharCode(0xD83D,0xDD0C),String.fromCharCode(0xD83D,0xDCDA),String.fromCharCode(0xD83C,0xDF7D,0xFE0F)];
  var colors=["#dc2626","#7c3aed","#059669","#d97706","#2563eb","#0891b2","#0d9488","#ea580c","#1e40af","#6b7280","#bf4626","#84cc16","#f59e0b","#ec4899","#6366f1","#10b981"];
  
  var startEdit=(c)=>{
    setEditing(c);
    setFormCat({name:c.name,icon:c.icon||"",color:c.color||"#bf4626",description:c.description||""});
    setShowAdd(true);
  };
  
  var startAdd=()=>{
    setEditing(null);
    setFormCat({...emptyCategory,icon:icons[0],color:colors[0]});
    setShowAdd(true);
  };
  
  var saveCategory=()=>{
    if(!formCat.name.trim()){alert("Enter a category name");return;}
    var payload={
      id:editing?editing.id:undefined,
      branchId:null, // global for now
      name:formCat.name.trim(),
      icon:formCat.icon,
      color:formCat.color,
      description:formCat.description,
      displayOrder:editing?editing.display_order:list.length+1,
    };
    dbSaveExpenseCat(payload).then(r=>{
      if(r.error){alert("Failed: "+JSON.stringify(r.error));return;}
      var newList;
      if(editing){
        newList=list.map(c=>c.id===editing.id?r.data:c);
      }else{
        newList=[...list,r.data];
      }
      setList(newList);
      onUpdate(newList);
      setShowAdd(false);
      setEditing(null);
      push&&push({title:editing?"Category updated":"Category added",body:formCat.name,color:formCat.color});
    });
  };
  
  var deleteCat=(c)=>{
    if(!window.confirm("Delete category \""+c.name+"\"? Existing expenses will keep their category name but you cannot use this category for new expenses."))return;
    dbDeleteExpenseCat(c.id).then(()=>{
      var newList=list.filter(x=>x.id!==c.id);
      setList(newList);
      onUpdate(newList);
      push&&push({title:"Category deleted",body:c.name,color:"#dc2626"});
    });
  };
  
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",zIndex:9400,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
    <div style={{background:"#fafaf5",color:"#1a1208",borderRadius:14,maxWidth:600,width:"100%",maxHeight:"96vh",overflow:"hidden",display:"flex",flexDirection:"column",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
      <div style={{background:"linear-gradient(135deg,#1a1208,#3d2e22)",color:"#fff",padding:"15px 20px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <p style={{fontSize:11,opacity:.85,fontWeight:700,letterSpacing:2}}>FINANCE</p>
          <h2 style={{fontSize:18,fontWeight:700}}>{String.fromCharCode(0xD83D,0xDCC1)} Manage Expense Categories</h2>
        </div>
        <button onClick={onClose} style={{width:34,height:34,borderRadius:"50%",background:"rgba(255,255,255,.15)",color:"#fff",border:"none",cursor:"pointer",fontSize:16,fontWeight:700}}>x</button>
      </div>
      
      <div style={{flex:1,overflowY:"auto",padding:18}}>
        {!showAdd?<>
          <button onClick={startAdd} style={{width:"100%",padding:"12px",background:"linear-gradient(135deg,#059669,#10b981)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer",marginBottom:11}}>{String.fromCharCode(0x2B)} Add New Category</button>
          
          <div>
            {list.filter(c=>c.active!==false).map(c=><div key={c.id} style={{padding:11,border:"2px solid #ede8de",borderRadius:9,marginBottom:6,display:"flex",alignItems:"center",gap:10,borderLeft:"5px solid "+(c.color||"#bf4626")}}>
              <span style={{fontSize:24}}>{c.icon||String.fromCharCode(0xD83D,0xDCDD)}</span>
              <div style={{flex:1}}>
                <p style={{fontSize:13,fontWeight:700}}>{c.name}</p>
                {c.description&&<p style={{fontSize:11,color:"#8a8078"}}>{c.description}</p>}
              </div>
              <button onClick={()=>startEdit(c)} style={{padding:"5px 9px",background:"#fef3c7",color:"#92400e",border:"none",borderRadius:5,fontSize:11,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0x270F,0xFE0F)} Edit</button>
              <button onClick={()=>deleteCat(c)} style={{padding:"5px 9px",background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:5,fontSize:11,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0xD83D,0xDDD1,0xFE0F)}</button>
            </div>)}
          </div>
        </>:<>
          <h3 style={{fontSize:14,fontWeight:700,marginBottom:11}}>{editing?"Edit Category":"New Category"}</h3>
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>NAME</p>
          <input value={formCat.name} onChange={e=>setFormCat({...formCat,name:e.target.value})} placeholder="e.g., Pest Control" autoFocus style={{width:"100%",padding:"11px",border:"2px solid #ede8de",borderRadius:7,fontSize:13,marginBottom:11,boxSizing:"border-box"}}/>
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>DESCRIPTION (OPTIONAL)</p>
          <input value={formCat.description} onChange={e=>setFormCat({...formCat,description:e.target.value})} placeholder="What types of expenses go here?" style={{width:"100%",padding:"11px",border:"2px solid #ede8de",borderRadius:7,fontSize:13,marginBottom:11,boxSizing:"border-box"}}/>
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>ICON</p>
          <div style={{display:"grid",gridTemplateColumns:"repeat(8,1fr)",gap:5,marginBottom:11}}>
            {icons.map((ic,i)=><button key={i} onClick={()=>setFormCat({...formCat,icon:ic})} style={{padding:"9px",fontSize:18,background:formCat.icon===ic?formCat.color:"#fff",border:"2px solid "+(formCat.icon===ic?formCat.color:"#ede8de"),borderRadius:6,cursor:"pointer"}}>{ic}</button>)}
          </div>
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>COLOR</p>
          <div style={{display:"grid",gridTemplateColumns:"repeat(8,1fr)",gap:5,marginBottom:11}}>
            {colors.map(c=><button key={c} onClick={()=>setFormCat({...formCat,color:c})} style={{padding:"14px",background:c,border:"3px solid "+(formCat.color===c?"#1a1208":"transparent"),borderRadius:6,cursor:"pointer"}}/>)}
          </div>
          
          <div style={{padding:11,background:"#fff",borderRadius:7,border:"2px solid "+formCat.color,marginBottom:11,display:"flex",alignItems:"center",gap:8}}>
            <span style={{fontSize:24}}>{formCat.icon||String.fromCharCode(0xD83D,0xDCDD)}</span>
            <div>
              <p style={{fontSize:13,fontWeight:700}}>{formCat.name||"Preview"}</p>
              <p style={{fontSize:11,color:"#8a8078"}}>{formCat.description||"Description will appear here"}</p>
            </div>
          </div>
          
          <div style={{display:"flex",gap:6}}>
            <button onClick={()=>{setShowAdd(false);setEditing(null);}} style={{flex:1,padding:"13px",background:"#fff",border:"2px solid #ede8de",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>Cancel</button>
            <button onClick={saveCategory} style={{flex:2,padding:"13px",background:"linear-gradient(135deg,#059669,#10b981)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>{String.fromCharCode(0x2713)} Save Category</button>
          </div>
        </>}
      </div>
    </div>
  </div>;
}

// ============================================================
// RECURRING EXPENSES MANAGER - view/edit/delete recurring templates
// ============================================================
function RecurringExpensesManager({list,categories,branch,onClose,onUpdate,push}){
  var [items,setItems]=useState(list);
  var [editing,setEditing]=useState(null);
  var [showAdd,setShowAdd]=useState(false);
  
  var emptyForm={
    description:"",amount:"",categoryId:categories[0]?.id||"",
    frequency:"monthly",dayOfMonth:1,
    startDate:new Date().toISOString().split("T")[0],endDate:"",
  };
  var [form,setForm]=useState(emptyForm);
  
  var startEdit=(r)=>{
    setEditing(r);
    setForm({
      description:r.description,
      amount:String(r.amount),
      categoryId:r.category_id||"",
      frequency:r.frequency,
      dayOfMonth:r.day_of_month||1,
      startDate:r.start_date,
      endDate:r.end_date||"",
    });
    setShowAdd(true);
  };
  
  var startAdd=()=>{
    setEditing(null);
    setForm({...emptyForm,categoryId:categories[0]?.id||""});
    setShowAdd(true);
  };
  
  var saveRec=()=>{
    if(!form.description.trim()){alert("Enter description");return;}
    if(!form.amount||parseFloat(form.amount)<=0){alert("Enter valid amount");return;}
    var cat=categories.find(c=>c.id===form.categoryId);
    var payload={
      id:editing?editing.id:undefined,
      branchId:branch?.id||null,
      categoryId:form.categoryId,
      categoryName:cat?.name||"Other",
      amount:parseFloat(form.amount),
      description:form.description.trim(),
      frequency:form.frequency,
      dayOfMonth:parseInt(form.dayOfMonth)||1,
      startDate:form.startDate,
      endDate:form.endDate||null,
      active:true,
    };
    dbSaveRecurring(payload).then(r=>{
      if(r.error){alert("Failed: "+JSON.stringify(r.error));return;}
      var newList;
      if(editing){
        newList=items.map(x=>x.id===editing.id?r.data:x);
      }else{
        newList=[...items,r.data];
      }
      setItems(newList);
      onUpdate(newList);
      setShowAdd(false);
      setEditing(null);
      push&&push({title:editing?"Recurring updated":"Recurring added",body:form.description,color:"#7c3aed"});
    });
  };
  
  var pauseRec=(r)=>{
    if(!window.confirm((r.active?"Pause":"Resume")+" recurring expense \""+r.description+"\"?"))return;
    dbSaveRecurring({id:r.id,branchId:r.branch_id,categoryId:r.category_id,categoryName:r.category_name,amount:r.amount,description:r.description,frequency:r.frequency,dayOfMonth:r.day_of_month,startDate:r.start_date,endDate:r.end_date,active:!r.active}).then(()=>{
      var newList=items.map(x=>x.id===r.id?{...x,active:!r.active}:x);
      setItems(newList);
      onUpdate(newList);
    });
  };
  
  var deleteRec=(r)=>{
    if(!window.confirm("Delete \""+r.description+"\"? Future auto-creations will stop. (Existing expenses are NOT deleted.)"))return;
    dbDeleteRecurring(r.id).then(()=>{
      var newList=items.filter(x=>x.id!==r.id);
      setItems(newList);
      onUpdate(newList);
      push&&push({title:"Recurring deleted",body:r.description,color:"#dc2626"});
    });
  };
  
  // Compute next due date for display
  var computeNextDue=(r)=>{
    if(!r.active)return"PAUSED";
    var today=new Date();
    today.setHours(0,0,0,0);
    var startDate=new Date(r.start_date);
    startDate.setHours(0,0,0,0);
    
    var next;
    if(r.last_generated_date){
      // Already generated - calculate next based on last + frequency
      next=new Date(r.last_generated_date);
      if(r.frequency==="weekly")next.setDate(next.getDate()+7);
      else if(r.frequency==="monthly")next.setMonth(next.getMonth()+1);
      else if(r.frequency==="quarterly")next.setMonth(next.getMonth()+3);
      else if(r.frequency==="yearly")next.setFullYear(next.getFullYear()+1);
    }else{
      // Never generated - first due is start date OR if start is in past, show next scheduled
      next=new Date(startDate);
      // Keep advancing while next is in the past (auto-gen would have created these)
      while(next<today){
        if(r.frequency==="weekly")next.setDate(next.getDate()+7);
        else if(r.frequency==="monthly")next.setMonth(next.getMonth()+1);
        else if(r.frequency==="quarterly")next.setMonth(next.getMonth()+3);
        else if(r.frequency==="yearly")next.setFullYear(next.getFullYear()+1);
        else break;
      }
    }
    return next.toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"});
  };
  
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",zIndex:9400,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
    <div style={{background:"#fafaf5",color:"#1a1208",borderRadius:14,maxWidth:640,width:"100%",maxHeight:"96vh",overflow:"hidden",display:"flex",flexDirection:"column",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
      <div style={{background:"linear-gradient(135deg,#7c3aed,#a855f7)",color:"#fff",padding:"15px 20px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <p style={{fontSize:11,opacity:.85,fontWeight:700,letterSpacing:2}}>FINANCE</p>
          <h2 style={{fontSize:18,fontWeight:700}}>{String.fromCharCode(0xD83D,0xDD04)} Recurring Expenses</h2>
        </div>
        <button onClick={onClose} style={{width:34,height:34,borderRadius:"50%",background:"rgba(255,255,255,.15)",color:"#fff",border:"none",cursor:"pointer",fontSize:16,fontWeight:700}}>x</button>
      </div>
      
      <div style={{flex:1,overflowY:"auto",padding:18}}>
        {!showAdd?<>
          <div style={{padding:11,background:"#f5f3ff",borderRadius:9,marginBottom:11,fontSize:11,color:"#7c3aed",borderLeft:"4px solid #7c3aed"}}>
            <p style={{fontWeight:700,marginBottom:3}}>{String.fromCharCode(0x2139,0xFE0F)} How recurring works:</p>
            <p>These templates auto-create expenses on schedule. Visit Finance tab to trigger generation.</p>
          </div>
          
          <button onClick={startAdd} style={{width:"100%",padding:"12px",background:"linear-gradient(135deg,#7c3aed,#a855f7)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer",marginBottom:11}}>{String.fromCharCode(0x2B)} Add Recurring Expense</button>
          
          {items.length===0?<p style={{textAlign:"center",color:"#8a8078",fontStyle:"italic",fontSize:12,padding:20}}>No recurring expenses yet. Add rent, internet, insurance etc to auto-generate them.</p>:
            <div>
              {items.map(r=>{
                var cat=categories.find(c=>c.id===r.category_id);
                return <div key={r.id} style={{padding:11,border:"2px solid #ede8de",borderRadius:9,marginBottom:6,borderLeft:"5px solid "+(r.active?(cat?.color||"#7c3aed"):"#9ca3af"),opacity:r.active?1:.6}}>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <span style={{fontSize:24}}>{cat?.icon||String.fromCharCode(0xD83D,0xDD04)}</span>
                    <div style={{flex:1,minWidth:0}}>
                      <p style={{fontSize:13,fontWeight:700}}>{r.description}</p>
                      <p style={{fontSize:11,color:"#8a8078"}}>{r.category_name} - {fmt(r.amount)} - {r.frequency}{r.frequency==="monthly"?" (day "+r.day_of_month+")":""}</p>
                      <p style={{fontSize:10,color:"#7c3aed",fontWeight:700}}>Next due: {computeNextDue(r)}</p>
                    </div>
                  </div>
                  <div style={{display:"flex",gap:5,marginTop:7,flexWrap:"wrap"}}>
                    <button onClick={()=>pauseRec(r)} style={{padding:"5px 9px",background:r.active?"#fef3c7":"#d1fae5",color:r.active?"#92400e":"#047857",border:"none",borderRadius:5,fontSize:10,fontWeight:700,cursor:"pointer"}}>{r.active?String.fromCharCode(0x23F8,0xFE0F)+" Pause":String.fromCharCode(0x25B6,0xFE0F)+" Resume"}</button>
                    <button onClick={()=>startEdit(r)} style={{padding:"5px 9px",background:"#fef3c7",color:"#92400e",border:"none",borderRadius:5,fontSize:10,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0x270F,0xFE0F)} Edit</button>
                    <button onClick={()=>deleteRec(r)} style={{padding:"5px 9px",background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:5,fontSize:10,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0xD83D,0xDDD1,0xFE0F)} Delete</button>
                  </div>
                </div>;
              })}
            </div>
          }
        </>:<>
          <h3 style={{fontSize:14,fontWeight:700,marginBottom:11}}>{editing?"Edit Recurring":"New Recurring"}</h3>
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>DESCRIPTION</p>
          <input value={form.description} onChange={e=>setForm({...form,description:e.target.value})} placeholder="e.g., Monthly rent" autoFocus style={{width:"100%",padding:"11px",border:"2px solid #ede8de",borderRadius:7,fontSize:13,marginBottom:11,boxSizing:"border-box"}}/>
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>AMOUNT</p>
          <input type="number" step="0.01" value={form.amount} onChange={e=>setForm({...form,amount:e.target.value})} placeholder="0.00" style={{width:"100%",padding:"13px",border:"3px solid #7c3aed",borderRadius:7,fontSize:20,fontWeight:700,fontFamily:"'Courier New',monospace",textAlign:"right",marginBottom:11,boxSizing:"border-box"}}/>
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>CATEGORY</p>
          <select value={form.categoryId} onChange={e=>setForm({...form,categoryId:e.target.value})} className="field" style={{padding:"11px",fontSize:13,marginBottom:11}}>
            {categories.filter(c=>c.active!==false).map(c=><option key={c.id} value={c.id}>{c.icon} {c.name}</option>)}
          </select>
          
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:7,marginBottom:11}}>
            <div>
              <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>FREQUENCY</p>
              <select value={form.frequency} onChange={e=>setForm({...form,frequency:e.target.value})} className="field" style={{padding:"11px",fontSize:13}}>
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
                <option value="quarterly">Quarterly</option>
                <option value="yearly">Yearly</option>
              </select>
            </div>
            {form.frequency==="monthly"&&<div>
              <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>DAY OF MONTH</p>
              <input type="number" min="1" max="28" value={form.dayOfMonth} onChange={e=>setForm({...form,dayOfMonth:e.target.value})} className="field" style={{padding:"11px",fontSize:13}}/>
            </div>}
          </div>
          
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:7,marginBottom:11}}>
            <div>
              <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>START DATE</p>
              <input type="date" value={form.startDate} onChange={e=>setForm({...form,startDate:e.target.value})} className="field" style={{padding:"11px",fontSize:13}}/>
            </div>
            <div>
              <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>END DATE (OPTIONAL)</p>
              <input type="date" value={form.endDate} onChange={e=>setForm({...form,endDate:e.target.value})} className="field" style={{padding:"11px",fontSize:13}}/>
            </div>
          </div>
          
          <div style={{display:"flex",gap:6}}>
            <button onClick={()=>{setShowAdd(false);setEditing(null);}} style={{flex:1,padding:"13px",background:"#fff",border:"2px solid #ede8de",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>Cancel</button>
            <button onClick={saveRec} style={{flex:2,padding:"13px",background:"linear-gradient(135deg,#7c3aed,#a855f7)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>{String.fromCharCode(0x2713)} Save</button>
          </div>
        </>}
      </div>
    </div>
  </div>;
}

// ============================================================
// PROFIT & LOSS STATEMENT - HMRC compliant format
// ============================================================
function PLStatement({orders,expenses,fromDate,toDate,branch,onClose}){
  // Calculate income breakdown
  var periodOrders=(orders||[]).filter(o=>{
    try{
      var dateStr=o.created_at||o.placedAt||o.createdAt;
      if(!dateStr)return false;
      var d=new Date(dateStr).toISOString().split("T")[0];
      return d>=fromDate&&d<=toDate&&o.status!=="cancelled";
    }catch(e){return false;}
  });
  
  // Income by type
  var incomeByType={};
  periodOrders.forEach(o=>{
    var t=o.type||"other";
    if(!incomeByType[t])incomeByType[t]=0;
    incomeByType[t]+=parseFloat(o.total||0);
  });
  
  var grossIncome=periodOrders.reduce((s,o)=>s+parseFloat(o.total||0),0);
  
  // Calculate VAT (if enabled)
  var s=getReceiptSettings();
  var vatExtracted=0;
  var netIncome=grossIncome;
  if(s.showVAT){
    vatExtracted=grossIncome*(s.vatRate/(100+s.vatRate));
    netIncome=grossIncome-vatExtracted;
  }
  
  // Expenses by category
  var expensesByCategory={};
  (expenses||[]).forEach(e=>{
    var cat=e.category_name||"Other";
    if(!expensesByCategory[cat])expensesByCategory[cat]=0;
    expensesByCategory[cat]+=parseFloat(e.amount||0);
  });
  var totalExpenses=Object.values(expensesByCategory).reduce((s,v)=>s+v,0);
  var sortedExp=Object.entries(expensesByCategory).sort((a,b)=>b[1]-a[1]);
  
  var grossProfit=netIncome-totalExpenses;
  var profitMargin=netIncome>0?(grossProfit/netIncome)*100:0;
  
  var fromStr=new Date(fromDate).toLocaleDateString("en-GB",{day:"numeric",month:"long",year:"numeric"});
  var toStr=new Date(toDate).toLocaleDateString("en-GB",{day:"numeric",month:"long",year:"numeric"});
  var generatedStr=new Date().toLocaleString("en-GB",{day:"numeric",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit"});
  
  var printPL=()=>{
    var w=window.open("","_blank","width=900,height=1200");if(!w)return;
    var incomeRows=Object.entries(incomeByType).map(([t,v])=>{
      var label=t.charAt(0).toUpperCase()+t.slice(1).replace("-"," ");
      return `<tr><td style="padding:5px 14px;padding-left:30px">${label}</td><td style="padding:5px 14px;text-align:right">${fmt(v)}</td></tr>`;
    }).join("");
    var expRows=sortedExp.map(([cat,amt])=>`<tr><td style="padding:5px 14px;padding-left:30px">${cat}</td><td style="padding:5px 14px;text-align:right">${fmt(amt)}</td></tr>`).join("");
    var js="window.onload=function(){window.print()}";
    w.document.write(`<!DOCTYPE html><html><head><title>P&L ${fromDate} to ${toDate}</title><style>
      body{font-family:Arial,sans-serif;padding:36px;color:#1a1208;max-width:760px;margin:0 auto;font-size:14px}
      h1{color:#1a1208;margin:0;font-size:28px;letter-spacing:2px}
      h2{font-size:18px;margin:18px 0 6px;color:#1a1208;border-bottom:2px solid #1a1208;padding-bottom:4px;letter-spacing:1px}
      .header{text-align:center;border-bottom:4px solid #1a1208;padding-bottom:18px;margin-bottom:22px}
      .header p{margin:3px 0;color:#666;font-size:12px}
      .period{background:#fef3c7;padding:10px 16px;border-radius:8px;margin:14px 0;text-align:center;font-size:14px;font-weight:700;color:#92400e}
      table{width:100%;border-collapse:collapse;margin:9px 0}
      td{padding:5px 14px}
      .section{background:#f7f3ee;font-weight:700;font-size:14px}
      .total-row{border-top:2px solid #1a1208;border-bottom:2px solid #1a1208;background:#1a1208;color:#fff;font-weight:700;font-size:15px}
      .total-row td{padding:9px 14px}
      .profit-row{border:3px solid #d4952a;background:#fffbeb;font-size:18px;font-weight:700;color:#d4952a}
      .profit-row td{padding:11px 14px}
      .loss-row{border:3px solid #dc2626;background:#fef2f2;font-size:18px;font-weight:700;color:#dc2626}
      .footer{margin-top:36px;padding-top:14px;border-top:1px solid #ccc;text-align:center;color:#666;font-size:11px}
    </style></head><body>
      <div class="header">
        <h1>PROFIT & LOSS STATEMENT</h1>
        <p><b>${branch?.name||"La Tavola"}</b></p>
        ${branch?`<p>${branch.addr||""}</p>`:""}
        <p>Generated: ${generatedStr}</p>
      </div>
      
      <div class="period"><b>Reporting Period:</b> ${fromStr} - ${toStr}</div>
      
      <h2>INCOME</h2>
      <table>
        <tr class="section"><td colspan="2">Sales by Order Type</td></tr>
        ${incomeRows||'<tr><td colspan="2" style="padding:11px;text-align:center;color:#666;font-style:italic">No sales in this period</td></tr>'}
        ${s.showVAT?`<tr style="background:#f5f5f5"><td style="padding:7px 14px;padding-left:30px"><b>Gross Sales</b></td><td style="padding:7px 14px;text-align:right"><b>${fmt(grossIncome)}</b></td></tr>
        <tr><td style="padding:5px 14px;padding-left:30px;color:#666">Less: VAT @ ${s.vatRate}%</td><td style="padding:5px 14px;text-align:right;color:#666">(${fmt(vatExtracted)})</td></tr>`:""}
        <tr class="total-row"><td>NET INCOME</td><td style="text-align:right">${fmt(netIncome)}</td></tr>
      </table>
      
      <h2>EXPENSES</h2>
      <table>
        <tr class="section"><td colspan="2">Operating Expenses</td></tr>
        ${expRows||'<tr><td colspan="2" style="padding:11px;text-align:center;color:#666;font-style:italic">No expenses recorded</td></tr>'}
        <tr class="total-row"><td>TOTAL EXPENSES</td><td style="text-align:right">${fmt(totalExpenses)}</td></tr>
      </table>
      
      <h2>RESULT</h2>
      <table>
        <tr><td style="padding:7px 14px">Net Income</td><td style="padding:7px 14px;text-align:right">${fmt(netIncome)}</td></tr>
        <tr><td style="padding:7px 14px">Less: Total Expenses</td><td style="padding:7px 14px;text-align:right">(${fmt(totalExpenses)})</td></tr>
        <tr class="${grossProfit>=0?"profit-row":"loss-row"}"><td>${grossProfit>=0?"NET PROFIT":"NET LOSS"}</td><td style="text-align:right">${grossProfit>=0?fmt(grossProfit):"("+fmt(Math.abs(grossProfit))+")"}</td></tr>
        <tr><td style="padding:7px 14px;font-size:12px;color:#666">Profit Margin</td><td style="padding:7px 14px;text-align:right;font-size:12px;color:#666">${profitMargin.toFixed(1)}%</td></tr>
      </table>
      
      <div class="footer">
        <p><b>Notes:</b></p>
        <p style="text-align:left;margin:6px 0">- Income figures based on completed orders only (excludes cancelled/refunded)</p>
        ${s.showVAT?'<p style="text-align:left;margin:6px 0">- VAT extracted at standard UK rate of '+s.vatRate+'%</p>':""}
        <p style="text-align:left;margin:6px 0">- This statement is for management purposes only</p>
        <p style="margin-top:14px;font-style:italic">For HMRC submissions, please use authorised accounting software</p>
      </div>
    </body></html>`);
    var sc=w.document.createElement("script");sc.textContent=js;w.document.body.appendChild(sc);
    w.document.close();
  };
  
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",zIndex:9400,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
    <div style={{background:"#fafaf5",color:"#1a1208",borderRadius:14,maxWidth:700,width:"100%",maxHeight:"96vh",overflow:"hidden",display:"flex",flexDirection:"column",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
      <div style={{background:"linear-gradient(135deg,#1a1208,#3d2e22)",color:"#fff",padding:"15px 20px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <p style={{fontSize:11,opacity:.85,fontWeight:700,letterSpacing:2}}>FINANCE</p>
          <h2 style={{fontSize:18,fontWeight:700}}>{String.fromCharCode(0xD83D,0xDCCA)} Profit & Loss Statement</h2>
        </div>
        <button onClick={onClose} style={{width:34,height:34,borderRadius:"50%",background:"rgba(255,255,255,.15)",color:"#fff",border:"none",cursor:"pointer",fontSize:16,fontWeight:700}}>x</button>
      </div>
      
      <div style={{flex:1,overflowY:"auto",padding:20}}>
        {/* Period header */}
        <div style={{padding:14,background:"#fef3c7",borderRadius:9,marginBottom:18,textAlign:"center"}}>
          <p style={{fontSize:11,color:"#92400e",fontWeight:700,letterSpacing:2,marginBottom:3}}>REPORTING PERIOD</p>
          <p style={{fontSize:14,fontWeight:700,color:"#92400e"}}>{fromStr} - {toStr}</p>
        </div>
        
        {/* INCOME SECTION */}
        <div style={{marginBottom:22}}>
          <h3 style={{fontSize:14,fontWeight:700,marginBottom:9,paddingBottom:5,borderBottom:"2px solid #1a1208",letterSpacing:1}}>{String.fromCharCode(0xD83D,0xDCB0)} INCOME</h3>
          <table style={{width:"100%",fontSize:13}}>
            <tbody>
              <tr style={{background:"#f7f3ee"}}><td colSpan="2" style={{padding:"6px 11px",fontWeight:700,fontSize:12}}>Sales by Order Type</td></tr>
              {Object.entries(incomeByType).length===0?<tr><td colSpan="2" style={{padding:11,textAlign:"center",color:"#8a8078",fontStyle:"italic"}}>No sales in this period</td></tr>:
                Object.entries(incomeByType).map(([t,v])=><tr key={t}><td style={{padding:"5px 14px",paddingLeft:30}}>{t.charAt(0).toUpperCase()+t.slice(1).replace("-"," ")}</td><td style={{padding:"5px 14px",textAlign:"right",fontFamily:"'Courier New',monospace"}}>{fmt(v)}</td></tr>)
              }
              {s.showVAT&&<>
                <tr style={{background:"#f5f5f5"}}><td style={{padding:"7px 14px",paddingLeft:30,fontWeight:700}}>Gross Sales</td><td style={{padding:"7px 14px",textAlign:"right",fontWeight:700,fontFamily:"'Courier New',monospace"}}>{fmt(grossIncome)}</td></tr>
                <tr><td style={{padding:"5px 14px",paddingLeft:30,color:"#8a8078"}}>Less: VAT @ {s.vatRate}%</td><td style={{padding:"5px 14px",textAlign:"right",color:"#8a8078",fontFamily:"'Courier New',monospace"}}>({fmt(vatExtracted)})</td></tr>
              </>}
              <tr style={{borderTop:"2px solid #1a1208",borderBottom:"2px solid #1a1208",background:"#1a1208",color:"#fff"}}>
                <td style={{padding:"9px 14px",fontWeight:700,letterSpacing:1}}>NET INCOME</td>
                <td style={{padding:"9px 14px",textAlign:"right",fontWeight:700,fontFamily:"'Courier New',monospace",fontSize:15}}>{fmt(netIncome)}</td>
              </tr>
            </tbody>
          </table>
        </div>
        
        {/* EXPENSES SECTION */}
        <div style={{marginBottom:22}}>
          <h3 style={{fontSize:14,fontWeight:700,marginBottom:9,paddingBottom:5,borderBottom:"2px solid #1a1208",letterSpacing:1}}>{String.fromCharCode(0xD83D,0xDCB8)} EXPENSES</h3>
          <table style={{width:"100%",fontSize:13}}>
            <tbody>
              <tr style={{background:"#f7f3ee"}}><td colSpan="2" style={{padding:"6px 11px",fontWeight:700,fontSize:12}}>Operating Expenses</td></tr>
              {sortedExp.length===0?<tr><td colSpan="2" style={{padding:11,textAlign:"center",color:"#8a8078",fontStyle:"italic"}}>No expenses recorded</td></tr>:
                sortedExp.map(([cat,amt])=><tr key={cat}><td style={{padding:"5px 14px",paddingLeft:30}}>{cat}</td><td style={{padding:"5px 14px",textAlign:"right",fontFamily:"'Courier New',monospace"}}>{fmt(amt)}</td></tr>)
              }
              <tr style={{borderTop:"2px solid #1a1208",borderBottom:"2px solid #1a1208",background:"#1a1208",color:"#fff"}}>
                <td style={{padding:"9px 14px",fontWeight:700,letterSpacing:1}}>TOTAL EXPENSES</td>
                <td style={{padding:"9px 14px",textAlign:"right",fontWeight:700,fontFamily:"'Courier New',monospace",fontSize:15}}>{fmt(totalExpenses)}</td>
              </tr>
            </tbody>
          </table>
        </div>
        
        {/* RESULT */}
        <div>
          <h3 style={{fontSize:14,fontWeight:700,marginBottom:9,paddingBottom:5,borderBottom:"2px solid #1a1208",letterSpacing:1}}>{String.fromCharCode(0xD83D,0xDCC8)} RESULT</h3>
          <table style={{width:"100%",fontSize:13}}>
            <tbody>
              <tr><td style={{padding:"7px 14px"}}>Net Income</td><td style={{padding:"7px 14px",textAlign:"right",fontFamily:"'Courier New',monospace"}}>{fmt(netIncome)}</td></tr>
              <tr><td style={{padding:"7px 14px"}}>Less: Total Expenses</td><td style={{padding:"7px 14px",textAlign:"right",fontFamily:"'Courier New',monospace"}}>({fmt(totalExpenses)})</td></tr>
              <tr style={{border:"3px solid "+(grossProfit>=0?"#d4952a":"#dc2626"),background:grossProfit>=0?"#fffbeb":"#fef2f2"}}>
                <td style={{padding:"11px 14px",fontWeight:700,fontSize:16,letterSpacing:1,color:grossProfit>=0?"#d4952a":"#dc2626"}}>{grossProfit>=0?"NET PROFIT":"NET LOSS"}</td>
                <td style={{padding:"11px 14px",textAlign:"right",fontWeight:700,fontSize:18,fontFamily:"'Courier New',monospace",color:grossProfit>=0?"#d4952a":"#dc2626"}}>{grossProfit>=0?fmt(grossProfit):"("+fmt(Math.abs(grossProfit))+")"}</td>
              </tr>
              <tr><td style={{padding:"5px 14px",fontSize:11,color:"#8a8078"}}>Profit Margin</td><td style={{padding:"5px 14px",textAlign:"right",fontSize:11,color:"#8a8078"}}>{profitMargin.toFixed(1)}%</td></tr>
            </tbody>
          </table>
        </div>
      </div>
      
      <div style={{padding:11,background:"#fff",borderTop:"1px solid #ede8de",display:"flex",gap:6}}>
        <button onClick={onClose} style={{flex:1,padding:"13px",background:"#fff",border:"2px solid #ede8de",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>Close</button>
        <button onClick={printPL} style={{flex:2,padding:"13px",background:"linear-gradient(135deg,#1a1208,#3d2e22)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>{String.fromCharCode(0xD83D,0xDDA8,0xFE0F)} Print P&L Statement</button>
      </div>
    </div>
  </div>;
}

// ============================================================
// STAFF MANAGEMENT MODULE
// ============================================================

// ============================================================
// STAFF PIN LOGIN MODAL
// ============================================================
// ============================================================
// LANGUAGE PICKER
// ============================================================
function LanguagePicker({compact}){
  var [open,setOpen]=useState(false);
  var [currentLang,setCurrentLang]=useState(getCurrentLanguage());
  var ref=useRef();
  
  useEffect(()=>{
    var handler=(e)=>{
      if(ref.current&&!ref.current.contains(e.target))setOpen(false);
    };
    document.addEventListener("mousedown",handler);
    return ()=>document.removeEventListener("mousedown",handler);
  },[]);
  
  var pickLang=(code)=>{
    setLanguage(code);
    setCurrentLang(code);
    setOpen(false);
    // Force re-render of whole app
    window.dispatchEvent(new Event("languagechange-custom"));
  };
  
  var info=LANGUAGES[currentLang]||LANGUAGES.en;
  
  return <div ref={ref} style={{position:"relative",display:"inline-block"}}>
    <button onClick={()=>setOpen(!open)} style={{padding:compact?"5px 9px":"7px 12px",background:"rgba(255,255,255,.1)",color:"#fff",border:"1px solid rgba(255,255,255,.2)",borderRadius:7,fontSize:compact?11:12,fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",gap:5}}>
      <span style={{fontSize:compact?13:15}}>{info.flag}</span>
      <span>{info.native}</span>
      <span style={{fontSize:9,opacity:.7}}>{open?String.fromCharCode(0x25B2):String.fromCharCode(0x25BC)}</span>
    </button>
    {open && <div style={{position:"fixed",top:"50%",left:"50%",transform:"translate(-50%,-50%)",background:"#fff",border:"2px solid #ede8de",borderRadius:14,boxShadow:"0 20px 60px rgba(0,0,0,.4)",zIndex:99999,width:300,maxWidth:"90vw",maxHeight:"80vh",overflow:"hidden",display:"flex",flexDirection:"column"}}>
      <div style={{padding:"14px 16px",background:"linear-gradient(135deg,#1a1208,#3d2e22)",color:"#fff",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <p style={{fontSize:14,fontWeight:700}}>{String.fromCharCode(0xD83C,0xDF10)} Choose Language</p>
        <button onClick={()=>setOpen(false)} style={{background:"rgba(255,255,255,.15)",border:"none",color:"#fff",width:28,height:28,borderRadius:"50%",cursor:"pointer",fontSize:14,fontWeight:700}}>{String.fromCharCode(0x00D7)}</button>
      </div>
      <div style={{overflowY:"auto",flex:1}}>
      {Object.keys(LANGUAGES).map(code=>{
        var lang=LANGUAGES[code];
        var isCurrent=code===currentLang;
        return <button key={code} onClick={()=>pickLang(code)} style={{width:"100%",padding:"13px 16px",background:isCurrent?"#fef3c7":"#fff",color:isCurrent?"#92400e":"#1a1208",border:"none",cursor:"pointer",display:"flex",alignItems:"center",gap:11,fontSize:14,textAlign:"left",borderBottom:"1px solid #ede8de"}} onMouseOver={e=>{if(!isCurrent)e.currentTarget.style.background="#f7f3ee";}} onMouseOut={e=>{if(!isCurrent)e.currentTarget.style.background="#fff";}}>
          <span style={{fontSize:22}}>{lang.flag}</span>
          <div style={{flex:1}}>
            <p style={{fontWeight:700,fontSize:14}}>{lang.native}</p>
            <p style={{fontSize:11,color:"#8a8078"}}>{lang.name}</p>
          </div>
          {isCurrent && <span style={{color:"#22c55e",fontSize:18,fontWeight:700}}>{String.fromCharCode(0x2713)}</span>}
        </button>;
      })}
      </div>
    </div>}
    {open && <div onClick={()=>setOpen(false)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.5)",zIndex:99998}}/>}
  </div>;
}

function StaffPINLoginModal({onSuccess, onCancel, allowSkip}){
  var [pin, setPin] = useState("");
  var [error, setError] = useState("");
  var [verifying, setVerifying] = useState(false);
  
  var handleNumber = (n)=>{
    setError("");
    if(pin.length<4){
      var newPin = pin+n;
      setPin(newPin);
      if(newPin.length===4){
        setTimeout(()=>verifyPin(newPin), 100);
      }
    }
  };
  
  var handleBackspace = ()=>{
    setError("");
    setPin(pin.slice(0,-1));
  };
  
  var handleClear = ()=>{
    setError("");
    setPin("");
  };
  
  var verifyPin = async (pinToCheck)=>{
    setVerifying(true);
    var result = await dbVerifyStaffPIN(pinToCheck);
    setVerifying(false);
    
    if(result.error){
      setError(result.error);
      setPin("");
      return;
    }
    
    if(result.staff){
      dbSetActiveStaff(result.staff);
      onSuccess&&onSuccess(result.staff);
    }
  };
  
  var btnStyle = {
    padding:"18px 0",
    fontSize:24,
    fontWeight:700,
    background:"#fff",
    border:"2px solid #ede8de",
    borderRadius:11,
    cursor:"pointer",
    color:"#1a1208",
  };
  
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
    <div className="card" style={{width:"100%",maxWidth:380,padding:22}}>
      <h2 style={{fontSize:22,fontWeight:700,textAlign:"center",marginBottom:7}}>{String.fromCharCode(0xD83D,0xDD10)} Staff Login</h2>
      <p style={{fontSize:13,color:"#8a8078",textAlign:"center",marginBottom:18}}>Enter your 4-digit PIN</p>
      
      {/* PIN Display */}
      <div style={{display:"flex",justifyContent:"center",gap:9,marginBottom:18}}>
        {[0,1,2,3].map(i=><div key={i} style={{width:50,height:60,background:pin.length>i?"#bf4626":"#f7f3ee",border:"2px solid "+(pin.length>i?"#bf4626":"#ede8de"),borderRadius:9,display:"flex",alignItems:"center",justifyContent:"center",fontSize:30,color:"#fff"}}>{pin.length>i?String.fromCharCode(0x25CF):""}</div>)}
      </div>
      
      {error && <p style={{textAlign:"center",color:"#dc2626",fontSize:13,fontWeight:700,marginBottom:11,padding:7,background:"#fee2e2",borderRadius:7}}>{String.fromCharCode(0x274C)} {error}</p>}
      {verifying && <p style={{textAlign:"center",color:"#22c55e",fontSize:13,fontWeight:700,marginBottom:11}}>Verifying...</p>}
      
      {/* Number Pad */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:9,marginBottom:11}}>
        {[1,2,3,4,5,6,7,8,9].map(n=><button key={n} onClick={()=>handleNumber(String(n))} disabled={verifying} style={btnStyle}>{n}</button>)}
        <button onClick={handleClear} disabled={verifying} style={{...btnStyle,fontSize:14,color:"#8a8078"}}>C</button>
        <button onClick={()=>handleNumber("0")} disabled={verifying} style={btnStyle}>0</button>
        <button onClick={handleBackspace} disabled={verifying} style={{...btnStyle,fontSize:18}}>{String.fromCharCode(0x232B)}</button>
      </div>
      
      {/* Skip option (for restaurant owner) */}
      {allowSkip && <button onClick={onCancel} style={{width:"100%",padding:"11px",background:"#fff",border:"2px solid #ede8de",borderRadius:7,fontWeight:700,cursor:"pointer",color:"#8a8078",fontSize:12}}>Continue as Owner (no PIN)</button>}
    </div>
  </div>;
}

// ============================================================
// ACTIVE STAFF BANNER (shows who is logged in)
// ============================================================
function ActiveStaffBanner({activeStaff, onSwitchUser, onLogout}){
  if(!activeStaff) return null;
  
  var posColor = {manager:"#7c3aed",waiter:"#0891b2",chef:"#d97706",driver:"#059669",kitchen:"#dc2626",bar:"#ec4899",cleaner:"#6b7280"}[activeStaff.position] || "#1a1208";
  
  // Build a readable list of what this staff CAN do
  var p=activeStaff.permissions||{};
  var allowed=[];
  if(p.take_orders!==false)allowed.push("Orders");
  if(p.view_reports===true)allowed.push("Reports");
  if(p.view_finance===true)allowed.push("Finance");
  if(p.manage_menu===true)allowed.push("Menu");
  if(p.manage_staff===true)allowed.push("Staff");
  if(p.manage_settings===true)allowed.push("Settings");
  if(p.process_refunds===true)allowed.push("Refunds");
  var accessText=allowed.length>0?allowed.join(", "):"No access set";
  
  return <div style={{background:posColor,color:"#fff",padding:"7px 14px",display:"flex",justifyContent:"space-between",alignItems:"center",fontSize:12,fontWeight:700,flexWrap:"wrap",gap:7}}>
    <div style={{display:"flex",alignItems:"center",gap:9}}>
      <div style={{width:28,height:28,borderRadius:"50%",background:"rgba(255,255,255,.25)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:700}}>
        {activeStaff.full_name.charAt(0).toUpperCase()}
      </div>
      <div>
        <p>{activeStaff.full_name}</p>
        <p style={{fontSize:10,opacity:.85}}><span style={{textTransform:"capitalize"}}>{activeStaff.position}</span> {String.fromCharCode(0x2022)} Access: {accessText}</p>
      </div>
    </div>
    <div style={{display:"flex",gap:5}}>
      <button onClick={onSwitchUser} style={{padding:"5px 11px",background:"rgba(255,255,255,.2)",color:"#fff",border:"1px solid rgba(255,255,255,.3)",borderRadius:5,fontSize:11,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0xD83D,0xDD04)} Switch</button>
      <button onClick={onLogout} style={{padding:"5px 11px",background:"rgba(255,255,255,.2)",color:"#fff",border:"1px solid rgba(255,255,255,.3)",borderRadius:5,fontSize:11,fontWeight:700,cursor:"pointer"}}>Logout</button>
    </div>
  </div>;
}


// ============================================================
// MARKETING CENTER - SMS & Email campaigns + credits
// ============================================================
function MarketingCenter({restaurant, branch, push}){
  var [credits,setCredits]=useState({sms_credits:0,email_credits:0,sms_purchased:0,email_purchased:0,sms_used:0,email_used:0});
  var [campaigns,setCampaigns]=useState([]);
  var [purchases,setPurchases]=useState([]);
  var [loading,setLoading]=useState(true);
  var [campaignType,setCampaignType]=useState("sms");
  var [showBuyModal,setShowBuyModal]=useState(null); // 'sms' or 'email'
  var [showCampaignBuilder,setShowCampaignBuilder]=useState(false);
  
  var loadData=()=>{
    setLoading(true);
    Promise.all([
      dbFetchCredits(),
      dbFetchCampaigns(),
      dbFetchPurchases(),
    ]).then(([cr,camps,purchs])=>{
      setCredits(cr||{sms_credits:0,email_credits:0});
      setCampaigns(camps||[]);
      setPurchases(purchs||[]);
      setLoading(false);
    });
  };
  
  useEffect(()=>{loadData();},[]);
  
  if(loading)return <div style={{padding:30,textAlign:"center",color:"#8a8078"}}>Loading marketing center...</div>;
  
  return <div>
    {/* Header */}
    <div style={{background:"linear-gradient(135deg,#7c2d12,#9333ea,#7c3aed)",borderRadius:14,padding:"18px 22px",marginBottom:14,color:"#fff",position:"relative",overflow:"hidden"}}>
      <div style={{position:"absolute",top:-20,right:-20,width:120,height:120,borderRadius:"50%",background:"radial-gradient(circle,rgba(255,255,255,.15),transparent 70%)"}}></div>
      <div style={{position:"relative",zIndex:1}}>
        <p style={{fontSize:10,color:"#fbbf24",letterSpacing:2.5,fontWeight:700,marginBottom:4}}>{String.fromCharCode(0xD83D,0xDCE3)} MARKETING CENTER</p>
        <h2 style={{fontSize:22,fontWeight:700,fontFamily:"Georgia,serif"}}>Grow Your Business</h2>
        <p style={{fontSize:12,opacity:.85}}>Send SMS & Email campaigns to your customers</p>
      </div>
    </div>
    
    {/* Credit Cards */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",gap:11,marginBottom:14}}>
      {/* SMS Credits Card */}
      <div style={{background:"linear-gradient(135deg,#1e40af,#2563eb)",borderRadius:14,padding:16,color:"#fff",position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",top:11,right:13,fontSize:40,opacity:.2}}>{String.fromCharCode(0xD83D,0xDCF1)}</div>
        <p style={{fontSize:10,letterSpacing:2,fontWeight:700,opacity:.8,marginBottom:5}}>SMS CREDITS</p>
        <p style={{fontSize:36,fontWeight:700,marginBottom:5}}>{credits.sms_credits||0}</p>
        <p style={{fontSize:11,opacity:.85,marginBottom:11}}>{credits.sms_used||0} used {String.fromCharCode(0x2022)} {credits.sms_purchased||0} total purchased</p>
        <button onClick={()=>setShowBuyModal("sms")} style={{padding:"9px 16px",background:"rgba(255,255,255,.2)",color:"#fff",border:"1px solid rgba(255,255,255,.3)",borderRadius:7,fontSize:12,fontWeight:700,cursor:"pointer"}}>+ Buy SMS Credits</button>
      </div>
      
      {/* Email Credits Card */}
      <div style={{background:"linear-gradient(135deg,#059669,#10b981)",borderRadius:14,padding:16,color:"#fff",position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",top:11,right:13,fontSize:40,opacity:.2}}>{String.fromCharCode(0xD83D,0xDCE7)}</div>
        <p style={{fontSize:10,letterSpacing:2,fontWeight:700,opacity:.8,marginBottom:5}}>EMAIL CREDITS</p>
        <p style={{fontSize:36,fontWeight:700,marginBottom:5}}>{credits.email_credits||0}</p>
        <p style={{fontSize:11,opacity:.85,marginBottom:11}}>{credits.email_used||0} used {String.fromCharCode(0x2022)} {credits.email_purchased||0} total purchased</p>
        <button onClick={()=>setShowBuyModal("email")} style={{padding:"9px 16px",background:"rgba(255,255,255,.2)",color:"#fff",border:"1px solid rgba(255,255,255,.3)",borderRadius:7,fontSize:12,fontWeight:700,cursor:"pointer"}}>+ Buy Email Credits</button>
      </div>
    </div>
    
    {/* Quick Actions */}
    <div className="card" style={{padding:16,marginBottom:14}}>
      <p style={{fontSize:14,fontWeight:700,marginBottom:11}}>{String.fromCharCode(0x26A1)} Create Campaign</p>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:9}}>
        <button onClick={()=>{setCampaignType("sms");setShowCampaignBuilder(true);}} disabled={credits.sms_credits<=0} style={{padding:"14px 16px",background:credits.sms_credits>0?"linear-gradient(135deg,#1e40af,#2563eb)":"#9ca3af",color:"#fff",border:"none",borderRadius:9,fontSize:14,fontWeight:700,cursor:credits.sms_credits>0?"pointer":"not-allowed",display:"flex",alignItems:"center",gap:9}}>
          <span style={{fontSize:22}}>{String.fromCharCode(0xD83D,0xDCF1)}</span>
          <div style={{textAlign:"left"}}>
            <p>New SMS Campaign</p>
            <p style={{fontSize:10,opacity:.85,fontWeight:500}}>Reach customers via text</p>
          </div>
        </button>
        <button onClick={()=>{setCampaignType("email");setShowCampaignBuilder(true);}} disabled={credits.email_credits<=0} style={{padding:"14px 16px",background:credits.email_credits>0?"linear-gradient(135deg,#059669,#10b981)":"#9ca3af",color:"#fff",border:"none",borderRadius:9,fontSize:14,fontWeight:700,cursor:credits.email_credits>0?"pointer":"not-allowed",display:"flex",alignItems:"center",gap:9}}>
          <span style={{fontSize:22}}>{String.fromCharCode(0xD83D,0xDCE7)}</span>
          <div style={{textAlign:"left"}}>
            <p>New Email Campaign</p>
            <p style={{fontSize:10,opacity:.85,fontWeight:500}}>Send beautiful emails</p>
          </div>
        </button>
      </div>
      {(credits.sms_credits<=0||credits.email_credits<=0)&&<p style={{fontSize:11,color:"#92400e",marginTop:9,padding:9,background:"#fef3c7",borderRadius:7}}>{String.fromCharCode(0xD83D,0xDCA1)} Buy credits to enable campaign sending</p>}
    </div>
    
    {/* Campaign History */}
    <div className="card" style={{padding:16,marginBottom:14}}>
      <p style={{fontSize:14,fontWeight:700,marginBottom:11}}>{String.fromCharCode(0xD83D,0xDCCB)} Campaign History</p>
      {campaigns.length===0?<div style={{padding:30,textAlign:"center"}}>
        <div style={{fontSize:48,marginBottom:9}}>{String.fromCharCode(0xD83D,0xDCE3)}</div>
        <p style={{fontSize:14,fontWeight:700,marginBottom:5}}>No campaigns yet</p>
        <p style={{fontSize:12,color:"#8a8078"}}>Create your first SMS or Email campaign above to start engaging customers!</p>
      </div>:
      <div style={{display:"flex",flexDirection:"column",gap:7}}>
        {campaigns.map(c=><div key={c.id} style={{padding:11,background:"#fafaf5",borderRadius:7,border:"1px solid #ede8de",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:9}}>
          <div style={{flex:1,minWidth:180}}>
            <div style={{display:"flex",gap:7,alignItems:"center",marginBottom:3}}>
              <span style={{fontSize:14}}>{c.type==="sms"?String.fromCharCode(0xD83D,0xDCF1):String.fromCharCode(0xD83D,0xDCE7)}</span>
              <p style={{fontSize:13,fontWeight:700}}>{c.name}</p>
              <span style={{padding:"2px 7px",background:c.status==="sent"?"#d1fae5":c.status==="sending"?"#fef3c7":c.status==="draft"?"#e0e7ff":"#fee2e2",color:c.status==="sent"?"#059669":c.status==="sending"?"#92400e":c.status==="draft"?"#3730a3":"#dc2626",borderRadius:9,fontSize:9,fontWeight:700,textTransform:"uppercase"}}>{c.status}</span>
            </div>
            <p style={{fontSize:11,color:"#8a8078"}}>{c.recipient_count||0} recipients {String.fromCharCode(0x2022)} {c.sent_count||0} sent {String.fromCharCode(0x2022)} \u00A3{parseFloat(c.estimated_cost||0).toFixed(2)} cost</p>
            <p style={{fontSize:10,color:"#8a8078",marginTop:3}}>{new Date(c.created_at).toLocaleDateString()} {String.fromCharCode(0x2022)} {c.audience_type}</p>
          </div>
          {c.status==="draft"&&<button onClick={async()=>{
            if(!window.confirm("Delete this draft campaign?"))return;
            await dbDeleteCampaign(c.id);
            loadData();
          }} style={{padding:"5px 11px",background:"#fee2e2",color:"#dc2626",border:"1px solid #dc2626",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>Delete</button>}
        </div>)}
      </div>}
    </div>
    
    {/* Purchase History */}
    {purchases.length>0&&<div className="card" style={{padding:16}}>
      <p style={{fontSize:14,fontWeight:700,marginBottom:11}}>{String.fromCharCode(0xD83D,0xDCB3)} Credit Purchase History</p>
      <div style={{display:"flex",flexDirection:"column",gap:7}}>
        {purchases.slice(0,5).map(p=><div key={p.id} style={{padding:9,background:"#fafaf5",borderRadius:7,display:"flex",justifyContent:"space-between",alignItems:"center",border:"1px solid #ede8de",flexWrap:"wrap",gap:7}}>
          <div>
            <p style={{fontSize:13,fontWeight:700}}>{p.amount} {p.type==="sms"?"SMS":"Email"} credits {p.package_name?"("+p.package_name+")":""}</p>
            <p style={{fontSize:11,color:"#8a8078"}}>{new Date(p.created_at).toLocaleDateString()} {String.fromCharCode(0x2022)} {p.payment_method||"manual"}</p>
          </div>
          <div style={{textAlign:"right"}}>
            <p style={{fontSize:14,fontWeight:700,color:"#059669"}}>\u00A3{parseFloat(p.price).toFixed(2)}</p>
            <span style={{padding:"2px 7px",background:p.payment_status==="completed"?"#d1fae5":"#fef3c7",color:p.payment_status==="completed"?"#059669":"#92400e",borderRadius:9,fontSize:9,fontWeight:700,textTransform:"uppercase"}}>{p.payment_status}</span>
          </div>
        </div>)}
      </div>
    </div>}
    
    {/* BUY CREDITS MODAL */}
    {showBuyModal&&<BuyCreditsModal type={showBuyModal} onClose={()=>setShowBuyModal(null)} onSuccess={()=>{setShowBuyModal(null);loadData();}} push={push}/>}
    
    {/* CAMPAIGN BUILDER */}
    {showCampaignBuilder&&<CampaignBuilder type={campaignType} credits={credits} restaurant={restaurant} branch={branch} push={push} onClose={()=>{setShowCampaignBuilder(false);loadData();}}/>}
  </div>;
}

// ============================================================
// BUY CREDITS MODAL - with Stripe + Manual payment
// ============================================================
function BuyCreditsModal({type,onClose,onSuccess,push}){
  var packages=type==="sms"?SMS_PACKAGES:EMAIL_PACKAGES;
  var [buying,setBuying]=useState(false);
  var [selectedPkg,setSelectedPkg]=useState(null);
  var [paymentMethod,setPaymentMethod]=useState("stripe"); // 'stripe' or 'manual'
  var [manualRef,setManualRef]=useState("");
  
  var handlePackageSelect=(pkg)=>{
    setSelectedPkg(pkg);
  };
  
  var handlePayWithStripe=async()=>{
    if(!selectedPkg)return;
    setBuying(true);
    var result=await dbStripeCheckout(selectedPkg.id);
    setBuying(false);
    if(result.error){
      if(window.showAlert){
        window.showAlert("Payment setup failed",result.error.message+"\n\nMake sure Stripe Edge Function is deployed.","error");
      }else{
        alert("Failed: "+result.error.message);
      }
      return;
    }
    // Redirect to Stripe checkout
    window.location.href=result.data.url;
  };
  
  var handleManualPayment=async()=>{
    if(!selectedPkg)return;
    if(!manualRef.trim()){
      alert("Please enter your payment reference (e.g. bank transfer reference)");
      return;
    }
    setBuying(true);
    var result=await dbManualPayment(selectedPkg.id,manualRef.trim());
    setBuying(false);
    if(result.error){
      alert("Failed: "+result.error.message);
      return;
    }
    if(window.showAlert){
      window.showAlert(
        "Manual payment recorded",
        "Your payment request has been recorded with reference: "+manualRef+
        "\n\nCredits will be added once super admin approves your payment.\n\n"+
        "Please transfer £"+selectedPkg.price+" to:\n"+
        "Bank: [YOUR BANK NAME]\n"+
        "Account: [YOUR ACCOUNT]\n"+
        "Reference: "+manualRef,
        "info"
      );
    }
    push&&push({title:"Payment recorded",body:"Waiting for admin approval",color:"#d97706"});
    onSuccess();
  };
  
  return <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:18}}>
    <div onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:14,padding:22,maxWidth:680,width:"100%",maxHeight:"90vh",overflow:"auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
        <div>
          <h2 style={{fontSize:22,fontWeight:700}}>{type==="sms"?String.fromCharCode(0xD83D,0xDCF1)+" Buy SMS Credits":String.fromCharCode(0xD83D,0xDCE7)+" Buy Email Credits"}</h2>
          <p style={{fontSize:12,color:"#8a8078"}}>Choose a package and payment method</p>
        </div>
        <button onClick={onClose} style={{background:"none",border:"none",fontSize:24,cursor:"pointer",color:"#8a8078"}}>{String.fromCharCode(0x00D7)}</button>
      </div>
      
      {/* STEP 1: Select Package */}
      {!selectedPkg&&<div>
        <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:11}}>STEP 1: CHOOSE PACKAGE</p>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:9}}>
          {packages.map(pkg=><div key={pkg.id} onClick={()=>handlePackageSelect(pkg)} style={{padding:16,background:pkg.recommended?"linear-gradient(135deg,#fef3c7,#fde68a)":"#fafaf5",borderRadius:11,border:"2px solid "+(pkg.recommended?"#f59e0b":"#ede8de"),position:"relative",cursor:"pointer",transition:"transform .15s"}} onMouseEnter={e=>e.currentTarget.style.transform="translateY(-2px)"} onMouseLeave={e=>e.currentTarget.style.transform="translateY(0)"}>
            {pkg.recommended&&<div style={{position:"absolute",top:-9,right:9,background:"#f59e0b",color:"#fff",fontSize:9,fontWeight:700,padding:"3px 9px",borderRadius:9}}>BEST VALUE</div>}
            <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>{pkg.name.toUpperCase()}</p>
            <p style={{fontSize:24,fontWeight:700,marginBottom:3}}>{pkg.credits.toLocaleString()}</p>
            <p style={{fontSize:11,color:"#8a8078",marginBottom:11}}>{type==="sms"?"SMS messages":"emails"}</p>
            <p style={{fontSize:20,fontWeight:700,color:"#bf4626",marginBottom:3}}>\u00A3{pkg.price}</p>
            <p style={{fontSize:10,color:"#8a8078"}}>\u00A3{(pkg.perUnit*100).toFixed(1)}p per {type==="sms"?"SMS":"email"}</p>
          </div>)}
        </div>
      </div>}
      
      {/* STEP 2: Choose Payment Method */}
      {selectedPkg&&<div>
        <div style={{padding:13,background:"linear-gradient(135deg,#fef3c7,#fde68a)",borderRadius:9,marginBottom:18,border:"2px solid #f59e0b"}}>
          <p style={{fontSize:11,fontWeight:700,color:"#92400e",letterSpacing:1}}>SELECTED PACKAGE</p>
          <p style={{fontSize:18,fontWeight:700,marginTop:3}}>{selectedPkg.credits.toLocaleString()} {type==="sms"?"SMS":"Email"} credits - £{selectedPkg.price}</p>
          <button onClick={()=>setSelectedPkg(null)} style={{padding:"5px 11px",marginTop:7,background:"transparent",color:"#92400e",border:"1px solid #f59e0b",borderRadius:5,fontSize:11,fontWeight:700,cursor:"pointer"}}>Change package</button>
        </div>
        
        <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:11}}>STEP 2: CHOOSE PAYMENT METHOD</p>
        
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))",gap:9,marginBottom:14}}>
          <label style={{padding:14,background:paymentMethod==="stripe"?"#dbeafe":"#fafaf5",borderRadius:9,border:"2px solid "+(paymentMethod==="stripe"?"#3b82f6":"#ede8de"),cursor:"pointer",display:"flex",alignItems:"center",gap:9}}>
            <input type="radio" checked={paymentMethod==="stripe"} onChange={()=>setPaymentMethod("stripe")} style={{width:18,height:18}}/>
            <div style={{flex:1}}>
              <p style={{fontWeight:700,fontSize:13}}>{String.fromCharCode(0xD83D,0xDCB3)} Credit/Debit Card</p>
              <p style={{fontSize:11,color:"#8a8078",marginTop:3}}>Instant - via Stripe (recommended)</p>
            </div>
          </label>
          <label style={{padding:14,background:paymentMethod==="manual"?"#dbeafe":"#fafaf5",borderRadius:9,border:"2px solid "+(paymentMethod==="manual"?"#3b82f6":"#ede8de"),cursor:"pointer",display:"flex",alignItems:"center",gap:9}}>
            <input type="radio" checked={paymentMethod==="manual"} onChange={()=>setPaymentMethod("manual")} style={{width:18,height:18}}/>
            <div style={{flex:1}}>
              <p style={{fontWeight:700,fontSize:13}}>{String.fromCharCode(0xD83C,0xDFE6)} Bank Transfer</p>
              <p style={{fontSize:11,color:"#8a8078",marginTop:3}}>Wait for admin approval</p>
            </div>
          </label>
        </div>
        
        {paymentMethod==="manual"&&<div style={{marginBottom:14}}>
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>YOUR REFERENCE</p>
          <input value={manualRef} onChange={e=>setManualRef(e.target.value)} placeholder="e.g. Your bank transfer reference" style={{width:"100%",padding:11,border:"2px solid #ede8de",borderRadius:7,fontSize:13,boxSizing:"border-box"}}/>
          <p style={{fontSize:11,color:"#8a8078",marginTop:5}}>{String.fromCharCode(0xD83D,0xDCA1)} Transfer \u00A3{selectedPkg.price} via Faster Payments. Admin will approve once confirmed.</p>
        </div>}
        
        <div style={{display:"flex",gap:9}}>
          <button onClick={()=>setSelectedPkg(null)} disabled={buying} style={{flex:1,padding:13,background:"#fff",color:"#1a1208",border:"2px solid #ede8de",borderRadius:9,fontSize:13,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0x2190)} Back</button>
          {paymentMethod==="stripe"?
            <button onClick={handlePayWithStripe} disabled={buying} style={{flex:2,padding:13,background:buying?"#9ca3af":"linear-gradient(135deg,#3b82f6,#1d4ed8)",color:"#fff",border:"none",borderRadius:9,fontSize:13,fontWeight:700,cursor:buying?"not-allowed":"pointer"}}>{buying?"Loading...":String.fromCharCode(0xD83D,0xDCB3)+" Pay £"+selectedPkg.price+" with Card"}</button>
            :
            <button onClick={handleManualPayment} disabled={buying||!manualRef.trim()} style={{flex:2,padding:13,background:buying||!manualRef.trim()?"#9ca3af":"linear-gradient(135deg,#059669,#10b981)",color:"#fff",border:"none",borderRadius:9,fontSize:13,fontWeight:700,cursor:buying||!manualRef.trim()?"not-allowed":"pointer"}}>{buying?"Submitting...":String.fromCharCode(0x2713)+" Submit Payment Request"}</button>
          }
        </div>
      </div>}
      
      <div style={{marginTop:14,padding:11,background:"#dbeafe",borderRadius:7,fontSize:11,color:"#1e40af"}}>
        <strong>{String.fromCharCode(0xD83D,0xDCA1)} About credits:</strong> Credits never expire. Bulk discounts available on larger packages. Manual payments require admin approval (usually within 24 hours).
      </div>
    </div>
  </div>;
}

// ============================================================
// CAMPAIGN BUILDER
// ============================================================
function CampaignBuilder({type,credits,restaurant,branch,push,onClose}){
  var [step,setStep]=useState(1); // 1=name, 2=audience, 3=message, 4=review
  var [name,setName]=useState("");
  var [subject,setSubject]=useState("");
  var [message,setMessage]=useState("");
  var [audienceType,setAudienceType]=useState("all");
  var [audienceCount,setAudienceCount]=useState(0);
  var [audienceList,setAudienceList]=useState([]);
  var [sending,setSending]=useState(false);
  
  // Load audience count when type changes
  useEffect(()=>{
    dbGetAudienceCount(audienceType,{}).then(c=>setAudienceCount(c||0));
    dbGetAudienceCustomers(audienceType,{},type).then(list=>setAudienceList(list||[]));
  },[audienceType,type]);
  
  var balance=type==="sms"?credits.sms_credits:credits.email_credits;
  var unitCost=type==="sms"?0.10:0.005;
  var totalCost=audienceList.length*unitCost;
  var canSend=audienceList.length>0&&audienceList.length<=balance&&message.trim()&&name.trim();
  
  var handleSend=async()=>{
    if(!canSend)return;
    if(!window.confirm("Send to "+audienceList.length+" recipients?\nThis will use "+audienceList.length+" credits."))return;
    
    setSending(true);
    
    // Create campaign
    var campResult=await dbCreateCampaign({
      name,
      type,
      subject:type==="email"?subject:null,
      message,
      audience_type:audienceType,
      recipient_count:audienceList.length,
      estimated_cost:totalCost,
    });
    
    if(campResult.error){
      alert("Failed to create campaign: "+campResult.error.message);
      setSending(false);
      return;
    }
    
    // Try REAL sending via edge function first, fall back to simulation
    var sendResult;
    try{
      if(type==="sms"){
        sendResult=await dbSendSmsReal(campResult.data.id,audienceList);
      }else{
        sendResult=await dbSendEmailReal(campResult.data.id,audienceList);
      }
      
      // If edge function returned error, fall back to simulation
      if(sendResult.error){
        console.warn("Edge function failed, falling back to simulation:",sendResult.error);
        sendResult=await dbSendCampaign(campResult.data.id,audienceList);
      }
    }catch(e){
      console.warn("Edge function error, simulating:",e);
      sendResult=await dbSendCampaign(campResult.data.id,audienceList);
    }
    
    setSending(false);
    
    if(sendResult.error){
      alert("Failed to send: "+sendResult.error.message);
      return;
    }
    
    var sentMsg=sendResult.data?.sent?
      sendResult.data.sent+" "+type+"s sent successfully!"+(sendResult.data.failed>0?" ("+sendResult.data.failed+" failed)":""):
      audienceList.length+" "+type+"s sending now";
    
    push&&push({title:"Campaign sent!",body:sentMsg,color:"#059669"});
    onClose();
  };
  
  return <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:18}}>
    <div onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:14,padding:22,maxWidth:580,width:"100%",maxHeight:"90vh",overflow:"auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:11}}>
        <h2 style={{fontSize:20,fontWeight:700}}>{type==="sms"?String.fromCharCode(0xD83D,0xDCF1)+" New SMS Campaign":String.fromCharCode(0xD83D,0xDCE7)+" New Email Campaign"}</h2>
        <button onClick={onClose} style={{background:"none",border:"none",fontSize:24,cursor:"pointer",color:"#8a8078"}}>{String.fromCharCode(0x00D7)}</button>
      </div>
      
      {/* Step indicator */}
      <div style={{display:"flex",gap:5,marginBottom:18}}>
        {[1,2,3,4].map(s=><div key={s} style={{flex:1,height:5,borderRadius:3,background:step>=s?"#bf4626":"#ede8de"}}></div>)}
      </div>
      
      {/* Step 1: Name */}
      {step===1&&<div>
        <p style={{fontSize:12,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>STEP 1 OF 4</p>
        <h3 style={{fontSize:16,fontWeight:700,marginBottom:11}}>What's the campaign name?</h3>
        <input value={name} onChange={e=>setName(e.target.value)} placeholder="e.g. Weekend Special, New Menu Launch" autoFocus style={{width:"100%",padding:13,border:"2px solid #ede8de",borderRadius:7,fontSize:14,boxSizing:"border-box",marginBottom:14}}/>
        <p style={{fontSize:11,color:"#8a8078",marginBottom:18}}>This is just for your records. Customers won't see this.</p>
        <button onClick={()=>setStep(2)} disabled={!name.trim()} style={{width:"100%",padding:13,background:name.trim()?"linear-gradient(135deg,#bf4626,#7c2d12)":"#9ca3af",color:"#fff",border:"none",borderRadius:9,fontSize:14,fontWeight:700,cursor:name.trim()?"pointer":"not-allowed"}}>Next: Choose Audience {String.fromCharCode(0x2192)}</button>
      </div>}
      
      {/* Step 2: Audience */}
      {step===2&&<div>
        <p style={{fontSize:12,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>STEP 2 OF 4</p>
        <h3 style={{fontSize:16,fontWeight:700,marginBottom:11}}>Who should receive this?</h3>
        <div style={{display:"flex",flexDirection:"column",gap:7,marginBottom:14}}>
          {[
            {id:"all",label:"All customers",desc:"Send to everyone who has registered"},
            {id:"recent",label:"Recent customers",desc:"Customers who ordered in last 30 days"},
            {id:"vip",label:"VIP customers",desc:"Customers with 10+ orders"},
          ].map(a=><label key={a.id} style={{padding:11,background:audienceType===a.id?"#fef3c7":"#fafaf5",borderRadius:7,border:"2px solid "+(audienceType===a.id?"#f59e0b":"#ede8de"),cursor:"pointer",display:"flex",alignItems:"center",gap:9}}>
            <input type="radio" checked={audienceType===a.id} onChange={()=>setAudienceType(a.id)} style={{width:18,height:18}}/>
            <div style={{flex:1}}>
              <p style={{fontWeight:700,fontSize:13}}>{a.label}</p>
              <p style={{fontSize:11,color:"#8a8078"}}>{a.desc}</p>
            </div>
          </label>)}
        </div>
        <div style={{padding:11,background:"#dbeafe",borderRadius:7,marginBottom:14}}>
          <p style={{fontSize:12,fontWeight:700,color:"#1e40af"}}>{String.fromCharCode(0xD83D,0xDCCA)} Audience preview</p>
          <p style={{fontSize:11,color:"#1e40af"}}>{audienceList.length} customers will receive this ({audienceCount} total in this group, but some may not have {type==="sms"?"phone":"email"})</p>
        </div>
        <div style={{display:"flex",gap:9}}>
          <button onClick={()=>setStep(1)} style={{flex:1,padding:13,background:"#fff",color:"#1a1208",border:"2px solid #ede8de",borderRadius:9,fontSize:14,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0x2190)} Back</button>
          <button onClick={()=>setStep(3)} disabled={audienceList.length===0} style={{flex:2,padding:13,background:audienceList.length>0?"linear-gradient(135deg,#bf4626,#7c2d12)":"#9ca3af",color:"#fff",border:"none",borderRadius:9,fontSize:14,fontWeight:700,cursor:audienceList.length>0?"pointer":"not-allowed"}}>Next: Write Message {String.fromCharCode(0x2192)}</button>
        </div>
      </div>}
      
      {/* Step 3: Message */}
      {step===3&&<div>
        <p style={{fontSize:12,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>STEP 3 OF 4</p>
        <h3 style={{fontSize:16,fontWeight:700,marginBottom:11}}>Write your {type==="sms"?"SMS":"email"}</h3>
        
        {type==="email"&&<div style={{marginBottom:11}}>
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>SUBJECT</p>
          <input value={subject} onChange={e=>setSubject(e.target.value)} placeholder="Subject line" style={{width:"100%",padding:11,border:"2px solid #ede8de",borderRadius:7,fontSize:13,boxSizing:"border-box"}}/>
        </div>}
        
        <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>MESSAGE</p>
        <textarea value={message} onChange={e=>setMessage(e.target.value)} placeholder={type==="sms"?"Hey [Name]! Get 20% off this weekend at "+(restaurant?.name||"our restaurant")+". Show this SMS to claim. Reply STOP to opt out.":"Write your email content here..."} rows={type==="sms"?4:8} style={{width:"100%",padding:11,border:"2px solid #ede8de",borderRadius:7,fontSize:13,boxSizing:"border-box",resize:"vertical",fontFamily:"inherit"}}/>
        <p style={{fontSize:10,color:"#8a8078",marginTop:5,marginBottom:14}}>{message.length}{type==="sms"?"/160 characters":" characters"} {type==="sms"&&message.length>160?String.fromCharCode(0x26A0,0xFE0F)+" Will be split into "+Math.ceil(message.length/160)+" messages":""}</p>
        
        <div style={{padding:11,background:"#dbeafe",borderRadius:7,marginBottom:14,fontSize:11,color:"#1e40af"}}>
          <strong>{String.fromCharCode(0xD83D,0xDCA1)} Tip:</strong> Use <code>[Name]</code> to personalize. Always include opt-out instructions for legal compliance ({type==="sms"?"\"Reply STOP\"":"\"Unsubscribe\""}).
        </div>
        
        <div style={{display:"flex",gap:9}}>
          <button onClick={()=>setStep(2)} style={{flex:1,padding:13,background:"#fff",color:"#1a1208",border:"2px solid #ede8de",borderRadius:9,fontSize:14,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0x2190)} Back</button>
          <button onClick={()=>setStep(4)} disabled={!message.trim()} style={{flex:2,padding:13,background:message.trim()?"linear-gradient(135deg,#bf4626,#7c2d12)":"#9ca3af",color:"#fff",border:"none",borderRadius:9,fontSize:14,fontWeight:700,cursor:message.trim()?"pointer":"not-allowed"}}>Next: Review {String.fromCharCode(0x2192)}</button>
        </div>
      </div>}
      
      {/* Step 4: Review & Send */}
      {step===4&&<div>
        <p style={{fontSize:12,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>STEP 4 OF 4 - REVIEW</p>
        <h3 style={{fontSize:16,fontWeight:700,marginBottom:14}}>Review & Send</h3>
        
        <div style={{display:"flex",flexDirection:"column",gap:9,marginBottom:14}}>
          <div style={{padding:11,background:"#fafaf5",borderRadius:7,border:"1px solid #ede8de"}}>
            <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3}}>CAMPAIGN NAME</p>
            <p style={{fontSize:13,fontWeight:700}}>{name}</p>
          </div>
          
          <div style={{padding:11,background:"#fafaf5",borderRadius:7,border:"1px solid #ede8de"}}>
            <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3}}>RECIPIENTS</p>
            <p style={{fontSize:13,fontWeight:700}}>{audienceList.length} customers ({audienceType})</p>
          </div>
          
          {type==="email"&&subject&&<div style={{padding:11,background:"#fafaf5",borderRadius:7,border:"1px solid #ede8de"}}>
            <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3}}>SUBJECT</p>
            <p style={{fontSize:13,fontWeight:700}}>{subject}</p>
          </div>}
          
          <div style={{padding:11,background:"#fafaf5",borderRadius:7,border:"1px solid #ede8de"}}>
            <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3}}>MESSAGE</p>
            <p style={{fontSize:12,whiteSpace:"pre-wrap"}}>{message}</p>
          </div>
          
          <div style={{padding:14,background:"linear-gradient(135deg,#fef3c7,#fde68a)",borderRadius:9,border:"2px solid #f59e0b"}}>
            <p style={{fontSize:11,color:"#92400e",fontWeight:700,letterSpacing:1,marginBottom:5}}>{String.fromCharCode(0xD83D,0xDCB0)} COST SUMMARY</p>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
              <span style={{fontSize:13}}>{audienceList.length} {type==="sms"?"SMS":"emails"} \u00D7 \u00A3{unitCost.toFixed(3)}</span>
              <span style={{fontSize:14,fontWeight:700}}>\u00A3{totalCost.toFixed(2)}</span>
            </div>
            <div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:"#92400e"}}>
              <span>Credits after sending</span>
              <span style={{fontWeight:700}}>{balance-audienceList.length} {type==="sms"?"SMS":"emails"}</span>
            </div>
          </div>
        </div>
        
        <div style={{display:"flex",gap:9}}>
          <button onClick={()=>setStep(3)} disabled={sending} style={{flex:1,padding:13,background:"#fff",color:"#1a1208",border:"2px solid #ede8de",borderRadius:9,fontSize:14,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0x2190)} Edit</button>
          <button onClick={handleSend} disabled={!canSend||sending} style={{flex:2,padding:13,background:canSend&&!sending?"linear-gradient(135deg,#059669,#10b981)":"#9ca3af",color:"#fff",border:"none",borderRadius:9,fontSize:14,fontWeight:700,cursor:canSend&&!sending?"pointer":"not-allowed"}}>{sending?"Sending...":String.fromCharCode(0xD83D,0xDE80)+" Send Campaign"}</button>
        </div>
      </div>}
    </div>
  </div>;
}

function StaffManagementTab({restaurant, branch, push}){
  var [view, setView] = useState("list"); // "list", "schedule", "timeclock", "payroll"
  var [staff, setStaff] = useState([]);
  var [loading, setLoading] = useState(true);
  var [editingStaff, setEditingStaff] = useState(null);
  var [showAddModal, setShowAddModal] = useState(false);
  var [searchTerm, setSearchTerm] = useState("");
  var [filterPosition, setFilterPosition] = useState("all");
  var [showInactive, setShowInactive] = useState(false);
  
  var loadStaff = ()=>{
    setLoading(true);
    dbFetchStaff(showInactive).then(data=>{
      setStaff(data || []);
      setLoading(false);
    });
  };
  
  useEffect(()=>{loadStaff();}, [showInactive]); // eslint-disable-line react-hooks/exhaustive-deps
  
  var handleSave = async (data)=>{
    var result;
    try{
      if(data.id){
        result = await dbUpdateStaff(data.id, data);
      } else {
        result = await dbCreateStaff(data);
      }
    }catch(e){
      console.error("Staff save exception:",e);
      if(window.showAlert)window.showAlert("Save Failed","Could not save staff: "+(e.message||"unknown error"),"error");
      return;
    }
    
    if(result.error){
      console.error("Staff save error:", result.error);
      if(window.showAlert)window.showAlert("Save Failed",(result.error.message||result.error.details||"Check the details and try again."),"error");
      else push&&push({title:"Failed", body:(result.error.message||"error")});
      return;
    }
    
    if(window.showAlert)window.showAlert(data.id?"Staff Updated":"Staff Added",(data.full_name||"Staff member")+" saved successfully.","success");
    else push&&push({title:data.id?"Staff updated":"Staff added", color:"#059669"});
    setEditingStaff(null);
    setShowAddModal(false);
    loadStaff();
  };
  
  var handleDelete = async (staffId, name)=>{
    if(!window.confirm("Remove "+name+" from staff?\n\nThey will be marked as terminated. Their records will be preserved.")) return;
    var result = await dbDeleteStaff(staffId, false);
    if(result.error){
      push&&push({title:"Delete failed", body:result.error.message});
      return;
    }
    push&&push({title:"Staff removed", color:"#059669"});
    loadStaff();
  };
  
  // Filter staff
  var filteredStaff = staff.filter(s=>{
    if(searchTerm && !s.full_name.toLowerCase().includes(searchTerm.toLowerCase())) return false;
    if(filterPosition!=="all" && s.position!==filterPosition) return false;
    return true;
  });
  
  // Quick stats
  var stats = {
    total: staff.length,
    active: staff.filter(s=>s.status==="active").length,
    drivers: staff.filter(s=>s.position==="driver").length,
    waiters: staff.filter(s=>s.position==="waiter").length,
    chefs: staff.filter(s=>s.position==="chef").length,
  };
  
  return <div>
    {/* Header */}
    <div className="card" style={{marginBottom:11, padding:14, background:"linear-gradient(135deg,#1a1208,#3d2e22)", color:"#fff"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:9}}>
        <div>
          <h3 style={{fontSize:18,fontWeight:700,marginBottom:3}}>{String.fromCharCode(0xD83D,0xDC65)} Staff Management</h3>
          <p style={{fontSize:12,opacity:.85}}>Manage employees, drivers, schedules, and payroll</p>
        </div>
        <button onClick={()=>setShowAddModal(true)} style={{padding:"10px 18px",background:"#22c55e",color:"#fff",border:"none",borderRadius:9,fontWeight:700,cursor:"pointer",fontSize:13}}>{String.fromCharCode(0x2795)} Add Staff</button>
      </div>
    </div>
    
    {/* Sub-navigation */}
    <div style={{display:"flex",gap:5,marginBottom:11,flexWrap:"wrap"}}>
      {[["list","Staff List"],["timeclock","Time Clock"],["schedule","Schedules"],["payroll","Payroll"]].map(t=>
        <button key={t[0]} onClick={()=>setView(t[0])} style={{padding:"8px 14px",background:view===t[0]?"#bf4626":"#fff",color:view===t[0]?"#fff":"#1a1208",border:"2px solid "+(view===t[0]?"#bf4626":"#ede8de"),borderRadius:7,cursor:"pointer",fontWeight:700,fontSize:12}}>{t[1]}</button>
      )}
    </div>
    
    {view==="list" && <>
      {/* Stats cards */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(110px,1fr))",gap:9,marginBottom:11}}>
        <div className="card" style={{padding:11,textAlign:"center"}}>
          <p style={{fontSize:24,fontWeight:700,color:"#bf4626"}}>{stats.total}</p>
          <p style={{fontSize:11,color:"#8a8078"}}>Total Staff</p>
        </div>
        <div className="card" style={{padding:11,textAlign:"center"}}>
          <p style={{fontSize:24,fontWeight:700,color:"#059669"}}>{stats.active}</p>
          <p style={{fontSize:11,color:"#8a8078"}}>Active</p>
        </div>
        <div className="card" style={{padding:11,textAlign:"center"}}>
          <p style={{fontSize:24,fontWeight:700,color:"#0891b2"}}>{stats.drivers}</p>
          <p style={{fontSize:11,color:"#8a8078"}}>Drivers</p>
        </div>
        <div className="card" style={{padding:11,textAlign:"center"}}>
          <p style={{fontSize:24,fontWeight:700,color:"#7c3aed"}}>{stats.waiters}</p>
          <p style={{fontSize:11,color:"#8a8078"}}>Waiters</p>
        </div>
        <div className="card" style={{padding:11,textAlign:"center"}}>
          <p style={{fontSize:24,fontWeight:700,color:"#d97706"}}>{stats.chefs}</p>
          <p style={{fontSize:11,color:"#8a8078"}}>Chefs</p>
        </div>
      </div>
      
      {/* Search & Filter */}
      <div style={{display:"flex",gap:7,marginBottom:11,flexWrap:"wrap"}}>
        <input value={searchTerm} onChange={e=>setSearchTerm(e.target.value)} placeholder="Search staff..." style={{flex:1,minWidth:180,padding:"9px 12px",border:"2px solid #ede8de",borderRadius:7,fontSize:13}}/>
        <select value={filterPosition} onChange={e=>setFilterPosition(e.target.value)} style={{padding:"9px 12px",border:"2px solid #ede8de",borderRadius:7,fontSize:13}}>
          <option value="all">All Positions</option>
          <option value="manager">Manager</option>
          <option value="waiter">Waiter</option>
          <option value="chef">Chef</option>
          <option value="driver">Driver</option>
          <option value="kitchen">Kitchen Staff</option>
          <option value="bar">Bar Staff</option>
          <option value="cleaner">Cleaner</option>
        </select>
        <label style={{display:"flex",alignItems:"center",gap:5,padding:"9px 12px",background:"#fff",border:"2px solid #ede8de",borderRadius:7,cursor:"pointer",fontSize:12}}>
          <input type="checkbox" checked={showInactive} onChange={e=>setShowInactive(e.target.checked)}/>
          Show Inactive
        </label>
      </div>
      
      {/* Staff list */}
      {loading ? <div className="card" style={{padding:30,textAlign:"center"}}>Loading...</div> :
       filteredStaff.length===0 ? <div className="card" style={{padding:30,textAlign:"center"}}>
         <p style={{fontSize:36,marginBottom:9}}>{String.fromCharCode(0xD83D,0xDC64)}</p>
         <p style={{fontSize:14,fontWeight:700,marginBottom:4}}>No staff yet</p>
         <p style={{fontSize:12,color:"#8a8078"}}>Click "Add Staff" to add your first team member</p>
       </div> :
       <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:9}}>
         {filteredStaff.map(s=>{
           var posIcon = {manager:String.fromCharCode(0xD83D,0xDC54),waiter:String.fromCharCode(0xD83C,0xDF7D,0xFE0F),chef:String.fromCharCode(0xD83D,0xDC68,0x200D,0xD83C,0xDF73),driver:String.fromCharCode(0xD83D,0xDEF5),kitchen:String.fromCharCode(0xD83C,0xDF73),bar:String.fromCharCode(0xD83C,0xDF78),cleaner:String.fromCharCode(0xD83E,0xDDF9)}[s.position] || String.fromCharCode(0xD83D,0xDC64);
           var posColor = {manager:"#7c3aed",waiter:"#0891b2",chef:"#d97706",driver:"#059669",kitchen:"#dc2626",bar:"#ec4899",cleaner:"#6b7280"}[s.position] || "#1a1208";
           return <div key={s.id} className="card" style={{padding:14,borderLeft:"4px solid "+posColor,opacity:s.status==="active"?1:.6}}>
             <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:9}}>
               <div style={{display:"flex",alignItems:"center",gap:9,flex:1}}>
                 <div style={{width:42,height:42,borderRadius:"50%",background:posColor,color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,fontWeight:700}}>
                   {s.full_name.charAt(0).toUpperCase()}
                 </div>
                 <div style={{flex:1,minWidth:0}}>
                   <p style={{fontSize:13,fontWeight:700,marginBottom:2}}>{s.full_name}</p>
                   <p style={{fontSize:11,color:posColor,fontWeight:700,textTransform:"capitalize"}}>{posIcon} {s.position}</p>
                 </div>
                 {s.status!=="active" && <span style={{padding:"2px 7px",background:"#fee2e2",color:"#dc2626",borderRadius:5,fontSize:9,fontWeight:700,textTransform:"uppercase"}}>{s.status}</span>}
               </div>
             </div>
             
             {s.phone && <p style={{fontSize:11,color:"#8a8078",marginBottom:3}}>{String.fromCharCode(0xD83D,0xDCDE)} {s.phone}</p>}
             {s.email && <p style={{fontSize:11,color:"#8a8078",marginBottom:3}}>{String.fromCharCode(0xD83D,0xDCE7)} {s.email}</p>}
             {s.employee_id && <p style={{fontSize:10,color:"#8a8078"}}>ID: {s.employee_id} {s.pin?"\u00B7 PIN: "+s.pin:""}</p>}
             
             {/* Compensation */}
             {(s.hourly_rate||s.monthly_salary) && <div style={{marginTop:7,padding:7,background:"#f7f3ee",borderRadius:5,fontSize:11}}>
               {s.payment_type==="hourly"&&s.hourly_rate ? <p><b>{"\u00A3"}{s.hourly_rate}/hr</b></p> : null}
               {s.payment_type==="salary"&&s.monthly_salary ? <p><b>{"\u00A3"}{s.monthly_salary}/month</b></p> : null}
             </div>}
             
             {/* Driver info */}
             {s.position==="driver" && s.vehicle_registration && <div style={{marginTop:7,padding:7,background:"#ecfdf5",borderRadius:5,fontSize:11}}>
               <p>{String.fromCharCode(0xD83D,0xDE97)} {s.vehicle_registration} {s.vehicle_make?"- "+s.vehicle_make:""}</p>
             </div>}
             
             {/* Actions */}
             <div style={{display:"flex",gap:5,marginTop:9}}>
               <button onClick={()=>setEditingStaff(s)} style={{flex:1,padding:"7px",fontSize:11,background:"#0891b2",color:"#fff",border:"none",borderRadius:5,cursor:"pointer",fontWeight:700}}>{String.fromCharCode(0x270F,0xFE0F)} Edit</button>
               {s.status==="active" && <button onClick={()=>handleDelete(s.id,s.full_name)} style={{padding:"7px 11px",fontSize:11,background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:5,cursor:"pointer",fontWeight:700}}>{String.fromCharCode(0xD83D,0xDDD1,0xFE0F)}</button>}
             </div>
           </div>;
         })}
       </div>
      }
    </>}
    
    {view==="timeclock" && <TimeClockView staff={staff.filter(s=>s.status==="active")} push={push}/>}
    {view==="schedule" && <SchedulesView staff={staff.filter(s=>s.status==="active")} push={push}/>}
    {view==="payroll" && <PayrollView staff={staff.filter(s=>s.status==="active")} push={push}/>}
    
    {/* Add/Edit Modal */}
    {(showAddModal || editingStaff) && <StaffFormModal 
      staff={editingStaff} 
      onClose={()=>{setShowAddModal(false); setEditingStaff(null);}} 
      onSave={handleSave}
    />}
  </div>;
}

// STAFF FORM MODAL - Add/Edit staff member
function StaffFormModal({staff, onClose, onSave}){
  var [form, setForm] = useState({
    id: staff?.id || null,
    full_name: staff?.full_name || "",
    email: staff?.email || "",
    phone: staff?.phone || "",
    address: staff?.address || "",
    postcode: staff?.postcode || "",
    date_of_birth: staff?.date_of_birth || "",
    emergency_contact_name: staff?.emergency_contact_name || "",
    emergency_contact_phone: staff?.emergency_contact_phone || "",
    national_insurance: staff?.national_insurance || "",
    position: staff?.position || "waiter",
    employee_id: staff?.employee_id || "",
    start_date: staff?.start_date || new Date().toISOString().split("T")[0],
    pin: staff?.pin || "",
    payment_type: staff?.payment_type || "hourly",
    hourly_rate: staff?.hourly_rate || "",
    monthly_salary: staff?.monthly_salary || "",
    payment_method: staff?.payment_method || "bank",
    bank_account: staff?.bank_account || "",
    bank_sort_code: staff?.bank_sort_code || "",
    permissions: staff?.permissions || {take_orders:true,view_reports:false,manage_menu:false,process_refunds:false,manage_staff:false,manage_settings:false,view_finance:false,export_customers:false},
    driver_license_number: staff?.driver_license_number || "",
    driver_license_expiry: staff?.driver_license_expiry || "",
    vehicle_make: staff?.vehicle_make || "",
    vehicle_model: staff?.vehicle_model || "",
    vehicle_registration: staff?.vehicle_registration || "",
    vehicle_color: staff?.vehicle_color || "",
    insurance_provider: staff?.insurance_provider || "",
    insurance_expiry: staff?.insurance_expiry || "",
    delivery_zone: staff?.delivery_zone || "",
    is_available_for_delivery: staff?.is_available_for_delivery !== false,
    status: staff?.status || "active",
    notes: staff?.notes || "",
  });
  var [saving, setSaving] = useState(false);
  var [section, setSection] = useState("personal"); // personal, employment, compensation, driver, permissions
  
  var handleSave = async ()=>{
    if(!form.full_name.trim()){alert("Full name is required"); return;}
    if(!form.position){alert("Position is required"); return;}
    
    setSaving(true);
    await onSave(form);
    setSaving(false);
  };
  
  var setField = (key, value)=>setForm(f=>({...f, [key]: value}));
  var setPerm = (key, value)=>setForm(f=>({...f, permissions: {...f.permissions, [key]: value}}));
  
  var inputStyle = {width:"100%",padding:"9px 11px",border:"2px solid #ede8de",borderRadius:7,fontSize:13,boxSizing:"border-box"};
  var labelStyle = {fontSize:11,fontWeight:700,color:"#1a1208",marginBottom:3,display:"block"};
  
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:14}} onClick={onClose}>
    <div onClick={e=>e.stopPropagation()} className="card" style={{width:"100%",maxWidth:600,maxHeight:"92vh",overflow:"auto",padding:18}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,paddingBottom:9,borderBottom:"2px solid #ede8de"}}>
        <h2 style={{fontSize:20,fontWeight:700}}>{staff?"Edit "+staff.full_name:"Add Staff Member"}</h2>
        <button onClick={onClose} style={{background:"none",border:"none",color:"#8a8078",fontSize:22,cursor:"pointer"}}>{String.fromCharCode(0x00D7)}</button>
      </div>
      
      {/* Section tabs */}
      <div style={{display:"flex",gap:5,marginBottom:14,flexWrap:"wrap"}}>
        {[["personal","Personal"],["employment","Employment"],["compensation","Pay"],["permissions","Access"]].concat(form.position==="driver"?[["driver","Vehicle"]]:[]).map(t=>
          <button key={t[0]} onClick={()=>setSection(t[0])} style={{padding:"6px 12px",background:section===t[0]?"#bf4626":"#fff",color:section===t[0]?"#fff":"#1a1208",border:"2px solid "+(section===t[0]?"#bf4626":"#ede8de"),borderRadius:5,cursor:"pointer",fontWeight:700,fontSize:11}}>{t[1]}</button>
        )}
      </div>
      
      {/* PERSONAL */}
      {section==="personal" && <div style={{display:"grid",gap:11}}>
        <div><label style={labelStyle}>FULL NAME *</label><input value={form.full_name} onChange={e=>setField("full_name",e.target.value)} style={inputStyle}/></div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9}}>
          <div><label style={labelStyle}>PHONE</label><input value={form.phone} onChange={e=>setField("phone",e.target.value)} style={inputStyle}/></div>
          <div><label style={labelStyle}>EMAIL</label><input value={form.email} onChange={e=>setField("email",e.target.value)} type="email" style={inputStyle}/></div>
        </div>
        <div><label style={labelStyle}>ADDRESS</label><input value={form.address} onChange={e=>setField("address",e.target.value)} style={inputStyle}/></div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9}}>
          <div><label style={labelStyle}>POSTCODE</label><input value={form.postcode} onChange={e=>setField("postcode",e.target.value.toUpperCase())} style={inputStyle}/></div>
          <div><label style={labelStyle}>DATE OF BIRTH</label><input type="date" value={form.date_of_birth} onChange={e=>setField("date_of_birth",e.target.value)} style={inputStyle}/></div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9}}>
          <div><label style={labelStyle}>EMERGENCY CONTACT NAME</label><input value={form.emergency_contact_name} onChange={e=>setField("emergency_contact_name",e.target.value)} style={inputStyle}/></div>
          <div><label style={labelStyle}>EMERGENCY PHONE</label><input value={form.emergency_contact_phone} onChange={e=>setField("emergency_contact_phone",e.target.value)} style={inputStyle}/></div>
        </div>
        <div><label style={labelStyle}>NATIONAL INSURANCE NO. (UK)</label><input value={form.national_insurance} onChange={e=>setField("national_insurance",e.target.value.toUpperCase())} placeholder="QQ123456C" style={inputStyle}/></div>
      </div>}
      
      {/* EMPLOYMENT */}
      {section==="employment" && <div style={{display:"grid",gap:11}}>
        <div><label style={labelStyle}>POSITION *</label>
          <select value={form.position} onChange={e=>setField("position",e.target.value)} style={inputStyle}>
            <option value="manager">Manager</option>
            <option value="waiter">Waiter / Server</option>
            <option value="chef">Chef / Head Chef</option>
            <option value="kitchen">Kitchen Staff</option>
            <option value="driver">Delivery Driver</option>
            <option value="bar">Bartender</option>
            <option value="cleaner">Cleaner</option>
          </select>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9}}>
          <div><label style={labelStyle}>EMPLOYEE ID</label><input value={form.employee_id} onChange={e=>setField("employee_id",e.target.value)} placeholder="Auto" style={inputStyle}/></div>
          <div><label style={labelStyle}>4-DIGIT PIN</label><input value={form.pin} onChange={e=>setField("pin",e.target.value.replace(/\D/g,"").slice(0,4))} placeholder="Auto" maxLength="4" style={inputStyle}/></div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9}}>
          <div><label style={labelStyle}>START DATE</label><input type="date" value={form.start_date} onChange={e=>setField("start_date",e.target.value)} style={inputStyle}/></div>
          <div><label style={labelStyle}>STATUS</label>
            <select value={form.status} onChange={e=>setField("status",e.target.value)} style={inputStyle}>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
              <option value="on_leave">On Leave</option>
              <option value="terminated">Terminated</option>
            </select>
          </div>
        </div>
        <div><label style={labelStyle}>NOTES</label><textarea value={form.notes} onChange={e=>setField("notes",e.target.value)} style={{...inputStyle,minHeight:60,resize:"vertical"}} placeholder="Any notes about this employee..."/></div>
      </div>}
      
      {/* COMPENSATION */}
      {section==="compensation" && <div style={{display:"grid",gap:11}}>
        <div><label style={labelStyle}>PAYMENT TYPE</label>
          <select value={form.payment_type} onChange={e=>setField("payment_type",e.target.value)} style={inputStyle}>
            <option value="hourly">Hourly</option>
            <option value="salary">Monthly Salary</option>
            <option value="commission">Commission</option>
          </select>
        </div>
        {form.payment_type==="hourly" && <div><label style={labelStyle}>HOURLY RATE ({"\u00A3"})</label><input type="number" step="0.50" value={form.hourly_rate} onChange={e=>setField("hourly_rate",e.target.value)} placeholder="11.50" style={inputStyle}/></div>}
        {form.payment_type==="salary" && <div><label style={labelStyle}>MONTHLY SALARY ({"\u00A3"})</label><input type="number" value={form.monthly_salary} onChange={e=>setField("monthly_salary",e.target.value)} placeholder="2500" style={inputStyle}/></div>}
        <div><label style={labelStyle}>PAYMENT METHOD</label>
          <select value={form.payment_method} onChange={e=>setField("payment_method",e.target.value)} style={inputStyle}>
            <option value="bank">Bank Transfer</option>
            <option value="cash">Cash</option>
            <option value="cheque">Cheque</option>
          </select>
        </div>
        {form.payment_method==="bank" && <>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9}}>
            <div><label style={labelStyle}>SORT CODE</label><input value={form.bank_sort_code} onChange={e=>setField("bank_sort_code",e.target.value)} placeholder="00-00-00" style={inputStyle}/></div>
            <div><label style={labelStyle}>ACCOUNT (last 4)</label><input value={form.bank_account} onChange={e=>setField("bank_account",e.target.value)} placeholder="****1234" style={inputStyle}/></div>
          </div>
        </>}
      </div>}
      
      {/* DRIVER */}
      {section==="driver" && form.position==="driver" && <div style={{display:"grid",gap:11}}>
        <div><label style={labelStyle}>DRIVING LICENSE NUMBER</label><input value={form.driver_license_number} onChange={e=>setField("driver_license_number",e.target.value.toUpperCase())} style={inputStyle}/></div>
        <div><label style={labelStyle}>LICENSE EXPIRY</label><input type="date" value={form.driver_license_expiry} onChange={e=>setField("driver_license_expiry",e.target.value)} style={inputStyle}/></div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9}}>
          <div><label style={labelStyle}>VEHICLE MAKE</label><input value={form.vehicle_make} onChange={e=>setField("vehicle_make",e.target.value)} placeholder="Honda" style={inputStyle}/></div>
          <div><label style={labelStyle}>VEHICLE MODEL</label><input value={form.vehicle_model} onChange={e=>setField("vehicle_model",e.target.value)} placeholder="PCX 125" style={inputStyle}/></div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9}}>
          <div><label style={labelStyle}>REGISTRATION</label><input value={form.vehicle_registration} onChange={e=>setField("vehicle_registration",e.target.value.toUpperCase())} placeholder="LX22 ABC" style={inputStyle}/></div>
          <div><label style={labelStyle}>COLOR</label><input value={form.vehicle_color} onChange={e=>setField("vehicle_color",e.target.value)} placeholder="Red" style={inputStyle}/></div>
        </div>
        <div><label style={labelStyle}>INSURANCE PROVIDER</label><input value={form.insurance_provider} onChange={e=>setField("insurance_provider",e.target.value)} style={inputStyle}/></div>
        <div><label style={labelStyle}>INSURANCE EXPIRY</label><input type="date" value={form.insurance_expiry} onChange={e=>setField("insurance_expiry",e.target.value)} style={inputStyle}/></div>
        <div><label style={labelStyle}>DELIVERY ZONE</label><input value={form.delivery_zone} onChange={e=>setField("delivery_zone",e.target.value)} placeholder="E.g. East London" style={inputStyle}/></div>
        <label style={{display:"flex",alignItems:"center",gap:7,padding:11,background:"#f7f3ee",borderRadius:7,cursor:"pointer"}}>
          <input type="checkbox" checked={form.is_available_for_delivery} onChange={e=>setField("is_available_for_delivery",e.target.checked)}/>
          <span>Available for delivery assignments</span>
        </label>
      </div>}
      
      {/* PERMISSIONS */}
      {section==="permissions" && <div style={{display:"grid",gap:11}}>
        <p style={{fontSize:12,color:"#8a8078",padding:9,background:"#fef3c7",borderRadius:7}}>{String.fromCharCode(0xD83D,0xDD11)} Control what this staff member can access</p>
        {[["take_orders","Take Orders","Place orders for customers"],["view_reports","View Reports","See sales reports & analytics"],["manage_menu","Manage Menu","Add/edit menu items"],["process_refunds","Process Refunds","Issue refunds to customers"],["manage_staff","Manage Staff","Add/edit other staff"],["view_finance","View Finance","See expenses & profit/loss"],["manage_settings","Manage Settings","Change restaurant settings"],["export_customers","Export Customer Data","Download customer contacts as CSV"]].map(p=>
          <label key={p[0]} style={{display:"flex",alignItems:"center",gap:9,padding:11,background:"#fff",border:"2px solid #ede8de",borderRadius:7,cursor:"pointer"}}>
            <input type="checkbox" checked={!!form.permissions[p[0]]} onChange={e=>setPerm(p[0],e.target.checked)}/>
            <div style={{flex:1}}>
              <p style={{fontSize:13,fontWeight:700}}>{p[1]}</p>
              <p style={{fontSize:11,color:"#8a8078"}}>{p[2]}</p>
            </div>
          </label>
        )}
      </div>}
      
      <div style={{display:"flex",gap:7,marginTop:18,paddingTop:14,borderTop:"2px solid #ede8de"}}>
        <button onClick={onClose} disabled={saving} style={{flex:1,padding:"11px",background:"#fff",border:"2px solid #ede8de",borderRadius:7,fontWeight:700,cursor:"pointer"}}>Cancel</button>
        <button onClick={handleSave} disabled={saving} style={{flex:2,padding:"11px",background:saving?"#8a8078":"#22c55e",color:"#fff",border:"none",borderRadius:7,fontWeight:700,cursor:saving?"not-allowed":"pointer"}}>{saving?"Saving...":(staff?"Save Changes":"Add Staff Member")}</button>
      </div>
    </div>
  </div>;
}

// TIME CLOCK VIEW
function TimeClockView({staff, push}){
  var [currentlyClocked, setCurrentlyClocked] = useState([]);
  var [records, setRecords] = useState([]);
  var [pinInput, setPinInput] = useState("");
  var [pinError, setPinError] = useState("");
  
  var loadData = ()=>{
    Promise.all([dbFetchCurrentClocked(), dbFetchClock(null, null, null)]).then(([cur, recs])=>{
      setCurrentlyClocked(cur || []);
      setRecords(recs || []);
    });
  };
  
  useEffect(()=>{loadData();},[]); // eslint-disable-line react-hooks/exhaustive-deps
  
  var handleClockToggle = async ()=>{
    setPinError("");
    var member = staff.find(s=>s.pin===pinInput);
    if(!member){
      setPinError("Invalid PIN");
      return;
    }
    
    // Check if already clocked in
    var alreadyIn = currentlyClocked.find(c=>c.employee_id===member.id);
    
    var result;
    if(alreadyIn){
      // Clock out
      result = await dbStaffClockOut(member.id, 0);
      if(result.error){
        push&&push({title:"Error",body:result.error.message});
        return;
      }
      push&&push({title:member.full_name+" clocked out",body:"Hours: "+result.data.total_hours,color:"#dc2626"});
    } else {
      // Clock in
      result = await dbStaffClockIn(member.id);
      if(result.error){
        push&&push({title:"Error",body:result.error.message});
        return;
      }
      push&&push({title:member.full_name+" clocked in",color:"#059669"});
    }
    
    setPinInput("");
    loadData();
  };
  
  return <div>
    {/* Clock in/out form */}
    <div className="card" style={{padding:18,marginBottom:14,background:"linear-gradient(135deg,#22c55e,#16a34a)",color:"#fff"}}>
      <h3 style={{fontSize:16,fontWeight:700,marginBottom:11}}>{String.fromCharCode(0x23F0)} Clock In / Out</h3>
      <div style={{display:"flex",gap:9,maxWidth:400}}>
        <input type="password" value={pinInput} onChange={e=>setPinInput(e.target.value.replace(/\D/g,"").slice(0,4))} onKeyPress={e=>e.key==="Enter"&&handleClockToggle()} placeholder="Enter your 4-digit PIN" maxLength="4" style={{flex:1,padding:"11px",borderRadius:7,border:"2px solid rgba(255,255,255,.3)",background:"rgba(255,255,255,.15)",color:"#fff",fontSize:18,letterSpacing:9,textAlign:"center",fontWeight:700}}/>
        <button onClick={handleClockToggle} disabled={pinInput.length!==4} style={{padding:"11px 22px",background:"#fff",color:"#22c55e",border:"none",borderRadius:7,fontWeight:700,cursor:pinInput.length===4?"pointer":"not-allowed",opacity:pinInput.length===4?1:.5}}>Clock In/Out</button>
      </div>
      {pinError && <p style={{marginTop:7,color:"#fee2e2",fontSize:13}}>{pinError}</p>}
    </div>
    
    {/* Currently clocked in */}
    <div style={{marginBottom:14}}>
      <h4 style={{fontSize:14,fontWeight:700,marginBottom:9,color:"#22c55e"}}>{String.fromCharCode(0xD83D,0xDFE2)} Currently Working ({currentlyClocked.length})</h4>
      {currentlyClocked.length===0 ? <div className="card" style={{padding:14,textAlign:"center",color:"#8a8078",fontSize:12}}>No one is currently clocked in</div> :
       <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:7}}>
         {currentlyClocked.map(c=>{
           var hours = ((new Date() - new Date(c.clock_in))/3600000).toFixed(1);
           return <div key={c.id} className="card" style={{padding:11,borderLeft:"4px solid #22c55e"}}>
             <p style={{fontSize:13,fontWeight:700}}>{c.employees?.full_name || "Unknown"}</p>
             <p style={{fontSize:11,color:"#8a8078"}}>{c.employees?.position}</p>
             <p style={{fontSize:11,color:"#22c55e",marginTop:5}}>In since {new Date(c.clock_in).toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"})} ({hours}h)</p>
           </div>;
         })}
       </div>
      }
    </div>
    
    {/* Recent records */}
    <div>
      <h4 style={{fontSize:14,fontWeight:700,marginBottom:9}}>Recent Clock Records</h4>
      {records.length===0 ? <div className="card" style={{padding:14,textAlign:"center",color:"#8a8078",fontSize:12}}>No records yet</div> :
       <div className="card" style={{padding:0,overflow:"hidden"}}>
         <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
           <thead>
             <tr style={{background:"#f7f3ee"}}>
               <th style={{padding:9,textAlign:"left"}}>Staff</th>
               <th style={{padding:9,textAlign:"left"}}>Date</th>
               <th style={{padding:9,textAlign:"left"}}>In</th>
               <th style={{padding:9,textAlign:"left"}}>Out</th>
               <th style={{padding:9,textAlign:"right"}}>Hours</th>
             </tr>
           </thead>
           <tbody>
             {records.slice(0,20).map(r=><tr key={r.id} style={{borderTop:"1px solid #ede8de"}}>
               <td style={{padding:9}}>{r.employees?.full_name || "?"}</td>
               <td style={{padding:9,color:"#8a8078"}}>{new Date(r.clock_in).toLocaleDateString()}</td>
               <td style={{padding:9}}>{new Date(r.clock_in).toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"})}</td>
               <td style={{padding:9}}>{r.clock_out?new Date(r.clock_out).toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"}):<span style={{color:"#22c55e",fontWeight:700}}>Active</span>}</td>
               <td style={{padding:9,textAlign:"right",fontWeight:700}}>{r.total_hours||"-"}</td>
             </tr>)}
           </tbody>
         </table>
       </div>
      }
    </div>
  </div>;
}

// SCHEDULES VIEW (simple version)
function SchedulesView({staff, push}){
  var [schedules, setSchedules] = useState([]);
  var [weekStart, setWeekStart] = useState(()=>{
    var d = new Date();
    d.setDate(d.getDate() - d.getDay() + 1); // Monday
    return d.toISOString().split("T")[0];
  });
  var [showModal, setShowModal] = useState(false);
  var [editingSchedule, setEditingSchedule] = useState(null);
  
  var loadSchedules = ()=>{
    var weekEnd = new Date(weekStart);
    weekEnd.setDate(weekEnd.getDate() + 6);
    dbFetchSchedules2(weekStart, weekEnd.toISOString().split("T")[0]).then(data=>setSchedules(data||[]));
  };
  
  useEffect(()=>{loadSchedules();}, [weekStart]); // eslint-disable-line react-hooks/exhaustive-deps
  
  var weekDays = [];
  for(var i=0;i<7;i++){
    var d = new Date(weekStart);
    d.setDate(d.getDate() + i);
    weekDays.push(d.toISOString().split("T")[0]);
  }
  
  var handleSave = async (data)=>{
    var result = await dbSaveSchedule2(data);
    if(result.error){push&&push({title:"Failed",body:result.error.message});return;}
    push&&push({title:"Schedule saved",color:"#059669"});
    setShowModal(false);
    setEditingSchedule(null);
    loadSchedules();
  };
  
  var handleDelete = async (id)=>{
    if(!window.confirm("Delete this schedule?")) return;
    await dbDeleteSchedule2(id);
    loadSchedules();
  };
  
  return <div>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:11,flexWrap:"wrap",gap:9}}>
      <div style={{display:"flex",gap:7,alignItems:"center"}}>
        <button onClick={()=>{var d=new Date(weekStart);d.setDate(d.getDate()-7);setWeekStart(d.toISOString().split("T")[0]);}} style={{padding:"7px 14px",background:"#fff",border:"2px solid #ede8de",borderRadius:7,cursor:"pointer",fontWeight:700}}>{String.fromCharCode(0x2190)} Prev</button>
        <p style={{fontSize:13,fontWeight:700}}>Week of {new Date(weekStart).toLocaleDateString()}</p>
        <button onClick={()=>{var d=new Date(weekStart);d.setDate(d.getDate()+7);setWeekStart(d.toISOString().split("T")[0]);}} style={{padding:"7px 14px",background:"#fff",border:"2px solid #ede8de",borderRadius:7,cursor:"pointer",fontWeight:700}}>Next {String.fromCharCode(0x2192)}</button>
      </div>
      <button onClick={()=>{setEditingSchedule(null);setShowModal(true);}} style={{padding:"9px 16px",background:"#22c55e",color:"#fff",border:"none",borderRadius:7,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0x2795)} Add Shift</button>
    </div>
    
    {/* Week grid */}
    <div className="card" style={{padding:0,overflow:"auto"}}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",minWidth:700}}>
        {weekDays.map((day,i)=>{
          var daySchedules = schedules.filter(s=>s.schedule_date===day);
          var dayName = new Date(day).toLocaleDateString([],{weekday:"short"});
          var dayNum = new Date(day).getDate();
          return <div key={day} style={{borderRight:i<6?"1px solid #ede8de":"none",minHeight:200}}>
            <div style={{padding:9,background:"#f7f3ee",textAlign:"center",borderBottom:"2px solid #ede8de"}}>
              <p style={{fontSize:11,color:"#8a8078",fontWeight:700,textTransform:"uppercase"}}>{dayName}</p>
              <p style={{fontSize:18,fontWeight:700}}>{dayNum}</p>
            </div>
            <div style={{padding:5}}>
              {daySchedules.length===0 ? <p style={{textAlign:"center",color:"#ccc",fontSize:11,padding:9}}>No shifts</p> :
               daySchedules.map(s=>
                 <div key={s.id} onClick={()=>{setEditingSchedule(s);setShowModal(true);}} style={{padding:7,marginBottom:5,background:"#ecfdf5",borderLeft:"3px solid #22c55e",borderRadius:4,cursor:"pointer",fontSize:11}}>
                   <p style={{fontWeight:700}}>{s.employees?.full_name||"?"}</p>
                   <p style={{color:"#8a8078"}}>{s.shift_start?.slice(0,5)} - {s.shift_end?.slice(0,5)}</p>
                 </div>
               )
              }
            </div>
          </div>;
        })}
      </div>
    </div>
    
    {showModal && <ScheduleModal schedule={editingSchedule} staff={staff} onClose={()=>{setShowModal(false);setEditingSchedule(null);}} onSave={handleSave} onDelete={handleDelete}/>}
  </div>;
}

// SCHEDULE MODAL
function ScheduleModal({schedule, staff, onClose, onSave, onDelete}){
  var [form, setForm] = useState({
    id: schedule?.id || null,
    employee_id: schedule?.employee_id || (staff[0]?.id || ""),
    schedule_date: schedule?.schedule_date || new Date().toISOString().split("T")[0],
    shift_start: schedule?.shift_start || "09:00",
    shift_end: schedule?.shift_end || "17:00",
    break_minutes: schedule?.break_minutes || 30,
    notes: schedule?.notes || "",
  });
  
  var inputStyle = {width:"100%",padding:"9px 11px",border:"2px solid #ede8de",borderRadius:7,fontSize:13,boxSizing:"border-box"};
  
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:14}} onClick={onClose}>
    <div onClick={e=>e.stopPropagation()} className="card" style={{width:"100%",maxWidth:440,padding:18}}>
      <h3 style={{fontSize:17,fontWeight:700,marginBottom:14}}>{schedule?"Edit Shift":"Add Shift"}</h3>
      
      <div style={{display:"grid",gap:11}}>
        <div>
          <label style={{fontSize:11,fontWeight:700,marginBottom:3,display:"block"}}>STAFF MEMBER</label>
          <select value={form.employee_id} onChange={e=>setForm(f=>({...f,employee_id:e.target.value}))} style={inputStyle}>
            {staff.map(s=><option key={s.id} value={s.id}>{s.full_name} ({s.position})</option>)}
          </select>
        </div>
        <div>
          <label style={{fontSize:11,fontWeight:700,marginBottom:3,display:"block"}}>DATE</label>
          <input type="date" value={form.schedule_date} onChange={e=>setForm(f=>({...f,schedule_date:e.target.value}))} style={inputStyle}/>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9}}>
          <div>
            <label style={{fontSize:11,fontWeight:700,marginBottom:3,display:"block"}}>START TIME</label>
            <input type="time" value={form.shift_start} onChange={e=>setForm(f=>({...f,shift_start:e.target.value}))} style={inputStyle}/>
          </div>
          <div>
            <label style={{fontSize:11,fontWeight:700,marginBottom:3,display:"block"}}>END TIME</label>
            <input type="time" value={form.shift_end} onChange={e=>setForm(f=>({...f,shift_end:e.target.value}))} style={inputStyle}/>
          </div>
        </div>
        <div>
          <label style={{fontSize:11,fontWeight:700,marginBottom:3,display:"block"}}>BREAK (minutes)</label>
          <input type="number" value={form.break_minutes} onChange={e=>setForm(f=>({...f,break_minutes:+e.target.value}))} style={inputStyle}/>
        </div>
      </div>
      
      <div style={{display:"flex",gap:7,marginTop:14}}>
        {schedule && <button onClick={()=>{onDelete(schedule.id);onClose();}} style={{padding:"9px 14px",background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:7,fontWeight:700,cursor:"pointer"}}>Delete</button>}
        <button onClick={onClose} style={{flex:1,padding:"9px",background:"#fff",border:"2px solid #ede8de",borderRadius:7,fontWeight:700,cursor:"pointer"}}>Cancel</button>
        <button onClick={()=>onSave(form)} style={{flex:2,padding:"9px",background:"#22c55e",color:"#fff",border:"none",borderRadius:7,fontWeight:700,cursor:"pointer"}}>Save Shift</button>
      </div>
    </div>
  </div>;
}

// PAYROLL VIEW
function PayrollView({staff, push}){
  var [period, setPeriod] = useState({
    from: new Date(new Date().setDate(1)).toISOString().split("T")[0],
    to: new Date().toISOString().split("T")[0]
  });
  var [calculations, setCalculations] = useState([]);
  var [loading, setLoading] = useState(false);
  
  var calculateAll = async ()=>{
    setLoading(true);
    var results = await Promise.all(staff.map(s=>dbCalcPayroll(s.id, period.from, period.to)));
    setCalculations(results.filter(r=>!r.error));
    setLoading(false);
  };
  
  return <div>
    <div className="card" style={{padding:14,marginBottom:11}}>
      <h3 style={{fontSize:15,fontWeight:700,marginBottom:11}}>Pay Period</h3>
      <div style={{display:"flex",gap:9,alignItems:"flex-end",flexWrap:"wrap"}}>
        <div>
          <label style={{fontSize:11,fontWeight:700,marginBottom:3,display:"block"}}>FROM</label>
          <input type="date" value={period.from} onChange={e=>setPeriod(p=>({...p,from:e.target.value}))} style={{padding:"9px 11px",border:"2px solid #ede8de",borderRadius:7,fontSize:13}}/>
        </div>
        <div>
          <label style={{fontSize:11,fontWeight:700,marginBottom:3,display:"block"}}>TO</label>
          <input type="date" value={period.to} onChange={e=>setPeriod(p=>({...p,to:e.target.value}))} style={{padding:"9px 11px",border:"2px solid #ede8de",borderRadius:7,fontSize:13}}/>
        </div>
        <button onClick={calculateAll} disabled={loading} style={{padding:"9px 18px",background:"#bf4626",color:"#fff",border:"none",borderRadius:7,fontWeight:700,cursor:"pointer"}}>{loading?"Calculating...":"Calculate"}</button>
      </div>
    </div>
    
    {calculations.length>0 && <div className="card" style={{padding:0,overflow:"hidden"}}>
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
        <thead>
          <tr style={{background:"#f7f3ee"}}>
            <th style={{padding:11,textAlign:"left"}}>Staff</th>
            <th style={{padding:11,textAlign:"left"}}>Position</th>
            <th style={{padding:11,textAlign:"right"}}>Hours</th>
            <th style={{padding:11,textAlign:"right"}}>Rate</th>
            <th style={{padding:11,textAlign:"right"}}>Total Pay</th>
          </tr>
        </thead>
        <tbody>
          {calculations.map(c=><tr key={c.staff.id} style={{borderTop:"1px solid #ede8de"}}>
            <td style={{padding:11,fontWeight:700}}>{c.staff.full_name}</td>
            <td style={{padding:11,color:"#8a8078",textTransform:"capitalize"}}>{c.staff.position}</td>
            <td style={{padding:11,textAlign:"right"}}>{c.totalHours}</td>
            <td style={{padding:11,textAlign:"right"}}>{c.staff.hourly_rate?"\u00A3"+c.staff.hourly_rate+"/hr":(c.staff.monthly_salary?"\u00A3"+c.staff.monthly_salary+"/mo":"-")}</td>
            <td style={{padding:11,textAlign:"right",fontWeight:700,color:"#22c55e"}}>{"\u00A3"}{c.basePay}</td>
          </tr>)}
        </tbody>
        <tfoot>
          <tr style={{background:"#f7f3ee",fontWeight:700}}>
            <td colSpan="4" style={{padding:11,textAlign:"right"}}>TOTAL:</td>
            <td style={{padding:11,textAlign:"right",color:"#22c55e",fontSize:16}}>{"\u00A3"}{calculations.reduce((s,c)=>s+parseFloat(c.basePay),0).toFixed(2)}</td>
          </tr>
        </tfoot>
      </table>
    </div>}
    
    {calculations.length===0 && !loading && <div className="card" style={{padding:30,textAlign:"center",color:"#8a8078"}}>
      <p style={{fontSize:36,marginBottom:9}}>{String.fromCharCode(0xD83D,0xDCB0)}</p>
      <p style={{fontSize:13}}>Click Calculate to see payroll for the selected period</p>
    </div>}
  </div>;
}

// ============================================================
// END STAFF MANAGEMENT MODULE
// ============================================================

// Dashboard tile customization card (icons + order + hide)
function DashboardCustomizeCard({push}){
  // All possible tile labels (must match exactly what's in PosDashboard)
  var ALL_TILES=[
    {label:"Dine In",defaultIcon:String.fromCharCode(0xD83C,0xDF73)},
    {label:"Walk-in Takeaway",defaultIcon:String.fromCharCode(0xD83D,0xDED2)},
    {label:"Phone Order",defaultIcon:String.fromCharCode(0xD83D,0xDCDE)},
    {label:"Incoming",defaultIcon:String.fromCharCode(0xD83D,0xDED2)},
    {label:"Kitchen",defaultIcon:String.fromCharCode(0xD83C,0xDF73)},
    {label:"Tables",defaultIcon:String.fromCharCode(0xD83D,0xDCCD)},
    {label:"Driver",defaultIcon:String.fromCharCode(0xD83D,0xDED2)},
    {label:"Bookings",defaultIcon:String.fromCharCode(0xD83D,0xDCC5)},
    {label:"Reports",defaultIcon:String.fromCharCode(0xD83D,0xDCCA)},
    {label:"Open Shift",defaultIcon:String.fromCharCode(0xD83C,0xDF05)},
    {label:"Close Shift",defaultIcon:String.fromCharCode(0xD83C,0xDF05)},
    {label:"Admin",defaultIcon:String.fromCharCode(0x2699,0xFE0F)},
    {label:"Fullscreen POS",defaultIcon:String.fromCharCode(0xD83D,0xDDA5,0xFE0F)},
    {label:"Open POS",defaultIcon:String.fromCharCode(0xD83D,0xDCBB)},
    {label:"Exit / Logout",defaultIcon:String.fromCharCode(0x21AA,0xFE0F)},
  ];
  
  var loadCust=function(){
    try{return JSON.parse(localStorage.getItem("tile_customization")||"{}");}catch(e){return {};}
  };
  
  var [cust,setCust]=useState(loadCust);
  // Build the working list: saved order first, then any not-yet-ordered tiles
  var orderedLabels=Array.isArray(cust._order)?cust._order.slice():[];
  ALL_TILES.forEach(function(t){if(!orderedLabels.includes(t.label))orderedLabels.push(t.label);});
  
  var saveCust=function(next){
    setCust(next);
    try{localStorage.setItem("tile_customization",JSON.stringify(next));}catch(e){}
  };
  
  var setIcon=function(label,icon){
    var next={...cust};
    if(!next[label])next[label]={};
    next[label]={...next[label],icon:icon};
    saveCust(next);
  };
  
  var toggleHide=function(label){
    var next={...cust};
    if(!next[label])next[label]={};
    next[label]={...next[label],hidden:!next[label].hidden};
    saveCust(next);
  };
  
  var move=function(label,direction){
    var idx=orderedLabels.indexOf(label);
    var target=idx+direction;
    if(target<0||target>=orderedLabels.length)return;
    var newOrder=orderedLabels.slice();
    newOrder.splice(idx,1);
    newOrder.splice(target,0,label);
    saveCust({...cust,_order:newOrder});
  };
  
  var resetAll=async function(){
    var ok=await window.showConfirm("Reset Dashboard","Reset all tile customization back to defaults?","Reset","Cancel","warning");
    if(!ok)return;
    saveCust({});
    if(push)push({title:"Dashboard reset",body:"Defaults restored",color:"#059669"});
  };
  
  var [expanded,setExpanded]=useState(false);
  // Many emoji choices grouped by category
  var EMOJI_OPTIONS=[
    // Food & drink
    String.fromCharCode(0xD83C,0xDF73),String.fromCharCode(0xD83C,0xDF7D,0xFE0F),
    String.fromCharCode(0xD83C,0xDF55),String.fromCharCode(0xD83C,0xDF54),
    String.fromCharCode(0xD83C,0xDF5F),String.fromCharCode(0xD83C,0xDF2D),
    String.fromCharCode(0xD83C,0xDF2E),String.fromCharCode(0xD83C,0xDF2F),
    String.fromCharCode(0xD83C,0xDF5B),String.fromCharCode(0xD83C,0xDF5C),
    String.fromCharCode(0xD83C,0xDF5D),String.fromCharCode(0xD83C,0xDF5E),
    String.fromCharCode(0xD83C,0xDF63),String.fromCharCode(0xD83C,0xDF71),
    String.fromCharCode(0xD83C,0xDF72),String.fromCharCode(0xD83C,0xDF74),
    String.fromCharCode(0xD83C,0xDF75),String.fromCharCode(0xD83C,0xDF76),
    String.fromCharCode(0xD83C,0xDF77),String.fromCharCode(0xD83C,0xDF78),
    String.fromCharCode(0xD83C,0xDF79),String.fromCharCode(0xD83C,0xDF7A),
    String.fromCharCode(0xD83C,0xDF7B),String.fromCharCode(0xD83C,0xDF7E),
    String.fromCharCode(0xD83C,0xDF7F),String.fromCharCode(0xD83C,0xDF80),
    String.fromCharCode(0xD83C,0xDF81),String.fromCharCode(0xD83C,0xDF82),
    String.fromCharCode(0xD83C,0xDF66),String.fromCharCode(0xD83C,0xDF67),
    String.fromCharCode(0xD83C,0xDF68),String.fromCharCode(0xD83C,0xDF69),
    String.fromCharCode(0xD83C,0xDF6A),String.fromCharCode(0xD83C,0xDF6B),
    String.fromCharCode(0xD83C,0xDF6C),String.fromCharCode(0xD83C,0xDF6D),
    String.fromCharCode(0xD83C,0xDF6E),String.fromCharCode(0xD83C,0xDF6F),
    String.fromCharCode(0xD83C,0xDF70),String.fromCharCode(0xD83E,0xDD63),
    String.fromCharCode(0xD83E,0xDD64),String.fromCharCode(0xD83E,0xDD66),
    String.fromCharCode(0xD83E,0xDD68),String.fromCharCode(0xD83E,0xDD69),
    String.fromCharCode(0xD83E,0xDD6A),String.fromCharCode(0xD83E,0xDD6B),
    String.fromCharCode(0xD83E,0xDD6E),String.fromCharCode(0xD83E,0xDD6F),
    String.fromCharCode(0xD83E,0xDDC0),String.fromCharCode(0xD83E,0xDDC1),
    String.fromCharCode(0xD83E,0xDDC2),String.fromCharCode(0xD83E,0xDDC3),
    String.fromCharCode(0xD83E,0xDDC8),String.fromCharCode(0xD83E,0xDD50),
    String.fromCharCode(0xD83E,0xDD51),String.fromCharCode(0xD83E,0xDD52),
    String.fromCharCode(0xD83E,0xDD53),String.fromCharCode(0xD83E,0xDD54),
    String.fromCharCode(0xD83E,0xDD55),String.fromCharCode(0xD83E,0xDD56),
    String.fromCharCode(0xD83E,0xDD57),String.fromCharCode(0xD83E,0xDD58),
    String.fromCharCode(0xD83E,0xDD59),String.fromCharCode(0xD83E,0xDD5A),
    String.fromCharCode(0xD83E,0xDD5B),String.fromCharCode(0xD83E,0xDD5C),
    String.fromCharCode(0xD83E,0xDD5D),String.fromCharCode(0xD83E,0xDD5E),
    String.fromCharCode(0xD83E,0xDD5F),String.fromCharCode(0xD83E,0xDD60),
    String.fromCharCode(0xD83E,0xDD61),String.fromCharCode(0xD83E,0xDD62),
    // Orders & business
    String.fromCharCode(0xD83D,0xDED2),String.fromCharCode(0xD83D,0xDECD,0xFE0F),
    String.fromCharCode(0xD83D,0xDCB0),String.fromCharCode(0xD83D,0xDCB5),
    String.fromCharCode(0xD83D,0xDCB3),String.fromCharCode(0xD83D,0xDCB8),
    String.fromCharCode(0xD83D,0xDCB2),String.fromCharCode(0xD83E,0xDDFE),
    String.fromCharCode(0xD83D,0xDCCA),String.fromCharCode(0xD83D,0xDCC8),
    String.fromCharCode(0xD83D,0xDCC9),String.fromCharCode(0xD83D,0xDCC4),
    String.fromCharCode(0xD83D,0xDCC1),String.fromCharCode(0xD83D,0xDCC2),
    String.fromCharCode(0xD83D,0xDCC5),String.fromCharCode(0xD83D,0xDCC6),
    String.fromCharCode(0xD83D,0xDCC7),String.fromCharCode(0xD83D,0xDCDD),
    String.fromCharCode(0xD83D,0xDCE6),String.fromCharCode(0xD83D,0xDCE7),
    String.fromCharCode(0xD83D,0xDCE8),String.fromCharCode(0xD83D,0xDCE9),
    String.fromCharCode(0xD83D,0xDCEC),String.fromCharCode(0xD83D,0xDCED),
    String.fromCharCode(0xD83D,0xDCEE),String.fromCharCode(0xD83D,0xDCEF),
    // People & roles
    String.fromCharCode(0xD83D,0xDC65),String.fromCharCode(0xD83D,0xDC64),
    String.fromCharCode(0xD83D,0xDC68,0x200D,0xD83C,0xDF73),
    String.fromCharCode(0xD83D,0xDC69,0x200D,0xD83C,0xDF73),
    String.fromCharCode(0xD83D,0xDC68,0x200D,0xD83D,0xDCBC),
    String.fromCharCode(0xD83D,0xDC69,0x200D,0xD83D,0xDCBC),
    String.fromCharCode(0xD83E,0xDDD1,0x200D,0xD83C,0xDF73),
    String.fromCharCode(0xD83D,0xDC6E),String.fromCharCode(0xD83D,0xDC77),
    String.fromCharCode(0xD83D,0xDC81),String.fromCharCode(0xD83D,0xDE4B),
    // Locations & transport
    String.fromCharCode(0xD83D,0xDCCD),String.fromCharCode(0xD83C,0xDFE0),
    String.fromCharCode(0xD83C,0xDFEA),String.fromCharCode(0xD83C,0xDFEC),
    String.fromCharCode(0xD83C,0xDFED),String.fromCharCode(0xD83C,0xDFE2),
    String.fromCharCode(0xD83D,0xDE97),String.fromCharCode(0xD83D,0xDE99),
    String.fromCharCode(0xD83D,0xDE9A),String.fromCharCode(0xD83D,0xDEB2),
    String.fromCharCode(0xD83D,0xDEF5),String.fromCharCode(0xD83D,0xDEF4),
    String.fromCharCode(0xD83D,0xDEF6),
    // Communication
    String.fromCharCode(0xD83D,0xDCDE),String.fromCharCode(0xD83D,0xDCF1),
    String.fromCharCode(0xD83D,0xDCAC),String.fromCharCode(0xD83D,0xDCAD),
    String.fromCharCode(0xD83D,0xDCE2),String.fromCharCode(0xD83D,0xDCE3),
    String.fromCharCode(0xD83D,0xDD14),String.fromCharCode(0xD83D,0xDD15),
    // Tools & system
    String.fromCharCode(0x2699,0xFE0F),String.fromCharCode(0xD83D,0xDD27),
    String.fromCharCode(0xD83D,0xDD28),String.fromCharCode(0xD83D,0xDEE0,0xFE0F),
    String.fromCharCode(0xD83D,0xDDA5,0xFE0F),String.fromCharCode(0xD83D,0xDCBB),
    String.fromCharCode(0xD83D,0xDCFA),String.fromCharCode(0xD83D,0xDCF7),
    String.fromCharCode(0xD83D,0xDD0D),String.fromCharCode(0xD83D,0xDD0E),
    String.fromCharCode(0xD83D,0xDD11),String.fromCharCode(0xD83D,0xDD12),
    String.fromCharCode(0xD83D,0xDD13),String.fromCharCode(0xD83D,0xDD10),
    // Time
    String.fromCharCode(0xD83C,0xDF05),String.fromCharCode(0xD83C,0xDF06),
    String.fromCharCode(0xD83C,0xDF07),String.fromCharCode(0xD83C,0xDF19),
    String.fromCharCode(0x231A),String.fromCharCode(0x23F0),
    String.fromCharCode(0x23F1,0xFE0F),String.fromCharCode(0x23F2,0xFE0F),
    String.fromCharCode(0x23F3),String.fromCharCode(0x231B),
    // Symbols & status
    String.fromCharCode(0x2705),String.fromCharCode(0x274C),
    String.fromCharCode(0x2B50),String.fromCharCode(0xD83C,0xDF1F),
    String.fromCharCode(0x2728),String.fromCharCode(0xD83D,0xDCAF),
    String.fromCharCode(0x2764,0xFE0F),String.fromCharCode(0xD83D,0xDC4D),
    String.fromCharCode(0xD83D,0xDC4E),String.fromCharCode(0xD83D,0xDC4C),
    String.fromCharCode(0xD83D,0xDC4A),String.fromCharCode(0x270B),
    String.fromCharCode(0x270C,0xFE0F),String.fromCharCode(0xD83D,0xDE4F),
    String.fromCharCode(0xD83D,0xDCAA),String.fromCharCode(0xD83D,0xDD25),
    String.fromCharCode(0x26A1),String.fromCharCode(0xD83D,0xDCA1),
    String.fromCharCode(0xD83C,0xDFAF),String.fromCharCode(0xD83C,0xDFC6),
    String.fromCharCode(0xD83C,0xDFAB),String.fromCharCode(0xD83C,0xDFAA),
    String.fromCharCode(0xD83C,0xDF89),String.fromCharCode(0xD83C,0xDF8A),
    String.fromCharCode(0x21AA,0xFE0F),String.fromCharCode(0x27A1,0xFE0F),
    String.fromCharCode(0x2B05,0xFE0F),String.fromCharCode(0x2B06,0xFE0F),
    String.fromCharCode(0x2B07,0xFE0F),String.fromCharCode(0x2197,0xFE0F),
    String.fromCharCode(0x2198,0xFE0F),String.fromCharCode(0x2196,0xFE0F),
    String.fromCharCode(0x2199,0xFE0F),String.fromCharCode(0xD83D,0xDD04),
    String.fromCharCode(0xD83D,0xDD03),String.fromCharCode(0x267B,0xFE0F),
  ];
  
  var [pickerFor,setPickerFor]=useState(null); // tile label whose emoji is being changed
  
  return <div className="card" style={{padding:18,marginBottom:12,borderLeft:"4px solid #f59e0b"}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
      <p style={{fontSize:15,fontWeight:700}}>{String.fromCharCode(0xD83C,0xDFA8)} Customize Dashboard Tiles</p>
      <button onClick={function(){setExpanded(!expanded);}} style={{padding:"6px 12px",background:expanded?"#fee2e2":"#fef3c7",color:expanded?"#dc2626":"#92400e",border:"none",borderRadius:7,fontWeight:700,fontSize:12,cursor:"pointer"}}>{expanded?"Done":"Edit"}</button>
    </div>
    <p style={{fontSize:11,color:"#8a8078",marginBottom:expanded?12:0}}>Reorder tiles, change their icons, or hide tiles you don't use.</p>
    
    {expanded&&<>
      <div style={{display:"grid",gap:6,marginTop:10}}>
        {orderedLabels.map(function(lbl,i){
          var def=ALL_TILES.find(function(t){return t.label===lbl;});
          var custData=cust[lbl]||{};
          var icon=custData.icon||(def?def.defaultIcon:"");
          var hidden=custData.hidden;
          return <div key={lbl} style={{display:"flex",alignItems:"center",gap:7,padding:"8px 10px",background:hidden?"#f3f4f6":"#fff",border:"1px solid "+(hidden?"#d1d5db":"#ede8de"),borderRadius:9,opacity:hidden?0.55:1}}>
            <div style={{display:"flex",flexDirection:"column",gap:2}}>
              <button onClick={function(){move(lbl,-1);}} disabled={i===0} style={{padding:"3px 7px",fontSize:10,background:i===0?"#f3f4f6":"#fef3c7",color:i===0?"#999":"#92400e",border:"none",borderRadius:4,cursor:i===0?"not-allowed":"pointer",fontWeight:700}}>{String.fromCharCode(0x25B2)}</button>
              <button onClick={function(){move(lbl,1);}} disabled={i===orderedLabels.length-1} style={{padding:"3px 7px",fontSize:10,background:i===orderedLabels.length-1?"#f3f4f6":"#fef3c7",color:i===orderedLabels.length-1?"#999":"#92400e",border:"none",borderRadius:4,cursor:i===orderedLabels.length-1?"not-allowed":"pointer",fontWeight:700}}>{String.fromCharCode(0x25BC)}</button>
            </div>
            <button onClick={function(){setPickerFor(lbl);}} title="Change icon" style={{padding:"5px 9px",fontSize:24,minWidth:42,background:"#f9fafb",border:"1px solid #ede8de",borderRadius:7,cursor:"pointer"}}>{icon}</button>
            <span style={{flex:1,fontSize:13,fontWeight:600,textDecoration:hidden?"line-through":"none"}}>{lbl}</span>
            <button onClick={function(){toggleHide(lbl);}} style={{padding:"5px 9px",background:hidden?"#fef3c7":"#fee2e2",color:hidden?"#92400e":"#dc2626",border:"none",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>{hidden?"Show":"Hide"}</button>
          </div>;
        })}
      </div>
      <button onClick={resetAll} style={{marginTop:10,padding:"9px 14px",background:"#fef2f2",color:"#dc2626",border:"1px solid #fecaca",borderRadius:8,fontWeight:700,fontSize:12,cursor:"pointer"}}>{String.fromCharCode(0xD83D,0xDD04)} Reset All to Defaults</button>
      <p style={{fontSize:10,color:"#8a8078",marginTop:8}}>{String.fromCharCode(0xD83D,0xDCA1)} Changes apply on the next page load. Refresh the dashboard to see them.</p>
    </>}
    
    {/* EMOJI PICKER MODAL */}
    {pickerFor&&<div onClick={function(){setPickerFor(null);}} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:9700,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
      <div onClick={function(e){e.stopPropagation();}} style={{background:"#fff",borderRadius:14,maxWidth:500,width:"100%",maxHeight:"80vh",overflowY:"auto",padding:18}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:11}}>
          <p style={{fontSize:15,fontWeight:700}}>Pick an icon for "{pickerFor}"</p>
          <button onClick={function(){setPickerFor(null);}} style={{padding:"6px 12px",background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:7,fontWeight:700,fontSize:12,cursor:"pointer"}}>Close</button>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(46px,1fr))",gap:5}}>
          {EMOJI_OPTIONS.map(function(e,i){
            var current=(cust[pickerFor]&&cust[pickerFor].icon)||((ALL_TILES.find(function(t){return t.label===pickerFor;})||{}).defaultIcon);
            var isCurrent=e===current;
            return <button key={i} onClick={function(){setIcon(pickerFor,e);setPickerFor(null);}} style={{padding:"8px 4px",fontSize:22,background:isCurrent?"#fef3c7":"#fff",border:"1.5px solid "+(isCurrent?"#f59e0b":"#ede8de"),borderRadius:7,cursor:"pointer"}}>{e}</button>;
          })}
        </div>
        <p style={{fontSize:11,color:"#8a8078",marginTop:11,textAlign:"center"}}>{EMOJI_OPTIONS.length} icons available {String.fromCharCode(0x2022)} tap one to select</p>
      </div>
    </div>}
  </div>;
}

// Restaurant logo upload card (shown in Settings)
function RestaurantLogoCard({restaurant,setRestaurant,push}){
  var [uploading,setUploading]=useState(false);
  var [logoUrl,setLogoUrl]=useState(restaurant?.logo_url||"");
  var [logoSize,setLogoSize]=useState(restaurant?.logo_size||"medium");
  var fileRef=useRef(null);
  
  var handleFile=async function(e){
    var file=e.target.files&&e.target.files[0];
    if(!file)return;
    setUploading(true);
    try{
      // Reuse the menu image upload (same storage bucket)
      var result=await dbUploadMenuImage(file,restaurant?.id);
      if(result.error){
        if(window.showAlert)window.showAlert("Upload Failed",result.error.message||"Could not upload logo.","error");
        setUploading(false);
        return;
      }
      var url=result.url||result.data;
      // Save the URL to the restaurant
      var saveResult=await dbSaveLogo(restaurant.id,url);
      if(saveResult.error){
        if(window.showAlert)window.showAlert("Save Failed","Logo uploaded but could not save. Try again.","error");
        setUploading(false);
        return;
      }
      setLogoUrl(url);
      if(setRestaurant)setRestaurant(function(r){return r?{...r,logo_url:url}:r;});
      if(push)push({title:"Logo updated",color:"#059669"});
    }catch(err){
      if(window.showAlert)window.showAlert("Error","Could not upload logo: "+(err.message||"unknown error"),"error");
    }
    setUploading(false);
  };
  
  var removeLogo=async function(){
    var ok=await window.showConfirm("Remove Logo","Remove your logo? The restaurant name will show as text instead.","Remove","Cancel","warning");
    if(!ok)return;
    var result=await dbSaveLogo(restaurant.id,null);
    if(result.error){
      if(window.showAlert)window.showAlert("Error","Could not remove logo.","error");
      return;
    }
    setLogoUrl("");
    if(setRestaurant)setRestaurant(function(r){return r?{...r,logo_url:null}:r;});
    if(push)push({title:"Logo removed",color:"#8a8078"});
  };
  
  var changeSize=async function(size){
    setLogoSize(size);
    if(setRestaurant)setRestaurant(function(r){return r?{...r,logo_size:size}:r;});
    var result=await dbSaveLogoSize(restaurant.id,size);
    if(result.error){
      if(window.showAlert)window.showAlert("Error","Could not save logo size.","error");
    }
  };
  
  // Preview height by size
  var sizeHeights={small:32,medium:44,large:58,xlarge:74};
  var navHeight=sizeHeights[logoSize]||44;
  
  return <div className="card" style={{padding:18,marginBottom:12,borderLeft:"4px solid #bf4626"}}>
    <p style={{fontSize:15,fontWeight:700,marginBottom:4}}>{String.fromCharCode(0xD83C,0xDFA8)} Restaurant Logo</p>
    <p style={{fontSize:11,color:"#8a8078",marginBottom:12}}>Upload your logo to show it instead of text. Appears on your ordering page and receipts.</p>
    
    {/* Current logo preview */}
    <div style={{display:"flex",alignItems:"center",gap:14,flexWrap:"wrap"}}>
      <div style={{width:90,height:90,borderRadius:12,border:"2px dashed #ddd",display:"flex",alignItems:"center",justifyContent:"center",background:"#f7f3ee",overflow:"hidden",flexShrink:0}}>
        {logoUrl?
          <img src={logoUrl} alt="Logo" style={{width:"100%",height:"100%",objectFit:"contain"}}/>
          :
          <span style={{fontSize:11,color:"#8a8078",textAlign:"center",padding:6}}>No logo<br/>(text shown)</span>
        }
      </div>
      <div style={{flex:1,minWidth:160}}>
        <input ref={fileRef} type="file" accept="image/png,image/jpeg,image/webp" onChange={handleFile} style={{display:"none"}}/>
        <button onClick={function(){fileRef.current&&fileRef.current.click();}} disabled={uploading} style={{padding:"10px 16px",background:uploading?"#8a8078":"linear-gradient(135deg,#bf4626,#7c2d12)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:13,cursor:uploading?"not-allowed":"pointer",width:"100%",marginBottom:7}}>
          {uploading?"Uploading...":(logoUrl?String.fromCharCode(0xD83D,0xDD04)+" Change Logo":String.fromCharCode(0xD83D,0xDCE4)+" Upload Logo")}
        </button>
        {logoUrl&&<button onClick={removeLogo} style={{padding:"8px 16px",background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:9,fontWeight:700,fontSize:12,cursor:"pointer",width:"100%"}}>Remove Logo</button>}
      </div>
    </div>
    
    {/* Logo SIZE selector - only if logo uploaded */}
    {logoUrl&&<div style={{marginTop:14,paddingTop:14,borderTop:"1px solid #ede8de"}}>
      <p style={{fontSize:12,fontWeight:700,marginBottom:8}}>Logo Size</p>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:7}}>
        {[["small","Small"],["medium","Medium"],["large","Large"],["xlarge","Extra Large"]].map(function(s){
          var isActive=logoSize===s[0];
          return <button key={s[0]} onClick={function(){changeSize(s[0]);}} style={{padding:"10px 4px",borderRadius:9,border:"2px solid "+(isActive?"#bf4626":"#ede8de"),background:isActive?"#fef2f0":"#fff",cursor:"pointer",textAlign:"center"}}>
            <p style={{fontWeight:700,fontSize:11,color:isActive?"#bf4626":"#8a8078"}}>{s[1]}</p>
          </button>;
        })}
      </div>
      {/* Live preview at chosen size */}
      <div style={{marginTop:11,padding:"12px",background:"#1a1208",borderRadius:9,display:"flex",alignItems:"center",justifyContent:"center"}}>
        <img src={logoUrl} alt="Preview" style={{height:navHeight,maxWidth:170,objectFit:"contain"}}/>
      </div>
      <p style={{fontSize:10,color:"#8a8078",marginTop:6,textAlign:"center"}}>{String.fromCharCode(0xD83D,0xDC46)} This is how your logo appears in the top bar</p>
    </div>}
    
    <p style={{fontSize:10,color:"#8a8078",marginTop:10}}>{String.fromCharCode(0xD83D,0xDCA1)} Best: square image (e.g. 200x200px), PNG with transparent background. Max 5MB.</p>
  </div>;
}

function AdminV({orders,setOrders,menu,setMenu,discounts,setDiscounts,push,branches,setMeals,setSetMeals,categories,setCategories,tables,setTables,branch,stations,setStations,user,restaurant,setRestaurant}){
  var [tab,setTab]=useState("orders"),[bf,setBF]=useState("all"),[nc,setNC]=useState({code:"",type:"percent",value:"",desc:""});
  var [editItem,setEditItem]=useState(null),[editMeal,setEditMeal]=useState(null),[editCat,setEditCat]=useState(null),[showImport,setShowImport]=useState(false),[editTable,setEditTable]=useState(null),[adminBranch,setAdminBranch]=useState(branch?.id||"b1"),[editStation,setEditStation]=useState(null);
  var [cashHandovers,setCashHandovers]=useState([]);
  var [handoverDriver,setHandoverDriver]=useState("");
  var [showQRGenerator,setShowQRGenerator]=useState(false);
  var [posUiStyle,setPosUiStyle]=useState(()=>{
    try{return localStorage.getItem("pos_ui_style")||"modern";}catch(e){return "modern";}
  });
  var [showDashboard,setShowDashboard]=useState(()=>{
    try{return localStorage.getItem("show_pos_dashboard")==="1";}catch(e){return false;}
  });
  var [kbSize,setKbSize]=useState(()=>{
    try{return localStorage.getItem("kb_size")||"medium";}catch(e){return "medium";}
  });
  var [showVAT,setShowVAT]=useState(()=>{
    try{return localStorage.getItem("show_vat")!=="0";}catch(e){return true;}
  });
  var [vatRate,setVatRate]=useState(()=>{
    try{return parseFloat(localStorage.getItem("vat_rate"))||20;}catch(e){return 20;}
  });
  var [vatNumber,setVatNumber]=useState(()=>{
    try{return localStorage.getItem("vat_number")||"GB 123 4567 89";}catch(e){return "GB 123 4567 89";}
  });
  var [menuSearch,setMenuSearch]=useState("");
  var [orderSearch,setOrderSearch]=useState("");
  var [custSearch,setCustSearch]=useState("");
  var [refundOrder,setRefundOrder]=useState(null);
  var [shiftsList,setShiftsList]=useState([]);
  var [shiftsLoading,setShiftsLoading]=useState(false);
  // Finance state
  var [expenses,setExpenses]=useState([]);
  var [expenseCategories,setExpenseCategories]=useState([]);
  var [recurringExpenses,setRecurringExpenses]=useState([]);
  var [financeLoading,setFinanceLoading]=useState(false);
  var [showRecurringManager,setShowRecurringManager]=useState(false);
  var [showPLStatement,setShowPLStatement]=useState(false);
  var [financeFromDate,setFinanceFromDate]=useState(()=>{var d=new Date();d.setDate(1);return d.toISOString().split("T")[0];});
  var [financeToDate,setFinanceToDate]=useState(()=>new Date().toISOString().split("T")[0]);
  var [showAddExpense,setShowAddExpense]=useState(false);
  var [showCategoryManager,setShowCategoryManager]=useState(false);
  var [editingExpense,setEditingExpense]=useState(null);

  // Load shifts when shifts tab is active
  useEffect(()=>{
    if(tab==="shifts"){
      setShiftsLoading(true);
      dbFetchShifts(branch?.id||null).then(data=>{
        setShiftsList(data||[]);
        setShiftsLoading(false);
      }).catch(e=>{console.log("Shifts load failed:",e);setShiftsLoading(false);});
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[tab,branch?.id]);

  // Load finance data when finance tab is active
  useEffect(()=>{
    if(tab==="finance"){
      setFinanceLoading(true);
      Promise.all([
        dbFetchExpenseCats(branch?.id||null),
        dbFetchExpenses(branch?.id||null,financeFromDate,financeToDate),
        dbFetchRecurring(branch?.id||null),
      ]).then(([cats,exp,rec])=>{
        setExpenseCategories(cats||[]);
        setExpenses(exp||[]);
        setRecurringExpenses(rec||[]);
        setFinanceLoading(false);
        // AUTO-GENERATE recurring expenses that are due
        autoGenerateRecurring(rec||[],branch,user);
      }).catch(e=>{console.log("Finance load failed:",e);setFinanceLoading(false);});
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[tab,branch?.id,financeFromDate,financeToDate]);

  // AUTO-GENERATE recurring expenses based on schedule
  var autoGenerateRecurring=async(recList,br,u)=>{
    var today=new Date();
    today.setHours(0,0,0,0);
    var generated=0;
    
    for(var rec of recList){
      if(!rec.active)continue;
      if(rec.end_date&&new Date(rec.end_date)<today)continue;
      
      // Determine first date to consider for generation
      var nextDue;
      if(rec.last_generated_date){
        // Already generated - move to next occurrence
        nextDue=new Date(rec.last_generated_date);
        if(rec.frequency==="weekly")nextDue.setDate(nextDue.getDate()+7);
        else if(rec.frequency==="monthly")nextDue.setMonth(nextDue.getMonth()+1);
        else if(rec.frequency==="quarterly")nextDue.setMonth(nextDue.getMonth()+3);
        else if(rec.frequency==="yearly")nextDue.setFullYear(nextDue.getFullYear()+1);
        else continue;
      }else{
        // Never generated - start from start_date
        nextDue=new Date(rec.start_date);
      }
      nextDue.setHours(0,0,0,0);
      
      // Generate all due occurrences (today and earlier)
      while(nextDue<=today){
        var dueStr=nextDue.toISOString().split("T")[0];
        try{
          await dbSaveExpense({
            branchId:rec.branch_id,
            categoryId:rec.category_id,
            categoryName:rec.category_name,
            amount:rec.amount,
            description:rec.description+" (auto-recurring)",
            expenseDate:dueStr,
            recordedBy:"System (Auto)",
            recordedByRole:"manager",
            isRecurring:true,
            recurringId:rec.id,
            notes:"Auto-generated from recurring template",
          });
          await dbUpdateRecurringDate(rec.id,dueStr);
          generated++;
          // Move to next due date
          if(rec.frequency==="weekly")nextDue.setDate(nextDue.getDate()+7);
          else if(rec.frequency==="monthly")nextDue.setMonth(nextDue.getMonth()+1);
          else if(rec.frequency==="quarterly")nextDue.setMonth(nextDue.getMonth()+3);
          else if(rec.frequency==="yearly")nextDue.setFullYear(nextDue.getFullYear()+1);
          else break;
        }catch(e){
          console.log("Auto-gen failed for",rec.description,e);
          break;
        }
      }
    }
    
    if(generated>0){
      // Reload expenses list
      var freshExpenses=await dbFetchExpenses(br?.id||null,financeFromDate,financeToDate);
      setExpenses(freshExpenses||[]);
      var freshRec=await dbFetchRecurring(br?.id||null);
      setRecurringExpenses(freshRec||[]);
      push&&push({title:"Auto-recurring",body:"Generated "+generated+" recurring expense(s)",color:"#7c3aed"});
    }
  };

  var [advHours,setAdvHours]=useState({}); // { branchId: { Mon: { all_1: {...} }, Tue: ... } }
  var [holidays,setHolidays]=useState({}); // { branchId: [{ id, holiday_date, ... }] }
  var [hoursConfig,setHoursConfig]=useState({}); // { branchId: { use_per_service_hours, ... } }
  var [hoursLoading,setHoursLoading]=useState(false);
  var [editingBranch,setEditingBranch]=useState(null);
  var [showHolidayModal,setShowHolidayModal]=useState(false);
  var [editHoliday,setEditHoliday]=useState(null);

  // Load advanced hours from DB on mount
  useEffect(()=>{
    if(!branches||!branches.length)return;
    setHoursLoading(true);
    Promise.all(branches.map(b=>Promise.all([
      dbFetchBranchHours(b.id),
      dbFetchHolidays(b.id),
      dbFetchHoursConfig(b.id),
    ]))).then(results=>{
      var h={},hol={},cfg={};
      results.forEach((r,i)=>{
        var bid=branches[i].id;
        var hourRows=r[0]||[];
        h[bid]={};
        hourRows.forEach(row=>{
          if(!h[bid][row.day_of_week])h[bid][row.day_of_week]={};
          var key=row.service_type+"_"+row.service_window;
          h[bid][row.day_of_week][key]={
            id:row.id,
            is_closed:row.is_closed,
            open_time:row.open_time?row.open_time.slice(0,5):"",
            close_time:row.close_time?row.close_time.slice(0,5):"",
            last_order_time:row.last_order_time?row.last_order_time.slice(0,5):"",
          };
        });
        hol[bid]=r[1]||[];
        cfg[bid]=r[2]||{branch_id:bid,use_per_service_hours:false,block_orders_when_closed:true,block_orders_after_last_order:true,show_last_order_warning:true,warning_threshold_minutes:30,allow_staff_override:true};
      });
      setAdvHours(h);setHolidays(hol);setHoursConfig(cfg);setHoursLoading(false);
    }).catch(e=>{console.log("Hours load failed:",e);setHoursLoading(false);});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  // Save hours for a day
  var saveDayHours=(branchId,day,serviceType,serviceWindow,hours)=>{
    dbSaveBranchHours(branchId,day,serviceType,serviceWindow,hours).then(r=>{
      if(r.data){
        setAdvHours(h=>{
          var newH={...h};
          if(!newH[branchId])newH[branchId]={};
          if(!newH[branchId][day])newH[branchId][day]={};
          var key=serviceType+"_"+serviceWindow;
          newH[branchId][day][key]={...hours,id:r.data.id};
          return newH;
        });
      }
    });
  };

  // Save holiday
  var saveHoliday=(branchId,h)=>{
    dbSaveHoliday({...h,branch_id:branchId}).then(r=>{
      if(r.data){
        setHolidays(prev=>{
          var newHol={...prev};
          if(!newHol[branchId])newHol[branchId]=[];
          var existing=newHol[branchId].findIndex(x=>x.id===r.data.id);
          if(existing>=0)newHol[branchId][existing]=r.data;
          else newHol[branchId]=[...newHol[branchId],r.data].sort((a,b)=>a.holiday_date.localeCompare(b.holiday_date));
          return newHol;
        });
      }
    });
  };

  var deleteHoliday=(branchId,id)=>{
    if(!window.confirm("Delete this holiday?"))return;
    dbDeleteHoliday(id).then(()=>{
      setHolidays(prev=>{var newHol={...prev};newHol[branchId]=(newHol[branchId]||[]).filter(h=>h.id!==id);return newHol;});
    });
  };

  // Save config
  var saveConfig=(branchId,partial)=>{
    var current=hoursConfig[branchId]||{branch_id:branchId};
    var updated={...current,...partial};
    setHoursConfig(c=>({...c,[branchId]:updated}));
    dbSaveHoursConfig(updated);
  };
  var [orderDateFilter,setOrderDateFilter]=useState("all"); // all, today, yesterday, week, month, custom
  var [orderCustomFrom,setOrderCustomFrom]=useState("");
  var [orderCustomTo,setOrderCustomTo]=useState("");
  var [orderTypeFilter,setOrderTypeFilter]=useState("all"); // all, dine-in, takeaway, delivery, collection
  var [orderStatusFilter,setOrderStatusFilter]=useState("all"); // all, pending, preparing, ready, delivered, collected, cancelled
  var [orderSourceFilter,setOrderSourceFilter]=useState("all"); // all, online, qr-table, staff, phone
  var [menuSort,setMenuSort]=useState("az");
  var [menuFilterCat,setMenuFilterCat]=useState("all");
  var [menuFilterStation,setMenuFilterStation]=useState("all");
  var [menuFilterStatus,setMenuFilterStatus]=useState("all");
  var [handoverAmount,setHandoverAmount]=useState("");
  var [pendingHandoversList,setPendingHandoversList]=useState([]);
  var [confirmAmounts,setConfirmAmounts]=useState({});
  var [newHandoverHistory,setNewHandoverHistory]=useState([]);

  // Load cash handover history on mount + when admin tab opened
  useEffect(()=>{
    dbFetchHandovers().then(list=>setCashHandovers(list||[]));
    // Load new two-step handover system data
    var loadNewHandovers=()=>{
      dbGetPendingHandovers().then(list=>setPendingHandoversList(list||[]));
      dbHandoverHistory({}).then(list=>setNewHandoverHistory(list||[]));
    };
    loadNewHandovers();
    var hi=setInterval(loadNewHandovers,15000);
    return()=>clearInterval(hi);
  },[]);
  var [delivSettings,setDelivSettings]=useState({});
  var [promoCodes,setPromoCodes]=useState([]);
  var [autoDiscs,setAutoDiscs]=useState([]);
  var [editCode,setEditCode]=useState(null);
  var [editAuto,setEditAuto]=useState(null);

  // Load delivery and promo data
  useEffect(()=>{
    dbFetchAllDelivery().then(list=>{
      var map={};
      (list||[]).forEach(s=>{map[s.branch_id]={
        dbId:s.id,method:s.method,enabled:s.enabled,
        minOrder:parseFloat(s.min_order||0),freeOver:parseFloat(s.free_over||0),
        flatFee:parseFloat(s.flat_fee||0),maxRadius:s.max_radius||3,
        zones:s.zones||[],postcodes:s.postcodes||[],
        codEnabled:s.cod_enabled,codMinOrder:parseFloat(s.cod_min_order||15),codMaxMiles:s.cod_max_miles||3,
        serviceChargeEnabled:s.service_charge_enabled||false,
        serviceChargePercent:parseFloat(s.service_charge_percent||12.5),
        serviceChargeMandatory:s.service_charge_mandatory||false,
        serviceChargeGroupSize:s.service_charge_group_size||6,
      };});
      setDelivSettings(map);
    });
    dbFetchCodes().then(list=>{
      setPromoCodes((list||[]).map(c=>({
        dbId:c.id,code:c.code,type:c.type,value:parseFloat(c.value),
        description:c.description,minOrder:parseFloat(c.min_order||0),
        maxUses:c.max_uses,uses:c.uses||0,expiresAt:c.expires_at,active:c.active,
        firstOrderOnly:c.first_order_only,branchIds:c.branch_ids||[],
      })));
    });
    dbFetchAutoDiscounts().then(list=>{
      setAutoDiscs((list||[]).map(a=>({
        dbId:a.id,name:a.name,description:a.description,ruleType:a.rule_type,
        minOrder:parseFloat(a.min_order||0),discountType:a.discount_type,
        discountValue:parseFloat(a.discount_value||0),active:a.active,
        firstOrderOnly:a.first_order_only,branchIds:a.branch_ids||[],
      })));
    });
  },[]);
  var fil=bf==="all"?orders:orders.filter(o=>o.branchId===bf),rev=fil.filter(o=>o.status!=="cancelled"&&o.status!=="refunded").reduce((s,o)=>s+parseFloat(o.total||0),0);
  var allSt=["pending","preparing","ready","out_for_delivery","delivered","collected","cancelled"];
  // Status order rank for detecting backward movement
  var statusRank={pending:1,preparing:2,ready:3,out_for_delivery:4,delivered:5,collected:5};
  var upSt=async(id,st)=>{
    var order=orders.find(o=>o.id===id);
    var currentRank=statusRank[order?.status]||0;
    var newRank=statusRank[st]||0;
    // Detect backward movement (ignore cancelled - that's always allowed)
    if(order&&st!=="cancelled"&&currentRank>0&&newRank>0&&newRank<currentRank){
      var ok=await window.showConfirm(
        String.fromCharCode(0x26A0,0xFE0F)+" Move Order Backward?",
        id+" is already \""+SL[order.status]+"\".\n\nMoving it back to \""+SL[st]+"\" will make it appear as an active order again. This can cause confusion.\n\nAre you sure?",
        "Yes, Move Back","Cancel","warning"
      );
      if(!ok)return;
    }
    setOrders(os=>os.map(o=>o.id===id?{...o,status:st}:o));
    push({title:"Updated",body:id+" -> "+SL[st],color:SC[st]});
    dbUpdateOrderStatus(id,st).catch(e=>console.log("Admin status save failed:",e));
    // Commission is auto-handled in dbUpdateOrderStatus (records if delivered/collected+paid, reverses if cancelled)
    
    // AUTO-FREE the table when a dine-in order is completed
    if(order&&(order.type==="dine-in"||order.type==="eatin")&&(st==="delivered"||st==="collected"||st==="cancelled")){
      // Find the table - try tableId field first, fall back to customer field "Table N"
      var tblId=order.tableId;
      if(!tblId&&order.customer){
        var match=String(order.customer).match(/\d+/);
        if(match)tblId=parseInt(match[0]);
      }
      if(tblId&&tables){
        // Check if any OTHER unfinished orders still on this table
        var otherActive=orders.filter(function(o){
          if(o.id===id)return false; // skip current
          if(o.status==="delivered"||o.status==="collected"||o.status==="cancelled")return false;
          if(o.type!=="dine-in"&&o.type!=="eatin")return false;
          var otId=o.tableId;
          if(!otId&&o.customer){
            var m=String(o.customer).match(/\d+/);
            if(m)otId=parseInt(m[0]);
          }
          return otId===tblId;
        });
        // Only free the table if no other active orders on it
        if(otherActive.length===0&&setTables){
          setTables(function(ts){
            return ts.map(function(t){
              if((t.id===tblId||t.id===String(tblId))&&t.status==="occupied"){
                if(t.dbId)dbUpdateTableStatus(t.dbId,"free",{}).catch(function(e){console.log("Table free failed:",e);});
                return{...t,status:"free",since:null,guests:null,orderId:null};
              }
              return t;
            });
          });
        }
      }
    }
  };
  var addCode=()=>{if(!nc.code||!nc.value)return;setDiscounts(ds=>[...ds,{code:nc.code.toUpperCase(),type:nc.type,value:+nc.value,desc:nc.desc,active:true,uses:0,max:9999}]);setNC({code:"",type:"percent",value:"",desc:""});};
  var saveItem=item=>{
    // Determine if this is an edit (has dbId) or new item
    var isEdit=!!item.dbId;
    
    // Check if item with same name+category already exists (prevent duplicates)
    var existing=menu.find(m=>{
      // Skip the same item (by dbId or by id)
      if(item.dbId && m.dbId === item.dbId)return false;
      if(item.id && m.id === item.id)return false;
      // Check name+category match
      return (m.name||"").toLowerCase().trim()===(item.name||"").toLowerCase().trim() &&
             (m.cat||"").toLowerCase().trim()===(item.cat||"").toLowerCase().trim();
    });
    
    // Only block duplicates for NEW items (not edits)
    if(existing && !isEdit){
      if(window.showAlert){
        window.showAlert("Duplicate Item",'"'+item.name+'" already exists in '+item.cat+'. Please use a different name or category.',"warning");
      } else {
        push({title:"Duplicate item",body:item.name+" already exists in "+item.cat,color:"#dc2626"});
      }
      return;
    }
    // Save to local state immediately (for instant UI)
    setMenu(ms=>{var ex=ms.find(m=>m.id===item.id||(m.dbId&&m.dbId===item.dbId));return ex?ms.map(m=>(m.id===item.id||m.dbId===item.dbId)?{...m,...item}:m):[...ms,item];});
    // Save to database
    dbSaveMenuItem(item).then(result=>{
      if(result.error){push({title:"DB save failed",body:result.error.message||"Try again",color:"#dc2626"});}
      else{
        push({title:"Saved",body:item.name,color:"#059669"});
        // Update the local state with the database ID
        if(result.data&&result.data.id){
          setMenu(ms=>ms.map(m=>(m.id===item.id||m.dbId===item.dbId)?{...m,dbId:result.data.id,id:result.data.id}:m));
        }
      }
    }).catch(e=>{console.error(e);push({title:"Error",body:"Could not save",color:"#dc2626"});});
  };
  var deleteItem=id=>{
    var item=menu.find(m=>m.id===id);
    setMenu(ms=>ms.filter(m=>m.id!==id));
    if(item?.dbId){
      dbDeleteMenuItem(item.dbId).then(result=>{
        if(result.error){push({title:"Delete failed",body:result.error.message,color:"#dc2626"});}
        else{push({title:"Deleted",body:"Menu item removed",color:"#dc2626"});}
      });
    }else{push({title:"Deleted",body:"Menu item removed",color:"#dc2626"});}
  };
  var saveMeal=meal=>{
    setSetMeals(ms=>{var ex=ms.find(m=>m.id===meal.id);return ex?ms.map(m=>m.id===meal.id?meal:m):[...ms,meal];});
    dbSaveSetMeal(meal).then(result=>{
      if(result.error){push({title:"DB save failed",body:result.error.message||"Try again",color:"#dc2626"});}
      else{
        push({title:"Saved",body:meal.name,color:"#059669"});
        if(result.data&&result.data.id){
          setSetMeals(ms=>ms.map(m=>m.id===meal.id?{...m,dbId:result.data.id,id:result.data.id}:m));
        }
      }
    }).catch(e=>{console.error(e);push({title:"Error",body:"Could not save",color:"#dc2626"});});
  };
  var deleteMeal=id=>{
    var meal=setMeals.find(m=>m.id===id);
    setSetMeals(ms=>ms.filter(m=>m.id!==id));
    if(meal?.dbId){
      dbDeleteSetMeal(meal.dbId).then(result=>{
        if(result.error){push({title:"Delete failed",body:result.error.message,color:"#dc2626"});}
        else{push({title:"Deleted",body:"Combo removed",color:"#dc2626"});}
      });
    }else{push({title:"Deleted",body:"Combo removed",color:"#dc2626"});}
  };
  var saveCat=cat=>{
    setCategories(cs=>{var ex=cs.find(c=>c.id===cat.id);return ex?cs.map(c=>c.id===cat.id?cat:c):[...cs,cat];});
    dbSaveCategory(cat).then(result=>{
      if(result.error){push({title:"DB save failed",body:result.error.message||"Try again",color:"#dc2626"});}
      else{
        push({title:"Saved",body:cat.name,color:"#059669"});
        if(result.data&&result.data.id){
          setCategories(cs=>cs.map(c=>c.id===cat.id?{...c,dbId:result.data.id,id:result.data.id}:c));
        }
      }
    }).catch(e=>{console.error(e);push({title:"Error",body:"Could not save",color:"#dc2626"});});
  };
  var deleteCat=id=>{
    var cat=categories.find(c=>c.id===id);
    var used=menu.filter(m=>m.cat===cat?.name).length;
    if(used>0){alert("Cannot delete - "+used+" menu item(s) use this category. Move them first.");return;}
    setCategories(cs=>cs.filter(c=>c.id!==id));
    if(cat?.dbId){
      dbDeleteCategory(cat.dbId).then(result=>{
        if(result.error){push({title:"Delete failed",body:result.error.message,color:"#dc2626"});}
        else{push({title:"Deleted",body:"Category removed",color:"#dc2626"});}
      });
    }else{push({title:"Deleted",body:"Category removed",color:"#dc2626"});}
  };
  var bulkImport=(newCats,newItems)=>{
    // Save each category to DB
    newCats.forEach(cat=>{
      setCategories(cs=>[...cs,cat]);
      dbSaveCategory(cat).then(r=>{
        if(r.data&&r.data.id){setCategories(cs=>cs.map(c=>c.id===cat.id?{...c,dbId:r.data.id,id:r.data.id}:c));}
      });
    });
    // Save each item to DB
    newItems.forEach(item=>{
      setMenu(ms=>[...ms,item]);
      dbSaveMenuItem(item).then(r=>{
        if(r.data&&r.data.id){setMenu(ms=>ms.map(m=>m.id===item.id?{...m,dbId:r.data.id,id:r.data.id}:m));}
      });
    });
    push({title:"Imported!",body:newItems.length+" items, "+newCats.length+" categories",color:"#059669"});
  };

  // Tables management
  var saveTable=tbl=>{
    if(tbl.dbId){
      // Update existing
      setTables(ts=>ts.map(t=>t.dbId===tbl.dbId?tbl:t));
      dbSaveTable(tbl).then(r=>{
        if(r.error)push({title:"Save failed",body:r.error.message,color:"#dc2626"});
        else push({title:"Table updated",body:"Table "+tbl.id,color:"#059669"});
      });
    }else{
      // Insert new
      var newT={...tbl,branchId:adminBranch,status:"free"};
      setTables(ts=>[...ts,newT]);
      dbSaveTable(newT).then(r=>{
        if(r.error){push({title:"Save failed",body:r.error.message,color:"#dc2626"});}
        else if(r.data){
          setTables(ts=>ts.map(t=>(t.id===newT.id&&!t.dbId)?{...t,dbId:r.data.id}:t));
          push({title:"Table added",body:"Table "+tbl.id,color:"#059669"});
        }
      });
    }
    setEditTable(null);
  };
  var deleteTable=tbl=>{
    if(tbl.status==="occupied"){alert("Cannot delete occupied table. Clear it first.");return;}
    if(!window.confirm("Delete Table "+tbl.id+"? This cannot be undone."))return;
    setTables(ts=>ts.filter(t=>t!==tbl));
    if(tbl.dbId){
      dbDeleteTable(tbl.dbId).then(r=>{
        if(r.error)push({title:"Delete failed",body:r.error.message,color:"#dc2626"});
        else push({title:"Table deleted",body:"Table "+tbl.id,color:"#dc2626"});
      });
    }
  };
  var TABS_ALL=[["orders","Orders"],["analytics","Analytics"],["finance","Finance"],["customers","Customers"],["settings","Settings"],["menu","Menu"],["categories","Categories"],["combos","Set Meals"],["tables","Tables"],["stations","Stations"],["delivery","Delivery"],["staff","Staff"],["marketing","Marketing"],["codes","Promo Codes"],["autodisc","Auto Offers"],["cash","Cash"],["shifts","Shifts"],["stock","Availability"],["discounts","Legacy Disc"],["hours","Hours"]];
  
  // STAFF PIN: Filter tabs based on permissions
  var activeStaff = (typeof window!=="undefined")?dbGetActiveStaff():null;
  var TABS = TABS_ALL.filter(t=>{
    // PLAN-BASED FILTERING (applies regardless of staff)
    if(restaurant){
      // Bookings tab requires bookings feature (Pro+)
      if(t[0]==="combos" && !hasFeature(restaurant,"set_meals")) return false;
      // Promo codes require promo_codes feature (Pro+)
      if(t[0]==="codes" && !hasFeature(restaurant,"promo_codes")) return false;
      // Auto offers require auto_offers feature (Pro+)
      if(t[0]==="autodisc" && !hasFeature(restaurant,"auto_offers")) return false;
      // Advanced analytics for Enterprise only
      if(t[0]==="analytics" && !hasFeature(restaurant,"basic_reports")) return false;
      // Hide tables tab if dine-in is disabled
      if(t[0]==="tables" && !hasService(restaurant,"dine_in")) return false;
      // Hide delivery tab if delivery service is off
      if(t[0]==="delivery" && !hasService(restaurant,"delivery")) return false;
    }
    
    // No active staff = restaurant owner = full access (still filtered by plan above)
    if(!activeStaff) return true;
    var perms = activeStaff.permissions || {};
    
    // Map EVERY tab to a required permission (strict: must be explicitly true)
    // MENU MANAGEMENT group
    if(t[0]==="menu") return perms.manage_menu===true;
    if(t[0]==="categories") return perms.manage_menu===true;
    if(t[0]==="combos") return perms.manage_menu===true;
    if(t[0]==="stations") return perms.manage_menu===true;
    if(t[0]==="stock") return perms.manage_menu===true;
    // PROMOTIONS group (also menu management)
    if(t[0]==="codes") return perms.manage_menu===true;
    if(t[0]==="autodisc") return perms.manage_menu===true;
    if(t[0]==="discounts") return perms.manage_menu===true;
    // ORDERS group
    if(t[0]==="orders") return perms.take_orders===true;
    if(t[0]==="tables") return perms.take_orders===true;
    if(t[0]==="customers") return perms.take_orders===true||perms.view_reports===true;
    // REPORTS group
    if(t[0]==="analytics") return perms.view_reports===true;
    // FINANCE group
    if(t[0]==="finance") return perms.view_finance===true;
    if(t[0]==="cash") return perms.view_finance===true;
    if(t[0]==="shifts") return perms.view_finance===true;
    // SETTINGS group
    if(t[0]==="settings") return perms.manage_settings===true;
    if(t[0]==="hours") return perms.manage_settings===true;
    if(t[0]==="delivery") return perms.manage_settings===true;
    if(t[0]==="marketing") return perms.manage_settings===true;
    // STAFF group
    if(t[0]==="staff") return perms.manage_staff===true;
    
    // Anything not explicitly mapped = hidden for staff (safe default)
    return false;
  });
  
  // If current tab is not in allowed TABS (e.g. limited staff), switch to first allowed
  useEffect(()=>{
    if(TABS.length>0 && !TABS.some(t=>t[0]===tab)){
      setTab(TABS[0][0]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[TABS.length]);
  
  // ORDERS SEARCH & FILTERS - applied to fil (already branch-filtered orders)
  var searchedOrders=(()=>{
    var result=fil;
    // Text search across multiple fields
    var q=orderSearch.trim().toLowerCase();
    if(q){
      result=result.filter(o=>{
        var hay=[
          o.id,
          o.customer,
          o.phone,
          o.address?(typeof o.address==="string"?o.address:(o.address.line1||"")+" "+(o.address.postcode||"")):"",
          o.takenBy,
          (o.items||[]).map(i=>i.name).join(" "),
          o.deliveryCode,
          o.payMethod,
        ].filter(x=>x).join(" ").toLowerCase();
        return hay.includes(q);
      });
    }
    // Date filter
    if(orderDateFilter!=="all"){
      var now=new Date();
      var todayStr=now.toISOString().split("T")[0];
      var yesterday=new Date(now-86400000).toISOString().split("T")[0];
      var weekAgo=new Date(now-7*86400000).toISOString().split("T")[0];
      var monthAgo=new Date(now-30*86400000).toISOString().split("T")[0];
      result=result.filter(o=>{
        try{
          // Prefer created_at (full ISO timestamp) over time field (HH:MM only)
          var dateStr=o.created_at||o.time||"";
          if(!dateStr)return orderDateFilter==="today"; // assume today if no date info
          var d=new Date(dateStr);
          if(isNaN(d.getTime())){
            // If just HH:MM, treat as today (legacy data)
            if(/^\d{1,2}:\d{2}/.test(String(o.time||"")))return orderDateFilter==="today";
            return false;
          }
          var dStr=d.toISOString().split("T")[0];
          if(orderDateFilter==="today")return dStr===todayStr;
          if(orderDateFilter==="yesterday")return dStr===yesterday;
          if(orderDateFilter==="week")return dStr>=weekAgo;
          if(orderDateFilter==="month")return dStr>=monthAgo;
          if(orderDateFilter==="custom"){
            if(orderCustomFrom&&dStr<orderCustomFrom)return false;
            if(orderCustomTo&&dStr>orderCustomTo)return false;
            return true;
          }
        }catch(e){return false;}
        return true;
      });
    }
    // Type filter
    if(orderTypeFilter!=="all")result=result.filter(o=>o.type===orderTypeFilter);
    // Status filter
    if(orderStatusFilter!=="all")result=result.filter(o=>o.status===orderStatusFilter);
    // Source filter
    if(orderSourceFilter!=="all")result=result.filter(o=>o.source===orderSourceFilter);
    return result;
  })();
  return <div className="page">
    {refundOrder&&<RefundVoidFlow order={refundOrder} branch={branches.find(b=>b.id===refundOrder.branchId)} user={user} push={push} onClose={()=>setRefundOrder(null)} onDone={(result)=>{
      // Update order status to cancelled if void or full refund
      if(result.statusUpdate&&result.statusUpdate==="cancelled"){
        // Update local state
        var updatedOrder={...refundOrder,status:"cancelled",voidReason:result.reason,voidApprovedBy:result.manager,voidType:result.voidType,voidAmount:result.amount};
        setOrders(os=>os.map(o=>o.id===refundOrder.id?updatedOrder:o));
        // Save to database so it persists on refresh
        dbUpdateOrderStatus(refundOrder.id,"cancelled").catch(e=>console.log("Failed to save cancelled status:",e));
      }else if(result.voidType==="partial-refund"||result.voidType==="voucher"){
        // Partial refund or voucher - keep order active but log it
        var partial={...refundOrder,voidReason:result.reason,voidApprovedBy:result.manager,voidType:result.voidType,voidAmount:result.amount};
        setOrders(os=>os.map(o=>o.id===refundOrder.id?partial:o));
      }
      // Note: Auto-print removed - print prompt now appears in the flow itself
    }}/>}
    
    {showAddExpense&&<ExpenseForm
      categories={expenseCategories}
      branch={branch}
      user={user}
      editing={editingExpense}
      onCancel={()=>{setShowAddExpense(false);setEditingExpense(null);}}
      onSave={(saved)=>{
        if(editingExpense){
          setExpenses(es=>es.map(x=>x.id===saved.id?saved:x));
        }else{
          setExpenses(es=>[saved,...es]);
        }
        setShowAddExpense(false);
        setEditingExpense(null);
        push&&push({title:"Expense saved",body:saved.description+" - "+fmt(saved.amount),color:"#dc2626"});
      }}
    />}
    
    {showCategoryManager&&<CategoryManager
      categories={expenseCategories}
      branch={branch}
      onClose={()=>setShowCategoryManager(false)}
      onUpdate={(cats)=>setExpenseCategories(cats)}
      push={push}
    />}
    
    {showRecurringManager&&<RecurringExpensesManager
      list={recurringExpenses}
      categories={expenseCategories}
      branch={branch}
      onClose={()=>setShowRecurringManager(false)}
      onUpdate={(rec)=>setRecurringExpenses(rec)}
      push={push}
    />}
    
    {showPLStatement&&<PLStatement
      orders={fil}
      expenses={expenses}
      fromDate={financeFromDate}
      toDate={financeToDate}
      branch={branch}
      onClose={()=>setShowPLStatement(false)}
    />}
    
    {/* BEAUTIFUL ADMIN HEADER */}
    <div style={{background:"linear-gradient(135deg,#1a1208 0%,#3d2818 50%,#5d3a1f 100%)",borderRadius:14,padding:"18px 22px",marginBottom:14,color:"#fff",position:"relative",overflow:"hidden",boxShadow:"0 8px 24px rgba(0,0,0,.15)"}}>
      <div style={{position:"absolute",top:-30,right:-30,width:140,height:140,borderRadius:"50%",background:"radial-gradient(circle,rgba(212,149,42,.3),transparent 70%)"}}></div>
      <div style={{position:"absolute",bottom:-20,left:-20,width:90,height:90,borderRadius:"50%",background:"radial-gradient(circle,rgba(191,70,38,.2),transparent 70%)"}}></div>
      <div style={{position:"relative",zIndex:1,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12}}>
        <div>
          <p style={{fontSize:10,color:"#d4952a",letterSpacing:2.5,fontWeight:700,textTransform:"uppercase",marginBottom:4}}>{String.fromCharCode(0x2699,0xFE0F)} Admin Dashboard</p>
          <h2 style={{fontSize:22,fontWeight:700,marginBottom:3,fontFamily:"Georgia,serif"}}>{(window.__currentRestaurant?.name)||"Restaurant"}</h2>
          <p style={{color:"rgba(255,255,255,.7)",fontSize:11}}>{branches.length} Branch{branches.length!==1?"es":""} {String.fromCharCode(0x2022)} {fil.length} Order{fil.length!==1?"s":""} Today</p>
        </div>
        <select className="field" value={bf} onChange={e=>setBF(e.target.value)} style={{width:"auto",padding:"8px 13px",fontSize:12,background:"rgba(255,255,255,.95)",border:"none",borderRadius:8,fontWeight:600}}>
          <option value="all">{String.fromCharCode(0xD83C,0xDFEA)} All Branches</option>
          {branches.map(b=><option key={b.id} value={b.id}>{String.fromCharCode(0xD83D,0xDCCD)} {b.name}</option>)}
        </select>
      </div>
    </div>
    
    {/* BEAUTIFUL STAT CARDS */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:9,marginBottom:14}}>
      {[
        {label:"Revenue",value:fmt(rev),color:"#059669",bg:"linear-gradient(135deg,#d1fae5,#a7f3d0)",icon:String.fromCharCode(0xD83D,0xDCB0),border:"#10b981"},
        {label:"Pending",value:fil.filter(o=>o.status==="pending").length,color:"#d97706",bg:"linear-gradient(135deg,#fef3c7,#fde68a)",icon:String.fromCharCode(0x23F3),border:"#f59e0b"},
        {label:"Preparing",value:fil.filter(o=>o.status==="preparing").length,color:"#2563eb",bg:"linear-gradient(135deg,#dbeafe,#bfdbfe)",icon:String.fromCharCode(0xD83D,0xDC68,0x200D,0xD83C,0xDF73),border:"#3b82f6"},
        {label:"Ready",value:fil.filter(o=>o.status==="ready").length,color:"#16a34a",bg:"linear-gradient(135deg,#dcfce7,#bbf7d0)",icon:String.fromCharCode(0x2705),border:"#22c55e"},
        {label:"Total Orders",value:fil.length,color:"#bf4626",bg:"linear-gradient(135deg,#fee2e2,#fecaca)",icon:String.fromCharCode(0xD83D,0xDCE6),border:"#ef4444"},
      ].map(s=><div key={s.label} style={{background:s.bg,borderRadius:11,padding:"12px 13px",border:"2px solid "+s.border+"40",position:"relative",overflow:"hidden",transition:"transform .2s,box-shadow .2s",cursor:"default"}} onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-2px)";e.currentTarget.style.boxShadow="0 6px 16px rgba(0,0,0,.08)";}} onMouseLeave={e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="";}}>
        <div style={{position:"absolute",top:9,right:11,fontSize:20,opacity:.5}}>{s.icon}</div>
        <p style={{fontSize:10,color:s.color,fontWeight:700,letterSpacing:1,textTransform:"uppercase",marginBottom:3,opacity:.85}}>{s.label}</p>
        <p style={{fontSize:20,fontWeight:700,color:s.color}}>{s.value}</p>
      </div>)}
    </div>
    
    {/* BEAUTIFUL TAB NAVIGATION - touch-friendly */}
    <div style={{background:"#fff",borderRadius:13,padding:9,marginBottom:14,boxShadow:"0 2px 8px rgba(0,0,0,.04)",overflow:"hidden"}}>
      <div style={{display:"flex",gap:5,overflowX:"auto",paddingBottom:3}}>
        {TABS.map(([k,l])=>{
          var tabIcons={orders:String.fromCharCode(0xD83D,0xDCE6),analytics:String.fromCharCode(0xD83D,0xDCCA),finance:String.fromCharCode(0xD83D,0xDCB0),customers:String.fromCharCode(0xD83D,0xDC64),settings:String.fromCharCode(0x2699,0xFE0F),menu:String.fromCharCode(0xD83C,0xDF7D,0xFE0F),categories:String.fromCharCode(0xD83D,0xDCC1),combos:String.fromCharCode(0xD83C,0xDF7D,0xFE0F),tables:String.fromCharCode(0xD83E,0xDE91),stations:String.fromCharCode(0xD83D,0xDD25),delivery:String.fromCharCode(0xD83D,0xDEF5),staff:String.fromCharCode(0xD83D,0xDC65),marketing:String.fromCharCode(0xD83D,0xDCE3),codes:String.fromCharCode(0xD83C,0xDFAB),autodisc:String.fromCharCode(0xD83C,0xDF81),cash:String.fromCharCode(0xD83D,0xDCB5),shifts:String.fromCharCode(0xD83D,0xDD52),stock:String.fromCharCode(0x2705),discounts:String.fromCharCode(0xD83C,0xDFF7,0xFE0F),hours:String.fromCharCode(0xD83D,0xDD56)};
          return <button key={k} onClick={()=>setTab(k)} style={{padding:"13px 18px",borderRadius:10,fontWeight:700,fontSize:13.5,whiteSpace:"nowrap",border:"none",background:tab===k?"linear-gradient(135deg,#1a1208,#3d2818)":"#f7f3ee",color:tab===k?"#fff":"#5d4e3e",cursor:"pointer",flexShrink:0,transition:"all .15s",display:"flex",alignItems:"center",gap:7,boxShadow:tab===k?"0 3px 10px rgba(26,18,8,.25)":"none",minHeight:50}}>
            <span style={{fontSize:17}}>{tabIcons[k]||String.fromCharCode(0x2022)}</span>
            <span>{l}</span>
          </button>;
        })}
      </div>
    </div>
    {tab==="orders"&&<div>
      {/* Search Bar */}
      <div className="card" style={{marginBottom:10,padding:12}}>
        <div style={{display:"flex",gap:6,alignItems:"center",marginBottom:8,flexWrap:"wrap"}}>
          <div style={{flex:1,minWidth:240,position:"relative"}}>
            <input value={orderSearch} onChange={e=>setOrderSearch(e.target.value)} placeholder="Search by order#, name, phone, address, item, code..." className="field" style={{paddingLeft:34,paddingRight:orderSearch?32:10,fontSize:13}}/>
            <span style={{position:"absolute",left:11,top:"50%",transform:"translateY(-50%)",fontSize:14,color:"#8a8078",pointerEvents:"none"}}>{String.fromCharCode(0xD83D,0xDD0D)}</span>
            {orderSearch&&<button onClick={()=>setOrderSearch("")} style={{position:"absolute",right:8,top:"50%",transform:"translateY(-50%)",background:"#ede8de",border:"none",width:22,height:22,borderRadius:11,cursor:"pointer",fontWeight:700,color:"#8a8078",fontSize:11}}>x</button>}
          </div>
          {(orderSearch||orderDateFilter!=="all"||orderTypeFilter!=="all"||orderStatusFilter!=="all"||orderSourceFilter!=="all")&&<button onClick={()=>{setOrderSearch("");setOrderDateFilter("all");setOrderTypeFilter("all");setOrderStatusFilter("all");setOrderSourceFilter("all");setOrderCustomFrom("");setOrderCustomTo("");}} style={{padding:"7px 12px",background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:7,fontSize:11,fontWeight:700,cursor:"pointer"}}>Clear All</button>}
        </div>

        {/* Filter chips */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:6}}>
          <div>
            <p style={{fontSize:9,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3}}>DATE</p>
            <select className="field" value={orderDateFilter} onChange={e=>setOrderDateFilter(e.target.value)} style={{fontSize:12,padding:"6px 8px"}}>
              <option value="all">All time</option>
              <option value="today">Today</option>
              <option value="yesterday">Yesterday</option>
              <option value="week">Last 7 days</option>
              <option value="month">Last 30 days</option>
              <option value="custom">Custom range</option>
            </select>
          </div>
          <div>
            <p style={{fontSize:9,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3}}>TYPE</p>
            <select className="field" value={orderTypeFilter} onChange={e=>setOrderTypeFilter(e.target.value)} style={{fontSize:12,padding:"6px 8px"}}>
              <option value="all">All types</option>
              <option value="dine-in">Dine In</option>
              <option value="takeaway">Takeaway</option>
              <option value="delivery">Delivery</option>
              <option value="collection">Collection</option>
              <option value="eatin">QR Eat-In</option>
            </select>
          </div>
          <div>
            <p style={{fontSize:9,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3}}>STATUS</p>
            <select className="field" value={orderStatusFilter} onChange={e=>setOrderStatusFilter(e.target.value)} style={{fontSize:12,padding:"6px 8px"}}>
              <option value="all">All statuses</option>
              <option value="pending">Pending</option>
              <option value="preparing">Preparing</option>
              <option value="ready">Ready</option>
              <option value="out_for_delivery">Out for Delivery</option>
              <option value="delivered">Delivered</option>
              <option value="collected">Collected</option>
              <option value="cancelled">Cancelled</option>
            </select>
          </div>
          <div>
            <p style={{fontSize:9,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3}}>SOURCE</p>
            <select className="field" value={orderSourceFilter} onChange={e=>setOrderSourceFilter(e.target.value)} style={{fontSize:12,padding:"6px 8px"}}>
              <option value="all">All sources</option>
              <option value="online">Customer Online</option>
              <option value="qr-table">QR Code Table</option>
              <option value="staff">Staff POS</option>
              <option value="phone">Phone Order</option>
            </select>
          </div>
        </div>

        {/* Custom date range */}
        {orderDateFilter==="custom"&&<div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,marginTop:7}}>
          <div>
            <p style={{fontSize:9,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3}}>FROM</p>
            <input type="date" value={orderCustomFrom} onChange={e=>setOrderCustomFrom(e.target.value)} className="field" style={{fontSize:12,padding:"6px 8px"}}/>
          </div>
          <div>
            <p style={{fontSize:9,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3}}>TO</p>
            <input type="date" value={orderCustomTo} onChange={e=>setOrderCustomTo(e.target.value)} className="field" style={{fontSize:12,padding:"6px 8px"}}/>
          </div>
        </div>}

        {/* Result count */}
        <div style={{marginTop:9,padding:"7px 11px",background:"#f7f3ee",borderRadius:7,fontSize:11,color:"#8a8078",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span><strong style={{color:"#1a1208"}}>{searchedOrders.length}</strong> order{searchedOrders.length!==1?"s":""} found {fil.length!==searchedOrders.length?"(of "+fil.length+" total)":""}</span>
          {searchedOrders.length>0&&<span style={{fontWeight:700,color:"#bf4626"}}>Total: {fmt(searchedOrders.reduce((s,o)=>s+(parseFloat(o.total)||0),0))}</span>}
        </div>
      </div>

      {/* Order list */}
      {searchedOrders.length===0?<div className="card" style={{textAlign:"center",padding:40,color:"#8a8078"}}>
        <p style={{fontSize:36,marginBottom:9}}>{String.fromCharCode(0xD83D,0xDD0D)}</p>
        <p style={{fontSize:14,fontWeight:700,marginBottom:4}}>No orders found</p>
        <p style={{fontSize:12}}>Try adjusting your search or filters</p>
      </div>:allSt.map(st=>{
        var grp=searchedOrders.filter(o=>o.status===st);
        if(!grp.length)return null;
        return <div key={st} style={{marginBottom:14}}>
          <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
            <span className="bdg" style={{background:SB[st],color:SC[st]}}>{SL[st]}</span>
            <span style={{color:"#8a8078",fontSize:11}}>{grp.length}</span>
          </div>
          <div className="ag">{grp.map(o=><div key={o.id} className="card" style={{padding:"11px 13px"}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
              <div style={{flex:1,minWidth:0}}>
                <p style={{fontWeight:700,fontSize:13}}>{o.id}</p>
                <p style={{fontSize:10,color:"#8a8078"}}>{o.customer} - {(()=>{
                  try{
                    if(o.created_at){
                      var d=new Date(o.created_at);
                      if(!isNaN(d.getTime())){
                        var today=new Date().toISOString().split("T")[0];
                        var yest=new Date(Date.now()-86400000).toISOString().split("T")[0];
                        var dStr=d.toISOString().split("T")[0];
                        var tm=d.toLocaleTimeString("en-GB",{hour:"2-digit",minute:"2-digit"});
                        if(dStr===today)return "Today "+tm;
                        if(dStr===yest)return "Yesterday "+tm;
                        return d.toLocaleDateString("en-GB",{day:"numeric",month:"short"})+" "+tm;
                      }
                    }
                  }catch(e){}
                  return o.time||"";
                })()}</p>
                {o.phone&&<p style={{fontSize:10,color:"#8a8078"}}>{EM.phone} {o.phone}</p>}
                {o.address&&typeof o.address==="object"&&<p style={{fontSize:10,color:"#8a8078"}}>{EM.pin} {o.address.line1}, {o.address.postcode}</p>}
                <p style={{fontSize:9,color:"#8a8078",marginTop:2}}>
                  {o.source==="online"?String.fromCharCode(0xD83C,0xDF10)+" Online":""}
                  {o.source==="qr-table"?String.fromCharCode(0xD83D,0xDCF1)+" QR Table":""}
                  {o.source==="staff"?String.fromCharCode(0xD83D,0xDC68)+" Staff":""}
                  {o.source==="phone"?EM.phone+" Phone":""}
                  {" - "+(o.type||"")}
                  {o.takenBy?" - by "+o.takenBy:""}
                </p>
                {o.assignedDriverName&&<p style={{fontSize:10,color:o.status==="out_for_delivery"?"#2563eb":"#0891b2",fontWeight:700,marginTop:2}}>{o.status==="out_for_delivery"?String.fromCharCode(0xD83D,0xDEF5)+" "+o.assignedDriverName+" - on the way":String.fromCharCode(0x270B)+" Claimed by "+o.assignedDriverName}</p>}
              </div>
              <div style={{textAlign:"right"}}>
                <p style={{fontWeight:700,color:"#bf4626",fontSize:13}}>{fmt(o.total)}</p>
                <span style={{fontSize:10,color:o.paid?"#059669":"#dc2626",fontWeight:600}}>{o.paid?"Paid"+(o.payMethod?" "+o.payMethod:""):"Unpaid"}</span>
                {o.deliveryCode&&<p style={{fontSize:10,color:"#7c3aed",fontWeight:700,fontFamily:"'Courier New',monospace",marginTop:1}}>Code: {o.deliveryCode}</p>}
              </div>
            </div>
            <p style={{fontSize:11,color:"#8a8078",marginBottom:6}}>{(o.items||[]).map(i=>i.name+"x"+i.qty).join(", ")}</p>
            {o.notes&&<p style={{fontSize:10,color:"#92400e",background:"#fef3c7",padding:"4px 7px",borderRadius:5,marginBottom:6,fontStyle:"italic"}}>Note: {o.notes}</p>}
            {(o.status==="cancelled"||o.voidType==="partial-refund"||o.voidType==="voucher")&&<div style={{padding:"7px 10px",background:o.voidType==="voucher"?"#f5f3ff":"#fee2e2",border:"2px solid "+(o.voidType==="voucher"?"#7c3aed":"#dc2626"),borderRadius:6,marginBottom:6}}>
              <p style={{fontSize:11,color:o.voidType==="voucher"?"#5b21b6":"#991b1b",fontWeight:700}}>{o.voidType==="voucher"?String.fromCharCode(0xD83C,0xDF81)+" VOUCHER ISSUED":(String.fromCharCode(0x274C)+" "+(o.voidType==="refund"?"REFUNDED":(o.voidType==="partial-refund"?"PARTIALLY REFUNDED":"VOIDED")))}{o.voidAmount?" - "+fmt(o.voidAmount):""}</p>
              {o.voidReason&&<p style={{fontSize:10,color:o.voidType==="voucher"?"#7c3aed":"#7f1d1d",marginTop:2}}>Reason: {o.voidReason}</p>}
              {o.voidApprovedBy&&<p style={{fontSize:10,color:o.voidType==="voucher"?"#7c3aed":"#7f1d1d",marginTop:1}}>Approved by: {o.voidApprovedBy}</p>}
            </div>}
            <div style={{display:"flex",gap:3,flexWrap:"wrap"}}>
              {o.status!=="cancelled"&&allSt.filter(s=>s!==o.status&&s!=="cancelled").map(s=><button key={s} onClick={()=>upSt(o.id,s)} style={{padding:"2px 6px",borderRadius:5,fontSize:10,fontWeight:600,border:"1px solid "+SC[s],color:SC[s],background:SB[s],cursor:"pointer"}}>{SL[s]}</button>)}
            </div>
            <div style={{display:"flex",gap:6,marginTop:4,flexWrap:"wrap"}}>
              <button onClick={()=>printR(o,branches.find(b=>b.id===o.branchId))} style={{fontSize:10,color:"#8a8078",border:"none",background:"none",cursor:"pointer"}}>{String.fromCharCode(0xD83D,0xDDA8,0xFE0F)} Receipt</button>
              <button onClick={()=>printKitchenTicket(o,branches.find(b=>b.id===o.branchId))} style={{fontSize:10,color:"#8a8078",border:"none",background:"none",cursor:"pointer"}}>{String.fromCharCode(0xD83C,0xDF73)} Kitchen Ticket</button>
              {o.voidType==="voucher"&&<button onClick={()=>printVoucherReceipt(o,branches.find(b=>b.id===o.branchId))} style={{fontSize:10,color:"#7c3aed",border:"none",background:"none",cursor:"pointer",fontWeight:700}}>{String.fromCharCode(0xD83C,0xDF81)} Voucher Receipt</button>}
              {(o.status==="cancelled"||o.voidType==="partial-refund")&&o.voidType!=="voucher"&&<button onClick={()=>printRefundReceipt(o,branches.find(b=>b.id===o.branchId))} style={{fontSize:10,color:"#dc2626",border:"none",background:"none",cursor:"pointer",fontWeight:700}}>{String.fromCharCode(0xD83D,0xDCB0)} Refund Receipt</button>}
              {o.status!=="cancelled"&&<button onClick={()=>setRefundOrder(o)} style={{fontSize:10,color:"#dc2626",border:"none",background:"none",cursor:"pointer",fontWeight:700}}>{String.fromCharCode(0xD83D,0xDD12)} Void/Refund</button>}
            </div>
          </div>)}</div>
        </div>;
      })}
    </div>}
    {tab==="customers"&&(()=>{
      // Build customer list from orders - aggregate by phone/name
      var custMap={};
      (orders||[]).forEach(function(o){
        if(o.status==="cancelled")return;
        var key=(o.phone||o.customer||"unknown").toLowerCase().trim();
        if(!custMap[key]){
          custMap[key]={
            name:o.customer||"Guest",
            phone:o.phone||"",
            address:o.address||null,
            orderCount:0,
            totalSpent:0,
            lastOrder:null,
            types:{},
          };
        }
        var c=custMap[key];
        c.orderCount++;
        c.totalSpent+=parseFloat(o.total||0);
        if(o.customer&&o.customer!=="Guest")c.name=o.customer;
        if(o.phone)c.phone=o.phone;
        if(o.address)c.address=o.address;
        if(o.type)c.types[o.type]=(c.types[o.type]||0)+1;
        var od=o.created_at?new Date(o.created_at):null;
        if(od&&(!c.lastOrder||od>c.lastOrder))c.lastOrder=od;
      });
      var custListAll=Object.values(custMap).filter(function(c){return c.phone||c.name!=="Guest";});
      custListAll.sort(function(a,b){return b.totalSpent-a.totalSpent;});
      
      // Apply search filter - name, phone, address, postcode
      var cq=custSearch.trim().toLowerCase();
      var custList=cq?custListAll.filter(function(c){
        var addr=c.address||{};
        var addrStr=[addr.line1,addr.line2,addr.city,addr.postcode].filter(Boolean).join(" ").toLowerCase();
        return (c.name||"").toLowerCase().includes(cq)||
               (c.phone||"").toLowerCase().includes(cq)||
               addrStr.includes(cq);
      }):custListAll;
      
      // Export function - downloads CSV of contacts
      var exportContacts=function(){
        var rows=[["Name","Phone","Address","Orders","Total Spent","Last Order"]];
        custListAll.forEach(function(c){
          var addr=c.address||{};
          var addrLine=[addr.line1,addr.city,addr.postcode].filter(Boolean).join(" ");
          rows.push([
            c.name||"",
            c.phone||"",
            addrLine,
            c.orderCount,
            c.totalSpent.toFixed(2),
            c.lastOrder?c.lastOrder.toLocaleDateString("en-GB"):"",
          ]);
        });
        var csv=rows.map(function(r){
          return r.map(function(cell){
            var s=String(cell);
            // Escape quotes and wrap if contains comma
            if(s.includes(",")||s.includes('"')||s.includes("\n")){
              return '"'+s.replace(/"/g,'""')+'"';
            }
            return s;
          }).join(",");
        }).join("\n");
        var blob=new Blob([csv],{type:"text/csv;charset=utf-8;"});
        var url=URL.createObjectURL(blob);
        var a=document.createElement("a");
        a.href=url;
        a.download="customers-"+new Date().toISOString().split("T")[0]+".csv";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      };
      
      // Export: OWNER only by default. Owner can grant a manager access via the 'export_customers' permission.
      var custActiveStaff=(typeof window!=="undefined")?dbGetActiveStaff():null;
      // No active staff = owner is logged in directly = can export
      // Active staff = only if owner gave them the export_customers permission
      var canExport=!custActiveStaff || (custActiveStaff.permissions&&custActiveStaff.permissions.export_customers===true);
      
      return <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,flexWrap:"wrap",gap:8}}>
          <div>
            <h3 style={{fontSize:18,fontWeight:700}}>Customers</h3>
            <p style={{fontSize:12,color:"#8a8078"}}>{custListAll.length} customers from order history</p>
          </div>
          {canExport&&<button onClick={exportContacts} style={{padding:"10px 16px",background:"linear-gradient(135deg,#059669,#047857)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer",display:"flex",alignItems:"center",gap:6}}>
            <span style={{fontSize:15}}>{String.fromCharCode(0xD83D,0xDCE5)}</span>
            <span>Export CSV</span>
          </button>}
        </div>
        
        {canExport&&<div style={{padding:"8px 12px",background:"#fffbeb",border:"1px solid #fde68a",borderRadius:8,marginBottom:12,fontSize:11,color:"#92400e"}}>
          {String.fromCharCode(0x26A0,0xFE0F)} Customer data is confidential. Handle exported files securely and in line with GDPR. Do not share customer contact details.
        </div>}
        
        {/* Search bar */}
        <div style={{marginBottom:14,position:"relative"}}>
          <input value={custSearch} onChange={function(e){setCustSearch(e.target.value);}} placeholder={String.fromCharCode(0xD83D,0xDD0D)+" Search by name, phone, address or postcode..."} style={{width:"100%",padding:"12px 14px",border:"2px solid #ede8de",borderRadius:9,fontSize:14,boxSizing:"border-box"}}/>
          {custSearch&&<button onClick={function(){setCustSearch("");}} style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:6,padding:"4px 9px",fontSize:11,fontWeight:700,cursor:"pointer"}}>Clear</button>}
        </div>
        {cq&&<p style={{fontSize:12,color:"#8a8078",marginBottom:10}}>Showing {custList.length} of {custListAll.length} customers</p>}
        
        {custList.length===0?
          <div className="card" style={{textAlign:"center",padding:30}}>
            <div style={{fontSize:40,marginBottom:8}}>{cq?String.fromCharCode(0xD83D,0xDD0D):String.fromCharCode(0xD83D,0xDC64)}</div>
            <p style={{fontSize:14,fontWeight:700,marginBottom:3}}>{cq?"No matching customers":"No customers yet"}</p>
            <p style={{fontSize:12,color:"#8a8078"}}>{cq?"Try a different name, phone, address or postcode":"Customers appear here automatically as orders come in"}</p>
          </div>
          :
          <div style={{display:"grid",gap:9}}>
            {custList.map(function(c,i){
              var addr=c.address||{};
              var addrLine=[addr.line1,addr.city,addr.postcode].filter(Boolean).join(", ");
              var typeList=Object.keys(c.types).map(function(t){return t+" ("+c.types[t]+")";}).join(", ");
              return <div key={i} className="card" style={{padding:14}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:8}}>
                  <div style={{flex:1,minWidth:180}}>
                    <p style={{fontWeight:700,fontSize:15}}>{c.name}</p>
                    {c.phone&&<p style={{fontSize:13,marginTop:3}}><a href={"tel:"+c.phone} style={{color:"#2563eb",fontWeight:600,textDecoration:"none"}}>{String.fromCharCode(0xD83D,0xDCDE)} {c.phone}</a></p>}
                    {addrLine&&<p style={{fontSize:12,color:"#8a8078",marginTop:3}}>{String.fromCharCode(0xD83D,0xDCCD)} {addrLine}</p>}
                    {typeList&&<p style={{fontSize:11,color:"#8a8078",marginTop:3}}>{typeList}</p>}
                  </div>
                  <div style={{textAlign:"right"}}>
                    <p style={{fontSize:18,fontWeight:700,color:"#bf4626"}}>{fmt(c.totalSpent)}</p>
                    <p style={{fontSize:11,color:"#8a8078"}}>{c.orderCount} order{c.orderCount!==1?"s":""}</p>
                    {c.lastOrder&&<p style={{fontSize:10,color:"#8a8078",marginTop:2}}>Last: {c.lastOrder.toLocaleDateString("en-GB",{day:"numeric",month:"short"})}</p>}
                  </div>
                </div>
                {/* Quick actions */}
                <div style={{display:"flex",gap:6,marginTop:10}}>
                  {c.phone&&<a href={"tel:"+c.phone} style={{flex:1,padding:"8px",background:"#2563eb",color:"#fff",borderRadius:7,fontWeight:700,fontSize:12,textAlign:"center",textDecoration:"none"}}>{String.fromCharCode(0xD83D,0xDCDE)} Call</a>}
                  {c.phone&&<a href={"sms:"+c.phone} style={{flex:1,padding:"8px",background:"#7c3aed",color:"#fff",borderRadius:7,fontWeight:700,fontSize:12,textAlign:"center",textDecoration:"none"}}>{String.fromCharCode(0xD83D,0xDCAC)} Text</a>}
                </div>
              </div>;
            })}
          </div>
        }
      </div>;
    })()}
    
    {tab==="analytics"&&<div className="g2"><div className="card"><h3 style={{fontSize:15,marginBottom:10}}>Revenue</h3><p style={{fontSize:26,fontWeight:700,color:"#bf4626"}}>{fmt(rev)}</p><p style={{fontSize:12,color:"#8a8078",marginTop:4}}>Avg: {fmt(fil.length?rev/fil.length:0)}</p></div><div className="card"><h3 style={{fontSize:15,marginBottom:10}}>Order Types</h3>{[["Dine In","dine-in"],["Takeaway","takeaway"],["Collection","collection"]].map(([l,t])=>{var c=fil.filter(o=>o.type===t).length;return <div key={t} style={{marginBottom:7}}><div style={{display:"flex",justifyContent:"space-between",fontSize:12,marginBottom:2}}><span style={{fontWeight:600}}>{l}</span><span style={{color:"#8a8078"}}>{c}</span></div><div style={{height:4,background:"#f7f3ee",borderRadius:2,overflow:"hidden"}}><div style={{height:"100%",background:"#bf4626",width:Math.max(fil.length,1)?Math.round((c/Math.max(fil.length,1))*100)+"%":"0%",borderRadius:2}}/></div></div>;})}</div></div>}
    {tab==="menu"&&(()=>{
      // Apply filters
      var q=menuSearch.trim().toLowerCase();
      var filtered=menu.filter(item=>{
        if(menuFilterCat!=="all"&&item.cat!==menuFilterCat)return false;
        if(menuFilterStation!=="all"){
          if(menuFilterStation==="none"&&item.station)return false;
          else if(menuFilterStation!=="none"&&item.station!==menuFilterStation)return false;
        }
        if(menuFilterStatus==="available"&&!item.avail)return false;
        if(menuFilterStatus==="unavailable"&&item.avail)return false;
        if(menuFilterStatus==="lowstock"&&(item.stock>5||item.stock===0))return false;
        if(menuFilterStatus==="soldout"&&item.stock!==0)return false;
        if(q){
          var hay=(item.name+" "+(item.desc||"")+" "+(item.cat||"")).toLowerCase();
          if(!hay.includes(q))return false;
        }
        return true;
      });
      // Apply sort
      filtered=[...filtered].sort((a,b)=>{
        if(menuSort==="az")return a.name.localeCompare(b.name);
        if(menuSort==="za")return b.name.localeCompare(a.name);
        if(menuSort==="cheap")return (+a.price||0)-(+b.price||0);
        if(menuSort==="expensive")return (+b.price||0)-(+a.price||0);
        if(menuSort==="cat")return (a.cat||"").localeCompare(b.cat||"")||a.name.localeCompare(b.name);
        return 0;
      });

      // Highlight match in name
      var hl=(text)=>{
        if(!q||!text)return text;
        var idx=text.toLowerCase().indexOf(q);
        if(idx<0)return text;
        return <>{text.slice(0,idx)}<mark style={{background:"#fef3c7",padding:0}}>{text.slice(idx,idx+q.length)}</mark>{text.slice(idx+q.length)}</>;
      };

      var hasActiveFilter=q||menuFilterCat!=="all"||menuFilterStation!=="all"||menuFilterStatus!=="all";
      return <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,flexWrap:"wrap",gap:8}}>
          <div><h3 style={{fontSize:16}}>Menu Items <span style={{color:"#8a8078",fontWeight:400}}>({filtered.length}{filtered.length!==menu.length?" of "+menu.length:""})</span></h3><p style={{fontSize:11,color:"#8a8078"}}>Tap a card to edit, or add new items</p></div>
          <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
            <button onClick={()=>setShowImport(true)} style={{padding:"8px 14px",fontSize:13,fontWeight:700,background:"linear-gradient(135deg,#7c3aed,#a855f7)",color:"#fff",border:"none",borderRadius:9,cursor:"pointer"}}>{EM.party} Import with AI</button>
            <button className="btn btn-r" onClick={()=>setEditItem({})} style={{padding:"8px 16px",fontSize:13}}>+ Add New Item</button>
          </div>
        </div>

        <div className="card" style={{padding:12,marginBottom:12}}>
          <div style={{position:"relative",marginBottom:8}}>
            <input value={menuSearch} onChange={e=>setMenuSearch(e.target.value)} placeholder="Search by name, description, or category..." className="field" style={{paddingLeft:36,paddingRight:menuSearch?36:12,fontSize:13}}/>
            <span style={{position:"absolute",left:12,top:"50%",transform:"translateY(-50%)",fontSize:16,color:"#8a8078",pointerEvents:"none"}}>{String.fromCharCode(0x1F50D >> 10) + String.fromCharCode(0x1F50D & 0x3FF)}</span>
            {menuSearch&&<button onClick={()=>setMenuSearch("")} style={{position:"absolute",right:8,top:"50%",transform:"translateY(-50%)",background:"#ede8de",border:"none",width:24,height:24,borderRadius:12,cursor:"pointer",fontWeight:700,color:"#8a8078"}}>x</button>}
          </div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(150px,1fr))",gap:6}}>
            <select value={menuSort} onChange={e=>setMenuSort(e.target.value)} className="field" style={{fontSize:12}}>
              <option value="az">Sort: A to Z</option>
              <option value="za">Sort: Z to A</option>
              <option value="cat">Sort: by Category</option>
              <option value="cheap">Sort: Price low-high</option>
              <option value="expensive">Sort: Price high-low</option>
            </select>
            <select value={menuFilterCat} onChange={e=>setMenuFilterCat(e.target.value)} className="field" style={{fontSize:12}}>
              <option value="all">All Categories</option>
              {[...new Set(menu.map(m=>m.cat).filter(Boolean))].sort().map(c=><option key={c} value={c}>{c}</option>)}
            </select>
            <select value={menuFilterStation} onChange={e=>setMenuFilterStation(e.target.value)} className="field" style={{fontSize:12}}>
              <option value="all">All Stations</option>
              <option value="none">No Station Set</option>
              {(stations||[]).filter(s=>s.active!==false).map(s=><option key={s.dbId} value={s.name}>{s.name}</option>)}
            </select>
            <select value={menuFilterStatus} onChange={e=>setMenuFilterStatus(e.target.value)} className="field" style={{fontSize:12}}>
              <option value="all">All Status</option>
              <option value="available">Available</option>
              <option value="unavailable">Unavailable (86'd)</option>
              <option value="lowstock">Low Stock (1-5)</option>
              <option value="soldout">Sold Out (0)</option>
            </select>
          </div>
          {hasActiveFilter&&<button onClick={()=>{setMenuSearch("");setMenuFilterCat("all");setMenuFilterStation("all");setMenuFilterStatus("all");}} style={{marginTop:8,padding:"6px 11px",fontSize:11,fontWeight:700,background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:6,cursor:"pointer"}}>Clear all filters</button>}
        </div>

        {filtered.length===0?<div className="card" style={{textAlign:"center",padding:40}}>
          <p style={{fontSize:36,marginBottom:9}}>{EM.cross}</p>
          <p style={{fontSize:14,fontWeight:700,marginBottom:4}}>No items match your search</p>
          <p style={{fontSize:12,color:"#8a8078",marginBottom:11}}>Try a different search or clear filters</p>
          {hasActiveFilter&&<button onClick={()=>{setMenuSearch("");setMenuFilterCat("all");setMenuFilterStation("all");setMenuFilterStatus("all");}} className="btn btn-r" style={{padding:"8px 16px",fontSize:12}}>Clear All Filters</button>}
        </div>:<div className="ag">{filtered.map(item=><div key={item.id} className="card" style={{opacity:item.avail?1:.5,cursor:"pointer",transition:"transform .15s"}} onClick={()=>setEditItem(item)} onMouseEnter={e=>e.currentTarget.style.transform="translateY(-2px)"} onMouseLeave={e=>e.currentTarget.style.transform="translateY(0)"}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}><span style={{fontSize:26}}>{EM[item.icon]||""}</span><span style={{fontWeight:700,color:"#bf4626"}}>{fmt(item.price)}</span></div>
          <p style={{fontWeight:700,fontSize:13,marginBottom:1}}>{hl(item.name)}</p>
          <p style={{fontSize:10,color:"#8a8078",marginBottom:6}}>{item.cat}{item.station?" - "+item.station:""} - Stock: {item.stock}</p>
          {item.allergens&&item.allergens.length>0&&<p style={{fontSize:9,color:"#7c3aed",marginBottom:6,fontWeight:600}}>{item.allergens.length} dietary tag{item.allergens.length>1?"s":""}</p>}
          <div style={{display:"flex",gap:4}}>
            <button onClick={e=>{e.stopPropagation();setMenu(ms=>ms.map(m=>m.id===item.id?{...m,avail:!m.avail}:m));}} style={{flex:1,padding:"6px",borderRadius:7,fontWeight:600,fontSize:11,border:"2px solid",borderColor:item.avail?"#059669":"#ede8de",background:item.avail?"#d1fae5":"#f7f3ee",color:item.avail?"#065f46":"#8a8078",cursor:"pointer"}}>{item.avail?"Available":"86'd"}</button>
            <button onClick={e=>{e.stopPropagation();setEditItem(item);}} style={{padding:"6px 10px",borderRadius:7,background:"#1a1208",color:"#fff",border:"none",fontWeight:700,fontSize:11,cursor:"pointer"}}>Edit</button>
          </div>
        </div>)}</div>}
      </div>;
    })()}

    {tab==="combos"&&<div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,flexWrap:"wrap",gap:8}}>
        <div><h3 style={{fontSize:16}}>Set Meals & Combos ({setMeals.length})</h3><p style={{fontSize:11,color:"#8a8078"}}>Bundle items at a discounted price</p></div>
        <button className="btn btn-p" onClick={()=>setEditMeal({})} style={{padding:"8px 16px",fontSize:13}}>+ Create Combo</button>
      </div>
      {setMeals.length===0&&<div className="card" style={{textAlign:"center",padding:30,color:"#8a8078"}}><p style={{fontSize:14,marginBottom:4}}>No set meals yet</p><p style={{fontSize:12}}>Create combos to increase average order value</p></div>}
      <div className="ag">{setMeals.map(sm=>{
        var items=sm.itemIds.map(id=>menu.find(m=>m.id===id)).filter(Boolean);
        var reg=items.reduce((s,i)=>s+i.price,0), save=reg-sm.price;
        return <div key={sm.id} className="card" style={{opacity:sm.avail?1:.5,cursor:"pointer",borderLeft:"4px solid #7c3aed",transition:"transform .15s"}} onClick={()=>setEditMeal(sm)} onMouseEnter={e=>e.currentTarget.style.transform="translateY(-2px)"} onMouseLeave={e=>e.currentTarget.style.transform="translateY(0)"}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}><span style={{fontSize:26}}>{EM[sm.icon]||""}</span><div style={{textAlign:"right"}}><span style={{fontWeight:700,color:"#7c3aed",fontSize:14}}>{fmt(sm.price)}</span>{save>0&&<p style={{fontSize:10,color:"#059669",fontWeight:700}}>Save {fmt(save)}</p>}</div></div>
          <p style={{fontWeight:700,fontSize:13,marginBottom:2}}>{sm.name}</p>
          <p style={{fontSize:11,color:"#8a8078",marginBottom:6,lineHeight:1.4}}>{sm.desc}</p>
          <div style={{padding:"6px 8px",background:"#f5f0ff",borderRadius:6,marginBottom:8}}>
            {items.map(i=><div key={i.id} style={{fontSize:11,color:"#1a1208",display:"flex",gap:6,marginBottom:2}}><span>{EM[i.icon]||""}</span><span>{i.name}</span></div>)}
          </div>
          <div style={{display:"flex",gap:4}}>
            <button onClick={e=>{e.stopPropagation();setSetMeals(ms=>ms.map(m=>m.id===sm.id?{...m,avail:!m.avail}:m));}} style={{flex:1,padding:"6px",borderRadius:7,fontWeight:600,fontSize:11,border:"2px solid",borderColor:sm.avail?"#059669":"#ede8de",background:sm.avail?"#d1fae5":"#f7f3ee",color:sm.avail?"#065f46":"#8a8078",cursor:"pointer"}}>{sm.avail?"Active":"Inactive"}</button>
            <button onClick={e=>{e.stopPropagation();setEditMeal(sm);}} style={{padding:"6px 10px",borderRadius:7,background:"#7c3aed",color:"#fff",border:"none",fontWeight:700,fontSize:11,cursor:"pointer"}}>Edit</button>
          </div>
        </div>;
      })}</div>
    </div>}

    {tab==="categories"&&<div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,flexWrap:"wrap",gap:8}}>
        <div><h3 style={{fontSize:16}}>Menu Categories ({categories.length})</h3><p style={{fontSize:11,color:"#8a8078"}}>Organize your menu into sections</p></div>
        <button className="btn btn-r" onClick={()=>setEditCat({})} style={{padding:"8px 16px",fontSize:13}}>+ Add Category</button>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:10}}>
        {categories.slice().sort((a,b)=>a.order-b.order).map(c=>{
          var count=menu.filter(m=>m.cat===c.name).length;
          return <div key={c.id} className="card" style={{cursor:"pointer",borderLeft:"4px solid #d4952a",transition:"transform .15s"}} onClick={()=>setEditCat(c)} onMouseEnter={e=>e.currentTarget.style.transform="translateY(-2px)"} onMouseLeave={e=>e.currentTarget.style.transform="translateY(0)"}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
              <span style={{fontSize:28}}>{EM[c.icon]||""}</span>
              <span style={{fontSize:10,background:"#f7f3ee",padding:"2px 8px",borderRadius:10,color:"#8a8078",fontWeight:700}}>#{c.order}</span>
            </div>
            <p style={{fontWeight:700,fontSize:15,marginBottom:2}}>{c.name}</p>
            <p style={{fontSize:11,color:"#8a8078"}}>{count} item{count!==1?"s":""}</p>
          </div>;
        })}
      </div>
    </div>}

    {editItem&&<MenuEditor item={editItem} onSave={saveItem} onClose={()=>setEditItem(null)} onDelete={deleteItem} modifiers={MODIFIERS0} categories={categories} stations={stations}/>}
    {showQRGenerator&&restaurant&&<RestaurantQRGenerator restaurant={restaurant} onClose={()=>setShowQRGenerator(false)}/>}
    {editMeal&&<SetMealEditor meal={editMeal} menu={menu} onSave={saveMeal} onClose={()=>setEditMeal(null)} onDelete={deleteMeal}/>}
    {editCat&&<CategoryEditor cat={editCat} onSave={saveCat} onClose={()=>setEditCat(null)} onDelete={deleteCat} menu={menu}/>}
    {showImport&&<MenuImportModal onClose={()=>setShowImport(false)} onImport={bulkImport} categories={categories}/>}
    {editTable&&<TableEditor table={editTable} onSave={saveTable} onClose={()=>setEditTable(null)} existingTables={tables.filter(t=>t.branchId===adminBranch)}/>}
    {editCode&&<div onClick={()=>setEditCode(null)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:8500,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div onClick={e=>e.stopPropagation()} className="card" style={{width:"100%",maxWidth:460,padding:22,maxHeight:"90vh",overflowY:"auto"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
          <h2 style={{fontSize:20}}>{editCode.dbId?"Edit Code":"Create Promo Code"}</h2>
          <button onClick={()=>setEditCode(null)} style={{color:"#999",fontSize:22,border:"none",background:"none",cursor:"pointer"}}>x</button>
        </div>
        <div style={{marginBottom:10}}><label className="lbl">Code (customers type this)</label><input className="field" value={editCode.code||""} onChange={e=>setEditCode({...editCode,code:e.target.value.toUpperCase()})} placeholder="WELCOME10" style={{fontWeight:700,letterSpacing:1}}/></div>
        <div style={{marginBottom:10}}>
          <label className="lbl">Discount Type</label>
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:5}}>
            {[["percent","% off"],["fixed",EM.pound+" off"],["free_delivery","Free delivery"]].map(([k,l])=><button key={k} onClick={()=>setEditCode({...editCode,type:k})} style={{padding:"10px 4px",fontSize:12,fontWeight:700,background:editCode.type===k?"#bf4626":"#fff",color:editCode.type===k?"#fff":"#1a1208",border:"2px solid "+(editCode.type===k?"#bf4626":"#ede8de"),borderRadius:7,cursor:"pointer"}}>{l}</button>)}
          </div>
        </div>
        {editCode.type!=="free_delivery"&&<div style={{marginBottom:10}}><label className="lbl">{editCode.type==="percent"?"Percentage":"Amount"}</label><input type="number" step="0.01" className="field" value={editCode.value||""} onChange={e=>setEditCode({...editCode,value:+e.target.value})}/></div>}
        <div style={{marginBottom:10}}><label className="lbl">Description (shown to customer)</label><input className="field" value={editCode.description||""} onChange={e=>setEditCode({...editCode,description:e.target.value})} placeholder="10% off your first order"/></div>
        <div className="g2" style={{marginBottom:10}}>
          <div><label className="lbl">Min order {EM.pound}</label><input type="number" step="0.01" className="field" value={editCode.minOrder||0} onChange={e=>setEditCode({...editCode,minOrder:+e.target.value})}/></div>
          <div><label className="lbl">Max uses</label><input type="number" className="field" value={editCode.maxUses||100} onChange={e=>setEditCode({...editCode,maxUses:+e.target.value})}/></div>
        </div>
        <label style={{display:"flex",alignItems:"center",gap:8,marginBottom:8,cursor:"pointer"}}>
          <input type="checkbox" checked={editCode.firstOrderOnly||false} onChange={e=>setEditCode({...editCode,firstOrderOnly:e.target.checked})} style={{width:16,height:16,cursor:"pointer"}}/>
          <span style={{fontSize:13}}>First order only</span>
        </label>
        <label style={{display:"flex",alignItems:"center",gap:8,marginBottom:14,cursor:"pointer"}}>
          <input type="checkbox" checked={editCode.active!==false} onChange={e=>setEditCode({...editCode,active:e.target.checked})} style={{width:16,height:16,cursor:"pointer"}}/>
          <span style={{fontSize:13,fontWeight:700}}>Active</span>
        </label>
        <div style={{display:"flex",gap:7}}>
          <button className="btn btn-o" onClick={()=>setEditCode(null)} style={{flex:1,padding:"11px"}}>Cancel</button>
          <button className="btn btn-r" onClick={()=>{
            if(!editCode.code){alert("Code required");return;}
            dbSaveCode(editCode).then(r=>{
              if(r.error){push({title:"Save failed",body:r.error.message,color:"#dc2626"});return;}
              var saved={...editCode,dbId:r.data?.id||editCode.dbId};
              setPromoCodes(cs=>editCode.dbId?cs.map(x=>x.dbId===editCode.dbId?saved:x):[...cs,saved]);
              push({title:"Code saved",body:editCode.code,color:"#059669"});
              setEditCode(null);
            });
          }} style={{flex:2,padding:"11px"}}>Save Code</button>
        </div>
      </div>
    </div>}
    {editStation&&<div onClick={()=>setEditStation(null)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:8500,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div onClick={e=>e.stopPropagation()} className="card" style={{width:"100%",maxWidth:540,padding:22,maxHeight:"92vh",overflowY:"auto"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
          <h2 style={{fontSize:20}}>{editStation.dbId?"Edit Station":"New Station"}</h2>
          <button onClick={()=>setEditStation(null)} style={{color:"#999",fontSize:22,border:"none",background:"none",cursor:"pointer"}}>x</button>
        </div>
        <div className="g2" style={{marginBottom:10}}>
          <div><label className="lbl">Station Name</label><input className="field" value={editStation.name||""} onChange={e=>setEditStation({...editStation,name:e.target.value})} placeholder="Tandoor"/></div>
          <div><label className="lbl">Color</label><div style={{display:"flex",gap:5}}>
            <input type="color" value={editStation.color||"#bf4626"} onChange={e=>setEditStation({...editStation,color:e.target.value})} style={{width:46,height:38,border:"2px solid #ede8de",borderRadius:7,cursor:"pointer"}}/>
            <input className="field" value={editStation.color||""} onChange={e=>setEditStation({...editStation,color:e.target.value})} placeholder="#bf4626" style={{flex:1}}/>
          </div></div>
        </div>
        <label style={{display:"flex",alignItems:"center",gap:8,marginBottom:14,cursor:"pointer"}}>
          <input type="checkbox" checked={editStation.active!==false} onChange={e=>setEditStation({...editStation,active:e.target.checked})} style={{width:16,height:16,cursor:"pointer"}}/>
          <span style={{fontWeight:700}}>Active</span>
        </label>

        <div style={{padding:"11px 13px",background:"#fafaf5",borderRadius:9,marginBottom:10}}>
          <p style={{fontWeight:700,fontSize:13,marginBottom:8}}>Printer Setup</p>
          <label className="lbl">Print Method</label>
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:5,marginBottom:9}}>
            {[["none","No Printer"],["browser","Browser Print"],["printnode","PrintNode (auto)"]].map(([k,l])=><button key={k} onClick={()=>setEditStation({...editStation,printerMethod:k})} style={{padding:"9px 4px",fontSize:11,fontWeight:700,background:editStation.printerMethod===k?"#bf4626":"#fff",color:editStation.printerMethod===k?"#fff":"#1a1208",border:"2px solid "+(editStation.printerMethod===k?"#bf4626":"#ede8de"),borderRadius:7,cursor:"pointer"}}>{l}</button>)}
          </div>

          {editStation.printerMethod&&editStation.printerMethod!=="none"&&<>
            <label className="lbl">Paper Format</label>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:5,marginBottom:9}}>
              {[["thermal","Thermal 80mm"],["a4","A4 Standard"]].map(([k,l])=><button key={k} onClick={()=>setEditStation({...editStation,printerFormat:k})} style={{padding:"9px 4px",fontSize:11,fontWeight:700,background:editStation.printerFormat===k?"#7c3aed":"#fff",color:editStation.printerFormat===k?"#fff":"#1a1208",border:"2px solid "+(editStation.printerFormat===k?"#7c3aed":"#ede8de"),borderRadius:7,cursor:"pointer"}}>{l}</button>)}
            </div>

            <label className="lbl">What to print</label>
            <div style={{display:"grid",gridTemplateColumns:"1fr",gap:5,marginBottom:9}}>
              {[["station_only","Only this station's items"],["full_order","Full order (all items)"],["station_with_full_summary","Station items + summary of full order"]].map(([k,l])=><button key={k} onClick={()=>setEditStation({...editStation,printContent:k})} style={{padding:"8px 10px",fontSize:11,fontWeight:700,background:editStation.printContent===k?"#1a1208":"#fff",color:editStation.printContent===k?"#fff":"#1a1208",border:"2px solid "+(editStation.printContent===k?"#1a1208":"#ede8de"),borderRadius:7,cursor:"pointer",textAlign:"left"}}>{l}</button>)}
            </div>

            <div className="g2" style={{marginBottom:9}}>
              <div><label className="lbl">Copies</label><input type="number" min="1" max="5" className="field" value={editStation.copies||1} onChange={e=>setEditStation({...editStation,copies:+e.target.value})}/></div>
              <div>
                <label className="lbl">Auto-print</label>
                <button onClick={()=>setEditStation({...editStation,autoPrint:!editStation.autoPrint})} style={{width:"100%",padding:"9px",fontSize:12,fontWeight:700,background:editStation.autoPrint?"#059669":"#fff",color:editStation.autoPrint?"#fff":"#1a1208",border:"2px solid "+(editStation.autoPrint?"#059669":"#ede8de"),borderRadius:7,cursor:"pointer"}}>{editStation.autoPrint?"ON - Print on accept":"OFF - Manual print"}</button>
              </div>
            </div>

            {editStation.printerMethod==="printnode"&&<div>
              <label className="lbl">PrintNode Printer ID</label>
              <input className="field" value={editStation.printnodeId||""} onChange={e=>setEditStation({...editStation,printnodeId:e.target.value})} placeholder="123456 (find in printnode.com dashboard)"/>
              <p style={{fontSize:10,color:"#8a8078",marginTop:4}}>API key set globally in Stations tab. Direct browser calls may fail due to CORS - production should proxy via server.</p>
            </div>}
          </>}
        </div>

        <div style={{display:"flex",gap:7}}>
          <button className="btn btn-o" onClick={()=>setEditStation(null)} style={{flex:1,padding:"11px"}}>Cancel</button>
          <button className="btn btn-r" onClick={()=>{
            if(!editStation.name){alert("Name required");return;}
            dbSaveStation(editStation).then(r=>{
              if(r.error){push({title:"Save failed",body:r.error.message,color:"#dc2626"});return;}
              var saved={...editStation,dbId:r.data?.id||editStation.dbId};
              setStations(ls=>editStation.dbId?ls.map(x=>x.dbId===editStation.dbId?saved:x):[...(ls||[]),saved]);
              push({title:"Station saved",body:editStation.name,color:"#059669"});
              setEditStation(null);
            });
          }} style={{flex:2,padding:"11px"}}>Save Station</button>
        </div>
      </div>
    </div>}

    {editAuto&&<div onClick={()=>setEditAuto(null)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:8500,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div onClick={e=>e.stopPropagation()} className="card" style={{width:"100%",maxWidth:460,padding:22,maxHeight:"90vh",overflowY:"auto"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
          <h2 style={{fontSize:20}}>{editAuto.dbId?"Edit Offer":"Create Auto Offer"}</h2>
          <button onClick={()=>setEditAuto(null)} style={{color:"#999",fontSize:22,border:"none",background:"none",cursor:"pointer"}}>x</button>
        </div>
        <div style={{marginBottom:10}}><label className="lbl">Offer Name</label><input className="field" value={editAuto.name||""} onChange={e=>setEditAuto({...editAuto,name:e.target.value})} placeholder="10% off \u00A330+"/></div>
        <div style={{marginBottom:10}}><label className="lbl">Description</label><input className="field" value={editAuto.description||""} onChange={e=>setEditAuto({...editAuto,description:e.target.value})} placeholder="Shown to customer at checkout"/></div>
        <div style={{marginBottom:10}}><label className="lbl">Minimum order to trigger {EM.pound}</label><input type="number" step="0.01" className="field" value={editAuto.minOrder||0} onChange={e=>setEditAuto({...editAuto,minOrder:+e.target.value})}/></div>
        <div style={{marginBottom:10}}>
          <label className="lbl">Discount Type</label>
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:5}}>
            {[["percent","% off"],["fixed",EM.pound+" off"],["free_delivery","Free delivery"]].map(([k,l])=><button key={k} onClick={()=>setEditAuto({...editAuto,discountType:k})} style={{padding:"10px 4px",fontSize:12,fontWeight:700,background:editAuto.discountType===k?"#7c3aed":"#fff",color:editAuto.discountType===k?"#fff":"#1a1208",border:"2px solid "+(editAuto.discountType===k?"#7c3aed":"#ede8de"),borderRadius:7,cursor:"pointer"}}>{l}</button>)}
          </div>
        </div>
        {editAuto.discountType!=="free_delivery"&&<div style={{marginBottom:10}}><label className="lbl">{editAuto.discountType==="percent"?"Percentage %":"Amount "+EM.pound}</label><input type="number" step="0.01" className="field" value={editAuto.discountValue||0} onChange={e=>setEditAuto({...editAuto,discountValue:+e.target.value})}/></div>}
        <label style={{display:"flex",alignItems:"center",gap:8,marginBottom:8,cursor:"pointer"}}>
          <input type="checkbox" checked={editAuto.firstOrderOnly||false} onChange={e=>setEditAuto({...editAuto,firstOrderOnly:e.target.checked})} style={{width:16,height:16,cursor:"pointer"}}/>
          <span style={{fontSize:13}}>First order only</span>
        </label>
        <label style={{display:"flex",alignItems:"center",gap:8,marginBottom:14,cursor:"pointer"}}>
          <input type="checkbox" checked={editAuto.active!==false} onChange={e=>setEditAuto({...editAuto,active:e.target.checked})} style={{width:16,height:16,cursor:"pointer"}}/>
          <span style={{fontSize:13,fontWeight:700}}>Active</span>
        </label>
        <div style={{display:"flex",gap:7}}>
          <button className="btn btn-o" onClick={()=>setEditAuto(null)} style={{flex:1,padding:"11px"}}>Cancel</button>
          <button className="btn btn-r" onClick={()=>{
            if(!editAuto.name){alert("Name required");return;}
            dbSaveAutoDiscount(editAuto).then(r=>{
              if(r.error){push({title:"Save failed",body:r.error.message,color:"#dc2626"});return;}
              var saved={...editAuto,dbId:r.data?.id||editAuto.dbId};
              setAutoDiscs(ls=>editAuto.dbId?ls.map(x=>x.dbId===editAuto.dbId?saved:x):[...ls,saved]);
              push({title:"Offer saved",body:editAuto.name,color:"#059669"});
              setEditAuto(null);
            });
          }} style={{flex:2,padding:"11px"}}>Save Offer</button>
        </div>
      </div>
    </div>}
    {tab==="tables"&&<div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,flexWrap:"wrap",gap:8}}>
        <div>
          <h3 style={{fontSize:16,marginBottom:2}}>Tables Management</h3>
          <p style={{fontSize:11,color:"#8a8078"}}>Manage tables for each branch independently</p>
        </div>
        <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
          <select value={adminBranch} onChange={e=>setAdminBranch(e.target.value)} style={{padding:"7px 10px",fontSize:12,border:"2px solid #ede8de",borderRadius:8,fontWeight:700,cursor:"pointer"}}>{branches.map(b=><option key={b.id} value={b.id}>{b.name}</option>)}</select>
          <button onClick={()=>{
            var branchTables=tables.filter(t=>t.branchId===adminBranch).sort((a,b)=>(+a.id)-(+b.id));
            if(branchTables.length===0){alert("No tables for this branch yet. Add tables first.");return;}
            var baseUrl=window.location.origin+window.location.pathname;
            // Critical: include the restaurant slug so customer lands on the right restaurant page
            var slug=(typeof window!=="undefined"&&window.__currentRestaurant&&window.__currentRestaurant.slug)?window.__currentRestaurant.slug:(restaurant&&restaurant.slug?restaurant.slug:null);
            if(!slug){alert("Restaurant not detected. Please refresh and try again.");return;}
            var win=window.open("","","width=900,height=700");
            if(!win){alert("Please allow pop-ups to print QR codes");return;}
            var restName=(typeof window!=="undefined"&&window.__currentRestaurant?window.__currentRestaurant.name:(restaurant?restaurant.name:"Restaurant"));
            var cards=branchTables.map(t=>{
              // URL with restaurant slug + branch + table
              var url=baseUrl+"?r="+encodeURIComponent(slug)+"&branch="+adminBranch+"&table="+t.id;
              var qrImgUrl="https://api.qrserver.com/v1/create-qr-code/?size=220x220&data="+encodeURIComponent(url);
              return "<div style='border:2px dashed #8a8078;border-radius:14px;padding:20px 16px;text-align:center;page-break-inside:avoid;margin:8px;width:280px;display:inline-block;vertical-align:top;background:#fff'><div style='font-size:12px;color:#8a8078;letter-spacing:2px;margin-bottom:4px'>"+restName.toUpperCase()+"</div><div style='font-size:14px;color:#666;margin-bottom:14px'>"+(branches.find(b=>b.id===adminBranch)||{}).name+"</div><div style='font-size:42px;font-weight:bold;color:#bf4626;margin-bottom:14px'>TABLE "+t.id+"</div><img src='"+qrImgUrl+"' style='width:220px;height:220px'/><p style='font-size:13px;color:#333;margin-top:14px;font-weight:600'>Scan to order</p><p style='font-size:10px;color:#8a8078;margin-top:4px;word-break:break-all'>"+url+"</p></div>";
            }).join("");
            win.document.write("<html><head><title>QR Codes - "+(branches.find(b=>b.id===adminBranch)||{}).name+"</title><style>body{font-family:system-ui,sans-serif;padding:20px;background:#f5f5f5}h1{text-align:center;margin-bottom:20px}.print-hint{text-align:center;color:#666;margin-bottom:20px}@media print{body{background:#fff;padding:0}.print-hint{display:none}}</style></head><body><h1>QR Codes - Stick on Tables</h1><p class='print-hint'>Use Cmd/Ctrl+P to print. Stick each QR code on its corresponding table.</p>"+cards+"</body></html>");
            win.document.close();
          }} style={{padding:"7px 14px",fontSize:12,fontWeight:700,background:"#1a1208",color:"#fff",border:"none",borderRadius:8,cursor:"pointer"}}>Print QR Codes</button>
          <button className="btn btn-r" onClick={()=>{var tbs=tables.filter(t=>t.branchId===adminBranch);var nextNum=tbs.length>0?Math.max(...tbs.map(t=>+t.id||0))+1:1;setEditTable({id:nextNum,seats:4,x:20,y:20});}} style={{padding:"7px 14px",fontSize:12}}>+ Add Table</button>
        </div>
      </div>
      {(()=>{var branchTables=tables.filter(t=>t.branchId===adminBranch);var totalSeats=branchTables.reduce((s,t)=>s+t.seats,0);return <>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:6,marginBottom:12}}>
          <div style={{background:"#fff",borderRadius:9,padding:"9px 8px",border:"1px solid #ede8de",textAlign:"center"}}><div style={{fontSize:18,fontWeight:700,color:"#1a1208"}}>{branchTables.length}</div><div style={{fontSize:10,color:"#8a8078"}}>Tables</div></div>
          <div style={{background:"#fff",borderRadius:9,padding:"9px 8px",border:"1px solid #ede8de",textAlign:"center"}}><div style={{fontSize:18,fontWeight:700,color:"#bf4626"}}>{totalSeats}</div><div style={{fontSize:10,color:"#8a8078"}}>Total Seats</div></div>
          <div style={{background:"#fff",borderRadius:9,padding:"9px 8px",border:"1px solid #ede8de",textAlign:"center"}}><div style={{fontSize:18,fontWeight:700,color:"#059669"}}>{branchTables.filter(t=>t.status==="free").length}</div><div style={{fontSize:10,color:"#8a8078"}}>Available</div></div>
        </div>
        {branchTables.length===0?<div className="card" style={{textAlign:"center",padding:30}}><p style={{fontSize:40,marginBottom:10}}>{EM.cart}</p><p style={{fontSize:14,color:"#8a8078",marginBottom:10}}>No tables yet for this branch</p><button className="btn btn-r" onClick={()=>setEditTable({id:1,seats:4,x:20,y:20})} style={{padding:"9px 18px"}}>Add First Table</button></div>:
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:8}}>
          {branchTables.sort((a,b)=>(+a.id)-(+b.id)).map(tbl=>{
            var statusColor=tbl.status==="occupied"?"#dc2626":tbl.status==="reserved"?"#d4952a":"#059669";
            return <div key={(tbl.dbId||tbl.id)+"_"+tbl.id} className="card" style={{padding:12,borderLeft:"4px solid "+statusColor}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
                <div><p style={{fontWeight:700,fontSize:18}}>Table {tbl.id}</p><p style={{fontSize:11,color:"#8a8078"}}>{tbl.seats} seats - <span style={{color:statusColor,fontWeight:700,textTransform:"capitalize"}}>{tbl.status||"free"}</span></p></div>
              </div>
              <div style={{display:"flex",gap:5}}>
                <button onClick={()=>setEditTable(tbl)} style={{flex:1,padding:"6px",fontSize:11,background:"#f7f3ee",border:"none",borderRadius:6,cursor:"pointer",fontWeight:700}}>Edit</button>
                <button onClick={()=>deleteTable(tbl)} style={{padding:"6px 10px",fontSize:11,background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:6,cursor:"pointer",fontWeight:700}}>x</button>
              </div>
            </div>;
          })}
        </div>}
      </>})()}
    </div>}
    {tab==="cash"&&(()=>{
      // Find all delivered orders with cash collected but not yet handed over
      // Catches both "cash" and "cod" pay methods (COD orders paid in cash)
      var unsettled=orders.filter(o=>{
        if(branch&&o.branchId&&o.branchId!==branch.id)return false;
        var isCashType=o.payMethod==="cash"||o.payMethod==="cod";
        return o.type==="delivery"&&o.status==="delivered"&&isCashType&&o.paid&&!o.cashHandoverId&&!o.handoverId;
      });
      // Group by driver
      var byDriver={};
      unsettled.forEach(o=>{
        var d=o.deliveredBy||"Unknown";
        if(!byDriver[d])byDriver[d]={driver:d,orders:[],total:0};
        byDriver[d].orders.push(o);
        byDriver[d].total+=parseFloat(o.cashCollected||o.total||0);
      });
      var driverList=Object.values(byDriver);

      var doHandover=(group)=>{
        var amt=parseFloat(handoverAmount||group.total);
        if(!amt||amt<=0){alert("Enter cash amount received");return;}
        var orderIds=group.orders.map(o=>o.id);
        var handover={branchId:branch?.id,driverName:group.driver,managerName:user?.name||"Manager",amount:amt,expectedAmount:group.total,orderIds:orderIds};
        dbRecordHandover(handover).then(r=>{
          if(r.error){push({title:"Save failed",body:r.error.message,color:"#dc2626"});return;}
          // Update local orders to mark as handed over
          setOrders(os=>os.map(o=>orderIds.includes(o.id)?{...o,cashHandoverId:r.data?.id||"local"}:o));
          // Refresh handover list
          dbFetchHandovers().then(list=>setCashHandovers(list||[]));
          var diff=amt-group.total;
          var msg=diff===0?"Exact":(diff>0?"Over by "+fmt(diff):"Short by "+fmt(Math.abs(diff)));
          push({title:"Cash received from "+group.driver,body:fmt(amt)+" - "+msg,color:diff===0?"#059669":"#d4952a"});
          setHandoverAmount("");setHandoverDriver("");
        });
      };

      return <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:8}}>
          <div><h3 style={{fontSize:16,marginBottom:2}}>Cash Reconciliation</h3><p style={{fontSize:11,color:"#8a8078"}}>Receive cash from drivers - {branch?.name}</p></div>
          <select value={adminBranch} onChange={e=>setAdminBranch(e.target.value)} style={{padding:"7px 10px",fontSize:12,border:"2px solid #ede8de",borderRadius:8,fontWeight:700,cursor:"pointer"}}>{branches.map(b=><option key={b.id} value={b.id}>{b.name}</option>)}</select>
        </div>

        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:8,marginBottom:14}}>
          <div className="card" style={{padding:13,textAlign:"center",background:"#fef3c7"}}>
            <p style={{fontSize:11,color:"#92400e",fontWeight:700}}>OUTSTANDING</p>
            <p style={{fontSize:24,fontWeight:700,color:"#92400e"}}>{fmt(unsettled.reduce((s,o)=>s+(o.cashCollected||o.total||0),0))}</p>
            <p style={{fontSize:10,color:"#92400e"}}>{unsettled.length} orders awaiting handover</p>
          </div>
          <div className="card" style={{padding:13,textAlign:"center",background:"#d1fae5"}}>
            <p style={{fontSize:11,color:"#065f46",fontWeight:700}}>RECEIVED TODAY</p>
            <p style={{fontSize:24,fontWeight:700,color:"#065f46"}}>{fmt(cashHandovers.filter(h=>{var d=new Date(h.confirmed_at||h.initiated_at);return d.toDateString()===new Date().toDateString()&&h.status==="confirmed";}).reduce((s,h)=>s+parseFloat(h.manager_confirmed_amount||h.driver_declared_amount||0),0))}</p>
            <p style={{fontSize:10,color:"#065f46"}}>{cashHandovers.filter(h=>{var d=new Date(h.confirmed_at||h.initiated_at);return d.toDateString()===new Date().toDateString()&&h.status==="confirmed";}).length} handovers today</p>
          </div>
        </div>

        {/* NEW: PENDING HANDOVERS - drivers waiting for confirmation */}
        {pendingHandoversList.length>0&&<div style={{marginBottom:18}}>
          <h4 style={{fontSize:13,fontWeight:700,marginBottom:8,color:"#92400e",letterSpacing:1}}>{String.fromCharCode(0xD83D,0xDD14)} PENDING HANDOVERS - DRIVERS WAITING</h4>
          {pendingHandoversList.map(h=>{
            var confirmVal=confirmAmounts[h.id]!==undefined?confirmAmounts[h.id]:h.driver_declared_amount;
            var doConfirm=async()=>{
              var amt=parseFloat(confirmVal);
              if(isNaN(amt)||amt<0){window.showAlert("Invalid amount","Enter the cash amount you counted","warning");return;}
              var diff=amt-parseFloat(h.driver_declared_amount);
              var result=await dbConfirmHandover(h.id,user?.id,user?.name||"Manager",amt,diff!==0?(diff<0?"Short":"Over")+" by "+fmt(Math.abs(diff)):"");
              if(result.error){push({title:"Error",body:"Could not confirm",color:"#dc2626"});return;}
              push({title:String.fromCharCode(0x2705)+" Handover confirmed",body:"From "+h.driver_name+": "+fmt(amt),color:"#059669"});
              dbGetPendingHandovers().then(list=>setPendingHandoversList(list||[]));
              dbHandoverHistory({}).then(list=>setNewHandoverHistory(list||[]));
            };
            return <div key={h.id} className="card" style={{padding:14,marginBottom:9,borderLeft:"4px solid #f59e0b"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:9,flexWrap:"wrap",gap:6}}>
                <div>
                  <p style={{fontWeight:700,fontSize:15}}>{String.fromCharCode(0xD83D,0xDEF5)} {h.driver_name}</p>
                  <p style={{fontSize:11,color:"#8a8078"}}>{h.order_count} orders {String.fromCharCode(0x2022)} Started {new Date(h.initiated_at).toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"})}</p>
                </div>
                <div style={{textAlign:"right"}}>
                  <p style={{fontSize:10,color:"#8a8078"}}>Driver says</p>
                  <p style={{fontSize:22,fontWeight:700,color:"#92400e"}}>{fmt(h.driver_declared_amount)}</p>
                </div>
              </div>
              <div style={{padding:"11px 13px",background:"#fffbeb",borderRadius:8,border:"2px solid #fde68a"}}>
                <p style={{fontSize:11,fontWeight:700,color:"#92400e",marginBottom:7}}>{String.fromCharCode(0xD83D,0xDCB5)} Count the cash, then enter the amount you received:</p>
                <div style={{display:"flex",gap:6}}>
                  <input type="number" step="0.01" value={confirmVal} onChange={e=>setConfirmAmounts(c=>({...c,[h.id]:e.target.value}))} style={{flex:1,padding:"11px",fontSize:16,fontWeight:700,textAlign:"center",border:"2px solid #f59e0b",borderRadius:7}}/>
                  <button onClick={doConfirm} style={{padding:"11px 16px",background:"#059669",color:"#fff",border:"none",borderRadius:7,cursor:"pointer",fontWeight:700,fontSize:13}}>{EM.check} Confirm Received</button>
                </div>
                {parseFloat(confirmVal)!==parseFloat(h.driver_declared_amount)&&<p style={{fontSize:11,fontWeight:700,marginTop:6,color:parseFloat(confirmVal)<parseFloat(h.driver_declared_amount)?"#dc2626":"#d97706"}}>{parseFloat(confirmVal)<parseFloat(h.driver_declared_amount)?String.fromCharCode(0x26A0,0xFE0F)+" Short":String.fromCharCode(0x2B06,0xFE0F)+" Over"} by {fmt(Math.abs(parseFloat(confirmVal||0)-parseFloat(h.driver_declared_amount)))}</p>}
              </div>
            </div>;
          })}
        </div>}

        <h4 style={{fontSize:13,fontWeight:700,marginBottom:8,color:"#8a8078",letterSpacing:1}}>DRIVERS WITH CASH OWED</h4>
        {driverList.length===0?<div className="card" style={{textAlign:"center",padding:24}}>
          <p style={{fontSize:30,marginBottom:6}}>{EM.check}</p>
          <p style={{fontSize:13,color:"#8a8078",fontWeight:700}}>No outstanding cash right now</p>
          <p style={{fontSize:11,color:"#8a8078",marginTop:4}}>When drivers collect cash on delivery, it appears here. Drivers can also start a handover from their portal - those show in "Pending Handovers" above.</p>
        </div>:driverList.map(g=><div key={g.driver} className="card" style={{padding:14,marginBottom:9,borderLeft:"4px solid #f59e0b"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:9,flexWrap:"wrap",gap:6}}>
            <div>
              <p style={{fontWeight:700,fontSize:15}}>{g.driver}</p>
              <p style={{fontSize:11,color:"#8a8078"}}>{g.orders.length} delivered orders - cash to collect</p>
            </div>
            <p style={{fontSize:22,fontWeight:700,color:"#bf4626"}}>{fmt(g.total)}</p>
          </div>
          <details style={{marginBottom:9}}>
            <summary style={{cursor:"pointer",fontSize:11,color:"#8a8078",fontWeight:700}}>Show {g.orders.length} order{g.orders.length!==1?"s":""}</summary>
            <div style={{marginTop:7,background:"#fafaf5",borderRadius:6,padding:"7px 10px",fontSize:11}}>
              {g.orders.map(o=><div key={o.id} style={{display:"flex",justifyContent:"space-between",padding:"3px 0"}}><span>{o.id} - {o.customer}</span><span style={{fontWeight:700}}>{fmt(o.cashCollected||o.total)}</span></div>)}
            </div>
          </details>
          <div style={{padding:"10px 12px",background:"#fffbeb",borderRadius:8,border:"2px solid #fde68a"}}>
            <p style={{fontSize:11,fontWeight:700,color:"#92400e",marginBottom:7}}>Receive cash from {g.driver}</p>
            <div style={{display:"flex",gap:6}}>
              <input type="number" step="0.01" value={handoverDriver===g.driver?handoverAmount:""} onFocus={()=>setHandoverDriver(g.driver)} onChange={e=>{setHandoverDriver(g.driver);setHandoverAmount(e.target.value);}} placeholder={fmt(g.total)} style={{flex:1,padding:"10px",fontSize:14,fontWeight:700,textAlign:"center",border:"2px solid #f59e0b",borderRadius:7}}/>
              <button onClick={()=>doHandover(g)} style={{padding:"10px 14px",background:"#059669",color:"#fff",border:"none",borderRadius:7,cursor:"pointer",fontWeight:700,fontSize:13}}>{EM.check} Confirm Received</button>
            </div>
            <p style={{fontSize:10,color:"#92400e",marginTop:5}}>Tip: leave blank to confirm exact expected amount</p>
          </div>
        </div>)}

        {/* NEW: Two-step handover history with proof */}
        {newHandoverHistory.length>0&&<div style={{marginTop:18}}>
          <h4 style={{fontSize:13,fontWeight:700,marginBottom:8,color:"#8a8078",letterSpacing:1}}>{String.fromCharCode(0xD83D,0xDCCB)} HANDOVER RECORDS (PROOF)</h4>
          <div style={{display:"grid",gap:6}}>
            {newHandoverHistory.slice(0,20).map(h=>{
              var disc=parseFloat(h.discrepancy||0);
              return <div key={h.id} className="card" style={{padding:"10px 13px",fontSize:12}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:6}}>
                  <div>
                    <p style={{fontWeight:700}}>{String.fromCharCode(0xD83D,0xDEF5)} {h.driver_name} {h.manager_name?String.fromCharCode(0x2192)+" "+h.manager_name:""}</p>
                    <p style={{fontSize:10,color:"#8a8078"}}>{new Date(h.initiated_at).toLocaleString("en-GB",{day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"})} {String.fromCharCode(0x2022)} {h.order_count} orders</p>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <p style={{fontWeight:700,fontSize:15}}>{fmt(h.manager_confirmed_amount||h.driver_declared_amount)}</p>
                    <span style={{padding:"2px 8px",borderRadius:10,fontSize:9,fontWeight:700,background:h.status==="confirmed"?"#d1fae5":h.status==="pending"?"#fef3c7":"#fee2e2",color:h.status==="confirmed"?"#065f46":h.status==="pending"?"#92400e":"#991b1b"}}>{h.status==="confirmed"?"CONFIRMED":h.status==="pending"?"PENDING":"CANCELLED"}</span>
                  </div>
                </div>
                {h.status==="confirmed"&&disc!==0&&<p style={{fontSize:10,fontWeight:700,marginTop:4,color:disc<0?"#dc2626":"#d97706"}}>{disc<0?"Driver short":"Driver over"} by {fmt(Math.abs(disc))} - declared {fmt(h.driver_declared_amount)}, received {fmt(h.manager_confirmed_amount)}</p>}
              </div>;
            })}
          </div>
        </div>}

      </div>;
    })()}

    {tab==="stations"&&<div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,flexWrap:"wrap",gap:8}}>
        <div><h3 style={{fontSize:16,marginBottom:2}}>Kitchen Stations & Printers</h3><p style={{fontSize:11,color:"#8a8078"}}>Configure each station's printer (browser, PrintNode, or none)</p></div>
        <button className="btn btn-r" onClick={()=>setEditStation({name:"",icon:"cook",color:"#bf4626",sortOrder:(stations||[]).length+1,active:true,printerMethod:"none",printerFormat:"thermal",printContent:"station_only",autoPrint:false,copies:1})} style={{padding:"7px 14px",fontSize:12}}>+ Add Station</button>
      </div>
      {(!stations||stations.length===0)?<div className="card" style={{textAlign:"center",padding:30}}>
        <p style={{fontSize:40,marginBottom:10}}>{EM.cook}</p>
        <p style={{fontSize:14,color:"#8a8078"}}>No stations yet. Click "+ Add Station" or run the migration SQL.</p>
      </div>:<div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:9}}>
        {stations.map(s=><div key={s.dbId} className="card" style={{padding:13,borderLeft:"5px solid "+s.color}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
            <p style={{fontWeight:700,fontSize:15}}>{s.name}</p>
            <span style={{padding:"2px 7px",background:s.active?"#d1fae5":"#f5f5f5",color:s.active?"#065f46":"#8a8078",borderRadius:4,fontSize:10,fontWeight:700}}>{s.active?"ACTIVE":"OFF"}</span>
          </div>
          <p style={{fontSize:11,color:"#8a8078",marginBottom:6}}>{menu.filter(m=>m.station===s.name).length} menu items</p>
          <div style={{padding:"7px 9px",background:"#f7f3ee",borderRadius:6,marginBottom:9,fontSize:11}}>
            <div style={{marginBottom:2}}><strong>Printer:</strong> {s.printerMethod==="none"?"None":s.printerMethod==="browser"?"Browser print":s.printerMethod==="printnode"?"PrintNode auto":(s.printerMethod||"none")}</div>
            {s.printerMethod&&s.printerMethod!=="none"&&<>
              <div style={{marginBottom:2}}><strong>Format:</strong> {s.printerFormat==="a4"?"A4":"Thermal 80mm"}</div>
              <div style={{marginBottom:2}}><strong>Content:</strong> {s.printContent==="full_order"?"Full order":s.printContent==="station_with_full_summary"?"Station + summary":"Station items only"}</div>
              <div><strong>Auto-print:</strong> {s.autoPrint?"Yes":"No"} - {s.copies||1} cop{(s.copies||1)>1?"ies":"y"}</div>
            </>}
          </div>
          <div style={{display:"flex",gap:5}}>
            <button onClick={()=>setEditStation(s)} style={{flex:2,padding:"7px",fontSize:11,fontWeight:700,background:"#1a1208",color:"#fff",border:"none",borderRadius:6,cursor:"pointer"}}>Edit Settings</button>
            <button onClick={()=>{
              var inUse=menu.filter(m=>m.station===s.name).length;
              if(inUse>0){if(!window.confirm("This station has "+inUse+" menu items. Delete anyway?"))return;}
              else{if(!window.confirm("Delete "+s.name+"?"))return;}
              setStations(ls=>ls.filter(x=>x.dbId!==s.dbId));
              dbDeleteStation(s.dbId).then(()=>push({title:"Deleted",body:s.name,color:"#dc2626"}));
            }} style={{padding:"7px 11px",fontSize:11,background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:6,cursor:"pointer",fontWeight:700}}>x</button>
          </div>
        </div>)}
      </div>}
      <div className="card" style={{padding:12,marginTop:12,background:"#fffbeb",borderLeft:"4px solid #d97706"}}>
        <p style={{fontSize:12,fontWeight:700,marginBottom:6,color:"#92400e"}}>{EM.star} PrintNode Setup (optional, for true auto-print)</p>
        <p style={{fontSize:11,color:"#92400e",marginBottom:7}}>If using PrintNode, install client at printnode.com and paste your API key below. It is stored only in this browser.</p>
        <input type="password" className="field" placeholder="PrintNode API key" defaultValue={(()=>{try{return localStorage.getItem("printnode_api_key")||"";}catch(e){return "";}})()} onChange={e=>{try{localStorage.setItem("printnode_api_key",e.target.value);}catch(err){}}} style={{fontSize:11}}/>
      </div>
    </div>}

    {tab==="delivery"&&(()=>{
      var ds=delivSettings[adminBranch]||{method:"radius",enabled:true,minOrder:15,freeOver:25,flatFee:2.50,maxRadius:3,zones:[],postcodes:[],codEnabled:true,codMinOrder:15,codMaxMiles:3};
      var update=(key,val)=>{setDelivSettings(s=>({...s,[adminBranch]:{...ds,[key]:val}}));};
      var save=()=>{
        dbSaveDelivery(adminBranch,ds).then(r=>{
          if(r.error)push({title:"Save failed",body:r.error.message,color:"#dc2626"});
          else push({title:"Delivery saved",body:(branches.find(b=>b.id===adminBranch)||{}).name,color:"#059669"});
        });
      };
      return <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,flexWrap:"wrap",gap:8}}>
          <div><h3 style={{fontSize:16,marginBottom:2}}>Delivery Settings</h3><p style={{fontSize:11,color:"#8a8078"}}>Configure delivery for each branch</p></div>
          <select value={adminBranch} onChange={e=>setAdminBranch(e.target.value)} style={{padding:"7px 10px",fontSize:12,border:"2px solid #ede8de",borderRadius:8,fontWeight:700,cursor:"pointer"}}>{branches.map(b=><option key={b.id} value={b.id}>{b.name}</option>)}</select>
        </div>
        <div className="card" style={{padding:16,marginBottom:10}}>
          <label style={{display:"flex",alignItems:"center",gap:8,marginBottom:12,cursor:"pointer"}}>
            <input type="checkbox" checked={ds.enabled!==false} onChange={e=>update("enabled",e.target.checked)} style={{width:18,height:18,cursor:"pointer"}}/>
            <span style={{fontWeight:700}}>Delivery Enabled</span>
          </label>
          <p style={{fontSize:11,fontWeight:700,color:"#8a8078",letterSpacing:1,marginBottom:6}}>METHOD</p>
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:5,marginBottom:12}}>
            {[["radius","Radius","Simple - X miles from here"],["postcode","Postcode","By UK postcode areas"],["zone","Zone","Tiered - multiple zones"]].map(([k,l,d])=><button key={k} onClick={()=>update("method",k)} style={{padding:"11px 6px",fontSize:12,fontWeight:700,background:ds.method===k?"#bf4626":"#fff",color:ds.method===k?"#fff":"#1a1208",border:"2px solid "+(ds.method===k?"#bf4626":"#ede8de"),borderRadius:8,cursor:"pointer",textAlign:"center"}}><div>{l}</div><div style={{fontSize:9,fontWeight:500,marginTop:2,opacity:.8}}>{d}</div></button>)}
          </div>
          <div className="g2" style={{marginBottom:12}}>
            <div><label className="lbl">Minimum order</label><input type="number" step="0.01" className="field" value={ds.minOrder||0} onChange={e=>update("minOrder",+e.target.value)}/></div>
            <div><label className="lbl">Free delivery over</label><input type="number" step="0.01" className="field" value={ds.freeOver||0} onChange={e=>update("freeOver",+e.target.value)} placeholder="0 = never free"/></div>
          </div>

          {ds.method==="radius"&&<div className="g2">
            <div><label className="lbl">Flat delivery fee</label><input type="number" step="0.01" className="field" value={ds.flatFee||0} onChange={e=>update("flatFee",+e.target.value)}/></div>
            <div><label className="lbl">Max radius (miles)</label><input type="number" className="field" value={ds.maxRadius||3} onChange={e=>update("maxRadius",+e.target.value)}/></div>
          </div>}

          {ds.method==="postcode"&&<div>
            <label className="lbl">Postcode areas and fees</label>
            {(ds.postcodes||[]).map((p,i)=><div key={i} style={{display:"flex",gap:5,marginBottom:5}}>
              <input className="field" value={p.prefix} onChange={e=>{var arr=[...ds.postcodes];arr[i]={...arr[i],prefix:e.target.value.toUpperCase()};update("postcodes",arr);}} placeholder="EC1" style={{flex:1}}/>
              <input type="number" step="0.01" className="field" value={p.fee} onChange={e=>{var arr=[...ds.postcodes];arr[i]={...arr[i],fee:+e.target.value};update("postcodes",arr);}} placeholder="Fee" style={{flex:1}}/>
              <button onClick={()=>{var arr=ds.postcodes.filter((_,x)=>x!==i);update("postcodes",arr);}} style={{padding:"0 12px",background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:6,fontWeight:700,cursor:"pointer"}}>x</button>
            </div>)}
            <button onClick={()=>update("postcodes",[...(ds.postcodes||[]),{prefix:"",fee:0}])} style={{padding:"8px 14px",fontSize:12,fontWeight:700,background:"#f7f3ee",border:"2px dashed #ede8de",borderRadius:7,cursor:"pointer",width:"100%"}}>+ Add Postcode</button>
          </div>}

          {ds.method==="zone"&&<div>
            <label className="lbl">Zones (tiered by distance)</label>
            {(ds.zones||[]).map((z,i)=><div key={i} style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 40px",gap:5,marginBottom:5}}>
              <input className="field" value={z.name||""} onChange={e=>{var arr=[...ds.zones];arr[i]={...arr[i],name:e.target.value};update("zones",arr);}} placeholder="Zone name"/>
              <input type="number" step="0.1" className="field" value={z.maxMiles||0} onChange={e=>{var arr=[...ds.zones];arr[i]={...arr[i],maxMiles:+e.target.value};update("zones",arr);}} placeholder="Max mi"/>
              <input type="number" step="0.01" className="field" value={z.fee||0} onChange={e=>{var arr=[...ds.zones];arr[i]={...arr[i],fee:+e.target.value};update("zones",arr);}} placeholder="Fee"/>
              <button onClick={()=>{var arr=ds.zones.filter((_,x)=>x!==i);update("zones",arr);}} style={{background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:6,fontWeight:700,cursor:"pointer"}}>x</button>
            </div>)}
            <button onClick={()=>update("zones",[...(ds.zones||[]),{name:"Zone "+((ds.zones||[]).length+1),maxMiles:3,fee:0}])} style={{padding:"8px 14px",fontSize:12,fontWeight:700,background:"#f7f3ee",border:"2px dashed #ede8de",borderRadius:7,cursor:"pointer",width:"100%"}}>+ Add Zone</button>
          </div>}
        </div>

        <div className="card" style={{padding:16,marginBottom:10}}>
          <p style={{fontSize:14,fontWeight:700,marginBottom:8}}>Cash on Delivery</p>
          <label style={{display:"flex",alignItems:"center",gap:8,marginBottom:10,cursor:"pointer"}}>
            <input type="checkbox" checked={ds.codEnabled!==false} onChange={e=>update("codEnabled",e.target.checked)} style={{width:18,height:18,cursor:"pointer"}}/>
            <span style={{fontWeight:700}}>Accept Cash on Delivery</span>
          </label>
          {ds.codEnabled&&<div className="g2">
            <div><label className="lbl">Min order for COD</label><input type="number" step="0.01" className="field" value={ds.codMinOrder||15} onChange={e=>update("codMinOrder",+e.target.value)}/></div>
            <div><label className="lbl">Max miles for COD</label><input type="number" className="field" value={ds.codMaxMiles||3} onChange={e=>update("codMaxMiles",+e.target.value)}/></div>
          </div>}
        </div>

        <div className="card" style={{padding:16,marginBottom:10}}>
          <p style={{fontSize:14,fontWeight:700,marginBottom:4}}>Service Charge (Dine-in)</p>
          <p style={{fontSize:11,color:"#8a8078",marginBottom:9}}>Optional gratuity added to dine-in bills. Not applied to delivery or collection.</p>
          <label style={{display:"flex",alignItems:"center",gap:8,marginBottom:10,cursor:"pointer"}}>
            <input type="checkbox" checked={ds.serviceChargeEnabled||false} onChange={e=>update("serviceChargeEnabled",e.target.checked)} style={{width:18,height:18,cursor:"pointer"}}/>
            <span style={{fontWeight:700}}>Add service charge to dine-in bills</span>
          </label>
          {ds.serviceChargeEnabled&&<>
            <div className="g2" style={{marginBottom:9}}>
              <div><label className="lbl">Percentage %</label><input type="number" step="0.5" className="field" value={ds.serviceChargePercent||12.5} onChange={e=>update("serviceChargePercent",+e.target.value)}/></div>
              <div><label className="lbl">Auto-apply for groups of</label><input type="number" className="field" value={ds.serviceChargeGroupSize||6} onChange={e=>update("serviceChargeGroupSize",+e.target.value)}/></div>
            </div>
            <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer"}}>
              <input type="checkbox" checked={ds.serviceChargeMandatory||false} onChange={e=>update("serviceChargeMandatory",e.target.checked)} style={{width:16,height:16,cursor:"pointer"}}/>
              <span style={{fontSize:13}}>Mandatory (customer cannot remove)</span>
            </label>
          </>}
        </div>

        <button className="btn btn-r" onClick={save} style={{width:"100%",padding:"13px",fontSize:14}}>Save Delivery Settings</button>
      </div>;
    })()}

    {tab==="marketing"&&<MarketingCenter restaurant={restaurant} branch={branch} push={push}/>}

    {tab==="codes"&&<div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,flexWrap:"wrap",gap:8}}>
        <div><h3 style={{fontSize:16,marginBottom:2}}>Promo Codes</h3><p style={{fontSize:11,color:"#8a8078"}}>Customer-entered discount codes</p></div>
        <button className="btn btn-r" onClick={()=>setEditCode({type:"percent",value:10,minOrder:0,maxUses:100,active:true})} style={{padding:"7px 14px",fontSize:12}}>+ Create Code</button>
      </div>
      {promoCodes.length===0?<div className="card" style={{textAlign:"center",padding:30}}>
        <p style={{fontSize:40,marginBottom:10}}>{EM.star}</p>
        <p style={{fontSize:14,color:"#8a8078"}}>No promo codes yet</p>
      </div>:<div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(250px,1fr))",gap:8}}>
        {promoCodes.map(c=><div key={c.dbId} className="card" style={{padding:12,borderLeft:"4px solid "+(c.active?"#059669":"#8a8078")}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
            <p style={{fontWeight:700,fontSize:16,letterSpacing:1,color:"#bf4626"}}>{c.code}</p>
            <span style={{padding:"2px 7px",background:c.active?"#d1fae5":"#f5f5f5",color:c.active?"#065f46":"#8a8078",borderRadius:4,fontSize:10,fontWeight:700}}>{c.active?"ACTIVE":"INACTIVE"}</span>
          </div>
          <p style={{fontSize:13,fontWeight:700,marginBottom:3}}>{c.type==="percent"?c.value+"% off":c.type==="fixed"?fmt(c.value)+" off":"Free delivery"}</p>
          {c.description&&<p style={{fontSize:11,color:"#8a8078",marginBottom:6}}>{c.description}</p>}
          <div style={{fontSize:11,color:"#8a8078",marginBottom:8}}>
            <div>Min order: {fmt(c.minOrder)}</div>
            <div>Used: {c.uses}/{c.maxUses}</div>
            {c.firstOrderOnly&&<div style={{color:"#d4952a",fontWeight:700}}>First order only</div>}
          </div>
          <div style={{display:"flex",gap:5}}>
            <button onClick={()=>setEditCode(c)} style={{flex:1,padding:"6px",fontSize:11,fontWeight:700,background:"#f7f3ee",border:"none",borderRadius:6,cursor:"pointer"}}>Edit</button>
            <button onClick={()=>{if(!window.confirm("Delete code "+c.code+"?"))return;setPromoCodes(cs=>cs.filter(x=>x.dbId!==c.dbId));dbDeleteCode(c.dbId).then(r=>{if(r.error)push({title:"Delete failed",body:r.error.message,color:"#dc2626"});else push({title:"Code deleted",body:c.code,color:"#dc2626"});});}} style={{padding:"6px 12px",fontSize:11,background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:6,cursor:"pointer",fontWeight:700}}>x</button>
          </div>
        </div>)}
      </div>}
    </div>}

    {tab==="autodisc"&&<div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,flexWrap:"wrap",gap:8}}>
        <div><h3 style={{fontSize:16,marginBottom:2}}>Auto Discounts</h3><p style={{fontSize:11,color:"#8a8078"}}>Offers that apply automatically without a code</p></div>
        <button className="btn btn-r" onClick={()=>setEditAuto({name:"",ruleType:"min_order",minOrder:30,discountType:"percent",discountValue:10,active:true})} style={{padding:"7px 14px",fontSize:12}}>+ Create Offer</button>
      </div>
      {autoDiscs.length===0?<div className="card" style={{textAlign:"center",padding:30}}>
        <p style={{fontSize:40,marginBottom:10}}>{EM.party}</p>
        <p style={{fontSize:14,color:"#8a8078"}}>No auto offers yet</p>
      </div>:<div style={{display:"grid",gap:8}}>
        {autoDiscs.map(a=><div key={a.dbId} className="card" style={{padding:12,borderLeft:"4px solid "+(a.active?"#7c3aed":"#8a8078")}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:5,gap:8}}>
            <div style={{flex:1}}>
              <p style={{fontWeight:700,fontSize:15,marginBottom:3}}>{a.name}</p>
              <p style={{fontSize:12,color:"#8a8078"}}>{a.description}</p>
              <p style={{fontSize:11,color:"#7c3aed",fontWeight:700,marginTop:4}}>{a.discountType==="percent"?a.discountValue+"%":a.discountType==="fixed"?fmt(a.discountValue):"Free delivery"} on orders over {fmt(a.minOrder)}</p>
            </div>
            <span style={{padding:"2px 7px",background:a.active?"#d1fae5":"#f5f5f5",color:a.active?"#065f46":"#8a8078",borderRadius:4,fontSize:10,fontWeight:700}}>{a.active?"ON":"OFF"}</span>
          </div>
          <div style={{display:"flex",gap:5,marginTop:6}}>
            <button onClick={()=>setEditAuto(a)} style={{flex:1,padding:"6px",fontSize:11,fontWeight:700,background:"#f7f3ee",border:"none",borderRadius:6,cursor:"pointer"}}>Edit</button>
            <button onClick={()=>{if(!window.confirm("Delete offer "+a.name+"?"))return;setAutoDiscs(ls=>ls.filter(x=>x.dbId!==a.dbId));dbDeleteAutoDiscount(a.dbId).then(()=>push({title:"Offer deleted",body:a.name,color:"#dc2626"}));}} style={{padding:"6px 12px",fontSize:11,background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:6,cursor:"pointer",fontWeight:700}}>x</button>
          </div>
        </div>)}
      </div>}
    </div>}

    {tab==="staff"&&<StaffManagementTab restaurant={restaurant} branch={branch} push={push}/>}

    {tab==="stock"&&(()=>{
      // Group menu by category for easier viewing
      var byCat={};
      menu.forEach(function(item){
        var c=item.cat||"Other";
        if(!byCat[c])byCat[c]=[];
        byCat[c].push(item);
      });
      var cats=Object.keys(byCat).sort();
      var soldOutCount=menu.filter(function(i){return i.avail===false;}).length;
      var availCount=menu.length-soldOutCount;
      
      var toggleItem=function(item){
        var newAvail=item.avail===false?true:false;
        setMenu(function(ms){return ms.map(function(m){return m.id===item.id?{...m,avail:newAvail}:m;});});
        // Save to DB
        if(item.dbId){
          dbUpdateMenuItem(item.dbId,{available:newAvail}).catch(function(e){console.log("Avail save failed:",e);});
        }
      };
      
      var markAllAvail=async function(){
        var ok=await window.showConfirm("Mark All Available","Mark all menu items as available?","Yes","Cancel","success");
        if(!ok)return;
        setMenu(function(ms){return ms.map(function(m){return {...m,avail:true};});});
        // Save each
        menu.forEach(function(m){
          if(m.dbId&&m.avail===false){
            dbUpdateMenuItem(m.dbId,{available:true}).catch(function(e){console.log("Save failed:",e);});
          }
        });
        push&&push({title:"All items available",color:"#059669"});
      };
      
      return <div>
        {/* Header info */}
        <div className="card" style={{padding:14,marginBottom:12,background:"linear-gradient(135deg,#1a1208,#3d2e22)",color:"#fff"}}>
          <h3 style={{fontSize:17,fontWeight:700,marginBottom:5}}>{String.fromCharCode(0x2705)} Item Availability</h3>
          <p style={{fontSize:12,opacity:.85,marginBottom:9}}>Mark items as Sold Out when you run out. Customers and staff won't be able to order them.</p>
          <div style={{display:"flex",gap:11,fontSize:13,flexWrap:"wrap"}}>
            <span style={{padding:"4px 10px",background:"rgba(16,185,129,.3)",borderRadius:6,fontWeight:700}}>{String.fromCharCode(0x2705)} {availCount} available</span>
            <span style={{padding:"4px 10px",background:"rgba(220,38,38,.3)",borderRadius:6,fontWeight:700}}>{String.fromCharCode(0x274C)} {soldOutCount} sold out</span>
          </div>
        </div>
        
        {soldOutCount>0&&<button onClick={markAllAvail} style={{marginBottom:12,padding:"10px 16px",background:"linear-gradient(135deg,#059669,#047857)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>{String.fromCharCode(0x2728)} Mark All Items Available</button>}
        
        {/* Items grouped by category */}
        {cats.length===0?
          <div className="card" style={{padding:30,textAlign:"center"}}>
            <p style={{fontSize:13,color:"#8a8078"}}>No menu items yet. Add items in the Menu tab first.</p>
          </div>
          :
          cats.map(function(cat){
            return <div key={cat} style={{marginBottom:14}}>
              <h4 style={{fontSize:13,fontWeight:700,marginBottom:8,color:"#8a8078",letterSpacing:1,textTransform:"uppercase"}}>{cat}</h4>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(250px,1fr))",gap:8}}>
                {byCat[cat].map(function(item){
                  var soldOut=item.avail===false;
                  return <div key={item.id} className="card" style={{padding:13,display:"flex",justifyContent:"space-between",alignItems:"center",gap:9,opacity:soldOut?0.7:1,borderLeft:"4px solid "+(soldOut?"#dc2626":"#059669")}}>
                    <div style={{flex:1,minWidth:0}}>
                      <p style={{fontWeight:700,fontSize:13,textDecoration:soldOut?"line-through":"none"}}>{item.name}</p>
                      <p style={{fontSize:11,color:"#8a8078",marginTop:2}}>{fmt(item.price)}</p>
                    </div>
                    <button onClick={function(){toggleItem(item);}} style={{padding:"8px 14px",borderRadius:8,fontWeight:700,fontSize:12,border:"none",cursor:"pointer",minWidth:108,background:soldOut?"#fee2e2":"#d1fae5",color:soldOut?"#991b1b":"#065f46"}}>
                      {soldOut?String.fromCharCode(0x274C)+" Sold Out":String.fromCharCode(0x2705)+" Available"}
                    </button>
                  </div>;
                })}
              </div>
            </div>;
          })
        }
      </div>;
    })()}
    {tab==="discounts"&&<div><div className="card" style={{marginBottom:12}}><h3 style={{fontSize:14,marginBottom:9}}>Create Code</h3><div className="g2" style={{marginBottom:8}}><div><label className="lbl">Code</label><input className="field" value={nc.code} onChange={e=>setNC(n=>({...n,code:e.target.value.toUpperCase()}))} placeholder="SUMMER20"/></div><div><label className="lbl">Type</label><select className="field" value={nc.type} onChange={e=>setNC(n=>({...n,type:e.target.value}))}><option value="percent">Percent</option><option value="fixed">Fixed</option></select></div><div><label className="lbl">Value</label><input type="number" className="field" value={nc.value} onChange={e=>setNC(n=>({...n,value:e.target.value}))} placeholder="10"/></div><div><label className="lbl">Desc</label><input className="field" value={nc.desc} onChange={e=>setNC(n=>({...n,desc:e.target.value}))} placeholder="Summer deal"/></div></div><button className="btn btn-r" onClick={addCode} style={{padding:"8px 18px"}}>Create</button></div>{discounts.map((d,i)=><div key={i} className="card" style={{marginBottom:8,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:7}}><div><span style={{fontWeight:700,fontSize:13,fontFamily:"monospace",background:"#f7f3ee",padding:"2px 8px",borderRadius:5}}>{d.code}</span><span className="bdg" style={{background:d.active?"#d1fae5":"#fee2e2",color:d.active?"#065f46":"#dc2626",marginLeft:7}}>{d.active?"Active":"Off"}</span><p style={{color:"#8a8078",fontSize:11,marginTop:2}}>{d.type==="percent"?d.value+"%":fmt(d.value)} off</p></div><button onClick={()=>setDiscounts(ds=>ds.map((x,j)=>j===i?{...x,active:!x.active}:x))} style={{padding:"4px 11px",borderRadius:7,fontWeight:600,fontSize:11,border:"2px solid #ede8de",background:"#fff",cursor:"pointer"}}>{d.active?"Deactivate":"Activate"}</button></div>)}</div>}
    {tab==="finance"&&(()=>{
      // Calculate totals from orders + expenses for selected period
      var fromDateOnly=financeFromDate;
      var toDateOnly=financeToDate;
      var periodOrders=fil.filter(o=>{
        try{
          // Use created_at (DB field), fallback to placedAt or createdAt
          var dateStr=o.created_at||o.placedAt||o.createdAt;
          if(!dateStr)return false;
          var d=new Date(dateStr).toISOString().split("T")[0];
          return d>=fromDateOnly&&d<=toDateOnly&&o.status!=="cancelled";
        }catch(e){return false;}
      });
      var totalRevenue=periodOrders.reduce((s,o)=>s+parseFloat(o.total||0),0);
      var totalExpenses=expenses.reduce((s,e)=>s+parseFloat(e.amount||0),0);
      var profit=totalRevenue-totalExpenses;
      var profitMargin=totalRevenue>0?(profit/totalRevenue)*100:0;
      
      // Group expenses by category
      var expensesByCategory={};
      expenses.forEach(e=>{
        var cat=e.category_name||"Other";
        if(!expensesByCategory[cat])expensesByCategory[cat]={name:cat,total:0,count:0,items:[]};
        expensesByCategory[cat].total+=parseFloat(e.amount||0);
        expensesByCategory[cat].count++;
        expensesByCategory[cat].items.push(e);
      });
      var catBreakdown=Object.values(expensesByCategory).sort((a,b)=>b.total-a.total);
      
      // Income breakdown by order type
      var incomeByType={};
      periodOrders.forEach(o=>{
        var t=o.type||"other";
        if(!incomeByType[t])incomeByType[t]={name:t,total:0,count:0};
        incomeByType[t].total+=parseFloat(o.total||0);
        incomeByType[t].count++;
      });
      var incomeBreakdown=Object.values(incomeByType).sort((a,b)=>b.total-a.total);
      
      var formatDate=(d)=>{try{return new Date(d).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"});}catch(e){return d;}};
      var todayStr=new Date().toISOString().split("T")[0];
      var setQuickRange=(type)=>{
        var to=new Date();
        var from=new Date();
        if(type==="today"){from=new Date();}
        else if(type==="week"){from.setDate(from.getDate()-6);}
        else if(type==="month"){from=new Date(from.getFullYear(),from.getMonth(),1);}
        else if(type==="quarter"){var q=Math.floor(from.getMonth()/3);from=new Date(from.getFullYear(),q*3,1);}
        else if(type==="year"){from=new Date(from.getFullYear(),0,1);}
        else if(type==="lastmonth"){from=new Date(from.getFullYear(),from.getMonth()-1,1);to=new Date(from.getFullYear(),from.getMonth()+1,0);}
        setFinanceFromDate(from.toISOString().split("T")[0]);
        setFinanceToDate(to.toISOString().split("T")[0]);
      };
      
      return <div>
        {/* Header banner with explanation */}
        <div className="card" style={{padding:14,marginBottom:11,background:"linear-gradient(135deg,#1a1208,#3d2e22)",color:"#fff"}}>
          <h3 style={{fontSize:17,fontWeight:700,marginBottom:5}}>{String.fromCharCode(0xD83D,0xDCB0)} Finance & Profit Tracking</h3>
          <p style={{fontSize:12,opacity:.85,marginBottom:9}}>See if your restaurant is profitable. Track every penny in (sales) and out (expenses) for any date range.</p>
          <div style={{display:"flex",gap:11,fontSize:11,opacity:.8,flexWrap:"wrap"}}>
            <span>{String.fromCharCode(0x2705)} Income from orders auto-tracked</span>
            <span>{String.fromCharCode(0x2705)} Add your expenses manually</span>
            <span>{String.fromCharCode(0x2705)} Get profit/loss instantly</span>
          </div>
        </div>
        
        {/* Commission widget - only if on commission billing */}
        <CommissionWidget restaurant={restaurant}/>
        
        {/* Date Range Picker */}
        <div className="card" style={{padding:13,marginBottom:11}}>
          <div style={{display:"flex",gap:7,alignItems:"end",flexWrap:"wrap",marginBottom:9}}>
            <div>
              <p style={{fontSize:9,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3}}>FROM</p>
              <input type="date" className="field" value={financeFromDate} onChange={e=>setFinanceFromDate(e.target.value)} style={{padding:"7px 9px",fontSize:12}}/>
            </div>
            <div>
              <p style={{fontSize:9,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3}}>TO</p>
              <input type="date" className="field" value={financeToDate} max={todayStr} onChange={e=>setFinanceToDate(e.target.value)} style={{padding:"7px 9px",fontSize:12}}/>
            </div>
          </div>
          <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
            {[["today","Today"],["week","Last 7 Days"],["month","This Month"],["lastmonth","Last Month"],["quarter","This Quarter"],["year","This Year"]].map(([k,l])=><button key={k} onClick={()=>setQuickRange(k)} style={{padding:"6px 11px",borderRadius:6,fontSize:11,fontWeight:700,border:"1px solid #ede8de",background:"#fff",cursor:"pointer"}}>{l}</button>)}
          </div>
        </div>
        
        {/* Summary Cards: Income / Expenses / Profit */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:9,marginBottom:11}}>
          <div className="card" style={{padding:14,borderLeft:"5px solid #059669"}}>
            <p style={{fontSize:10,color:"#059669",fontWeight:700,letterSpacing:2,marginBottom:5}}>{String.fromCharCode(0xD83D,0xDCB5)} INCOME</p>
            <p style={{fontSize:24,fontWeight:700,color:"#059669",fontFamily:"'Courier New',monospace"}}>{fmt(totalRevenue)}</p>
            <p style={{fontSize:10,color:"#8a8078",marginTop:4}}>{periodOrders.length} order(s)</p>
          </div>
          <div className="card" style={{padding:14,borderLeft:"5px solid #dc2626"}}>
            <p style={{fontSize:10,color:"#dc2626",fontWeight:700,letterSpacing:2,marginBottom:5}}>{String.fromCharCode(0xD83D,0xDCB8)} EXPENSES</p>
            <p style={{fontSize:24,fontWeight:700,color:"#dc2626",fontFamily:"'Courier New',monospace"}}>{fmt(totalExpenses)}</p>
            <p style={{fontSize:10,color:"#8a8078",marginTop:4}}>{expenses.length} expense(s)</p>
          </div>
          <div className="card" style={{padding:14,borderLeft:"5px solid "+(profit>=0?"#d4952a":"#7f1d1d"),background:profit>=0?"#fffbeb":"#fef2f2"}}>
            <p style={{fontSize:10,color:profit>=0?"#d4952a":"#7f1d1d",fontWeight:700,letterSpacing:2,marginBottom:5}}>{String.fromCharCode(0xD83D,0xDCC8)} {profit>=0?"PROFIT":"LOSS"}</p>
            <p style={{fontSize:24,fontWeight:700,color:profit>=0?"#d4952a":"#7f1d1d",fontFamily:"'Courier New',monospace"}}>{profit>=0?fmt(profit):"-"+fmt(Math.abs(profit))}</p>
            <p style={{fontSize:10,color:"#8a8078",marginTop:4}}>Margin: {profitMargin.toFixed(1)}%</p>
          </div>
        </div>
        
        {/* Action Buttons - With clear descriptions */}
        <div style={{marginBottom:14}}>
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:7,textTransform:"uppercase"}}>{String.fromCharCode(0xD83D,0xDCB8)} Track Your Expenses</p>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(170px,1fr))",gap:7}}>
            <button onClick={()=>setShowAddExpense(true)} style={{padding:"14px 16px",background:"linear-gradient(135deg,#dc2626,#991b1b)",color:"#fff",border:"none",borderRadius:9,cursor:"pointer",textAlign:"left"}}>
              <div style={{fontSize:14,fontWeight:700,marginBottom:3}}>{String.fromCharCode(0x2B)} Add Expense</div>
              <div style={{fontSize:10,opacity:.85}}>Record a new expense (rent, utilities, food, etc.)</div>
            </button>
            <button onClick={()=>setShowCategoryManager(true)} style={{padding:"14px 16px",background:"#fff",color:"#1a1208",border:"2px solid #ede8de",borderRadius:9,cursor:"pointer",textAlign:"left"}}>
              <div style={{fontSize:14,fontWeight:700,marginBottom:3}}>{String.fromCharCode(0xD83D,0xDCC1)} Categories</div>
              <div style={{fontSize:10,color:"#8a8078"}}>Organise expenses by type ({expenseCategories.filter(c=>c.active).length} types)</div>
            </button>
            <button onClick={()=>setShowRecurringManager(true)} style={{padding:"14px 16px",background:"#fff",color:"#7c3aed",border:"2px solid #7c3aed",borderRadius:9,cursor:"pointer",textAlign:"left"}}>
              <div style={{fontSize:14,fontWeight:700,marginBottom:3}}>{String.fromCharCode(0xD83D,0xDD04)} Recurring Bills</div>
              <div style={{fontSize:10,color:"#7c3aed",opacity:.85}}>Auto-track monthly bills like rent ({recurringExpenses.filter(r=>r.active).length} active)</div>
            </button>
            <button onClick={()=>setShowPLStatement(true)} style={{padding:"14px 16px",background:"linear-gradient(135deg,#1a1208,#3d2e22)",color:"#fff",border:"none",borderRadius:9,cursor:"pointer",textAlign:"left"}}>
              <div style={{fontSize:14,fontWeight:700,marginBottom:3}}>{String.fromCharCode(0xD83D,0xDCCA)} P&L Statement</div>
              <div style={{fontSize:10,opacity:.85}}>View profit/loss summary report</div>
            </button>
          </div>
          <div style={{marginTop:9,padding:"9px 12px",background:"#fef3c7",borderRadius:7,fontSize:11,color:"#92400e",lineHeight:1.5}}>
            <strong>{String.fromCharCode(0xD83D,0xDCA1)} How it works:</strong> Track everything you spend (rent, utilities, food, salaries) so you can see your true profit. Categories organise expenses. Recurring bills (like rent) get added automatically each month so you don't have to type them every time.
          </div>
        </div>
        
        {/* Income breakdown */}
        <div className="card" style={{padding:14,marginBottom:11}}>
          <h3 style={{fontSize:14,fontWeight:700,marginBottom:9}}>{String.fromCharCode(0xD83D,0xDCB0)} Income Breakdown</h3>
          {incomeBreakdown.length===0?<p style={{fontSize:12,color:"#8a8078",fontStyle:"italic"}}>No orders in this period</p>:
            incomeBreakdown.map(i=><div key={i.name} style={{marginBottom:7}}>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:12,marginBottom:3}}>
                <span style={{fontWeight:600}}>{i.name.charAt(0).toUpperCase()+i.name.slice(1)} ({i.count})</span>
                <span style={{fontWeight:700,color:"#059669"}}>{fmt(i.total)}</span>
              </div>
              <div style={{height:8,background:"#f7f3ee",borderRadius:4,overflow:"hidden"}}>
                <div style={{height:"100%",background:"linear-gradient(90deg,#059669,#10b981)",width:totalRevenue>0?(i.total/totalRevenue*100)+"%":"0%"}}/>
              </div>
            </div>)
          }
        </div>
        
        {/* Expense breakdown */}
        <div className="card" style={{padding:14,marginBottom:11}}>
          <h3 style={{fontSize:14,fontWeight:700,marginBottom:9}}>{String.fromCharCode(0xD83D,0xDCB8)} Expense Breakdown</h3>
          {catBreakdown.length===0?<p style={{fontSize:12,color:"#8a8078",fontStyle:"italic"}}>No expenses recorded for this period. Click "Add Expense" above to start tracking.</p>:
            catBreakdown.map(c=><div key={c.name} style={{marginBottom:7}}>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:12,marginBottom:3}}>
                <span style={{fontWeight:600}}>{c.name} ({c.count})</span>
                <span style={{fontWeight:700,color:"#dc2626"}}>{fmt(c.total)}</span>
              </div>
              <div style={{height:8,background:"#f7f3ee",borderRadius:4,overflow:"hidden"}}>
                <div style={{height:"100%",background:"linear-gradient(90deg,#dc2626,#f87171)",width:totalExpenses>0?(c.total/totalExpenses*100)+"%":"0%"}}/>
              </div>
            </div>)
          }
        </div>
        
        {/* Recent expenses list */}
        <div className="card" style={{padding:14,marginBottom:11}}>
          <h3 style={{fontSize:14,fontWeight:700,marginBottom:9}}>{String.fromCharCode(0xD83D,0xDCDD)} Recent Expenses ({expenses.length})</h3>
          {financeLoading?<p style={{fontSize:12,color:"#8a8078"}}>Loading...</p>:
           expenses.length===0?<p style={{fontSize:12,color:"#8a8078",fontStyle:"italic"}}>No expenses yet for this date range.</p>:
            <div style={{maxHeight:400,overflowY:"auto"}}>
              {expenses.slice(0,50).map(e=>{
                var cat=expenseCategories.find(c=>c.id===e.category_id);
                return <div key={e.id} style={{padding:"9px 11px",border:"1px solid #ede8de",borderRadius:7,marginBottom:5,display:"flex",alignItems:"center",gap:10,borderLeft:"4px solid "+(cat?.color||"#bf4626")}}>
                  <span style={{fontSize:22}}>{cat?.icon||String.fromCharCode(0xD83D,0xDCDD)}</span>
                  <div style={{flex:1,minWidth:0}}>
                    <p style={{fontSize:13,fontWeight:700}}>{e.description}</p>
                    <p style={{fontSize:10,color:"#8a8078"}}>{e.category_name} - {formatDate(e.expense_date)} - by {e.recorded_by}</p>
                  </div>
                  <p style={{fontSize:15,fontWeight:700,color:"#dc2626",fontFamily:"'Courier New',monospace",whiteSpace:"nowrap"}}>{fmt(e.amount)}</p>
                  <button onClick={()=>{
                    if(window.confirm("Delete this expense?")){
                      dbDeleteExpense(e.id).then(()=>{
                        setExpenses(es=>es.filter(x=>x.id!==e.id));
                        push&&push({title:"Expense deleted",body:e.description,color:"#dc2626"});
                      });
                    }
                  }} style={{padding:"4px 7px",background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:4,fontSize:10,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0xD83D,0xDDD1,0xFE0F)}</button>
                </div>;
              })}
            </div>
          }
        </div>
      </div>;
    })()}
    
    {tab==="shifts"&&<div>
      <div className="card" style={{marginBottom:11,padding:14,background:"linear-gradient(135deg,#1a1208,#3d2e22)",color:"#fff"}}>
        <h3 style={{fontSize:17,fontWeight:700,marginBottom:5}}>{String.fromCharCode(0xD83C,0xDF05)} Staff Shifts</h3>
        <p style={{fontSize:12,opacity:.85}}>Track opening floats, cash sales, end-of-shift counts, and variance.</p>
      </div>
      
      {shiftsLoading?<div className="card" style={{padding:30,textAlign:"center",color:"#8a8078"}}>Loading shifts...</div>:
        shiftsList.length===0?<div className="card" style={{padding:30,textAlign:"center",color:"#8a8078"}}>
          <p style={{fontSize:36,marginBottom:9}}>{String.fromCharCode(0xD83C,0xDF05)}</p>
          <p style={{fontSize:14,fontWeight:700,marginBottom:4}}>No shifts recorded</p>
          <p style={{fontSize:12}}>When staff opens a shift, it will appear here.</p>
          <p style={{fontSize:11,marginTop:9}}>Enable "Shift Management" in Settings to require shifts.</p>
        </div>:
        <div>
          {/* Active shifts */}
          {shiftsList.filter(s=>s.status==="open").length>0&&<div style={{marginBottom:14}}>
            <p style={{fontSize:12,color:"#059669",fontWeight:700,letterSpacing:1,marginBottom:7}}>{String.fromCharCode(0xD83D,0xDD34)} CURRENTLY OPEN ({shiftsList.filter(s=>s.status==="open").length})</p>
            {shiftsList.filter(s=>s.status==="open").map(s=><div key={s.id} className="card" style={{padding:12,marginBottom:6,borderLeft:"6px solid #059669"}}>
              <div style={{display:"flex",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
                <div>
                  <p style={{fontSize:14,fontWeight:700}}>{s.staff_name}</p>
                  <p style={{fontSize:11,color:"#8a8078"}}>Opened: {new Date(s.opened_at).toLocaleString("en-GB",{day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"})}</p>
                  <p style={{fontSize:11,color:"#8a8078"}}>Float: <b>{fmt(s.opening_float)}</b></p>
                </div>
                <div style={{textAlign:"right"}}>
                  <p style={{fontSize:11,color:"#8a8078"}}>Cash sales: <b>{fmt(s.cash_sales)}</b></p>
                  <p style={{fontSize:11,color:"#8a8078"}}>Card sales: <b>{fmt(s.card_sales)}</b></p>
                  <p style={{fontSize:13,fontWeight:700,color:"#059669"}}>Total: {fmt(parseFloat(s.cash_sales||0)+parseFloat(s.card_sales||0))}</p>
                </div>
              </div>
            </div>)}
          </div>}
          
          {/* Closed shifts */}
          {shiftsList.filter(s=>s.status!=="open").length>0&&<div>
            <p style={{fontSize:12,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:7}}>{String.fromCharCode(0xD83D,0xDCC8)} HISTORY ({shiftsList.filter(s=>s.status!=="open").length})</p>
            {shiftsList.filter(s=>s.status!=="open").map(s=>{
              var variance=parseFloat(s.variance||0);
              var vColor=Math.abs(variance)<0.5?"#059669":(Math.abs(variance)<5?"#d97706":"#dc2626");
              return <div key={s.id} className="card" style={{padding:11,marginBottom:5,borderLeft:"4px solid "+vColor}}>
                <div style={{display:"flex",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
                  <div>
                    <p style={{fontSize:13,fontWeight:700}}>{s.staff_name}</p>
                    <p style={{fontSize:11,color:"#8a8078"}}>{new Date(s.opened_at).toLocaleDateString("en-GB",{day:"numeric",month:"short"})} {new Date(s.opened_at).toLocaleTimeString("en-GB",{hour:"2-digit",minute:"2-digit"})} - {s.closed_at?new Date(s.closed_at).toLocaleTimeString("en-GB",{hour:"2-digit",minute:"2-digit"}):"open"}</p>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <p style={{fontSize:11,color:"#8a8078"}}>Expected: {fmt(s.expected_cash||0)} | Actual: {fmt(s.actual_cash||0)}</p>
                    <p style={{fontSize:13,fontWeight:700,color:vColor}}>{variance>=0?"+":""}{fmt(variance)} {Math.abs(variance)<0.01?"(perfect)":(variance>0?"(over)":"(short)")}</p>
                  </div>
                </div>
                {s.notes&&<p style={{fontSize:10,color:"#92400e",background:"#fef3c7",padding:"4px 7px",borderRadius:5,marginTop:5,fontStyle:"italic"}}>Note: {s.notes}</p>}
              </div>;
            })}
          </div>}
        </div>}
    </div>}
    
    {tab==="hours"&&<div>
      {hoursLoading&&<div className="card" style={{padding:30,textAlign:"center",color:"#8a8078"}}>Loading hours...</div>}
      {!hoursLoading&&branches.map(b=>{
        var todayDay=DAYS[new Date().getDay()];
        var bHours=advHours[b.id]||{};
        var bHolidays=holidays[b.id]||[];
        var cfg=hoursConfig[b.id]||{};
        var isExpanded=editingBranch===b.id;
        var DAY_NAMES=["Mon","Tue","Wed","Thu","Fri","Sat","Sun"];
        return <div key={b.id} className="card" style={{marginBottom:14,padding:0,overflow:"hidden"}}>
          {/* Branch header */}
          <div style={{padding:"14px 16px",background:"linear-gradient(135deg,#1a1208,#3d2e22)",color:"#fff",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8}}>
            <div>
              <h3 style={{fontSize:16,fontWeight:700,marginBottom:2}}>{b.name}</h3>
              <p style={{fontSize:11,color:"rgba(255,255,255,.7)"}}>{b.addr}</p>
            </div>
            <div style={{display:"flex",gap:6,alignItems:"center"}}>
              <span className="bdg" style={{background:isOpenNow(b.id)?"#d1fae5":"#fee2e2",color:isOpenNow(b.id)?"#059669":"#dc2626",fontWeight:700}}>{isOpenNow(b.id)?"Open Now":"Closed"}</span>
              <button onClick={()=>setEditingBranch(isExpanded?null:b.id)} style={{padding:"6px 13px",background:isExpanded?"#bf4626":"rgba(255,255,255,.15)",color:"#fff",border:"none",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>{isExpanded?"Collapse":"Edit Hours"}</button>
            </div>
          </div>

          {/* Compact summary view (when collapsed) */}
          {!isExpanded&&<div style={{padding:12}}>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(120px,1fr))",gap:6}}>
              {DAY_NAMES.map(day=>{
                var dh=bHours[day]||{};
                var primary=dh.all_1||dh["dine-in_1"]||{};
                var isToday=day===todayDay;
                return <div key={day} style={{background:isToday?"#fff5f3":"#f7f3ee",borderRadius:7,padding:"7px 9px",border:isToday?"2px solid #bf4626":"1px solid #ede8de"}}>
                  <p style={{fontWeight:700,fontSize:11,color:isToday?"#bf4626":"#8a8078",marginBottom:2}}>{day}{isToday?" (Today)":""}</p>
                  {primary.is_closed?<p style={{fontSize:11,color:"#dc2626",fontWeight:700}}>CLOSED</p>:
                    primary.open_time?<>
                      <p style={{fontWeight:600,fontSize:12}}>{primary.open_time} - {primary.close_time}</p>
                      {primary.last_order_time&&<p style={{fontSize:10,color:"#8a8078"}}>Last: {primary.last_order_time}</p>}
                    </>:<p style={{fontSize:11,color:"#8a8078"}}>Not set</p>}
                </div>;
              })}
            </div>
            {bHolidays.length>0&&<div style={{marginTop:10,padding:"7px 11px",background:"#fef3c7",borderRadius:6,fontSize:11,color:"#92400e"}}>
              <strong>{bHolidays.length} holiday{bHolidays.length>1?"s":""} configured</strong>
            </div>}
          </div>}

          {/* Expanded edit view */}
          {isExpanded&&<div style={{padding:14}}>
            {/* Config toggles */}
            <div style={{padding:11,background:"#fafaf5",borderRadius:8,marginBottom:14,border:"1px solid #ede8de"}}>
              <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:7}}>BEHAVIOR SETTINGS</p>
              <label style={{display:"flex",alignItems:"center",gap:6,marginBottom:5,cursor:"pointer"}}>
                <input type="checkbox" checked={cfg.block_orders_when_closed!==false} onChange={e=>saveConfig(b.id,{block_orders_when_closed:e.target.checked})} style={{width:16,height:16}}/>
                <span style={{fontSize:12}}>Block customer orders when closed</span>
              </label>
              <label style={{display:"flex",alignItems:"center",gap:6,marginBottom:5,cursor:"pointer"}}>
                <input type="checkbox" checked={cfg.block_orders_after_last_order!==false} onChange={e=>saveConfig(b.id,{block_orders_after_last_order:e.target.checked})} style={{width:16,height:16}}/>
                <span style={{fontSize:12}}>Block customer orders after last order time</span>
              </label>
              <label style={{display:"flex",alignItems:"center",gap:6,marginBottom:5,cursor:"pointer"}}>
                <input type="checkbox" checked={cfg.show_last_order_warning!==false} onChange={e=>saveConfig(b.id,{show_last_order_warning:e.target.checked})} style={{width:16,height:16}}/>
                <span style={{fontSize:12}}>Show "last orders" warning to customers ({cfg.warning_threshold_minutes||30} min before)</span>
              </label>
              <label style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer"}}>
                <input type="checkbox" checked={cfg.allow_staff_override!==false} onChange={e=>saveConfig(b.id,{allow_staff_override:e.target.checked})} style={{width:16,height:16}}/>
                <span style={{fontSize:12}}>Allow staff to override and accept late orders</span>
              </label>
            </div>

            {/* Per-day editor */}
            <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:7}}>OPENING HOURS BY DAY</p>
            {DAY_NAMES.map(day=>{
              var dh=bHours[day]||{};
              var primary=dh.all_1||{};
              var isToday=day===todayDay;
              return <div key={day} style={{padding:11,background:isToday?"#fff5f3":"#fff",borderRadius:8,marginBottom:7,border:isToday?"2px solid #bf4626":"1px solid #ede8de"}}>
                <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                  <div style={{minWidth:60,fontWeight:700,fontSize:13,color:isToday?"#bf4626":"#1a1208"}}>{day}{isToday?" (Today)":""}</div>
                  <label style={{display:"flex",alignItems:"center",gap:5,cursor:"pointer"}}>
                    <input type="checkbox" checked={primary.is_closed||false} onChange={e=>saveDayHours(b.id,day,"all",1,{...primary,is_closed:e.target.checked})} style={{width:16,height:16}}/>
                    <span style={{fontSize:11,fontWeight:700,color:"#dc2626"}}>Closed all day</span>
                  </label>
                  {!primary.is_closed&&<>
                    <div style={{display:"flex",alignItems:"center",gap:4}}>
                      <label style={{fontSize:10,color:"#8a8078",fontWeight:700}}>OPEN</label>
                      <input type="time" value={primary.open_time||""} onChange={e=>saveDayHours(b.id,day,"all",1,{...primary,open_time:e.target.value})} style={{padding:"5px 7px",border:"1px solid #ede8de",borderRadius:5,fontSize:12,width:90}}/>
                    </div>
                    <div style={{display:"flex",alignItems:"center",gap:4}}>
                      <label style={{fontSize:10,color:"#8a8078",fontWeight:700}}>CLOSE</label>
                      <input type="time" value={primary.close_time||""} onChange={e=>saveDayHours(b.id,day,"all",1,{...primary,close_time:e.target.value})} style={{padding:"5px 7px",border:"1px solid #ede8de",borderRadius:5,fontSize:12,width:90}}/>
                    </div>
                    <div style={{display:"flex",alignItems:"center",gap:4}}>
                      <label style={{fontSize:10,color:"#8a8078",fontWeight:700}}>LAST ORDER</label>
                      <input type="time" value={primary.last_order_time||""} onChange={e=>saveDayHours(b.id,day,"all",1,{...primary,last_order_time:e.target.value})} style={{padding:"5px 7px",border:"1px solid #ede8de",borderRadius:5,fontSize:12,width:90,background:"#fef3c7"}}/>
                    </div>
                  </>}
                </div>
              </div>;
            })}

            {/* Holidays section */}
            <div style={{marginTop:14,padding:12,background:"#fafaf5",borderRadius:8,border:"1px solid #ede8de"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                <p style={{fontSize:13,fontWeight:700}}>{EM.cal} Holidays & Special Dates</p>
                <button onClick={()=>{setEditHoliday({branch_id:b.id,holiday_date:"",holiday_name:"",is_closed:true,open_time:"",close_time:"",last_order_time:"",notes:""});setShowHolidayModal(true);}} style={{padding:"6px 12px",background:"#bf4626",color:"#fff",border:"none",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>+ Add Holiday</button>
              </div>
              {bHolidays.length===0?<p style={{fontSize:11,color:"#8a8078",fontStyle:"italic"}}>No holidays configured. Add Christmas, Easter, etc.</p>:bHolidays.map(h=><div key={h.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"7px 9px",background:"#fff",borderRadius:6,marginBottom:4,border:"1px solid #ede8de"}}>
                <div>
                  <p style={{fontSize:12,fontWeight:700}}>{h.holiday_name} - {new Date(h.holiday_date).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"})}</p>
                  <p style={{fontSize:11,color:h.is_closed?"#dc2626":"#059669",fontWeight:700}}>{h.is_closed?"CLOSED":"Open "+h.open_time+" - "+h.close_time+(h.last_order_time?" (last order "+h.last_order_time+")":"")}</p>
                </div>
                <div style={{display:"flex",gap:5}}>
                  <button onClick={()=>{setEditHoliday(h);setShowHolidayModal(true);}} style={{padding:"4px 9px",background:"#f7f3ee",border:"1px solid #ede8de",borderRadius:5,fontSize:10,fontWeight:700,cursor:"pointer"}}>Edit</button>
                  <button onClick={()=>deleteHoliday(b.id,h.id)} style={{padding:"4px 9px",background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:5,fontSize:10,fontWeight:700,cursor:"pointer"}}>Delete</button>
                </div>
              </div>)}
            </div>
          </div>}
        </div>;
      })}

      {/* Holiday modal */}
      {showHolidayModal&&editHoliday&&<div onClick={()=>setShowHolidayModal(false)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",zIndex:9000,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
        <div onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:12,padding:18,maxWidth:480,width:"100%"}}>
          <h3 style={{fontSize:17,fontWeight:700,marginBottom:11}}>{editHoliday.id?"Edit":"Add"} Holiday</h3>
          <label style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3,display:"block"}}>HOLIDAY NAME</label>
          <input value={editHoliday.holiday_name} onChange={e=>setEditHoliday({...editHoliday,holiday_name:e.target.value})} placeholder="Christmas Day" className="field" style={{marginBottom:9}}/>
          <label style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3,display:"block"}}>DATE</label>
          <input type="date" value={editHoliday.holiday_date} onChange={e=>setEditHoliday({...editHoliday,holiday_date:e.target.value})} className="field" style={{marginBottom:9}}/>
          <label style={{display:"flex",alignItems:"center",gap:6,marginBottom:9,cursor:"pointer"}}>
            <input type="checkbox" checked={editHoliday.is_closed} onChange={e=>setEditHoliday({...editHoliday,is_closed:e.target.checked})} style={{width:16,height:16}}/>
            <span style={{fontSize:13,fontWeight:700}}>Closed all day</span>
          </label>
          {!editHoliday.is_closed&&<div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:5,marginBottom:9}}>
            <div><label style={{fontSize:10,color:"#8a8078",fontWeight:700}}>OPEN</label><input type="time" value={editHoliday.open_time||""} onChange={e=>setEditHoliday({...editHoliday,open_time:e.target.value})} className="field" style={{fontSize:12,padding:"6px 8px"}}/></div>
            <div><label style={{fontSize:10,color:"#8a8078",fontWeight:700}}>CLOSE</label><input type="time" value={editHoliday.close_time||""} onChange={e=>setEditHoliday({...editHoliday,close_time:e.target.value})} className="field" style={{fontSize:12,padding:"6px 8px"}}/></div>
            <div><label style={{fontSize:10,color:"#8a8078",fontWeight:700}}>LAST ORDER</label><input type="time" value={editHoliday.last_order_time||""} onChange={e=>setEditHoliday({...editHoliday,last_order_time:e.target.value})} className="field" style={{fontSize:12,padding:"6px 8px"}}/></div>
          </div>}
          <label style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3,display:"block"}}>NOTES (OPTIONAL)</label>
          <input value={editHoliday.notes||""} onChange={e=>setEditHoliday({...editHoliday,notes:e.target.value})} placeholder="e.g., Boxing Day - shorter hours" className="field" style={{marginBottom:11}}/>
          <div style={{display:"flex",gap:6}}>
            <button onClick={()=>setShowHolidayModal(false)} style={{flex:1,padding:"10px",background:"#f7f3ee",border:"1px solid #ede8de",borderRadius:7,fontWeight:700,cursor:"pointer",fontSize:13}}>Cancel</button>
            <button onClick={()=>{
              if(!editHoliday.holiday_name||!editHoliday.holiday_date){alert("Name and date required");return;}
              saveHoliday(editHoliday.branch_id,editHoliday);
              setShowHolidayModal(false);
              push({title:"Holiday saved",body:editHoliday.holiday_name,color:"#059669"});
            }} style={{flex:2,padding:"10px",background:"#059669",color:"#fff",border:"none",borderRadius:7,fontWeight:700,cursor:"pointer",fontSize:13}}>Save Holiday</button>
          </div>
        </div>
      </div>}
    </div>}

    {tab==="settings"&&<div>
      {/* PLAN INFO + QR CODE */}
      <div className="card" style={{padding:18,marginBottom:12,borderLeft:"4px solid #a855f7"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
          <div>
            <p style={{fontSize:15,fontWeight:700,marginBottom:4}}>{String.fromCharCode(0x2728)} Your Plan</p>
            <p style={{fontSize:13,color:"#8a8078"}}>
              {restaurant?.billing_type==="commission"
                ?"Commission plan - "+(restaurant.commission_rate||0)+"% per online order"
                :(restaurant?.plan||"Starter").charAt(0).toUpperCase()+(restaurant?.plan||"starter").slice(1)+" plan"+(restaurant?.plan_price?" - "+fmt(restaurant.plan_price)+"/month":"")}
            </p>
          </div>
          <button onClick={()=>setShowQRGenerator&&setShowQRGenerator(true)} style={{padding:"10px 16px",background:"linear-gradient(135deg,#059669,#047857)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer",display:"flex",alignItems:"center",gap:6}}>
            <span style={{fontSize:15}}>{String.fromCharCode(0xD83D,0xDCF1)}</span>
            <span>Get QR Code & Link</span>
          </button>
        </div>
        <p style={{fontSize:11,color:"#8a8078",marginTop:9}}>{String.fromCharCode(0xD83D,0xDCA1)} Share your QR code on tables, flyers, and social media so customers can order online.</p>
      </div>
      
      {/* RESTAURANT LOGO */}
      <RestaurantLogoCard restaurant={restaurant} setRestaurant={setRestaurant} push={push}/>
      
      {/* CUSTOMIZE DASHBOARD TILES */}
      <DashboardCustomizeCard push={push}/>
      
      {/* DISPLAY SIZE - touchscreen comfort */}
      <div className="card" style={{padding:18,marginBottom:12,borderLeft:"4px solid #0891b2"}}>
        <p style={{fontSize:15,fontWeight:700,marginBottom:4}}>{String.fromCharCode(0xD83D,0xDD0D)} Display Size</p>
        <p style={{fontSize:11,color:"#8a8078",marginBottom:12}}>Adjust text and button size for comfort. The buttons are already touch-friendly - this fine-tunes it.</p>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8}}>
          {[["95","Compact"],["100","Normal"],["108","Large"]].map(([val,label])=>{
            var current=(typeof window!=="undefined"&&localStorage.getItem("ui_scale"))||"100";
            var isActive=current===val;
            return <button key={val} onClick={()=>{
              try{
                localStorage.setItem("ui_scale",val);
                window.location.reload();
              }catch(e){}
            }} style={{padding:"16px 10px",borderRadius:11,border:"2px solid "+(isActive?"#0891b2":"#ede8de"),background:isActive?"#ecfeff":"#fff",cursor:"pointer",textAlign:"center"}}>
              <div style={{fontSize:val==="95"?16:val==="100"?20:24,fontWeight:700,marginBottom:4,color:isActive?"#0e7490":"#1a1208"}}>A</div>
              <p style={{fontSize:11,fontWeight:700,color:isActive?"#0e7490":"#8a8078"}}>{label}</p>
            </button>;
          })}
        </div>
        <p style={{fontSize:10,color:"#8a8078",marginTop:9,textAlign:"center"}}>{String.fromCharCode(0xD83D,0xDCA1)} The page will refresh to apply the new size</p>
      </div>
      
      {/* PHASE A: Restaurant Info - critical for delivery */}
      {restaurant&&<div className="card" style={{padding:16,marginBottom:12,borderLeft:"4px solid #bf4626"}}>
        <p style={{fontSize:15,fontWeight:700,marginBottom:4}}>{String.fromCharCode(0xD83C,0xDFEA)} Restaurant Information</p>
        <p style={{fontSize:11,color:"#8a8078",marginBottom:12}}>This is your restaurant's address and location. Used for delivery distance calculations.</p>
        <div className="g2" style={{marginBottom:9}}>
          <div><label className="lbl">Restaurant name</label><input className="field" defaultValue={restaurant.name||""} id="rest_name_input" placeholder="My Restaurant"/></div>
          <div><label className="lbl">Phone</label><input className="field" defaultValue={restaurant.phone||""} id="rest_phone_input" placeholder="020 7123 4567"/></div>
        </div>
        <div className="g2" style={{marginBottom:9}}>
          <div><label className="lbl">Full address</label><input className="field" defaultValue={restaurant.address||""} id="rest_addr_input" placeholder="123 High Street, London"/></div>
          <div><label className="lbl">Postcode</label><input className="field" defaultValue={restaurant.postcode||""} id="rest_postcode_input" placeholder="E1 6QL" style={{textTransform:"uppercase"}}/></div>
        </div>
        <div className="g2" style={{marginBottom:9}}>
          <div><label className="lbl">Latitude {String.fromCharCode(0x2139,0xFE0F)}</label><input className="field" type="number" step="0.0001" defaultValue={restaurant.lat||""} id="rest_lat_input" placeholder="51.5246"/></div>
          <div><label className="lbl">Longitude {String.fromCharCode(0x2139,0xFE0F)}</label><input className="field" type="number" step="0.0001" defaultValue={restaurant.lng||""} id="rest_lng_input" placeholder="-0.0716"/></div>
        </div>
        <div style={{padding:10,background:"#fef3c7",borderRadius:7,marginBottom:11,fontSize:11,color:"#92400e"}}>
          <p style={{fontWeight:700,marginBottom:3}}>{String.fromCharCode(0xD83D,0xDCA1)} How to find lat/lng:</p>
          <p>1. Open Google Maps, search your address</p>
          <p>2. Right-click on the location marker</p>
          <p>3. Click the coordinates that appear (e.g., "51.5246, -0.0716")</p>
          <p>4. Paste the first number in Latitude, second in Longitude</p>
        </div>
        <button onClick={()=>{
          var name=document.getElementById("rest_name_input").value.trim();
          var phone=document.getElementById("rest_phone_input").value.trim();
          var addr=document.getElementById("rest_addr_input").value.trim();
          var pc=document.getElementById("rest_postcode_input").value.trim().toUpperCase();
          var lat=parseFloat(document.getElementById("rest_lat_input").value);
          var lng=parseFloat(document.getElementById("rest_lng_input").value);
          if(!name){push({title:"Name required",body:"Restaurant name cannot be empty",color:"#dc2626"});return;}
          dbUpdateRestaurant(restaurant.id,{
            name:name,phone:phone,address:addr,postcode:pc,
            lat:isNaN(lat)?null:lat,lng:isNaN(lng)?null:lng
          }).then(({data,error})=>{
            if(error){push({title:"Save failed",body:error.message,color:"#dc2626"});return;}
            if(data){
              setRestaurant(data);
              try{window.__currentRestaurant=data;}catch(e){}
              try{localStorage.setItem("latavola_saas_restaurant",JSON.stringify(data));}catch(e){}
              push({title:"Restaurant info saved",body:"Address and location updated",color:"#059669"});
            }
          });
        }} className="btn btn-r" style={{width:"100%",padding:"11px",fontSize:13}}>Save Restaurant Info</button>
      </div>}

      {/* SERVICE TYPES - What this restaurant offers */}
      {restaurant&&<div className="card" style={{padding:16,marginBottom:12,borderLeft:"4px solid #7c3aed"}}>
        <p style={{fontSize:15,fontWeight:700,marginBottom:4}}>{String.fromCharCode(0xD83C,0xDF7D,0xFE0F)} Services Offered</p>
        <p style={{fontSize:11,color:"#8a8078",marginBottom:12}}>Choose what services you offer. This will hide/show features in your POS and on your customer ordering page.</p>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))",gap:9,marginBottom:12}}>
          {[
            {id:"dine_in",name:"Dine-in",icon:String.fromCharCode(0xD83C,0xDF7D,0xFE0F),desc:"Tables, bookings, restaurant POS",color:"#7c3aed"},
            {id:"collection",name:"Collection",icon:String.fromCharCode(0xD83D,0xDED2),desc:"Customer comes to pick up orders",color:"#0891b2"},
            {id:"delivery",name:"Delivery",icon:String.fromCharCode(0xD83D,0xDEF5),desc:"Delivery service with codes & drivers",color:"#dc2626"},
            {id:"phone_orders",name:"Phone Orders",icon:String.fromCharCode(0xD83D,0xDCDE),desc:"Take orders by phone via POS",color:"#059669"},
          ].map(svc=>{
            var lockState=getFeatureLockState(restaurant,svc.id);
            var isLockedOff=lockState==="lock_off";
            var isLockedOn=lockState==="lock_on";
            var canToggle=lockState==="allow";
            var isActive=isLockedOn?true:(isLockedOff?false:(restaurant?.service_types?.[svc.id]!==false));
            
            // Hide entirely if locked off (don't show to owner)
            if(isLockedOff)return null;
            
            return <label key={svc.id} style={{display:"flex",alignItems:"flex-start",gap:9,padding:11,background:isActive?"#f7f3ee":"#fafaf5",border:"2px solid "+(isActive?svc.color:"#ede8de"),borderRadius:9,cursor:canToggle?"pointer":"not-allowed",transition:"all .15s",opacity:canToggle?1:.85}}>
              <input type="checkbox" checked={isActive} disabled={!canToggle} onChange={async (e)=>{
                if(!canToggle)return;
                var newSvc={...(restaurant?.service_types||{dine_in:true,collection:true,delivery:true,phone_orders:true})};
                newSvc[svc.id]=e.target.checked;
                var result=await dbUpdateServiceTypes(restaurant.id,newSvc);
                if(result.error){
                  push&&push({title:"Failed",body:result.error.message,color:"#dc2626"});
                } else {
                  push&&push({title:svc.name+(e.target.checked?" enabled":" disabled"),color:svc.color});
                  if(setRestaurant)setRestaurant({...restaurant,service_types:newSvc});
                }
              }} style={{marginTop:3,width:18,height:18,cursor:canToggle?"pointer":"not-allowed"}}/>
              <div style={{flex:1}}>
                <p style={{fontSize:13,fontWeight:700,marginBottom:2,color:isActive?svc.color:"#8a8078"}}>{svc.icon} {svc.name} {isLockedOn&&<span style={{fontSize:10,color:"#059669",marginLeft:5}}>{String.fromCharCode(0xD83D,0xDD12)} Always on</span>}</p>
                <p style={{fontSize:11,color:"#8a8078"}}>{svc.desc}</p>
              </div>
            </label>;
          })}
        </div>
        <div style={{padding:9,background:"#fef3c7",borderRadius:7,fontSize:11,color:"#92400e"}}>
          <strong>{String.fromCharCode(0xD83D,0xDCA1)} Tip:</strong> Pure takeaway? Disable Dine-in. Pure restaurant? Disable Delivery. The system will adapt automatically.
        </div>
      </div>}

      {/* PLAN INFO */}
      {restaurant&&<div className="card" style={{padding:16,marginBottom:12,borderLeft:"4px solid #d97706"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:9,marginBottom:9}}>
          <div>
            <p style={{fontSize:15,fontWeight:700}}>{String.fromCharCode(0xD83D,0xDCB3)} Subscription Plan</p>
            <p style={{fontSize:11,color:"#8a8078"}}>Your current plan determines available features</p>
          </div>
          <div style={{padding:"7px 14px",background:restaurant.plan==="enterprise"?"#fef3c7":(restaurant.plan==="pro"?"#dbeafe":"#f7f3ee"),color:restaurant.plan==="enterprise"?"#92400e":(restaurant.plan==="pro"?"#1e40af":"#1a1208"),borderRadius:11,fontSize:13,fontWeight:700,textTransform:"capitalize"}}>
            {restaurant.plan||"starter"}
          </div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))",gap:7,fontSize:11}}>
          {[
            ["online_ordering","Online Ordering"],
            ["bookings","Bookings"],
            ["online_payments","Online Payments"],
            ["promo_codes","Promo Codes"],
            ["set_meals","Set Meals"],
            ["custom_url","Custom URL"],
            ["advanced_analytics","Advanced Analytics"],
            ["custom_domain","Custom Domain"],
          ].map(f=>{
            var has=hasFeature(restaurant,f[0]);
            return <div key={f[0]} style={{display:"flex",alignItems:"center",gap:5,padding:"5px 9px",background:has?"#d1fae5":"#fafaf5",borderRadius:5,color:has?"#065f46":"#8a8078"}}>
              <span style={{fontWeight:700}}>{has?String.fromCharCode(0x2713):String.fromCharCode(0x2715)}</span>
              <span>{f[1]}</span>
            </div>;
          })}
        </div>
        <p style={{fontSize:11,color:"#8a8078",marginTop:9}}>{String.fromCharCode(0xD83D,0xDCDE)} Need more features? Contact support to upgrade your plan.</p>
      </div>}

      <div className="card" style={{padding:16,marginBottom:12}}>
        <p style={{fontSize:15,fontWeight:700,marginBottom:6}}>POS User Interface</p>
        <p style={{fontSize:11,color:"#8a8078",marginBottom:12}}>Choose how the POS screen looks for staff. Each style is optimized for different needs.</p>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(170px,1fr))",gap:8}}>
          {[
            {id:"modern",name:"Modern",desc:"Clean, mobile-friendly, beautiful design",icon:EM.star,color:"#bf4626"},
            {id:"classic",name:"Classic",desc:"Traditional POSCUBE-style with category buttons",icon:EM.cook,color:"#d4952a"},
            {id:"compact",name:"Compact",desc:"Small screens & tablets, condensed layout",icon:EM.phone,color:"#7c3aed"},
          ].map(opt=><button key={opt.id} onClick={()=>{setPosUiStyle(opt.id);try{localStorage.setItem("pos_ui_style",opt.id);}catch(e){}push({title:"UI updated",body:opt.name+" UI now active",color:opt.color});}} style={{padding:"14px 13px",background:posUiStyle===opt.id?opt.color:"#fff",color:posUiStyle===opt.id?"#fff":"#1a1208",border:"3px solid "+opt.color,borderRadius:12,cursor:"pointer",textAlign:"left",fontWeight:700,transition:"all .15s"}}>
            <div style={{fontSize:24,marginBottom:5}}>{opt.icon}</div>
            <p style={{fontSize:14,fontWeight:700,marginBottom:3}}>{opt.name}{posUiStyle===opt.id?" - Active":""}</p>
            <p style={{fontSize:10,opacity:.85,fontWeight:400,lineHeight:1.4}}>{opt.desc}</p>
          </button>)}
        </div>
      </div>

      <div className="card" style={{padding:16,marginBottom:12}}>
        <p style={{fontSize:15,fontWeight:700,marginBottom:6}}>Shift Management</p>
        <p style={{fontSize:11,color:"#8a8078",marginBottom:12}}>Track staff shifts with opening cash float, sales totals, and end-of-shift cash counts. When enabled, staff must open a shift before taking orders and close it at end of day.</p>
        <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer"}}>
          <input type="checkbox" checked={(()=>{try{return localStorage.getItem("shifts_enabled")==="1";}catch(e){return false;}})()} onChange={e=>{try{localStorage.setItem("shifts_enabled",e.target.checked?"1":"0");push({title:e.target.checked?"Shift management enabled":"Shift management disabled",body:e.target.checked?"Staff will need to open a shift before serving":"Staff can serve without shift tracking",color:"#059669"});window.location.reload();}catch(err){}}} style={{width:18,height:18,cursor:"pointer"}}/>
          <span style={{fontWeight:700,fontSize:13}}>Enable shift management</span>
        </label>
      </div>

      {/* OFFLINE PIN - Security */}
      <div className="card" style={{padding:16,marginBottom:12,borderLeft:"4px solid #dc2626"}}>
        <p style={{fontSize:15,fontWeight:700,marginBottom:6}}>{String.fromCharCode(0xD83D,0xDD12)} Offline Login PIN</p>
        <p style={{fontSize:11,color:"#8a8078",marginBottom:12}}>Set a 4-6 digit PIN to require for offline login. Prevents unauthorized access when internet is down. Leave empty to disable PIN requirement.</p>
        
        <div style={{display:"flex",gap:7,alignItems:"end",flexWrap:"wrap"}}>
          <div style={{flex:1,minWidth:140}}>
            <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>CURRENT PIN</p>
            <input type="password" id="offline-pin-input" defaultValue={(()=>{try{return localStorage.getItem("latavola_offline_pin")||"";}catch(e){return"";}})()} inputMode="numeric" pattern="[0-9]*" maxLength={6} placeholder="4-6 digits" style={{width:"100%",padding:"11px",border:"2px solid #ede8de",borderRadius:7,fontSize:14,letterSpacing:3,boxSizing:"border-box"}}/>
          </div>
          <button onClick={()=>{
            var input=document.getElementById("offline-pin-input");
            var val=input?input.value.replace(/\D/g,""):"";
            try{
              if(!val){
                localStorage.removeItem("latavola_offline_pin");
                push({title:"PIN disabled",body:"No PIN required for offline login",color:"#d97706"});
              }else if(val.length<4){
                if(window.showAlert)window.showAlert("PIN too short","Use at least 4 digits","warning");
                return;
              }else{
                localStorage.setItem("latavola_offline_pin",val);
                push({title:"PIN saved",body:val.length+" digit PIN set",color:"#059669"});
              }
            }catch(err){}
          }} style={{padding:"11px 18px",background:"#dc2626",color:"#fff",border:"none",borderRadius:7,fontWeight:700,fontSize:13,cursor:"pointer"}}>Save PIN</button>
        </div>
        
        <div style={{padding:9,background:"#fef2f2",borderRadius:7,marginTop:11,fontSize:11,color:"#991b1b"}}>
          <strong>{String.fromCharCode(0x26A0,0xFE0F)} Important:</strong>
          <ul style={{paddingLeft:18,marginTop:5}}>
            <li>PIN only applies to OFFLINE login</li>
            <li>Online login still requires email + password</li>
            <li>Remember your PIN - if forgotten, login online to reset</li>
            <li>Don't share PIN with anyone</li>
          </ul>
        </div>
      </div>
      
      {/* FULLSCREEN POS MODE SETTING */}
      <div className="card" style={{padding:16,marginBottom:12,borderLeft:"4px solid #9333ea"}}>
        <p style={{fontSize:15,fontWeight:700,marginBottom:6}}>{String.fromCharCode(0x26F6,0xFE0F)} Fullscreen POS Mode</p>
        <p style={{fontSize:11,color:"#8a8078",marginBottom:12}}>Make the POS feel like a real EPOS terminal. Hides browser bars, address bar, tabs, etc. for a clean professional look. Staff can press ESC anytime to exit.</p>
        
        <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",marginBottom:11}}>
          <input type="checkbox" checked={(()=>{try{return localStorage.getItem("pos_auto_fullscreen")==="1";}catch(e){return false;}})()} onChange={e=>{
            try{
              localStorage.setItem("pos_auto_fullscreen",e.target.checked?"1":"0");
              push({title:e.target.checked?"Auto fullscreen enabled":"Auto fullscreen disabled",body:e.target.checked?"POS will go fullscreen automatically":"Staff can choose to go fullscreen",color:"#059669"});
            }catch(err){}
          }} style={{width:18,height:18,cursor:"pointer"}}/>
          <span style={{fontWeight:700,fontSize:13}}>Auto-enter fullscreen when staff opens dashboard</span>
        </label>
        
        <div style={{display:"flex",gap:7,flexWrap:"wrap",marginTop:7}}>
          <button onClick={()=>{
            try{
              if(document.fullscreenElement){
                document.exitFullscreen();
              }else{
                document.documentElement.requestFullscreen().catch(e=>{
                  alert("Fullscreen not supported in your browser");
                });
              }
            }catch(e){}
          }} style={{padding:"9px 14px",background:"#9333ea",color:"#fff",border:"none",borderRadius:7,fontSize:12,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0x26F6,0xFE0F)} Test Fullscreen Now</button>
          <span style={{fontSize:10,color:"#8a8078",alignSelf:"center"}}>{String.fromCharCode(0xD83D,0xDCA1)} Press F11 or ESC to exit anytime</span>
        </div>
        
        <div style={{padding:9,background:"#f3e8ff",borderRadius:7,marginTop:11,fontSize:11,color:"#6b21a8"}}>
          <strong>{String.fromCharCode(0xD83D,0xDCA1)} Pro tip:</strong> For best EPOS experience:
          <ul style={{paddingLeft:18,marginTop:5}}>
            <li>Use a tablet/iPad mounted on counter</li>
            <li>Or dedicated touchscreen monitor</li>
            <li>Enable auto-fullscreen above</li>
            <li>Bookmark the URL for quick access</li>
          </ul>
        </div>
      </div>

      <div className="card" style={{padding:16,marginBottom:12}}>
        <p style={{fontSize:15,fontWeight:700,marginBottom:6}}>Receipt & VAT Settings</p>
        <p style={{fontSize:11,color:"#8a8078",marginBottom:12}}>Configure how VAT is shown on receipts. UK businesses are usually required to show VAT breakdown by HMRC.</p>
        
        <label style={{display:"flex",alignItems:"center",gap:8,marginBottom:11,cursor:"pointer"}}>
          <input type="checkbox" checked={showVAT} onChange={e=>{setShowVAT(e.target.checked);try{localStorage.setItem("show_vat",e.target.checked?"1":"0");}catch(err){}}} style={{width:18,height:18,cursor:"pointer"}}/>
          <span style={{fontWeight:700,fontSize:13}}>Show VAT breakdown on receipts</span>
        </label>

        {showVAT&&<div style={{display:"grid",gridTemplateColumns:"1fr 2fr",gap:8,marginTop:9}}>
          <div>
            <label style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:4,display:"block"}}>VAT RATE %</label>
            <input type="number" value={vatRate} onChange={e=>{var v=parseFloat(e.target.value)||0;setVatRate(v);try{localStorage.setItem("vat_rate",String(v));}catch(err){}}} step="0.5" className="field" style={{padding:"8px 11px"}}/>
          </div>
          <div>
            <label style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:4,display:"block"}}>VAT REGISTRATION NUMBER</label>
            <input value={vatNumber} onChange={e=>{setVatNumber(e.target.value);try{localStorage.setItem("vat_number",e.target.value);}catch(err){}}} placeholder="GB 123 4567 89" className="field" style={{padding:"8px 11px"}}/>
          </div>
        </div>}
      </div>

      <div className="card" style={{padding:16,marginBottom:12}}>
        <p style={{fontSize:15,fontWeight:700,marginBottom:6}}>On-Screen Keyboard Size</p>
        <p style={{fontSize:11,color:"#8a8078",marginBottom:12}}>Pick keyboard button size for staff. Larger sizes are easier to tap on touchscreens.</p>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8}}>
          {[
            {id:"small",name:"Small",desc:"Compact - fits more on screen",h:46,fs:16},
            {id:"medium",name:"Medium",desc:"Balanced - good for most users",h:58,fs:20},
            {id:"large",name:"Large",desc:"Big buttons - best for touchscreens",h:72,fs:24},
          ].map(opt=><button key={opt.id} onClick={()=>{setKbSize(opt.id);try{localStorage.setItem("kb_size",opt.id);}catch(e){}push({title:"Keyboard size "+opt.name,body:"Will apply to next phone order",color:"#bf4626"});}} style={{padding:"14px 11px",background:kbSize===opt.id?"#bf4626":"#fff",color:kbSize===opt.id?"#fff":"#1a1208",border:"3px solid #bf4626",borderRadius:11,cursor:"pointer",textAlign:"left",fontWeight:700}}>
            <div style={{height:opt.h/3,background:kbSize===opt.id?"rgba(255,255,255,.2)":"#f7f3ee",borderRadius:5,marginBottom:6,display:"flex",alignItems:"center",justifyContent:"center",fontSize:opt.fs/2,fontWeight:700}}>A B C</div>
            <p style={{fontSize:13,marginBottom:2}}>{opt.name}{kbSize===opt.id?" - Active":""}</p>
            <p style={{fontSize:9,opacity:.85,fontWeight:400,lineHeight:1.3}}>{opt.desc}</p>
          </button>)}
        </div>
      </div>

      <div className="card" style={{padding:16,marginBottom:12}}>
        <p style={{fontSize:15,fontWeight:700,marginBottom:6}}>POS Dashboard Home Screen</p>
        <p style={{fontSize:11,color:"#8a8078",marginBottom:12}}>Show a dashboard with quick-access tiles when staff opens POS. Like POSCUBE-style restaurants.</p>
        <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer"}}>
          <input type="checkbox" checked={showDashboard} onChange={e=>{setShowDashboard(e.target.checked);try{localStorage.setItem("show_pos_dashboard",e.target.checked?"1":"0");}catch(err){}push({title:"Dashboard "+(e.target.checked?"enabled":"disabled"),body:"Refresh POS to see change",color:"#2563eb"});}} style={{width:18,height:18,cursor:"pointer"}}/>
          <span style={{fontWeight:700,fontSize:13}}>Show dashboard home screen on POS</span>
        </label>
        <p style={{fontSize:10,color:"#8a8078",marginTop:8}}>Note: Dashboard feature is being built. Toggle on to be ready when it launches.</p>
      </div>

      <div className="card" style={{padding:16,background:"#fffbeb",borderLeft:"4px solid #f59e0b"}}>
        <p style={{fontSize:13,fontWeight:700,color:"#92400e",marginBottom:5}}>Coming Soon</p>
        <p style={{fontSize:11,color:"#92400e",marginBottom:6}}>The Classic and Compact UI styles are currently placeholder screens.</p>
        <p style={{fontSize:11,color:"#92400e"}}>For full feature access, keep "Modern" UI selected. We will build out Classic and Compact in upcoming updates.</p>
      </div>
    </div>}
  </div>;
}

// Restaurant's own commission view (shown in Finance tab if on commission plan)
function CommissionWidget({restaurant}){
  var [comm,setComm]=useState(null);
  
  useEffect(function(){
    if(!restaurant||restaurant.billing_type!=="commission")return;
    dbGetRestCommission(restaurant.id).then(function(d){setComm(d);}).catch(function(e){console.error(e);});
  },[restaurant]);
  
  // Only show for commission-plan restaurants
  if(!restaurant||restaurant.billing_type!=="commission")return null;
  if(!comm)return null;
  
  // This month's charges
  var now=new Date();
  var thisMonth=(comm.entries||[]).filter(function(e){
    var d=new Date(e.created_at);
    return d.getMonth()===now.getMonth()&&d.getFullYear()===now.getFullYear();
  });
  var thisMonthTotal=thisMonth.reduce(function(s,e){return s+parseFloat(e.commission_amount||0);},0);
  
  return <div className="card" style={{padding:14,marginBottom:11,borderLeft:"4px solid #7c3aed"}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:8}}>
      <div>
        <p style={{fontSize:14,fontWeight:700}}>{String.fromCharCode(0xD83D,0xDCB3)} Platform Commission</p>
        <p style={{fontSize:11,color:"#8a8078",marginTop:2}}>You're on the commission plan ({restaurant.commission_rate||0}% per online order)</p>
      </div>
    </div>
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(120px,1fr))",gap:9,marginTop:11}}>
      <div style={{background:"#f5f3ff",borderRadius:9,padding:11}}>
        <p style={{fontSize:19,fontWeight:700,color:"#7c3aed"}}>{fmt(thisMonthTotal)}</p>
        <p style={{fontSize:10,color:"#8a8078"}}>This month</p>
      </div>
      <div style={{background:"#fef3c7",borderRadius:9,padding:11}}>
        <p style={{fontSize:19,fontWeight:700,color:"#92400e"}}>{fmt(comm.unpaid)}</p>
        <p style={{fontSize:10,color:"#8a8078"}}>Total owed</p>
      </div>
      <div style={{background:"#d1fae5",borderRadius:9,padding:11}}>
        <p style={{fontSize:19,fontWeight:700,color:"#065f46"}}>{fmt(comm.paid)}</p>
        <p style={{fontSize:10,color:"#8a8078"}}>Paid to date</p>
      </div>
    </div>
    {comm.unpaid>0&&<p style={{fontSize:11,color:"#8a8078",marginTop:9,paddingTop:9,borderTop:"1px solid #ede8de"}}>{String.fromCharCode(0xD83D,0xDCA1)} Commission is billed monthly. You'll be contacted with payment details.</p>}
  </div>;
}

function ReportV({orders}){
  // Build last 30 days of REAL revenue from actual orders
  var today=new Date();
  // First, group orders by date string
  var revByDate={};
  var countByDate={};
  (orders||[]).forEach(function(o){
    if(o.status==="cancelled"||o.status==="refunded")return;
    if(!o.created_at)return;
    var ds=new Date(o.created_at).toDateString();
    revByDate[ds]=(revByDate[ds]||0)+parseFloat(o.total||0);
    countByDate[ds]=(countByDate[ds]||0)+1;
  });
  // Build the 30-day array
  var days=[];
  for(var i=29;i>=0;i--){
    var d=new Date(today);
    d.setDate(d.getDate()-i);
    var ds2=d.toDateString();
    days.push({
      day:d.toLocaleDateString("en-GB",{month:"short",day:"numeric"}),
      rev:revByDate[ds2]||0,
      count:countByDate[ds2]||0,
    });
  }
  var last7=days.slice(-7);
  var last30=days;
  var totalRev=last30.reduce(function(s,d){return s+d.rev;},0);
  var totalOrders=last30.reduce(function(s,d){return s+d.count;},0);
  var mx=Math.max.apply(null,last7.map(function(d){return d.rev;}).concat([1]));
  var todayRev=days[days.length-1].rev;
  var todayOrders=days[days.length-1].count;
  
  return <div className="page">
    <h2 style={{fontSize:24,marginBottom:4}}>Sales Reports</h2>
    <p style={{color:"#8a8078",fontSize:13,marginBottom:18}}>Real sales data - last 30 days</p>
    
    {/* Today's stats */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(145px,1fr))",gap:9,marginBottom:12}}>
      <div className="card" style={{background:"linear-gradient(135deg,#fef3c7,#fde68a)"}}>
        <div style={{fontSize:22,fontWeight:700,color:"#92400e",marginBottom:2}}>{fmt(todayRev)}</div>
        <div style={{fontSize:11,color:"#92400e",fontWeight:600}}>Today's Revenue</div>
      </div>
      <div className="card" style={{background:"linear-gradient(135deg,#dbeafe,#bfdbfe)"}}>
        <div style={{fontSize:22,fontWeight:700,color:"#1e40af",marginBottom:2}}>{todayOrders}</div>
        <div style={{fontSize:11,color:"#1e40af",fontWeight:600}}>Today's Orders</div>
      </div>
    </div>
    
    {/* 30-day stats */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(145px,1fr))",gap:9,marginBottom:18}}>
      {[["30-Day Revenue",fmt(totalRev),"#bf4626"],["30-Day Orders",totalOrders,"#2563eb"],["Avg Order",fmt(totalRev/Math.max(totalOrders,1)),"#4a7155"]].map(([l,v,c])=><div key={l} className="card"><div style={{fontSize:20,fontWeight:700,color:c,marginBottom:2}}>{v}</div><div style={{fontSize:11,color:"#8a8078",fontWeight:600}}>{l}</div></div>)}
    </div>
    
    <div className="card" style={{marginBottom:14}}>
      <h3 style={{fontSize:16,marginBottom:12}}>Revenue - Last 7 Days</h3>
      {totalOrders===0?
        <p style={{fontSize:13,color:"#8a8078",textAlign:"center",padding:20}}>No sales data yet. Reports will fill in as orders come in.</p>
        :
        <div style={{display:"flex",alignItems:"flex-end",gap:4,height:90}}>{last7.map((d,i)=><div key={i} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:3}}>
          <span style={{fontSize:9,fontWeight:700,color:"#bf4626"}}>{d.rev>0?fmt(d.rev):""}</span>
          <div style={{width:"100%",background:"#bf4626",borderRadius:"3px 3px 0 0",height:Math.round((d.rev/mx)*60)+"px",opacity:.7+.3*(d.rev/mx),minHeight:d.rev>0?4:2}}/>
          <span style={{fontSize:9,color:"#8a8078",textAlign:"center"}}>{d.day}</span>
        </div>)}</div>
      }
    </div>
  </div>;
}

// -- TABLES / FLOOR PLAN ---------------------------------------------------
// eslint-disable-next-line no-unused-vars
var TABLES0=[
  {id:1,seats:2,x:10,y:10,status:"free"},
  {id:2,seats:2,x:10,y:30,status:"occupied",since:"12:15",guests:2,orderId:"ORD-1001"},
  {id:3,seats:4,x:10,y:50,status:"free"},
  {id:4,seats:4,x:35,y:10,status:"reserved",resTime:"19:00",resName:"Johnson"},
  {id:5,seats:4,x:35,y:30,status:"occupied",since:"12:30",guests:3},
  {id:6,seats:6,x:35,y:50,status:"free"},
  {id:7,seats:2,x:60,y:10,status:"free"},
  {id:8,seats:4,x:60,y:30,status:"occupied",since:"12:45",guests:4,orderId:"ORD-1002"},
  {id:9,seats:6,x:60,y:50,status:"free"},
  {id:10,seats:8,x:85,y:30,status:"reserved",resTime:"20:00",resName:"Smith party"},
];

function TablesV({tables,setTables,push,branch,orders,setOrders,onGoToPos,onEditTable}){
  var [tablesDeliv,setTablesDeliv]=useState(null);
  // EDIT MODE & DRAG STATE
  var [editMode,setEditMode]=useState(false);
  var [draggedTable,setDraggedTable]=useState(null);
  var [dragOffset,setDragOffset]=useState({x:0,y:0});
  var floorRef=useRef(null);
  
  // Snap to grid (5% increments)
  var snap=(val)=>Math.round(val/5)*5;
  
  // Drag handlers - desktop
  var handleDragStart=(e,table)=>{
    e.preventDefault();
    var btnRect=e.currentTarget.getBoundingClientRect();
    setDraggedTable(table.id);
    setDragOffset({
      x:e.clientX-btnRect.left-btnRect.width/2,
      y:e.clientY-btnRect.top-btnRect.height/2,
    });
  };
  
  var handleDrag=(e)=>{
    if(!draggedTable||!floorRef.current)return;
    var rect=floorRef.current.getBoundingClientRect();
    var x=((e.clientX-rect.left-dragOffset.x)/rect.width)*100;
    var y=((e.clientY-rect.top-dragOffset.y)/rect.height)*100;
    // Clamp to bounds
    x=Math.max(5,Math.min(95,snap(x)));
    y=Math.max(5,Math.min(95,snap(y)));
    setTables(prev=>prev.map(t=>t.id===draggedTable?{...t,x:x,y:y}:t));
  };
  
  var handleDragEnd=async()=>{
    if(!draggedTable)return;
    var tableObj=tables.find(t=>t.id===draggedTable);
    if(tableObj&&tableObj.dbId){
      // Save new position to DB
      try{
        var r=await dbSaveTable(tableObj);
        if(r.error)console.error("Save position failed:",r.error);
      }catch(e){console.error(e);}
    }
    setDraggedTable(null);
  };
  
  // Touch handlers - mobile/tablet
  var handleTouchStart=(e,table)=>{
    var touch=e.touches[0];
    var btnRect=e.currentTarget.getBoundingClientRect();
    setDraggedTable(table.id);
    setDragOffset({
      x:touch.clientX-btnRect.left-btnRect.width/2,
      y:touch.clientY-btnRect.top-btnRect.height/2,
    });
  };
  
  var handleTouchMove=(e)=>{
    if(!draggedTable||!floorRef.current)return;
    e.preventDefault();
    var touch=e.touches[0];
    var rect=floorRef.current.getBoundingClientRect();
    var x=((touch.clientX-rect.left-dragOffset.x)/rect.width)*100;
    var y=((touch.clientY-rect.top-dragOffset.y)/rect.height)*100;
    x=Math.max(5,Math.min(95,snap(x)));
    y=Math.max(5,Math.min(95,snap(y)));
    setTables(prev=>prev.map(t=>t.id===draggedTable?{...t,x:x,y:y}:t));
  };
  
  useEffect(()=>{
    if(!branch)return;
    dbFetchAllDelivery().then(list=>{
      var s=(list||[]).find(x=>x.branch_id===branch.id);
      if(s){
        setTablesDeliv({
          serviceChargeEnabled:s.service_charge_enabled||false,
          serviceChargePercent:parseFloat(s.service_charge_percent||12.5),
          serviceChargeMandatory:s.service_charge_mandatory||false,
        });
      }
    });
  },[branch]);
  var [selected,setSelected]=useState(null);
  var [guestCount,setGuestCount]=useState(2);
  var [paymentStep,setPaymentStep]=useState(null);
  var [splitMode,setSplitMode]=useState("amount");
  var [splitN,setSplitN]=useState(2);
  var [paidSplits,setPaidSplits]=useState([]);
  var [itemSplit,setItemSplit]=useState({});
  var [customAmount,setCustomAmount]=useState("");
  // Filter tables by current branch
  var branchTables=branch?tables.filter(t=>!t.branchId||t.branchId===branch.id):tables;
  
  // AUTO-MARK tables as occupied if they have unpaid dine-in orders
  // This handles the case where order is synced but table status didn't update
  branchTables=branchTables.map(tbl=>{
    var hasActiveOrder=orders.some(o=>{
      if(branch&&o.branchId&&o.branchId!==branch.id)return false;
      if(o.type!=="dine-in")return false;
      if(o.paid)return false;
      if(o.status==="cancelled")return false;
      var orderTableNum=parseInt(o.tableId);
      var thisTableNum=parseInt(tbl.id);
      return !isNaN(orderTableNum)&&!isNaN(thisTableNum)&&orderTableNum===thisTableNum;
    });
    // Force occupied status if has active order
    if(hasActiveOrder&&tbl.status!=="occupied"){
      return {...tbl,status:"occupied",guests:tbl.guests||2,since:tbl.since||new Date().toLocaleTimeString()};
    }
    return tbl;
  });
  
  var t=branchTables.find(t=>t.id===selected);

  // Get all unpaid orders for selected table - MUST match branch + table number
  var tableOrders=t&&orders?orders.filter(o=>{
    // Must match this branch
    if(branch&&o.branchId&&o.branchId!==branch.id)return false;
    // Must match this table number (strict match - both as numbers)
    var orderTableNum=parseInt(o.tableId);
    var thisTableNum=parseInt(t.id);
    if(isNaN(orderTableNum)||isNaN(thisTableNum))return false;
    if(orderTableNum!==thisTableNum)return false;
    // Must be unpaid + not cancelled
    if(o.paid)return false;
    if(o.status==="cancelled")return false;
    return true;
  }):[];
  // Aggregate items across all orders for this table (for display)
  var allItems=[];
  tableOrders.forEach(o=>{(o.items||[]).forEach(it=>{
    var ex=allItems.find(x=>x.name===it.name&&x.price===it.price);
    if(ex)ex.qty+=it.qty;
    else allItems.push({...it,orderId:o.id});
  });});
  // CRITICAL: Use saved order totals (already include discount + service charge)
  // not re-calculated from items - that would lose the customer's promo discount
  var subtotal=tableOrders.reduce((s,o)=>s+parseFloat(o.subtotal||o.items?.reduce((x,i)=>x+(+i.price||0)*i.qty,0)||0),0);
  var totalDiscount=tableOrders.reduce((s,o)=>s+parseFloat(o.discount||0),0);
  var totalServiceCharge=tableOrders.reduce((s,o)=>s+parseFloat(o.serviceCharge||0),0);
  // If service charge wasn't on order, calculate it now (for staff-taken orders that didn't have it)
  if(totalServiceCharge===0&&tablesDeliv&&tablesDeliv.serviceChargeEnabled){
    totalServiceCharge=Math.max(0,subtotal-totalDiscount)*((tablesDeliv.serviceChargePercent||0)/100);
  }
  var serviceChargeT=totalServiceCharge;
  var vat=subtotal-subtotal/1.2;
  // Total is sum of saved order totals (already correct)
  var total=tableOrders.reduce((s,o)=>{
    var t=parseFloat(o.total||0);
    if(t>0)return s+t;
    // Fallback if total wasn't saved
    return s+(parseFloat(o.subtotal||0)-parseFloat(o.discount||0)+parseFloat(o.serviceCharge||0));
  },0);
  // If no orders had totals saved, fall back to calculated
  if(total===0)total=subtotal-totalDiscount+serviceChargeT;

  var updateTable=(id,updates)=>{
    // Match by BOTH branch_id AND table_number to avoid updating same-numbered tables in other branches
    var currentBranchId=branch?.id;
    setTables(ts=>ts.map(x=>{
      var matches=x.id===id&&(!currentBranchId||!x.branchId||x.branchId===currentBranchId);
      return matches?{...x,...updates}:x;
    }));
    // Find the correct table (this branch only) and save to DB
    var tbl=tables.find(x=>x.id===id&&(!currentBranchId||!x.branchId||x.branchId===currentBranchId));
    if(tbl?.dbId){
      dbUpdateTableStatus(tbl.dbId,updates.status||tbl.status,{}).catch(e=>console.log("Table status save failed:",e));
    }
  };

  var seat=(guests)=>{
    updateTable(selected,{status:"occupied",since:nowT(),guests:guests,orderId:null,resTime:null,resName:null});
    push({title:"Table "+selected+" seated",body:guests+" guests",color:"#2563eb"});
    setSelected(null);
  };
  var clearT=()=>{
    if(tableOrders.length>0){
      if(!window.confirm("Table has "+tableOrders.length+" unpaid order(s) totaling "+fmt(total)+". Clear without payment?"))return;
    }
    updateTable(selected,{status:"free",since:null,guests:null,orderId:null,resTime:null,resName:null});
    push({title:"Table "+selected+" cleared",body:"Ready for next guests",color:"#059669"});
    setSelected(null);
    setPaymentStep(null);
  };
  var reserve=()=>{
    var nm=prompt("Reservation name:");if(!nm)return;
    var tm=prompt("Time (HH:MM):","19:00");if(!tm)return;
    updateTable(selected,{status:"reserved",resName:nm,resTime:tm,guests:null,since:null,orderId:null});
    setSelected(null);
  };
  // Mark all table orders as paid and free the table
  var payAll=(method)=>{
    tableOrders.forEach(o=>{
      setOrders(os=>os.map(x=>x.id===o.id?{...x,paid:true,payMethod:method,status:"collected"}:x));
      dbUpdateOrderPayment(o.id,true,method).catch(e=>console.log("Payment save failed:",e));
      dbUpdateOrderStatus(o.id,"collected").catch(e=>console.log("Status save failed:",e));
    });
    updateTable(selected,{status:"free",since:null,guests:null,orderId:null});
    push({title:"Payment received",body:fmt(total)+" by "+method+" - Table "+selected+" cleared",color:"#059669"});
    setSelected(null);
    setPaymentStep(null);
    setPaidSplits([]);
    setSplitN(2);
    setItemSplit({});
  };
  // Handle partial split payment
  var paySplitPortion=(amount,method)=>{
    setPaidSplits(ps=>[...ps,{amount,method,at:nowT()}]);
    var totalPaid=paidSplits.reduce((s,p)=>s+p.amount,0)+amount;
    if(totalPaid>=total-0.01){
      // All paid, close out - mark orders paid AND completed (dine-in = collected)
      tableOrders.forEach(o=>{
        setOrders(os=>os.map(x=>x.id===o.id?{...x,paid:true,payMethod:"split",status:"collected"}:x));
        dbUpdateOrderPayment(o.id,true,"split").catch(e=>console.log("Payment save failed:",e));
        dbUpdateOrderStatus(o.id,"collected").catch(e=>console.log("Status save failed:",e));
      });
      updateTable(selected,{status:"free",since:null,guests:null,orderId:null});
      push({title:"Bill fully paid",body:"Table "+selected+" cleared",color:"#059669"});
      setSelected(null);
      setPaymentStep(null);
      setPaidSplits([]);
      setSplitN(2);
      setItemSplit({});
    }else{
      push({title:"Split payment",body:fmt(amount)+" by "+method+" received",color:"#2563eb"});
    }
  };

  var stats={
    free:branchTables.filter(t=>t.status==="free").length,
    occupied:branchTables.filter(t=>t.status==="occupied").length,
    reserved:branchTables.filter(t=>t.status==="reserved").length,
    total:branchTables.length,
    guests:branchTables.filter(t=>t.status==="occupied").reduce((s,t)=>s+(t.guests||0),0),
    capacity:branchTables.reduce((s,t)=>s+t.seats,0),
  };
  var utilization=stats.capacity>0?Math.round((stats.guests/stats.capacity)*100):0;
  var colors={free:"#10b981",occupied:"#dc2626",reserved:"#d4952a"};
  var bgs={free:"#d1fae5",occupied:"#fee2e2",reserved:"#fef3c7"};

  return <div className="page">
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:8}}>
      <div><h2 style={{fontSize:22,marginBottom:2}}>Floor Plan</h2><p style={{color:"#8a8078",fontSize:12}}>Tap a table to manage</p></div>
      <div style={{background:"#1a1208",color:"#d4952a",borderRadius:9,padding:"8px 14px",fontWeight:700,fontSize:13}}>{utilization}% full - {stats.guests}/{stats.capacity}</div>
    </div>
    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:16}}>
      {[["Free",stats.free,"#10b981"],["Occupied",stats.occupied,"#dc2626"],["Reserved",stats.reserved,"#d4952a"],["Total",stats.total,"#1a1208"]].map(([l,v,c])=><div key={l} style={{background:"#fff",borderRadius:11,padding:"10px 8px",border:"1px solid #ede8de",textAlign:"center"}}><div style={{fontSize:20,fontWeight:700,color:c}}>{v}</div><div style={{fontSize:10,color:"#8a8078",fontWeight:600}}>{l}</div></div>)}
    </div>
    <div style={{background:"#fff",borderRadius:14,padding:16,marginBottom:14,border:"1px solid #ede8de"}}>
      {/* Edit mode toggle */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,flexWrap:"wrap",gap:7}}>
        <p style={{fontSize:13,fontWeight:700,color:"#1a1208"}}>{String.fromCharCode(0xD83C,0xDFE0)} Floor Plan {editMode&&<span style={{color:"#bf4626",fontSize:11,marginLeft:7}}>{String.fromCharCode(0x270F,0xFE0F)} Edit Mode</span>}</p>
        <button onClick={async()=>{
          if(editMode){
            // SAVING: Save ALL table positions to DB
            try{
              for(var t of branchTables){
                if(t.dbId){
                  await dbSaveTable(t);
                }
              }
              push&&push({title:"Layout saved",body:"All tables saved to database",color:"#059669"});
            }catch(e){
              console.error("Save layout failed:",e);
              push&&push({title:"Save failed",body:e.message,color:"#dc2626"});
            }
          }
          setEditMode(!editMode);
          setSelected(null);
        }} style={{padding:"7px 14px",background:editMode?"#dc2626":"#0891b2",color:"#fff",border:"none",borderRadius:7,fontSize:12,fontWeight:700,cursor:"pointer"}}>
          {editMode?String.fromCharCode(0x2713)+" Save & Done":String.fromCharCode(0x270F,0xFE0F)+" Edit Layout"}
        </button>
      </div>
      
      {editMode&&<div style={{padding:9,background:"#fef3c7",borderRadius:7,marginBottom:10,fontSize:11,color:"#92400e"}}>
        <strong>{String.fromCharCode(0xD83D,0xDC46)} Drag tables to position them.</strong> Tables snap to grid. Click a table to edit details (number/seats/shape).
      </div>}
      
      <div ref={floorRef} onMouseMove={editMode?handleDrag:undefined} onMouseUp={editMode?handleDragEnd:undefined} onTouchMove={editMode?handleTouchMove:undefined} onTouchEnd={editMode?handleDragEnd:undefined} style={{position:"relative",width:"100%",height:380,background:editMode?"repeating-linear-gradient(0deg,transparent,transparent 19px,rgba(0,0,0,.05) 19px,rgba(0,0,0,.05) 20px),repeating-linear-gradient(90deg,transparent,transparent 19px,rgba(0,0,0,.05) 19px,rgba(0,0,0,.05) 20px),repeating-linear-gradient(45deg,#fafaf5,#fafaf5 10px,#f5f0e8 10px,#f5f0e8 20px)":"repeating-linear-gradient(45deg,#fafaf5,#fafaf5 10px,#f5f0e8 10px,#f5f0e8 20px)",borderRadius:10,border:"2px dashed #d4c9b8",userSelect:"none",touchAction:editMode?"none":"auto"}}>
        <div style={{position:"absolute",top:4,left:8,fontSize:10,color:"#aaa",fontWeight:700,letterSpacing:1,pointerEvents:"none"}}>MAIN DINING</div>
        <div style={{position:"absolute",bottom:4,right:8,fontSize:10,color:"#aaa",fontWeight:700,letterSpacing:1,pointerEvents:"none"}}>KITCHEN</div>
        {branchTables.map(tb=>{
          var isSel=selected===tb.id,c=colors[tb.status],bg=bgs[tb.status];
          var isDragging=draggedTable===tb.id;
          var size=tb.seats<=2?44:tb.seats<=4?54:tb.seats<=6?64:74;
          // Shape-aware border radius
          var shape=tb.shape||"rectangle";
          var br=shape==="round"?"50%":shape==="square"?12:8;
          // Rectangle is wider
          var w=shape==="rectangle"?size+18:size;
          var h=size;
          return <button 
            key={tb.id} 
            onMouseDown={editMode?(e)=>handleDragStart(e,tb):undefined}
            onTouchStart={editMode?(e)=>handleTouchStart(e,tb):undefined}
            onClick={editMode?(e)=>{e.preventDefault();if(!isDragging)onEditTable&&onEditTable(tb);}:()=>setSelected(tb.id)} 
            style={{position:"absolute",left:tb.x+"%",top:tb.y+"%",width:w,height:h,borderRadius:br,background:bg,border:"3px solid "+c,cursor:editMode?"move":"pointer",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",transition:isDragging?"none":"all .2s",transform:"translate(-50%,-50%)"+(isSel?" scale(1.1)":""),boxShadow:isSel?"0 4px 20px "+c+"88":isDragging?"0 8px 24px rgba(0,0,0,.3)":"0 2px 6px rgba(0,0,0,.1)",zIndex:isDragging?100:(isSel?10:1),padding:0,opacity:isDragging?.7:1}}>
            <span style={{fontSize:14,fontWeight:700,color:c,lineHeight:1}}>T{tb.id}</span>
            <span style={{fontSize:9,color:c,fontWeight:600}}>{tb.seats} seats</span>
            {tb.status==="occupied"&&tb.guests&&!editMode&&<span style={{fontSize:9,color:c,fontWeight:700,marginTop:1}}>{tb.guests} in</span>}
          </button>;
        })}
      </div>
      
      {!editMode&&<div style={{display:"flex",gap:14,marginTop:12,justifyContent:"center",flexWrap:"wrap"}}>
        {[["Free","#10b981","#d1fae5"],["Occupied","#dc2626","#fee2e2"],["Reserved","#d4952a","#fef3c7"]].map(([l,c,bg])=><div key={l} style={{display:"flex",alignItems:"center",gap:5}}><span style={{width:14,height:14,borderRadius:"50%",background:bg,border:"2px solid "+c,display:"inline-block"}}/><span style={{fontSize:11,color:"#8a8078",fontWeight:600}}>{l}</span></div>)}
      </div>}
    </div>
    {t&&<div className="card fadeup" style={{borderLeft:"4px solid "+colors[t.status]}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
        <div>
          <h3 style={{fontSize:22,marginBottom:2}}>Table {t.id}</h3>
          <p style={{color:"#8a8078",fontSize:12}}>{t.seats} seats - currently <strong style={{color:colors[t.status],textTransform:"capitalize"}}>{t.status}</strong></p>
          {t.status==="occupied"&&<>
            <p style={{fontSize:12,color:"#8a8078",marginTop:3}}>Seated since {t.since} with {t.guests} guest{t.guests!==1?"s":""}</p>
            {tableOrders.length>0&&<p style={{fontSize:12,color:"#bf4626",fontWeight:700,marginTop:2}}>{tableOrders.length} unpaid order{tableOrders.length!==1?"s":""}</p>}
          </>}
          {t.status==="reserved"&&<p style={{fontSize:12,color:"#8a8078",marginTop:3}}>Reserved for <strong>{t.resName}</strong> at <strong>{t.resTime}</strong></p>}
        </div>
        <button onClick={()=>{setSelected(null);setPaymentStep(null);setPaidSplits([]);}} style={{color:"#ccc",fontSize:18,border:"none",background:"none",cursor:"pointer",padding:4}}>x</button>
      </div>

      {/* FREE TABLE */}
      {t.status==="free"&&<div>
        <p style={{fontSize:11,fontWeight:700,color:"#8a8078",letterSpacing:1,marginBottom:6}}>SEAT GUESTS</p>
        <div style={{display:"grid",gridTemplateColumns:"repeat("+Math.min(t.seats,8)+",1fr)",gap:5,marginBottom:10}}>
          {Array.from({length:t.seats}).map((_,i)=><button key={i} onClick={()=>setGuestCount(i+1)} style={{padding:"10px 4px",borderRadius:8,fontWeight:700,fontSize:14,background:guestCount===i+1?"#1a1208":"#f7f3ee",color:guestCount===i+1?"#fff":"#1a1208",border:"none",cursor:"pointer"}}>{i+1}</button>)}
        </div>
        <div style={{display:"flex",gap:7}}>
          <button className="btn btn-r" onClick={()=>seat(guestCount)} style={{flex:2,padding:"12px"}}>Seat {guestCount} guest{guestCount>1?"s":""}</button>
          <button className="btn btn-o" onClick={reserve} style={{flex:1,padding:"12px"}}>Reserve</button>
        </div>
      </div>}

      {/* OCCUPIED TABLE - RUNNING BILL */}
      {t.status==="occupied"&&!paymentStep&&<div>
        {allItems.length>0?<>
          <div style={{background:"#fafaf5",borderRadius:10,padding:12,marginBottom:12,border:"1px solid #ede8de"}}>
            <p style={{fontSize:11,fontWeight:700,color:"#8a8078",letterSpacing:1,marginBottom:8}}>RUNNING BILL</p>
            {allItems.map((it,i)=><div key={i} style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:"1px solid #ede8de",fontSize:13}}>
              <span>{it.name} <span style={{color:"#8a8078"}}>x{it.qty}</span></span>
              <span style={{fontWeight:700}}>{fmt((+it.price||0)*it.qty)}</span>
            </div>)}
            <div style={{display:"flex",justifyContent:"space-between",padding:"7px 0 2px",fontSize:12,color:"#8a8078"}}>
              <span>Subtotal</span><span>{fmt(subtotal)}</span>
            </div>
            {totalDiscount>0&&<div style={{display:"flex",justifyContent:"space-between",padding:"2px 0",fontSize:12,color:"#dc2626",fontWeight:700}}>
              <span>Discount</span><span>- {fmt(totalDiscount)}</span>
            </div>}
            {serviceChargeT>0&&<div style={{display:"flex",justifyContent:"space-between",padding:"2px 0",fontSize:12,color:"#7c3aed",fontWeight:700}}>
              <span>Service ({tablesDeliv?.serviceChargePercent||0}%)</span><span>+ {fmt(serviceChargeT)}</span>
            </div>}
            <div style={{display:"flex",justifyContent:"space-between",padding:"2px 0",fontSize:11,color:"#8a8078"}}>
              <span>VAT incl. 20%</span><span>{fmt(vat)}</span>
            </div>
            <div style={{display:"flex",justifyContent:"space-between",padding:"8px 0 0",marginTop:6,borderTop:"2px solid #1a1208",fontWeight:700,fontSize:18}}>
              <span>TOTAL</span><span style={{color:"#bf4626"}}>{fmt(total)}</span>
            </div>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,marginBottom:6}}>
            <button className="btn btn-o" onClick={()=>onGoToPos&&onGoToPos(t.id)} style={{padding:"11px",fontSize:13}}>+ Add More Items</button>
            <button className="btn btn-o" onClick={()=>{
              var win=window.open("","","width=300,height=500");
              if(!win)return;
              var rows=allItems.map(i=>"<tr><td>"+i.name+" x"+i.qty+"</td><td style='text-align:right'>"+fmt((+i.price||0)*i.qty)+"</td></tr>").join("");
              win.document.write("<html><head><title>Bill - Table "+t.id+"</title><style>body{font-family:monospace;padding:12px;max-width:280px}h3{text-align:center}table{width:100%;border-collapse:collapse}td{padding:3px 0;border-bottom:1px dashed #ccc}.tot{font-weight:700;font-size:16px;border-top:2px solid #000;padding-top:8px;margin-top:8px}</style></head><body><h3>"+((branch?.name||(typeof window!=="undefined"&&window.__currentRestaurant?window.__currentRestaurant.name:"Restaurant")).toUpperCase())+"</h3><p style='text-align:center'>"+(branch?.name||"")+"</p><p>Table "+t.id+" - "+(t.guests||"?")+" guests</p><p>"+new Date().toLocaleString("en-GB")+"</p><hr/><table>"+rows+"</table><div class='tot'>Subtotal: "+fmt(subtotal)+"</div>"+(totalDiscount>0?"<div>Discount: -"+fmt(totalDiscount)+"</div>":"")+(serviceChargeT>0?"<div>Service ("+(tablesDeliv?.serviceChargePercent||0)+"%): "+fmt(serviceChargeT)+"</div>":"")+"<div>VAT: "+fmt(vat)+"</div><div class='tot'>TOTAL: "+fmt(total)+"</div><p style='text-align:center;margin-top:20px'>Thank you!</p></body></html>");
              win.document.close();
              setTimeout(()=>win.print(),200);
            }} style={{padding:"11px",fontSize:13}}>Print Bill</button>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,marginBottom:6}}>
            <button className="btn btn-d" onClick={()=>payAll("cash")} style={{padding:"13px",fontSize:14}}>Pay Cash {fmt(total)}</button>
            <button className="btn btn-p" onClick={()=>payAll("card")} style={{padding:"13px",fontSize:14}}>Pay Card {fmt(total)}</button>
          </div>
          <div style={{display:"flex",gap:6}}>
            <button onClick={()=>setPaymentStep("split")} style={{flex:1,padding:"11px",fontSize:13,background:"#7c3aed",color:"#fff",border:"none",borderRadius:8,cursor:"pointer",fontWeight:700}}>Split Bill</button>
            <button onClick={clearT} style={{flex:1,padding:"11px",fontSize:13,background:"#fff",color:"#dc2626",border:"2px solid #fee2e2",borderRadius:8,cursor:"pointer",fontWeight:700}}>Clear Without Pay</button>
          </div>
        </>:<div>
          <p style={{color:"#8a8078",fontSize:13,marginBottom:10,textAlign:"center",padding:"15px 0"}}>No orders yet for this table</p>
          <div style={{display:"flex",gap:7}}>
            <button className="btn btn-r" onClick={()=>onGoToPos&&onGoToPos(t.id)} style={{flex:2,padding:"12px"}}>Take Order</button>
            <button className="btn btn-d" onClick={clearT} style={{flex:1,padding:"12px"}}>Clear Table</button>
          </div>
        </div>}
      </div>}

      {/* SPLIT BILL UI - simplified */}
      {t.status==="occupied"&&paymentStep==="split"&&<div>
        <div style={{background:"#f5f3ff",borderRadius:10,padding:14,marginBottom:14,border:"2px solid #7c3aed"}}>
          <p style={{fontSize:13,fontWeight:700,color:"#7c3aed"}}>{String.fromCharCode(0xD83E,0xDDFE)} Splitting the Bill</p>
          <div style={{display:"flex",justifyContent:"space-between",marginTop:8,fontSize:13}}>
            <span style={{color:"#8a8078"}}>Total bill</span>
            <span style={{fontWeight:700}}>{fmt(total)}</span>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",marginTop:3,fontSize:13}}>
            <span style={{color:"#059669"}}>Paid so far</span>
            <span style={{fontWeight:700,color:"#059669"}}>{fmt(paidSplits.reduce((s,p)=>s+p.amount,0))}</span>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",marginTop:3,fontSize:15,paddingTop:8,borderTop:"1px solid #ddd6f3"}}>
            <span style={{fontWeight:700}}>Still to pay</span>
            <span style={{fontWeight:700,color:"#dc2626"}}>{fmt(total-paidSplits.reduce((s,p)=>s+p.amount,0))}</span>
          </div>
        </div>
        
        {/* Two simple choices */}
        <p style={{fontSize:12,fontWeight:700,marginBottom:8}}>How do they want to split?</p>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:16}}>
          <button onClick={()=>setSplitMode("amount")} style={{padding:"14px 8px",fontSize:13,fontWeight:700,background:splitMode==="amount"?"#7c3aed":"#fff",color:splitMode==="amount"?"#fff":"#1a1208",border:"2px solid "+(splitMode==="amount"?"#7c3aed":"#ede8de"),borderRadius:10,cursor:"pointer"}}>
            {String.fromCharCode(0xD83D,0xDC65)}<br/>Split Equally
          </button>
          <button onClick={()=>setSplitMode("item")} style={{padding:"14px 8px",fontSize:13,fontWeight:700,background:splitMode==="item"?"#7c3aed":"#fff",color:splitMode==="item"?"#fff":"#1a1208",border:"2px solid "+(splitMode==="item"?"#7c3aed":"#ede8de"),borderRadius:10,cursor:"pointer"}}>
            {String.fromCharCode(0xD83C,0xDF7D,0xFE0F)}<br/>Pay for Own Items
          </button>
        </div>

        {/* Split equally */}
        {splitMode==="amount"&&<>
          <p style={{fontSize:12,fontWeight:700,color:"#8a8078",marginBottom:8,textAlign:"center"}}>How many people are splitting?</p>
          <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:14,marginBottom:14}}>
            <button onClick={()=>setSplitN(Math.max(2,splitN-1))} style={{width:48,height:48,borderRadius:"50%",border:"2px solid #7c3aed",background:"#fff",color:"#7c3aed",fontSize:24,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0x2212)}</button>
            <div style={{textAlign:"center",minWidth:60}}>
              <p style={{fontSize:36,fontWeight:700,color:"#1a1208"}}>{splitN}</p>
              <p style={{fontSize:10,color:"#8a8078"}}>people</p>
            </div>
            <button onClick={()=>setSplitN(Math.min(12,splitN+1))} style={{width:48,height:48,borderRadius:"50%",border:"2px solid #7c3aed",background:"#fff",color:"#7c3aed",fontSize:24,fontWeight:700,cursor:"pointer"}}>+</button>
          </div>
          <div style={{background:"#fef2f0",borderRadius:10,padding:16,marginBottom:14,textAlign:"center",border:"2px solid #f5c4b8"}}>
            <p style={{fontSize:12,color:"#8a8078"}}>Each person pays</p>
            <p style={{fontSize:34,fontWeight:700,color:"#bf4626"}}>{fmt(total/splitN)}</p>
          </div>
          <p style={{fontSize:11,color:"#8a8078",textAlign:"center",marginBottom:8}}>Tap below each time a person pays their share:</p>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
            <button onClick={()=>paySplitPortion(total/splitN,"cash")} style={{padding:"15px",fontSize:14,fontWeight:700,background:"#059669",color:"#fff",border:"none",borderRadius:10,cursor:"pointer"}}>{String.fromCharCode(0xD83D,0xDCB5)} Cash<br/><span style={{fontSize:16}}>{fmt(total/splitN)}</span></button>
            <button onClick={()=>paySplitPortion(total/splitN,"card")} style={{padding:"15px",fontSize:14,fontWeight:700,background:"#2563eb",color:"#fff",border:"none",borderRadius:10,cursor:"pointer"}}>{String.fromCharCode(0xD83D,0xDCB3)} Card<br/><span style={{fontSize:16}}>{fmt(total/splitN)}</span></button>
          </div>
        </>}

        {/* Split by item */}
        {splitMode==="item"&&<>
          <p style={{fontSize:11,fontWeight:700,color:"#8a8078",marginBottom:6}}>Tap items to select for this person</p>
          <div style={{maxHeight:220,overflowY:"auto",border:"1px solid #ede8de",borderRadius:8,marginBottom:10}}>
            {allItems.map((it,i)=><button key={i} onClick={()=>{
              setItemSplit(s=>({...s,[i]:!s[i]}));
            }} style={{width:"100%",display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 12px",background:itemSplit[i]?"#f5f3ff":"#fff",border:"none",borderBottom:"1px solid #ede8de",cursor:"pointer",textAlign:"left"}}>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <span style={{width:18,height:18,borderRadius:"50%",background:itemSplit[i]?"#7c3aed":"#ede8de",color:"#fff",fontSize:11,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700}}>{itemSplit[i]?EM.check:""}</span>
                <span style={{fontWeight:600,fontSize:13}}>{it.name} x{it.qty}</span>
              </div>
              <span style={{fontWeight:700,fontSize:13}}>{fmt((+it.price||0)*it.qty)}</span>
            </button>)}
          </div>
          {(()=>{
            var selectedTotal=allItems.reduce((s,it,i)=>s+(itemSplit[i]?(+it.price||0)*it.qty:0),0);
            return <>
              <div style={{background:"#fafaf5",borderRadius:8,padding:10,marginBottom:10,textAlign:"center"}}>
                <p style={{fontSize:11,color:"#8a8078"}}>This person pays</p>
                <p style={{fontSize:22,fontWeight:700,color:"#bf4626"}}>{fmt(selectedTotal)}</p>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
                <button className="btn btn-d" disabled={selectedTotal<=0} onClick={()=>{paySplitPortion(selectedTotal,"cash");setItemSplit({});}} style={{padding:"12px",fontSize:13}}>Cash {fmt(selectedTotal)}</button>
                <button className="btn btn-p" disabled={selectedTotal<=0} onClick={()=>{paySplitPortion(selectedTotal,"card");setItemSplit({});}} style={{padding:"12px",fontSize:13}}>Card {fmt(selectedTotal)}</button>
              </div>
            </>;
          })()}
        </>}

        {/* MIXED PAYMENT - Cash + Card for same customer */}
        {splitMode==="mixed"&&(()=>{
          var remaining=total-paidSplits.reduce((s,p)=>s+p.amount,0);
          var amt=parseFloat(customAmount)||0;
          var isValid=amt>0&&amt<=remaining+0.01;
          return <>
            <div style={{padding:"10px 12px",background:"#fffbeb",borderRadius:7,marginBottom:10,fontSize:11,color:"#92400e"}}>
              <strong>Mixed Payment:</strong> Enter how much to take, then tap Cash or Card. Repeat until full amount is paid.
            </div>
            <div style={{background:"#fafaf5",borderRadius:8,padding:12,marginBottom:10,textAlign:"center"}}>
              <p style={{fontSize:11,color:"#8a8078"}}>Remaining to pay</p>
              <p style={{fontSize:26,fontWeight:700,color:"#bf4626"}}>{fmt(remaining)}</p>
            </div>
            <label className="lbl">Amount to take now</label>
            <input type="number" step="0.01" className="field" value={customAmount} onChange={e=>setCustomAmount(e.target.value)} placeholder="e.g. 50.00" style={{marginBottom:8,fontSize:18,padding:"12px",textAlign:"center",fontWeight:700}}/>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:5,marginBottom:10}}>
              {[10,20,50,100].map(n=><button key={n} onClick={()=>setCustomAmount(String(Math.min(n,remaining)))} style={{padding:"9px 4px",fontSize:12,fontWeight:700,background:"#fff",border:"2px solid #ede8de",borderRadius:7,cursor:"pointer"}}>{EM.pound}{n}</button>)}
            </div>
            <div style={{display:"flex",gap:6,marginBottom:6}}>
              <button onClick={()=>setCustomAmount(String(remaining.toFixed(2)))} style={{flex:1,padding:"8px",fontSize:11,fontWeight:700,background:"#f5f3ff",color:"#7c3aed",border:"2px solid #e9d5ff",borderRadius:7,cursor:"pointer"}}>Use remaining {fmt(remaining)}</button>
              <button onClick={()=>setCustomAmount(String((remaining/2).toFixed(2)))} style={{flex:1,padding:"8px",fontSize:11,fontWeight:700,background:"#f5f3ff",color:"#7c3aed",border:"2px solid #e9d5ff",borderRadius:7,cursor:"pointer"}}>Half {fmt(remaining/2)}</button>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
              <button className="btn btn-d" disabled={!isValid} onClick={()=>{paySplitPortion(amt,"cash");setCustomAmount("");}} style={{padding:"13px",fontSize:14}}>Cash {fmt(amt)}</button>
              <button className="btn btn-p" disabled={!isValid} onClick={()=>{paySplitPortion(amt,"card");setCustomAmount("");}} style={{padding:"13px",fontSize:14}}>Card {fmt(amt)}</button>
            </div>
            {amt>remaining&&<p style={{color:"#dc2626",fontSize:11,marginTop:6,textAlign:"center",fontWeight:700}}>Amount exceeds remaining balance</p>}
          </>;
        })()}

        {paidSplits.length>0&&<div style={{marginTop:12,padding:"8px 12px",background:"#d1fae5",borderRadius:7}}>
          <p style={{fontSize:11,fontWeight:700,color:"#065f46",marginBottom:4}}>PAYMENTS RECEIVED</p>
          {paidSplits.map((p,i)=><div key={i} style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"#065f46"}}><span>{i+1}. {p.method} at {p.at}</span><span style={{fontWeight:700}}>{fmt(p.amount)}</span></div>)}
        </div>}

        <button onClick={()=>{setPaymentStep(null);setPaidSplits([]);setItemSplit({});setCustomAmount("");}} style={{marginTop:10,width:"100%",padding:"9px",fontSize:12,background:"none",color:"#8a8078",border:"1px solid #ede8de",borderRadius:7,cursor:"pointer",fontWeight:700}}>Cancel Split</button>
      </div>}

      {/* RESERVED TABLE */}
      {t.status==="reserved"&&<div style={{display:"flex",gap:7}}>
        <button className="btn btn-r" onClick={()=>seat(2)} style={{flex:2,padding:"12px"}}>Check in guests</button>
        <button className="btn btn-o" onClick={clearT} style={{flex:1,padding:"12px"}}>Cancel reservation</button>
      </div>}
    </div>}
  </div>;
}

// -- POSTCODE LOOKUP (UK) -----------------------------------------------------
// Uses free postcodes.io API - no key needed, unlimited calls
// Returns {ok, town, area, district, lat, lng, distance}
function lookupPostcode(postcode, branchLat, branchLng){
  var clean=postcode.replace(/\s+/g,"").toUpperCase();
  if(!clean)return Promise.resolve({ok:false,reason:"Enter a postcode"});
  return fetch("https://api.postcodes.io/postcodes/"+encodeURIComponent(clean))
    .then(r=>r.json())
    .then(j=>{
      if(j.status!==200)return{ok:false,reason:"Postcode not found"};
      var r=j.result;
      var distance=null;
      if(branchLat&&branchLng){
        var toRad=d=>d*Math.PI/180;
        var dLat=toRad(r.latitude-branchLat),dLng=toRad(r.longitude-branchLng);
        var a=Math.sin(dLat/2)*Math.sin(dLat/2)+Math.cos(toRad(branchLat))*Math.cos(toRad(r.latitude))*Math.sin(dLng/2)*Math.sin(dLng/2);
        distance=2*3959*Math.asin(Math.sqrt(a));
      }
      return{ok:true,town:r.admin_ward||r.parish||r.admin_district,area:r.region,district:r.admin_district,country:r.country,lat:r.latitude,lng:r.longitude,distance};
    })
    .catch(()=>({ok:false,reason:"Lookup failed - check internet"}));
}

// -- CUSTOMER DATABASE --------------------------------------------------------
// eslint-disable-next-line no-unused-vars
var CUSTOMERS0=[
  {id:"c1",phone:"07700900001",name:"John Smith",address:{line1:"45 Oxford Street",postcode:"E14 5AB",notes:"Flat 3B, buzzer broken"},distance:2.1,lastOrder:"ORD-1002",totalOrders:8,totalSpent:187.50,notes:"Allergic to nuts"},
  {id:"c2",phone:"07700900002",name:"Sarah Williams",address:{line1:"12 Camden Road",postcode:"N1 9AA",notes:"Green door"},distance:4.3,lastOrder:null,totalOrders:3,totalSpent:62.80,notes:"Prefers extra spicy"},
  {id:"c3",phone:"07700900003",name:"Raj Patel",address:{line1:"88 Brick Lane",postcode:"E1 6RL",notes:""},distance:0.8,lastOrder:"ORD-1004",totalOrders:15,totalSpent:412.30,notes:"VIP - regular customer"},
];

// -- PHONE ORDER VIEW ---------------------------------------------------------
function PhoneOrderV({customers,setCustomers,menu,onOrder,push,user,branch,orders,restaurant}){
  var [phone,setPhone]=useState("");
  var [found,setFound]=useState(null);
  // eslint-disable-next-line no-unused-vars
  var [searched,setSearched]=useState(false);
  var [step,setStep]=useState("search");
  var [newCust,setNewCust]=useState({name:"",line1:"",postcode:"",notes:"",distance:0});
  var [orderType,setOrderType]=useState("delivery");
  var [cart,setCart]=useState([]);
  var [cat,setCat]=useState("");
  var [flashId,setFlashId]=useState(null);
  var [lookingUp,setLookingUp]=useState(false);
  var [lookupResult,setLookupResult]=useState(null);
  var [searchTerm,setSearchTerm]=useState("");
  var [orderNotes,setOrderNotes]=useState("");
  var [editNoteId,setEditNoteId]=useState(null);
  var cats=[...new Set(menu.filter(i=>i.avail).map(i=>i.cat))];
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(()=>{if(!cat&&cats.length)setCat(cats[0]);},[cat]);

  var doLookup=()=>{
    if(!newCust.postcode.trim())return;
    setLookingUp(true);setLookupResult(null);
    lookupPostcode(newCust.postcode,branch?.lat,branch?.lng).then(r=>{
      setLookupResult(r);
      setLookingUp(false);
      if(r.ok&&r.distance!==null){
        setNewCust(c=>({...c,distance:r.distance.toFixed(1)}));
      }
    });
  };

  var search=()=>{
    var clean=phone.replace(/\s+/g,"").replace(/^0/,"").replace(/^\+?44/,"0");
    var full=clean.startsWith("0")?clean:"0"+clean;
    var c=customers.find(x=>x.phone.replace(/\s+/g,"")===full);
    setFound(c||null);
    setSearched(true);
    if(c)setStep("existing");else setStep("new");
  };

  var createCustomer=()=>{
    if(!newCust.name.trim()){alert("Name required");return;}
    var c={id:"c"+Date.now(),phone:phone,name:newCust.name,address:{line1:newCust.line1,postcode:newCust.postcode,notes:newCust.notes},distance:+newCust.distance||0,lastOrder:null,totalOrders:0,totalSpent:0,notes:""};
    setCustomers(cs=>[...cs,c]);
    // Save to DB
    dbSaveCustomer({phone:phone,name:newCust.name,address:c.address,distance:c.distance,notes:""}).then(r=>{
      if(r.data&&r.data.id){
        // Update local with real DB id
        setCustomers(cs=>cs.map(x=>x.id===c.id?{...x,id:r.data.id,dbId:r.data.id}:x));
        setFound(prev=>prev&&prev.id===c.id?{...prev,id:r.data.id,dbId:r.data.id}:prev);
      }
    }).catch(e=>console.log("Customer save failed (kept locally):",e));
    setFound(c);
    setStep("ordering");
    push({title:"Customer added",body:c.name,color:"#059669"});
  };

  var addItem=it=>{
    var typePrice=getItemPrice(it,orderType);
    setCart(c=>{var ex=c.find(x=>x.id===it.id);return ex?c.map(x=>x.id===it.id?{...x,qty:x.qty+1,price:typePrice}:x):[...c,{id:it.id,name:it.name,qty:1,price:typePrice,note:""}];});
    setFlashId(it.id);setTimeout(()=>setFlashId(null),600);
  };
  var decItem=id=>setCart(c=>c.map(x=>x.id===id?{...x,qty:x.qty-1}:x).filter(x=>x.qty>0));
  var delItem=id=>setCart(c=>c.filter(x=>x.id!==id));
  var setItemNote=(id,note)=>setCart(c=>c.map(x=>x.id===id?{...x,note:note}:x));

  // Reorder last - copy items from last order to cart
  var reorderLast=()=>{
    if(!found)return;
    var lastOrder=orders.filter(o=>o.userId===found.id||o.phone===found.phone).sort((a,b)=>{
      var ta=new Date(a.created_at||a.time||0).getTime()||0;
      var tb=new Date(b.created_at||b.time||0).getTime()||0;
      return tb-ta;
    })[0];
    if(!lastOrder||!lastOrder.items||!lastOrder.items.length){
      push({title:"No previous order",body:"This customer has not ordered before",color:"#dc2626"});
      return;
    }
    var newCart=lastOrder.items.map(it=>{
      var m=menu.find(x=>String(x.id)===String(it.id)||x.name===it.name);
      var typePrice=m?getItemPrice(m,orderType):it.price;
      return {id:it.id,name:it.name,qty:it.qty,price:typePrice,note:""};
    });
    setCart(newCart);
    push({title:"Last order added",body:newCart.length+" items added to cart",color:"#059669"});
  };

  // Find customer's last order
  var lastOrder=found?orders.filter(o=>o.userId===found.id||o.phone===found.phone).sort((a,b)=>{
    var ta=new Date(a.created_at||a.time||0).getTime()||0;
    var tb=new Date(b.created_at||b.time||0).getTime()||0;
    return tb-ta;
  })[0]:null;

  var subtotal=cart.reduce((s,i)=>s+i.price*i.qty,0);
  var deliveryCheck=orderType==="delivery"&&found?checkDelivery(branch,{...found.address,distance:found.distance},subtotal):null;
  var deliveryFee=deliveryCheck?.fee||0;
  var total=subtotal+deliveryFee;

  var placeOrder=(paid)=>{
    if(!cart.length)return;
    if(orderType==="delivery"&&deliveryCheck&&!deliveryCheck.ok){alert(deliveryCheck.reason);return;}
    // Generate 4-digit delivery code for delivery orders (driver verifies it)
    var deliveryCode=orderType==="delivery"?String(Math.floor(1000+Math.random()*9000)):null;
    var o={id:uid(),branchId:branch?.id,userId:found.id,customer:found.name+" ("+found.phone+")",phone:found.phone,items:cart,subtotal,deliveryFee,total,status:"preparing",time:nowT(),created_at:new Date().toISOString(),type:orderType==="delivery"?"delivery":orderType==="collection"?"collection":"dine-in",paid,address:orderType==="delivery"?found.address:null,takenBy:user?.name,source:"phone",notes:orderNotes||"",deliveryCode:deliveryCode};
    onOrder(o);
    setCustomers(cs=>cs.map(c=>c.id===found.id?{...c,lastOrder:o.id,totalOrders:c.totalOrders+1,totalSpent:c.totalSpent+total}:c));
    if(deliveryCode){
      push({title:"Phone order placed!",body:o.id+" - Delivery code: "+deliveryCode,color:"#059669"});
      if(window.showAlert)window.showAlert("Delivery Code: "+deliveryCode,"Tell the customer their delivery code is "+deliveryCode+".\n\nThey must give this code to the driver when paying cash on delivery.","info");
    }else{
      push({title:"Phone order placed!",body:o.id+" - "+fmt(total),color:"#059669"});
    }
    setPhone("");setFound(null);setSearched(false);setStep("search");setCart([]);setNewCust({name:"",line1:"",postcode:"",notes:"",distance:0});setOrderNotes("");
  };

  // Step 1: Search by phone
  if(step==="search") return <div className="page" style={{maxWidth:500}}>
    <h2 style={{fontSize:24,marginBottom:4}}>Phone Order</h2>
    <p style={{color:"#8a8078",fontSize:13,marginBottom:20}}>Enter customer's phone number</p>
    <div className="card" style={{marginBottom:12}}>
      <label className="lbl">Customer Phone Number</label>
      <input className="field" value={phone} onChange={e=>setPhone(e.target.value)} onKeyDown={e=>e.key==="Enter"&&search()} placeholder="07700 900 000" style={{fontSize:22,padding:"14px 16px",textAlign:"center",fontWeight:700,letterSpacing:1}} autoFocus/>
      <button className="btn btn-r" onClick={search} disabled={phone.length<5} style={{width:"100%",padding:"12px",marginTop:10,fontSize:15}}>Search Customer</button>
    </div>
    <div style={{padding:"12px 14px",background:"#fffbeb",borderRadius:9,border:"1px solid #fde68a",fontSize:12,color:"#92400e"}}>
      <strong>Tip:</strong> Type the number your customer is calling from. If they're new, you can register them. If returning, you will see their history and last order.
    </div>
  </div>;

  // Step 2: Existing customer found
  if(step==="existing"&&found) return <div className="page" style={{maxWidth:560}}>
    <button className="btn btn-g" onClick={()=>{setStep("search");setFound(null);setPhone("");setSearched(false);}} style={{marginBottom:10,fontSize:13}}>{"< Back"}</button>
    <div className="card" style={{marginBottom:14,background:"linear-gradient(135deg,#059669,#10b981)",color:"#fff",border:"none"}}>
      <p style={{fontSize:11,opacity:.8,letterSpacing:1,marginBottom:3}}>{EM.check} EXISTING CUSTOMER</p>
      <h2 style={{fontSize:26,color:"#fff",marginBottom:4}}>{found.name}</h2>
      <p style={{fontSize:13,opacity:.9}}>{found.phone}</p>
      {found.notes&&<p style={{fontSize:12,opacity:.9,marginTop:6,padding:"5px 9px",background:"rgba(0,0,0,.15)",borderRadius:6}}>{EM.star} {found.notes}</p>}
    </div>

    <div className="g3" style={{marginBottom:12}}>
      {[["Orders",found.totalOrders,"#2563eb"],["Spent",fmt(found.totalSpent),"#059669"],["Distance",found.distance?found.distance.toFixed(1)+" mi":"-","#d97706"]].map(([l,v,c])=><div key={l} style={{background:"#fff",borderRadius:11,padding:"12px 8px",textAlign:"center",border:"1px solid #ede8de"}}><div style={{fontWeight:700,fontSize:16,color:c}}>{v}</div><div style={{fontSize:10,color:"#8a8078",fontWeight:600,textTransform:"uppercase"}}>{l}</div></div>)}
    </div>

    <div className="card" style={{marginBottom:12}}>
      <p style={{fontWeight:700,fontSize:13,marginBottom:8}}>{EM.pin} Address</p>
      <p style={{fontSize:14,marginBottom:2}}>{found.address.line1}</p>
      <p style={{fontSize:14,color:"#8a8078"}}>{found.address.postcode}</p>
      {found.address.notes&&<p style={{fontSize:12,color:"#8a8078",fontStyle:"italic",marginTop:4}}>{found.address.notes}</p>}
    </div>

    {found.lastOrder&&<button className="btn btn-p" onClick={reorderLast} style={{width:"100%",padding:"14px",fontSize:15,marginBottom:10}}>
      Would you like your last order? ({found.lastOrder})
    </button>}

    <button className="btn btn-r" onClick={()=>setStep("ordering")} style={{width:"100%",padding:"14px",fontSize:15}}>
      Start New Order
    </button>
  </div>;

  // Step 3: New customer
  if(step==="new") return <div className="page" style={{maxWidth:500}}>
    <button className="btn btn-g" onClick={()=>{setStep("search");setPhone("");setSearched(false);}} style={{marginBottom:10,fontSize:13}}>{"< Back"}</button>
    <div className="card" style={{marginBottom:14,background:"#fef3c7",border:"2px solid #fcd34d"}}>
      <p style={{fontSize:11,letterSpacing:1,color:"#92400e",fontWeight:700,marginBottom:3}}>NEW CUSTOMER</p>
      <p style={{fontSize:14,color:"#92400e"}}>No customer found for <strong>{phone}</strong></p>
      <p style={{fontSize:12,color:"#92400e",marginTop:4}}>Type postcode below to auto-fill area</p>
    </div>

    <div className="card">
      <label className="lbl">Name *</label>
      <input className="field" value={newCust.name} onChange={e=>setNewCust({...newCust,name:e.target.value})} placeholder="John Smith" style={{marginBottom:10}}/>

      <label className="lbl">Phone (confirmed)</label>
      <input className="field" value={phone} readOnly style={{background:"#f7f3ee",marginBottom:12}}/>

      {/* Postcode lookup */}
      <label className="lbl">Postcode - auto lookup</label>
      <div style={{display:"flex",gap:6,marginBottom:6}}>
        <input className="field" value={newCust.postcode} onChange={e=>setNewCust({...newCust,postcode:e.target.value.toUpperCase()})} onKeyDown={e=>e.key==="Enter"&&doLookup()} placeholder="E14 5AB" style={{flex:1,fontSize:16,letterSpacing:1}}/>
        <button onClick={doLookup} disabled={lookingUp||!newCust.postcode} style={{padding:"0 18px",background:lookingUp?"#8a8078":"#1a1208",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer",whiteSpace:"nowrap"}}>
          {lookingUp?"...":"Find"}
        </button>
      </div>

      {/* Lookup result */}
      {lookupResult&&lookupResult.ok&&<div style={{padding:"10px 12px",background:"#d1fae5",border:"2px solid #059669",borderRadius:8,marginBottom:10,fontSize:12}}>
        <p style={{fontWeight:700,color:"#065f46",marginBottom:3}}>{EM.check} {lookupResult.town}, {lookupResult.district}</p>
        {lookupResult.distance!==null&&<p style={{color:"#065f46"}}>{lookupResult.distance.toFixed(1)} miles from branch</p>}
      </div>}
      {lookupResult&&!lookupResult.ok&&<div style={{padding:"10px 12px",background:"#fee2e2",border:"2px solid #dc2626",borderRadius:8,marginBottom:10,fontSize:12,color:"#991b1b",fontWeight:700}}>
        {EM.cross} {lookupResult.reason}
      </div>}

      <label className="lbl">House number + Street</label>
      <input className="field" value={newCust.line1} onChange={e=>setNewCust({...newCust,line1:e.target.value})} placeholder="45 Oxford Street" style={{marginBottom:10}}/>

      <label className="lbl">Delivery Notes</label>
      <input className="field" value={newCust.notes} onChange={e=>setNewCust({...newCust,notes:e.target.value})} placeholder="Flat 3B, buzzer broken" style={{marginBottom:14}}/>

      <button className="btn btn-r" onClick={createCustomer} disabled={!newCust.name.trim()||!newCust.postcode} style={{width:"100%",padding:"13px"}}>
        Save Customer & Start Order
      </button>
    </div>
  </div>;

  // Step 4: Ordering - REDESIGNED
  // Build search-filtered list
  var menuItems=(()=>{
    var seen=new Set();
    var q=searchTerm.trim().toLowerCase();
    return menu.filter(i=>{
      if(!i.avail)return false;
      if(!isItemAvailable(i,orderType))return false;
      if(q){
        var hay=(i.name+" "+(i.desc||"")+" "+(i.cat||"")).toLowerCase();
        return hay.includes(q);
      }
      return i.cat===cat;
    }).filter(i=>{
      var key=(i.name||"").toLowerCase().trim()+"|"+(i.cat||"");
      if(seen.has(key))return false;
      seen.add(key);
      return true;
    });
  })();

  return <div className="page" style={{maxWidth:1200,padding:14}}>
    <button className="btn btn-g" onClick={()=>setStep("existing")} style={{marginBottom:10,fontSize:12,padding:"6px 12px"}}>{"< Back to customer"}</button>

    {/* Premium Customer Header */}
    <div style={{background:"linear-gradient(135deg,#1a1208,#3d2e22)",color:"#fff",borderRadius:14,padding:"14px 18px",marginBottom:10,boxShadow:"0 4px 12px rgba(0,0,0,.1)"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:10}}>
        <div style={{flex:1,minWidth:200}}>
          <h2 style={{fontSize:22,fontWeight:700,marginBottom:3,color:"#fff"}}>{found.name}</h2>
          <p style={{fontSize:12,color:"rgba(255,255,255,.7)",marginBottom:6}}>{EM.phone} {found.phone}</p>
          {orderType==="delivery"&&found.address&&<p style={{fontSize:12,color:"rgba(255,255,255,.85)",marginBottom:4}}>{EM.pin} {found.address.line1||"No address"}{found.address.postcode?", "+found.address.postcode:""}{found.distance?" - "+(typeof found.distance==="number"?found.distance.toFixed(1):found.distance)+" mi":""}</p>}
          {(found.totalOrders>0||found.totalSpent>0)&&<p style={{fontSize:11,color:"#d4952a",fontWeight:700,marginTop:4}}>{found.totalOrders||0} previous orders - {fmt(found.totalSpent||0)} total spent</p>}
        </div>
        <div style={{display:"flex",gap:5}}>
          {[["delivery","Delivery"],["collection","Collection"]].filter(([t])=>{
            if(!restaurant)return true;
            if(t==="delivery"&&!hasService(restaurant,"delivery"))return false;
            if(t==="collection"&&!hasService(restaurant,"collection"))return false;
            return true;
          }).map(([t,l])=><button key={t} onClick={()=>setOrderType(t)} style={{padding:"9px 16px",borderRadius:8,fontWeight:700,fontSize:12,background:orderType===t?"#bf4626":"rgba(255,255,255,.1)",color:"#fff",border:"2px solid "+(orderType===t?"#bf4626":"rgba(255,255,255,.2)"),cursor:"pointer"}}>{l}</button>)}
        </div>
      </div>

      {lastOrder&&cart.length===0&&<div style={{marginTop:11,paddingTop:11,borderTop:"1px solid rgba(255,255,255,.15)"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:6}}>
          <div>
            <p style={{fontSize:11,color:"#d4952a",fontWeight:700,letterSpacing:1,marginBottom:2}}>LAST ORDER</p>
            <p style={{fontSize:12,color:"rgba(255,255,255,.85)"}}>{(lastOrder.items||[]).map(i=>i.name+" x"+i.qty).slice(0,3).join(", ")}{(lastOrder.items||[]).length>3?", +"+((lastOrder.items||[]).length-3)+" more":""}</p>
            <p style={{fontSize:11,color:"rgba(255,255,255,.6)",marginTop:2}}>{fmt(lastOrder.total||0)} - {lastOrder.time||"recent"}</p>
          </div>
          <button onClick={reorderLast} style={{padding:"9px 14px",borderRadius:7,fontSize:12,fontWeight:700,background:"#d4952a",color:"#1a1208",border:"none",cursor:"pointer",whiteSpace:"nowrap"}}>{String.fromCharCode(0x21BB)} Reorder Same</button>
        </div>
      </div>}
    </div>

    {/* Delivery status */}
    {orderType==="delivery"&&deliveryCheck&&<div style={{marginBottom:10,padding:"10px 14px",borderRadius:9,background:deliveryCheck.ok?"#d1fae5":"#fee2e2",border:"2px solid "+(deliveryCheck.ok?"#059669":"#dc2626"),fontSize:13,fontWeight:700,color:deliveryCheck.ok?"#065f46":"#991b1b",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:6}}>
      <span>{deliveryCheck.ok?(EM.check+" Delivery OK"+(deliveryCheck.zone?" - "+deliveryCheck.zone:"")):(EM.cross+" "+deliveryCheck.reason)}</span>
      {deliveryCheck.ok&&<span style={{fontSize:14}}>{deliveryCheck.fee===0?"FREE DELIVERY":fmt(deliveryCheck.fee)+" fee"}</span>}
    </div>}

    {/* Two-column main area */}
    <div style={{display:"grid",gridTemplateColumns:cart.length?"1.5fr 380px":"1fr",gap:12}}>
      {/* LEFT: Menu */}
      <div>
        {/* Search bar */}
        <div style={{position:"relative",marginBottom:10}}>
          <input value={searchTerm} onChange={e=>setSearchTerm(e.target.value)} placeholder="Search items..." className="field" style={{paddingLeft:32,fontSize:13}}/>
          <span style={{position:"absolute",left:12,top:"50%",transform:"translateY(-50%)",fontSize:14,color:"#8a8078"}}>{String.fromCharCode(0xD83D,0xDD0D)}</span>
          {searchTerm&&<button onClick={()=>setSearchTerm("")} style={{position:"absolute",right:8,top:"50%",transform:"translateY(-50%)",background:"#ede8de",border:"none",width:24,height:24,borderRadius:12,cursor:"pointer",fontWeight:700,color:"#8a8078"}}>x</button>}
        </div>

        {/* Categories */}
        {!searchTerm&&<div style={{display:"flex",gap:5,overflowX:"auto",marginBottom:10,paddingBottom:4}}>
          {cats.map(c=>{
            var count=menu.filter(m=>m.cat===c&&m.avail&&isItemAvailable(m,orderType)).length;
            return <button key={c} onClick={()=>setCat(c)} style={{whiteSpace:"nowrap",padding:"9px 14px",borderRadius:9,fontWeight:700,fontSize:12,border:"2px solid",borderColor:cat===c?"#1a1208":"#ede8de",background:cat===c?"#1a1208":"#fff",color:cat===c?"#d4952a":"#1a1208",cursor:"pointer",flexShrink:0,transition:"all .15s"}}>{c} <span style={{fontSize:10,opacity:.7,marginLeft:3}}>{count}</span></button>;
          })}
        </div>}

        {/* Menu grid - bigger cards */}
        {menuItems.length===0?<div className="card" style={{textAlign:"center",padding:30,color:"#8a8078"}}>
          <p style={{fontSize:30,marginBottom:8}}>{EM.cook}</p>
          <p style={{fontSize:13}}>{searchTerm?"No items match \""+searchTerm+"\"":"No items in "+cat}</p>
        </div>:<div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(140px,1fr))",gap:8}}>
          {menuItems.map(item=>{
            var inCart=cart.find(c=>c.id===item.id);
            var displayPrice=getItemPrice(item,orderType);
            return <button key={item.dbId||item.id} onClick={()=>addItem(item)} disabled={item.stock===0} style={{background:inCart?"linear-gradient(135deg,#fff5f3,#fff)":"#fff",border:"2px solid "+(inCart?"#bf4626":"transparent"),borderRadius:11,padding:"14px 10px",cursor:item.stock===0?"not-allowed":"pointer",opacity:item.stock===0?.4:1,boxShadow:inCart?"0 6px 18px rgba(191,70,38,.25)":"0 2px 8px rgba(0,0,0,.08)",display:"flex",flexDirection:"column",alignItems:"center",gap:5,position:"relative",minHeight:130,transition:"all .15s"}}>
              {inCart&&<div style={{position:"absolute",top:-7,right:-7,background:"#bf4626",color:"#fff",borderRadius:"50%",width:28,height:28,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:700,border:"2px solid #fff",boxShadow:"0 2px 6px rgba(191,70,38,.4)"}}>{inCart.qty}</div>}
              <span style={{fontSize:34}}>{EM[item.icon]||""}</span>
              <p style={{fontSize:12,fontWeight:700,textAlign:"center",lineHeight:1.25}}>{item.name}</p>
              <p style={{fontSize:14,fontWeight:700,color:"#bf4626"}}>{fmt(displayPrice)}</p>
            </button>;
          })}
        </div>}
      </div>

      {/* RIGHT: Cart */}
      {cart.length>0&&<div style={{position:"sticky",top:14,alignSelf:"flex-start"}}>
        <div className="card" style={{padding:0,overflow:"hidden"}}>
          {/* Cart header */}
          <div style={{background:"#1a1208",color:"#fff",padding:"12px 14px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div>
              <p style={{fontSize:13,fontWeight:700}}>Order Summary</p>
              <p style={{fontSize:11,color:"rgba(255,255,255,.65)"}}>{cart.reduce((s,i)=>s+i.qty,0)} items - {orderType==="delivery"?"Delivery":"Collection"}</p>
            </div>
            <button onClick={()=>setCart([])} style={{padding:"5px 10px",fontSize:11,background:"rgba(255,255,255,.1)",color:"#fff",border:"1px solid rgba(255,255,255,.2)",borderRadius:6,cursor:"pointer",fontWeight:700}}>Clear</button>
          </div>

          {/* Cart items */}
          <div style={{maxHeight:380,overflowY:"auto",padding:"8px 12px"}}>
            {cart.map(it=><div key={it.id} className={flashId===it.id?"flash":""} style={{padding:"9px 0",borderBottom:"1px solid #f5f0e8"}}>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <div style={{flex:1,minWidth:0}}>
                  <p style={{fontSize:13,fontWeight:700,marginBottom:2,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{it.name}</p>
                  <p style={{fontSize:11,color:"#8a8078"}}>{fmt(it.price)} each</p>
                </div>
                <div style={{display:"flex",alignItems:"center",gap:5,background:"#f7f3ee",borderRadius:18,padding:"3px 6px"}}>
                  <button onClick={()=>decItem(it.id)} style={{width:22,height:22,borderRadius:"50%",border:"none",background:"#fff",cursor:"pointer",fontSize:14,fontWeight:700,color:"#bf4626",lineHeight:1}}>-</button>
                  <span style={{fontWeight:700,minWidth:18,textAlign:"center",fontSize:13}}>{it.qty}</span>
                  <button onClick={()=>addItem(it)} style={{width:22,height:22,borderRadius:"50%",border:"none",background:"#fff",cursor:"pointer",fontSize:14,fontWeight:700,color:"#059669",lineHeight:1}}>+</button>
                </div>
                <p style={{fontWeight:700,fontSize:13,color:"#bf4626",minWidth:54,textAlign:"right"}}>{fmt(it.price*it.qty)}</p>
                <button onClick={()=>delItem(it.id)} style={{width:22,height:22,borderRadius:"50%",border:"none",background:"#fee2e2",color:"#dc2626",cursor:"pointer",fontWeight:700,fontSize:11}}>x</button>
              </div>
              {/* Item note */}
              {editNoteId===it.id?<input autoFocus value={it.note||""} onChange={e=>setItemNote(it.id,e.target.value)} onBlur={()=>setEditNoteId(null)} placeholder="No onions, extra spicy..." style={{width:"100%",marginTop:6,padding:"6px 9px",fontSize:11,border:"2px solid #d4952a",borderRadius:6}}/>:it.note?<div onClick={()=>setEditNoteId(it.id)} style={{marginTop:5,padding:"4px 8px",background:"#fef3c7",borderRadius:5,fontSize:10,color:"#92400e",cursor:"pointer",fontStyle:"italic"}}>Note: {it.note} (tap to edit)</div>:<button onClick={()=>setEditNoteId(it.id)} style={{marginTop:5,padding:"3px 7px",fontSize:10,background:"transparent",color:"#8a8078",border:"1px dashed #ddd",borderRadius:4,cursor:"pointer"}}>+ Add note</button>}
            </div>)}
          </div>

          {/* Order notes */}
          <div style={{padding:"8px 12px",borderTop:"1px solid #ede8de",background:"#fafaf5"}}>
            <p style={{fontSize:11,fontWeight:700,marginBottom:5,color:"#8a8078",letterSpacing:1}}>ORDER NOTES (OPTIONAL)</p>
            <textarea value={orderNotes} onChange={e=>setOrderNotes(e.target.value)} placeholder="Special delivery instructions, gate code, etc." style={{width:"100%",minHeight:50,padding:"7px 9px",border:"1px solid #ede8de",borderRadius:6,fontSize:12,fontFamily:"inherit",resize:"vertical"}}/>
          </div>

          {/* Totals */}
          <div style={{padding:"10px 14px",background:"#fafaf5",borderTop:"1px solid #ede8de"}}>
            <div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"#8a8078",marginBottom:3}}><span>Subtotal</span><span>{fmt(subtotal)}</span></div>
            {orderType==="delivery"&&deliveryFee>0&&<div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"#8a8078",marginBottom:3}}><span>Delivery</span><span>{fmt(deliveryFee)}</span></div>}
            {orderType==="delivery"&&deliveryCheck?.ok&&deliveryFee===0&&<div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"#059669",marginBottom:3,fontWeight:700}}><span>Delivery</span><span>FREE</span></div>}
            <div style={{display:"flex",justifyContent:"space-between",fontWeight:700,fontSize:20,marginTop:6,paddingTop:6,borderTop:"2px solid #ede8de"}}><span>Total</span><span style={{color:"#bf4626"}}>{fmt(total)}</span></div>
          </div>

          {/* Action buttons */}
          <div style={{padding:"10px 12px",display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
            <button disabled={orderType==="delivery"&&deliveryCheck&&!deliveryCheck.ok} onClick={()=>placeOrder(true)} style={{padding:"13px",fontSize:13,fontWeight:700,background:"#059669",color:"#fff",border:"none",borderRadius:9,cursor:orderType==="delivery"&&deliveryCheck&&!deliveryCheck.ok?"not-allowed":"pointer",opacity:orderType==="delivery"&&deliveryCheck&&!deliveryCheck.ok?.5:1}}>{EM.check} Customer Paid</button>
            <button disabled={orderType==="delivery"&&deliveryCheck&&!deliveryCheck.ok} onClick={()=>placeOrder(false)} style={{padding:"13px",fontSize:13,fontWeight:700,background:"#bf4626",color:"#fff",border:"none",borderRadius:9,cursor:orderType==="delivery"&&deliveryCheck&&!deliveryCheck.ok?"not-allowed":"pointer",opacity:orderType==="delivery"&&deliveryCheck&&!deliveryCheck.ok?.5:1}}>{EM.pound} Cash on Delivery</button>
          </div>
        </div>
      </div>}
    </div>
  </div>;
}

// -- POS (EPOS for Staff) -----------------------------------------------------
// -- STAFF BOOKINGS DASHBOARD ----------------------------------------------
function StaffBookingsV({branch,push}){
  var [bookings,setBookings]=useState([]);
  var [filter,setFilter]=useState("today");
  var [loading,setLoading]=useState(true);
  var seenBookingIdsRef=useRef(new Set());
  var initialBookingLoadRef=useRef(true);
  var [soundOn,setSoundOn]=useState(()=>{try{return localStorage.getItem("booking_sound")!=="0";}catch(e){return true;}});
  var today=new Date().toISOString().split("T")[0];
  var tomorrow=new Date(Date.now()+86400000).toISOString().split("T")[0];
  var weekAhead=new Date(Date.now()+7*86400000).toISOString().split("T")[0];

  // Sound for new bookings
  var playBookingDing=useCallback(()=>{
    if(!soundOn)return;
    try{
      var AudioCtx=window.AudioContext||window.webkitAudioContext;
      if(!AudioCtx)return;
      var ctx=new AudioCtx();
      var osc=ctx.createOscillator();
      var gain=ctx.createGain();
      osc.connect(gain);gain.connect(ctx.destination);
      osc.type="sine";
      osc.frequency.setValueAtTime(660,ctx.currentTime);
      osc.frequency.exponentialRampToValueAtTime(880,ctx.currentTime+0.2);
      gain.gain.setValueAtTime(0.3,ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.01,ctx.currentTime+0.5);
      osc.start(ctx.currentTime);
      osc.stop(ctx.currentTime+0.5);
    }catch(e){}
  },[soundOn]);

  var refresh=useCallback((isAuto)=>{
    if(!isAuto)setLoading(true);
    var from=today,to=today;
    if(filter==="tomorrow"){from=tomorrow;to=tomorrow;}
    else if(filter==="week"){from=today;to=weekAhead;}
    else if(filter==="past"){from="2020-01-01";to=today;}
    dbFetchReservations(branch?.id,from,to).then(data=>{
      var fresh=data||[];
      // Detect new bookings (by ID we've never seen)
      if(initialBookingLoadRef.current){
        fresh.forEach(b=>seenBookingIdsRef.current.add(b.id));
        initialBookingLoadRef.current=false;
      }else{
        var newOnes=fresh.filter(b=>!seenBookingIdsRef.current.has(b.id));
        if(newOnes.length>0){
          newOnes.forEach(b=>seenBookingIdsRef.current.add(b.id));
          playBookingDing();
          var latest=newOnes[0];
          push({title:"New booking!",body:latest.customer_name+" - "+latest.guests+" guests at "+latest.reservation_time,color:"#7c3aed"});
          // Browser notification
          if(typeof window!=="undefined"&&"Notification" in window&&Notification.permission==="granted"){
            try{
              var n=new Notification(String.fromCharCode(0xD83D,0xDCC5)+" New Booking - La Tavola",{
                body:latest.customer_name+" booked "+latest.guests+" guests at "+latest.reservation_time,
                tag:"booking-"+latest.id,
              });
              setTimeout(()=>n.close(),8000);
            }catch(e){}
          }
        }
      }
      setBookings(fresh);
      setLoading(false);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[branch,filter,playBookingDing,push]);

  useEffect(()=>{refresh();},[refresh]);

  // Auto-refresh every 15 seconds to catch new bookings
  useEffect(()=>{
    var interval=setInterval(()=>refresh(true),15000);
    return()=>clearInterval(interval);
  },[refresh]);

  // Request notification permission once
  useEffect(()=>{
    if(typeof window!=="undefined"&&"Notification" in window&&Notification.permission==="default"){
      Notification.requestPermission();
    }
  },[]);

  var toggleSound=()=>{
    var v=!soundOn;setSoundOn(v);
    try{localStorage.setItem("booking_sound",v?"1":"0");}catch(e){}
    if(v)playBookingDing();
  };

  var checkIn=b=>{
    dbUpdateReservationStatus(b.id,"arrived").then(r=>{
      if(r.error){push({title:"Update failed",body:r.error.message,color:"#dc2626"});return;}
      push({title:"Checked in",body:b.customer_name+" arrived",color:"#059669"});
      refresh();
    });
  };
  var noShow=b=>{
    if(!window.confirm("Mark "+b.customer_name+" as no-show?"))return;
    dbUpdateReservationStatus(b.id,"no-show").then(()=>{refresh();push({title:"Marked no-show",body:b.customer_name,color:"#dc2626"});});
  };
  var cancel=b=>{
    if(!window.confirm("Cancel booking for "+b.customer_name+"?"))return;
    dbUpdateReservationStatus(b.id,"cancelled").then(()=>{refresh();push({title:"Booking cancelled",body:b.customer_name,color:"#dc2626"});});
  };

  var grouped={};
  bookings.forEach(b=>{
    var key=b.reservation_date;
    if(!grouped[key])grouped[key]=[];
    grouped[key].push(b);
  });
  Object.keys(grouped).forEach(k=>grouped[k].sort((a,b)=>a.reservation_time.localeCompare(b.reservation_time)));

  var statusColor={confirmed:"#2563eb",arrived:"#059669","no-show":"#dc2626",cancelled:"#8a8078"};
  var statusBg={confirmed:"#dbeafe",arrived:"#d1fae5","no-show":"#fee2e2",cancelled:"#f5f5f5"};

  var stats={
    total:bookings.length,
    today:bookings.filter(b=>b.reservation_date===today&&b.status!=="cancelled").length,
    arrived:bookings.filter(b=>b.status==="arrived").length,
    pending:bookings.filter(b=>b.status==="confirmed"&&b.reservation_date===today).length,
  };

  return <div className="page">
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:8}}>
      <div><h2 style={{fontSize:22,marginBottom:2}}>Bookings</h2><p style={{color:"#8a8078",fontSize:12}}>{branch?.name} - auto-refreshes every 15 sec</p></div>
      <div style={{display:"flex",gap:6,alignItems:"center"}}>
        <button onClick={toggleSound} title={soundOn?"Sound on":"Sound off"} style={{padding:"8px 11px",fontSize:14,background:soundOn?"#d1fae5":"#f5f5f5",color:soundOn?"#065f46":"#999",border:"2px solid "+(soundOn?"#059669":"#ddd"),borderRadius:8,cursor:"pointer",fontWeight:700}}>{soundOn?String.fromCharCode(0xD83D,0xDD0A):String.fromCharCode(0xD83D,0xDD07)}</button>
        <button onClick={()=>refresh(false)} style={{padding:"8px 14px",fontSize:12,background:"#1a1208",color:"#fff",border:"none",borderRadius:8,cursor:"pointer",fontWeight:700}}>Refresh</button>
      </div>
    </div>

    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:14}}>
      {[["Today",stats.today,"#2563eb"],["Arrived",stats.arrived,"#059669"],["Pending",stats.pending,"#d4952a"],["Total",stats.total,"#1a1208"]].map(([l,v,c])=><div key={l} style={{background:"#fff",borderRadius:11,padding:"10px 8px",border:"1px solid #ede8de",textAlign:"center"}}><div style={{fontSize:22,fontWeight:700,color:c}}>{v}</div><div style={{fontSize:10,color:"#8a8078",fontWeight:600}}>{l}</div></div>)}
    </div>

    <div style={{display:"flex",gap:6,marginBottom:14,overflowX:"auto",flexWrap:"wrap"}}>
      {[["today","Today"],["tomorrow","Tomorrow"],["week","Next 7 days"],["past","Past"]].map(([k,l])=><button key={k} onClick={()=>setFilter(k)} style={{padding:"8px 14px",fontSize:12,fontWeight:700,background:filter===k?"#bf4626":"#fff",color:filter===k?"#fff":"#1a1208",border:"2px solid "+(filter===k?"#bf4626":"#ede8de"),borderRadius:8,cursor:"pointer",whiteSpace:"nowrap"}}>{l}</button>)}
    </div>

    {loading&&<p style={{textAlign:"center",color:"#8a8078",padding:20,fontSize:13}}>Loading bookings...</p>}
    {!loading&&bookings.length===0&&<div className="card" style={{textAlign:"center",padding:30}}>
      <p style={{fontSize:40,marginBottom:10}}>{EM.cal}</p>
      <p style={{fontSize:14,color:"#8a8078"}}>No bookings for this period</p>
    </div>}

    {Object.keys(grouped).sort().map(date=><div key={date} style={{marginBottom:20}}>
      <h3 style={{fontSize:14,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:8,paddingBottom:6,borderBottom:"2px solid #ede8de"}}>
        {new Date(date+"T00:00:00").toLocaleDateString("en-GB",{weekday:"long",day:"numeric",month:"long"})}
        <span style={{float:"right",color:"#bf4626",fontSize:12}}>{grouped[date].length} booking{grouped[date].length!==1?"s":""}</span>
      </h3>
      {grouped[date].map(b=><div key={b.id} className="card" style={{marginBottom:8,padding:"12px 14px",borderLeft:"4px solid "+statusColor[b.status]}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:6,flexWrap:"wrap",gap:6}}>
          <div style={{flex:1,minWidth:0}}>
            <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
              <p style={{fontWeight:700,fontSize:16}}>{b.customer_name}</p>
              <span style={{padding:"2px 8px",borderRadius:6,background:statusBg[b.status],color:statusColor[b.status],fontSize:10,fontWeight:700,textTransform:"uppercase"}}>{b.status}</span>
            </div>
            <p style={{fontSize:13,color:"#8a8078",marginTop:3}}>
              {EM.cal} {b.reservation_time.slice(0,5)} - {b.party_size} guest{b.party_size!==1?"s":""}
              {b.table_id&&<span style={{color:"#bf4626",fontWeight:700,marginLeft:8}}>Table {b.table_id}</span>}
            </p>
            {b.customer_phone&&<p style={{fontSize:12,color:"#8a8078",marginTop:2}}>{EM.phone} {b.customer_phone}</p>}
            {b.customer_email&&<p style={{fontSize:11,color:"#8a8078",marginTop:1}}>{b.customer_email}</p>}
            {b.notes&&<p style={{fontSize:12,color:"#d4952a",marginTop:4,fontStyle:"italic"}}>Note: {b.notes}</p>}
          </div>
        </div>
        {b.status==="confirmed"&&b.reservation_date===today&&<div style={{display:"flex",gap:6,marginTop:8}}>
          <button className="btn btn-r" onClick={()=>checkIn(b)} style={{flex:2,padding:"8px",fontSize:12}}>{EM.check} Check In</button>
          <button className="btn btn-d" onClick={()=>noShow(b)} style={{flex:1,padding:"8px",fontSize:12}}>No-show</button>
          <button onClick={()=>cancel(b)} style={{flex:1,padding:"8px",fontSize:12,background:"none",color:"#8a8078",border:"1px solid #ede8de",borderRadius:8,cursor:"pointer",fontWeight:700}}>Cancel</button>
        </div>}
        {b.status==="confirmed"&&b.reservation_date>today&&<div style={{display:"flex",gap:6,marginTop:8}}>
          <button onClick={()=>cancel(b)} style={{padding:"8px 14px",fontSize:12,background:"none",color:"#dc2626",border:"1px solid #fee2e2",borderRadius:8,cursor:"pointer",fontWeight:700}}>Cancel Booking</button>
        </div>}
      </div>)}
    </div>)}
  </div>;
}


// -- INCOMING ONLINE ORDERS PANEL ------------------------------------------
// -- DRIVER VIEW: Active deliveries, code verification, cash collection ------
function DriverV({orders,setOrders,push,user,branch}){
  var [codeInput,setCodeInput]=useState({});
  var [collectInput,setCollectInput]=useState({});
  
  // Use active staff name (PIN login) if available, otherwise user name
  var activeStaff=(typeof window!=="undefined")?dbGetActiveStaff():null;
  var driverName=activeStaff?.full_name||user?.name||"Driver";

  // Active deliveries: ready or out for delivery, type=delivery
  var myDeliveries=orders.filter(o=>{
    if(branch&&o.branchId&&o.branchId!==branch.id)return false;
    if(o.type!=="delivery")return false;
    return o.status==="ready"||o.status==="out_for_delivery"||(o.status==="delivered"&&o.payMethod==="cod"&&!o.paid);
  });
  var todayDelivered=orders.filter(o=>{
    if(branch&&o.branchId&&o.branchId!==branch.id)return false;
    if(o.type!=="delivery"||o.status!=="delivered")return false;
    if(o.deliveredBy&&o.deliveredBy!==driverName)return false;
    return true;
  });
  var cashOwed=todayDelivered.filter(o=>o.payMethod==="cash"&&o.paid&&!o.cashHandoverId).reduce((s,o)=>s+(o.cashCollected||o.total||0),0);

  var verifyCode=(o)=>{
    var entered=codeInput[o.id]||"";
    if(!entered||entered.length<4){alert("Enter the 4-digit code from customer");return;}
    if(String(entered)!==String(o.deliveryCode)){
      push({title:"Wrong code",body:"Code does not match for "+o.id,color:"#dc2626"});
      return;
    }
    // Code matches - mark delivered
    setOrders(os=>os.map(x=>x.id===o.id?{...x,status:"delivered",deliveredAt:new Date().toISOString(),deliveredBy:driverName}:x));
    dbUpdateOrderStatus(o.id,"delivered").catch(e=>{});
    push({title:"Delivered!",body:o.id+" - confirmed by code",color:"#059669"});
    setCodeInput(c=>({...c,[o.id]:""}));
  };

  var pickup=(o)=>{
    setOrders(os=>os.map(x=>x.id===o.id?{...x,status:"out_for_delivery"}:x));
    dbUpdateOrderStatus(o.id,"out_for_delivery").catch(e=>{});
    push({title:"Out for delivery",body:o.id,color:"#2563eb"});
  };

  var collectCash=(o)=>{
    var amt=parseFloat(collectInput[o.id]||o.total||0);
    if(!amt||amt<=0){alert("Enter cash amount");return;}
    setOrders(os=>os.map(x=>x.id===o.id?{...x,paid:true,payMethod:"cash",cashCollected:amt,deliveredBy:driverName}:x));
    dbRecordCash(o.id,amt,driverName).catch(e=>console.log("Cash record save:",e));
    push({title:"Cash collected",body:fmt(amt)+" from "+o.id,color:"#059669"});
    setCollectInput(c=>({...c,[o.id]:""}));
  };

  // Calculate today's stats for driver
  var todayDelivered2=todayDelivered.length;
  var pendingCount=myDeliveries.filter(o=>o.status==="ready").length;
  var enRouteCount=myDeliveries.filter(o=>o.status==="out_for_delivery").length;

  return <div className="page">
    {/* Beautiful Driver Header */}
    <div style={{background:"linear-gradient(135deg,#1e3a8a,#2563eb,#0891b2)",borderRadius:14,padding:"18px",marginBottom:14,color:"#fff",position:"relative",overflow:"hidden"}}>
      <div style={{position:"absolute",top:-20,right:-20,width:120,height:120,borderRadius:"50%",background:"radial-gradient(circle,rgba(255,255,255,.15),transparent 70%)"}}></div>
      <div style={{position:"relative",zIndex:1}}>
        <p style={{fontSize:10,letterSpacing:2.5,fontWeight:700,opacity:.85,marginBottom:5}}>{String.fromCharCode(0xD83D,0xDEF5)} DRIVER VIEW</p>
        <h2 style={{fontSize:22,fontWeight:700,fontFamily:"Georgia,serif",marginBottom:3}}>Hi {driverName}!</h2>
        <p style={{fontSize:12,opacity:.85}}>{branch?.name||"Restaurant"}</p>
      </div>
    </div>
    
    {/* STATS CARDS */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:9,marginBottom:14}}>
      <div style={{padding:"11px 14px",background:"linear-gradient(135deg,#fef3c7,#fde68a)",borderRadius:11,border:"2px solid #f59e0b"}}>
        <p style={{fontSize:10,color:"#92400e",letterSpacing:1,fontWeight:700}}>READY TO PICKUP</p>
        <p style={{fontSize:24,fontWeight:700,color:"#92400e"}}>{pendingCount}</p>
      </div>
      <div style={{padding:"11px 14px",background:"linear-gradient(135deg,#dbeafe,#bfdbfe)",borderRadius:11,border:"2px solid #3b82f6"}}>
        <p style={{fontSize:10,color:"#1e40af",letterSpacing:1,fontWeight:700}}>EN ROUTE</p>
        <p style={{fontSize:24,fontWeight:700,color:"#1e40af"}}>{enRouteCount}</p>
      </div>
      <div style={{padding:"11px 14px",background:"linear-gradient(135deg,#d1fae5,#a7f3d0)",borderRadius:11,border:"2px solid #10b981"}}>
        <p style={{fontSize:10,color:"#065f46",letterSpacing:1,fontWeight:700}}>DELIVERED TODAY</p>
        <p style={{fontSize:24,fontWeight:700,color:"#065f46"}}>{todayDelivered2}</p>
      </div>
      <div style={{padding:"11px 14px",background:cashOwed>0?"linear-gradient(135deg,#fee2e2,#fecaca)":"linear-gradient(135deg,#d1fae5,#a7f3d0)",borderRadius:11,border:"2px solid "+(cashOwed>0?"#dc2626":"#10b981")}}>
        <p style={{fontSize:10,color:cashOwed>0?"#991b1b":"#065f46",letterSpacing:1,fontWeight:700}}>CASH IN HAND</p>
        <p style={{fontSize:24,fontWeight:700,color:cashOwed>0?"#991b1b":"#065f46"}}>{fmt(cashOwed)}</p>
        {cashOwed>0&&<p style={{fontSize:9,color:"#991b1b",marginTop:3}}>{String.fromCharCode(0x26A0,0xFE0F)} Hand to manager</p>}
      </div>
    </div>

    {myDeliveries.length===0?<div className="card" style={{textAlign:"center",padding:30}}>
      <p style={{fontSize:40,marginBottom:10}}>{EM.bag}</p>
      <p style={{fontSize:14,color:"#8a8078"}}>No active deliveries</p>
    </div>:myDeliveries.map(o=>{
      var addrLine=o.address?(typeof o.address==="string"?o.address:[o.address.line1,o.address.postcode].filter(Boolean).join(", ")):"No address";
      var isCOD=o.payMethod==="cod"&&!o.paid;
      var needsCashStep=o.status==="delivered"&&isCOD;
      var fullyDone=o.status==="delivered"&&!isCOD;
      return <div key={o.id} className="card" style={{marginBottom:11,padding:14,borderLeft:"5px solid "+(fullyDone?"#10b981":needsCashStep?"#f59e0b":o.status==="out_for_delivery"?"#2563eb":"#bf4626")}}>
        {/* CLAIM STATUS BANNER - shows who has this order */}
        {o.assignedDriverName?
          <div style={{margin:"-14px -14px 11px -14px",padding:"7px 14px",background:o.status==="out_for_delivery"?"linear-gradient(135deg,#2563eb,#1d4ed8)":"linear-gradient(135deg,#0891b2,#0e7490)",color:"#fff",fontSize:11,fontWeight:700,display:"flex",alignItems:"center",gap:6}}>
            <span style={{fontSize:14}}>{o.status==="out_for_delivery"?String.fromCharCode(0xD83D,0xDEF5):String.fromCharCode(0x270B)}</span>
            <span>{o.status==="out_for_delivery"?o.assignedDriverName+" is delivering this now":o.assignedDriverName+" claimed this order"}</span>
          </div>
          :
          (o.status==="ready"&&<div style={{margin:"-14px -14px 11px -14px",padding:"7px 14px",background:"linear-gradient(135deg,#d97706,#b45309)",color:"#fff",fontSize:11,fontWeight:700,display:"flex",alignItems:"center",gap:6}}>
            <span style={{fontSize:14}}>{String.fromCharCode(0x23F3)}</span>
            <span>Waiting for a driver to claim</span>
          </div>)
        }
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8,flexWrap:"wrap",gap:6}}>
          <div style={{flex:1,minWidth:0}}>
            <p style={{fontWeight:700,fontSize:16,marginBottom:3}}>{o.customer||"Guest"}</p>
            <p style={{fontSize:11,color:"#8a8078"}}>{o.id} - {fmt(o.total)} - {o.payMethod==="cod"?String.fromCharCode(0xD83D,0xDCB5)+" CASH ON DELIVERY":o.paid?String.fromCharCode(0x2705)+" PAID ONLINE":String.fromCharCode(0x26A0,0xFE0F)+" UNPAID"}</p>
            <p style={{fontSize:13,marginTop:6,fontWeight:600}}>{EM.pin} {addrLine}</p>
            {o.address?.notes&&<p style={{fontSize:11,color:"#8a8078",marginTop:2,fontStyle:"italic"}}>Note: {o.address.notes}</p>}
          </div>
          <span style={{padding:"3px 9px",background:fullyDone?"#d1fae5":needsCashStep?"#fef3c7":o.status==="out_for_delivery"?"#dbeafe":"#fee2e2",color:fullyDone?"#065f46":needsCashStep?"#92400e":o.status==="out_for_delivery"?"#1e40af":"#991b1b",borderRadius:5,fontSize:10,fontWeight:700}}>{fullyDone?"DONE":needsCashStep?"COLLECT CASH":o.status==="out_for_delivery"?"EN ROUTE":"READY TO PICKUP"}</span>
        </div>
        
        {/* QUICK ACTION BUTTONS - Call + Maps */}
        {(o.phone||addrLine!=="No address")&&!fullyDone&&<div style={{display:"flex",gap:7,marginBottom:11}}>
          {o.phone&&<a href={"tel:"+o.phone} style={{flex:1,padding:"11px",background:"linear-gradient(135deg,#2563eb,#1e40af)",color:"#fff",borderRadius:9,fontWeight:700,fontSize:13,textAlign:"center",textDecoration:"none",display:"flex",alignItems:"center",justifyContent:"center",gap:5}}>
            <span style={{fontSize:16}}>{String.fromCharCode(0xD83D,0xDCDE)}</span>
            <span>Call</span>
          </a>}
          {addrLine!=="No address"&&<a href={"https://www.google.com/maps/dir/?api=1&destination="+encodeURIComponent(addrLine)} target="_blank" rel="noopener noreferrer" style={{flex:1,padding:"11px",background:"linear-gradient(135deg,#059669,#047857)",color:"#fff",borderRadius:9,fontWeight:700,fontSize:13,textAlign:"center",textDecoration:"none",display:"flex",alignItems:"center",justifyContent:"center",gap:5}}>
            <span style={{fontSize:16}}>{String.fromCharCode(0xD83D,0xDDFA,0xFE0F)}</span>
            <span>Navigate</span>
          </a>}
          {o.phone&&<a href={"sms:"+o.phone+"?body="+encodeURIComponent("Hi! Your order from "+(typeof window!=="undefined"&&window.__currentRestaurant?window.__currentRestaurant.name:"the restaurant")+" is on the way!")} style={{padding:"11px 14px",background:"#7c3aed",color:"#fff",borderRadius:9,fontWeight:700,fontSize:13,textAlign:"center",textDecoration:"none",display:"flex",alignItems:"center",justifyContent:"center",gap:5}}>
            <span style={{fontSize:16}}>{String.fromCharCode(0xD83D,0xDCAC)}</span>
          </a>}
        </div>}

        <div style={{background:"#fafaf5",borderRadius:6,padding:"7px 10px",marginBottom:10,fontSize:11}}>
          {(o.items||[]).map((it,i)=><div key={i} style={{display:"flex",justifyContent:"space-between"}}><span>{it.name} x{it.qty}</span><span>{fmt((+it.price||0)*it.qty)}</span></div>)}
          <div style={{display:"flex",justifyContent:"space-between",borderTop:"1px solid #ede8de",marginTop:5,paddingTop:5,fontWeight:700}}><span>Total</span><span>{fmt(o.total)}</span></div>
        </div>

        {o.status==="ready"&&!o.assignedDriverName&&<button className="btn btn-r" onClick={()=>pickup(o)} style={{width:"100%",padding:"14px",fontSize:14,fontWeight:700}}>{String.fromCharCode(0xD83D,0xDEF5)} Pick Up Order - Start Delivery</button>}
        
        {o.status==="ready"&&o.assignedDriverName&&<div style={{padding:"11px",background:"#ecfeff",borderRadius:9,textAlign:"center",border:"1px solid #0891b2"}}>
          <p style={{fontSize:12,color:"#0e7490",fontWeight:700}}>{String.fromCharCode(0x270B)} {o.assignedDriverName} claimed this - waiting for pickup</p>
        </div>}

        {o.status==="out_for_delivery"&&<div style={{padding:"12px",background:"#fff7ed",borderRadius:9,border:"2px dashed #f59e0b"}}>
          <p style={{fontSize:12,fontWeight:700,color:"#92400e",marginBottom:7,textAlign:"center"}}>{String.fromCharCode(0xD83D,0xDCCD)} At customer's door? Ask for delivery code</p>
          <div style={{display:"flex",gap:6}}>
            <input value={codeInput[o.id]||""} onChange={e=>setCodeInput(c=>({...c,[o.id]:e.target.value.replace(/[^0-9]/g,"").slice(0,4)}))} placeholder="0000" maxLength={4} style={{flex:1,padding:"14px",fontSize:24,fontWeight:700,textAlign:"center",letterSpacing:8,fontFamily:"'Courier New',monospace",border:"2px solid #f59e0b",borderRadius:8}}/>
            <button onClick={()=>verifyCode(o)} style={{padding:"14px 16px",background:"#059669",color:"#fff",border:"none",borderRadius:8,cursor:"pointer",fontWeight:700,fontSize:13}}>{EM.check} Verify</button>
          </div>
        </div>}

        {needsCashStep&&<div style={{padding:"12px",background:"#fef3c7",borderRadius:9,border:"2px solid #f59e0b",marginTop:8}}>
          <p style={{fontSize:13,fontWeight:700,color:"#92400e",marginBottom:7,textAlign:"center"}}>{EM.pound} COLLECT {fmt(o.total)} CASH</p>
          <div style={{display:"flex",gap:6}}>
            <input type="number" step="0.01" value={collectInput[o.id]||o.total||""} onChange={e=>setCollectInput(c=>({...c,[o.id]:e.target.value}))} placeholder="0.00" style={{flex:1,padding:"11px",fontSize:16,fontWeight:700,textAlign:"center",border:"2px solid #f59e0b",borderRadius:8}}/>
            <button onClick={()=>collectCash(o)} style={{padding:"11px 14px",background:"#059669",color:"#fff",border:"none",borderRadius:8,cursor:"pointer",fontWeight:700,fontSize:13}}>{EM.check} Confirm Cash</button>
          </div>
        </div>}
      </div>;
    })}

    {todayDelivered.length>0&&<div className="card" style={{padding:14,marginTop:14,background:"#f0fdf4"}}>
      <p style={{fontWeight:700,fontSize:14,marginBottom:8,color:"#065f46"}}>{EM.check} Delivered Today: {todayDelivered.length}</p>
      <p style={{fontSize:11,color:"#065f46"}}>Cash collected (not yet handed over): {fmt(cashOwed)}</p>
      {cashOwed>0&&<p style={{fontSize:11,color:"#92400e",marginTop:6,fontWeight:700}}>{EM.star} Hand cash to manager - they will mark received in Admin tab</p>}
    </div>}
  </div>;
}

function IncomingOrdersV({orders,setOrders,push,branch,customers,tables,setTables,stations,menu}){
  var [filter,setFilter]=useState("new");
  var [soundOn,setSoundOn]=useState(()=>{
    try{return localStorage.getItem("latavola_sound")!=="0";}catch(e){return true;}
  });
  var seenOrderIdsRef=useRef(new Set());
  var initialLoadRef=useRef(true);
  var audioRef=useRef(null);
  var origTitleRef=useRef(typeof document!=="undefined"?document.title:"La Tavola");

  // Only show orders from online/QR sources that need attention
  var relevant=orders.filter(o=>{
    if(branch&&o.branchId&&o.branchId!==branch.id)return false;
    if(o.source==="staff"||o.source==="phone")return false;
    return true;
  });
  var newOrders=relevant.filter(o=>o.status==="pending");
  var accepted=relevant.filter(o=>["preparing","ready"].includes(o.status));
  var completed=relevant.filter(o=>["delivered","collected"].includes(o.status));
  var rejected=relevant.filter(o=>o.status==="cancelled");

  var list=filter==="new"?newOrders:filter==="accepted"?accepted:filter==="completed"?completed:rejected;

  // Play chime sound
  var playDing=useCallback(()=>{
    if(!soundOn)return;
    try{
      // Use Web Audio API to generate a "ding" chime (no file needed)
      var AudioCtx=window.AudioContext||window.webkitAudioContext;
      if(!AudioCtx)return;
      var ctx=new AudioCtx();
      var osc=ctx.createOscillator();
      var gain=ctx.createGain();
      osc.connect(gain);gain.connect(ctx.destination);
      osc.type="sine";
      osc.frequency.setValueAtTime(880,ctx.currentTime); // High A note
      osc.frequency.exponentialRampToValueAtTime(660,ctx.currentTime+0.15);
      gain.gain.setValueAtTime(0.35,ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.01,ctx.currentTime+0.4);
      osc.start(ctx.currentTime);
      osc.stop(ctx.currentTime+0.4);
      // Second note for "ding-dong" effect
      setTimeout(()=>{
        var osc2=ctx.createOscillator();
        var gain2=ctx.createGain();
        osc2.connect(gain2);gain2.connect(ctx.destination);
        osc2.type="sine";
        osc2.frequency.setValueAtTime(1100,ctx.currentTime);
        gain2.gain.setValueAtTime(0.3,ctx.currentTime);
        gain2.gain.exponentialRampToValueAtTime(0.01,ctx.currentTime+0.5);
        osc2.start(ctx.currentTime);
        osc2.stop(ctx.currentTime+0.5);
      },180);
    }catch(e){console.log("Sound failed:",e);}
  },[soundOn]);

  // Show browser notification
  var showBrowserNotif=useCallback((order)=>{
    if(typeof window==="undefined"||!("Notification" in window))return;
    if(Notification.permission!=="granted")return;
    try{
      var body=order.customer+" - "+fmt(order.total)+" - "+(order.type||"order");
      var notif=new Notification(String.fromCharCode(0xD83C,0xDF7D)+" New Order - La Tavola",{
        body:body,
        icon:"/icon-192.png",
        badge:"/icon-192.png",
        tag:"order-"+order.id,
        requireInteraction:false,
      });
      notif.onclick=function(){
        window.focus();
        this.close();
      };
      setTimeout(()=>notif.close(),8000);
    }catch(e){console.log("Notif failed:",e);}
  },[]);

  // Detect genuinely new orders (by ID, not just count) and trigger alerts
  useEffect(()=>{
    // On first load, mark all current new orders as "already seen" - don't alert
    if(initialLoadRef.current){
      newOrders.forEach(o=>seenOrderIdsRef.current.add(o.id));
      initialLoadRef.current=false;
      return;
    }
    // Check for any order IDs we haven't seen before
    var trulyNewOrders=newOrders.filter(o=>!seenOrderIdsRef.current.has(o.id));
    if(trulyNewOrders.length>0){
      var latest=trulyNewOrders[0];
      playDing();
      showBrowserNotif(latest);
      // Mark these orders as seen
      trulyNewOrders.forEach(o=>seenOrderIdsRef.current.add(o.id));
      // Flash tab title
      if(typeof document!=="undefined"){
        var titleFlash=setInterval(()=>{
          document.title=document.title===origTitleRef.current?
            String.fromCharCode(0xD83D,0xDD14)+" ("+newOrders.length+") New Orders - La Tavola":origTitleRef.current;
        },1000);
        setTimeout(()=>{
          clearInterval(titleFlash);
          document.title=origTitleRef.current;
        },10000);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[newOrders.length,newOrders.map(o=>o.id).join(",")]);

  // Auto-refresh - reload orders from DB every 10 seconds
  useEffect(()=>{
    var interval=setInterval(()=>{
      fetchOrders().then(dbOrders=>{
        if(dbOrders&&dbOrders.length){
          var formatted=dbOrders.map(o=>({
            id:o.order_number,branchId:o.branch_id,userId:o.customer_id,
            customer:o.customer_name||"Guest",phone:o.customer_phone,
            items:o.items||[],subtotal:parseFloat(o.subtotal||0),
            deliveryFee:parseFloat(o.delivery_fee||0),total:parseFloat(o.total||0),
            status:o.status,type:o.type,paid:o.paid,payMethod:o.pay_method,
            address:o.address,slot:o.slot,takenBy:o.taken_by,source:o.source,
            tableId:o.table_id,stationProgress:o.station_progress||{},deliveryCode:o.delivery_code,codeMethod:o.code_method,deliveredAt:o.delivered_at,deliveredBy:o.delivered_by,cashCollected:o.cash_collected?parseFloat(o.cash_collected):null,cashHandoverId:o.cash_handover_id,serviceCharge:parseFloat(o.service_charge||0),discount:parseFloat(o.discount||0),
            assignedDriverId:o.assigned_driver_id,assignedDriverName:o.assigned_driver_name,claimedAt:o.claimed_at,handoverId:o.handover_id,
            created_at:o.created_at,
            time:new Date(o.created_at).toLocaleTimeString("en-GB",{hour:"2-digit",minute:"2-digit"}),
          }));
          setOrders(formatted);
        }
      }).catch(e=>console.log("Auto-refresh failed:",e));
    },10000); // 10 seconds
    return()=>clearInterval(interval);
  },[setOrders]);

  // Request notification permission on mount
  useEffect(()=>{
    if(typeof window!=="undefined"&&"Notification" in window){
      if(Notification.permission==="default"){
        Notification.requestPermission();
      }
    }
  },[]);

  var toggleSound=()=>{
    var newVal=!soundOn;
    setSoundOn(newVal);
    try{localStorage.setItem("latavola_sound",newVal?"1":"0");}catch(e){}
    if(newVal)playDing(); // Test sound when enabling
  };

  var getRiskInfo=(o)=>{
    var flags=[];
    var customer=customers?.find(c=>c.phone===o.phone);
    if(!customer||!customer.total_orders||customer.total_orders===0)flags.push("first_time");
    if(o.total>=50)flags.push("high_value");
    if(!o.paid)flags.push("unpaid");
    return flags;
  };

  var accept=o=>{
    setOrders(os=>os.map(x=>x.id===o.id?{...x,status:"preparing"}:x));
    push({title:"Order accepted",body:o.id+" - sent to kitchen",color:"#059669"});
    dbUpdateOrderStatus(o.id,"preparing").catch(e=>console.log("Status save failed:",e));
    // Auto-occupy table for QR/eat-in orders
    if(o.tableId&&tables&&setTables){
      var tbl=tables.find(t=>(t.id===o.tableId||t.id===+o.tableId||+t.id===+o.tableId)&&(!branch||!t.branchId||t.branchId===branch.id));
      if(tbl){
        setTables(ts=>ts.map(x=>x===tbl?{...x,status:"occupied",since:nowT(),guests:x.guests||1,orderId:o.id}:x));
        if(tbl.dbId){
          dbUpdateTableStatus(tbl.dbId,"occupied",{}).catch(e=>console.log("Table save failed:",e));
        }
      }
    }
    // Auto-print to stations that have it enabled
    if(stations&&menu){
      // Determine which stations have items in this order
      var stationsInOrder=new Set();
      (o.items||[]).forEach(it=>{
        var m=menu.find(x=>String(x.id)===String(it.id)||x.name===it.name);
        if(m&&m.station)stationsInOrder.add(m.station);
      });
      stations.forEach(s=>{
        if(s.autoPrint&&s.printerMethod&&s.printerMethod!=="none"&&stationsInOrder.has(s.name)){
          // Annotate items with their station for filtering inside ticket
          var enrichedOrder={...o,items:(o.items||[]).map(it=>{
            var m=menu.find(x=>String(x.id)===String(it.id)||x.name===it.name);
            return {...it,station:m?.station||null};
          })};
          setTimeout(()=>dispatchPrint(enrichedOrder,s,branch),300*Array.from(stationsInOrder).indexOf(s.name));
        }
      });
    }
  };
  var reject=o=>{
    var reason=prompt("Why are you rejecting this order? (optional)");
    setOrders(os=>os.map(x=>x.id===o.id?{...x,status:"cancelled",rejectReason:reason||"Restaurant unable to fulfill"}:x));
    push({title:"Order rejected",body:o.id,color:"#dc2626"});
    dbUpdateOrderStatus(o.id,"cancelled").catch(e=>console.log("Status save failed:",e));
  };
  var callCust=o=>{
    if(o.phone)window.location.href="tel:"+o.phone;
    else alert("No phone number on this order");
  };

  return <div className="page">
    <audio ref={audioRef} preload="auto"/>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:8}}>
      <div>
        <h2 style={{fontSize:22,marginBottom:2}}>Incoming Orders</h2>
        <p style={{color:"#8a8078",fontSize:12}}>Online + QR code orders - {branch?.name} - auto-refreshes every 10 sec</p>
      </div>
      <div style={{display:"flex",gap:8,alignItems:"center"}}>
        <button onClick={toggleSound} title={soundOn?"Sound on - click to mute":"Sound off - click to enable"} style={{padding:"8px 12px",fontSize:18,background:soundOn?"#d1fae5":"#f5f5f5",color:soundOn?"#065f46":"#999",border:"2px solid "+(soundOn?"#059669":"#ddd"),borderRadius:8,cursor:"pointer",fontWeight:700}}>{soundOn?String.fromCharCode(0xD83D,0xDD0A):String.fromCharCode(0xD83D,0xDD07)}</button>
        {newOrders.length>0&&<div style={{padding:"8px 14px",background:"#dc2626",color:"#fff",borderRadius:20,fontSize:13,fontWeight:700,animation:"pulse 1s infinite",boxShadow:"0 0 20px rgba(220,38,38,.5)"}}>{newOrders.length} NEW!</div>}
      </div>
    </div>

    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:14}}>
      {[["New",newOrders.length,"#dc2626"],["Accepted",accepted.length,"#2563eb"],["Completed",completed.length,"#059669"],["Rejected",rejected.length,"#8a8078"]].map(([l,v,c])=><div key={l} style={{background:"#fff",borderRadius:11,padding:"10px 8px",border:(l==="New"&&v>0)?"2px solid "+c:"1px solid #ede8de",textAlign:"center",animation:(l==="New"&&v>0)?"flashPulse 1.5s infinite":"none"}}><div style={{fontSize:22,fontWeight:700,color:c}}>{v}</div><div style={{fontSize:10,color:"#8a8078",fontWeight:600}}>{l}</div></div>)}
    </div>

    <div style={{display:"flex",gap:6,marginBottom:14,flexWrap:"wrap"}}>
      {[["new","New"],["accepted","Preparing"],["completed","Done"],["rejected","Rejected"]].map(([k,l])=><button key={k} onClick={()=>setFilter(k)} style={{padding:"8px 14px",fontSize:12,fontWeight:700,background:filter===k?"#bf4626":"#fff",color:filter===k?"#fff":"#1a1208",border:"2px solid "+(filter===k?"#bf4626":"#ede8de"),borderRadius:8,cursor:"pointer"}}>{l}</button>)}
    </div>

    {list.length===0?<div className="card" style={{textAlign:"center",padding:30}}>
      <p style={{fontSize:40,marginBottom:10}}>{EM.bag}</p>
      <p style={{fontSize:14,color:"#8a8078"}}>No {filter} orders</p>
    </div>:list.map(o=>{
      var risk=getRiskInfo(o);
      var isHighRisk=risk.length>=2;
      var isNew=o.status==="pending";
      var typeLabel=o.source==="qr-table"?"QR Eat-In Table "+(o.tableId||"?"):o.type==="delivery"?"Delivery":o.type==="collection"?"Collection "+(o.slot||""):o.type;
      return <div key={o.id} className="card" style={{
        marginBottom:10,
        padding:"12px 14px",
        borderLeft:"4px solid "+(isHighRisk?"#dc2626":o.status==="preparing"?"#2563eb":o.status==="cancelled"?"#8a8078":"#d4952a"),
        animation:isNew?"flashPulse 1.8s infinite":"none",
        boxShadow:isNew?"0 0 0 2px #dc2626":"0 1px 3px rgba(0,0,0,.05)",
      }}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8,flexWrap:"wrap",gap:6}}>
          <div style={{flex:1,minWidth:0}}>
            <div style={{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap",marginBottom:3}}>
              {isNew&&<span style={{padding:"2px 8px",background:"#dc2626",color:"#fff",borderRadius:5,fontSize:10,fontWeight:700,animation:"pulse 1s infinite"}}>NEW</span>}
              <p style={{fontWeight:700,fontSize:15}}>{o.customer||"Guest"}</p>
              <span style={{padding:"2px 7px",background:"#f5f0ff",color:"#7c3aed",borderRadius:5,fontSize:10,fontWeight:700}}>{typeLabel}</span>
              {o.paid?<span style={{padding:"2px 7px",background:"#d1fae5",color:"#065f46",borderRadius:5,fontSize:10,fontWeight:700}}>PAID {o.payMethod||""}</span>:o.payMethod==="cod"?<span style={{padding:"2px 7px",background:"#fde68a",color:"#92400e",borderRadius:5,fontSize:10,fontWeight:700}}>{EM.pound} CASH ON DELIVERY</span>:o.payMethod==="cash-at-counter"?<span style={{padding:"2px 7px",background:"#fef3c7",color:"#92400e",borderRadius:5,fontSize:10,fontWeight:700}}>CASH AT COUNTER</span>:<span style={{padding:"2px 7px",background:"#fef3c7",color:"#92400e",borderRadius:5,fontSize:10,fontWeight:700}}>UNPAID</span>}
            </div>
            <p style={{fontSize:11,color:"#8a8078"}}>{o.id} - {o.time} - {fmt(o.total)}</p>
            {o.phone&&<p style={{fontSize:11,color:"#8a8078"}}>{EM.phone} {o.phone}</p>}
            {o.address&&<p style={{fontSize:11,color:"#8a8078"}}>{EM.pin} {typeof o.address==="string"?o.address:o.address.line1||""}</p>}
          </div>
        </div>

        {risk.length>0&&o.status==="pending"&&<div style={{padding:"7px 10px",background:isHighRisk?"#fee2e2":"#fffbeb",borderRadius:7,marginBottom:8,fontSize:11,color:isHighRisk?"#991b1b":"#92400e"}}>
          <strong>{isHighRisk?EM.cross+" High Risk":EM.star+" Check this"}:</strong>
          {risk.includes("first_time")&&" First-time customer."}
          {risk.includes("high_value")&&" High-value order ("+fmt(o.total)+")."}
          {risk.includes("unpaid")&&" Payment not collected yet."}
        </div>}

        <div style={{background:"#fafaf5",borderRadius:6,padding:"7px 10px",marginBottom:8,fontSize:11}}>
          {(o.items||[]).map((it,i)=><div key={i} style={{display:"flex",justifyContent:"space-between"}}><span>{it.name} x{it.qty}</span><span>{fmt((+it.price||0)*it.qty)}</span></div>)}
        </div>

        {o.status==="pending"&&<div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
          <button className="btn btn-r" onClick={()=>accept(o)} style={{flex:2,padding:"10px",fontSize:13,minWidth:160}}>{EM.check} Accept & Send to Kitchen</button>
          {o.phone&&<button onClick={()=>callCust(o)} style={{flex:1,padding:"10px",fontSize:12,background:"#2563eb",color:"#fff",border:"none",borderRadius:8,cursor:"pointer",fontWeight:700,minWidth:80}}>{EM.phone} Call</button>}
          <button onClick={()=>reject(o)} style={{flex:1,padding:"10px",fontSize:12,background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:8,cursor:"pointer",fontWeight:700,minWidth:80}}>Reject</button>
          {stations&&stations.some(s=>s.printerMethod&&s.printerMethod!=="none")&&<button onClick={()=>{
            var enriched={...o,items:(o.items||[]).map(it=>{var m=menu?.find(x=>String(x.id)===String(it.id)||x.name===it.name);return{...it,station:m?.station||null};})};
            stations.filter(s=>s.printerMethod&&s.printerMethod!=="none").forEach((s,i)=>setTimeout(()=>dispatchPrint(enriched,s,branch),i*400));
          }} title="Manually print to all stations" style={{padding:"10px 12px",fontSize:11,background:"#1a1208",color:"#fff",border:"none",borderRadius:8,cursor:"pointer",fontWeight:700}}>{EM.cart} Print</button>}
        </div>}
        {o.status==="preparing"&&<div style={{display:"flex",gap:6}}>
          <button className="btn btn-p" onClick={()=>{
            setOrders(os=>os.map(x=>x.id===o.id?{...x,status:"ready"}:x));
            dbUpdateOrderStatus(o.id,"ready").catch(e=>console.log("Status save failed:",e));
          }} style={{flex:1,padding:"9px",fontSize:12}}>Mark Ready</button>
          {/* Collection orders: counter staff marks Collected. Delivery: only the driver. */}
          {o.type!=="delivery"&&<button className="btn btn-d" onClick={()=>{
            var isCOD=!o.paid;
            if(isCOD){
              if(!window.confirm("Customer collecting - did they pay "+fmt(o.total)+"?\n\nOK = Yes, paid\nCancel = Not paid yet"))return;
              setOrders(os=>os.map(x=>x.id===o.id?{...x,status:"collected",paid:true,payMethod:"cash"}:x));
              push({title:"Order collected",body:o.id+" - "+fmt(o.total),color:"#059669"});
              dbUpdateOrderPayment(o.id,true,"cash").catch(e=>console.log("Save failed:",e));
              dbUpdateOrderStatus(o.id,"collected").catch(e=>console.log("Status save failed:",e));
            }else{
              setOrders(os=>os.map(x=>x.id===o.id?{...x,status:"collected"}:x));
              dbUpdateOrderStatus(o.id,"collected").catch(e=>console.log("Status save failed:",e));
            }
          }} style={{flex:1,padding:"9px",fontSize:12}}>{String.fromCharCode(0x2705)} Mark Collected</button>}
        </div>}
        {/* Delivery order that's ready - waiting for a driver */}
        {o.status==="ready"&&o.type==="delivery"&&<div style={{padding:"9px 11px",background:"#dbeafe",borderRadius:8,fontSize:12,color:"#1e40af",fontWeight:700,textAlign:"center"}}>
          {String.fromCharCode(0xD83D,0xDEF5)} Ready - driver will collect & deliver
        </div>}
        {/* Collection order that's ready - waiting for customer */}
        {o.status==="ready"&&o.type!=="delivery"&&<div style={{display:"flex",gap:6}}>
          <button className="btn btn-d" onClick={()=>{
            var isCOD=!o.paid;
            if(isCOD){
              if(!window.confirm("Customer collecting - did they pay "+fmt(o.total)+"?\n\nOK = Yes, paid\nCancel = Not paid yet"))return;
              setOrders(os=>os.map(x=>x.id===o.id?{...x,status:"collected",paid:true,payMethod:"cash"}:x));
              push({title:"Order collected",body:o.id+" - "+fmt(o.total),color:"#059669"});
              dbUpdateOrderPayment(o.id,true,"cash").catch(e=>console.log("Save failed:",e));
              dbUpdateOrderStatus(o.id,"collected").catch(e=>console.log("Status save failed:",e));
            }else{
              setOrders(os=>os.map(x=>x.id===o.id?{...x,status:"collected"}:x));
              dbUpdateOrderStatus(o.id,"collected").catch(e=>console.log("Status save failed:",e));
            }
          }} style={{flex:1,padding:"10px",fontSize:13}}>{String.fromCharCode(0x2705)} Customer Collected - Mark Done</button>
        </div>}
      </div>;
    })}
  </div>;
}

// POS UI router - dispatches to correct UI based on user preference
// ============================================================
// CASH DRAWER ALERT - shows when drawer should open
// ============================================================
function DrawerOpenAlert({onClose,cashGiven,changeReturn,total}){
  // Play beep sound on mount
  useEffect(()=>{
    try{
      var AudioCtx=window.AudioContext||window.webkitAudioContext;
      if(!AudioCtx)return;
      var ctx=new AudioCtx();
      [0,0.15,0.3].forEach(delay=>{
        var osc=ctx.createOscillator();
        var gain=ctx.createGain();
        osc.connect(gain);gain.connect(ctx.destination);
        osc.frequency.value=880;
        osc.type="sine";
        gain.gain.setValueAtTime(0,ctx.currentTime+delay);
        gain.gain.linearRampToValueAtTime(0.3,ctx.currentTime+delay+0.02);
        gain.gain.linearRampToValueAtTime(0,ctx.currentTime+delay+0.12);
        osc.start(ctx.currentTime+delay);
        osc.stop(ctx.currentTime+delay+0.13);
      });
    }catch(e){}
  },[]);

  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.95)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
    <div style={{background:"linear-gradient(135deg,#059669,#047857)",color:"#fff",borderRadius:18,padding:"36px 30px",maxWidth:500,width:"100%",textAlign:"center",boxShadow:"0 30px 80px rgba(5,150,105,.5)",border:"5px solid #fff",animation:"shake .5s"}}>
      <style>{`@keyframes shake{0%,100%{transform:translateX(0)}25%{transform:translateX(-8px)}75%{transform:translateX(8px)}}@keyframes pulseBig{0%,100%{transform:scale(1)}50%{transform:scale(1.05)}}`}</style>
      <p style={{fontSize:64,marginBottom:5,animation:"pulseBig 1s ease-in-out infinite"}}>{String.fromCharCode(0xD83D,0xDCB5)}</p>
      <h2 style={{fontSize:32,fontWeight:700,marginBottom:14,letterSpacing:2}}>OPEN DRAWER NOW</h2>
      
      <div style={{background:"rgba(0,0,0,.2)",borderRadius:12,padding:"18px",marginBottom:16}}>
        <p style={{fontSize:13,opacity:.85,fontWeight:700,letterSpacing:2,marginBottom:6}}>CUSTOMER GAVE</p>
        <p style={{fontSize:38,fontWeight:700,fontFamily:"'Courier New',monospace"}}>{fmt(cashGiven)}</p>
      </div>
      
      {changeReturn>0&&<div style={{background:"#fff",color:"#1a1208",borderRadius:12,padding:"22px 18px",marginBottom:16,border:"3px solid #d4952a"}}>
        <p style={{fontSize:13,color:"#bf4626",fontWeight:700,letterSpacing:2,marginBottom:6}}>RETURN CHANGE</p>
        <p style={{fontSize:54,fontWeight:700,color:"#bf4626",fontFamily:"'Courier New',monospace",lineHeight:1}}>{fmt(changeReturn)}</p>
      </div>}
      
      {changeReturn===0&&<div style={{padding:"14px",background:"rgba(255,255,255,.2)",borderRadius:9,marginBottom:16}}>
        <p style={{fontSize:18,fontWeight:700}}>Exact amount - No change</p>
      </div>}
      
      <p style={{fontSize:13,opacity:.85,marginBottom:16}}>Place {fmt(total)} in drawer{changeReturn>0?", give "+fmt(changeReturn)+" change":""}</p>
      
      <button onClick={onClose} style={{padding:"18px 36px",background:"#fff",color:"#059669",border:"none",borderRadius:12,fontSize:18,fontWeight:700,cursor:"pointer",width:"100%",boxShadow:"0 6px 18px rgba(0,0,0,.25)",letterSpacing:1}}>{EM.check} DONE - Close Drawer</button>
    </div>
  </div>;
}

// ============================================================
// NUMBER PAD - calculator-style for amount entry
// ============================================================
function NumberPad({value,onChange,onSubmit}){
  var press=k=>{
    if(k==="DEL"){
      onChange(String(value).slice(0,-1));
    }else if(k==="CLR"){
      onChange("");
    }else if(k==="."){
      if(!String(value).includes("."))onChange(String(value)+".");
    }else if(k==="OK"){
      if(onSubmit)onSubmit();
    }else{
      onChange(String(value)+k);
    }
  };
  var btnStyle=(special)=>({
    height:60,fontSize:24,fontWeight:700,
    background:special==="del"?"linear-gradient(180deg,#fbbf24,#d97706)":
              special==="clr"?"linear-gradient(180deg,#dc2626,#991b1b)":
              special==="ok"?"linear-gradient(180deg,#059669,#047857)":
              "linear-gradient(180deg,#fff,#f5f0e8)",
    color:special?"#fff":"#1a1208",
    border:"1px solid "+(special?"transparent":"#d4b896"),
    borderRadius:9,cursor:"pointer",
    boxShadow:"0 2px 0 rgba(0,0,0,.15), inset 0 1px 0 rgba(255,255,255,.5)",
  });
  var pressDown=e=>{e.currentTarget.style.transform="translateY(2px)";};
  var pressUp=e=>{e.currentTarget.style.transform="translateY(0)";};

  return <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:5}}>
    {[
      ["1","2","3","DEL"],
      ["4","5","6","CLR"],
      ["7","8","9","."],
      ["00","0","OK"]
    ].flat().map((k,i)=>{
      if(k==="OK")return <button key={i} onClick={()=>press(k)} onMouseDown={pressDown} onMouseUp={pressUp} onMouseLeave={pressUp} onTouchStart={pressDown} onTouchEnd={pressUp} style={{...btnStyle("ok"),gridColumn:"span 2"}}>{String.fromCharCode(0x2713)} OK</button>;
      var sp=k==="DEL"?"del":k==="CLR"?"clr":null;
      return <button key={i} onClick={()=>press(k)} onMouseDown={pressDown} onMouseUp={pressUp} onMouseLeave={pressUp} onTouchStart={pressDown} onTouchEnd={pressUp} style={btnStyle(sp)}>{k==="DEL"?String.fromCharCode(0x232B):k}</button>;
    })}
  </div>;
}

// ============================================================
// PAYMENT FLOW - LEDGER STYLE
// Multiple payments allowed (5 customers, mixed cash/card)
// ============================================================
function PaymentFlow({total,cart,onComplete,onCancel,branch,user,orderId,allowItemSplit}){
  var [payments,setPayments]=useState([]); // [{id, method, amount, cashGiven, change, items}]
  var [tipAmount,setTipAmount]=useState(0);
  var [showAddPayment,setShowAddPayment]=useState(null); // null, "cash", "card"
  var [showDrawer,setShowDrawer]=useState(null);
  var [itemSplitMode,setItemSplitMode]=useState(false);
  var [customerCount,setCustomerCount]=useState(0);
  var [customerItems,setCustomerItems]=useState({});
  var [activeCustomer,setActiveCustomer]=useState(1);
  var [payingCustomer,setPayingCustomer]=useState(0);
  var [customerPayments,setCustomerPayments]=useState({});
  // Voucher state
  var [showVoucherInput,setShowVoucherInput]=useState(false);
  var [voucherCodeInput,setVoucherCodeInput]=useState("");
  var [voucherError,setVoucherError]=useState("");
  var [voucherChecking,setVoucherChecking]=useState(false);
  var [appliedVoucher,setAppliedVoucher]=useState(null); // {code, amount, dbId}
  
  // Calculations
  var voucherDiscount=appliedVoucher?Math.min(parseFloat(appliedVoucher.amount||0),total+tipAmount):0;
  var totalWithTip=Math.max(0,(total+tipAmount)-voucherDiscount);
  var paidSoFar=payments.reduce((s,p)=>s+(parseFloat(p.amount)||0),0);
  var remaining=Math.max(0,totalWithTip-paidSoFar);
  var isComplete=Math.abs(remaining)<0.01;

  // VOUCHER APPLY - look up code in DB
  var applyVoucher=()=>{
    var code=voucherCodeInput.trim().toUpperCase();
    if(!code){setVoucherError("Enter a code");return;}
    setVoucherChecking(true);
    setVoucherError("");
    dbFetchCodes().then(codes=>{
      setVoucherChecking(false);
      var found=(codes||[]).find(c=>(c.code||"").toUpperCase()===code);
      if(!found){setVoucherError("Code not found");return;}
      if(!found.active){setVoucherError("This code is no longer active");return;}
      // Check expiry
      if(found.expiresAt){
        var exp=new Date(found.expiresAt);
        if(exp<new Date()){setVoucherError("This voucher expired on "+exp.toLocaleDateString("en-GB"));return;}
      }
      // Check usage limit
      if(found.maxUses&&found.uses>=found.maxUses){setVoucherError("This voucher has already been used");return;}
      // Check if there are already payments - voucher applied first
      if(payments.length>0){setVoucherError("Remove existing payments first to apply voucher");return;}
      // Apply!
      var voucherValue=found.type==="fixed"?parseFloat(found.value):(parseFloat(found.value)/100*total);
      setAppliedVoucher({code:code,amount:voucherValue,dbId:found.dbId,uses:found.uses||0,maxUses:found.maxUses||1});
      setShowVoucherInput(false);
      setVoucherCodeInput("");
      setVoucherError("");
    }).catch(e=>{
      setVoucherChecking(false);
      setVoucherError("Error checking voucher: "+e.message);
    });
  };
  
  var removeVoucher=()=>{
    if(!window.confirm("Remove voucher? You can apply it again later."))return;
    setAppliedVoucher(null);
  };

  var addPayment=(p)=>{
    setPayments(prev=>[...prev,{...p,id:Date.now()+Math.random()}]);
    setShowAddPayment(null);
    if(p.method==="cash"&&p.cashGiven&&p.change>0){
      // Show drawer alert briefly
      setShowDrawer({cashGiven:p.cashGiven,changeReturn:p.change,total:p.amount});
    }else if(p.method==="cash"){
      // Exact cash - still open drawer
      setShowDrawer({cashGiven:p.amount,changeReturn:0,total:p.amount});
    }
  };

  var removePayment=(id)=>{
    if(!window.confirm("Remove this payment?"))return;
    setPayments(prev=>prev.filter(p=>p.id!==id));
  };

  var completePayment=()=>{
    // Save payments to DB
    payments.forEach(p=>{
      if(orderId){
        dbRecordPayment({
          order_id:orderId,branch_id:branch?.id,
          payment_method:p.method,amount:p.amount,
          cash_given:p.cashGiven||null,change_returned:p.change||null,
          tip_amount:p===payments[payments.length-1]?tipAmount:0,
          taken_by:user?.name,
        }).catch(e=>console.log("Payment save fail:",e));
      }
    });
    
    // Mark voucher as used (increment uses, deactivate if max reached)
    if(appliedVoucher&&appliedVoucher.dbId){
      var newUses=(appliedVoucher.uses||0)+1;
      dbSaveCode({
        dbId:appliedVoucher.dbId,
        code:appliedVoucher.code,
        type:"fixed",
        value:appliedVoucher.amount,
        uses:newUses,
        maxUses:appliedVoucher.maxUses,
        active:newUses<appliedVoucher.maxUses,
      }).catch(e=>console.log("Voucher mark used fail:",e));
    }
    
    var totalCash=payments.filter(p=>p.method==="cash").reduce((s,p)=>s+p.amount,0);
    var totalCard=payments.filter(p=>p.method==="card").reduce((s,p)=>s+p.amount,0);
    
    // Update shift sales if shift is open
    var shiftsOn=(()=>{try{return localStorage.getItem("shifts_enabled")==="1";}catch(e){return false;}})();
    if(shiftsOn&&user&&branch){
      dbFetchOpenShift(branch.id,user.name).then(s=>{
        if(s)dbUpdateShiftSales(s.id,totalCash,totalCard,tipAmount).catch(e=>console.log("Shift update fail:",e));
      }).catch(e=>{});
    }
    
    onComplete({
      method:payments.length===1?payments[0].method:"split",
      total:totalWithTip,
      tip:tipAmount,
      payments:payments,
      totalCash,
      totalCard,
      // Voucher info
      voucher:appliedVoucher?{code:appliedVoucher.code,amount:voucherDiscount}:null,
      voucherDiscount:voucherDiscount,
      originalTotal:total+tipAmount,
      // For backward compat
      cashGiven:payments.filter(p=>p.method==="cash").reduce((s,p)=>s+(p.cashGiven||p.amount),0),
      changeReturn:payments.filter(p=>p.method==="cash").reduce((s,p)=>s+(p.change||0),0),
      cashPart:totalCash,
      cardPart:totalCard,
    });
  };

  if(showDrawer){
    return <DrawerOpenAlert {...showDrawer} onClose={()=>setShowDrawer(null)}/>;
  }

  if(showAddPayment){
    return <AddPaymentScreen
      mode={showAddPayment}
      remaining={remaining}
      onCancel={()=>setShowAddPayment(null)}
      onSave={(p)=>addPayment(p)}
    />;
  }

  // ITEM SPLIT MODE
  if(itemSplitMode){
    // Step 1: Choose customer count
    if(customerCount===0){
      return <ItemSplitCustomerCount
        onCancel={()=>{setItemSplitMode(false);}}
        onContinue={(n)=>{
          setCustomerCount(n);
          // Initialize empty assignments
          var init={shared:[]};
          for(var i=1;i<=n;i++)init[i]=[];
          setCustomerItems(init);
        }}
      />;
    }
    // Step 2: Assign items to customers
    if(payingCustomer===0){
      return <ItemSplitAssign
        cart={cart}
        customerCount={customerCount}
        customerItems={customerItems}
        setCustomerItems={setCustomerItems}
        activeCustomer={activeCustomer}
        setActiveCustomer={setActiveCustomer}
        onCancel={()=>{setItemSplitMode(false);setCustomerCount(0);}}
        onContinue={()=>setPayingCustomer(1)}
      />;
    }
    // Step 3: Pay each customer one by one
    if(payingCustomer<=customerCount){
      return <ItemSplitPayCustomer
        customerNum={payingCustomer}
        totalCustomers={customerCount}
        cart={cart}
        customerItems={customerItems}
        branch={branch}
        user={user}
        orderId={orderId}
        onPaid={(custPayment)=>{
          var allCustPayments={...customerPayments,[payingCustomer]:custPayment};
          setCustomerPayments(allCustPayments);
          // Show drawer for cash
          if(custPayment.method==="cash"&&custPayment.change>=0){
            setShowDrawer({cashGiven:custPayment.cashGiven,changeReturn:custPayment.change,total:custPayment.amount});
          }
          // Move to next customer
          setPayingCustomer(payingCustomer+1);
        }}
        onCancel={()=>{
          if(window.confirm("Cancel item split? Already collected payments will be lost."))
          {setItemSplitMode(false);setCustomerCount(0);setPayingCustomer(0);setCustomerPayments({});}
        }}
      />;
    }
    // Step 4: All customers paid - summary and complete
    return <ItemSplitComplete
      customerCount={customerCount}
      customerPayments={customerPayments}
      cart={cart}
      customerItems={customerItems}
      branch={branch}
      onCancel={()=>{
        if(window.confirm("Cancel? All payments will be lost."))
        {setItemSplitMode(false);setCustomerCount(0);setPayingCustomer(0);setCustomerPayments({});}
      }}
      onComplete={()=>{
        // Build payments array from customerPayments
        var allPayments=[];
        Object.keys(customerPayments).forEach(custNum=>{
          var p=customerPayments[custNum];
          allPayments.push({
            id:Date.now()+Math.random(),
            method:p.method,amount:p.amount,
            cashGiven:p.cashGiven,change:p.change,
            customerNum:parseInt(custNum),
            items:customerItems[custNum]||[],
          });
        });
        var totalCash=allPayments.filter(p=>p.method==="cash").reduce((s,p)=>s+p.amount,0);
        var totalCard=allPayments.filter(p=>p.method==="card").reduce((s,p)=>s+p.amount,0);
        // Save each payment to DB
        allPayments.forEach(p=>{
          if(orderId){
            dbRecordPayment({
              order_id:orderId,branch_id:branch?.id,
              payment_method:p.method,amount:p.amount,
              cash_given:p.cashGiven||null,change_returned:p.change||null,
              taken_by:user?.name,
            }).catch(e=>console.log("Payment save fail:",e));
          }
        });
        onComplete({
          method:"item-split",
          total:total,tip:0,
          payments:allPayments,
          customerCount:customerCount,
          customerItems:customerItems,
          customerPayments:customerPayments,
          totalCash,totalCard,
          cashGiven:allPayments.filter(p=>p.method==="cash").reduce((s,p)=>s+(p.cashGiven||p.amount),0),
          changeReturn:allPayments.filter(p=>p.method==="cash").reduce((s,p)=>s+(p.change||0),0),
          cashPart:totalCash,
          cardPart:totalCard,
        });
      }}
    />;
  }

  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",zIndex:9000,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
    <div style={{background:"#fafaf5",color:"#1a1208",borderRadius:14,maxWidth:560,width:"100%",maxHeight:"94vh",overflow:"hidden",display:"flex",flexDirection:"column",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
      
      {/* Header */}
      <div style={{background:"linear-gradient(135deg,#1a1208,#3d2e22)",color:"#fff",padding:"14px 18px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <p style={{fontSize:11,color:"#d4952a",fontWeight:700,letterSpacing:2}}>PAYMENT</p>
          <h2 style={{fontSize:18,fontWeight:700}}>Payment Ledger</h2>
        </div>
        <button onClick={onCancel} style={{width:36,height:36,borderRadius:"50%",background:"rgba(255,255,255,.15)",color:"#fff",border:"none",cursor:"pointer",fontSize:18,fontWeight:700}}>x</button>
      </div>

      <div style={{flex:1,overflowY:"auto",padding:14}}>
        
        {/* Total + Status display */}
        <div style={{textAlign:"center",marginBottom:12,padding:"14px",background:"#fff",borderRadius:11,border:"3px solid "+(isComplete?"#059669":"#d4952a")}}>
          {voucherDiscount>0&&<>
            <p style={{fontSize:10,color:"#8a8078",letterSpacing:1,marginBottom:1}}>Original: {fmt(total+tipAmount)}</p>
            <p style={{fontSize:11,color:"#7c3aed",fontWeight:700,marginBottom:5}}>Voucher: -{fmt(voucherDiscount)}</p>
          </>}
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:2,marginBottom:3}}>TOTAL DUE</p>
          <p style={{fontSize:36,fontWeight:700,color:"#bf4626",fontFamily:"'Courier New',monospace",lineHeight:1,marginBottom:9}}>{fmt(totalWithTip)}</p>
          
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,paddingTop:9,borderTop:"1px solid #ede8de"}}>
            <div>
              <p style={{fontSize:10,color:"#059669",fontWeight:700,letterSpacing:2}}>PAID SO FAR</p>
              <p style={{fontSize:22,fontWeight:700,color:"#059669",fontFamily:"'Courier New',monospace"}}>{fmt(paidSoFar)}</p>
            </div>
            <div>
              <p style={{fontSize:10,color:isComplete?"#059669":"#dc2626",fontWeight:700,letterSpacing:2}}>{isComplete?"COMPLETE":"REMAINING"}</p>
              <p style={{fontSize:22,fontWeight:700,color:isComplete?"#059669":"#dc2626",fontFamily:"'Courier New',monospace"}}>{isComplete?String.fromCharCode(0x2713):fmt(remaining)}</p>
            </div>
          </div>
        </div>

        {/* Voucher section */}
        {payments.length===0&&<div style={{marginBottom:11}}>
          {appliedVoucher?<div style={{padding:11,background:"#f5f3ff",borderRadius:9,border:"2px solid #7c3aed",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div>
              <p style={{fontSize:11,color:"#7c3aed",fontWeight:700,letterSpacing:2,marginBottom:2}}>{String.fromCharCode(0xD83C,0xDF81)} VOUCHER APPLIED</p>
              <p style={{fontSize:13,fontWeight:700,fontFamily:"'Courier New',monospace"}}>{appliedVoucher.code}</p>
              <p style={{fontSize:11,color:"#5b21b6"}}>Discount: -{fmt(voucherDiscount)}</p>
            </div>
            <button onClick={removeVoucher} style={{padding:"7px 11px",background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>Remove</button>
          </div>:!showVoucherInput?<button onClick={()=>setShowVoucherInput(true)} style={{width:"100%",padding:"11px",background:"#fff",border:"2px dashed #7c3aed",color:"#7c3aed",borderRadius:9,fontSize:12,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0xD83C,0xDF81)} Have a voucher? Apply code</button>:<div style={{padding:11,background:"#fff",borderRadius:9,border:"2px solid #7c3aed"}}>
            <p style={{fontSize:11,color:"#7c3aed",fontWeight:700,letterSpacing:1,marginBottom:5}}>ENTER VOUCHER CODE</p>
            <div style={{display:"flex",gap:5,marginBottom:5}}>
              <input value={voucherCodeInput} onChange={e=>{setVoucherCodeInput(e.target.value.toUpperCase());setVoucherError("");}} placeholder="A4F8K2" autoFocus style={{flex:1,padding:"11px 14px",border:"2px solid #ede8de",borderRadius:7,fontSize:18,fontWeight:700,fontFamily:"'Courier New',monospace",letterSpacing:3,textAlign:"center",textTransform:"uppercase",boxSizing:"border-box"}}/>
              <button onClick={applyVoucher} disabled={voucherChecking||!voucherCodeInput} style={{padding:"11px 14px",background:voucherChecking||!voucherCodeInput?"#9ca3af":"linear-gradient(135deg,#7c3aed,#a855f7)",color:"#fff",border:"none",borderRadius:7,fontWeight:700,fontSize:12,cursor:voucherChecking||!voucherCodeInput?"not-allowed":"pointer"}}>{voucherChecking?"Checking...":"Apply"}</button>
            </div>
            {voucherError&&<p style={{fontSize:11,color:"#dc2626",fontWeight:700,marginTop:5}}>{String.fromCharCode(0x26A0,0xFE0F)} {voucherError}</p>}
            <button onClick={()=>{setShowVoucherInput(false);setVoucherError("");setVoucherCodeInput("");}} style={{marginTop:6,padding:"5px",background:"none",border:"none",color:"#8a8078",fontSize:11,cursor:"pointer",textDecoration:"underline"}}>Cancel</button>
          </div>}
        </div>}

        {/* Tip selector - only when no payments yet */}
        {payments.length===0&&<div style={{marginBottom:11,padding:11,background:"#fff",borderRadius:9,border:"1px solid #ede8de"}}>
          <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>OPTIONAL TIP</p>
          <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:5}}>
            {[0,1,2,5,10].map(t=><button key={t} onClick={()=>setTipAmount(t)} style={{padding:"9px 4px",border:"2px solid "+(tipAmount===t?"#7c3aed":"#ede8de"),borderRadius:7,background:tipAmount===t?"#f5f3ff":"#fff",fontWeight:700,fontSize:12,cursor:"pointer",color:tipAmount===t?"#7c3aed":"#1a1208"}}>{t===0?"None":fmt(t)}</button>)}
          </div>
        </div>}

        {/* Payment ledger */}
        {payments.length>0&&<div style={{marginBottom:11}}>
          <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:2,marginBottom:6}}>PAYMENTS RECEIVED ({payments.length})</p>
          {payments.map((p,i)=><div key={p.id} style={{display:"flex",alignItems:"center",gap:8,padding:"10px 12px",background:"#fff",border:"2px solid "+(p.method==="cash"?"#059669":"#2563eb"),borderRadius:9,marginBottom:5}}>
            <span style={{fontSize:24}}>{p.method==="cash"?String.fromCharCode(0xD83D,0xDCB5):String.fromCharCode(0xD83D,0xDCB3)}</span>
            <div style={{flex:1}}>
              <p style={{fontSize:13,fontWeight:700}}>{p.method==="cash"?"Cash":"Card"} #{i+1}: {fmt(p.amount)}</p>
              {p.method==="cash"&&p.cashGiven&&<p style={{fontSize:10,color:"#8a8078"}}>Given {fmt(p.cashGiven)} - Change {fmt(p.change||0)}</p>}
              {p.method==="card"&&<p style={{fontSize:10,color:"#059669",fontWeight:700}}>{String.fromCharCode(0x2713)} Approved</p>}
            </div>
            <button onClick={()=>removePayment(p.id)} style={{width:26,height:26,borderRadius:"50%",background:"#fee2e2",color:"#dc2626",border:"none",cursor:"pointer",fontWeight:700,fontSize:12}}>x</button>
          </div>)}
        </div>}

        {/* Add payment buttons */}
        {!isComplete&&<>
          <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:2,marginBottom:6}}>ADD PAYMENT</p>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:11}}>
            <button onClick={()=>setShowAddPayment("cash")} style={{padding:"22px 14px",background:"linear-gradient(135deg,#059669,#10b981)",color:"#fff",border:"none",borderRadius:13,cursor:"pointer",boxShadow:"0 4px 14px rgba(5,150,105,.3)",fontWeight:700}}>
              <p style={{fontSize:38,marginBottom:4,lineHeight:1}}>{String.fromCharCode(0xD83D,0xDCB5)}</p>
              <p style={{fontSize:14,letterSpacing:1}}>ADD CASH</p>
            </button>
            <button onClick={()=>setShowAddPayment("card")} style={{padding:"22px 14px",background:"linear-gradient(135deg,#2563eb,#3b82f6)",color:"#fff",border:"none",borderRadius:13,cursor:"pointer",boxShadow:"0 4px 14px rgba(37,99,235,.3)",fontWeight:700}}>
              <p style={{fontSize:38,marginBottom:4,lineHeight:1}}>{String.fromCharCode(0xD83D,0xDCB3)}</p>
              <p style={{fontSize:14,letterSpacing:1}}>ADD CARD</p>
            </button>
          </div>
          
          {/* Quick "pay all remaining" buttons */}
          <p style={{fontSize:10,color:"#8a8078",fontStyle:"italic",textAlign:"center",marginBottom:10}}>Or pay all remaining ({fmt(remaining)}) at once:</p>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:5,marginBottom:9}}>
            <button onClick={()=>setShowAddPayment("cash")} style={{padding:"9px",background:"#fff",border:"1px solid #059669",color:"#059669",borderRadius:7,fontWeight:700,fontSize:11,cursor:"pointer"}}>All Cash {fmt(remaining)}</button>
            <button onClick={()=>addPayment({method:"card",amount:remaining})} style={{padding:"9px",background:"#fff",border:"1px solid #2563eb",color:"#2563eb",borderRadius:7,fontWeight:700,fontSize:11,cursor:"pointer"}}>All Card {fmt(remaining)}</button>
          </div>

          {/* Split by Items - only show when no payments yet AND cart is provided AND multiple items */}
          {allowItemSplit&&payments.length===0&&cart&&cart.length>0&&<button onClick={()=>setItemSplitMode(true)} style={{width:"100%",padding:"13px",background:"linear-gradient(135deg,#7c3aed,#a855f7)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer",marginTop:6,boxShadow:"0 3px 10px rgba(124,58,237,.3)"}}>{String.fromCharCode(0xD83D,0xDC65)} Split by Items (Multiple Customers)</button>}
        </>}

        {/* Complete button */}
        {isComplete&&<button onClick={completePayment} style={{width:"100%",padding:"18px",background:"linear-gradient(135deg,#059669,#10b981)",color:"#fff",border:"none",borderRadius:11,fontSize:16,fontWeight:700,cursor:"pointer",boxShadow:"0 4px 14px rgba(5,150,105,.4)",letterSpacing:1}}>{String.fromCharCode(0x2713)} PAYMENT COMPLETE - Place Order</button>}
      </div>
    </div>
  </div>;
}

// ============================================================
// ADD PAYMENT SCREEN - amount entry with number pad
// ============================================================
function AddPaymentScreen({mode,remaining,onCancel,onSave}){
  var [amount,setAmount]=useState(remaining.toFixed(2));
  var [cashGiven,setCashGiven]=useState("");
  var [activeField,setActiveField]=useState("amount"); // "amount" or "cashGiven"
  
  var amountNum=parseFloat(amount)||0;
  var cashGivenNum=parseFloat(cashGiven)||0;
  var change=Math.max(0,cashGivenNum-amountNum);
  
  var canSave=()=>{
    if(!amountNum||amountNum<=0)return false;
    if(amountNum>remaining+0.01)return false;
    if(mode==="cash"&&cashGivenNum<amountNum)return false;
    return true;
  };

  var handleSave=()=>{
    if(!canSave())return;
    if(mode==="cash"){
      onSave({method:"cash",amount:amountNum,cashGiven:cashGivenNum,change:change});
    }else{
      onSave({method:"card",amount:amountNum});
    }
  };

  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.9)",zIndex:9100,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
    <div style={{background:"#fafaf5",color:"#1a1208",borderRadius:14,maxWidth:520,width:"100%",maxHeight:"96vh",overflow:"hidden",display:"flex",flexDirection:"column",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
      
      {/* Header */}
      <div style={{background:mode==="cash"?"linear-gradient(135deg,#059669,#047857)":"linear-gradient(135deg,#2563eb,#1e40af)",color:"#fff",padding:"14px 18px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <p style={{fontSize:11,opacity:.85,fontWeight:700,letterSpacing:2}}>ADD PAYMENT</p>
          <h2 style={{fontSize:18,fontWeight:700}}>{mode==="cash"?(String.fromCharCode(0xD83D,0xDCB5)+" Cash Payment"):(String.fromCharCode(0xD83D,0xDCB3)+" Card Payment")}</h2>
        </div>
        <button onClick={onCancel} style={{width:36,height:36,borderRadius:"50%",background:"rgba(255,255,255,.15)",color:"#fff",border:"none",cursor:"pointer",fontSize:18,fontWeight:700}}>x</button>
      </div>

      <div style={{flex:1,overflowY:"auto",padding:14}}>
        
        {/* Remaining amount info */}
        <div style={{padding:"9px 14px",background:"#fef3c7",borderRadius:7,marginBottom:11,textAlign:"center",fontSize:12,fontWeight:700,color:"#92400e"}}>
          Remaining to pay: {fmt(remaining)}
        </div>

        {/* AMOUNT field */}
        <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:4}}>HOW MUCH {mode==="cash"?"CASH":"CARD"}?</p>
        <div onClick={()=>setActiveField("amount")} style={{padding:"14px",background:"#fff",borderRadius:11,border:activeField==="amount"?"3px solid #d4952a":"2px solid #ede8de",marginBottom:9,fontSize:36,fontWeight:700,textAlign:"center",fontFamily:"'Courier New',monospace",color:"#1a1208",cursor:"pointer"}}>
          {String.fromCharCode(0xA3)}{amount||"0.00"}
        </div>

        {/* Quick amounts */}
        <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>QUICK AMOUNTS</p>
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:5,marginBottom:9}}>
          {[5,10,20,50,100,remaining].filter((v,i,arr)=>arr.indexOf(v)===i).map(v=><button key={v} onClick={()=>{setAmount(v.toFixed(2));setActiveField("amount");}} style={{padding:"10px 4px",background:"#fff",border:"2px solid #ede8de",borderRadius:7,fontWeight:700,fontSize:13,cursor:"pointer"}}>{fmt(v)}</button>)}
        </div>
        <button onClick={()=>{setAmount(remaining.toFixed(2));setActiveField("amount");}} style={{width:"100%",padding:"10px",background:"#d4952a",color:"#fff",border:"none",borderRadius:7,fontWeight:700,fontSize:12,cursor:"pointer",marginBottom:11}}>Pay All Remaining: {fmt(remaining)}</button>

        {/* Cash given field - only for cash payments */}
        {mode==="cash"&&<>
          <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:4}}>CUSTOMER GAVE</p>
          <div onClick={()=>setActiveField("cashGiven")} style={{padding:"14px",background:"#fff",borderRadius:11,border:activeField==="cashGiven"?"3px solid #d4952a":"2px solid #ede8de",marginBottom:9,fontSize:32,fontWeight:700,textAlign:"center",fontFamily:"'Courier New',monospace",color:"#1a1208",cursor:"pointer"}}>
            {String.fromCharCode(0xA3)}{cashGiven||"0.00"}
          </div>
          
          {/* Quick cash given amounts */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:4,marginBottom:9}}>
            {[5,10,20,50,100].map(v=><button key={v} onClick={()=>{setCashGiven(v.toFixed(2));setActiveField("cashGiven");}} style={{padding:"8px 2px",background:"#fff",border:"2px solid #ede8de",borderRadius:6,fontWeight:700,fontSize:12,cursor:"pointer"}}>{fmt(v)}</button>)}
          </div>
          <button onClick={()=>{setCashGiven(amountNum.toFixed(2));setActiveField("cashGiven");}} style={{width:"100%",padding:"8px",background:"#fff",border:"2px solid #059669",color:"#059669",borderRadius:6,fontWeight:700,fontSize:12,cursor:"pointer",marginBottom:9}}>Exact Amount: {fmt(amountNum)}</button>
          
          {/* Change display */}
          {cashGivenNum>0&&amountNum>0&&<div style={{padding:"14px",background:cashGivenNum>=amountNum?"#d1fae5":"#fee2e2",borderRadius:11,border:"3px solid "+(cashGivenNum>=amountNum?"#059669":"#dc2626"),marginBottom:9,textAlign:"center"}}>
            {cashGivenNum>=amountNum?<>
              <p style={{fontSize:11,color:"#065f46",fontWeight:700,letterSpacing:2,marginBottom:4}}>CHANGE TO RETURN</p>
              <p style={{fontSize:34,fontWeight:700,color:"#059669",fontFamily:"'Courier New',monospace",lineHeight:1}}>{fmt(change)}</p>
            </>:<>
              <p style={{fontSize:11,color:"#991b1b",fontWeight:700,letterSpacing:2,marginBottom:4}}>INSUFFICIENT</p>
              <p style={{fontSize:18,fontWeight:700,color:"#dc2626"}}>Need {fmt(amountNum-cashGivenNum)} more</p>
            </>}
          </div>}
        </>}

        {/* Card flow */}
        {mode==="card"&&<div style={{padding:18,background:"#dbeafe",borderRadius:11,marginBottom:9,textAlign:"center",border:"2px dashed #2563eb"}}>
          <p style={{fontSize:36,marginBottom:6}}>{String.fromCharCode(0xD83D,0xDCB3)}</p>
          <p style={{fontSize:14,fontWeight:700,color:"#1e40af",marginBottom:3}}>Charge {fmt(amountNum)} on card terminal</p>
          <p style={{fontSize:11,color:"#3b82f6"}}>Customer: insert/tap card on terminal</p>
        </div>}

        {/* Number pad */}
        <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>NUMBER PAD</p>
        <NumberPad
          value={activeField==="amount"?amount:cashGiven}
          onChange={(v)=>{if(activeField==="amount")setAmount(v);else setCashGiven(v);}}
          onSubmit={handleSave}
        />
      </div>

      {/* Action buttons */}
      <div style={{padding:11,background:"#fff",borderTop:"1px solid #ede8de",display:"flex",gap:6}}>
        <button onClick={onCancel} style={{flex:1,padding:"15px",background:"#fff",border:"2px solid #ede8de",borderRadius:9,fontWeight:700,fontSize:14,cursor:"pointer"}}>Cancel</button>
        <button onClick={handleSave} disabled={!canSave()} style={{flex:2,padding:"15px",background:!canSave()?"#9ca3af":(mode==="cash"?"linear-gradient(135deg,#059669,#10b981)":"linear-gradient(135deg,#2563eb,#3b82f6)"),color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:14,cursor:!canSave()?"not-allowed":"pointer"}}>{mode==="cash"?(String.fromCharCode(0x2713)+" Add Cash & Open Drawer"):(String.fromCharCode(0x2713)+" Card Approved")}</button>
      </div>
    </div>
  </div>;
}

// ============================================================
// ITEM SPLIT - Step 1: Choose customer count
// ============================================================
function ItemSplitCustomerCount({onCancel,onContinue}){
  var [count,setCount]=useState(2);
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",zIndex:9100,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
    <div style={{background:"#fafaf5",color:"#1a1208",borderRadius:14,maxWidth:520,width:"100%",overflow:"hidden",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
      <div style={{background:"linear-gradient(135deg,#7c3aed,#a855f7)",color:"#fff",padding:"16px 20px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <p style={{fontSize:11,opacity:.85,fontWeight:700,letterSpacing:2}}>SPLIT BY ITEMS</p>
          <h2 style={{fontSize:18,fontWeight:700}}>{String.fromCharCode(0xD83D,0xDC65)} How Many Customers?</h2>
        </div>
        <button onClick={onCancel} style={{width:36,height:36,borderRadius:"50%",background:"rgba(255,255,255,.15)",color:"#fff",border:"none",cursor:"pointer",fontSize:18,fontWeight:700}}>x</button>
      </div>
      <div style={{padding:24,textAlign:"center"}}>
        <p style={{fontSize:13,color:"#8a8078",marginBottom:18}}>How many people will pay separately?</p>
        
        <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:14,marginBottom:18}}>
          <button onClick={()=>setCount(Math.max(2,count-1))} style={{width:60,height:60,borderRadius:"50%",background:"#fff",border:"3px solid #7c3aed",color:"#7c3aed",fontSize:28,fontWeight:700,cursor:"pointer",boxShadow:"0 3px 8px rgba(0,0,0,.1)"}}>-</button>
          <p style={{fontSize:80,fontWeight:700,color:"#7c3aed",fontFamily:"'Courier New',monospace",lineHeight:1,minWidth:120}}>{count}</p>
          <button onClick={()=>setCount(Math.min(20,count+1))} style={{width:60,height:60,borderRadius:"50%",background:"#fff",border:"3px solid #7c3aed",color:"#7c3aed",fontSize:28,fontWeight:700,cursor:"pointer",boxShadow:"0 3px 8px rgba(0,0,0,.1)"}}>+</button>
        </div>
        
        <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:6}}>QUICK SELECT</p>
        <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:5,marginBottom:20}}>
          {[2,3,4,5,6,7,8].map(n=><button key={n} onClick={()=>setCount(n)} style={{padding:"12px 4px",background:count===n?"#7c3aed":"#fff",color:count===n?"#fff":"#1a1208",border:"2px solid #7c3aed",borderRadius:7,fontWeight:700,fontSize:14,cursor:"pointer"}}>{n}</button>)}
        </div>

        <button onClick={()=>onContinue(count)} style={{width:"100%",padding:"16px",background:"linear-gradient(135deg,#7c3aed,#a855f7)",color:"#fff",border:"none",borderRadius:11,fontWeight:700,fontSize:15,cursor:"pointer",letterSpacing:1,boxShadow:"0 4px 14px rgba(124,58,237,.4)"}}>Continue with {count} customers {String.fromCharCode(0x2192)}</button>
      </div>
    </div>
  </div>;
}

// ============================================================
// ITEM SPLIT - Step 2: Assign items to customers
// ============================================================
function ItemSplitAssign({cart,customerCount,customerItems,setCustomerItems,activeCustomer,setActiveCustomer,onCancel,onContinue}){
  // Each item in cart can be a single unit OR have qty>1. We split per UNIT for flexibility.
  // Build a flat list of "item units": each item with qty 3 becomes 3 separate units
  var itemUnits=(()=>{
    var units=[];
    cart.forEach((item,idx)=>{
      for(var q=0;q<item.qty;q++){
        units.push({uid:idx+"_"+q,itemIdx:idx,name:item.name,price:item.price,note:item.note});
      }
    });
    return units;
  })();
  
  // Find which customer/shared an item unit is assigned to
  var findAssignment=(uid)=>{
    var keys=Object.keys(customerItems);
    for(var k of keys){
      if((customerItems[k]||[]).includes(uid))return k;
    }
    return null;
  };
  
  // Calculate each customer's total
  var calcTotal=(custKey)=>{
    var ids=customerItems[custKey]||[];
    if(custKey==="shared"){
      // Shared items split evenly across all customers
      var sharedTotal=ids.reduce((s,uid)=>{
        var u=itemUnits.find(x=>x.uid===uid);
        return s+(u?u.price:0);
      },0);
      return sharedTotal;
    }
    return ids.reduce((s,uid)=>{
      var u=itemUnits.find(x=>x.uid===uid);
      return s+(u?u.price:0);
    },0);
  };
  
  var sharedAmount=calcTotal("shared");
  var sharedPerCust=customerCount>0?sharedAmount/customerCount:0;
  
  // Each customer's true total = their items + share of shared
  var custDisplayTotal=(n)=>calcTotal(n)+sharedPerCust;
  
  // Toggle assignment
  var assign=(uid,target)=>{
    setCustomerItems(prev=>{
      var newCI={...prev};
      // Remove from any existing assignment
      Object.keys(newCI).forEach(k=>{
        newCI[k]=(newCI[k]||[]).filter(x=>x!==uid);
      });
      // Add to target
      if(!newCI[target])newCI[target]=[];
      newCI[target]=[...newCI[target],uid];
      return newCI;
    });
  };
  
  var allAssigned=itemUnits.every(u=>findAssignment(u.uid));
  var assignedCount=itemUnits.filter(u=>findAssignment(u.uid)).length;
  
  // Customer card colors
  var custColors=["#dc2626","#0891b2","#059669","#d4952a","#7c3aed","#ea580c","#be185d","#0d9488","#4338ca","#ca8a04"];
  
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.9)",zIndex:9100,display:"flex",alignItems:"center",justifyContent:"center",padding:10}}>
    <div style={{background:"#fafaf5",color:"#1a1208",borderRadius:14,maxWidth:900,width:"100%",maxHeight:"96vh",display:"flex",flexDirection:"column",overflow:"hidden",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
      
      {/* Header */}
      <div style={{background:"linear-gradient(135deg,#7c3aed,#a855f7)",color:"#fff",padding:"12px 18px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <p style={{fontSize:10,opacity:.85,fontWeight:700,letterSpacing:2}}>SPLIT BY ITEMS</p>
          <h2 style={{fontSize:16,fontWeight:700}}>Tap customer below, then tap items they had</h2>
        </div>
        <button onClick={onCancel} style={{width:34,height:34,borderRadius:"50%",background:"rgba(255,255,255,.15)",color:"#fff",border:"none",cursor:"pointer",fontSize:16,fontWeight:700}}>x</button>
      </div>

      <div style={{flex:1,overflowY:"auto",padding:12}}>
        
        {/* Customer cards row */}
        <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:2,marginBottom:6}}>SELECT CUSTOMER (active = you'll assign items to this person)</p>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(110px,1fr))",gap:5,marginBottom:11}}>
          {Array.from({length:customerCount},(_,i)=>i+1).map(n=>{
            var color=custColors[(n-1)%custColors.length];
            var isActive=activeCustomer===n;
            var itemCount=(customerItems[n]||[]).length;
            return <button key={n} onClick={()=>setActiveCustomer(n)} style={{padding:"10px 7px",background:isActive?color:"#fff",color:isActive?"#fff":color,border:"3px solid "+color,borderRadius:9,cursor:"pointer",fontWeight:700,textAlign:"center"}}>
              <p style={{fontSize:18,marginBottom:2}}>#{n}</p>
              <p style={{fontSize:13,fontWeight:700}}>{fmt(custDisplayTotal(n))}</p>
              <p style={{fontSize:10,opacity:.8}}>{itemCount} item{itemCount!==1?"s":""}</p>
            </button>;
          })}
          <button onClick={()=>setActiveCustomer("shared")} style={{padding:"10px 7px",background:activeCustomer==="shared"?"#1a1208":"#fff",color:activeCustomer==="shared"?"#fff":"#1a1208",border:"3px solid #1a1208",borderRadius:9,cursor:"pointer",fontWeight:700,textAlign:"center"}}>
            <p style={{fontSize:14,marginBottom:2}}>{String.fromCharCode(0xD83C,0xDF77)}</p>
            <p style={{fontSize:11,fontWeight:700}}>SHARED</p>
            <p style={{fontSize:9,opacity:.8}}>{(customerItems.shared||[]).length} items</p>
          </button>
        </div>

        {/* Items list */}
        <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:2,marginBottom:6}}>ITEMS - tap to assign to {activeCustomer==="shared"?"SHARED":"Customer #"+activeCustomer}</p>
        <div style={{display:"grid",gridTemplateColumns:"1fr",gap:4,marginBottom:11}}>
          {itemUnits.map(u=>{
            var assignedTo=findAssignment(u.uid);
            var isAssignedToActive=assignedTo===String(activeCustomer);
            var isAssignedToOther=assignedTo&&!isAssignedToActive;
            var assignedColor=assignedTo==="shared"?"#1a1208":(custColors[(parseInt(assignedTo)-1)%custColors.length]||"#9ca3af");
            return <button key={u.uid} onClick={()=>assign(u.uid,String(activeCustomer))} style={{padding:"10px 12px",background:isAssignedToActive?assignedColor:(isAssignedToOther?"#f7f3ee":"#fff"),color:isAssignedToActive?"#fff":"#1a1208",border:"2px solid "+(isAssignedToActive?assignedColor:(isAssignedToOther?assignedColor:"#ede8de")),borderRadius:8,cursor:"pointer",fontWeight:600,textAlign:"left",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{flex:1}}>
                <p style={{fontSize:13,fontWeight:700}}>{u.name}</p>
                {u.note&&<p style={{fontSize:10,opacity:.8,fontStyle:"italic"}}>Note: {u.note}</p>}
              </div>
              <div style={{textAlign:"right"}}>
                <p style={{fontSize:14,fontWeight:700}}>{fmt(u.price)}</p>
                {assignedTo&&<p style={{fontSize:10,opacity:.85,fontWeight:700}}>{assignedTo==="shared"?"SHARED":"#"+assignedTo}</p>}
              </div>
            </button>;
          })}
        </div>

        {/* Progress indicator */}
        <div style={{padding:"10px 12px",background:allAssigned?"#d1fae5":"#fef3c7",borderRadius:9,marginBottom:11,textAlign:"center",border:"2px solid "+(allAssigned?"#059669":"#d97706")}}>
          <p style={{fontSize:13,fontWeight:700,color:allAssigned?"#065f46":"#92400e"}}>{allAssigned?String.fromCharCode(0x2713)+" All items assigned ("+itemUnits.length+"/"+itemUnits.length+")":"Assigned: "+assignedCount+" of "+itemUnits.length+" items"}</p>
        </div>
      </div>

      {/* Footer buttons */}
      <div style={{padding:11,background:"#fff",borderTop:"1px solid #ede8de",display:"flex",gap:6}}>
        <button onClick={onCancel} style={{flex:1,padding:"15px",background:"#fff",border:"2px solid #ede8de",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>Cancel</button>
        <button onClick={onContinue} disabled={!allAssigned} style={{flex:2,padding:"15px",background:allAssigned?"linear-gradient(135deg,#7c3aed,#a855f7)":"#9ca3af",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:14,cursor:allAssigned?"pointer":"not-allowed"}}>{allAssigned?"Pay Each Customer "+String.fromCharCode(0x2192):"Assign all items first"}</button>
      </div>
    </div>
  </div>;
}

// ============================================================
// ITEM SPLIT - Step 3: Pay each customer one by one
// ============================================================
function ItemSplitPayCustomer({customerNum,totalCustomers,cart,customerItems,branch,user,orderId,onPaid,onCancel}){
  var [step,setStep]=useState("preview"); // preview, addPayment
  var [paymentMode,setPaymentMode]=useState(null); // "cash" or "card"
  
  var custColors=["#dc2626","#0891b2","#059669","#d4952a","#7c3aed","#ea580c","#be185d","#0d9488","#4338ca","#ca8a04"];
  var color=custColors[(customerNum-1)%custColors.length];
  
  // Build flat item units
  var itemUnits=(()=>{
    var units=[];
    cart.forEach((item,idx)=>{
      for(var q=0;q<item.qty;q++){
        units.push({uid:idx+"_"+q,itemIdx:idx,name:item.name,price:item.price,note:item.note});
      }
    });
    return units;
  })();
  
  // This customer's items
  var myItemIds=customerItems[customerNum]||[];
  var myItems=myItemIds.map(uid=>itemUnits.find(u=>u.uid===uid)).filter(Boolean);
  var myItemsTotal=myItems.reduce((s,u)=>s+u.price,0);
  
  // Shared portion
  var sharedItems=(customerItems.shared||[]).map(uid=>itemUnits.find(u=>u.uid===uid)).filter(Boolean);
  var sharedTotal=sharedItems.reduce((s,u)=>s+u.price,0);
  var mySharedPortion=totalCustomers>0?sharedTotal/totalCustomers:0;
  
  var amount=myItemsTotal+mySharedPortion;
  
  if(step==="addPayment"&&paymentMode){
    return <AddPaymentScreen
      mode={paymentMode}
      remaining={amount}
      onCancel={()=>{setStep("preview");setPaymentMode(null);}}
      onSave={(p)=>{onPaid(p);}}
    />;
  }

  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.9)",zIndex:9100,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
    <div style={{background:"#fafaf5",color:"#1a1208",borderRadius:14,maxWidth:520,width:"100%",maxHeight:"94vh",overflow:"hidden",display:"flex",flexDirection:"column",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
      
      {/* Header */}
      <div style={{background:"linear-gradient(135deg,"+color+",rgba(0,0,0,.3))",color:"#fff",padding:"14px 18px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <p style={{fontSize:11,opacity:.85,fontWeight:700,letterSpacing:2}}>CUSTOMER {customerNum} OF {totalCustomers}</p>
          <h2 style={{fontSize:20,fontWeight:700}}>Pay Customer #{customerNum}</h2>
        </div>
        <button onClick={onCancel} style={{width:36,height:36,borderRadius:"50%",background:"rgba(255,255,255,.15)",color:"#fff",border:"none",cursor:"pointer",fontSize:18,fontWeight:700}}>x</button>
      </div>

      <div style={{flex:1,overflowY:"auto",padding:14}}>
        
        {/* Items list */}
        <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:2,marginBottom:6}}>THEIR ITEMS</p>
        <div style={{background:"#fff",borderRadius:9,padding:11,marginBottom:11,border:"1px solid #ede8de"}}>
          {myItems.map((u,i)=><div key={i} style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:i<myItems.length-1?"1px solid #ede8de":"none"}}>
            <span style={{fontSize:13}}>{u.name}{u.note?" ("+u.note+")":""}</span>
            <span style={{fontWeight:700,fontSize:13}}>{fmt(u.price)}</span>
          </div>)}
          {myItems.length===0&&<p style={{fontSize:12,color:"#8a8078",fontStyle:"italic"}}>No personal items</p>}
        </div>

        {/* Shared portion */}
        {mySharedPortion>0&&<div style={{background:"#fef3c7",borderRadius:9,padding:11,marginBottom:11,border:"1px solid #d97706"}}>
          <p style={{fontSize:11,color:"#92400e",fontWeight:700,letterSpacing:1,marginBottom:5}}>{String.fromCharCode(0xD83C,0xDF77)} SHARED ITEMS PORTION</p>
          <div style={{display:"flex",justifyContent:"space-between"}}>
            <span style={{fontSize:13}}>Share of {sharedItems.length} shared items ({totalCustomers} ways)</span>
            <span style={{fontWeight:700,fontSize:13}}>{fmt(mySharedPortion)}</span>
          </div>
        </div>}

        {/* Total */}
        <div style={{padding:"18px",background:color,color:"#fff",borderRadius:11,marginBottom:14,textAlign:"center"}}>
          <p style={{fontSize:11,opacity:.85,fontWeight:700,letterSpacing:2}}>CUSTOMER #{customerNum} TOTAL</p>
          <p style={{fontSize:42,fontWeight:700,fontFamily:"'Courier New',monospace",lineHeight:1}}>{fmt(amount)}</p>
        </div>

        {/* Payment buttons */}
        <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:2,marginBottom:6}}>HOW IS CUSTOMER #{customerNum} PAYING?</p>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
          <button onClick={()=>{setPaymentMode("cash");setStep("addPayment");}} style={{padding:"22px 14px",background:"linear-gradient(135deg,#059669,#10b981)",color:"#fff",border:"none",borderRadius:13,cursor:"pointer",boxShadow:"0 4px 14px rgba(5,150,105,.3)",fontWeight:700}}>
            <p style={{fontSize:38,marginBottom:4,lineHeight:1}}>{String.fromCharCode(0xD83D,0xDCB5)}</p>
            <p style={{fontSize:14,letterSpacing:1}}>CASH</p>
          </button>
          <button onClick={()=>{setPaymentMode("card");setStep("addPayment");}} style={{padding:"22px 14px",background:"linear-gradient(135deg,#2563eb,#3b82f6)",color:"#fff",border:"none",borderRadius:13,cursor:"pointer",boxShadow:"0 4px 14px rgba(37,99,235,.3)",fontWeight:700}}>
            <p style={{fontSize:38,marginBottom:4,lineHeight:1}}>{String.fromCharCode(0xD83D,0xDCB3)}</p>
            <p style={{fontSize:14,letterSpacing:1}}>CARD</p>
          </button>
        </div>
      </div>
    </div>
  </div>;
}

// ============================================================
// ITEM SPLIT - Step 4: Complete - all customers paid
// ============================================================
function ItemSplitComplete({customerCount,customerPayments,cart,customerItems,branch,onCancel,onComplete}){
  var custColors=["#dc2626","#0891b2","#059669","#d4952a","#7c3aed","#ea580c","#be185d","#0d9488","#4338ca","#ca8a04"];
  var totalPaid=Object.values(customerPayments).reduce((s,p)=>s+(p.amount||0),0);
  
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.9)",zIndex:9100,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
    <div style={{background:"#fafaf5",color:"#1a1208",borderRadius:14,maxWidth:520,width:"100%",maxHeight:"94vh",overflow:"hidden",display:"flex",flexDirection:"column",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
      
      <div style={{background:"linear-gradient(135deg,#059669,#047857)",color:"#fff",padding:"14px 18px",textAlign:"center"}}>
        <p style={{fontSize:48,marginBottom:6}}>{String.fromCharCode(0x2713)}</p>
        <h2 style={{fontSize:22,fontWeight:700}}>All Customers Paid!</h2>
        <p style={{fontSize:13,opacity:.9}}>Total collected: {fmt(totalPaid)}</p>
      </div>

      <div style={{flex:1,overflowY:"auto",padding:14}}>
        <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:2,marginBottom:6}}>PAYMENT SUMMARY</p>
        {Array.from({length:customerCount},(_,i)=>i+1).map(n=>{
          var p=customerPayments[n];
          if(!p)return null;
          var color=custColors[(n-1)%custColors.length];
          return <div key={n} style={{padding:"11px 14px",background:"#fff",border:"2px solid "+color,borderLeft:"6px solid "+color,borderRadius:9,marginBottom:5,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div>
              <p style={{fontSize:13,fontWeight:700,color:color}}>Customer #{n}</p>
              <p style={{fontSize:11,color:"#8a8078"}}>{p.method==="cash"?(String.fromCharCode(0xD83D,0xDCB5)+" Cash"+(p.cashGiven?" (given "+fmt(p.cashGiven)+", change "+fmt(p.change||0)+")":"")):(String.fromCharCode(0xD83D,0xDCB3)+" Card "+String.fromCharCode(0x2713)+" Approved")}</p>
            </div>
            <p style={{fontSize:18,fontWeight:700,fontFamily:"'Courier New',monospace"}}>{fmt(p.amount)}</p>
          </div>;
        })}
      </div>

      <div style={{padding:11,background:"#fff",borderTop:"1px solid #ede8de",display:"flex",gap:6}}>
        <button onClick={onCancel} style={{flex:1,padding:"15px",background:"#fff",border:"2px solid #ede8de",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>Cancel</button>
        <button onClick={onComplete} style={{flex:2,padding:"15px",background:"linear-gradient(135deg,#059669,#10b981)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:14,cursor:"pointer"}}>{String.fromCharCode(0x2713)} Place Order</button>
      </div>
    </div>
  </div>;
}

// ============================================================
// MANAGER PIN PROMPT - reusable PIN entry for protected actions
// ============================================================
function ManagerPinPrompt({title,reason,onCancel,onApproved,branch}){
  var [pin,setPin]=useState("");
  var [error,setError]=useState("");
  var [verifying,setVerifying]=useState(false);
  
  var press=(k)=>{
    setError("");
    if(k==="DEL"){setPin(p=>p.slice(0,-1));}
    else if(k==="CLR"){setPin("");}
    else if(pin.length<6){setPin(p=>p+k);}
  };
  
  var verify=()=>{
    if(pin.length<4){setError("PIN too short");return;}
    setVerifying(true);
    dbVerifyPin(pin,branch?.id).then(r=>{
      setVerifying(false);
      if(r){
        onApproved(r);
      }else{
        setError("Invalid PIN");
        setPin("");
      }
    }).catch(e=>{
      setVerifying(false);
      setError("Verification failed");
    });
  };
  
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.92)",zIndex:9500,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
    <div style={{background:"#fafaf5",color:"#1a1208",borderRadius:14,maxWidth:440,width:"100%",overflow:"hidden",boxShadow:"0 20px 60px rgba(0,0,0,.5)",border:"3px solid #d4952a"}}>
      <div style={{background:"linear-gradient(135deg,#7c2d12,#9a3412)",color:"#fff",padding:"16px 20px",textAlign:"center"}}>
        <p style={{fontSize:36,marginBottom:5}}>{String.fromCharCode(0xD83D,0xDD12)}</p>
        <h2 style={{fontSize:18,fontWeight:700}}>{title||"Manager Authorization Required"}</h2>
        {reason&&<p style={{fontSize:12,opacity:.85,marginTop:5}}>{reason}</p>}
      </div>
      
      <div style={{padding:18}}>
        <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:7,textAlign:"center"}}>ENTER MANAGER PIN</p>
        
        <div style={{padding:"14px",background:"#fff",borderRadius:11,border:error?"3px solid #dc2626":"3px solid #d4952a",marginBottom:11,fontSize:36,fontWeight:700,textAlign:"center",fontFamily:"'Courier New',monospace",letterSpacing:8,minHeight:32}}>
          {pin?Array(pin.length).fill(String.fromCharCode(0x25CF)).join(""):<span style={{color:"#d4b896"}}>----</span>}
        </div>
        
        {error&&<p style={{fontSize:12,color:"#dc2626",fontWeight:700,textAlign:"center",marginBottom:9}}>{String.fromCharCode(0x26A0,0xFE0F)} {error}</p>}
        
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:5,marginBottom:8}}>
          {["1","2","3","4","5","6","7","8","9","CLR","0","DEL"].map(k=><button key={k} onClick={()=>press(k)} style={{padding:"16px 0",fontSize:22,fontWeight:700,background:k==="DEL"||k==="CLR"?"linear-gradient(180deg,#fbbf24,#d97706)":"linear-gradient(180deg,#fff,#f5f0e8)",color:k==="DEL"||k==="CLR"?"#fff":"#1a1208",border:"1px solid "+(k==="DEL"||k==="CLR"?"transparent":"#d4b896"),borderRadius:9,cursor:"pointer",boxShadow:"0 2px 0 rgba(0,0,0,.15)"}}>{k==="DEL"?String.fromCharCode(0x232B):k}</button>)}
        </div>
        
        <div style={{display:"flex",gap:6}}>
          <button onClick={onCancel} style={{flex:1,padding:"14px",background:"#fff",border:"2px solid #ede8de",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>Cancel</button>
          <button onClick={verify} disabled={verifying||pin.length<4} style={{flex:2,padding:"14px",background:verifying||pin.length<4?"#9ca3af":"linear-gradient(135deg,#7c2d12,#9a3412)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:14,cursor:verifying||pin.length<4?"not-allowed":"pointer"}}>{verifying?"Verifying...":(String.fromCharCode(0xD83D,0xDD13)+" Authorize")}</button>
        </div>
      </div>
    </div>
  </div>;
}

// ============================================================
// REFUND/VOID FLOW - protected by manager PIN
// ============================================================
function RefundVoidFlow({order,onClose,onDone,branch,user,push}){
  var [step,setStep]=useState("type"); // type, pin, reason, confirm, done
  var [voidType,setVoidType]=useState(null); // "void", "refund", "partial-refund", "voucher"
  var [refundAmount,setRefundAmount]=useState("");
  var [reason,setReason]=useState("");
  var [manager,setManager]=useState(null);
  var [submitting,setSubmitting]=useState(false);
  var [voucherCode,setVoucherCode]=useState(""); // generated code
  
  var commonReasons={
    "void":["Customer changed mind","Wrong order taken","Item out of stock","Duplicate order","Staff error"],
    "refund":["Wrong order delivered","Food quality issue","Customer dissatisfied","Item missing","Cold food","Long wait time"],
    "partial-refund":["One item missing","Quality issue with item","Wrong item received","Discount not applied"],
    "voucher":["Goodwill gesture","Quality issue","Long wait time","Service complaint","Apology for mistake","Loyalty reward"],
  };
  
  // Generate 6-character voucher code (alphanumeric, exclude confusing chars 0/O/1/I)
  var generateVoucherCode=()=>{
    var chars="ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    var code="";
    for(var i=0;i<6;i++)code+=chars.charAt(Math.floor(Math.random()*chars.length));
    return code;
  };
  
  var processVoid=()=>{
    setSubmitting(true);
    var amount=(voidType==="partial-refund"||voidType==="voucher")?parseFloat(refundAmount):parseFloat(order.total);
    
    // For voucher: generate code and save as discount code
    if(voidType==="voucher"){
      var code=generateVoucherCode();
      setVoucherCode(code);
      // 90 day expiry
      var expiresDate=new Date();
      expiresDate.setDate(expiresDate.getDate()+90);
      // Save voucher as discount_code (type: fixed amount)
      dbSaveCode({
        code:code,
        type:"fixed",
        value:amount,
        description:"Voucher - Order "+order.id+" - "+(reason||""),
        minOrder:0,
        maxUses:1,
        uses:0,
        expiresAt:expiresDate.toISOString(),
        active:true,
        firstOrderOnly:false,
        branchIds:[],
      }).then(r=>{
        if(r.error){alert("Failed to save voucher: "+JSON.stringify(r.error));setSubmitting(false);return;}
        // Also log void record
        dbRecordVoid({
          order_id:order.id,
          branch_id:branch?.id||order.branchId,
          void_type:"voucher",
          amount:amount,
          reason:(reason||"")+" | Voucher Code: "+code,
          approved_by:manager?.manager_name||"Manager",
          staff_member:user?.name||"Staff",
        }).then(()=>{
          setSubmitting(false);
          push&&push({title:"VOUCHER ISSUED",body:"Code: "+code+" - "+fmt(amount),color:"#7c3aed"});
          setStep("done");
        }).catch(e=>{setSubmitting(false);alert("Void log error: "+e.message);});
      }).catch(e=>{setSubmitting(false);alert("Voucher save error: "+e.message);});
      return;
    }
    
    dbRecordVoid({
      order_id:order.id,
      branch_id:branch?.id||order.branchId,
      void_type:voidType,
      amount:amount,
      reason:reason,
      approved_by:manager?.manager_name||"Manager",
      staff_member:user?.name||"Staff",
    }).then(r=>{
      setSubmitting(false);
      if(r.error){alert("Failed to record: "+JSON.stringify(r.error));return;}
      // For full void/refund, mark order as cancelled
      var statusUpdate=voidType==="void"?"cancelled":(voidType==="refund"?"cancelled":order.status);
      if(onDone)onDone({voidType,amount,reason,manager:manager?.manager_name,statusUpdate});
      push&&push({title:voidType.toUpperCase()+" recorded",body:fmt(amount)+" - approved by "+(manager?.manager_name||"Manager"),color:"#dc2626"});
      setStep("done");
    }).catch(e=>{
      setSubmitting(false);
      alert("Error: "+e.message);
    });
  };
  
  // STEP 1: Choose action type
  if(step==="type"){
    return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",zIndex:9400,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
      <div style={{background:"#fafaf5",color:"#1a1208",borderRadius:14,maxWidth:520,width:"100%",overflow:"hidden",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
        <div style={{background:"linear-gradient(135deg,#7c2d12,#9a3412)",color:"#fff",padding:"16px 20px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <p style={{fontSize:11,opacity:.85,fontWeight:700,letterSpacing:2}}>ORDER {order.id}</p>
            <h2 style={{fontSize:18,fontWeight:700}}>{String.fromCharCode(0x26A0,0xFE0F)} Refund or Void Order</h2>
          </div>
          <button onClick={onClose} style={{width:36,height:36,borderRadius:"50%",background:"rgba(255,255,255,.15)",color:"#fff",border:"none",cursor:"pointer",fontSize:18,fontWeight:700}}>x</button>
        </div>
        
        <div style={{padding:18}}>
          <div style={{padding:11,background:"#fef3c7",borderRadius:9,marginBottom:14,fontSize:12,color:"#92400e",borderLeft:"4px solid #d97706"}}>
            <p><b>Order:</b> {order.customer} - {fmt(order.total)} - {order.payMethod||"Unpaid"}</p>
            <p style={{marginTop:3}}>{order.items?.length||0} items - Status: <b>{order.status}</b></p>
          </div>
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:2,marginBottom:7}}>WHAT DO YOU WANT TO DO?</p>
          
          <button onClick={()=>{setVoidType("void");setStep("pin");}} style={{width:"100%",padding:"14px 16px",background:"#fff",border:"2px solid #dc2626",borderRadius:9,marginBottom:7,cursor:"pointer",textAlign:"left"}}>
            <p style={{fontSize:14,fontWeight:700,color:"#dc2626",marginBottom:2}}>{String.fromCharCode(0x274C)} VOID Order</p>
            <p style={{fontSize:11,color:"#8a8078"}}>Cancel order before payment OR cancel an unpaid order</p>
          </button>
          
          {order.paid&&<button onClick={()=>{setVoidType("refund");setStep("pin");}} style={{width:"100%",padding:"14px 16px",background:"#fff",border:"2px solid #ea580c",borderRadius:9,marginBottom:7,cursor:"pointer",textAlign:"left"}}>
            <p style={{fontSize:14,fontWeight:700,color:"#ea580c",marginBottom:2}}>{String.fromCharCode(0xD83D,0xDCB0)} FULL REFUND</p>
            <p style={{fontSize:11,color:"#8a8078"}}>Refund all {fmt(order.total)} and cancel the order</p>
          </button>}
          
          {order.paid&&<button onClick={()=>{setVoidType("partial-refund");setStep("pin");}} style={{width:"100%",padding:"14px 16px",background:"#fff",border:"2px solid #d97706",borderRadius:9,cursor:"pointer",textAlign:"left",marginBottom:7}}>
            <p style={{fontSize:14,fontWeight:700,color:"#d97706",marginBottom:2}}>{String.fromCharCode(0xD83D,0xDCB5)} PARTIAL REFUND</p>
            <p style={{fontSize:11,color:"#8a8078"}}>Refund only some amount (eg if one dish was bad)</p>
          </button>}
          
          <button onClick={()=>{setVoidType("voucher");setStep("pin");}} style={{width:"100%",padding:"14px 16px",background:"#fff",border:"2px solid #7c3aed",borderRadius:9,cursor:"pointer",textAlign:"left"}}>
            <p style={{fontSize:14,fontWeight:700,color:"#7c3aed",marginBottom:2}}>{String.fromCharCode(0xD83C,0xDF81)} ISSUE VOUCHER</p>
            <p style={{fontSize:11,color:"#8a8078"}}>Give customer a voucher code instead of cash refund (90 days valid)</p>
          </button>
        </div>
      </div>
    </div>;
  }
  
  // STEP 2: Manager PIN
  if(step==="pin"){
    return <ManagerPinPrompt
      title={voidType==="void"?"Authorize Void":(voidType==="refund"?"Authorize Refund":"Authorize Partial Refund")}
      reason={"For order "+order.id+" - "+fmt(order.total)}
      branch={branch}
      onCancel={()=>setStep("type")}
      onApproved={(mgr)=>{setManager(mgr);setStep("reason");}}
    />;
  }
  
  // STEP 3: Enter reason + amount (if partial)
  if(step==="reason"){
    var reasons=commonReasons[voidType]||[];
    return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",zIndex:9400,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
      <div style={{background:"#fafaf5",color:"#1a1208",borderRadius:14,maxWidth:520,width:"100%",overflow:"hidden",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
        <div style={{background:"linear-gradient(135deg,#7c2d12,#9a3412)",color:"#fff",padding:"16px 20px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <p style={{fontSize:11,opacity:.85,fontWeight:700,letterSpacing:2}}>{voidType.toUpperCase().replace("-"," ")}</p>
            <h2 style={{fontSize:18,fontWeight:700}}>Reason Required</h2>
            <p style={{fontSize:11,opacity:.85,marginTop:2}}>{String.fromCharCode(0x2713)} Approved by {manager?.manager_name}</p>
          </div>
          <button onClick={onClose} style={{width:36,height:36,borderRadius:"50%",background:"rgba(255,255,255,.15)",color:"#fff",border:"none",cursor:"pointer",fontSize:18,fontWeight:700}}>x</button>
        </div>
        
        <div style={{padding:18}}>
          {(voidType==="partial-refund"||voidType==="voucher")&&<>
            <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>{voidType==="voucher"?"VOUCHER VALUE":"REFUND AMOUNT"} (max {fmt(order.total)})</p>
            <input type="number" step="0.01" max={order.total} value={refundAmount} onChange={e=>setRefundAmount(e.target.value)} placeholder="0.00" style={{width:"100%",padding:"14px",border:"3px solid "+(voidType==="voucher"?"#7c3aed":"#d4952a"),borderRadius:9,fontSize:24,fontWeight:700,fontFamily:"'Courier New',monospace",textAlign:"right",marginBottom:7,boxSizing:"border-box"}}/>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:5,marginBottom:11}}>
              {[5,10,20,parseFloat(order.total).toFixed(2)].filter((v,i,a)=>a.indexOf(v)===i).map(v=><button key={v} onClick={()=>setRefundAmount(String(v))} style={{padding:"8px",background:"#fff",border:"2px solid #ede8de",borderRadius:6,fontWeight:700,fontSize:12,cursor:"pointer"}}>{fmt(v)}</button>)}
            </div>
            {voidType==="voucher"&&<div style={{padding:"9px 11px",background:"#f5f3ff",borderRadius:7,marginBottom:11,fontSize:11,color:"#7c3aed",borderLeft:"3px solid #7c3aed"}}>
              <p style={{fontWeight:700,marginBottom:2}}>{String.fromCharCode(0xD83C,0xDF81)} Voucher will be valid for 90 days</p>
              <p>Expires: {(()=>{var d=new Date();d.setDate(d.getDate()+90);return d.toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"});})()}</p>
            </div>}
          </>}
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>QUICK REASONS</p>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:5,marginBottom:9}}>
            {reasons.map(r=><button key={r} onClick={()=>setReason(r)} style={{padding:"10px",background:reason===r?"#7c2d12":"#fff",color:reason===r?"#fff":"#1a1208",border:"2px solid "+(reason===r?"#7c2d12":"#ede8de"),borderRadius:7,fontSize:11,fontWeight:700,cursor:"pointer",textAlign:"left"}}>{r}</button>)}
          </div>
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>OR TYPE CUSTOM REASON</p>
          <textarea value={reason} onChange={e=>setReason(e.target.value)} placeholder="Enter reason..." rows={3} style={{width:"100%",padding:"10px",border:"2px solid #ede8de",borderRadius:7,fontSize:13,fontFamily:"inherit",resize:"vertical",marginBottom:11,boxSizing:"border-box"}}/>
          
          <div style={{display:"flex",gap:6}}>
            <button onClick={()=>setStep("type")} style={{flex:1,padding:"14px",background:"#fff",border:"2px solid #ede8de",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>{"<"} Back</button>
            <button onClick={()=>setStep("confirm")} disabled={!reason||((voidType==="partial-refund"||voidType==="voucher")&&(!refundAmount||parseFloat(refundAmount)<=0||parseFloat(refundAmount)>parseFloat(order.total)))} style={{flex:2,padding:"14px",background:!reason||((voidType==="partial-refund"||voidType==="voucher")&&(!refundAmount||parseFloat(refundAmount)<=0||parseFloat(refundAmount)>parseFloat(order.total)))?"#9ca3af":(voidType==="voucher"?"linear-gradient(135deg,#7c3aed,#a855f7)":"linear-gradient(135deg,#dc2626,#991b1b)"),color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:14,cursor:!reason?"not-allowed":"pointer"}}>Continue {String.fromCharCode(0x2192)}</button>
          </div>
        </div>
      </div>
    </div>;
  }
  
  // STEP 4: Confirm
  if(step==="confirm"){
    var amount=(voidType==="partial-refund"||voidType==="voucher")?parseFloat(refundAmount||0):parseFloat(order.total);
    return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",zIndex:9400,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
      <div style={{background:"#fafaf5",color:"#1a1208",borderRadius:14,maxWidth:480,width:"100%",overflow:"hidden",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
        <div style={{background:"linear-gradient(135deg,#dc2626,#991b1b)",color:"#fff",padding:"16px 20px",textAlign:"center"}}>
          <p style={{fontSize:36,marginBottom:5}}>{String.fromCharCode(0x26A0,0xFE0F)}</p>
          <h2 style={{fontSize:20,fontWeight:700}}>Confirm {voidType.toUpperCase().replace("-"," ")}</h2>
        </div>
        
        <div style={{padding:18}}>
          <div style={{padding:14,background:"#fff",borderRadius:11,marginBottom:14,border:"2px solid #ede8de"}}>
            <p style={{fontSize:11,color:"#8a8078",marginBottom:3}}>Order:</p>
            <p style={{fontSize:14,fontWeight:700,marginBottom:7}}>{order.id} - {order.customer}</p>
            <p style={{fontSize:11,color:"#8a8078",marginBottom:3}}>Amount:</p>
            <p style={{fontSize:28,fontWeight:700,color:"#dc2626",marginBottom:9,fontFamily:"'Courier New',monospace"}}>{fmt(amount)}</p>
            <p style={{fontSize:11,color:"#8a8078",marginBottom:3}}>Reason:</p>
            <p style={{fontSize:13,marginBottom:7,fontStyle:"italic"}}>{reason}</p>
            <p style={{fontSize:11,color:"#8a8078",marginBottom:3}}>Approved by:</p>
            <p style={{fontSize:13,fontWeight:700,color:"#7c2d12"}}>{String.fromCharCode(0xD83D,0xDD13)} {manager?.manager_name}</p>
          </div>
          
          <p style={{fontSize:11,color:"#dc2626",fontWeight:700,marginBottom:11,textAlign:"center"}}>This action cannot be undone</p>
          
          <div style={{display:"flex",gap:6}}>
            <button onClick={()=>setStep("reason")} style={{flex:1,padding:"15px",background:"#fff",border:"2px solid #ede8de",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>{"<"} Back</button>
            <button onClick={processVoid} disabled={submitting} style={{flex:2,padding:"15px",background:submitting?"#9ca3af":"linear-gradient(135deg,#dc2626,#991b1b)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:14,cursor:submitting?"not-allowed":"pointer"}}>{submitting?"Processing...":(String.fromCharCode(0x2713)+" Confirm "+voidType.toUpperCase().replace("-"," "))}</button>
          </div>
        </div>
      </div>
    </div>;
  }
  
  // STEP 5: Done - ask "Print receipt? Yes/No"
  var doneAmount=(voidType==="partial-refund"||voidType==="voucher")?parseFloat(refundAmount||0):parseFloat(order.total);
  var orderForReceipt={
    ...order,
    voidType:voidType,
    voidAmount:doneAmount,
    voidReason:reason,
    voidApprovedBy:manager?.manager_name||"Manager",
    voucherCode:voucherCode,
  };
  
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",zIndex:9400,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
    <div style={{background:"#fafaf5",color:"#1a1208",borderRadius:14,maxWidth:480,width:"100%",overflow:"hidden",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
      <div style={{background:voidType==="voucher"?"linear-gradient(135deg,#7c3aed,#a855f7)":"linear-gradient(135deg,#059669,#047857)",color:"#fff",padding:"22px 20px",textAlign:"center"}}>
        <p style={{fontSize:48,marginBottom:5}}>{voidType==="voucher"?String.fromCharCode(0xD83C,0xDF81):String.fromCharCode(0x2713)}</p>
        <h2 style={{fontSize:22,fontWeight:700}}>{voidType==="voucher"?"VOUCHER ISSUED":voidType.toUpperCase().replace("-"," ")+" Recorded"}</h2>
      </div>
      
      <div style={{padding:18}}>
        {/* Voucher code prominent display */}
        {voidType==="voucher"&&voucherCode&&<div style={{padding:18,background:"#fff",borderRadius:11,border:"4px dashed #7c3aed",marginBottom:14,textAlign:"center"}}>
          <p style={{fontSize:11,color:"#7c3aed",fontWeight:700,letterSpacing:2,marginBottom:6}}>VOUCHER CODE</p>
          <p style={{fontSize:48,fontWeight:700,color:"#7c3aed",fontFamily:"'Courier New',monospace",letterSpacing:8,lineHeight:1,marginBottom:6}}>{voucherCode}</p>
          <p style={{fontSize:13,color:"#1a1208",fontWeight:700}}>Value: {fmt(doneAmount)}</p>
          <p style={{fontSize:11,color:"#8a8078",marginTop:5}}>Valid 90 days from today</p>
        </div>}

        {/* Summary */}
        <div style={{padding:11,background:"#f7f3ee",borderRadius:9,marginBottom:14,fontSize:12}}>
          <p style={{marginBottom:3}}><b>Type:</b> {voidType.toUpperCase().replace("-"," ")}</p>
          <p style={{marginBottom:3}}><b>Amount:</b> {fmt(doneAmount)}</p>
          <p style={{marginBottom:3}}><b>Approved by:</b> {manager?.manager_name||"Manager"}</p>
          <p><b>Reason:</b> {reason}</p>
        </div>

        <p style={{fontSize:14,fontWeight:700,marginBottom:11,textAlign:"center"}}>{String.fromCharCode(0xD83D,0xDDA8,0xFE0F)} Do you want to print a receipt?</p>
        
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
          <button onClick={onClose} style={{padding:"16px",background:"#fff",border:"2px solid #ede8de",color:"#1a1208",borderRadius:11,fontWeight:700,fontSize:14,cursor:"pointer"}}>{String.fromCharCode(0x274C)} No - Skip</button>
          <button onClick={()=>{
            // Print appropriate receipt based on type
            if(voidType==="voucher"){
              printVoucherReceipt(orderForReceipt,branch);
            }else{
              printRefundReceipt(orderForReceipt,branch);
            }
            // Close after a short delay
            setTimeout(()=>onClose(),300);
          }} style={{padding:"16px",background:"linear-gradient(135deg,#059669,#10b981)",color:"#fff",border:"none",borderRadius:11,fontWeight:700,fontSize:14,cursor:"pointer"}}>{String.fromCharCode(0x2713)} Yes - Print</button>
        </div>
        
        <p style={{fontSize:10,color:"#8a8078",fontStyle:"italic",textAlign:"center",marginTop:11}}>You can reprint anytime from Admin {String.fromCharCode(0x2192)} Orders</p>
      </div>
    </div>
  </div>;
}

// ============================================================
// SHIFT OPEN SCREEN - enter opening cash float
// ============================================================
function ShiftOpenScreen({branch,user,onCancel,onOpened}){
  var [openingFloat,setOpeningFloat]=useState("100.00");
  var [submitting,setSubmitting]=useState(false);
  
  var press=(k)=>{
    if(k==="DEL")setOpeningFloat(p=>String(p).slice(0,-1));
    else if(k==="CLR")setOpeningFloat("");
    else if(k==="."){if(!String(openingFloat).includes("."))setOpeningFloat(p=>String(p)+".");}
    else setOpeningFloat(p=>String(p)+k);
  };
  
  var startShift=()=>{
    var f=parseFloat(openingFloat||0);
    if(f<0){alert("Float cannot be negative");return;}
    setSubmitting(true);
    dbOpenShift(branch?.id,user?.name||"Staff",f).then(r=>{
      setSubmitting(false);
      if(r.error){alert("Failed: "+JSON.stringify(r.error));return;}
      onOpened(r.data);
    });
  };
  
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.92)",zIndex:9300,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
    <div style={{background:"#fafaf5",color:"#1a1208",borderRadius:14,maxWidth:480,width:"100%",overflow:"hidden",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
      <div style={{background:"linear-gradient(135deg,#059669,#047857)",color:"#fff",padding:"18px 22px",textAlign:"center"}}>
        <p style={{fontSize:36,marginBottom:5}}>{String.fromCharCode(0xD83C,0xDF05)}</p>
        <h2 style={{fontSize:22,fontWeight:700}}>Open New Shift</h2>
        <p style={{fontSize:12,opacity:.85,marginTop:5}}>{user?.name} - {new Date().toLocaleString("en-GB",{weekday:"long",day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"})}</p>
      </div>
      
      <div style={{padding:20}}>
        <p style={{fontSize:12,color:"#8a8078",marginBottom:11,textAlign:"center"}}>Count the cash currently in the drawer (the opening float). This is what you'll have at the start of your shift.</p>
        
        <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5,textAlign:"center"}}>OPENING CASH FLOAT</p>
        <div style={{padding:"16px",background:"#fff",borderRadius:11,border:"3px solid #059669",fontSize:36,fontWeight:700,textAlign:"center",fontFamily:"'Courier New',monospace",marginBottom:11}}>{String.fromCharCode(0xA3)}{openingFloat||"0.00"}</div>
        
        <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:4}}>QUICK AMOUNTS</p>
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:5,marginBottom:9}}>
          {["50","100","150","200"].map(v=><button key={v} onClick={()=>setOpeningFloat(v+".00")} style={{padding:"10px 4px",background:"#fff",border:"2px solid #ede8de",borderRadius:7,fontWeight:700,fontSize:13,cursor:"pointer"}}>{String.fromCharCode(0xA3)}{v}</button>)}
        </div>
        
        <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:4}}>NUMBER PAD</p>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:5,marginBottom:11}}>
          {["1","2","3","4","5","6","7","8","9",".","0","DEL"].map(k=><button key={k} onClick={()=>press(k)} style={{padding:"14px",fontSize:18,fontWeight:700,background:k==="DEL"?"linear-gradient(180deg,#fbbf24,#d97706)":"linear-gradient(180deg,#fff,#f5f0e8)",color:k==="DEL"?"#fff":"#1a1208",border:"1px solid "+(k==="DEL"?"transparent":"#d4b896"),borderRadius:7,cursor:"pointer",boxShadow:"0 2px 0 rgba(0,0,0,.15)"}}>{k==="DEL"?String.fromCharCode(0x232B):k}</button>)}
        </div>
        
        <div style={{display:"flex",gap:6}}>
          <button onClick={onCancel} style={{flex:1,padding:"15px",background:"#fff",border:"2px solid #ede8de",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>Cancel</button>
          <button onClick={startShift} disabled={submitting} style={{flex:2,padding:"15px",background:submitting?"#9ca3af":"linear-gradient(135deg,#059669,#10b981)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:14,cursor:submitting?"not-allowed":"pointer"}}>{submitting?"Opening...":(String.fromCharCode(0x2713)+" Start My Shift")}</button>
        </div>
      </div>
    </div>
  </div>;
}

// ============================================================
// SHIFT CLOSE SCREEN - count cash + show variance
// ============================================================
function ShiftCloseScreen({shift,onCancel,onClosed,branch,push}){
  var [actualCash,setActualCash]=useState("");
  var [notes,setNotes]=useState("");
  var [submitting,setSubmitting]=useState(false);
  
  var openingFloat=parseFloat(shift?.opening_float||0);
  var cashSales=parseFloat(shift?.cash_sales||0);
  var cardSales=parseFloat(shift?.card_sales||0);
  var tips=parseFloat(shift?.tips_collected||0);
  var expectedCash=openingFloat+cashSales;
  var actualNum=parseFloat(actualCash||0);
  var variance=actualNum-expectedCash;
  
  var press=(k)=>{
    if(k==="DEL")setActualCash(p=>String(p).slice(0,-1));
    else if(k==="CLR")setActualCash("");
    else if(k==="."){if(!String(actualCash).includes("."))setActualCash(p=>String(p)+".");}
    else setActualCash(p=>String(p)+k);
  };
  
  var closeShift=()=>{
    if(!actualCash){alert("Please enter actual cash count");return;}
    setSubmitting(true);
    dbCloseShift(shift.id,actualNum,notes).then(r=>{
      setSubmitting(false);
      if(r.error){alert("Failed: "+JSON.stringify(r.error));return;}
      push&&push({title:"Shift closed",body:"Variance: "+fmt(r.variance),color:Math.abs(r.variance)<0.5?"#059669":"#dc2626"});
      onClosed(r.data);
    });
  };
  
  var varianceColor=Math.abs(variance)<0.5?"#059669":(Math.abs(variance)<5?"#d97706":"#dc2626");
  
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.92)",zIndex:9300,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
    <div style={{background:"#fafaf5",color:"#1a1208",borderRadius:14,maxWidth:520,width:"100%",maxHeight:"96vh",overflow:"hidden",display:"flex",flexDirection:"column",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
      <div style={{background:"linear-gradient(135deg,#dc2626,#991b1b)",color:"#fff",padding:"18px 22px",textAlign:"center"}}>
        <p style={{fontSize:36,marginBottom:5}}>{String.fromCharCode(0xD83C,0xDF1A)}</p>
        <h2 style={{fontSize:22,fontWeight:700}}>Close Shift</h2>
        <p style={{fontSize:12,opacity:.85,marginTop:5}}>{shift.staff_name} - opened {new Date(shift.opened_at).toLocaleTimeString("en-GB",{hour:"2-digit",minute:"2-digit"})}</p>
      </div>
      
      <div style={{flex:1,overflowY:"auto",padding:18}}>
        {/* Expected breakdown */}
        <div style={{padding:13,background:"#fff",borderRadius:11,border:"2px solid #ede8de",marginBottom:14}}>
          <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:2,marginBottom:7}}>EXPECTED IN DRAWER</p>
          <table style={{width:"100%",fontSize:13}}>
            <tbody>
              <tr><td style={{padding:"4px 0"}}>Opening float</td><td style={{textAlign:"right",fontWeight:700,fontFamily:"'Courier New',monospace"}}>{fmt(openingFloat)}</td></tr>
              <tr><td style={{padding:"4px 0"}}>+ Cash sales</td><td style={{textAlign:"right",fontWeight:700,fontFamily:"'Courier New',monospace"}}>{fmt(cashSales)}</td></tr>
              <tr style={{borderTop:"2px solid #1a1208"}}><td style={{padding:"7px 0",fontWeight:700,fontSize:14}}>Expected cash</td><td style={{textAlign:"right",fontWeight:700,fontSize:18,color:"#059669",fontFamily:"'Courier New',monospace",padding:"7px 0"}}>{fmt(expectedCash)}</td></tr>
            </tbody>
          </table>
          <div style={{marginTop:8,paddingTop:8,borderTop:"1px dashed #ede8de",fontSize:11,color:"#8a8078"}}>
            <p>Card sales: {fmt(cardSales)}</p>
            <p>Tips collected: {fmt(tips)}</p>
          </div>
        </div>

        {/* Actual cash count */}
        <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5,textAlign:"center"}}>COUNT CASH IN DRAWER NOW</p>
        <div style={{padding:"16px",background:"#fff",borderRadius:11,border:"3px solid #d4952a",fontSize:34,fontWeight:700,textAlign:"center",fontFamily:"'Courier New',monospace",marginBottom:11}}>{String.fromCharCode(0xA3)}{actualCash||"0.00"}</div>
        
        <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:4}}>NUMBER PAD</p>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:5,marginBottom:11}}>
          {["1","2","3","4","5","6","7","8","9",".","0","DEL"].map(k=><button key={k} onClick={()=>press(k)} style={{padding:"12px",fontSize:18,fontWeight:700,background:k==="DEL"?"linear-gradient(180deg,#fbbf24,#d97706)":"linear-gradient(180deg,#fff,#f5f0e8)",color:k==="DEL"?"#fff":"#1a1208",border:"1px solid "+(k==="DEL"?"transparent":"#d4b896"),borderRadius:7,cursor:"pointer",boxShadow:"0 2px 0 rgba(0,0,0,.15)"}}>{k==="DEL"?String.fromCharCode(0x232B):k}</button>)}
        </div>
        
        {/* Variance display */}
        {actualCash&&<div style={{padding:"14px",background:varianceColor==="#059669"?"#d1fae5":(varianceColor==="#d97706"?"#fef3c7":"#fee2e2"),borderRadius:11,marginBottom:11,textAlign:"center",border:"2px solid "+varianceColor}}>
          <p style={{fontSize:10,color:varianceColor,fontWeight:700,letterSpacing:2,marginBottom:5}}>{Math.abs(variance)<0.01?"PERFECT!":(variance>0?"OVER (extra cash)":"SHORT (missing cash)")}</p>
          <p style={{fontSize:32,fontWeight:700,color:varianceColor,fontFamily:"'Courier New',monospace",lineHeight:1}}>{variance>=0?"+":""}{fmt(variance)}</p>
        </div>}
        
        {/* Notes */}
        <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:4}}>NOTES (OPTIONAL)</p>
        <textarea value={notes} onChange={e=>setNotes(e.target.value)} placeholder="e.g., 5 pounds short - missed receipt for tea" rows={2} style={{width:"100%",padding:"10px",border:"2px solid #ede8de",borderRadius:7,fontSize:13,fontFamily:"inherit",resize:"vertical",marginBottom:5,boxSizing:"border-box"}}/>
      </div>
      
      <div style={{padding:11,background:"#fff",borderTop:"1px solid #ede8de",display:"flex",gap:6}}>
        <button onClick={onCancel} style={{flex:1,padding:"15px",background:"#fff",border:"2px solid #ede8de",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>Cancel</button>
        <button onClick={closeShift} disabled={submitting||!actualCash} style={{flex:2,padding:"15px",background:submitting||!actualCash?"#9ca3af":"linear-gradient(135deg,#dc2626,#991b1b)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:14,cursor:submitting||!actualCash?"not-allowed":"pointer"}}>{submitting?"Closing...":(String.fromCharCode(0x2713)+" Close Shift")}</button>
      </div>
    </div>
  </div>;
}

// PHONE ORDER CUSTOMER POPUP - opens from POS to capture customer for delivery/collection
// SLIDE-UP KEYBOARD - reusable touch keyboard that appears from bottom
function SlideUpKeyboard({mode,value,onChange,onSubmit,onClose,sizePreset}){
  // mode: "numeric" (phone), "alpha" (text), "alphanumeric" (postcode/email)
  // sizePreset: "small" | "medium" | "large"
  var [shifted,setShifted]=useState(true); // capital letters by default for postcode
  
  // Size presets - tuned for visibility (keyboard + popup must both fit)
  var sizes={
    small:{btnH:46,btnFs:16,gap:4,padding:8,labelFs:11,displayFs:22},
    medium:{btnH:58,btnFs:20,gap:5,padding:10,labelFs:12,displayFs:26},
    large:{btnH:72,btnFs:24,gap:6,padding:12,labelFs:13,displayFs:30},
  };
  var sz=sizes[sizePreset||"medium"];

  var typeChar=k=>{
    if(k==="DEL")onChange(value.slice(0,-1));
    else if(k==="SPACE")onChange(value+" ");
    else if(k==="SHIFT")setShifted(!shifted);
    else if(k==="OK"){if(onSubmit)onSubmit();}
    else if(k==="CLOSE"){if(onClose)onClose();}
    else{
      var char=mode==="alpha"||mode==="alphanumeric"?(shifted?k.toUpperCase():k.toLowerCase()):k;
      onChange(value+char);
    }
  };

  // Button style - warm restaurant brand
  var btnStyle=(special)=>{
    var baseBg=special==="action"?"linear-gradient(180deg,#bf4626,#a3391d)":
               special==="del"?"linear-gradient(180deg,#dc2626,#991b1b)":
               special==="ok"?"linear-gradient(180deg,#059669,#047857)":
               special==="space"?"linear-gradient(180deg,#fff,#fafaf5)":
               "linear-gradient(180deg,#fff,#f5f0e8)";
    var color=special==="action"||special==="del"||special==="ok"?"#fff":"#1a1208";
    return {
      height:sz.btnH,
      background:baseBg,
      color:color,
      border:"1px solid "+(special==="action"||special==="del"||special==="ok"?"transparent":"#d4b896"),
      borderRadius:10,
      fontSize:sz.btnFs,
      fontWeight:700,
      cursor:"pointer",
      boxShadow:"0 2px 0 rgba(0,0,0,.15), 0 4px 8px rgba(0,0,0,.08), inset 0 1px 0 rgba(255,255,255,.5)",
      transition:"transform .08s, box-shadow .08s",
      userSelect:"none",
      WebkitUserSelect:"none",
      display:"flex",
      alignItems:"center",
      justifyContent:"center",
      letterSpacing:.5,
    };
  };

  var pressDown=e=>{e.currentTarget.style.transform="translateY(2px)";e.currentTarget.style.boxShadow="0 0 0 rgba(0,0,0,.15), 0 2px 4px rgba(0,0,0,.08), inset 0 1px 0 rgba(255,255,255,.5)";};
  var pressUp=e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="0 2px 0 rgba(0,0,0,.15), 0 4px 8px rgba(0,0,0,.08), inset 0 1px 0 rgba(255,255,255,.5)";};

  // Define keys based on mode
  var renderKeys=()=>{
    if(mode==="numeric"){
      return <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:sz.gap}}>
        {["1","2","3","4","5","6","7","8","9"].map(k=><button key={k} onClick={()=>typeChar(k)} onMouseDown={pressDown} onMouseUp={pressUp} onMouseLeave={pressUp} onTouchStart={pressDown} onTouchEnd={pressUp} style={btnStyle()}>{k}</button>)}
        <button onClick={()=>typeChar("DEL")} onMouseDown={pressDown} onMouseUp={pressUp} onMouseLeave={pressUp} onTouchStart={pressDown} onTouchEnd={pressUp} style={btnStyle("del")}>{String.fromCharCode(0x232B)}</button>
        <button onClick={()=>typeChar("0")} onMouseDown={pressDown} onMouseUp={pressUp} onMouseLeave={pressUp} onTouchStart={pressDown} onTouchEnd={pressUp} style={btnStyle()}>0</button>
        <button onClick={()=>typeChar("OK")} onMouseDown={pressDown} onMouseUp={pressUp} onMouseLeave={pressUp} onTouchStart={pressDown} onTouchEnd={pressUp} style={btnStyle("ok")}>{String.fromCharCode(0x2713)}</button>
      </div>;
    }
    // alpha or alphanumeric
    var row1=mode==="alphanumeric"?["1","2","3","4","5","6","7","8","9","0"]:["q","w","e","r","t","y","u","i","o","p"];
    var row2=mode==="alphanumeric"?["q","w","e","r","t","y","u","i","o","p"]:["a","s","d","f","g","h","j","k","l"];
    var row3=mode==="alphanumeric"?["a","s","d","f","g","h","j","k","l"]:["z","x","c","v","b","n","m"];
    var row4=mode==="alphanumeric"?["z","x","c","v","b","n","m"]:[];

    return <div style={{display:"flex",flexDirection:"column",gap:sz.gap}}>
      <div style={{display:"grid",gridTemplateColumns:"repeat("+row1.length+",1fr)",gap:sz.gap}}>
        {row1.map(k=><button key={k} onClick={()=>typeChar(k)} onMouseDown={pressDown} onMouseUp={pressUp} onMouseLeave={pressUp} onTouchStart={pressDown} onTouchEnd={pressUp} style={btnStyle()}>{shifted?k.toUpperCase():k}</button>)}
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat("+row2.length+",1fr)",gap:sz.gap,padding:"0 "+(mode==="alpha"?sz.btnH/2:0)+"px"}}>
        {row2.map(k=><button key={k} onClick={()=>typeChar(k)} onMouseDown={pressDown} onMouseUp={pressUp} onMouseLeave={pressUp} onTouchStart={pressDown} onTouchEnd={pressUp} style={btnStyle()}>{shifted?k.toUpperCase():k}</button>)}
      </div>
      <div style={{display:"grid",gridTemplateColumns:mode==="alpha"?"1.5fr repeat("+row3.length+",1fr) 1.5fr":"repeat("+(row3.length+1)+",1fr) 1.5fr",gap:sz.gap}}>
        {mode==="alpha"&&<button onClick={()=>typeChar("SHIFT")} onMouseDown={pressDown} onMouseUp={pressUp} onMouseLeave={pressUp} onTouchStart={pressDown} onTouchEnd={pressUp} style={btnStyle(shifted?"action":"")}>{shifted?String.fromCharCode(0x21EA):String.fromCharCode(0x21E7)}</button>}
        {row3.map(k=><button key={k} onClick={()=>typeChar(k)} onMouseDown={pressDown} onMouseUp={pressUp} onMouseLeave={pressUp} onTouchStart={pressDown} onTouchEnd={pressUp} style={btnStyle()}>{shifted?k.toUpperCase():k}</button>)}
        {mode==="alphanumeric"&&row4.length===0&&<button onClick={()=>typeChar("SHIFT")} onMouseDown={pressDown} onMouseUp={pressUp} onMouseLeave={pressUp} onTouchStart={pressDown} onTouchEnd={pressUp} style={btnStyle(shifted?"action":"")}>{shifted?String.fromCharCode(0x21EA):String.fromCharCode(0x21E7)}</button>}
        <button onClick={()=>typeChar("DEL")} onMouseDown={pressDown} onMouseUp={pressUp} onMouseLeave={pressUp} onTouchStart={pressDown} onTouchEnd={pressUp} style={btnStyle("del")}>{String.fromCharCode(0x232B)}</button>
      </div>
      {row4.length>0&&<div style={{display:"grid",gridTemplateColumns:"1.5fr repeat("+row4.length+",1fr) 1.5fr",gap:sz.gap}}>
        <button onClick={()=>typeChar("SHIFT")} onMouseDown={pressDown} onMouseUp={pressUp} onMouseLeave={pressUp} onTouchStart={pressDown} onTouchEnd={pressUp} style={btnStyle(shifted?"action":"")}>{shifted?String.fromCharCode(0x21EA):String.fromCharCode(0x21E7)}</button>
        {row4.map(k=><button key={k} onClick={()=>typeChar(k)} onMouseDown={pressDown} onMouseUp={pressUp} onMouseLeave={pressUp} onTouchStart={pressDown} onTouchEnd={pressUp} style={btnStyle()}>{shifted?k.toUpperCase():k}</button>)}
        <button onClick={()=>typeChar("DEL")} onMouseDown={pressDown} onMouseUp={pressUp} onMouseLeave={pressUp} onTouchStart={pressDown} onTouchEnd={pressUp} style={btnStyle("del")}>{String.fromCharCode(0x232B)}</button>
      </div>}
      <div style={{display:"grid",gridTemplateColumns:"1fr 4fr 1fr",gap:sz.gap}}>
        <button onClick={()=>typeChar("CLOSE")} onMouseDown={pressDown} onMouseUp={pressUp} onMouseLeave={pressUp} onTouchStart={pressDown} onTouchEnd={pressUp} style={btnStyle()}>{String.fromCharCode(0x2715)}</button>
        <button onClick={()=>typeChar("SPACE")} onMouseDown={pressDown} onMouseUp={pressUp} onMouseLeave={pressUp} onTouchStart={pressDown} onTouchEnd={pressUp} style={btnStyle("space")}>SPACE</button>
        <button onClick={()=>typeChar("OK")} onMouseDown={pressDown} onMouseUp={pressUp} onMouseLeave={pressUp} onTouchStart={pressDown} onTouchEnd={pressUp} style={btnStyle("ok")}>{String.fromCharCode(0x2713)}</button>
      </div>
    </div>;
  };

  return <div style={{position:"fixed",bottom:0,left:0,right:0,background:"linear-gradient(180deg,#fafaf5,#f0e8d8)",borderTop:"3px solid #d4b896",boxShadow:"0 -8px 30px rgba(0,0,0,.2)",padding:sz.padding,zIndex:9999,animation:"slideUpKb .3s ease-out"}}>
    <style>{`@keyframes slideUpKb{from{transform:translateY(100%)}to{transform:translateY(0)}}`}</style>
    {renderKeys()}
  </div>;
}

function PhoneCustomerPopup({onClose,onCustomerReady,customers,setCustomers,push,branch,initialPhone}){
  var [step,setStep]=useState(initialPhone?"search":"phone"); // phone, search, existing, postcode, address, manual
  var [phone,setPhone]=useState(initialPhone||"");
  var [found,setFound]=useState(null);
  var [orderType,setOrderType]=useState("delivery");
  var [postcode,setPostcode]=useState("");
  var [postcodeOptions,setPostcodeOptions]=useState([]);
  var [lookingUp,setLookingUp]=useState(false);
  var [postcodeError,setPostcodeError]=useState("");
  var [selectedPostcode,setSelectedPostcode]=useState(null);
  var [doorNum,setDoorNum]=useState("");
  var [streetName,setStreetName]=useState("");
  var [name,setName]=useState("");
  var [notes,setNotes]=useState("");
  var [activeField,setActiveField]=useState(null); // 'phone','postcode','name','door','street','notes' or null
  var keyboardSize=(()=>{try{return localStorage.getItem("kb_size")||"medium";}catch(e){return "medium";}})();

  // On mount, if initialPhone provided, search immediately
  useEffect(()=>{
    if(initialPhone){
      var clean=initialPhone.replace(/\s+/g,"").replace(/^0/,"").replace(/^\+?44/,"0");
      var full=clean.startsWith("0")?clean:"0"+clean;
      var c=customers.find(x=>x.phone&&x.phone.replace(/\s+/g,"")===full);
      if(c){setFound(c);setName(c.name);setStep("existing");}
      else{setStep("postcode");}
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  // Auto-show keyboard for phone and postcode steps (always required)
  useEffect(()=>{
    if(step==="phone")setActiveField("phone");
    else if(step==="postcode")setActiveField("postcode");
    else setActiveField(null);
  },[step]);

  // Search by phone
  var searchPhone=()=>{
    var clean=phone.replace(/\s+/g,"").replace(/^0/,"").replace(/^\+?44/,"0");
    var full=clean.startsWith("0")?clean:"0"+clean;
    if(full.length<10){push({title:"Invalid phone",body:"Enter a valid UK phone number",color:"#dc2626"});return;}
    var c=customers.find(x=>x.phone&&x.phone.replace(/\s+/g,"")===full);
    if(c){setFound(c);setName(c.name);setStep("existing");}
    else{setStep("postcode");}
  };

  // Postcode lookup using postcodes.io (free)
  var lookupPostcodeIO=()=>{
    if(!postcode.trim()){push({title:"Enter postcode",body:"Type a postcode first",color:"#dc2626"});return;}
    setLookingUp(true);setPostcodeError("");setPostcodeOptions([]);
    var clean=postcode.trim().toUpperCase().replace(/\s+/g,"");
    // First try autocomplete (returns multiple matches)
    fetch("https://api.postcodes.io/postcodes/"+encodeURIComponent(clean)+"/autocomplete")
      .then(r=>r.json())
      .then(data=>{
        if(data.result&&data.result.length>0){
          // Get details for each suggestion (lat/lng to validate)
          var promises=data.result.slice(0,8).map(pc=>fetch("https://api.postcodes.io/postcodes/"+encodeURIComponent(pc)).then(r=>r.json()).catch(()=>null));
          Promise.all(promises).then(results=>{
            var valid=results.filter(r=>r&&r.result).map(r=>({
              postcode:r.result.postcode,
              lat:r.result.latitude,
              lng:r.result.longitude,
              area:r.result.admin_district||r.result.region||"",
              parish:r.result.parish||"",
            }));
            setPostcodeOptions(valid);
            setLookingUp(false);
            if(valid.length===0)setPostcodeError("No matches found. Try typing more or enter manually.");
          });
        }else{
          // Try direct lookup (full postcode)
          fetch("https://api.postcodes.io/postcodes/"+encodeURIComponent(clean))
            .then(r=>r.json())
            .then(data2=>{
              if(data2.result){
                setPostcodeOptions([{
                  postcode:data2.result.postcode,
                  lat:data2.result.latitude,
                  lng:data2.result.longitude,
                  area:data2.result.admin_district||"",
                  parish:data2.result.parish||"",
                }]);
              }else{
                setPostcodeError("Not a valid UK postcode. Type more or enter manually.");
              }
              setLookingUp(false);
            }).catch(()=>{setPostcodeError("Lookup failed - check internet");setLookingUp(false);});
        }
      })
      .catch(()=>{setPostcodeError("Lookup failed - check internet");setLookingUp(false);});
  };

  // Calculate distance from branch to selected postcode
  var calculateDistance=(lat,lng)=>{
    if(!branch||!branch.lat||!branch.lng)return 0;
    var R=3958.8; // miles
    var dLat=(lat-branch.lat)*Math.PI/180;
    var dLng=(lng-branch.lng)*Math.PI/180;
    var a=Math.sin(dLat/2)**2+Math.cos(branch.lat*Math.PI/180)*Math.cos(lat*Math.PI/180)*Math.sin(dLng/2)**2;
    var c=2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));
    return R*c;
  };

  // Confirm address & save customer
  var confirmAddress=()=>{
    if(!name.trim()){push({title:"Name required",body:"Enter customer name",color:"#dc2626"});return;}
    if(orderType==="delivery"){
      if(!doorNum.trim()){push({title:"Door number required",body:"Enter door/flat number",color:"#dc2626"});return;}
      if(!streetName.trim()){push({title:"Street required",body:"Enter street/road name",color:"#dc2626"});return;}
      if(!selectedPostcode&&!postcode.trim()){push({title:"Postcode required",body:"Enter postcode",color:"#dc2626"});return;}
    }
    var pcStr=selectedPostcode?selectedPostcode.postcode:postcode.toUpperCase();
    var addressLine1=doorNum+" "+streetName;
    var distance=selectedPostcode?calculateDistance(selectedPostcode.lat,selectedPostcode.lng):0;
    
    var c={
      id:"c"+Date.now(),
      phone:phone,
      name:name,
      address:{line1:addressLine1,postcode:pcStr,notes:notes},
      distance:distance,
      lastOrder:null,totalOrders:0,totalSpent:0,notes:"",
    };
    
    // Add to local state
    setCustomers(cs=>[...cs,c]);
    
    // Save to DB
    if(typeof dbSaveCustomer!=="undefined"){
      dbSaveCustomer({phone:phone,name:name,address:c.address,distance:distance,notes:""}).then(r=>{
        if(r&&r.data&&r.data.id){
          setCustomers(cs=>cs.map(x=>x.id===c.id?{...x,id:r.data.id,dbId:r.data.id}:x));
        }
      }).catch(e=>console.log("Customer save failed (kept locally):",e));
    }
    
    push({title:"Customer saved",body:c.name,color:"#059669"});
    onCustomerReady({customer:c,orderType:orderType});
  };

  // Existing customer - just confirm and continue
  var continueExisting=()=>{
    onCustomerReady({customer:found,orderType:orderType});
  };

  // On-screen keyboard helper
  // Helper: get current value/setter for active field
  var getActive=()=>{
    if(activeField==="phone")return [phone,setPhone,"numeric"];
    if(activeField==="postcode")return [postcode,setPostcode,"alphanumeric"];
    if(activeField==="name")return [name,setName,"alpha"];
    if(activeField==="door")return [doorNum,setDoorNum,"alphanumeric"];
    if(activeField==="street")return [streetName,setStreetName,"alpha"];
    if(activeField==="notes")return [notes,setNotes,"alpha"];
    return ["",()=>{},"alpha"];
  };
  var [activeVal,activeSetter,activeMode]=getActive();
  var submitActive=()=>{
    if(activeField==="phone")searchPhone();
    else if(activeField==="postcode")lookupPostcodeIO();
    else setActiveField(null); // close keyboard for text fields
  };

  // Calculate keyboard height based on size (5 rows of buttons + gaps + padding)
  var kbHeights={small:300,medium:370,large:450};
  var kbHeight=activeField?(kbHeights[keyboardSize]||370):0;

  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.5)",zIndex:9000,display:"flex",alignItems:"flex-start",justifyContent:"center",padding:"14px 14px 0 14px",paddingTop:14,overflow:"hidden"}}>
    <div style={{background:"#fafaf5",color:"#1a1208",borderRadius:14,maxWidth:600,width:"100%",height:"calc(100vh - "+(kbHeight+28)+"px)",maxHeight:"calc(100vh - "+(kbHeight+28)+"px)",display:"flex",flexDirection:"column",overflow:"hidden",boxShadow:"0 20px 50px rgba(0,0,0,.4)",transition:"height .3s, max-height .3s"}}>

      {/* Header */}
      <div style={{background:"linear-gradient(135deg,#1a1208,#3d2e22)",color:"#fff",padding:"14px 18px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <p style={{fontSize:11,color:"#d4952a",fontWeight:700,letterSpacing:2}}>PHONE ORDER</p>
          <h2 style={{fontSize:18,fontWeight:700}}>
            {step==="phone"?"Customer Phone Number":""}
            {step==="search"?"Searching...":""}
            {step==="existing"?"Existing Customer":""}
            {step==="postcode"?"New Customer - Postcode":""}
            {step==="address"?"Confirm Address":""}
          </h2>
        </div>
        <button onClick={onClose} style={{width:36,height:36,borderRadius:"50%",background:"rgba(255,255,255,.15)",color:"#fff",border:"none",cursor:"pointer",fontSize:18,fontWeight:700}}>x</button>
      </div>

      {/* Content - scrollable */}
      <div style={{flex:1,overflowY:"auto",padding:18}}>

        {/* STEP: PHONE ENTRY */}
        {step==="phone"&&<>
          <div style={{textAlign:"center",marginBottom:14}}>
            <div onClick={()=>setActiveField("phone")} style={{display:"inline-block",padding:"18px 30px",background:"#fff",borderRadius:13,fontSize:36,fontWeight:700,letterSpacing:4,minWidth:320,border:"3px solid #d4952a",color:"#1a1208",cursor:"text",boxShadow:"0 4px 12px rgba(0,0,0,.08)"}}>
              {phone||<span style={{color:"#d4b896"}}>0XXXXXXXXXX</span>}
            </div>
            <p style={{fontSize:13,color:"#8a8078",marginTop:10,fontWeight:600}}>Enter customer phone number using keyboard below</p>
          </div>
        </>}

        {/* STEP: EXISTING CUSTOMER */}
        {step==="existing"&&found&&<>
          <div style={{padding:14,background:"#d1fae5",border:"2px solid #059669",borderRadius:11,marginBottom:14}}>
            <p style={{fontSize:11,color:"#065f46",fontWeight:700,letterSpacing:1,marginBottom:5}}>{EM.check} CUSTOMER FOUND</p>
            <h3 style={{fontSize:20,fontWeight:700,color:"#065f46"}}>{found.name}</h3>
            <p style={{fontSize:13,color:"#065f46",marginTop:3}}>{found.phone}</p>
          </div>

          <div className="card" style={{padding:12,marginBottom:11}}>
            <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>SAVED ADDRESS</p>
            {found.address?<div>
              <p style={{fontSize:14,fontWeight:600}}>{found.address.line1||"(no address)"}</p>
              <p style={{fontSize:13,color:"#8a8078"}}>{found.address.postcode||""}</p>
              {found.distance>0&&<p style={{fontSize:12,color:"#bf4626",marginTop:3}}>{(typeof found.distance==="number"?found.distance.toFixed(1):found.distance)} miles from branch</p>}
            </div>:<p style={{fontSize:13,color:"#8a8078",fontStyle:"italic"}}>No saved address - will need to add</p>}
            <button onClick={()=>{setName(found.name);setDoorNum(found.address?.line1?.split(" ")[0]||"");setStreetName(found.address?.line1?.split(" ").slice(1).join(" ")||"");setPostcode(found.address?.postcode||"");setStep("postcode");}} style={{marginTop:10,padding:"7px 12px",background:"#f7f3ee",border:"1px solid #ede8de",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>Edit Address</button>
          </div>

          {found.totalOrders>0&&<div className="card" style={{padding:12,marginBottom:11,background:"#f5f3ff",borderLeft:"3px solid #7c3aed"}}>
            <p style={{fontSize:13,fontWeight:700,color:"#7c3aed"}}>{found.totalOrders} previous orders</p>
            <p style={{fontSize:12,color:"#7c3aed",marginTop:2}}>Total spent: {fmt(found.totalSpent||0)}</p>
          </div>}

          <p style={{fontSize:12,color:"#8a8078",fontWeight:700,marginBottom:6}}>Order Type:</p>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,marginBottom:14}}>
            {[["delivery","Delivery"],["collection","Collection"]].map(([t,l])=><button key={t} onClick={()=>setOrderType(t)} style={{padding:"14px",borderRadius:9,fontWeight:700,fontSize:13,background:orderType===t?"#bf4626":"#fff",color:orderType===t?"#fff":"#1a1208",border:"2px solid "+(orderType===t?"#bf4626":"#ede8de"),cursor:"pointer"}}>{l}</button>)}
          </div>

          <button onClick={continueExisting} style={{width:"100%",padding:"15px",background:"#059669",color:"#fff",border:"none",borderRadius:10,fontSize:15,fontWeight:700,cursor:"pointer"}}>{EM.check} Continue with this customer</button>
        </>}

        {/* STEP: POSTCODE ENTRY */}
        {step==="postcode"&&<>
          <p style={{fontSize:12,color:"#8a8078",marginBottom:8}}>Phone: <span style={{fontWeight:700,color:"#1a1208"}}>{phone}</span></p>
          <div style={{marginBottom:14}}>
            <label style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5,display:"block"}}>POSTCODE</label>
            <div onClick={()=>setActiveField("postcode")} style={{padding:"16px 22px",background:"#fff",borderRadius:11,fontSize:30,fontWeight:700,letterSpacing:3,border:"3px solid #d4952a",color:"#1a1208",textAlign:"center",cursor:"text",boxShadow:"0 4px 12px rgba(0,0,0,.08)"}}>
              {postcode||<span style={{color:"#d4b896"}}>E1 6AN</span>}
            </div>
          </div>

          <button onClick={lookupPostcodeIO} disabled={!postcode||lookingUp} style={{width:"100%",padding:"15px",background:lookingUp?"#8a8078":"linear-gradient(135deg,#2563eb,#3b82f6)",color:"#fff",border:"none",borderRadius:10,fontSize:15,fontWeight:700,cursor:lookingUp?"not-allowed":"pointer",marginBottom:11,boxShadow:"0 3px 8px rgba(37,99,235,.3)"}}>
            {lookingUp?"Looking up...":(String.fromCharCode(0xD83D,0xDD0D)+" Search Postcodes")}
          </button>

          {/* Postcode results */}
          {postcodeError&&<div style={{padding:11,background:"#fee2e2",border:"1px solid #dc2626",borderRadius:7,fontSize:12,color:"#991b1b",marginBottom:11}}>{postcodeError}</div>}

          {postcodeOptions.length>0&&<div style={{marginBottom:11}}>
            <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:6}}>SELECT POSTCODE ({postcodeOptions.length} found)</p>
            <div style={{display:"flex",flexDirection:"column",gap:4,maxHeight:200,overflowY:"auto"}}>
              {postcodeOptions.map((pc,i)=><button key={i} onClick={()=>{setSelectedPostcode(pc);setPostcode(pc.postcode);setStep("address");}} style={{padding:"12px 14px",background:"#fff",border:"2px solid #ede8de",borderRadius:8,cursor:"pointer",textAlign:"left",fontSize:14,fontWeight:700,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span>{pc.postcode}</span>
                <span style={{fontSize:11,color:"#8a8078",fontWeight:400}}>{pc.area} - {calculateDistance(pc.lat,pc.lng).toFixed(1)} mi</span>
              </button>)}
            </div>
          </div>}

          <button onClick={()=>{setSelectedPostcode(null);setStep("address");}} style={{width:"100%",padding:"11px",background:"transparent",color:"#8a8078",border:"2px dashed #ede8de",borderRadius:9,fontSize:12,fontWeight:700,cursor:"pointer"}}>Skip - Enter Address Manually</button>
        </>}

        {/* STEP: ADDRESS DETAILS */}
        {step==="address"&&<>
          <p style={{fontSize:12,color:"#8a8078",marginBottom:11}}>Phone: <span style={{fontWeight:700,color:"#1a1208"}}>{phone}</span> {selectedPostcode&&<>- Postcode: <span style={{fontWeight:700,color:"#1a1208"}}>{selectedPostcode.postcode}</span> ({calculateDistance(selectedPostcode.lat,selectedPostcode.lng).toFixed(1)} mi)</>}</p>

          <label style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:4,display:"block"}}>CUSTOMER NAME</label>
          <input value={name} onChange={e=>setName(e.target.value)} onClick={()=>setActiveField("name")} placeholder="Mr Smith" autoFocus className="field" style={{marginBottom:11,fontSize:18,padding:"14px 16px",borderColor:activeField==="name"?"#bf4626":undefined,borderWidth:activeField==="name"?2:1}}/>

          <div style={{display:"grid",gridTemplateColumns:"1fr 2fr",gap:8,marginBottom:11}}>
            <div>
              <label style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:4,display:"block"}}>DOOR / FLAT</label>
              <input value={doorNum} onChange={e=>setDoorNum(e.target.value)} onClick={()=>setActiveField("door")} placeholder="23" className="field" style={{fontSize:18,padding:"14px 16px",borderColor:activeField==="door"?"#bf4626":undefined,borderWidth:activeField==="door"?2:1}}/>
            </div>
            <div>
              <label style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:4,display:"block"}}>STREET / ROAD</label>
              <input value={streetName} onChange={e=>setStreetName(e.target.value)} onClick={()=>setActiveField("street")} placeholder="High Street" className="field" style={{fontSize:18,padding:"14px 16px",borderColor:activeField==="street"?"#bf4626":undefined,borderWidth:activeField==="street"?2:1}}/>
            </div>
          </div>

          {!selectedPostcode&&<>
            <label style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:4,display:"block"}}>POSTCODE</label>
            <input value={postcode} onChange={e=>setPostcode(e.target.value.toUpperCase())} onClick={()=>setActiveField("postcode")} placeholder="E1 6AN" className="field" style={{marginBottom:11,fontSize:18,padding:"14px 16px",textTransform:"uppercase",borderColor:activeField==="postcode"?"#bf4626":undefined,borderWidth:activeField==="postcode"?2:1}}/>
          </>}

          <label style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:4,display:"block"}}>NOTES (OPTIONAL)</label>
          <input value={notes} onChange={e=>setNotes(e.target.value)} onClick={()=>setActiveField("notes")} placeholder="Gate code, buzzer name..." className="field" style={{marginBottom:14,fontSize:16,padding:"12px 16px",borderColor:activeField==="notes"?"#bf4626":undefined,borderWidth:activeField==="notes"?2:1}}/>

          <p style={{fontSize:12,color:"#8a8078",fontWeight:700,marginBottom:6}}>Order Type:</p>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6,marginBottom:14}}>
            {[["delivery","Delivery"],["collection","Collection"]].map(([t,l])=><button key={t} onClick={()=>setOrderType(t)} style={{padding:"14px",borderRadius:9,fontWeight:700,fontSize:13,background:orderType===t?"#bf4626":"#fff",color:orderType===t?"#fff":"#1a1208",border:"2px solid "+(orderType===t?"#bf4626":"#ede8de"),cursor:"pointer"}}>{l}</button>)}
          </div>

          <div style={{display:"grid",gridTemplateColumns:"1fr 2fr",gap:6}}>
            <button onClick={()=>setStep("postcode")} style={{padding:"15px",background:"#fff",color:"#1a1208",border:"2px solid #ede8de",borderRadius:10,fontSize:13,fontWeight:700,cursor:"pointer"}}>{"< Back"}</button>
            <button onClick={confirmAddress} style={{padding:"15px",background:"#059669",color:"#fff",border:"none",borderRadius:10,fontSize:14,fontWeight:700,cursor:"pointer"}}>{EM.check} Save & Take Order</button>
          </div>
        </>}

      </div>
    </div>
    
    {/* Slide-up keyboard - shows when activeField is set */}
    {activeField&&<SlideUpKeyboard mode={activeMode} value={activeVal} onChange={activeSetter} onSubmit={submitActive} onClose={()=>setActiveField(null)} sizePreset={keyboardSize}/>}
  </div>;
}

function PosV(props){
  var [uiStyle,setUiStyle]=useState(()=>{
    try{return localStorage.getItem("pos_ui_style")||"modern";}catch(e){return "modern";}
  });
  var [showDash,setShowDash]=useState(()=>{
    try{return localStorage.getItem("show_pos_dashboard")==="1";}catch(e){return false;}
  });
  var [dashOpen,setDashOpen]=useState(showDash); // true means show dashboard, false means show POS
  // Listen for storage changes (when user changes UI in settings)
  useEffect(()=>{
    var check=()=>{
      try{
        var current=localStorage.getItem("pos_ui_style")||"modern";
        var dashSetting=localStorage.getItem("show_pos_dashboard")==="1";
        if(current!==uiStyle)setUiStyle(current);
        if(dashSetting!==showDash)setShowDash(dashSetting);
      }catch(e){}
    };
    var interval=setInterval(check,1000);
    return()=>clearInterval(interval);
  },[uiStyle,showDash]);

  // If dashboard is enabled and currently showing, render dashboard
  if(showDash&&dashOpen){
    return <PosDashboard {...props} onOpenPos={()=>setDashOpen(false)}/>;
  }

  // Otherwise show selected POS UI with a "Back to Dashboard" button if dashboard is enabled
  var enhancedProps={...props,onBackToDash:showDash?()=>setDashOpen(true):null};
  if(uiStyle==="classic")return <PosVClassic {...enhancedProps}/>;
  if(uiStyle==="compact")return <PosVCompact {...enhancedProps}/>;
  return <PosVModern {...enhancedProps}/>;
}

// POS DASHBOARD - POSCUBE-style home screen with action tiles
function PosDashboard({orders,setOrders,user,branch,tables,setTables,stations,menu,customers,setView,onOpenPos,setUser,push,restaurant}){
  var [modalView,setModalView]=useState(null);
  var [currentShift,setCurrentShift]=useState(null);
  var [showShiftOpen,setShowShiftOpen]=useState(false);
  var [showShiftClose,setShowShiftClose]=useState(false);
  var [showTablePicker,setShowTablePicker]=useState(false);
  // eslint-disable-next-line no-unused-vars
  var [, setFsTick]=useState(0); // Re-render trigger when fullscreen changes
  var shiftsEnabled=(()=>{try{return localStorage.getItem("shifts_enabled")==="1";}catch(e){return false;}})();
  
  // Listen for fullscreen changes to update UI
  useEffect(()=>{
    var handler=()=>setFsTick(t=>t+1);
    document.addEventListener("fullscreenchange",handler);
    return()=>document.removeEventListener("fullscreenchange",handler);
  },[]);
  
  // Auto-enter fullscreen if setting enabled
  useEffect(()=>{
    var autoFs=false;
    try{autoFs=localStorage.getItem("pos_auto_fullscreen")==="1";}catch(e){}
    if(autoFs&&!document.fullscreenElement){
      // Small delay so it doesn't trigger immediately
      setTimeout(()=>{
        try{
          document.documentElement.requestFullscreen().catch(()=>{});
        }catch(e){}
      },500);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  
  // Load active shift on mount
  useEffect(()=>{
    if(!shiftsEnabled||!user||!branch)return;
    dbFetchOpenShift(branch.id,user.name).then(s=>{
      if(s)setCurrentShift(s);
    }).catch(e=>console.log("Shift load:",e));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[user?.name,branch?.id]); // null, "incoming", "kitchen", "tables", "driver", "bookings", "report"
  // Safety: ensure all props have defaults to prevent crashes
  orders=orders||[];
  tables=tables||[];
  if(!setView)setView=()=>{};
  if(!onOpenPos)onOpenPos=()=>{};
  // Live counts
  var pendingOrders=orders.filter(o=>!o.paid&&o.status!=="cancelled"&&(!branch||!o.branchId||o.branchId===branch.id));
  var dineInActive=pendingOrders.filter(o=>o.type==="dine-in"||o.type==="eatin").length;
  var takeawayActive=pendingOrders.filter(o=>o.type==="takeaway"||o.type==="collection").length;
  var deliveryActive=pendingOrders.filter(o=>o.type==="delivery"&&o.status!=="delivered").length;
  var pendingIncoming=orders.filter(o=>o.status==="pending"&&(!branch||!o.branchId||o.branchId===branch.id)).length;
  var occupiedTables=(tables||[]).filter(t=>t.status==="occupied"&&(!branch||!t.branchId||t.branchId===branch.id)).length;
  var totalTables=(tables||[]).filter(t=>!branch||!t.branchId||t.branchId===branch.id).length;
  var driverActive=orders.filter(o=>o.type==="delivery"&&(o.status==="ready"||o.status==="out_for_delivery")&&(!branch||!o.branchId||o.branchId===branch.id)).length;

  // Today's stats - extra defensive against bad date values
  var todayStr="";
  try{todayStr=new Date().toISOString().split("T")[0];}catch(e){todayStr="";}
  var todayOrders=[];
  try{
    todayOrders=orders.filter(o=>{
      if(!o)return false;
      if(branch&&o.branchId&&o.branchId!==branch.id)return false;
      // Prefer created_at (full ISO date) for accurate filtering
      var dateStr=o.created_at||o.placedAt;
      if(dateStr){
        try{
          var d=new Date(dateStr);
          if(!isNaN(d.getTime())){
            return d.toISOString().split("T")[0]===todayStr;
          }
        }catch(err){}
      }
      // Fallback: only treat HH:MM time as today if no date info exists at all
      if(!o.time)return false;
      try{
        var t=String(o.time);
        if(/^\d{1,2}:\d{2}/.test(t)&&t.length<=8){
          // Time-only format - only count if order has no created_at (legacy)
          return !o.created_at;
        }
        var d2=new Date(t);
        if(!d2||isNaN(d2.getTime()))return false;
        return d2.toISOString().split("T")[0]===todayStr;
      }catch(err){return false;}
    });
  }catch(e){todayOrders=[];}
  var todayRevenue=0;
  try{
    // Only count PAID orders that aren't cancelled/voided
    todayRevenue=todayOrders
      .filter(o=>o.paid&&o.status!=="cancelled"&&!o.refunded&&!o.voided)
      .reduce((s,o)=>s+(parseFloat(o.total)||0),0);
  }catch(e){todayRevenue=0;}

  // Tile config - each tile has: icon, label, color, badge count, action
  var tiles=[
    // ROW 1: TAKE NEW ORDERS (4 tiles)
    ...(hasService(restaurant,"dine_in")?[{icon:EM.cook,label:"Dine In",color:"#bf4626",bgGradient:"linear-gradient(135deg,#bf4626,#dc2626)",badge:dineInActive>0?dineInActive:null,sublabel:"Customer at table",onClick:()=>{setShowTablePicker(true);}}]:[]),
    ...(hasService(restaurant,"collection")||hasService(restaurant,"delivery")?[{icon:EM.bag,label:"Walk-in Takeaway",color:"#d97706",bgGradient:"linear-gradient(135deg,#d97706,#f59e0b)",badge:takeawayActive>0?takeawayActive:null,sublabel:"At counter",onClick:()=>{try{window.__posInitialType="takeaway";}catch(e){}onOpenPos();}}]:[]),
    ...(hasService(restaurant,"phone_orders")?[{icon:EM.phone,label:"Phone Order",color:"#2563eb",bgGradient:"linear-gradient(135deg,#2563eb,#3b82f6)",badge:deliveryActive>0?deliveryActive:null,sublabel:"Delivery / collection",onClick:()=>{try{window.__posOpenPhonePopup=true;}catch(e){}onOpenPos();}}]:[]),
    {icon:EM.bag,label:"Incoming",color:"#dc2626",bgGradient:"linear-gradient(135deg,#dc2626,#ef4444)",badge:pendingIncoming>0?pendingIncoming:null,sublabel:"Online & QR orders",onClick:()=>setModalView("incoming"),pulse:pendingIncoming>0},

    // ROW 2: MANAGE ACTIVE ORDERS (4 tiles)
    {icon:EM.cook,label:"Kitchen",color:"#059669",bgGradient:"linear-gradient(135deg,#059669,#10b981)",badge:null,sublabel:"What to cook",onClick:()=>setModalView("kitchen")},
    ...(hasService(restaurant,"dine_in")?[{icon:EM.pin,label:"Tables",color:"#0891b2",bgGradient:"linear-gradient(135deg,#0891b2,#06b6d4)",badge:occupiedTables>0?occupiedTables+"/"+totalTables:null,sublabel:"Floor view",onClick:()=>setModalView("tables")}]:[]),
    ...(hasService(restaurant,"delivery")?[{icon:EM.bag,label:"Driver",color:"#ea580c",bgGradient:"linear-gradient(135deg,#ea580c,#f97316)",badge:driverActive>0?driverActive:null,sublabel:"Deliveries",onClick:()=>setModalView("driver")}]:[]),
    ...(hasService(restaurant,"dine_in")?[{icon:EM.cal,label:"Bookings",color:"#9333ea",bgGradient:"linear-gradient(135deg,#9333ea,#a855f7)",badge:null,sublabel:"Reservations",onClick:()=>setModalView("bookings")}]:[]),

    // ROW 3: MANAGEMENT (3 tiles)
    {icon:EM.chart,label:"Reports",color:"#0d9488",bgGradient:"linear-gradient(135deg,#0d9488,#14b8a6)",badge:null,sublabel:"Sales & analytics",onClick:()=>setModalView("report")},
    ...(shiftsEnabled?[{
      icon:String.fromCharCode(0xD83C,0xDF05),
      label:currentShift?"Close Shift":"Open Shift",
      color:currentShift?"#dc2626":"#059669",
      bgGradient:currentShift?"linear-gradient(135deg,#dc2626,#991b1b)":"linear-gradient(135deg,#059669,#047857)",
      badge:currentShift?"OPEN":null,
      sublabel:currentShift?("Float "+fmt(currentShift.opening_float)):"Start day",
      onClick:()=>currentShift?setShowShiftClose(true):setShowShiftOpen(true),
    }]:[]),
    {icon:EM.gear,label:"Admin",color:"#1f2937",bgGradient:"linear-gradient(135deg,#1f2937,#374151)",badge:null,sublabel:"Menu & settings",onClick:()=>setView("admin")},
    {icon:String.fromCharCode(0x26F6,0xFE0F),label:document.fullscreenElement?"Exit Fullscreen":"Fullscreen POS",color:"#9333ea",bgGradient:"linear-gradient(135deg,#9333ea,#7c3aed)",badge:document.fullscreenElement?"ON":null,sublabel:document.fullscreenElement?"Press ESC to exit":"Hide browser bars",onClick:()=>{
      try{
        if(document.fullscreenElement){
          document.exitFullscreen();
        }else{
          document.documentElement.requestFullscreen().catch(e=>{
            if(window.showAlert)window.showAlert("Fullscreen not available","Your browser does not support fullscreen mode, or it's blocked. Try Chrome/Edge/Safari.","warning");
          });
        }
      }catch(e){
        console.error("Fullscreen error:",e);
      }
    }},
    {icon:EM.cart,label:"Open POS",color:"#bf4626",bgGradient:"linear-gradient(135deg,#1a1208,#3d2e22)",badge:null,sublabel:"Direct to ordering",onClick:()=>onOpenPos()},
    {icon:String.fromCharCode(0x21AA,0xFE0F),label:"Exit / Logout",color:"#dc2626",bgGradient:"linear-gradient(135deg,#dc2626,#991b1b)",badge:null,sublabel:"Sign out from system",onClick:()=>{if(window.confirm("Sign out and return to login screen?")){if(setUser)setUser(null);if(setView)setView("menu");}}},
  ];
  
  // OWNER CUSTOMIZATION - apply saved tile icon overrides, hide flags, and order
  try{
    var tileCust=JSON.parse(localStorage.getItem("tile_customization")||"{}");
    // 1. Apply custom icons + hide flags
    tiles=tiles.map(function(t){
      var c=tileCust[t.label];
      if(!c)return t;
      var newTile={...t};
      if(c.icon)newTile.icon=c.icon;
      if(c.hidden)newTile._hidden=true;
      return newTile;
    }).filter(function(t){return !t._hidden;});
    // 2. Apply custom order
    if(tileCust._order&&Array.isArray(tileCust._order)){
      var orderMap={};
      tileCust._order.forEach(function(lbl,i){orderMap[lbl]=i;});
      tiles.sort(function(a,b){
        var ai=orderMap[a.label];
        var bi=orderMap[b.label];
        // Tiles not in saved order go to the end (in original order)
        if(ai===undefined&&bi===undefined)return 0;
        if(ai===undefined)return 1;
        if(bi===undefined)return -1;
        return ai-bi;
      });
    }
  }catch(e){console.log("Tile customization load failed:",e);}
  
  // STAFF PERMISSION FILTERING - hide dashboard tiles staff can't access
  var dashStaff=(typeof window!=="undefined")?dbGetActiveStaff():null;
  if(dashStaff){
    var dashPerms=dashStaff.permissions||{};
    tiles=tiles.filter(function(tile){
      var lbl=tile.label||"";
      // Always allow: Open POS, Fullscreen, Exit/Logout
      if(lbl==="Open POS"||lbl.indexOf("Fullscreen")>=0||lbl.indexOf("Exit")>=0)return true;
      // Reports tile needs view_reports
      if(lbl==="Reports")return dashPerms.view_reports===true;
      // Admin tile needs a management permission
      if(lbl==="Admin")return dashPerms.manage_menu===true||dashPerms.manage_staff===true||dashPerms.manage_settings===true||dashPerms.view_finance===true;
      // Shift tiles need finance permission
      if(lbl==="Open Shift"||lbl==="Close Shift")return dashPerms.view_finance===true;
      // Order-taking tiles need take_orders
      if(["Dine In","Walk-in Takeaway","Phone Order","Incoming","Kitchen","Tables","Driver","Bookings"].includes(lbl)){
        return dashPerms.take_orders===true;
      }
      // Anything else hidden for staff
      return false;
    });
  }

  return <div className="page" style={{padding:14,minHeight:"calc(100vh - 100px)",background:"linear-gradient(135deg,#fafaf5,#f0ede5)"}}>
    <style>{`@keyframes pulse{0%,100%{transform:scale(1)}50%{transform:scale(1.05)}}`}</style>
    {/* Header */}
    <div style={{background:"linear-gradient(135deg,#1a1208,#3d2e22)",color:"#fff",borderRadius:14,padding:"15px 18px",marginBottom:14,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
      <div>
        <p style={{fontSize:11,color:"#d4952a",fontWeight:700,letterSpacing:2,marginBottom:3}}>POS DASHBOARD - NEW VERSION</p>
        <h2 style={{fontSize:20,fontWeight:700,marginBottom:2}}>Welcome back, {user?.name||"Staff"}</h2>
        <p style={{fontSize:12,color:"rgba(255,255,255,.7)"}}>{branch?.name} - {new Date().toLocaleDateString("en-GB",{weekday:"long",day:"numeric",month:"long"})} - {nowT()}</p>
      </div>
      <div style={{display:"flex",gap:14,alignItems:"center"}}>
        <div style={{textAlign:"center"}}>
          <p style={{fontSize:10,color:"rgba(255,255,255,.6)",fontWeight:700,letterSpacing:1}}>TODAY</p>
          <p style={{fontSize:20,fontWeight:700,color:"#d4952a"}}>{fmt(todayRevenue)}</p>
        </div>
        <div style={{textAlign:"center"}}>
          <p style={{fontSize:10,color:"rgba(255,255,255,.6)",fontWeight:700,letterSpacing:1}}>ORDERS</p>
          <p style={{fontSize:20,fontWeight:700,color:"#fff"}}>{todayOrders.length}</p>
        </div>
      </div>
    </div>

    {/* Quick stats bar */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(120px,1fr))",gap:7,marginBottom:14}}>
      <div className="card" style={{padding:10,textAlign:"center"}}><p style={{fontSize:18,fontWeight:700,color:"#bf4626"}}>{dineInActive}</p><p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1}}>DINE IN</p></div>
      <div className="card" style={{padding:10,textAlign:"center"}}><p style={{fontSize:18,fontWeight:700,color:"#d97706"}}>{takeawayActive}</p><p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1}}>TAKEAWAY</p></div>
      <div className="card" style={{padding:10,textAlign:"center"}}><p style={{fontSize:18,fontWeight:700,color:"#7c3aed"}}>{deliveryActive}</p><p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1}}>DELIVERY</p></div>
      <div className="card" style={{padding:10,textAlign:"center"}}><p style={{fontSize:18,fontWeight:700,color:"#0891b2"}}>{occupiedTables}/{totalTables}</p><p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1}}>TABLES</p></div>
    </div>

    {/* Tile grid */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:10}}>
      {tiles.map((tile,i)=><button key={i} onClick={tile.onClick} style={{background:tile.bgGradient,color:"#fff",border:"none",borderRadius:14,padding:"22px 14px",cursor:"pointer",position:"relative",display:"flex",flexDirection:"column",alignItems:"center",gap:5,minHeight:140,boxShadow:"0 4px 14px rgba(0,0,0,.12)",transition:"transform .15s",animation:tile.pulse?"pulse 1.5s ease-in-out infinite":"none"}} onMouseDown={e=>e.currentTarget.style.transform="scale(.96)"} onMouseUp={e=>e.currentTarget.style.transform="scale(1)"} onMouseLeave={e=>e.currentTarget.style.transform="scale(1)"} onTouchStart={e=>e.currentTarget.style.transform="scale(.96)"} onTouchEnd={e=>e.currentTarget.style.transform="scale(1)"}>
        {tile.badge&&<span style={{position:"absolute",top:9,right:9,background:"#fff",color:tile.color,borderRadius:11,padding:"2px 9px",fontSize:11,fontWeight:700,minWidth:22,textAlign:"center",boxShadow:"0 1px 4px rgba(0,0,0,.2)"}}>{tile.badge}</span>}
        <span style={{fontSize:38,lineHeight:1,marginTop:5}}>{tile.icon}</span>
        <span style={{fontSize:14,fontWeight:700,letterSpacing:.5,textAlign:"center"}}>{tile.label}</span>
        {tile.sublabel&&<span style={{fontSize:10,fontWeight:400,opacity:.85,textAlign:"center",letterSpacing:.3}}>{tile.sublabel}</span>}
      </button>)}
    </div>

    {/* Footer note */}
    <div style={{marginTop:18,padding:"10px 12px",background:"#fff",borderRadius:9,border:"1px solid #ede8de",textAlign:"center"}}>
      <p style={{fontSize:11,color:"#8a8078"}}>To disable this dashboard, go to Admin {String.fromCharCode(0x2192)} Settings {String.fromCharCode(0x2192)} POS Dashboard Home Screen</p>
    </div>

    {/* SHIFT MANAGEMENT */}
    {showShiftOpen&&<ShiftOpenScreen branch={branch} user={user} onCancel={()=>setShowShiftOpen(false)} onOpened={(s)=>{setCurrentShift(s);setShowShiftOpen(false);push&&push({title:"Shift opened",body:"Float: "+fmt(s.opening_float),color:"#059669"});}}/>}
    {showShiftClose&&currentShift&&<ShiftCloseScreen shift={currentShift} branch={branch} push={push} onCancel={()=>setShowShiftClose(false)} onClosed={(s)=>{setCurrentShift(null);setShowShiftClose(false);}}/>}
    
    {/* DINE IN - Table picker popup */}
    {showTablePicker&&(()=>{
      var branchTables=(tables||[]).filter(function(t){return !branch||!t.branchId||t.branchId===branch.id;});
      return <div onClick={function(){setShowTablePicker(false);}} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.8)",zIndex:9500,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
        <div onClick={function(e){e.stopPropagation();}} style={{background:"#fff",borderRadius:16,maxWidth:560,width:"100%",maxHeight:"85vh",overflowY:"auto",padding:22}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
            <h3 style={{fontSize:19,fontWeight:700}}>{String.fromCharCode(0xD83E,0xDE91)} Pick a Table</h3>
            <button onClick={function(){setShowTablePicker(false);}} style={{background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:8,padding:"6px 12px",fontWeight:700,cursor:"pointer"}}>Close</button>
          </div>
          <p style={{fontSize:12,color:"#8a8078",marginBottom:16}}>Select which table the customers are sitting at. You can add to a table that's already in use.</p>
          {branchTables.length===0?
            <div style={{textAlign:"center",padding:24}}>
              <p style={{fontSize:13,color:"#8a8078"}}>No tables set up yet.</p>
              <p style={{fontSize:11,color:"#8a8078",marginTop:4}}>Add tables in Admin {String.fromCharCode(0x2192)} Tables.</p>
            </div>
            :
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(90px,1fr))",gap:10}}>
              {branchTables.map(function(t){
                // Use the table's own status field - single source of truth
                var busy=t.status==="occupied";
                var reserved=t.status==="reserved";
                var borderC=busy?"#f59e0b":reserved?"#a855f7":"#10b981";
                var bgC=busy?"#fffbeb":reserved?"#faf5ff":"#ecfdf5";
                var txtC=busy?"#92400e":reserved?"#7c3aed":"#065f46";
                return <button key={t.id} onClick={function(){
                  try{
                    window.__posInitialType="dine-in";
                    window.__preselectedTable=t.id;
                  }catch(e){}
                  setShowTablePicker(false);
                  onOpenPos();
                }} style={{padding:"16px 8px",borderRadius:12,border:"2px solid "+borderC,background:bgC,cursor:"pointer",textAlign:"center"}}>
                  <div style={{fontSize:24,fontWeight:700,color:txtC}}>{t.id}</div>
                  <div style={{fontSize:10,color:txtC,fontWeight:700,marginTop:3}}>{busy?"In use":reserved?"Reserved":"Free"}</div>
                  {t.seats&&<div style={{fontSize:9,color:"#8a8078",marginTop:2}}>{t.seats} seats</div>}
                </button>;
              })}
            </div>
          }
        </div>
      </div>;
    })()}

    {/* MODAL VIEWS - Click tile opens these as overlays */}
    {modalView&&<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",zIndex:9000,display:"flex",alignItems:"center",justifyContent:"center",padding:"20px 14px"}}>
      <div style={{background:"#fafaf5",color:"#1a1208",borderRadius:14,maxWidth:1200,width:"100%",maxHeight:"calc(100vh - 40px)",display:"flex",flexDirection:"column",overflow:"hidden",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
        {/* Modal header */}
        <div style={{background:"linear-gradient(135deg,#1a1208,#3d2e22)",color:"#fff",padding:"14px 20px",display:"flex",justifyContent:"space-between",alignItems:"center",borderBottom:"3px solid #d4952a"}}>
          <div>
            <p style={{fontSize:11,color:"#d4952a",fontWeight:700,letterSpacing:2,marginBottom:2}}>POS DASHBOARD</p>
            <h2 style={{fontSize:20,fontWeight:700}}>{
              modalView==="incoming"?(EM.bag+" Incoming Orders"):
              modalView==="kitchen"?(EM.cook+" Kitchen Stations"):
              modalView==="tables"?(EM.pin+" Tables - Floor View"):
              modalView==="driver"?(EM.bag+" Driver - Deliveries"):
              modalView==="bookings"?(EM.cal+" Bookings & Reservations"):
              modalView==="report"?(EM.chart+" Reports & Analytics"):
              "View"
            }</h2>
          </div>
          <button onClick={()=>setModalView(null)} style={{padding:"10px 18px",background:"linear-gradient(135deg,#dc2626,#991b1b)",color:"#fff",border:"none",borderRadius:9,fontSize:13,fontWeight:700,cursor:"pointer",boxShadow:"0 3px 8px rgba(220,38,38,.3)",display:"flex",alignItems:"center",gap:6}}>
            x Close
          </button>
        </div>
        {/* Modal content - scrollable */}
        <div style={{flex:1,overflowY:"auto",padding:14}}>
          {modalView==="incoming"&&<IncomingOrdersV orders={orders} setOrders={setOrders} push={push} branch={branch} customers={customers} tables={tables} setTables={setTables} stations={stations} menu={menu}/>}
          {modalView==="kitchen"&&<KitchenV orders={orders} setOrders={setOrders} push={push} stations={stations} menu={menu}/>}
          {modalView==="tables"&&<TablesV tables={tables} setTables={setTables} push={push} branch={branch} orders={orders} setOrders={setOrders} onEditTable={(tb)=>{setModalView(null);setTimeout(()=>{if(typeof window!=="undefined")window.__editTable=tb;setView&&setView("admin");},100);}} onGoToPos={tableId=>{setModalView(null);if(typeof window!=="undefined")window.__preselectedTable=tableId;onOpenPos();}}/>}
          {modalView==="driver"&&<DriverV orders={orders} setOrders={setOrders} push={push} user={user} branch={branch}/>}
          {modalView==="bookings"&&<StaffBookingsV branch={branch} push={push}/>}
          {modalView==="report"&&<ReportV orders={orders}/>}
        </div>
      </div>
    </div>}
  </div>;
}

// CLASSIC UI - POSCUBE-style with category buttons on left, items in middle, bill on right
// CLASSIC POSCUBE-style POS - traditional EPOS layout with categories on left, items in middle, bill on right
function PosVClassic({menu,onOrder,push,user,branch,tables,setTables,orders,onBackToDash,customers,setCustomers,restaurant}){
  var [phoneCust,setPhoneCust]=useState(null);
  var [showPhonePopup,setShowPhonePopup]=useState(()=>{try{if(window.__posOpenPhonePopup){window.__posOpenPhonePopup=false;return true;}}catch(e){}return false;});
  var cats=[...new Set(menu.filter(i=>i.avail).map(i=>i.cat))];
  var [cat,setCat]=useState(cats[0]||"");
  var [cart,setCart]=useState([]);
  var [type,setType]=useState(()=>{try{var t=window.__posInitialType;if(t){window.__posInitialType=null;return t;}}catch(e){}return "dine-in";});
  useEffect(()=>{if(restaurant&&!hasService(restaurant,"dine_in")&&type==="dine-in")setType("takeaway");},[restaurant,type]);
  var [tbl,setTbl]=useState(()=>{try{if(window.__preselectedTable){var v=window.__preselectedTable;window.__preselectedTable=null;return v;}}catch(e){}return "";});
  var [guests,setGuests]=useState("1");
  var [discPct,setDiscPct]=useState(0);
  var [showDiscModal,setShowDiscModal]=useState(false);
  var [showSplitModal,setShowSplitModal]=useState(false);
  var [showClassicPicker,setShowClassicPicker]=useState(false);
  var [splitN,setSplitN]=useState(2);
  var [posDeliv,setPosDeliv]=useState(null);
  var [showPayment,setShowPayment]=useState(false);

  // Color palette for categories - rotates through traditional EPOS colors
  var catColors=["#f59e0b","#fbbf24","#fcd34d","#fb923c","#fca5a5","#a78bfa","#60a5fa","#34d399"];
  var getCatColor=(idx)=>catColors[idx%catColors.length];

  useEffect(()=>{
    if(!branch)return;
    dbFetchAllDelivery().then(list=>{
      var s=(list||[]).find(x=>x.branch_id===branch.id);
      if(s){
        setPosDeliv({
          serviceChargeEnabled:s.service_charge_enabled||false,
          serviceChargePercent:parseFloat(s.service_charge_percent||12.5),
          serviceChargeMandatory:s.service_charge_mandatory||false,
        });
      }
    });
  },[branch]);

  // Calculations
  var rawSub=cart.reduce((s,i)=>s+i.price*i.qty,0);
  var discAmt=rawSub*(discPct/100);
  var afterDisc=rawSub-discAmt;
  var posServiceApplies=type==="dine-in"&&posDeliv&&posDeliv.serviceChargeEnabled;
  var serviceCharge=posServiceApplies?afterDisc*((posDeliv.serviceChargePercent||0)/100):0;
  var total=afterDisc+serviceCharge;

  var add=(it)=>{
    var typePrice=getItemPrice(it,type);
    setCart(c=>{
      var ex=c.find(x=>x.id===it.id);
      if(ex){
        var others=c.filter(x=>x.id!==it.id);
        return [{...ex,qty:ex.qty+1,price:typePrice},...others];
      }
      return [{id:it.id,name:it.name,qty:1,price:typePrice},...c];
    });
  };
  var rem=(idx)=>setCart(c=>c.filter((_,i)=>i!==idx));
  var qtyChange=(idx,delta)=>setCart(c=>c.map((it,i)=>i===idx?{...it,qty:Math.max(1,it.qty+delta)}:it));
  var clear=()=>{setCart([]);setDiscPct(0);};

  // Send order to kitchen / save
  var sendOrder=(paid,payMethod,payData)=>{
    if(cart.length===0){push({title:"Empty cart",body:"Add items first",color:"#dc2626"});return;}
    // VALIDATION: Dine-in requires table number
    if(type==="dine-in"&&!tbl){
      push({title:"Table required!",body:"Please select a table number for dine-in orders",color:"#dc2626"});
      if(typeof window!=="undefined"&&window.navigator&&window.navigator.vibrate){window.navigator.vibrate([50,50,50]);}
      return;
    }
    // Build customer info - use phone customer if set
    var customer,phoneNum,address,orderType,deliveryCode;
    if(phoneCust){
      customer=phoneCust.name+" ("+phoneCust.phone+")";
      phoneNum=phoneCust.phone;
      orderType=type==="takeaway"?"collection":(type==="dine-in"?"delivery":type);
      address=orderType==="delivery"?phoneCust.address:null;
      deliveryCode=String(Math.floor(1000+Math.random()*9000));
    }else{
      customer=type==="dine-in"?(tbl?"Table "+tbl:"Walk-in"):"Counter";
      phoneNum=null;address=null;orderType=type;deliveryCode=null;
    }
    var tableId=type==="dine-in"&&tbl?parseInt(tbl):null;
    // CONFLICT CHECK: If another order exists for this table already, warn
    if(tableId&&orders){
      var existing=orders.filter(o=>o.tableId===tableId&&o.branchId===branch?.id&&!o.paid&&!["delivered","collected","cancelled"].includes(o.status));
      if(existing.length>0){
        var otherOrder=existing[0];
        var msg="Table "+tableId+" already has an active order ("+otherOrder.id+") by "+(otherOrder.takenBy||otherOrder.customer)+" totaling "+fmt(otherOrder.total)+".\n\nOK = Add to existing bill (recommended)\nCancel = Don't send this order";
        if(!window.confirm(msg))return;
      }
    }
    var o={
      id:uid(),branchId:branch?.id,userId:phoneCust?phoneCust.id:(user?.id||"staff"),customer,phone:phoneNum,
      items:[...cart],subtotal:rawSub,discount:discAmt,
      serviceCharge:serviceCharge,
      tip:payData?payData.tip:0,
      total:payData?payData.total:total,
      status:"preparing",time:nowT(),created_at:new Date().toISOString(),type:orderType,
      paid:paid||false,payMethod:payMethod||null,takenBy:user?.name,
      tableId,source:phoneCust?"phone":"staff",guests:parseInt(guests)||1,
      address:address,deliveryCode:deliveryCode,phoneCustomer:phoneCust?true:false,
      paymentSplit:payData&&(payData.method==="split"||payData.method==="item-split")?{cash:payData.cashPart||payData.totalCash,card:payData.cardPart||payData.totalCard}:null,
      cashGiven:payData&&payData.cashGiven?payData.cashGiven:null,
      changeReturn:payData&&payData.changeReturn?payData.changeReturn:null,
      itemSplit:payData&&payData.method==="item-split"?{customerCount:payData.customerCount,customerItems:payData.customerItems,customerPayments:payData.customerPayments,payments:payData.payments}:null,
    };
    onOrder(o);
    if(type==="dine-in"&&tbl){
      var tnum=parseInt(tbl);
      setTables(ts=>ts.map(t=>{
        if((t.id===tnum||t.id===String(tnum))&&t.branchId===branch?.id){
          // Also save to DB so all views see it
          if(t.dbId)dbUpdateTableStatus(t.dbId,"occupied",{}).catch(e=>console.log("Table save failed:",e));
          return{...t,status:"occupied",guests:parseInt(guests)||1};
        }
        return t;
      }));
    }
    var msgBody=phoneCust?(phoneCust.name+(deliveryCode?" - Code: "+deliveryCode:"")):(o.id+" - "+fmt(total));
    push({title:paid?"Paid - sent to kitchen":(phoneCust?"Phone order sent":"Sent to kitchen"),body:msgBody,color:paid?"#059669":"#2563eb"});
    clear();
    setPhoneCust(null);
    if(onBackToDash&&!paid)setTimeout(()=>onBackToDash(),300);
  };

  // Filter and dedupe items in current category
  var visibleItems=(()=>{
    var seen=new Set();
    return menu.filter(i=>i.cat===cat&&i.avail&&isItemAvailable(i,type)).filter(i=>{
      var key=(i.name||"").toLowerCase().trim();
      if(seen.has(key))return false;
      seen.add(key);
      return true;
    });
  })();

  return <div style={{height:"calc(100vh - 100px)",display:"flex",flexDirection:"column",background:"#1a1208",color:"#fff",margin:-16,padding:8,overflow:"hidden"}}>
    <style>{`@keyframes pulse{0%,100%{opacity:1}50%{opacity:.7}}`}</style>
    {showPayment&&<PaymentFlow total={total} cart={cart} allowItemSplit={type==="dine-in"||type==="takeaway"} branch={branch} user={user} orderId={null} onCancel={()=>setShowPayment(false)} onComplete={(payData)=>{setShowPayment(false);sendOrder(true,payData.method,payData);}}/>}
    {showPhonePopup&&<PhoneCustomerPopup customers={customers} setCustomers={setCustomers} push={push} branch={branch} initialPhone="" onClose={()=>setShowPhonePopup(false)} onCustomerReady={(data)=>{setPhoneCust(data.customer);setType(data.orderType==="collection"?"takeaway":"takeaway");setShowPhonePopup(false);push({title:"Phone customer ready",body:data.customer.name+" - "+data.orderType,color:"#059669"});}}/>}
    
    {/* Phone customer banner */}
    {phoneCust&&<div style={{background:"linear-gradient(135deg,#2563eb,#3b82f6)",color:"#fff",padding:"8px 12px",borderRadius:8,marginBottom:6,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:6}}>
      <div style={{flex:1,minWidth:200}}>
        <p style={{fontSize:9,fontWeight:700,letterSpacing:2,opacity:.85}}>PHONE ORDER</p>
        <p style={{fontSize:13,fontWeight:700}}>{phoneCust.name} - {phoneCust.phone}</p>
        {phoneCust.address&&<p style={{fontSize:10,opacity:.85}}>{EM.pin} {phoneCust.address.line1}, {phoneCust.address.postcode}</p>}
      </div>
      <button onClick={()=>setPhoneCust(null)} style={{padding:"5px 10px",borderRadius:5,fontSize:10,fontWeight:700,background:"rgba(255,255,255,.15)",color:"#fff",border:"1px solid rgba(255,255,255,.3)",cursor:"pointer"}}>Clear</button>
    </div>}
    
    {/* Top bar - branch info + order type + table */}
    <div style={{display:"flex",alignItems:"center",gap:8,padding:"7px 10px",background:"linear-gradient(135deg,#2d1f12,#3d2e22)",borderRadius:8,marginBottom:6,flexWrap:"wrap"}}>
      {onBackToDash&&<button onClick={onBackToDash} style={{padding:"6px 11px",borderRadius:6,fontSize:11,fontWeight:700,background:"rgba(255,255,255,.1)",color:"#fff",border:"1px solid rgba(255,255,255,.2)",cursor:"pointer"}}>{"< Dashboard"}</button>}
      <button onClick={()=>setShowPhonePopup(true)} style={{padding:"6px 11px",borderRadius:6,fontSize:11,fontWeight:700,background:"#2563eb",color:"#fff",border:"none",cursor:"pointer"}}>{EM.phone} Phone</button>
      <div style={{flex:1,minWidth:120}}>
        <p style={{fontSize:11,color:"rgba(255,255,255,.6)",fontWeight:700,letterSpacing:1}}>POSCUBE STYLE</p>
        <p style={{fontSize:14,fontWeight:700,color:"#d4952a"}}>{branch?.name} - {user?.name}</p>
      </div>
      <div style={{display:"flex",gap:4,background:"rgba(0,0,0,.3)",borderRadius:7,padding:3}}>
        {[["dine-in","Dine In"],["takeaway","Takeaway"]].filter(([tp])=>{
          if(!restaurant)return true;
          if(tp==="dine-in"&&!hasService(restaurant,"dine_in"))return false;
          if(tp==="takeaway"&&!hasService(restaurant,"collection")&&!hasService(restaurant,"delivery"))return false;
          return true;
        }).map(([tp,lb])=><button key={tp} onClick={()=>{setType(tp);setCart(c=>c.map(it=>{var m=menu.find(x=>String(x.id)===String(it.id));return{...it,price:m?getItemPrice(m,tp):it.price};}));}} style={{padding:"6px 14px",borderRadius:5,fontSize:12,fontWeight:700,background:type===tp?"#bf4626":"transparent",color:"#fff",border:"none",cursor:"pointer"}}>{lb}</button>)}
      </div>
      {type==="dine-in"&&<>
        <input value={tbl} onChange={e=>setTbl(e.target.value)} placeholder="Table #" style={{width:70,padding:"6px 8px",borderRadius:6,border:"2px solid "+(!tbl?"#fbbf24":"#d4952a"),background:!tbl?"#fef3c7":"#fff",color:!tbl?"#92400e":"#1a1208",fontWeight:700,textAlign:"center",fontSize:13}}/>
        <button onClick={()=>setShowClassicPicker(true)} style={{padding:"6px 10px",borderRadius:6,fontSize:11,fontWeight:700,background:"#d4952a",color:"#1a1208",border:"none",cursor:"pointer"}}>Pick</button>
        <input value={guests} onChange={e=>setGuests(e.target.value)} placeholder="Guests" style={{width:70,padding:"6px 8px",borderRadius:6,border:"2px solid #d4952a",background:"#fff",color:"#1a1208",fontWeight:700,textAlign:"center",fontSize:13}}/>
      </>}
    </div>

    {/* Main area - 3 columns */}
    <div style={{flex:1,display:"flex",gap:6,minHeight:0}}>
      {/* LEFT: Categories sidebar */}
      <div style={{width:108,display:"flex",flexDirection:"column",gap:3,overflowY:"auto",background:"#0f0a05",borderRadius:8,padding:5}}>
        {cats.map((c,idx)=>{
          var color=getCatColor(idx);
          var isActive=cat===c;
          var count=menu.filter(m=>m.cat===c&&m.avail).length;
          return <button key={c} onClick={()=>setCat(c)} style={{padding:"10px 6px",background:isActive?color:"#2d1f12",color:isActive?"#1a1208":"#fff",border:"2px solid "+color,borderRadius:6,fontWeight:700,fontSize:11,cursor:"pointer",lineHeight:1.2,minHeight:48,display:"flex",flexDirection:"column",justifyContent:"center"}}>
            <span>{c}</span>
            <span style={{fontSize:9,opacity:.85,fontWeight:400,marginTop:2}}>{count} items</span>
          </button>;
        })}
      </div>

      {/* MIDDLE: Items grid */}
      <div style={{flex:1,background:"#fafaf5",borderRadius:8,padding:6,overflowY:"auto"}}>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(110px,1fr))",gap:5}}>
          {visibleItems.map(item=>{
            var price=getItemPrice(item,type);
            var inCart=cart.find(c=>c.id===item.id);
            var idx=cats.indexOf(item.cat);
            var color=getCatColor(idx);
            return <button key={item.dbId||item.id} onClick={()=>add(item)} disabled={item.stock===0} style={{padding:"10px 6px",background:inCart?"#fff":color,color:"#1a1208",border:"3px solid "+(inCart?"#bf4626":color),borderRadius:7,fontWeight:700,fontSize:11,cursor:item.stock===0?"not-allowed":"pointer",opacity:item.stock===0?.4:1,position:"relative",minHeight:62,boxShadow:"0 2px 4px rgba(0,0,0,.15)"}}>
              {inCart&&<div style={{position:"absolute",top:-7,right:-7,background:"#bf4626",color:"#fff",borderRadius:"50%",width:22,height:22,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,border:"2px solid #fff"}}>{inCart.qty}</div>}
              <div style={{fontWeight:700,marginBottom:2,lineHeight:1.1}}>{(item.name||"").toUpperCase()}</div>
              <div style={{fontSize:11,fontWeight:700,color:"#7c2d12"}}>{fmt(price)}</div>
            </button>;
          })}
        </div>
        {visibleItems.length===0&&<div style={{textAlign:"center",padding:50,color:"#8a8078"}}>
          <p style={{fontSize:32}}>{EM.cook}</p>
          <p style={{fontSize:13,marginTop:10}}>No items in {cat}</p>
        </div>}
      </div>

      {/* RIGHT: Running bill */}
      <div style={{width:240,display:"flex",flexDirection:"column",background:"#fff",color:"#1a1208",borderRadius:8,overflow:"hidden"}}>
        <div style={{background:type==="dine-in"&&!tbl?"#dc2626":"#1a1208",color:"#fff",padding:"7px 10px",fontWeight:700,fontSize:12,textAlign:"center"}}>
          {type==="dine-in"?(tbl?"Dine In - Table "+tbl+" - Guest: "+guests:"DINE IN - PICK A TABLE!"):"Takeaway"}
        </div>
        <div style={{flex:1,overflowY:"auto",padding:6}}>
          {cart.length===0?<p style={{fontSize:11,color:"#8a8078",textAlign:"center",padding:20}}>Tap items to add</p>:cart.map((it,i)=><div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"4px 0",borderBottom:"1px dashed #ede8de",fontSize:11}}>
            <div style={{flex:1,minWidth:0,display:"flex",alignItems:"center",gap:4}}>
              <button onClick={()=>qtyChange(i,-1)} style={{width:18,height:18,borderRadius:3,border:"1px solid #ddd",background:"#f7f3ee",cursor:"pointer",fontWeight:700,fontSize:10}}>-</button>
              <span style={{fontWeight:700,minWidth:18,textAlign:"center"}}>{it.qty}</span>
              <button onClick={()=>qtyChange(i,1)} style={{width:18,height:18,borderRadius:3,border:"1px solid #ddd",background:"#f7f3ee",cursor:"pointer",fontWeight:700,fontSize:10}}>+</button>
              <span style={{fontSize:10,marginLeft:3,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{it.name}</span>
            </div>
            <span style={{fontWeight:700,marginLeft:4}}>{fmt(it.price*it.qty)}</span>
            <button onClick={()=>rem(i)} style={{marginLeft:3,width:16,height:16,borderRadius:3,background:"#fee2e2",color:"#dc2626",border:"none",cursor:"pointer",fontSize:10,fontWeight:700}}>x</button>
          </div>)}
        </div>
        <div style={{padding:"7px 10px",borderTop:"2px solid #ede8de",background:"#fafaf5"}}>
          <div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:"#8a8078"}}><span>Subtotal</span><span>{fmt(rawSub)}</span></div>
          {discAmt>0&&<div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:"#dc2626"}}><span>Disc {discPct}%</span><span>-{fmt(discAmt)}</span></div>}
          {serviceCharge>0&&<div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:"#7c3aed"}}><span>Service</span><span>+{fmt(serviceCharge)}</span></div>}
          <div style={{display:"flex",justifyContent:"space-between",fontSize:18,fontWeight:700,color:"#bf4626",marginTop:4,paddingTop:4,borderTop:"1px solid #ede8de"}}><span>Amount Due:</span><span>{fmt(total)}</span></div>
        </div>
      </div>
    </div>

    {/* Warning banner - dine-in needs table */}
    {type==="dine-in"&&!tbl&&cart.length>0&&<div style={{padding:"8px 12px",background:"#dc2626",color:"#fff",borderRadius:7,marginTop:6,fontSize:12,fontWeight:700,textAlign:"center",animation:"pulse 1.5s ease-in-out infinite"}}>
      Pick a table number to send the order. Click the yellow Pick button at the top.
    </div>}

    {/* Bottom action bar */}
    <div style={{display:"flex",gap:4,marginTop:6,flexWrap:"wrap"}}>
      <button onClick={clear} style={{padding:"10px 14px",background:"#dc2626",color:"#fff",border:"none",borderRadius:7,fontWeight:700,fontSize:12,cursor:"pointer",minWidth:80}}>Cancel</button>
      <button onClick={()=>setShowDiscModal(true)} disabled={cart.length===0} style={{padding:"10px 14px",background:"#d4952a",color:"#fff",border:"none",borderRadius:7,fontWeight:700,fontSize:12,cursor:cart.length===0?"not-allowed":"pointer",opacity:cart.length===0?.5:1,minWidth:80}}>Discount</button>
      <button onClick={()=>setShowSplitModal(true)} disabled={cart.length===0||type!=="dine-in"} style={{padding:"10px 14px",background:"#7c3aed",color:"#fff",border:"none",borderRadius:7,fontWeight:700,fontSize:12,cursor:cart.length===0||type!=="dine-in"?"not-allowed":"pointer",opacity:cart.length===0||type!=="dine-in"?.5:1,minWidth:80}}>Split Bill</button>
      <div style={{flex:1}}/>
      <button onClick={()=>sendOrder(false,null)} disabled={cart.length===0||(type==="dine-in"&&!tbl)} style={{padding:"10px 18px",background:"#2563eb",color:"#fff",border:"none",borderRadius:7,fontWeight:700,fontSize:13,cursor:cart.length===0||(type==="dine-in"&&!tbl)?"not-allowed":"pointer",opacity:cart.length===0||(type==="dine-in"&&!tbl)?.5:1,minWidth:120}}>Send to Kitchen</button>
      <button onClick={()=>setShowPayment(true)} disabled={cart.length===0||(type==="dine-in"&&!tbl)} style={{padding:"10px 18px",background:"linear-gradient(135deg,#059669,#10b981)",color:"#fff",border:"none",borderRadius:7,fontWeight:700,fontSize:13,cursor:cart.length===0||(type==="dine-in"&&!tbl)?"not-allowed":"pointer",opacity:cart.length===0||(type==="dine-in"&&!tbl)?.5:1,minWidth:120}}>{String.fromCharCode(0xD83D,0xDCB0)} Pay Now</button>
    </div>

    {/* Discount modal */}
    {showDiscModal&&<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:99,padding:14}} onClick={()=>setShowDiscModal(false)}>
      <div onClick={e=>e.stopPropagation()} style={{background:"#fff",color:"#1a1208",borderRadius:11,padding:18,maxWidth:340,width:"100%"}}>
        <h3 style={{fontSize:16,marginBottom:9}}>Apply Discount</h3>
        <p style={{fontSize:12,color:"#8a8078",marginBottom:11}}>Quick percentages:</p>
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:5,marginBottom:11}}>
          {[5,10,15,20,25,50].map(p=><button key={p} onClick={()=>setDiscPct(p)} style={{padding:"11px",background:discPct===p?"#bf4626":"#f7f3ee",color:discPct===p?"#fff":"#1a1208",border:"none",borderRadius:7,fontWeight:700,fontSize:13,cursor:"pointer"}}>{p}%</button>)}
        </div>
        <input type="number" value={discPct} onChange={e=>setDiscPct(Math.max(0,Math.min(100,+e.target.value)))} placeholder="Custom %" style={{width:"100%",padding:"9px",border:"2px solid #ede8de",borderRadius:7,fontSize:14,textAlign:"center",marginBottom:11}}/>
        <div style={{display:"flex",gap:6}}>
          <button onClick={()=>{setDiscPct(0);setShowDiscModal(false);}} style={{flex:1,padding:"10px",background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:7,fontWeight:700,cursor:"pointer"}}>Remove</button>
          <button onClick={()=>setShowDiscModal(false)} style={{flex:1,padding:"10px",background:"#1a1208",color:"#fff",border:"none",borderRadius:7,fontWeight:700,cursor:"pointer"}}>Apply</button>
        </div>
      </div>
    </div>}

    {/* Split bill modal */}
    {showSplitModal&&<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:99,padding:14}} onClick={()=>setShowSplitModal(false)}>
      <div onClick={e=>e.stopPropagation()} style={{background:"#fff",color:"#1a1208",borderRadius:11,padding:18,maxWidth:340,width:"100%"}}>
        <h3 style={{fontSize:16,marginBottom:9}}>Split Bill</h3>
        <p style={{fontSize:12,color:"#8a8078",marginBottom:11}}>How many ways to split?</p>
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:5,marginBottom:11}}>
          {[2,3,4,5,6,8].map(n=><button key={n} onClick={()=>setSplitN(n)} style={{padding:"11px",background:splitN===n?"#7c3aed":"#f7f3ee",color:splitN===n?"#fff":"#1a1208",border:"none",borderRadius:7,fontWeight:700,fontSize:13,cursor:"pointer"}}>{n} ways</button>)}
        </div>
        <div style={{padding:"11px",background:"#f5f3ff",borderRadius:7,marginBottom:11,textAlign:"center"}}>
          <p style={{fontSize:11,color:"#7c3aed",fontWeight:700}}>Each person pays</p>
          <p style={{fontSize:22,fontWeight:700,color:"#7c3aed"}}>{fmt(total/splitN)}</p>
        </div>
        <button onClick={()=>setShowSplitModal(false)} style={{width:"100%",padding:"10px",background:"#1a1208",color:"#fff",border:"none",borderRadius:7,fontWeight:700,cursor:"pointer"}}>Done</button>
      </div>
    </div>}

    {/* Classic Table Picker Modal */}
    {showClassicPicker&&(()=>{
      var branchTables=tables?tables.filter(t=>!t.branchId||t.branchId===branch?.id).sort((a,b)=>(+a.id)-(+b.id)):[];
      var statusColor={free:"#10b981",occupied:"#dc2626",reserved:"#d4952a"};
      var statusBg={free:"#d1fae5",occupied:"#fee2e2",reserved:"#fef3c7"};
      return <div onClick={()=>setShowClassicPicker(false)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",zIndex:9000,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
        <div onClick={e=>e.stopPropagation()} style={{background:"#fff",color:"#1a1208",borderRadius:14,padding:18,maxWidth:540,width:"100%",maxHeight:"80vh",overflowY:"auto"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:11}}>
            <h3 style={{fontSize:18,fontWeight:700}}>Pick a Table</h3>
            <button onClick={()=>setShowClassicPicker(false)} style={{width:32,height:32,borderRadius:"50%",background:"#f7f3ee",border:"none",cursor:"pointer",fontSize:16,fontWeight:700}}>x</button>
          </div>
          {branchTables.length===0?<p style={{textAlign:"center",padding:30,color:"#8a8078"}}>No tables configured for this branch.</p>:<div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(80px,1fr))",gap:6}}>
            {branchTables.map(t=>{var st=t.status||"free";return <button key={t.id} onClick={()=>{setTbl(String(t.id));setShowClassicPicker(false);}} style={{padding:"14px 8px",border:"3px solid "+statusColor[st],borderRadius:9,background:statusBg[st],color:statusColor[st],fontWeight:700,cursor:"pointer",textAlign:"center"}}>
              <p style={{fontSize:18,fontWeight:700,marginBottom:2}}>T{t.id}</p>
              <p style={{fontSize:9,fontWeight:600,letterSpacing:1,textTransform:"uppercase"}}>{st}</p>
              <p style={{fontSize:9,marginTop:2}}>{t.seats||4} seats</p>
            </button>;})}
          </div>}
          <div style={{display:"flex",gap:8,marginTop:14,fontSize:11,justifyContent:"center"}}>
            <span><span style={{display:"inline-block",width:10,height:10,background:"#10b981",borderRadius:2,marginRight:3}}/> Free</span>
            <span><span style={{display:"inline-block",width:10,height:10,background:"#dc2626",borderRadius:2,marginRight:3}}/> Occupied</span>
            <span><span style={{display:"inline-block",width:10,height:10,background:"#d4952a",borderRadius:2,marginRight:3}}/> Reserved</span>
          </div>
        </div>
      </div>;
    })()}
  </div>;
}
function PosVCompact({menu,onOrder,push,user,branch,tables,setTables,orders,onBackToDash,customers,setCustomers,restaurant}){
  var [phoneCust,setPhoneCust]=useState(null);
  var [showPhonePopup,setShowPhonePopup]=useState(()=>{try{if(window.__posOpenPhonePopup){window.__posOpenPhonePopup=false;return true;}}catch(e){}return false;});
  var [showPayment,setShowPayment]=useState(false);
  var cats=[...new Set(menu.filter(i=>i.avail).map(i=>i.cat))];
  var [cat,setCat]=useState(cats[0]||"");
  var [cart,setCart]=useState([]);
  var [type,setType]=useState(()=>{try{var t=window.__posInitialType;if(t){window.__posInitialType=null;return t;}}catch(e){}return "dine-in";});
  useEffect(()=>{if(restaurant&&!hasService(restaurant,"dine_in")&&type==="dine-in")setType("takeaway");},[restaurant,type]);
  var [tbl,setTbl]=useState(()=>{try{if(window.__preselectedTable){var v=window.__preselectedTable;window.__preselectedTable=null;return v;}}catch(e){}return "";});
  var [showCart,setShowCart]=useState(false);
  var [search,setSearch]=useState("");
  var [posDeliv,setPosDeliv]=useState(null);

  useEffect(()=>{
    if(!branch)return;
    dbFetchAllDelivery().then(list=>{
      var s=(list||[]).find(x=>x.branch_id===branch.id);
      if(s){
        setPosDeliv({
          serviceChargeEnabled:s.service_charge_enabled||false,
          serviceChargePercent:parseFloat(s.service_charge_percent||12.5),
        });
      }
    });
  },[branch]);

  // Calculations
  var rawSub=cart.reduce((s,i)=>s+i.price*i.qty,0);
  var posServiceApplies=type==="dine-in"&&posDeliv&&posDeliv.serviceChargeEnabled;
  var serviceCharge=posServiceApplies?rawSub*((posDeliv.serviceChargePercent||0)/100):0;
  var total=rawSub+serviceCharge;
  var totalQty=cart.reduce((s,i)=>s+i.qty,0);

  var add=(it)=>{
    var typePrice=getItemPrice(it,type);
    setCart(c=>{
      var ex=c.find(x=>x.id===it.id);
      if(ex){
        return c.map(x=>x.id===it.id?{...x,qty:x.qty+1,price:typePrice}:x);
      }
      return [...c,{id:it.id,name:it.name,qty:1,price:typePrice}];
    });
    // Mini haptic feedback feel - flash effect on cart button
  };
  var qtyChange=(idx,delta)=>setCart(c=>c.map((it,i)=>i===idx?{...it,qty:Math.max(0,it.qty+delta)}:it).filter(it=>it.qty>0));
  var rem=(idx)=>setCart(c=>c.filter((_,i)=>i!==idx));
  var clear=()=>{setCart([]);setShowCart(false);};

  var sendOrder=(paid,payMethod,payData)=>{
    if(cart.length===0){push({title:"Empty cart",body:"Add items first",color:"#dc2626"});return;}
    // VALIDATION: Dine-in requires table number
    if(type==="dine-in"&&!tbl){
      push({title:"Table required!",body:"Please enter a table number for dine-in orders",color:"#dc2626"});
      if(typeof window!=="undefined"&&window.navigator&&window.navigator.vibrate){window.navigator.vibrate([50,50,50]);}
      return;
    }
    var customer,phoneNum,address,orderType,deliveryCode;
    if(phoneCust){
      customer=phoneCust.name+" ("+phoneCust.phone+")";
      phoneNum=phoneCust.phone;
      orderType=type==="takeaway"?"collection":(type==="dine-in"?"delivery":type);
      address=orderType==="delivery"?phoneCust.address:null;
      deliveryCode=String(Math.floor(1000+Math.random()*9000));
    }else{
      customer=type==="dine-in"?(tbl?"Table "+tbl:"Walk-in"):"Counter";
      phoneNum=null;address=null;orderType=type;deliveryCode=null;
    }
    var tableId=type==="dine-in"&&tbl?parseInt(tbl):null;
    var o={
      id:uid(),branchId:branch?.id,userId:phoneCust?phoneCust.id:(user?.id||"staff"),customer,phone:phoneNum,
      items:[...cart],subtotal:rawSub,discount:0,
      serviceCharge:serviceCharge,
      tip:payData?payData.tip:0,
      total:payData?payData.total:total,
      status:paid?"preparing":"pending",time:nowT(),type:orderType,
      paid:paid||false,payMethod:payMethod||null,takenBy:user?.name,
      tableId,source:phoneCust?"phone":"staff",
      address:address,deliveryCode:deliveryCode,phoneCustomer:phoneCust?true:false,
      paymentSplit:payData&&(payData.method==="split"||payData.method==="item-split")?{cash:payData.cashPart||payData.totalCash,card:payData.cardPart||payData.totalCard}:null,
      cashGiven:payData&&payData.cashGiven?payData.cashGiven:null,
      changeReturn:payData&&payData.changeReturn?payData.changeReturn:null,
      itemSplit:payData&&payData.method==="item-split"?{customerCount:payData.customerCount,customerItems:payData.customerItems,customerPayments:payData.customerPayments,payments:payData.payments}:null,
    };
    onOrder(o);
    if(type==="dine-in"&&tbl){
      var tnum=parseInt(tbl);
      setTables(ts=>ts.map(t=>{
        if((t.id===tnum||t.id===String(tnum))&&t.branchId===branch?.id){
          if(t.dbId)dbUpdateTableStatus(t.dbId,"occupied",{}).catch(e=>console.log("Table save failed:",e));
          return{...t,status:"occupied"};
        }
        return t;
      }));
    }
    var msgBody=phoneCust?(phoneCust.name+(deliveryCode?" - Code: "+deliveryCode:"")):(o.id+" - "+fmt(total));
    push({title:paid?"Paid - sent":(phoneCust?"Phone order sent":"Sent to kitchen"),body:msgBody,color:paid?"#059669":"#2563eb"});
    clear();
    setPhoneCust(null);
    if(onBackToDash&&!paid)setTimeout(()=>onBackToDash(),300);
  };

  // Filter items - search OR category
  var visibleItems=(()=>{
    var seen=new Set();
    var q=search.trim().toLowerCase();
    return menu.filter(i=>{
      if(!i.avail)return false;
      if(!isItemAvailable(i,type))return false;
      if(q){
        var hay=(i.name+" "+(i.desc||"")+" "+(i.cat||"")).toLowerCase();
        return hay.includes(q);
      }
      return i.cat===cat;
    }).filter(i=>{
      var key=(i.name||"").toLowerCase().trim();
      if(seen.has(key))return false;
      seen.add(key);
      return true;
    });
  })();

  return <div style={{display:"flex",flexDirection:"column",height:"calc(100vh - 100px)",margin:-16,position:"relative",overflow:"hidden"}}>
    {showPayment&&<PaymentFlow total={total} cart={cart} allowItemSplit={type==="dine-in"||type==="takeaway"} branch={branch} user={user} orderId={null} onCancel={()=>setShowPayment(false)} onComplete={(payData)=>{setShowPayment(false);sendOrder(true,payData.method,payData);}}/>}
    {showPhonePopup&&<PhoneCustomerPopup customers={customers} setCustomers={setCustomers} push={push} branch={branch} initialPhone="" onClose={()=>setShowPhonePopup(false)} onCustomerReady={(data)=>{setPhoneCust(data.customer);setType("takeaway");setShowPhonePopup(false);push({title:"Phone customer ready",body:data.customer.name,color:"#059669"});}}/>}
    
    {/* Phone customer banner */}
    {phoneCust&&<div style={{background:"linear-gradient(135deg,#2563eb,#3b82f6)",color:"#fff",padding:"6px 10px",display:"flex",justifyContent:"space-between",alignItems:"center",gap:6}}>
      <div style={{flex:1,minWidth:0}}>
        <p style={{fontSize:9,fontWeight:700,letterSpacing:1,opacity:.85}}>PHONE</p>
        <p style={{fontSize:11,fontWeight:700,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{phoneCust.name} - {phoneCust.phone}</p>
      </div>
      <button onClick={()=>setPhoneCust(null)} style={{padding:"4px 8px",borderRadius:5,fontSize:10,fontWeight:700,background:"rgba(255,255,255,.15)",color:"#fff",border:"none",cursor:"pointer"}}>Clear</button>
    </div>}
    
    {/* Top bar - super compact */}
    <div style={{padding:"7px 10px",background:"#1a1208",color:"#fff",display:"flex",gap:6,alignItems:"center"}}>
      {onBackToDash&&<button onClick={onBackToDash} style={{padding:"5px 9px",borderRadius:5,fontSize:11,fontWeight:700,background:"rgba(255,255,255,.1)",color:"#fff",border:"1px solid rgba(255,255,255,.2)",cursor:"pointer"}}>{"<"}</button>}
      <button onClick={()=>setShowPhonePopup(true)} style={{padding:"5px 9px",borderRadius:5,fontSize:11,fontWeight:700,background:"#2563eb",color:"#fff",border:"none",cursor:"pointer"}}>{EM.phone}</button>
      <div style={{flex:1,minWidth:0}}>
        <p style={{fontSize:10,color:"#d4952a",fontWeight:700}}>COMPACT POS</p>
        <p style={{fontSize:11,color:"rgba(255,255,255,.7)",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{branch?.name}</p>
      </div>
      <div style={{display:"flex",gap:3,background:"rgba(0,0,0,.3)",borderRadius:6,padding:2}}>
        {[["dine-in","Dine"],["takeaway","Take"]].filter(([tp])=>{
          if(!restaurant)return true;
          if(tp==="dine-in"&&!hasService(restaurant,"dine_in"))return false;
          if(tp==="takeaway"&&!hasService(restaurant,"collection")&&!hasService(restaurant,"delivery"))return false;
          return true;
        }).map(([tp,lb])=><button key={tp} onClick={()=>{setType(tp);setCart(c=>c.map(it=>{var m=menu.find(x=>String(x.id)===String(it.id));return{...it,price:m?getItemPrice(m,tp):it.price};}));}} style={{padding:"5px 10px",borderRadius:4,fontSize:11,fontWeight:700,background:type===tp?"#bf4626":"transparent",color:"#fff",border:"none",cursor:"pointer"}}>{lb}</button>)}
      </div>
      {type==="dine-in"&&<input value={tbl} onChange={e=>setTbl(e.target.value)} placeholder="T#" style={{width:42,padding:"5px",borderRadius:5,border:"none",fontSize:12,fontWeight:700,textAlign:"center",background:!tbl?"#fef3c7":"#fff",color:!tbl?"#92400e":"#1a1208"}}/>}
    </div>

    {/* Search */}
    <div style={{padding:"6px 8px",background:"#fafaf5",borderBottom:"1px solid #ede8de"}}>
      <input value={search} onChange={e=>setSearch(e.target.value)} placeholder={String.fromCharCode(0x1F50D >> 10)+String.fromCharCode((0x1F50D & 0x3FF)|0xDC00)+" Quick search items..."} style={{width:"100%",padding:"7px 10px",border:"2px solid #ede8de",borderRadius:7,fontSize:12,background:"#fff"}}/>
    </div>

    {/* Categories - horizontal scroll - hidden when searching */}
    {!search&&<div style={{display:"flex",gap:4,overflowX:"auto",padding:"6px 8px",background:"#fafaf5",borderBottom:"1px solid #ede8de"}}>
      {cats.map(c=><button key={c} onClick={()=>setCat(c)} style={{padding:"7px 13px",borderRadius:6,fontWeight:700,fontSize:11,whiteSpace:"nowrap",border:"2px solid",borderColor:cat===c?"#bf4626":"#ede8de",background:cat===c?"#bf4626":"#fff",color:cat===c?"#fff":"#1a1208",cursor:"pointer",flexShrink:0}}>{c}</button>)}
    </div>}

    {/* Items - 2 column grid for phones */}
    <div style={{flex:1,overflowY:"auto",padding:7,paddingBottom:80}}>
      {visibleItems.length===0?<div style={{textAlign:"center",padding:40,color:"#8a8078"}}>
        <p style={{fontSize:32}}>{search?String.fromCharCode(0x1F50D >> 10)+String.fromCharCode((0x1F50D & 0x3FF)|0xDC00):EM.cook}</p>
        <p style={{fontSize:13,marginTop:8}}>{search?"No items match":"No items"}</p>
      </div>:<div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
        {visibleItems.map(item=>{
          var price=getItemPrice(item,type);
          var inCart=cart.find(c=>c.id===item.id);
          return <button key={item.dbId||item.id} onClick={()=>add(item)} disabled={item.stock===0} style={{padding:"11px 8px",background:inCart?"#fff5f3":"#fff",color:"#1a1208",border:"2px solid "+(inCart?"#bf4626":"#ede8de"),borderRadius:9,cursor:"pointer",opacity:item.stock===0?.4:1,position:"relative",textAlign:"left",minHeight:78}}>
            {inCart&&<div style={{position:"absolute",top:-6,right:-6,background:"#bf4626",color:"#fff",borderRadius:"50%",width:24,height:24,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:700,border:"2px solid #fff"}}>{inCart.qty}</div>}
            <div style={{fontSize:18,marginBottom:3}}>{EM[item.icon]||""}</div>
            <p style={{fontSize:12,fontWeight:700,marginBottom:2,lineHeight:1.2}}>{item.name}</p>
            <p style={{fontSize:13,fontWeight:700,color:"#bf4626"}}>{fmt(price)}</p>
          </button>;
        })}
      </div>}
    </div>

    {/* Floating cart button - bottom */}
    {cart.length>0&&!showCart&&<button onClick={()=>setShowCart(true)} style={{position:"fixed",bottom:80,left:14,right:14,padding:"14px 18px",background:"linear-gradient(135deg,#bf4626,#dc2626)",color:"#fff",border:"none",borderRadius:14,fontWeight:700,fontSize:15,cursor:"pointer",boxShadow:"0 6px 20px rgba(191,70,38,.4)",display:"flex",alignItems:"center",justifyContent:"space-between",zIndex:50}}>
      <span style={{display:"flex",alignItems:"center",gap:8}}>
        <span style={{background:"rgba(255,255,255,.25)",borderRadius:"50%",width:28,height:28,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13}}>{totalQty}</span>
        View Cart
      </span>
      <span style={{fontSize:17,fontWeight:700}}>{fmt(total)}</span>
    </button>}

    {/* Slide-up cart panel */}
    {showCart&&<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.5)",zIndex:60}} onClick={()=>setShowCart(false)}>
      <div onClick={e=>e.stopPropagation()} style={{position:"absolute",bottom:0,left:0,right:0,background:"#fff",borderRadius:"16px 16px 0 0",maxHeight:"80vh",display:"flex",flexDirection:"column",animation:"slideUp .25s ease-out"}}>
        <div style={{padding:"12px 14px",borderBottom:"2px solid #ede8de",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <h3 style={{fontSize:16,fontWeight:700}}>Order {totalQty} item{totalQty!==1?"s":""}</h3>
            <p style={{fontSize:11,color:"#8a8078"}}>{type==="dine-in"?(tbl?"Table "+tbl:"Walk-in"):"Takeaway"}</p>
          </div>
          <button onClick={()=>setShowCart(false)} style={{width:32,height:32,borderRadius:"50%",background:"#f7f3ee",border:"none",cursor:"pointer",fontSize:16,fontWeight:700}}>x</button>
        </div>

        <div style={{flex:1,overflowY:"auto",padding:"8px 14px"}}>
          {cart.map((it,i)=><div key={i} style={{display:"flex",alignItems:"center",gap:8,padding:"9px 0",borderBottom:"1px solid #f5f0e8"}}>
            <div style={{flex:1,minWidth:0}}>
              <p style={{fontSize:13,fontWeight:700}}>{it.name}</p>
              <p style={{fontSize:11,color:"#8a8078"}}>{fmt(it.price)} each</p>
            </div>
            <div style={{display:"flex",alignItems:"center",gap:6,background:"#f7f3ee",borderRadius:18,padding:"3px 8px"}}>
              <button onClick={()=>qtyChange(i,-1)} style={{width:24,height:24,borderRadius:"50%",border:"none",background:"#fff",cursor:"pointer",fontSize:16,fontWeight:700,color:"#bf4626"}}>-</button>
              <span style={{fontWeight:700,minWidth:18,textAlign:"center"}}>{it.qty}</span>
              <button onClick={()=>qtyChange(i,1)} style={{width:24,height:24,borderRadius:"50%",border:"none",background:"#fff",cursor:"pointer",fontSize:16,fontWeight:700,color:"#059669"}}>+</button>
            </div>
            <p style={{fontWeight:700,fontSize:13,color:"#bf4626",minWidth:54,textAlign:"right"}}>{fmt(it.price*it.qty)}</p>
            <button onClick={()=>rem(i)} style={{width:24,height:24,borderRadius:"50%",border:"none",background:"#fee2e2",color:"#dc2626",cursor:"pointer",fontWeight:700}}>x</button>
          </div>)}
        </div>

        <div style={{padding:"10px 14px",borderTop:"2px solid #ede8de",background:"#fafaf5"}}>
          <div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"#8a8078"}}><span>Subtotal</span><span>{fmt(rawSub)}</span></div>
          {serviceCharge>0&&<div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"#7c3aed",fontWeight:700}}><span>Service ({posDeliv.serviceChargePercent}%)</span><span>+ {fmt(serviceCharge)}</span></div>}
          <div style={{display:"flex",justifyContent:"space-between",fontSize:18,fontWeight:700,color:"#bf4626",marginTop:5,paddingTop:5,borderTop:"1px solid #ede8de"}}><span>Total</span><span>{fmt(total)}</span></div>
        </div>

        <div style={{padding:"10px 14px",display:"flex",gap:6}}>
          <button onClick={clear} style={{padding:"12px 14px",background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:10,fontWeight:700,fontSize:13,cursor:"pointer"}}>Cancel</button>
          <button onClick={()=>sendOrder(false,null)} style={{flex:1,padding:"12px",background:"#2563eb",color:"#fff",border:"none",borderRadius:10,fontWeight:700,fontSize:13,cursor:"pointer"}}>Send Order</button>
          <button onClick={()=>setShowPayment(true)} style={{flex:2,padding:"12px",background:"linear-gradient(135deg,#059669,#10b981)",color:"#fff",border:"none",borderRadius:10,fontWeight:700,fontSize:13,cursor:"pointer"}}>{String.fromCharCode(0xD83D,0xDCB0)} Pay Now</button>
        </div>
      </div>
    </div>}
  </div>;
}

// MODERN UI - the current existing UI (renamed from PosV)
function PosVModern({menu,onOrder,push,user,branch,tables,setTables,orders,onBackToDash,customers,setCustomers,restaurant}){
  var [phoneCust,setPhoneCust]=useState(null); // when set, this is a delivery/collection order
  var [showCodePopup,setShowCodePopup]=useState(null); // {code, customer, type, total} when set
  var [showPhonePopup,setShowPhonePopup]=useState(()=>{try{if(window.__posOpenPhonePopup){window.__posOpenPhonePopup=false;return true;}}catch(e){}return false;});
  var cats=[...new Set(menu.filter(i=>i.avail).map(i=>i.cat))];
  var [cat,setCat]=useState(cats[0]),[cart,setCart]=useState([]),[tbl,setTbl]=useState(()=>{
    if(typeof window!=="undefined"&&window.__preselectedTable){
      var v=window.__preselectedTable;
      window.__preselectedTable=null;
      return v;
    }
    return "";
  }),[type,setType]=useState(()=>{try{var t=window.__posInitialType;if(t){window.__posInitialType=null;return t;}}catch(e){}return "dine-in";});
  useEffect(()=>{if(restaurant&&!hasService(restaurant,"dine_in")&&type==="dine-in")setType("takeaway");},[restaurant,type]);
  var [payStep,setPayStep]=useState(null),[cashGiven,setCashGiven]=useState("");
  var [showPayment,setShowPayment]=useState(false);
  var [tip,setTip]=useState(0),[discPct,setDiscPct]=useState(0),[discReason,setDiscReason]=useState("");
  var [splitN,setSplitN]=useState(1);
  var [adjOpen,setAdjOpen]=useState(false);
  var [lastOrder,setLastOrder]=useState(null);
  var [posDeliv,setPosDeliv]=useState(null); // delivery settings for service charge
  useEffect(()=>{
    if(!branch)return;
    dbFetchAllDelivery().then(list=>{
      var s=(list||[]).find(x=>x.branch_id===branch.id);
      if(s){
        setPosDeliv({
          serviceChargeEnabled:s.service_charge_enabled||false,
          serviceChargePercent:parseFloat(s.service_charge_percent||12.5),
          serviceChargeMandatory:s.service_charge_mandatory||false,
        });
      }
    });
  },[branch]);
  var rawSub=cart.reduce((s,i)=>s+i.price*i.qty,0);
  var discAmt=rawSub*(discPct/100);
  var afterDisc=rawSub-discAmt;
  // Service charge: only on dine-in, only if enabled in branch settings
  var posServiceApplies=type==="dine-in"&&posDeliv&&posDeliv.serviceChargeEnabled;
  var serviceCharge=posServiceApplies?afterDisc*((posDeliv.serviceChargePercent||0)/100):0;
  var vat=afterDisc-afterDisc/1.2;
  var total=afterDisc+serviceCharge+tip;
  var perSplit=total/Math.max(splitN,1);
  var count=cart.reduce((s,i)=>s+i.qty,0);
  var [flashId,setFlashId]=useState(null);
  var [showPicker,setShowPicker]=useState(false);
  var cartRef=useRef(null);
  var add=it=>{
    var typePrice=getItemPrice(it,type);
    setCart(c=>{
      var ex=c.find(x=>x.id===it.id);
      if(ex){
        // If item already in cart, increment qty and move to top
        var others=c.filter(x=>x.id!==it.id);
        return [{...ex,qty:ex.qty+1,price:typePrice},...others];
      }
      // New item goes to top
      return [{id:it.id,name:it.name,qty:1,price:typePrice},...c];
    });
    setFlashId(it.id);
    setTimeout(()=>setFlashId(null),600);
    // Auto-scroll cart to top to show newly added item
    setTimeout(()=>{
      if(cartRef.current)cartRef.current.scrollTop=0;
    },50);
    if(typeof window!=="undefined"&&window.navigator&&window.navigator.vibrate){window.navigator.vibrate(15);}
  };
  var dec=id=>setCart(c=>c.map(x=>x.id===id?{...x,qty:x.qty-1}:x).filter(x=>x.qty>0));
  var del=id=>setCart(c=>c.filter(x=>x.id!==id));
  var clear=()=>{setCart([]);setTbl("");setTip(0);setDiscPct(0);setDiscReason("");setSplitN(1);};
  var send=(paid,method,payData)=>{
    if(!cart.length)return;
    // VALIDATION: Dine-in requires table number
    if(type==="dine-in"&&!tbl){
      push({title:"Table required!",body:"Please select a table number for dine-in orders",color:"#dc2626"});
      if(typeof window!=="undefined"&&window.navigator&&window.navigator.vibrate){window.navigator.vibrate([50,50,50]);}
      return;
    }
    var tableId=type==="dine-in"?parseInt(tbl)||null:null;
    // CONFLICT CHECK: If another order exists for this table already, warn
    if(tableId&&orders){
      var existing=orders.filter(o=>o.tableId===tableId&&o.branchId===branch?.id&&!o.paid&&!["delivered","collected","cancelled"].includes(o.status));
      if(existing.length>0){
        var otherOrder=existing[0];
        var msg="Table "+tableId+" already has an active order ("+otherOrder.id+") by "+(otherOrder.takenBy||otherOrder.customer)+" totaling "+fmt(otherOrder.total)+".\n\nOK = Add to existing bill (recommended)\nCancel = Don't send this order";
        if(!window.confirm(msg))return;
      }
    }
    // Build customer & order details - use phone customer if set
    var customer,phoneNum,address,orderType,deliveryCode;
    if(phoneCust){
      // PHONE ORDER - use saved customer details
      customer=phoneCust.name+" ("+phoneCust.phone+")";
      phoneNum=phoneCust.phone;
      // type was set when phone customer was selected - "takeaway" for collection, but for delivery use proper type
      orderType=type==="takeaway"?"collection":(type==="dine-in"?"delivery":type);
      address=orderType==="delivery"?phoneCust.address:null;
      // Auto-generate a 4-digit delivery code so driver verification still works
      deliveryCode=String(Math.floor(1000+Math.random()*9000));
    }else{
      customer=type==="dine-in"?"Table "+(tbl||"?"):"Walk-in "+nowT();
      phoneNum=null;
      address=null;
      orderType=type;
      deliveryCode=null;
    }
    var o={id:uid(),branchId:branch?.id,userId:phoneCust?phoneCust.id:(user?.id||"staff"),customer,phone:phoneNum,items:cart,subtotal:rawSub,discount:discAmt,discReason:discReason,serviceCharge:serviceCharge,tip:payData?payData.tip:tip,total:payData?payData.total:total,status:"preparing",time:nowT(),created_at:new Date().toISOString(),type:orderType,paid,slot:null,payMethod:method||null,takenBy:user?.name,splitN:splitN,tableId:tableId,source:phoneCust?"phone":"staff",address:address,deliveryCode:deliveryCode,phoneCustomer:phoneCust?true:false,paymentSplit:payData&&(payData.method==="split"||payData.method==="item-split")?{cash:payData.cashPart||payData.totalCash,card:payData.cardPart||payData.totalCard}:null,cashGiven:payData&&payData.cashGiven?payData.cashGiven:null,changeReturn:payData&&payData.changeReturn?payData.changeReturn:null,itemSplit:payData&&payData.method==="item-split"?{customerCount:payData.customerCount,customerItems:payData.customerItems,customerPayments:payData.customerPayments,payments:payData.payments}:null};
    onOrder(o);setLastOrder(o);
    var msgBody=phoneCust?(phoneCust.name+" - "+fmt(o.total)+(deliveryCode?" - Code: "+deliveryCode:"")):(o.id+" - "+fmt(o.total));
    push({title:paid?"Paid by "+method:(phoneCust?"Phone order sent":"Sent to kitchen"),body:msgBody,color:paid?"#059669":"#2563eb"});
    // Show big popup with delivery code for phone orders so staff can read to customer
    if(phoneCust&&deliveryCode&&orderType==="delivery"){
      setShowCodePopup({code:deliveryCode,customer:phoneCust.name,phone:phoneCust.phone,type:orderType,total:o.total,address:phoneCust.address});
    }
    // Auto-update table status when dine-in order placed
    if(tableId&&setTables&&tables){
      var targetTable=tables.find(t=>t.id===tableId||t.table_number===tableId);
      if(targetTable){
        setTables(ts=>ts.map(t=>(t.id===tableId||t.table_number===tableId)?{...t,status:"occupied",since:nowT(),guests:t.guests||splitN,orderId:o.id}:t));
        // Save to DB if this table has a dbId
        if(targetTable.dbId||targetTable.id){
          var dbTableId=targetTable.dbId||targetTable.id;
          dbUpdateTableStatus(dbTableId,"occupied",{}).catch(e=>console.log("Table update failed:",e));
        }
      }
    }
    clear();setPayStep(paid?"done":null);setCashGiven("");
    setPhoneCust(null); // clear phone customer after order placed
    // If phone delivery order: don't auto-return - popup will handle it after OK click
    var hasCodePopup=phoneCust&&deliveryCode&&orderType==="delivery";
    // If dashboard mode enabled and just sent (not paid - which has its own success screen), return to dashboard
    // BUT only if no code popup is showing - that needs to stay until staff clicks OK
    if(!paid&&onBackToDash&&!hasCodePopup){
      setTimeout(()=>onBackToDash(),300);
    }
  };
  var change=parseFloat(cashGiven)-total;

  // Payment success with receipt option
  if(payStep==="done"&&lastOrder) return <div style={{minHeight:"100vh",background:"#1a1208",display:"flex",flexDirection:"column",padding:20,justifyContent:"center",alignItems:"center"}}>
    <div style={{fontSize:72,marginBottom:16,color:"#10b981"}}>{EM.check}</div>
    <h2 style={{color:"#fff",fontSize:30,marginBottom:6,fontFamily:"'Playfair Display',serif"}}>Payment Complete</h2>
    <p style={{color:"#d4952a",fontSize:36,fontWeight:700,marginBottom:4}}>{fmt(lastOrder.total)}</p>
    <p style={{color:"#888",fontSize:13,marginBottom:6}}>Paid by {lastOrder.payMethod} - {lastOrder.id}</p>
    {lastOrder.splitN>1&&<p style={{color:"#888",fontSize:12,marginBottom:6}}>Split {lastOrder.splitN} ways - {fmt(lastOrder.total/lastOrder.splitN)} each</p>}
    {lastOrder.itemSplit&&<p style={{color:"#7c3aed",fontSize:13,marginBottom:6,fontWeight:700}}>{String.fromCharCode(0xD83D,0xDC65)} Item-split: {lastOrder.itemSplit.customerCount} customers paid separately</p>}
    {lastOrder.tip>0&&<p style={{color:"#888",fontSize:12,marginBottom:30}}>Includes {fmt(lastOrder.tip)} tip</p>}
    <div style={{display:"flex",gap:10,flexWrap:"wrap",justifyContent:"center"}}>
      {lastOrder.itemSplit?<>
        <button className="btn btn-o" onClick={()=>printR(lastOrder,branch)} style={{padding:"14px 24px",fontSize:14,background:"linear-gradient(135deg,#7c3aed,#a855f7)",color:"#fff",border:"none"}}>{String.fromCharCode(0xD83D,0xDDA8,0xFE0F)} Combined Receipt</button>
        <button className="btn btn-o" onClick={()=>printItemSplitReceipts(lastOrder,branch)} style={{padding:"14px 24px",fontSize:14,background:"linear-gradient(135deg,#7c3aed,#a855f7)",color:"#fff",border:"none"}}>{String.fromCharCode(0xD83D,0xDC65)} {lastOrder.itemSplit.customerCount} Individual Receipts</button>
      </>:<button className="btn btn-o" onClick={()=>printR(lastOrder,branch)} style={{padding:"14px 24px",fontSize:14}}>Print Receipt</button>}
      <button className="btn btn-o" onClick={()=>{alert("Email receipt sent (simulated)");}} style={{padding:"14px 24px",fontSize:14}}>Email Receipt</button>
      <button className="btn btn-r" onClick={()=>{setLastOrder(null);setPayStep(null);if(onBackToDash)onBackToDash();}} style={{padding:"14px 24px",fontSize:14}}>{onBackToDash?"Back to Dashboard":"New Order"}</button>
    </div>
  </div>;

  // Cash payment screen
  if(payStep==="cash") return <div style={{minHeight:"100vh",background:"#1a1208",display:"flex",flexDirection:"column",padding:20}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
      <button onClick={()=>setPayStep(null)} style={{color:"#d4952a",fontSize:16,fontWeight:700,border:"none",background:"none",cursor:"pointer"}}>{"< Back"}</button>
      <p style={{color:"#fff",fontSize:22,fontWeight:700}}>Cash Payment</p>
      <div style={{width:60}}/>
    </div>
    <div style={{background:"#2e1f10",borderRadius:14,padding:20,marginBottom:16,textAlign:"center"}}>
      <p style={{color:"#d4952a",fontSize:12,letterSpacing:2,fontWeight:700,marginBottom:6}}>TOTAL DUE</p>
      <p style={{color:"#fff",fontSize:42,fontWeight:700,fontFamily:"'Playfair Display',serif"}}>{fmt(total)}</p>
    </div>
    <div style={{background:"#fff",borderRadius:14,padding:16,marginBottom:14}}>
      <label className="lbl">Cash Given</label>
      <input type="number" step="0.01" className="field" value={cashGiven} onChange={e=>setCashGiven(e.target.value)} placeholder="0.00" style={{fontSize:26,padding:"14px 16px",textAlign:"right",fontWeight:700}} autoFocus/>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:6,marginTop:10}}>
        {[5,10,20,50,100,total].map((v,i)=><button key={i} onClick={()=>setCashGiven(String(v))} style={{padding:"12px 4px",borderRadius:9,background:"#f7f3ee",fontWeight:700,fontSize:14,border:"2px solid #ede8de",cursor:"pointer"}}>{fmt(v)}</button>)}
      </div>
    </div>
    {cashGiven&&<div style={{background:change>=0?"#d1fae5":"#fee2e2",borderRadius:14,padding:16,marginBottom:16,textAlign:"center"}}>
      <p style={{fontSize:11,color:change>=0?"#059669":"#dc2626",fontWeight:700,letterSpacing:2,marginBottom:4}}>{change>=0?"CHANGE DUE":"INSUFFICIENT"}</p>
      <p style={{fontSize:32,fontWeight:700,color:change>=0?"#059669":"#dc2626"}}>{fmt(Math.abs(change))}</p>
    </div>}
    <button className="btn btn-r" disabled={change<0||!cashGiven} onClick={()=>send(true,"Cash")} style={{padding:"18px",fontSize:18,marginTop:"auto"}}>Confirm Cash Payment</button>
  </div>;

  // Card payment screen
  if(payStep==="card") return <div style={{minHeight:"100vh",background:"#1a1208",display:"flex",flexDirection:"column",padding:20}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
      <button onClick={()=>setPayStep(null)} style={{color:"#d4952a",fontSize:16,fontWeight:700,border:"none",background:"none",cursor:"pointer"}}>{"< Back"}</button>
      <p style={{color:"#fff",fontSize:22,fontWeight:700}}>Card Payment</p>
      <div style={{width:60}}/>
    </div>
    <div style={{background:"#2e1f10",borderRadius:14,padding:20,marginBottom:20,textAlign:"center"}}>
      <p style={{color:"#d4952a",fontSize:12,letterSpacing:2,fontWeight:700,marginBottom:6}}>INSERT / TAP CARD</p>
      <p style={{color:"#fff",fontSize:42,fontWeight:700,fontFamily:"'Playfair Display',serif"}}>{fmt(total)}</p>
    </div>
    <div style={{background:"#fff",borderRadius:14,padding:30,marginBottom:14,textAlign:"center",flex:1,display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",gap:14}}>
      <div style={{width:80,height:80,borderRadius:"50%",background:"#f7f3ee",display:"flex",alignItems:"center",justifyContent:"center",fontSize:40,animation:"pulse 1.5s infinite"}}>"CARD"</div>
      <p style={{fontSize:16,fontWeight:700}}>Waiting for terminal...</p>
      <p style={{fontSize:13,color:"#8a8078"}}>Insert chip, swipe, or tap card</p>
    </div>
    <div style={{display:"flex",gap:8}}>
      <button className="btn btn-o" onClick={()=>setPayStep(null)} style={{flex:1,padding:"14px"}}>Cancel</button>
      <button className="btn btn-r" onClick={()=>send(true,"Card")} style={{flex:2,padding:"14px",fontSize:16}}>Approve Payment</button>
    </div>
  </div>;

  return <div className="pos-wrap">
    {/* PAYMENT FLOW - new cash/card/split popup */}
    {showPayment&&<PaymentFlow total={total} cart={cart} allowItemSplit={type==="dine-in"||type==="takeaway"} branch={branch} user={user} orderId={null} onCancel={()=>setShowPayment(false)} onComplete={(payData)=>{
      setShowPayment(false);
      // Place the order with payment data
      send(true,payData.method,payData);
    }}/>}
    
    {/* DELIVERY CODE POPUP - big visible popup so staff can read to customer */}
    {showCodePopup&&<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.92)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
      <div style={{background:"linear-gradient(135deg,#1a1208,#3d2e22)",color:"#fff",borderRadius:16,padding:"30px 26px",maxWidth:520,width:"100%",textAlign:"center",boxShadow:"0 20px 60px rgba(0,0,0,.6)",border:"4px solid #d4952a"}}>
        <p style={{fontSize:13,color:"#d4952a",fontWeight:700,letterSpacing:3,marginBottom:10}}>{EM.check} ORDER SENT TO KITCHEN</p>
        <h2 style={{fontSize:22,fontWeight:700,marginBottom:6,color:"#fff"}}>{showCodePopup.customer}</h2>
        <p style={{fontSize:14,color:"rgba(255,255,255,.75)",marginBottom:14}}>{showCodePopup.phone} - {fmt(showCodePopup.total)}</p>
        
        <div style={{background:"#fff",color:"#1a1208",borderRadius:12,padding:"24px 16px",margin:"14px 0",boxShadow:"inset 0 0 0 3px #d4952a"}}>
          <p style={{fontSize:12,color:"#8a8078",fontWeight:700,letterSpacing:2,marginBottom:8}}>READ THIS CODE TO CUSTOMER</p>
          <p style={{fontSize:72,fontWeight:700,letterSpacing:16,color:"#bf4626",fontFamily:"'Courier New',monospace",lineHeight:1,marginBottom:6}}>{showCodePopup.code}</p>
          <p style={{fontSize:11,color:"#8a8078",marginTop:8}}>Driver will ask for this code on cash delivery</p>
        </div>
        
        <div style={{padding:"14px",background:"rgba(255,255,255,.08)",borderRadius:9,marginBottom:14,textAlign:"left",border:"1px solid rgba(255,255,255,.15)"}}>
          <p style={{fontSize:11,color:"#d4952a",fontWeight:700,letterSpacing:1,marginBottom:5}}>{String.fromCharCode(0xD83D,0xDCDE)} SAY TO CUSTOMER:</p>
          <p style={{fontSize:14,fontStyle:"italic",lineHeight:1.5}}>"Your order has been sent to the kitchen. When the driver arrives for cash payment, please give them this 4-digit code: <span style={{fontSize:20,fontWeight:700,color:"#fff",fontFamily:"'Courier New',monospace"}}>{showCodePopup.code.split("").join(" ")}</span>"</p>
        </div>
        
        <p style={{fontSize:11,color:"rgba(255,255,255,.5)",marginBottom:10,fontStyle:"italic"}}>This popup will stay until you click below</p>
        
        <button onClick={()=>{var hadDash=!!onBackToDash;setShowCodePopup(null);if(hadDash)setTimeout(()=>onBackToDash(),100);}} style={{padding:"18px 32px",background:"linear-gradient(135deg,#059669,#10b981)",color:"#fff",border:"none",borderRadius:11,fontSize:16,fontWeight:700,cursor:"pointer",width:"100%",boxShadow:"0 4px 14px rgba(5,150,105,.4)"}}>{EM.check} I have given the code - Close</button>
      </div>
    </div>}
    
    {showPhonePopup&&<PhoneCustomerPopup customers={customers} setCustomers={setCustomers} push={push} branch={branch} initialPhone="" onClose={()=>setShowPhonePopup(false)} onCustomerReady={(data)=>{setPhoneCust(data.customer);setType(data.orderType);setShowPhonePopup(false);push({title:"Phone customer ready",body:data.customer.name+" - "+data.orderType,color:"#059669"});}}/>}
    
    {/* Phone customer banner (when in phone order mode) */}
    {phoneCust&&<div style={{background:"linear-gradient(135deg,#2563eb,#3b82f6)",color:"#fff",padding:"10px 14px",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8}}>
      <div style={{flex:1,minWidth:200}}>
        <p style={{fontSize:10,fontWeight:700,letterSpacing:2,opacity:.85}}>PHONE ORDER - {(type||"DELIVERY").toUpperCase()}</p>
        <p style={{fontSize:14,fontWeight:700}}>{phoneCust.name} - {phoneCust.phone}</p>
        {phoneCust.address&&<p style={{fontSize:11,opacity:.85}}>{EM.pin} {phoneCust.address.line1}, {phoneCust.address.postcode}{phoneCust.distance>0?" - "+(typeof phoneCust.distance==="number"?phoneCust.distance.toFixed(1):phoneCust.distance)+" mi":""}</p>}
      </div>
      <button onClick={()=>{setPhoneCust(null);setType("dine-in");}} style={{padding:"6px 12px",borderRadius:6,fontSize:11,fontWeight:700,background:"rgba(255,255,255,.15)",color:"#fff",border:"1px solid rgba(255,255,255,.3)",cursor:"pointer"}}>Clear & Switch to Walk-in</button>
    </div>}
    
    <div style={{background:"#1a1208",padding:"10px 14px",display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
      {onBackToDash&&<button onClick={onBackToDash} style={{padding:"5px 10px",borderRadius:6,fontSize:11,fontWeight:700,background:"rgba(255,255,255,.1)",color:"#fff",border:"1px solid rgba(255,255,255,.2)",cursor:"pointer"}}>{"< Dashboard"}</button>}
      <p style={{color:"#d4952a",fontWeight:700,fontSize:14}}>POS</p>
      <button onClick={()=>setShowPhonePopup(true)} style={{padding:"5px 10px",borderRadius:6,fontSize:11,fontWeight:700,background:"#2563eb",color:"#fff",border:"none",cursor:"pointer",display:"flex",alignItems:"center",gap:4}}>{EM.phone} Phone Order</button>
      <div style={{display:"flex",gap:4}}>
        {[["dine-in","Dine In"],["takeaway","Takeaway"]].filter(([tp])=>{
          if(!restaurant)return true;
          if(tp==="dine-in"&&!hasService(restaurant,"dine_in"))return false;
          if(tp==="takeaway"&&!hasService(restaurant,"collection")&&!hasService(restaurant,"delivery"))return false;
          return true;
        }).map(([tp,lb])=><button key={tp} onClick={()=>{setType(tp);setCart(c=>c.map(it=>{var m=menu.find(x=>String(x.id)===String(it.id));var newPrice=m?getItemPrice(m,tp):it.price;return{...it,price:newPrice};}));}} style={{padding:"5px 10px",borderRadius:6,fontSize:11,fontWeight:700,background:type===tp?"#bf4626":"rgba(255,255,255,.1)",color:"#fff",border:"none",cursor:"pointer"}}>{lb}</button>)}
      </div>
      {type==="dine-in"&&<>
        <input value={tbl} onChange={e=>setTbl(e.target.value)} placeholder="Table #" style={{width:70,padding:"5px 8px",border:"none",borderRadius:6,fontSize:13,fontWeight:700,textAlign:"center",background:!tbl?"#fef3c7":"#fff",color:!tbl?"#92400e":"#1a1208"}}/>
        <button onClick={()=>setShowPicker(true)} style={{padding:"5px 10px",borderRadius:6,fontSize:11,fontWeight:700,background:"rgba(255,255,255,.1)",color:"#fff",border:"1px solid rgba(255,255,255,.2)",cursor:"pointer"}}>Pick Table</button>
      </>}
      <span style={{color:"#888",fontSize:11,marginLeft:"auto"}}>{user?.name||"Staff"}</span>
    </div>

    <div className="pos-body">
      
      <div className="pos-menu">
        <div style={{display:"flex",gap:5,overflowX:"auto",paddingBottom:6,marginBottom:8}}>
          {cats.map(c=><button key={c} onClick={()=>setCat(c)} style={{whiteSpace:"nowrap",padding:"10px 16px",borderRadius:8,fontWeight:700,fontSize:13,border:"none",background:cat===c?"#1a1208":"#fff",color:cat===c?"#d4952a":"#1a1208",flexShrink:0,cursor:"pointer",boxShadow:cat===c?"0 3px 10px rgba(0,0,0,.2)":"0 1px 3px rgba(0,0,0,.06)"}}>{c}</button>)}
        </div>
        <div className="pos-grid">
          {(()=>{var seen=new Set();return menu.filter(i=>i.cat===cat&&i.avail&&isItemAvailable(i,type)).filter(i=>{var key=(i.name||"").toLowerCase().trim()+"|"+(i.cat||"");if(seen.has(key))return false;seen.add(key);return true;}).map(item=>{
            var inCart=cart.find(c=>c.id===item.id);
            var displayPrice=getItemPrice(item,type);
            return <button key={item.dbId||item.id} onClick={()=>add(item)} disabled={item.stock===0} style={{background:inCart?"#fff5f3":"#fff",border:"2px solid "+(inCart?"#bf4626":"transparent"),borderRadius:10,padding:10,cursor:item.stock===0?"not-allowed":"pointer",opacity:item.stock===0?.4:1,boxShadow:inCart?"0 4px 16px rgba(191,70,38,.25)":"0 2px 8px rgba(0,0,0,.08)",display:"flex",flexDirection:"column",alignItems:"center",gap:5,minHeight:115,transition:"all .15s",position:"relative"}} onMouseDown={e=>e.currentTarget.style.transform="scale(.93)"} onMouseUp={e=>e.currentTarget.style.transform="scale(1)"} onMouseLeave={e=>e.currentTarget.style.transform="scale(1)"} onTouchStart={e=>e.currentTarget.style.transform="scale(.93)"} onTouchEnd={e=>e.currentTarget.style.transform="scale(1)"}>
              {inCart&&<div style={{position:"absolute",top:-6,right:-6,background:"#bf4626",color:"#fff",borderRadius:"50%",width:28,height:28,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:700,boxShadow:"0 2px 8px rgba(191,70,38,.5)",border:"2px solid #fff"}}>{inCart.qty}</div>}
              {item.image?
                <img src={item.image} alt={item.name} style={{width:"100%",height:62,objectFit:"cover",borderRadius:8,marginBottom:1}}/>
                :<div style={{width:"100%",height:62,borderRadius:8,marginBottom:1,background:"linear-gradient(135deg,#f3ede3,#e9e0d2)",display:"flex",alignItems:"center",justifyContent:"center"}}><span style={{fontSize:22,fontWeight:800,color:"#c9bba4"}}>{(item.name||"?").trim().charAt(0).toUpperCase()}</span></div>}
              <p style={{fontSize:11,fontWeight:700,textAlign:"center",lineHeight:1.2}}>{item.name}</p>
              <p style={{fontSize:13,fontWeight:700,color:"#bf4626"}}>{fmt(displayPrice)}</p>
            </button>;
          });})()}
        </div>
      </div>

      
      <div className="pos-cart">
        <div style={{padding:"12px 14px",borderBottom:"1px solid #ede8de",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <p style={{fontWeight:700,fontSize:14}}>{type==="dine-in"?"Table "+(tbl||"?"):"Takeaway"}</p>
            <p style={{fontSize:11,color:"#8a8078"}}>{count} item{count!==1?"s":""}</p>
          </div>
          {cart.length>0&&<button onClick={clear} style={{color:"#dc2626",fontSize:12,fontWeight:700,border:"none",background:"none",cursor:"pointer"}}>Clear</button>}
        </div>
        <div className="pos-cart-items" ref={cartRef}>
          {cart.length===0&&<p style={{textAlign:"center",color:"#8a8078",padding:20,fontSize:13}}>Tap menu items to add</p>}
          {cart.map(it=><div key={it.id} className={flashId===it.id?"flash":""} style={{display:"flex",alignItems:"center",gap:8,padding:"8px 0",borderBottom:"1px solid #f7f3ee"}}>
            <div style={{flex:1}}>
              <p style={{fontWeight:700,fontSize:13}}>{it.name}</p>
              <p style={{fontSize:11,color:"#8a8078"}}>{fmt(it.price)} each</p>
            </div>
            <div style={{display:"flex",alignItems:"center",gap:6,background:"#f7f3ee",borderRadius:50,padding:"3px 10px"}}>
              <button onClick={()=>dec(it.id)} style={{fontSize:18,color:"#bf4626",fontWeight:700,border:"none",background:"none",cursor:"pointer",width:20}}>-</button>
              <span style={{fontWeight:700,minWidth:18,textAlign:"center",fontSize:14}}>{it.qty}</span>
              <button onClick={()=>add(it)} style={{fontSize:18,color:"#bf4626",fontWeight:700,border:"none",background:"none",cursor:"pointer",width:20}}>+</button>
            </div>
            <p style={{fontWeight:700,minWidth:55,textAlign:"right",fontSize:13,color:"#bf4626"}}>{fmt(it.price*it.qty)}</p>
            <button onClick={()=>del(it.id)} style={{color:"#ccc",fontSize:16,border:"none",background:"none",cursor:"pointer"}}>x</button>
          </div>)}
        </div>
        <div className="pos-cart-footer">
          {/* Adjustments (Tip / Discount / Split) - collapsible to save footer space */}
          {cart.length>0&&<div style={{marginBottom:8,border:"1px solid #ede8de",borderRadius:8,overflow:"hidden",background:"#fff"}}>
            <button onClick={()=>setAdjOpen(o=>!o)} style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"space-between",padding:"9px 10px",border:"none",background:"none",cursor:"pointer"}}>
              <span style={{fontSize:11,color:"#8a8078",fontWeight:600,textAlign:"left"}}>{[posServiceApplies&&serviceCharge>0?"Service "+(posDeliv.serviceChargePercent)+"%":null,tip>0?"Tip":null,discPct>0?"Disc "+discPct+"%":null,splitN>1?"Split "+splitN+"x":null].filter(Boolean).join("  \u00b7  ")||"No tip \u00b7 No discount"}</span>
              <span style={{fontSize:11,fontWeight:700,color:"#bf4626",whiteSpace:"nowrap"}}>{adjOpen?"Hide \u25b2":"Tip \u00b7 Discount \u00b7 Split \u25be"}</span>
            </button>
            {adjOpen&&<div style={{padding:"2px 10px 10px"}}>
              {/* Tip selector */}
              <p style={{fontSize:10,fontWeight:700,color:"#8a8078",letterSpacing:1,margin:"6px 0 4px"}}>TIP</p>
              <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:4}}>
                {[0,0.05,0.10,0.125,0.15].map(p=><button key={p} onClick={()=>setTip(rawSub*p)} style={{padding:"7px 2px",borderRadius:6,fontSize:11,fontWeight:700,background:Math.abs(tip-rawSub*p)<0.01?"#d4952a":"#fff",color:Math.abs(tip-rawSub*p)<0.01?"#fff":"#1a1208",border:"2px solid "+(Math.abs(tip-rawSub*p)<0.01?"#d4952a":"#ede8de"),cursor:"pointer"}}>{p===0?"None":(p*100)+"%"}</button>)}
              </div>
              {/* Discount selector */}
              <p style={{fontSize:10,fontWeight:700,color:"#8a8078",letterSpacing:1,margin:"10px 0 4px"}}>DISCOUNT</p>
              <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:4}}>
                {[[0,"None"],[10,"10%"],[20,"20%"],[50,"50%"]].map(([p,lb])=><button key={p} onClick={()=>setDiscPct(p)} style={{padding:"7px 2px",borderRadius:6,fontSize:11,fontWeight:700,background:discPct===p?"#dc2626":"#fff",color:discPct===p?"#fff":"#1a1208",border:"2px solid "+(discPct===p?"#dc2626":"#ede8de"),cursor:"pointer"}}>{lb}</button>)}
              </div>
              {discPct>0&&<input value={discReason} onChange={e=>setDiscReason(e.target.value)} placeholder="Reason (staff, loyalty, complaint...)" style={{width:"100%",padding:"6px 8px",border:"1px solid #ede8de",borderRadius:6,fontSize:11,marginTop:4}}/>}
              {/* Split bill */}
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",margin:"10px 0 4px"}}>
                <p style={{fontSize:10,fontWeight:700,color:"#8a8078",letterSpacing:1}}>SPLIT BILL</p>
                {splitN>1&&<button onClick={()=>setSplitN(1)} style={{fontSize:10,color:"#dc2626",border:"none",background:"none",cursor:"pointer",fontWeight:700}}>Reset</button>}
              </div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(6,1fr)",gap:4}}>
                {[1,2,3,4,5,6].map(n=><button key={n} onClick={()=>setSplitN(n)} style={{padding:"7px 2px",borderRadius:6,fontSize:11,fontWeight:700,background:splitN===n?"#7c3aed":"#fff",color:splitN===n?"#fff":"#1a1208",border:"2px solid "+(splitN===n?"#7c3aed":"#ede8de"),cursor:"pointer"}}>{n===1?"No":n+"x"}</button>)}
              </div>
            </div>}
          </div>}

          {/* Totals */}
          <div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"#8a8078",marginBottom:2}}><span>Subtotal</span><span>{fmt(rawSub)}</span></div>
          {discAmt>0&&<div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"#dc2626",marginBottom:2,fontWeight:700}}><span>Discount ({discPct}%)</span><span>- {fmt(discAmt)}</span></div>}
          {posServiceApplies&&serviceCharge>0&&<div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"#7c3aed",marginBottom:2,fontWeight:700}}><span>Service ({posDeliv.serviceChargePercent}%)</span><span>+ {fmt(serviceCharge)}</span></div>}
          <div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:"#8a8078",marginBottom:2}}><span>VAT incl. 20%</span><span>{fmt(vat)}</span></div>
          {tip>0&&<div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:"#d4952a",marginBottom:2,fontWeight:700}}><span>Tip</span><span>+ {fmt(tip)}</span></div>}
          <div style={{display:"flex",justifyContent:"space-between",fontWeight:700,fontSize:18,marginBottom:6,paddingTop:6,borderTop:"1px solid #ede8de"}}><span>TOTAL</span><span style={{color:"#bf4626"}}>{fmt(total)}</span></div>
          {splitN>1&&<div style={{display:"flex",justifyContent:"space-between",fontSize:13,color:"#7c3aed",marginBottom:8,fontWeight:700,background:"#f5f3ff",padding:"6px 10px",borderRadius:7}}><span>Per person ({splitN})</span><span>{fmt(perSplit)}</span></div>}

          {type==="dine-in"&&!tbl&&cart.length>0&&<div style={{padding:"10px 12px",background:"#fee2e2",borderRadius:7,marginBottom:8,fontSize:12,color:"#991b1b",fontWeight:700,textAlign:"center",border:"2px solid #fca5a5"}}>
            {EM.cross} Select a table number to continue
          </div>}
          {type==="dine-in"&&tbl&&orders&&(()=>{
            var tableIdNum=parseInt(tbl);
            var existing=orders.filter(o=>o.tableId===tableIdNum&&o.branchId===branch?.id&&!o.paid&&!["delivered","collected","cancelled"].includes(o.status));
            if(existing.length===0)return null;
            return <div style={{padding:"10px 12px",background:"#fef3c7",borderRadius:7,marginBottom:8,fontSize:11,color:"#92400e",border:"2px solid #fde68a"}}>
              <strong>{EM.star} Table {tbl} already has {existing.length} active order{existing.length!==1?"s":""}</strong>
              <br/>By {existing[0].takenBy||existing[0].customer||"another staff"} - {fmt(existing.reduce((s,o)=>s+o.total,0))}
              <br/>Your new items will be added to the same bill.
            </div>;
          })()}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:6,marginBottom:6}}>
            <button className="btn btn-d" disabled={!cart.length||(type==="dine-in"&&!tbl)} onClick={()=>setShowPayment(true)} style={{padding:"14px",fontSize:14,background:"linear-gradient(135deg,#059669,#10b981)",color:"#fff",border:"none"}}>{String.fromCharCode(0xD83D,0xDCB5)} Cash</button>
            <button className="btn btn-p" disabled={!cart.length||(type==="dine-in"&&!tbl)} onClick={()=>setShowPayment(true)} style={{padding:"14px",fontSize:14,background:"linear-gradient(135deg,#2563eb,#3b82f6)",color:"#fff",border:"none"}}>{String.fromCharCode(0xD83D,0xDCB3)} Card</button>
            <button disabled={!cart.length||(type==="dine-in"&&!tbl)} onClick={()=>setShowPayment(true)} style={{padding:"14px",fontSize:14,background:"linear-gradient(135deg,#7c3aed,#a855f7)",color:"#fff",border:"none",borderRadius:8,cursor:"pointer",fontWeight:700,opacity:!cart.length||(type==="dine-in"&&!tbl)?.5:1}}>Split</button>
          </div>
          <button className="btn btn-o" disabled={!cart.length||(type==="dine-in"&&!tbl)} onClick={()=>send(false,null)} style={{width:"100%",padding:"10px",fontSize:13}}>Send to kitchen (pay later)</button>
        </div>
      </div>
    </div>

    {showPicker&&(()=>{
      var branchTables=tables?tables.filter(t=>!t.branchId||t.branchId===branch?.id).sort((a,b)=>(+a.id)-(+b.id)):[];
      var statusColor={free:"#10b981",occupied:"#dc2626",reserved:"#d4952a"};
      var statusBg={free:"#d1fae5",occupied:"#fee2e2",reserved:"#fef3c7"};
      return <div onClick={()=>setShowPicker(false)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",zIndex:9000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
        <div onClick={e=>e.stopPropagation()} className="card" style={{width:"100%",maxWidth:520,padding:22,maxHeight:"85vh",overflowY:"auto"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
            <div>
              <h2 style={{fontSize:20,marginBottom:2}}>Pick a Table</h2>
              <p style={{fontSize:12,color:"#8a8078"}}>{branch?.name} - {branchTables.length} tables</p>
            </div>
            <button onClick={()=>setShowPicker(false)} style={{color:"#999",fontSize:22,border:"none",background:"none",cursor:"pointer"}}>x</button>
          </div>
          <div style={{display:"flex",gap:10,marginBottom:14,fontSize:11}}>
            {[["Free","#10b981"],["Occupied","#dc2626"],["Reserved","#d4952a"]].map(([l,c])=><div key={l} style={{display:"flex",alignItems:"center",gap:4}}><span style={{width:12,height:12,borderRadius:"50%",background:c,display:"inline-block"}}/><span style={{color:"#8a8078"}}>{l}</span></div>)}
          </div>
          {branchTables.length===0?<div style={{textAlign:"center",padding:30}}>
            <p style={{fontSize:40,marginBottom:10}}>{EM.cart}</p>
            <p style={{fontSize:14,color:"#8a8078"}}>No tables yet. Add tables in Admin panel.</p>
          </div>:<div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(85px,1fr))",gap:8}}>
            {branchTables.map(t=>{
              var c=statusColor[t.status]||statusColor.free;
              var bg=statusBg[t.status]||statusBg.free;
              var selected=String(tbl)===String(t.id);
              return <button key={(t.dbId||t.id)+"_"+t.id} onClick={()=>{
                if(t.status==="occupied"){
                  if(!window.confirm("Table "+t.id+" is occupied. Add another order to this table?"))return;
                }
                setTbl(String(t.id));
                setShowPicker(false);
                if(typeof window!=="undefined"&&window.navigator&&window.navigator.vibrate){window.navigator.vibrate(10);}
              }} style={{
                padding:"14px 6px",
                background:selected?"#bf4626":bg,
                color:selected?"#fff":c,
                border:"3px solid "+(selected?"#bf4626":c),
                borderRadius:10,
                cursor:"pointer",
                fontWeight:700,
                display:"flex",
                flexDirection:"column",
                alignItems:"center",
                gap:2,
                transition:"all .15s",
              }}>
                <span style={{fontSize:18}}>T{t.id}</span>
                <span style={{fontSize:10,fontWeight:600}}>{t.seats} seats</span>
                {t.status==="occupied"&&t.guests&&<span style={{fontSize:9,fontWeight:700}}>{t.guests} in</span>}
              </button>;
            })}
          </div>}
          <div style={{marginTop:14,display:"flex",gap:7}}>
            <button className="btn btn-o" onClick={()=>setShowPicker(false)} style={{flex:1,padding:"11px"}}>Cancel</button>
          </div>
        </div>
      </div>;
    })()}
  </div>;
}


// ============================================================
// PHASE A: RESTAURANT DIRECTORY - shown when no restaurant selected
// ============================================================

function RestaurantDirectory({onSelectRestaurant}){
  var [restaurants,setRestaurants]=useState([]);
  var [loading,setLoading]=useState(true);
  var [search,setSearch]=useState("");
  
  useEffect(()=>{
    dbFetchPublicRests().then(rs=>{
      setRestaurants((rs||[]).filter(r=>r.show_in_directory!==false));
      setLoading(false);
    });
  },[]);
  
  var cuisineEmojis={
    italian:String.fromCharCode(0xD83C,0xDF55),
    indian:String.fromCharCode(0xD83C,0xDF5B),
    chinese:String.fromCharCode(0xD83C,0xDF5C),
    british:String.fromCharCode(0xD83C,0xDF5F),
    american:String.fromCharCode(0xD83C,0xDF54),
    mexican:String.fromCharCode(0xD83C,0xDF2E),
    japanese:String.fromCharCode(0xD83C,0xDF63),
    thai:String.fromCharCode(0xD83C,0xDF5C),
    cafe:String.fromCharCode(0x2615),
    other:String.fromCharCode(0xD83C,0xDF7D,0xFE0F),
  };
  
  var filtered=restaurants.filter(r=>{
    if(!search.trim())return true;
    var s=search.toLowerCase();
    return r.name.toLowerCase().includes(s)||(r.cuisine_type||"").toLowerCase().includes(s);
  });
  
  var goToRestaurant=(slug)=>{
    window.location.href="/?r="+encodeURIComponent(slug);
  };
  
  return <div style={{minHeight:"100vh",background:"linear-gradient(135deg,#1a1208,#3d2e22)",padding:"20px 14px",fontFamily:"-apple-system,sans-serif"}}>
    <div style={{maxWidth:880,margin:"0 auto"}}>
      {/* Header */}
      <div style={{textAlign:"center",marginBottom:30,color:"#fff"}}>
        <p style={{fontSize:38,fontFamily:"Georgia,serif",fontWeight:300,letterSpacing:5,marginBottom:7}}>{String.fromCharCode(0xD83C,0xDF7D,0xFE0F)} La Tavola</p>
        <p style={{fontSize:14,opacity:.8,letterSpacing:3}}>RESTAURANT ORDERING PLATFORM</p>
      </div>
      
      {/* Search */}
      <div style={{marginBottom:24,position:"relative"}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search restaurants or cuisines..." style={{width:"100%",padding:"15px 18px",fontSize:14,border:"none",borderRadius:11,boxShadow:"0 8px 30px rgba(0,0,0,.3)",boxSizing:"border-box"}}/>
      </div>
      
      {/* Restaurant Grid */}
      {loading?<p style={{textAlign:"center",color:"#fff",opacity:.7}}>Loading restaurants...</p>:
        filtered.length===0?<div style={{textAlign:"center",color:"#fff",padding:50}}>
          <p style={{fontSize:50,marginBottom:11}}>{String.fromCharCode(0xD83D,0xDD0D)}</p>
          <p style={{fontSize:16,opacity:.85}}>No restaurants found</p>
          {search&&<p style={{fontSize:13,opacity:.6,marginTop:6}}>Try searching for something else</p>}
        </div>:
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:14}}>
          {filtered.map(r=>{
            var emoji=cuisineEmojis[r.cuisine_type]||cuisineEmojis.other;
            return <button key={r.id} onClick={()=>goToRestaurant(r.slug)} style={{textAlign:"left",background:"#fff",border:"none",borderRadius:13,padding:0,cursor:"pointer",overflow:"hidden",transition:"transform 0.2s",boxShadow:"0 8px 24px rgba(0,0,0,.2)"}} onMouseEnter={e=>e.currentTarget.style.transform="translateY(-3px)"} onMouseLeave={e=>e.currentTarget.style.transform="translateY(0)"}>
              <div style={{height:90,background:"linear-gradient(135deg,"+(r.brand_color||"#bf4626")+","+(r.brand_color||"#bf4626")+"99)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:42}}>{emoji}</div>
              <div style={{padding:13}}>
                <p style={{fontWeight:700,fontSize:16,marginBottom:3,color:"#1a1208"}}>{r.name}</p>
                <p style={{fontSize:11,color:"#8a8078",textTransform:"capitalize",marginBottom:5}}>{(r.cuisine_type||"Restaurant").toUpperCase()}</p>
                {r.address&&<p style={{fontSize:11,color:"#8a8078",marginBottom:9}}>{String.fromCharCode(0xD83D,0xDCCD)} {r.address.substring(0,40)}</p>}
                <div style={{padding:"7px 11px",background:r.brand_color||"#bf4626",color:"#fff",borderRadius:6,textAlign:"center",fontSize:12,fontWeight:700}}>Order Now {String.fromCharCode(0x2192)}</div>
              </div>
            </button>;
          })}
        </div>
      }
      
      {/* Footer */}
      <div style={{textAlign:"center",marginTop:35,color:"#fff",opacity:.5,fontSize:11}}>
        <p>Are you a restaurant owner?</p>
        <button onClick={()=>{window.location.href="/?signup=1";}} style={{marginTop:7,padding:"7px 16px",background:"rgba(255,255,255,.1)",color:"#fff",border:"1px solid rgba(255,255,255,.2)",borderRadius:7,fontSize:11,cursor:"pointer",fontWeight:700}}>Join La Tavola Platform</button>
      </div>
    </div>
  </div>;
}

// ============================================================
// PHASE A: QR CODE GENERATOR FOR OWNERS
// ============================================================

function RestaurantQRGenerator({restaurant,onClose}){
  var baseUrl=window.location.origin;
  var customerUrl=baseUrl+"/?r="+restaurant.slug;
  var subdomainUrl="https://"+(restaurant.subdomain||restaurant.slug)+".latavola.app";
  
  var qrUrl=encodeURIComponent(customerUrl);
  var qrImageUrl="https://api.qrserver.com/v1/create-qr-code/?size=400x400&data="+qrUrl+"&color=1a1208&bgcolor=fafaf5";
  var qrLargeUrl="https://api.qrserver.com/v1/create-qr-code/?size=800x800&data="+qrUrl+"&color=1a1208&bgcolor=fafaf5";
  
  var copyLink=()=>{
    try{
      navigator.clipboard.writeText(customerUrl);
      alert("Link copied to clipboard!");
    }catch(e){
      alert("Link: "+customerUrl);
    }
  };
  
  var printQR=()=>{
    var w=window.open("","_blank","width=600,height=800");
    if(!w)return;
    w.document.write('<html><head><title>QR Code - '+restaurant.name+'</title><style>body{font-family:-apple-system,sans-serif;padding:30px;text-align:center;color:#1a1208}h1{font-size:32px;margin-bottom:8px}h2{font-size:18px;color:'+(restaurant.brand_color||"#bf4626")+';margin-bottom:24px;font-weight:600}img{width:300px;height:300px;border:2px dashed #8a8078;padding:12px;border-radius:14px;background:#fafaf5}p.url{margin-top:18px;font-family:monospace;font-size:11px;color:#666;word-break:break-all}p.instr{margin-top:18px;font-size:14px;color:#1a1208;font-weight:600}p.brand{margin-top:30px;font-size:9px;color:#aaa;letter-spacing:2px}.frame{display:inline-block;padding:30px;border:3px solid '+(restaurant.brand_color||"#bf4626")+';border-radius:18px;margin-top:14px}</style></head><body><h1>'+restaurant.name+'</h1><h2>SCAN TO ORDER</h2><div class="frame"><img src="'+qrLargeUrl+'"/></div><p class="instr">Point your phone camera at the QR code</p><p class="url">'+customerUrl+'</p><p class="brand">POWERED BY LA TAVOLA PLATFORM</p></body></html>');
    setTimeout(()=>{w.print();},500);
  };
  
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",zIndex:9500,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
    <div style={{background:"#fafaf5",borderRadius:14,maxWidth:520,width:"100%",maxHeight:"96vh",overflow:"hidden",display:"flex",flexDirection:"column"}}>
      <div style={{background:"linear-gradient(135deg,"+(restaurant.brand_color||"#bf4626")+","+(restaurant.brand_color||"#bf4626")+"99)",color:"#fff",padding:"15px 22px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <p style={{fontSize:11,opacity:.85,fontWeight:700,letterSpacing:2}}>SHARE YOUR RESTAURANT</p>
          <h2 style={{fontSize:18,fontWeight:700}}>{String.fromCharCode(0xD83D,0xDCF1)} QR Code &amp; Links</h2>
        </div>
        <button onClick={onClose} style={{width:34,height:34,borderRadius:"50%",background:"rgba(255,255,255,.15)",color:"#fff",border:"none",cursor:"pointer",fontSize:16,fontWeight:700}}>x</button>
      </div>
      
      <div style={{flex:1,overflowY:"auto",padding:22}}>
        {/* QR Code */}
        <div style={{textAlign:"center",marginBottom:20}}>
          <p style={{fontSize:11,fontWeight:700,letterSpacing:2,color:"#8a8078",marginBottom:11}}>SCAN TO ORDER</p>
          <div style={{display:"inline-block",padding:14,background:"#fff",borderRadius:13,border:"3px dashed "+(restaurant.brand_color||"#bf4626"),boxShadow:"0 4px 14px rgba(0,0,0,.08)"}}>
            <img src={qrImageUrl} alt="QR Code" style={{width:200,height:200,display:"block"}}/>
          </div>
        </div>
        
        <button onClick={printQR} style={{width:"100%",padding:"14px",background:"linear-gradient(135deg,"+(restaurant.brand_color||"#bf4626")+","+(restaurant.brand_color||"#bf4626")+"99)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:14,cursor:"pointer",marginBottom:11}}>{String.fromCharCode(0xD83D,0xDDA8,0xFE0F)} Print QR Code Poster</button>
        
        {/* Direct Link */}
        <div style={{padding:14,background:"#fff",borderRadius:9,marginBottom:11,border:"1px solid #ede8de"}}>
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>DIRECT LINK (Path)</p>
          <p style={{fontSize:13,fontFamily:"monospace",color:"#1a1208",wordBreak:"break-all",marginBottom:9}}>{customerUrl}</p>
          <button onClick={copyLink} style={{padding:"7px 13px",background:"#1a1208",color:"#fff",border:"none",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0xD83D,0xDCCB)} Copy Link</button>
        </div>
        
        {/* Subdomain Link */}
        <div style={{padding:14,background:"#fff",borderRadius:9,marginBottom:14,border:"1px solid #ede8de"}}>
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>SUBDOMAIN (Available After Domain Setup)</p>
          <p style={{fontSize:13,fontFamily:"monospace",color:"#8a8078",wordBreak:"break-all",marginBottom:5,textDecoration:"line-through"}}>{subdomainUrl}</p>
          <p style={{fontSize:10,color:"#8a8078",fontStyle:"italic"}}>Available when you upgrade to Pro plan with custom domain</p>
        </div>
        
        {/* Tips */}
        <div style={{padding:13,background:"#fef3c7",borderRadius:9,fontSize:11,color:"#92400e",marginBottom:11}}>
          <p style={{fontWeight:700,marginBottom:5}}>{String.fromCharCode(0xD83D,0xDCA1)} TIPS:</p>
          <ul style={{paddingLeft:18,lineHeight:1.7,margin:0}}>
            <li>Print the QR code and put it on every table</li>
            <li>Add the link to your Instagram bio</li>
            <li>Share the link in WhatsApp groups</li>
            <li>Print on flyers and business cards</li>
            <li>Add to your Google Business profile</li>
          </ul>
        </div>
      </div>
    </div>
  </div>;
}


// ============================================================
// SUPER ADMIN PANEL - Platform owner control center
// ============================================================

// =================================================================
// REP FORM MODAL - Create/Edit Sales Rep
// =================================================================
function RepFormModal({rep,onClose,onSave}){
  var isEdit=!!rep;
  var [form,setForm]=useState({
    full_name:rep?.full_name||"",
    email:rep?.email||"",
    password:"",
    phone:rep?.phone||"",
    commission_type:rep?.commission_type||"percentage",
    commission_percent:rep?.commission_percent||15,
    fixed_per_signup:rep?.fixed_per_signup||0,
    base_salary:rep?.base_salary||0,
    recurring_commission:rep?.recurring_commission||false,
    active:rep?.active!==false,
    notes:rep?.notes||"",
  });
  
  var save=()=>{
    if(!form.full_name||!form.email){alert("Name and email required");return;}
    if(!isEdit&&!form.password){alert("Password required for new rep");return;}
    var data={...form};
    if(isEdit&&!data.password)delete data.password; // Don't update password if empty
    onSave(data);
  };
  
  return <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:18}}>
    <div onClick={e=>e.stopPropagation()} style={{background:"#1a1208",borderRadius:14,padding:22,maxWidth:540,width:"100%",maxHeight:"90vh",overflow:"auto",border:"2px solid #3d2e22"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
        <h2 style={{fontSize:20,color:"#fbbf24",fontFamily:"Georgia,serif"}}>{isEdit?"Edit Sales Rep":"Add Sales Rep"}</h2>
        <button onClick={onClose} style={{background:"none",border:"none",color:"#a8956a",fontSize:24,cursor:"pointer"}}>{String.fromCharCode(0x00D7)}</button>
      </div>
      
      <div style={{display:"grid",gap:11}}>
        <div>
          <p style={{fontSize:10,color:"#a8956a",fontWeight:700,letterSpacing:1,marginBottom:5}}>FULL NAME</p>
          <input value={form.full_name} onChange={e=>setForm(f=>({...f,full_name:e.target.value}))} style={{width:"100%",padding:11,background:"#0f0a05",color:"#fff",border:"1px solid #3d2e22",borderRadius:7,fontSize:13,boxSizing:"border-box"}}/>
        </div>
        
        <div>
          <p style={{fontSize:10,color:"#a8956a",fontWeight:700,letterSpacing:1,marginBottom:5}}>EMAIL</p>
          <input type="email" value={form.email} onChange={e=>setForm(f=>({...f,email:e.target.value}))} style={{width:"100%",padding:11,background:"#0f0a05",color:"#fff",border:"1px solid #3d2e22",borderRadius:7,fontSize:13,boxSizing:"border-box"}}/>
        </div>
        
        <div>
          <p style={{fontSize:10,color:"#a8956a",fontWeight:700,letterSpacing:1,marginBottom:5}}>PASSWORD {isEdit&&"(leave empty to keep current)"}</p>
          <input type="password" value={form.password} onChange={e=>setForm(f=>({...f,password:e.target.value}))} placeholder={isEdit?"Leave empty":"Set password"} style={{width:"100%",padding:11,background:"#0f0a05",color:"#fff",border:"1px solid #3d2e22",borderRadius:7,fontSize:13,boxSizing:"border-box"}}/>
        </div>
        
        <div>
          <p style={{fontSize:10,color:"#a8956a",fontWeight:700,letterSpacing:1,marginBottom:5}}>PHONE (optional)</p>
          <input value={form.phone} onChange={e=>setForm(f=>({...f,phone:e.target.value}))} style={{width:"100%",padding:11,background:"#0f0a05",color:"#fff",border:"1px solid #3d2e22",borderRadius:7,fontSize:13,boxSizing:"border-box"}}/>
        </div>
        
        <div>
          <p style={{fontSize:10,color:"#a8956a",fontWeight:700,letterSpacing:1,marginBottom:5}}>COMMISSION TYPE</p>
          <select value={form.commission_type} onChange={e=>setForm(f=>({...f,commission_type:e.target.value}))} style={{width:"100%",padding:11,background:"#0f0a05",color:"#fff",border:"1px solid #3d2e22",borderRadius:7,fontSize:13,boxSizing:"border-box"}}>
            <option value="percentage">Percentage of plan price</option>
            <option value="fixed">Fixed amount per signup</option>
            <option value="salary">Monthly salary only</option>
            <option value="hybrid">Hybrid (percentage + fixed)</option>
          </select>
        </div>
        
        {(form.commission_type==="percentage"||form.commission_type==="hybrid")&&<div>
          <p style={{fontSize:10,color:"#a8956a",fontWeight:700,letterSpacing:1,marginBottom:5}}>COMMISSION PERCENT (% of plan price)</p>
          <input type="number" min="0" max="100" value={form.commission_percent} onChange={e=>setForm(f=>({...f,commission_percent:parseFloat(e.target.value)||0}))} style={{width:"100%",padding:11,background:"#0f0a05",color:"#fff",border:"1px solid #3d2e22",borderRadius:7,fontSize:13,boxSizing:"border-box"}}/>
        </div>}
        
        {(form.commission_type==="fixed"||form.commission_type==="hybrid")&&<div>
          <p style={{fontSize:10,color:"#a8956a",fontWeight:700,letterSpacing:1,marginBottom:5}}>FIXED AMOUNT PER SIGNUP (£)</p>
          <input type="number" min="0" value={form.fixed_per_signup} onChange={e=>setForm(f=>({...f,fixed_per_signup:parseFloat(e.target.value)||0}))} style={{width:"100%",padding:11,background:"#0f0a05",color:"#fff",border:"1px solid #3d2e22",borderRadius:7,fontSize:13,boxSizing:"border-box"}}/>
        </div>}
        
        {(form.commission_type==="salary"||form.commission_type==="hybrid")&&<div>
          <p style={{fontSize:10,color:"#a8956a",fontWeight:700,letterSpacing:1,marginBottom:5}}>MONTHLY SALARY (£)</p>
          <input type="number" min="0" value={form.base_salary} onChange={e=>setForm(f=>({...f,base_salary:parseFloat(e.target.value)||0}))} style={{width:"100%",padding:11,background:"#0f0a05",color:"#fff",border:"1px solid #3d2e22",borderRadius:7,fontSize:13,boxSizing:"border-box"}}/>
        </div>}
        
        <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",padding:9,background:"#0f0a05",borderRadius:7}}>
          <input type="checkbox" checked={form.recurring_commission} onChange={e=>setForm(f=>({...f,recurring_commission:e.target.checked}))} style={{width:18,height:18}}/>
          <span style={{fontSize:12,color:"#fff"}}>Recurring monthly commission (paid each month the restaurant subscribes)</span>
        </label>
        
        <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",padding:9,background:"#0f0a05",borderRadius:7}}>
          <input type="checkbox" checked={form.active} onChange={e=>setForm(f=>({...f,active:e.target.checked}))} style={{width:18,height:18}}/>
          <span style={{fontSize:12,color:"#fff"}}>Active (can login)</span>
        </label>
        
        <div>
          <p style={{fontSize:10,color:"#a8956a",fontWeight:700,letterSpacing:1,marginBottom:5}}>NOTES (internal only)</p>
          <textarea value={form.notes} onChange={e=>setForm(f=>({...f,notes:e.target.value}))} rows={3} style={{width:"100%",padding:11,background:"#0f0a05",color:"#fff",border:"1px solid #3d2e22",borderRadius:7,fontSize:13,boxSizing:"border-box",resize:"vertical"}}/>
        </div>
      </div>
      
      <div style={{display:"flex",gap:9,marginTop:18}}>
        <button onClick={onClose} style={{flex:1,padding:13,background:"#0f0a05",color:"#a8956a",border:"1px solid #3d2e22",borderRadius:7,fontWeight:700,fontSize:13,cursor:"pointer"}}>Cancel</button>
        <button onClick={save} style={{flex:2,padding:13,background:"#bf4626",color:"#fff",border:"none",borderRadius:7,fontWeight:700,fontSize:13,cursor:"pointer"}}>{isEdit?"Save Changes":"Create Rep"}</button>
      </div>
    </div>
  </div>;
}

// =================================================================
// SALES REP LOGIN SCREEN
// =================================================================
// =================================================================
// DRIVER LOGIN SCREEN - Email/Password OR PIN
// =================================================================
function DriverLoginScreen({onLogin}){
  var [mode,setMode]=useState("email"); // 'email' or 'pin'
  var [email,setEmail]=useState("");
  var [password,setPassword]=useState("");
  var [pin,setPin]=useState("");
  var [loading,setLoading]=useState(false);
  var [error,setError]=useState("");
  
  // Check URL for restaurant slug (e.g. ?driver=1&r=latavola)
  var restaurantSlug=null;
  try{
    var p=new URLSearchParams(window.location.search);
    restaurantSlug=p.get("r")||null;
  }catch(e){}
  
  var doEmailLogin=async()=>{
    if(!email||!password){setError("Email and PIN required");return;}
    setLoading(true);
    setError("");
    var result=await dbDriverEmail(email,password);
    setLoading(false);
    if(result.error){
      setError(result.error.message);
      return;
    }
    dbSaveDriver(result.data);
    onLogin(result.data);
  };
  
  var doPinLogin=async()=>{
    if(!pin||pin.length<4){setError("Enter your 4+ digit PIN");return;}
    setLoading(true);
    setError("");
    var result=await dbDriverPin(pin,restaurantSlug);
    setLoading(false);
    if(result.error){
      setError(result.error.message);
      // If PIN is ambiguous, suggest email login
      if(result.error.multiple){
        setMode("email");
      }
      return;
    }
    dbSaveDriver(result.data);
    onLogin(result.data);
  };
  
  return <div style={{minHeight:"100vh",background:"linear-gradient(135deg,#0c4a6e,#0e7490,#06b6d4)",display:"flex",alignItems:"center",justifyContent:"center",padding:18,fontFamily:"-apple-system,sans-serif"}}>
    <div style={{maxWidth:420,width:"100%",background:"#fff",borderRadius:18,padding:32,boxShadow:"0 20px 60px rgba(0,0,0,.3)"}}>
      <div style={{textAlign:"center",marginBottom:22}}>
        <div style={{fontSize:54,marginBottom:9}}>{String.fromCharCode(0xD83D,0xDEF5)}</div>
        <h2 style={{fontSize:24,fontWeight:700,color:"#1a1208",fontFamily:"Georgia,serif",marginBottom:5}}>Driver Portal</h2>
        <p style={{color:"#8a8078",fontSize:12}}>Sign in to start your deliveries</p>
      </div>
      
      {/* Mode Tabs */}
      <div style={{display:"flex",gap:5,marginBottom:18,padding:5,background:"#f7f3ee",borderRadius:9}}>
        <button onClick={()=>{setMode("email");setError("");}} style={{flex:1,padding:"9px",background:mode==="email"?"#fff":"transparent",color:mode==="email"?"#1a1208":"#8a8078",border:"none",borderRadius:7,fontSize:12,fontWeight:700,cursor:"pointer",boxShadow:mode==="email"?"0 1px 3px rgba(0,0,0,.1)":"none"}}>{String.fromCharCode(0xD83D,0xDCE7)} Email Login</button>
        <button onClick={()=>{setMode("pin");setError("");}} style={{flex:1,padding:"9px",background:mode==="pin"?"#fff":"transparent",color:mode==="pin"?"#1a1208":"#8a8078",border:"none",borderRadius:7,fontSize:12,fontWeight:700,cursor:"pointer",boxShadow:mode==="pin"?"0 1px 3px rgba(0,0,0,.1)":"none"}}>{String.fromCharCode(0xD83D,0xDD12)} Quick PIN</button>
      </div>
      
      {mode==="email"?<>
        <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>EMAIL ADDRESS</p>
        <input value={email} onChange={e=>setEmail(e.target.value)} type="email" placeholder="rumu@example.com" autoFocus style={{width:"100%",padding:"13px",border:"2px solid #ede8de",borderRadius:7,fontSize:14,marginBottom:11,boxSizing:"border-box"}}/>
        
        <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>PIN (PASSWORD)</p>
        <input value={password} onChange={e=>setPassword(e.target.value)} onKeyPress={e=>e.key==="Enter"&&doEmailLogin()} type="password" inputMode="numeric" pattern="[0-9]*" placeholder="****" style={{width:"100%",padding:"13px",border:"2px solid #ede8de",borderRadius:7,fontSize:14,marginBottom:14,boxSizing:"border-box",letterSpacing:4}}/>
        <p style={{fontSize:11,color:"#0891b2",marginTop:-7,marginBottom:14,textAlign:"center"}}>{String.fromCharCode(0x2705)} Recommended - works for all restaurants</p>
      </>:<>
        <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>YOUR 4-DIGIT PIN</p>
        <input value={pin} onChange={e=>setPin(e.target.value.replace(/\D/g,""))} onKeyPress={e=>e.key==="Enter"&&doPinLogin()} type="password" inputMode="numeric" pattern="[0-9]*" maxLength={6} placeholder="****" autoFocus style={{width:"100%",padding:"18px",border:"2px solid #ede8de",borderRadius:7,fontSize:28,marginBottom:14,boxSizing:"border-box",letterSpacing:11,textAlign:"center",fontWeight:700}}/>
        {restaurantSlug?
          <p style={{fontSize:11,color:"#059669",textAlign:"center",marginTop:-7,marginBottom:14,fontWeight:600}}>{String.fromCharCode(0x2705)} Restaurant: {restaurantSlug}</p>
          :
          <p style={{fontSize:11,color:"#d97706",textAlign:"center",marginTop:-7,marginBottom:14}}>{String.fromCharCode(0x26A0,0xFE0F)} If PIN doesn't work, use Email Login</p>
        }
      </>}
      
      {error&&<div style={{background:"#fee2e2",color:"#991b1b",padding:11,borderRadius:7,marginBottom:11,fontSize:12,textAlign:"center",fontWeight:600}}>{error}</div>}
      
      <button onClick={mode==="email"?doEmailLogin:doPinLogin} disabled={loading} style={{width:"100%",padding:"15px",background:loading?"#9ca3af":"linear-gradient(135deg,#0891b2,#0e7490)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:14,cursor:loading?"not-allowed":"pointer"}}>{loading?"Signing in...":String.fromCharCode(0xD83D,0xDEF5)+" Sign In"}</button>
      
      <button onClick={()=>{window.location.href="/";}} style={{width:"100%",marginTop:11,padding:"11px",background:"transparent",color:"#8a8078",border:"none",cursor:"pointer",fontSize:11}}>{String.fromCharCode(0x2190)} Back to Main Site</button>
    </div>
  </div>;
}

// =================================================================
// DRIVER STANDALONE VIEW - just DriverV with logout, no other tabs
// =================================================================
function DriverStandaloneView({driver, onLogout}){
  var [available,setAvailable]=useState([]);
  var [mine,setMine]=useState([]);
  var [completed,setCompleted]=useState([]);
  var [toasts,setToasts]=useState([]);
  var [loading,setLoading]=useState(true);
  var [codeInput,setCodeInput]=useState({});
  var [soundOn,setSoundOn]=useState(true);
  var prevAvailCount=useRef(0);
  var [showCompleted,setShowCompleted]=useState(false);
  // Cash handover state
  var [cashToHandover,setCashToHandover]=useState({orders:[],total:0});
  var [pendingHandover,setPendingHandover]=useState(null);
  var [handoverHistory,setHandoverHistory]=useState([]);
  var [showHandoverHistory,setShowHandoverHistory]=useState(false);
  var [handoverBusy,setHandoverBusy]=useState(false);
  
  var pushNotif=(t)=>{
    var id=Date.now();
    setToasts(ts=>[...ts,{...t,id}]);
    setTimeout(()=>setToasts(ts=>ts.filter(x=>x.id!==id)),4000);
  };
  
  // Play notification sound
  var playDing=()=>{
    if(!soundOn)return;
    try{
      var ctx=new(window.AudioContext||window.webkitAudioContext)();
      var osc=ctx.createOscillator();
      var gain=ctx.createGain();
      osc.connect(gain);gain.connect(ctx.destination);
      osc.frequency.value=880;
      gain.gain.setValueAtTime(0.3,ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.01,ctx.currentTime+0.5);
      osc.start();osc.stop(ctx.currentTime+0.5);
    }catch(e){}
  };
  
  useEffect(()=>{
    if(driver?.restaurants){
      try{
        window.__currentRestaurant=driver.restaurants;
        // CRITICAL: Restore restaurant ID context (lost on refresh)
        dbSetRestaurantId(driver.restaurants.id);
        console.log("Driver portal: restaurant context set to",driver.restaurants.id);
      }catch(e){console.error("Failed to set restaurant context:",e);}
    }
  },[driver]);
  
  // Load orders periodically
  var loadOrders=async()=>{
    if(!driver?.id)return;
    // Ensure restaurant context is set before fetching (critical after refresh)
    if(driver?.restaurants?.id){
      try{dbSetRestaurantId(driver.restaurants.id);}catch(e){}
    }
    try{
      var result=await dbFetchDriverOrders(driver.id);
      // Detect new available orders for sound alert
      if(result.available.length>prevAvailCount.current&&prevAvailCount.current>=0&&!loading){
        playDing();
        pushNotif({title:String.fromCharCode(0xD83D,0xDD14)+" New order ready!",body:"An order is available for delivery",color:"#0891b2"});
      }
      prevAvailCount.current=result.available.length;
      setAvailable(result.available||[]);
      setMine(result.mine||[]);
      setCompleted(result.completed||[]);
      setLoading(false);
      // Load handover data
      loadHandoverData();
    }catch(e){console.error("Load orders error:",e);setLoading(false);}
  };
  
  var loadHandoverData=async()=>{
    if(!driver?.id)return;
    // Ensure restaurant context is set (critical - history filters by restaurant)
    if(driver?.restaurants?.id){
      try{dbSetRestaurantId(driver.restaurants.id);}catch(e){}
    }
    try{
      var pending=await dbPendingHandover(driver.id);
      setPendingHandover(pending);
      if(!pending){
        // Only show cash-to-handover if no pending handover
        var cash=await dbCashToHandover(driver.id);
        setCashToHandover(cash);
      }
      var hist=await dbHandoverHistory({driverId:driver.id});
      setHandoverHistory(hist||[]);
    }catch(e){console.error("Load handover error:",e);}
  };
  
  useEffect(()=>{
    loadOrders();
    var interval=setInterval(loadOrders,10000); // refresh every 10s
    return()=>clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[driver]);
  
  var fmt=(n)=>"\u00A3"+parseFloat(n||0).toFixed(2);
  
  // Claim an order
  var claim=async(order)=>{
    var result=await dbClaimOrder(order.id,driver.id,driver.full_name);
    if(result.error){
      pushNotif({title:"Couldn't claim",body:result.error.message,color:"#dc2626"});
      loadOrders(); // refresh to show current state
      return;
    }
    pushNotif({title:String.fromCharCode(0x2705)+" Order claimed!",body:"Added to your deliveries",color:"#059669"});
    loadOrders();
  };
  
  // Release an order
  var release=async(order)=>{
    if(!window.confirm("Release this order back to the pool? Another driver can take it."))return;
    var result=await dbUnclaimOrder(order.id,driver.id);
    if(result.error){
      pushNotif({title:"Couldn't release",body:result.error.message,color:"#dc2626"});
      return;
    }
    pushNotif({title:"Order released",body:"Back in available pool",color:"#d97706"});
    loadOrders();
  };
  
  // Start delivery (picked up)
  var pickup=async(order)=>{
    var result=await dbStartDelivery(order.id,driver.id);
    if(result.error){
      pushNotif({title:"Error",body:result.error.message,color:"#dc2626"});
      return;
    }
    pushNotif({title:String.fromCharCode(0xD83D,0xDEF5)+" On your way!",body:"Drive safely",color:"#0891b2"});
    loadOrders();
  };
  
  // Verify delivery code
  var verifyCode=async(order)=>{
    var entered=(codeInput[order.id]||"").trim();
    var expected=String(order.delivery_code||order.deliveryCode||"").trim();
    
    // No code set on this order - skip verification, just mark delivered
    if(!expected||expected==="null"||expected==="undefined"){
      await markDelivered(order);
      return;
    }
    
    // Code is set - must match
    if(!entered){
      pushNotif({title:"Enter code",body:"Ask customer for their delivery code",color:"#d97706"});
      return;
    }
    if(entered!==expected){
      pushNotif({title:"Wrong code",body:"Code doesn't match. Try again.",color:"#dc2626"});
      return;
    }
    
    // Code matches!
    await markDelivered(order);
  };
  
  // Mark delivered
  var markDelivered=async(order)=>{
    try{
      var result=await dbMarkDelivered(order.id,driver.id,driver.full_name);
      if(result.error){
        pushNotif({title:"Error",body:"Could not mark delivered: "+result.error.message,color:"#dc2626"});
        return;
      }
      // If already paid (online) - fully done. If NOT paid - needs cash collection
      if(order.paid){
        pushNotif({title:String.fromCharCode(0x2705)+" Delivered!",body:"Great job",color:"#059669"});
      }else{
        pushNotif({title:String.fromCharCode(0xD83D,0xDCB5)+" Now collect cash",body:fmt(order.total)+" - tap Confirm Cash",color:"#d97706"});
      }
      loadOrders();
    }catch(e){
      pushNotif({title:"Error",body:"Could not mark delivered",color:"#dc2626"});
    }
  };
  
  // Collect cash
  var collectCash=async(order)=>{
    try{
      var amount=parseFloat(order.total||0);
      var result=await dbDriverCash(order.id,amount,driver.id,driver.full_name);
      if(result.error){
        pushNotif({title:"Error",body:"Could not record payment: "+result.error.message,color:"#dc2626"});
        return;
      }
      pushNotif({title:String.fromCharCode(0xD83D,0xDCB0)+" Cash collected!",body:fmt(amount)+" recorded",color:"#059669"});
      loadOrders();
    }catch(e){
      pushNotif({title:"Error",body:"Could not record payment",color:"#dc2626"});
    }
  };
  
  // Cash in hand calculation - cash collected from completed COD orders
  var cashOwed=completed.reduce((s,o)=>{
    // Order is paid + was cash (collected by driver) = driver holds this cash
    if(o.paid&&(o.pay_method==="cash"||o.pay_method==="cod"))return s+parseFloat(o.cash_collected||o.total||0);
    return s;
  },0);
  
  // HANDOVER: Driver initiates handover
  var doInitiateHandover=async()=>{
    if(cashToHandover.total<=0){
      pushNotif({title:"No cash to hand over",body:"Collect cash from deliveries first",color:"#d97706"});
      return;
    }
    var ok=await window.showConfirm(
      "Hand Over Cash?",
      "You are handing over "+fmt(cashToHandover.total)+" from "+cashToHandover.orders.length+" deliveries to your manager.\n\nThe manager will count and confirm the amount.",
      "Yes, Hand Over","Cancel","info"
    );
    if(!ok)return;
    setHandoverBusy(true);
    var orderIds=cashToHandover.orders.map(o=>o.id);
    var result=await dbInitiateHandover(driver.id,driver.full_name,cashToHandover.total,orderIds);
    setHandoverBusy(false);
    if(result.error){
      pushNotif({title:"Error",body:"Could not start handover",color:"#dc2626"});
      return;
    }
    pushNotif({title:String.fromCharCode(0x2705)+" Handover started",body:"Give cash to manager - they will confirm",color:"#059669"});
    loadHandoverData();
  };
  
  // HANDOVER: Driver cancels pending handover
  var doCancelHandover=async()=>{
    if(!pendingHandover)return;
    var ok=await window.showConfirm(
      "Cancel Handover?",
      "This will cancel the pending handover. You can start a new one later.",
      "Yes, Cancel It","Keep It","warning"
    );
    if(!ok)return;
    setHandoverBusy(true);
    await dbCancelHandover(pendingHandover.id,driver.id);
    setHandoverBusy(false);
    pushNotif({title:"Handover cancelled",body:"",color:"#d97706"});
    loadHandoverData();
  };
  
  // Render an order card
  var renderOrderCard=(o,section)=>{
    var addr=o.address||{};
    var addrLine=[addr.line1,addr.city,addr.postcode].filter(Boolean).join(", ")||o.delivery_address||"No address";
    var needsCash=o.status==="delivered"&&!o.paid;
    var customerName=o.customer_name||o.customer||"Customer";
    
    return <div key={o.id} style={{background:"#fff",borderRadius:11,padding:14,marginBottom:9,boxShadow:"0 2px 8px rgba(0,0,0,.06)",borderLeft:"5px solid "+(section==="available"?"#0891b2":section==="completed"?"#10b981":needsCash?"#f59e0b":o.status==="out_for_delivery"?"#2563eb":"#bf4626")}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:7,gap:7}}>
        <div style={{flex:1,minWidth:0}}>
          <p style={{fontWeight:700,fontSize:15}}>{customerName}</p>
          <p style={{fontSize:11,color:"#8a8078"}}>{o.order_number||o.id} {String.fromCharCode(0x2022)} {fmt(o.total)} {String.fromCharCode(0x2022)} {o.pay_method==="cod"?String.fromCharCode(0xD83D,0xDCB5)+" CASH":o.paid?String.fromCharCode(0x2705)+" PAID":String.fromCharCode(0x26A0,0xFE0F)+" UNPAID"}</p>
          <p style={{fontSize:13,marginTop:5,fontWeight:600}}>{String.fromCharCode(0xD83D,0xDCCD)} {addrLine}</p>
          {addr.notes&&<p style={{fontSize:11,color:"#8a8078",fontStyle:"italic",marginTop:2}}>Note: {addr.notes}</p>}
        </div>
      </div>
      
      {/* Items */}
      <div style={{background:"#fafaf5",borderRadius:7,padding:"7px 10px",marginBottom:9,fontSize:11}}>
        {(o.items||[]).map((it,i)=><div key={i} style={{display:"flex",justifyContent:"space-between"}}><span>{it.name} x{it.qty}</span><span>{fmt((+it.price||0)*it.qty)}</span></div>)}
      </div>
      
      {/* AVAILABLE - Claim button */}
      {section==="available"&&<button onClick={()=>claim(o)} style={{width:"100%",padding:"13px",background:"linear-gradient(135deg,#0891b2,#0e7490)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:14,cursor:"pointer"}}>{String.fromCharCode(0x270B)} Claim This Order</button>}
      
      {/* MINE - Action buttons */}
      {section==="mine"&&<>
        {/* Call / Navigate / SMS */}
        <div style={{display:"flex",gap:6,marginBottom:9}}>
          {o.phone&&<a href={"tel:"+o.phone} style={{flex:1,padding:"10px",background:"#2563eb",color:"#fff",borderRadius:8,fontWeight:700,fontSize:12,textAlign:"center",textDecoration:"none"}}>{String.fromCharCode(0xD83D,0xDCDE)} Call</a>}
          {addrLine!=="No address"&&<a href={"https://www.google.com/maps/dir/?api=1&destination="+encodeURIComponent(addrLine)} target="_blank" rel="noopener noreferrer" style={{flex:1,padding:"10px",background:"#059669",color:"#fff",borderRadius:8,fontWeight:700,fontSize:12,textAlign:"center",textDecoration:"none"}}>{String.fromCharCode(0xD83D,0xDDFA,0xFE0F)} Navigate</a>}
          {o.phone&&<a href={"sms:"+o.phone+"?body="+encodeURIComponent("Hi! Your order from "+(driver.restaurants?.name||"the restaurant")+" is on the way!")} style={{padding:"10px 13px",background:"#7c3aed",color:"#fff",borderRadius:8,fontWeight:700,fontSize:12,textAlign:"center",textDecoration:"none"}}>{String.fromCharCode(0xD83D,0xDCAC)}</a>}
        </div>
        
        {o.status==="ready"&&<div style={{display:"flex",gap:6}}>
          <button onClick={()=>release(o)} style={{padding:"12px 14px",background:"#fff",color:"#dc2626",border:"2px solid #fecaca",borderRadius:9,fontWeight:700,fontSize:12,cursor:"pointer"}}>Release</button>
          <button onClick={()=>pickup(o)} style={{flex:1,padding:"12px",background:"linear-gradient(135deg,#bf4626,#7c2d12)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>{String.fromCharCode(0xD83D,0xDEF5)} Pick Up - Start Delivery</button>
        </div>}
        
        {o.status==="out_for_delivery"&&<div style={{padding:"11px",background:"#fff7ed",borderRadius:9,border:"2px dashed #f59e0b"}}>
          <p style={{fontSize:12,fontWeight:700,color:"#92400e",marginBottom:7,textAlign:"center"}}>{String.fromCharCode(0xD83D,0xDCCD)} At customer's door? Enter delivery code</p>
          <div style={{display:"flex",gap:6}}>
            <input value={codeInput[o.id]||""} onChange={e=>setCodeInput(c=>({...c,[o.id]:e.target.value.replace(/\D/g,"").slice(0,4)}))} placeholder="0000" maxLength={4} style={{flex:1,padding:"12px",fontSize:22,fontWeight:700,textAlign:"center",letterSpacing:7,border:"2px solid #f59e0b",borderRadius:8}}/>
            <button onClick={()=>verifyCode(o)} style={{padding:"12px 15px",background:"#059669",color:"#fff",border:"none",borderRadius:8,cursor:"pointer",fontWeight:700,fontSize:13}}>{String.fromCharCode(0x2713)} Done</button>
          </div>
        </div>}
        
        {needsCash&&<div style={{padding:"11px",background:"#fef3c7",borderRadius:9,border:"2px solid #f59e0b"}}>
          <p style={{fontSize:13,fontWeight:700,color:"#92400e",marginBottom:7,textAlign:"center"}}>{String.fromCharCode(0xD83D,0xDCB5)} COLLECT {fmt(o.total)} CASH</p>
          <button onClick={()=>collectCash(o)} style={{width:"100%",padding:"12px",background:"#059669",color:"#fff",border:"none",borderRadius:8,cursor:"pointer",fontWeight:700,fontSize:13}}>{String.fromCharCode(0x2713)} Confirm Cash Collected</button>
        </div>}
      </>}
      
      {/* COMPLETED - just show status */}
      {section==="completed"&&<p style={{fontSize:11,color:"#059669",fontWeight:700,textAlign:"center"}}>{String.fromCharCode(0x2705)} Delivered {o.delivered_at?new Date(o.delivered_at).toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"}):""}</p>}
    </div>;
  };
  
  return <div style={{minHeight:"100vh",background:"#f7f3ee",fontFamily:"-apple-system,sans-serif"}}>
    {/* Header */}
    <div style={{background:"linear-gradient(135deg,#0c4a6e,#0e7490)",color:"#fff",padding:"11px 18px",position:"sticky",top:0,zIndex:100,boxShadow:"0 2px 8px rgba(0,0,0,.15)"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:9}}>
        <div style={{display:"flex",alignItems:"center",gap:9}}>
          <div style={{width:36,height:36,borderRadius:"50%",background:"rgba(255,255,255,.25)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,fontWeight:700}}>{(driver.full_name||"D").charAt(0).toUpperCase()}</div>
          <div>
            <p style={{fontSize:13,fontWeight:700}}>{driver.full_name}</p>
            <p style={{fontSize:10,opacity:.85}}>{String.fromCharCode(0xD83D,0xDEF5)} {driver.restaurants?.name||"Restaurant"}</p>
          </div>
        </div>
        <div style={{display:"flex",gap:5}}>
          <button onClick={()=>setSoundOn(s=>!s)} title="Toggle sound" style={{padding:"7px 10px",background:soundOn?"rgba(255,255,255,.25)":"rgba(0,0,0,.2)",color:"#fff",border:"none",borderRadius:7,cursor:"pointer",fontSize:14}}>{soundOn?String.fromCharCode(0xD83D,0xDD14):String.fromCharCode(0xD83D,0xDD15)}</button>
          <button onClick={onLogout} style={{padding:"7px 12px",background:"rgba(220,38,38,.3)",color:"#fee2e2",border:"1px solid rgba(220,38,38,.5)",borderRadius:7,cursor:"pointer",fontSize:11,fontWeight:700}}>Logout</button>
        </div>
      </div>
    </div>
    
    {/* Toasts */}
    <div style={{position:"fixed",top:70,right:14,zIndex:9999,display:"flex",flexDirection:"column",gap:7,maxWidth:280}}>
      {toasts.map(t=><div key={t.id} style={{padding:"11px 14px",background:t.color||"#1a1208",color:"#fff",borderRadius:9,fontSize:12,boxShadow:"0 4px 12px rgba(0,0,0,.25)"}}>
        <p style={{fontWeight:700}}>{t.title}</p>
        {t.body&&<p style={{fontSize:11,opacity:.9,marginTop:2}}>{t.body}</p>}
      </div>)}
    </div>
    
    <div style={{padding:"14px",maxWidth:600,margin:"0 auto"}}>
      {loading?<div style={{padding:40,textAlign:"center",color:"#8a8078"}}>Loading deliveries...</div>:<>
      
      {/* Stats Row */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:7,marginBottom:14}}>
        <div style={{padding:"9px",background:"linear-gradient(135deg,#cffafe,#a5f3fc)",borderRadius:9,textAlign:"center",border:"2px solid #0891b2"}}>
          <p style={{fontSize:20,fontWeight:700,color:"#0e7490"}}>{available.length}</p>
          <p style={{fontSize:9,color:"#0e7490",fontWeight:700}}>AVAILABLE</p>
        </div>
        <div style={{padding:"9px",background:"linear-gradient(135deg,#fed7aa,#fdba74)",borderRadius:9,textAlign:"center",border:"2px solid #ea580c"}}>
          <p style={{fontSize:20,fontWeight:700,color:"#c2410c"}}>{mine.length}</p>
          <p style={{fontSize:9,color:"#c2410c",fontWeight:700}}>MY DELIVERIES</p>
        </div>
        <div style={{padding:"9px",background:cashOwed>0?"linear-gradient(135deg,#fee2e2,#fecaca)":"linear-gradient(135deg,#d1fae5,#a7f3d0)",borderRadius:9,textAlign:"center",border:"2px solid "+(cashOwed>0?"#dc2626":"#10b981")}}>
          <p style={{fontSize:16,fontWeight:700,color:cashOwed>0?"#991b1b":"#065f46"}}>{fmt(cashOwed)}</p>
          <p style={{fontSize:9,color:cashOwed>0?"#991b1b":"#065f46",fontWeight:700}}>CASH IN HAND</p>
        </div>
      </div>
      
      {/* AVAILABLE ORDERS */}
      <div style={{marginBottom:18}}>
        <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:9}}>
          <h3 style={{fontSize:15,fontWeight:700}}>{String.fromCharCode(0xD83D,0xDD14)} Available Orders</h3>
          {available.length>0&&<span style={{padding:"2px 9px",background:"#0891b2",color:"#fff",borderRadius:11,fontSize:11,fontWeight:700}}>{available.length}</span>}
        </div>
        {available.length===0?<div style={{padding:22,textAlign:"center",background:"#fff",borderRadius:11,color:"#8a8078",fontSize:12}}>No orders waiting. New orders will appear here when ready.</div>:
          available.map(o=>renderOrderCard(o,"available"))}
      </div>
      
      {/* MY DELIVERIES */}
      <div style={{marginBottom:18}}>
        <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:9}}>
          <h3 style={{fontSize:15,fontWeight:700}}>{String.fromCharCode(0xD83D,0xDEF5)} My Deliveries</h3>
          {mine.length>0&&<span style={{padding:"2px 9px",background:"#ea580c",color:"#fff",borderRadius:11,fontSize:11,fontWeight:700}}>{mine.length}</span>}
        </div>
        {mine.length===0?<div style={{padding:22,textAlign:"center",background:"#fff",borderRadius:11,color:"#8a8078",fontSize:12}}>Claim an order above to start delivering</div>:
          mine.map(o=>renderOrderCard(o,"mine"))}
      </div>
      
      {/* COMPLETED TODAY */}
      <div style={{marginBottom:18}}>
        <button onClick={()=>setShowCompleted(s=>!s)} style={{width:"100%",padding:"11px",background:"#fff",border:"1px solid #ede8de",borderRadius:9,fontSize:13,fontWeight:700,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span>{String.fromCharCode(0x2705)} Completed Today ({completed.length})</span>
          <span>{showCompleted?String.fromCharCode(0x25B2):String.fromCharCode(0x25BC)}</span>
        </button>
        {showCompleted&&<div style={{marginTop:9}}>
          {completed.length===0?<p style={{padding:14,textAlign:"center",color:"#8a8078",fontSize:12}}>No completed deliveries yet today</p>:
            completed.map(o=>renderOrderCard(o,"completed"))}
        </div>}
      </div>
      
      {/* CASH HANDOVER SECTION */}
      <div style={{marginBottom:18}}>
        <h3 style={{fontSize:15,fontWeight:700,marginBottom:9}}>{String.fromCharCode(0xD83D,0xDCB0)} Cash Handover</h3>
        
        {pendingHandover?
          /* PENDING - waiting for manager */
          <div style={{background:"#fff7ed",borderRadius:11,padding:16,border:"2px solid #f59e0b"}}>
            <div style={{textAlign:"center",marginBottom:11}}>
              <div style={{fontSize:36,marginBottom:5}}>{String.fromCharCode(0x23F3)}</div>
              <p style={{fontSize:14,fontWeight:700,color:"#92400e"}}>Handover Pending</p>
              <p style={{fontSize:24,fontWeight:700,color:"#92400e",margin:"6px 0"}}>{fmt(pendingHandover.driver_declared_amount)}</p>
              <p style={{fontSize:11,color:"#92400e"}}>{pendingHandover.order_count} orders {String.fromCharCode(0x2022)} Started {new Date(pendingHandover.initiated_at).toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"})}</p>
            </div>
            <div style={{background:"#fff",borderRadius:8,padding:"9px 12px",marginBottom:11}}>
              <p style={{fontSize:12,color:"#92400e",textAlign:"center"}}>{String.fromCharCode(0xD83D,0xDC4B)} Give the cash to your manager. They will count it and confirm.</p>
            </div>
            <button onClick={doCancelHandover} disabled={handoverBusy} style={{width:"100%",padding:"10px",background:"#fff",color:"#dc2626",border:"2px solid #fecaca",borderRadius:8,fontWeight:700,fontSize:12,cursor:"pointer"}}>Cancel This Handover</button>
          </div>
          :
          /* NO PENDING - show cash to hand over */
          (cashToHandover.total>0?
            <div style={{background:"linear-gradient(135deg,#ecfdf5,#d1fae5)",borderRadius:11,padding:16,border:"2px solid #10b981"}}>
              <div style={{textAlign:"center",marginBottom:11}}>
                <p style={{fontSize:11,color:"#065f46",fontWeight:700,letterSpacing:1}}>CASH TO HAND OVER</p>
                <p style={{fontSize:32,fontWeight:700,color:"#065f46",margin:"4px 0"}}>{fmt(cashToHandover.total)}</p>
                <p style={{fontSize:11,color:"#047857"}}>From {cashToHandover.orders.length} cash deliveries</p>
              </div>
              <button onClick={doInitiateHandover} disabled={handoverBusy} style={{width:"100%",padding:"14px",background:"linear-gradient(135deg,#059669,#047857)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:14,cursor:handoverBusy?"wait":"pointer"}}>{String.fromCharCode(0xD83D,0xDCE4)} Hand Over {fmt(cashToHandover.total)} to Manager</button>
            </div>
            :
            <div style={{background:"#fff",borderRadius:11,padding:22,textAlign:"center",border:"1px solid #ede8de"}}>
              <div style={{fontSize:30,marginBottom:6}}>{String.fromCharCode(0x2705)}</div>
              <p style={{fontSize:13,color:"#8a8078"}}>No cash to hand over right now</p>
              <p style={{fontSize:11,color:"#8a8078",marginTop:3}}>Cash from deliveries will appear here</p>
            </div>
          )
        }
        
        {/* Handover History */}
        <button onClick={()=>setShowHandoverHistory(s=>!s)} style={{width:"100%",marginTop:9,padding:"11px",background:"#fff",border:"1px solid #ede8de",borderRadius:9,fontSize:13,fontWeight:700,cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <span>{String.fromCharCode(0xD83D,0xDCCB)} Handover History ({handoverHistory.length})</span>
          <span>{showHandoverHistory?String.fromCharCode(0x25B2):String.fromCharCode(0x25BC)}</span>
        </button>
        {showHandoverHistory&&<div style={{marginTop:9,display:"flex",flexDirection:"column",gap:7}}>
          {handoverHistory.length===0?<p style={{padding:14,textAlign:"center",color:"#8a8078",fontSize:12}}>No handovers yet</p>:
            handoverHistory.map(h=>{
              var disc=parseFloat(h.discrepancy||0);
              return <div key={h.id} style={{background:"#fff",borderRadius:9,padding:"11px 13px",border:"1px solid #ede8de"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                  <span style={{fontSize:13,fontWeight:700}}>{fmt(h.manager_confirmed_amount||h.driver_declared_amount)}</span>
                  <span style={{padding:"2px 8px",borderRadius:10,fontSize:9,fontWeight:700,background:h.status==="confirmed"?"#d1fae5":h.status==="pending"?"#fef3c7":"#fee2e2",color:h.status==="confirmed"?"#065f46":h.status==="pending"?"#92400e":"#991b1b"}}>{h.status==="confirmed"?"CONFIRMED":h.status==="pending"?"PENDING":"CANCELLED"}</span>
                </div>
                <p style={{fontSize:10,color:"#8a8078"}}>{new Date(h.initiated_at).toLocaleString("en-GB",{day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"})} {String.fromCharCode(0x2022)} {h.order_count} orders</p>
                {h.status==="confirmed"&&h.manager_name&&<p style={{fontSize:10,color:"#059669",marginTop:2}}>{String.fromCharCode(0x2705)} Received by {h.manager_name}</p>}
                {h.status==="confirmed"&&disc!==0&&<p style={{fontSize:10,color:disc<0?"#dc2626":"#d97706",fontWeight:700,marginTop:2}}>{disc<0?"Short":"Over"} by {fmt(Math.abs(disc))} (you declared {fmt(h.driver_declared_amount)})</p>}
              </div>;
            })}
        </div>}
      </div>
      </>}
    </div>
  </div>;
}

function SalesRepLogin({onLogin}){
  var [email,setEmail]=useState("");
  var [password,setPassword]=useState("");
  var [loading,setLoading]=useState(false);
  var [error,setError]=useState("");
  
  var doLogin=async()=>{
    if(!email||!password){setError("Email and password required");return;}
    setLoading(true);
    setError("");
    var result=await dbLoginRep(email,password);
    setLoading(false);
    if(result.error){
      setError(result.error.message);
      return;
    }
    dbSaveRep(result.data);
    onLogin(result.data);
  };
  
  return <div style={{minHeight:"100vh",background:"linear-gradient(135deg,#0f0a05,#1a1208)",display:"flex",alignItems:"center",justifyContent:"center",padding:18,fontFamily:"-apple-system,sans-serif"}}>
    <div style={{maxWidth:420,width:"100%",background:"#1a1208",borderRadius:18,padding:32,border:"2px solid #5d3a1f"}}>
      <div style={{textAlign:"center",marginBottom:22}}>
        <div style={{fontSize:48,marginBottom:9}}>{String.fromCharCode(0xD83D,0xDCBC)}</div>
        <h2 style={{fontSize:24,fontWeight:700,color:"#fbbf24",fontFamily:"Georgia,serif",marginBottom:5}}>Sales Rep Portal</h2>
        <p style={{color:"#a8956a",fontSize:12}}>La Tavola Platform</p>
      </div>
      
      <p style={{fontSize:11,color:"#fbbf24",fontWeight:700,letterSpacing:1,marginBottom:5}}>EMAIL</p>
      <input value={email} onChange={e=>setEmail(e.target.value)} type="email" placeholder="rep@example.com" autoFocus style={{width:"100%",padding:"13px",background:"#0f0a05",color:"#fff",border:"2px solid #5d3a1f",borderRadius:7,fontSize:14,marginBottom:11,boxSizing:"border-box"}}/>
      
      <p style={{fontSize:11,color:"#fbbf24",fontWeight:700,letterSpacing:1,marginBottom:5}}>PASSWORD</p>
      <input value={password} onChange={e=>setPassword(e.target.value)} onKeyPress={e=>e.key==="Enter"&&doLogin()} type="password" placeholder="******" style={{width:"100%",padding:"13px",background:"#0f0a05",color:"#fff",border:"2px solid #5d3a1f",borderRadius:7,fontSize:14,marginBottom:14,boxSizing:"border-box"}}/>
      
      {error&&<div style={{background:"#7f1d1d",color:"#fecaca",padding:9,borderRadius:7,marginBottom:11,fontSize:12,textAlign:"center"}}>{error}</div>}
      
      <button onClick={doLogin} disabled={loading} style={{width:"100%",padding:"15px",background:loading?"#5d3a1f":"linear-gradient(135deg,#bf4626,#7c2d12)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:14,cursor:loading?"not-allowed":"pointer"}}>{loading?"Signing in...":"Sign In"}</button>
      
      <button onClick={()=>{window.location.href="/";}} style={{width:"100%",marginTop:11,padding:"11px",background:"transparent",color:"#a8956a",border:"none",cursor:"pointer",fontSize:11}}>{String.fromCharCode(0x2190)} Back to Main Site</button>
    </div>
  </div>;
}

// =================================================================
// SALES REP DASHBOARD - rep sees their subscriptions & earnings
// =================================================================
function SalesRepDashboard({rep,onLogout}){
  var [tab,setTab]=useState("overview");
  var [subscriptions,setSubscriptions]=useState([]);
  var [commissions,setCommissions]=useState([]);
  var [loading,setLoading]=useState(true);
  
  useEffect(()=>{
    if(!rep)return;
    Promise.all([
      dbFetchRepSubs(rep.id).then(d=>setSubscriptions(d||[])),
      dbFetchRepComm(rep.id).then(d=>setCommissions(d||[])),
    ]).then(()=>setLoading(false));
  },[rep]);
  
  var activeSubs=subscriptions.filter(s=>s.active);
  var totalEarned=commissions.filter(c=>c.status==="paid").reduce((s,c)=>s+parseFloat(c.amount||0),0);
  var pendingEarned=commissions.filter(c=>c.status==="pending").reduce((s,c)=>s+parseFloat(c.amount||0),0);
  var thisMonth=commissions.filter(c=>{
    var d=new Date(c.created_at);
    var now=new Date();
    return d.getMonth()===now.getMonth()&&d.getFullYear()===now.getFullYear();
  }).reduce((s,c)=>s+parseFloat(c.amount||0),0);
  
  return <div style={{minHeight:"100vh",background:"#f7f3ee",fontFamily:"-apple-system,sans-serif"}}>
    {/* Header */}
    <div style={{background:"linear-gradient(135deg,#1a1208,#3d2818)",color:"#fff",padding:"16px 22px",position:"sticky",top:0,zIndex:100,boxShadow:"0 2px 8px rgba(0,0,0,.15)"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:9}}>
        <div>
          <p style={{fontSize:10,color:"#d4952a",letterSpacing:2.5,fontWeight:700,textTransform:"uppercase"}}>{String.fromCharCode(0xD83D,0xDCBC)} Sales Rep Portal</p>
          <h1 style={{fontSize:22,fontWeight:700,fontFamily:"Georgia,serif"}}>Welcome, {rep.full_name}</h1>
          <p style={{fontSize:11,opacity:.75}}>{rep.email} {String.fromCharCode(0x2022)} Commission: {rep.commission_type==="percentage"?rep.commission_percent+"%":rep.commission_type==="fixed"?"\u00A3"+rep.fixed_per_signup+" per signup":rep.commission_type==="salary"?"\u00A3"+rep.base_salary+"/mo salary":"Hybrid"}</p>
        </div>
        <button onClick={onLogout} style={{padding:"7px 14px",background:"rgba(220,38,38,.2)",color:"#fecaca",border:"1px solid #dc2626",borderRadius:7,cursor:"pointer",fontSize:11,fontWeight:700}}>{String.fromCharCode(0x21AA,0xFE0F)} Logout</button>
      </div>
    </div>
    
    <div style={{padding:18,maxWidth:1100,margin:"0 auto"}}>
      {/* STATS CARDS */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:11,marginBottom:18}}>
        {[
          {label:"Active Subscriptions",value:activeSubs.length,color:"#0891b2",bg:"linear-gradient(135deg,#cffafe,#a5f3fc)",icon:String.fromCharCode(0xD83C,0xDFEA)},
          {label:"Total Earned",value:"\u00A3"+totalEarned.toFixed(2),color:"#059669",bg:"linear-gradient(135deg,#d1fae5,#a7f3d0)",icon:String.fromCharCode(0xD83D,0xDCB0)},
          {label:"Pending",value:"\u00A3"+pendingEarned.toFixed(2),color:"#d97706",bg:"linear-gradient(135deg,#fef3c7,#fde68a)",icon:String.fromCharCode(0x23F3)},
          {label:"This Month",value:"\u00A3"+thisMonth.toFixed(2),color:"#bf4626",bg:"linear-gradient(135deg,#fee2e2,#fecaca)",icon:String.fromCharCode(0xD83D,0xDCCA)},
        ].map(s=><div key={s.label} style={{background:s.bg,borderRadius:11,padding:"14px",border:"2px solid "+s.color+"40",position:"relative",overflow:"hidden"}}>
          <div style={{position:"absolute",top:11,right:13,fontSize:24,opacity:.4}}>{s.icon}</div>
          <p style={{fontSize:10,color:s.color,fontWeight:700,letterSpacing:1,textTransform:"uppercase",marginBottom:5}}>{s.label}</p>
          <p style={{fontSize:24,fontWeight:700,color:s.color}}>{s.value}</p>
        </div>)}
      </div>
      
      {/* TABS */}
      <div style={{background:"#fff",borderRadius:11,padding:7,marginBottom:14,boxShadow:"0 2px 8px rgba(0,0,0,.04)"}}>
        <div style={{display:"flex",gap:3}}>
          {[["overview","Overview",String.fromCharCode(0xD83D,0xDCCA)],["subscriptions","My Subscriptions",String.fromCharCode(0xD83C,0xDFEA)],["commissions","Commissions",String.fromCharCode(0xD83D,0xDCB0)]].map(([k,l,ic])=><button key={k} onClick={()=>setTab(k)} style={{padding:"9px 14px",borderRadius:8,fontWeight:600,fontSize:12,border:"none",background:tab===k?"linear-gradient(135deg,#1a1208,#3d2818)":"transparent",color:tab===k?"#fff":"#5d4e3e",cursor:"pointer",display:"flex",alignItems:"center",gap:5}}>
            <span style={{fontSize:13}}>{ic}</span>
            <span>{l}</span>
          </button>)}
        </div>
      </div>
      
      {/* TAB CONTENT */}
      {loading?<div style={{padding:40,textAlign:"center",color:"#8a8078"}}>Loading...</div>:<>
      
      {tab==="overview"&&<div>
        <div className="card" style={{padding:18,marginBottom:14}}>
          <p style={{fontSize:15,fontWeight:700,marginBottom:11}}>{String.fromCharCode(0xD83D,0xDCCB)} How You Get Paid</p>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))",gap:11,fontSize:13}}>
            <div style={{padding:11,background:"#f7f3ee",borderRadius:8}}>
              <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3}}>COMMISSION TYPE</p>
              <p style={{fontWeight:700,textTransform:"capitalize"}}>{rep.commission_type}</p>
            </div>
            {rep.commission_type==="percentage"&&<div style={{padding:11,background:"#f7f3ee",borderRadius:8}}>
              <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3}}>RATE</p>
              <p style={{fontWeight:700}}>{rep.commission_percent}%</p>
            </div>}
            {(rep.commission_type==="fixed"||rep.commission_type==="hybrid")&&<div style={{padding:11,background:"#f7f3ee",borderRadius:8}}>
              <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3}}>FIXED PER SIGNUP</p>
              <p style={{fontWeight:700}}>£{rep.fixed_per_signup}</p>
            </div>}
            {rep.base_salary>0&&<div style={{padding:11,background:"#f7f3ee",borderRadius:8}}>
              <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3}}>MONTHLY SALARY</p>
              <p style={{fontWeight:700}}>£{rep.base_salary}/mo</p>
            </div>}
            <div style={{padding:11,background:"#f7f3ee",borderRadius:8}}>
              <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:3}}>RECURRING</p>
              <p style={{fontWeight:700}}>{rep.recurring_commission?"\u2705 Yes (monthly)":"\u274C No (one-time)"}</p>
            </div>
          </div>
        </div>
        
        <div className="card" style={{padding:18}}>
          <p style={{fontSize:15,fontWeight:700,marginBottom:11}}>{String.fromCharCode(0xD83D,0xDCAB)} Recent Activity</p>
          {commissions.length===0?<p style={{color:"#8a8078",fontSize:13,padding:14,textAlign:"center"}}>No commissions yet. Start signing up restaurants!</p>:
          <div>{commissions.slice(0,5).map(c=><div key={c.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"11px 0",borderBottom:"1px solid #ede8de"}}>
            <div>
              <p style={{fontSize:13,fontWeight:700,textTransform:"capitalize"}}>{c.type} commission</p>
              <p style={{fontSize:11,color:"#8a8078"}}>{c.rep_subscriptions?.restaurants?.name||"Unknown"} {String.fromCharCode(0x2022)} {new Date(c.created_at).toLocaleDateString()}</p>
            </div>
            <div style={{textAlign:"right"}}>
              <p style={{fontWeight:700,color:"#059669"}}>£{parseFloat(c.amount).toFixed(2)}</p>
              <p style={{fontSize:10,color:c.status==="paid"?"#059669":"#d97706",textTransform:"uppercase",fontWeight:700}}>{c.status}</p>
            </div>
          </div>)}</div>}
        </div>
      </div>}
      
      {tab==="subscriptions"&&<div className="card" style={{padding:18}}>
        <p style={{fontSize:15,fontWeight:700,marginBottom:11}}>{String.fromCharCode(0xD83C,0xDFEA)} Restaurants You Signed Up ({subscriptions.length})</p>
        {subscriptions.length===0?<p style={{color:"#8a8078",fontSize:13,padding:14,textAlign:"center"}}>You haven't signed up any restaurants yet</p>:
        <div style={{display:"flex",flexDirection:"column",gap:9}}>{subscriptions.map(s=>{
          var r=s.restaurants;
          if(!r)return null;
          var isExpired=r.subscription_ends_at&&new Date(r.subscription_ends_at)<new Date();
          return <div key={s.id} style={{padding:13,background:"#fafaf5",borderRadius:9,border:"1px solid #ede8de"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:7}}>
              <div>
                <p style={{fontSize:14,fontWeight:700,marginBottom:3}}>{r.name}</p>
                <p style={{fontSize:11,color:"#8a8078"}}>Signed: {new Date(s.signed_at).toLocaleDateString()} {String.fromCharCode(0x2022)} Plan: {r.plan||"trial"}</p>
              </div>
              <div style={{textAlign:"right"}}>
                <span style={{padding:"3px 9px",background:r.active===false||isExpired?"#fee2e2":"#d1fae5",color:r.active===false||isExpired?"#dc2626":"#059669",borderRadius:11,fontSize:10,fontWeight:700,textTransform:"uppercase"}}>
                  {r.active===false?"Suspended":isExpired?"Expired":"Active"}
                </span>
                <p style={{fontSize:11,color:"#059669",fontWeight:700,marginTop:5}}>Earned: £{parseFloat(s.signup_commission||0).toFixed(2)}</p>
              </div>
            </div>
          </div>;
        })}</div>}
      </div>}
      
      {tab==="commissions"&&<div className="card" style={{padding:18}}>
        <p style={{fontSize:15,fontWeight:700,marginBottom:11}}>{String.fromCharCode(0xD83D,0xDCB0)} Commission History</p>
        {commissions.length===0?<p style={{color:"#8a8078",fontSize:13,padding:14,textAlign:"center"}}>No commissions yet</p>:
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead>
            <tr style={{borderBottom:"2px solid #ede8de"}}>
              <th style={{textAlign:"left",padding:"9px 7px",fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1}}>DATE</th>
              <th style={{textAlign:"left",padding:"9px 7px",fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1}}>RESTAURANT</th>
              <th style={{textAlign:"left",padding:"9px 7px",fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1}}>TYPE</th>
              <th style={{textAlign:"right",padding:"9px 7px",fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1}}>AMOUNT</th>
              <th style={{textAlign:"center",padding:"9px 7px",fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1}}>STATUS</th>
            </tr>
          </thead>
          <tbody>
            {commissions.map(c=><tr key={c.id} style={{borderBottom:"1px solid #ede8de"}}>
              <td style={{padding:"11px 7px",fontSize:12}}>{new Date(c.created_at).toLocaleDateString()}</td>
              <td style={{padding:"11px 7px",fontSize:12}}>{c.rep_subscriptions?.restaurants?.name||"-"}</td>
              <td style={{padding:"11px 7px",fontSize:12,textTransform:"capitalize"}}>{c.type}</td>
              <td style={{padding:"11px 7px",fontSize:12,fontWeight:700,textAlign:"right"}}>£{parseFloat(c.amount).toFixed(2)}</td>
              <td style={{padding:"11px 7px",fontSize:11,textAlign:"center"}}>
                <span style={{padding:"3px 9px",background:c.status==="paid"?"#d1fae5":"#fef3c7",color:c.status==="paid"?"#059669":"#d97706",borderRadius:9,fontWeight:700,textTransform:"uppercase",fontSize:10}}>{c.status}</span>
              </td>
            </tr>)}
          </tbody>
        </table>}
      </div>}
      </>}
    </div>
  </div>;
}

// =================================================================
// SUPER ADMIN: Marketing Payments Tab - Approve manual payments
// =================================================================
function MarketingPaymentsTab({loadData}){
  var [pending,setPending]=useState([]);
  var [history,setHistory]=useState([]);
  var [loading,setLoading]=useState(true);
  var [tab,setTab]=useState("pending");
  
  var reload=()=>{
    setLoading(true);
    Promise.all([
      dbFetchPendingPurchases(),
      dbFetchAllPurchases(50),
    ]).then(([pend,hist])=>{
      setPending(pend||[]);
      setHistory(hist||[]);
      setLoading(false);
    });
  };
  
  useEffect(()=>{reload();},[]);
  
  var approve=async(purchase)=>{
    if(!window.confirm("Approve this payment?\n\nRestaurant: "+(purchase.restaurants?.name||"Unknown")+"\nAmount: \u00A3"+purchase.price+"\nCredits: "+purchase.amount+" "+purchase.type+"\n\nMake sure you've received the bank transfer first!"))return;
    var result=await dbApproveManual(purchase.id);
    if(result.error){
      alert("Failed: "+(result.error.message||"Unknown error"));
      return;
    }
    alert("Payment approved! "+purchase.amount+" "+purchase.type+" credits added to "+(purchase.restaurants?.name||"restaurant"));
    reload();
    loadData&&loadData();
  };
  
  var reject=async(purchase)=>{
    if(!window.confirm("Reject this payment?\n\nThis will mark the request as failed. The restaurant can try again."))return;
    await dbRejectManual(purchase.id,'admin-rejected');
    alert("Payment rejected");
    reload();
  };
  
  if(loading)return <div style={{padding:30,textAlign:"center",color:"#a8956a"}}>Loading payments...</div>;
  
  var pendingTotal=pending.reduce((s,p)=>s+parseFloat(p.price||0),0);
  
  return <div>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:9}}>
      <div>
        <p style={{fontSize:11,color:"#a8956a",letterSpacing:2,fontWeight:700,marginBottom:3}}>MARKETING PAYMENTS</p>
        <p style={{fontSize:11,color:"#a8956a"}}>Approve manual bank transfers and view all purchases</p>
      </div>
      <button onClick={reload} style={{padding:"7px 14px",background:"transparent",color:"#fbbf24",border:"1px solid #5d3a1f",borderRadius:7,fontSize:11,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0xD83D,0xDD04)} Refresh</button>
    </div>
    
    {/* Stats */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:9,marginBottom:14}}>
      <div style={{background:"linear-gradient(135deg,#7c2d12,#9a3412)",borderRadius:11,padding:14,color:"#fff"}}>
        <p style={{fontSize:10,letterSpacing:2,opacity:.85,fontWeight:700}}>PENDING APPROVAL</p>
        <p style={{fontSize:24,fontWeight:700,marginTop:5}}>{pending.length}</p>
        <p style={{fontSize:11,opacity:.85}}>\u00A3{pendingTotal.toFixed(2)} total</p>
      </div>
      <div style={{background:"linear-gradient(135deg,#064e3b,#065f46)",borderRadius:11,padding:14,color:"#fff"}}>
        <p style={{fontSize:10,letterSpacing:2,opacity:.85,fontWeight:700}}>TOTAL PURCHASES</p>
        <p style={{fontSize:24,fontWeight:700,marginTop:5}}>{history.length}</p>
        <p style={{fontSize:11,opacity:.85}}>Recent 50 shown</p>
      </div>
      <div style={{background:"linear-gradient(135deg,#1e3a8a,#1e40af)",borderRadius:11,padding:14,color:"#fff"}}>
        <p style={{fontSize:10,letterSpacing:2,opacity:.85,fontWeight:700}}>TOTAL REVENUE</p>
        <p style={{fontSize:24,fontWeight:700,marginTop:5}}>{String.fromCharCode(0x00A3)}{history.filter(p=>p.payment_status==="completed").reduce((s,p)=>s+parseFloat(p.price||0),0).toFixed(2)}</p>
        <p style={{fontSize:11,opacity:.85}}>From completed</p>
      </div>
    </div>
    
    {/* Tab selector */}
    <div style={{display:"flex",gap:5,marginBottom:14}}>
      <button onClick={()=>setTab("pending")} style={{padding:"9px 14px",background:tab==="pending"?"#3d2818":"transparent",color:tab==="pending"?"#fbbf24":"#a8956a",border:"1px solid #5d3a1f",borderRadius:7,fontSize:12,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0x23F3)} Pending ({pending.length})</button>
      <button onClick={()=>setTab("history")} style={{padding:"9px 14px",background:tab==="history"?"#3d2818":"transparent",color:tab==="history"?"#fbbf24":"#a8956a",border:"1px solid #5d3a1f",borderRadius:7,fontSize:12,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0xD83D,0xDCDC)} History</button>
    </div>
    
    {/* PENDING APPROVALS */}
    {tab==="pending"&&<>
      {pending.length===0?<div style={{background:"#1a1208",borderRadius:11,padding:22,textAlign:"center",border:"1px solid #3d2e22"}}>
        <p style={{color:"#a8956a",fontSize:13,marginBottom:5}}>{String.fromCharCode(0x2705)} No pending payments!</p>
        <p style={{color:"#a8956a",fontSize:11}}>All credit purchase requests have been processed.</p>
      </div>:<div style={{display:"grid",gap:9}}>
        {pending.map(p=><div key={p.id} style={{background:"#1a1208",borderRadius:11,padding:14,border:"2px solid #d97706"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:14,flexWrap:"wrap"}}>
            <div style={{flex:1,minWidth:220}}>
              <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:5}}>
                <span style={{fontSize:18}}>{p.type==="sms"?String.fromCharCode(0xD83D,0xDCF1):String.fromCharCode(0xD83D,0xDCE7)}</span>
                <p style={{fontSize:15,fontWeight:700,color:"#fbbf24"}}>{p.restaurants?.name||"Unknown Restaurant"}</p>
                <span style={{padding:"2px 7px",background:"rgba(217,119,6,.3)",color:"#fbbf24",borderRadius:9,fontSize:9,fontWeight:700,textTransform:"uppercase"}}>{p.payment_method||"manual"}</span>
              </div>
              <p style={{fontSize:13,color:"#fff",marginBottom:3}}>{p.amount.toLocaleString()} {p.type==="sms"?"SMS":"Email"} credits ({p.package_name||"Standard"})</p>
              <p style={{fontSize:11,color:"#a8956a"}}>
                Reference: <strong style={{color:"#fff"}}>{p.payment_reference||"None provided"}</strong>
              </p>
              <p style={{fontSize:10,color:"#6b5d3f",marginTop:5}}>Requested: {new Date(p.created_at).toLocaleString()}</p>
            </div>
            <div style={{textAlign:"right"}}>
              <p style={{fontSize:24,fontWeight:700,color:"#fbbf24",marginBottom:9}}>\u00A3{parseFloat(p.price).toFixed(2)}</p>
              <div style={{display:"flex",gap:5}}>
                <button onClick={()=>reject(p)} style={{padding:"7px 13px",background:"#7f1d1d",color:"#fecaca",border:"1px solid #dc2626",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0x274C)} Reject</button>
                <button onClick={()=>approve(p)} style={{padding:"7px 13px",background:"#22c55e",color:"#fff",border:"none",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0x2705)} Approve</button>
              </div>
            </div>
          </div>
        </div>)}
      </div>}
      
      <div style={{marginTop:14,padding:11,background:"rgba(217,119,6,.1)",borderRadius:7,fontSize:11,color:"#fbbf24"}}>
        <strong>{String.fromCharCode(0xD83D,0xDCA1)} How to verify payment:</strong>
        <ol style={{paddingLeft:18,marginTop:5}}>
          <li>Check your bank account for the transfer with the reference</li>
          <li>Verify the amount matches</li>
          <li>If everything looks good, click "Approve" - credits will be added automatically</li>
          <li>If something is wrong, click "Reject" - restaurant can retry</li>
        </ol>
      </div>
    </>}
    
    {/* HISTORY */}
    {tab==="history"&&<>
      {history.length===0?<p style={{color:"#a8956a",fontSize:13,textAlign:"center",padding:18}}>No purchase history yet</p>:
      <div style={{background:"#1a1208",borderRadius:11,overflow:"hidden",border:"1px solid #3d2e22"}}>
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead>
            <tr style={{background:"#0f0a05"}}>
              <th style={{padding:"11px 9px",textAlign:"left",fontSize:10,color:"#a8956a",letterSpacing:1,fontWeight:700}}>DATE</th>
              <th style={{padding:"11px 9px",textAlign:"left",fontSize:10,color:"#a8956a",letterSpacing:1,fontWeight:700}}>RESTAURANT</th>
              <th style={{padding:"11px 9px",textAlign:"left",fontSize:10,color:"#a8956a",letterSpacing:1,fontWeight:700}}>TYPE</th>
              <th style={{padding:"11px 9px",textAlign:"right",fontSize:10,color:"#a8956a",letterSpacing:1,fontWeight:700}}>AMOUNT</th>
              <th style={{padding:"11px 9px",textAlign:"right",fontSize:10,color:"#a8956a",letterSpacing:1,fontWeight:700}}>PRICE</th>
              <th style={{padding:"11px 9px",textAlign:"center",fontSize:10,color:"#a8956a",letterSpacing:1,fontWeight:700}}>METHOD</th>
              <th style={{padding:"11px 9px",textAlign:"center",fontSize:10,color:"#a8956a",letterSpacing:1,fontWeight:700}}>STATUS</th>
            </tr>
          </thead>
          <tbody>
            {history.map(p=><tr key={p.id} style={{borderTop:"1px solid #3d2e22"}}>
              <td style={{padding:"9px",fontSize:11,color:"#a8956a"}}>{new Date(p.created_at).toLocaleDateString()}</td>
              <td style={{padding:"9px",fontSize:12,color:"#fff",fontWeight:700}}>{p.restaurants?.name||"-"}</td>
              <td style={{padding:"9px",fontSize:12,color:"#fff"}}>{p.type==="sms"?"SMS":"Email"}</td>
              <td style={{padding:"9px",fontSize:12,color:"#fff",textAlign:"right"}}>{p.amount.toLocaleString()}</td>
              <td style={{padding:"9px",fontSize:12,color:"#fbbf24",textAlign:"right",fontWeight:700}}>\u00A3{parseFloat(p.price).toFixed(2)}</td>
              <td style={{padding:"9px",fontSize:11,color:"#a8956a",textAlign:"center",textTransform:"uppercase"}}>{p.payment_method||"-"}</td>
              <td style={{padding:"9px",textAlign:"center"}}>
                <span style={{padding:"2px 9px",background:p.payment_status==="completed"?"rgba(34,197,94,.2)":p.payment_status==="pending"?"rgba(217,119,6,.2)":"rgba(220,38,38,.2)",color:p.payment_status==="completed"?"#22c55e":p.payment_status==="pending"?"#fbbf24":"#fecaca",borderRadius:9,fontSize:9,fontWeight:700,textTransform:"uppercase"}}>{p.payment_status}</span>
              </td>
            </tr>)}
          </tbody>
        </table>
      </div>}
    </>}
  </div>;
}

// SUPER ADMIN: Commissions tab - restaurants on commission plan
// Monthly commission invoice for a restaurant
function CommissionInvoiceModal({restaurant,onClose}){
  // Month selection - default to last month
  var now=new Date();
  var [monthOffset,setMonthOffset]=useState(0); // 0 = this month, -1 = last month
  
  var targetDate=new Date(now.getFullYear(),now.getMonth()+monthOffset,1);
  var monthName=targetDate.toLocaleDateString("en-GB",{month:"long",year:"numeric"});
  
  // Filter this restaurant's commission entries for the selected month
  var entries=(restaurant.entries||[]).filter(function(e){
    var d=new Date(e.created_at);
    return d.getMonth()===targetDate.getMonth()&&d.getFullYear()===targetDate.getFullYear();
  });
  var monthTotal=entries.reduce(function(s,e){return s+parseFloat(e.commission_amount||0);},0);
  var orderTotalSum=entries.reduce(function(s,e){return s+parseFloat(e.order_total||0);},0);
  var rate=entries.length>0?entries[0].commission_rate:0;
  
  // Invoice number: INV-{restaurantshort}-{YYYYMM}
  var invNum="INV-"+(restaurant.restaurant_name||"R").slice(0,3).toUpperCase()+"-"+targetDate.getFullYear()+String(targetDate.getMonth()+1).padStart(2,"0");
  
  var printInvoice=function(){
    window.print();
  };
  
  return <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.7)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:9999,padding:14}}>
    <div onClick={function(e){e.stopPropagation();}} style={{background:"#fff",borderRadius:14,maxWidth:560,width:"100%",maxHeight:"90vh",overflowY:"auto"}}>
      {/* Controls (hidden when printing) */}
      <div className="no-print" style={{padding:"12px 16px",borderBottom:"1px solid #ede8de",display:"flex",justifyContent:"space-between",alignItems:"center",gap:8,flexWrap:"wrap"}}>
        <div style={{display:"flex",gap:6,alignItems:"center"}}>
          <button onClick={function(){setMonthOffset(monthOffset-1);}} style={{padding:"6px 11px",borderRadius:6,border:"1px solid #ddd",background:"#fff",cursor:"pointer",fontWeight:700}}>{String.fromCharCode(0x2190)}</button>
          <span style={{fontSize:13,fontWeight:700,minWidth:120,textAlign:"center"}}>{monthName}</span>
          <button onClick={function(){if(monthOffset<0)setMonthOffset(monthOffset+1);}} disabled={monthOffset>=0} style={{padding:"6px 11px",borderRadius:6,border:"1px solid #ddd",background:monthOffset>=0?"#f5f5f5":"#fff",cursor:monthOffset>=0?"not-allowed":"pointer",fontWeight:700}}>{String.fromCharCode(0x2192)}</button>
        </div>
        <div style={{display:"flex",gap:6}}>
          <button onClick={printInvoice} style={{padding:"7px 14px",background:"#1a1208",color:"#fff",border:"none",borderRadius:7,fontWeight:700,fontSize:12,cursor:"pointer"}}>{String.fromCharCode(0xD83D,0xDDA8,0xFE0F)} Print / Save PDF</button>
          <button onClick={onClose} style={{padding:"7px 12px",background:"#fee2e2",color:"#dc2626",border:"none",borderRadius:7,fontWeight:700,fontSize:12,cursor:"pointer"}}>Close</button>
        </div>
      </div>
      
      {/* THE INVOICE */}
      <div style={{padding:28,color:"#1a1208"}}>
        {/* Header */}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:24,flexWrap:"wrap",gap:12}}>
          <div>
            <p style={{fontSize:24,fontWeight:700,fontFamily:"Georgia,serif"}}>{String.fromCharCode(0xD83C,0xDF7D,0xFE0F)} La Tavola</p>
            <p style={{fontSize:11,color:"#8a8078"}}>Restaurant Management Platform</p>
            <p style={{fontSize:10,color:"#8a8078",marginTop:6}}>Arifuzzaman Chowdhury<br/>T/A La Tavola</p>
          </div>
          <div style={{textAlign:"right"}}>
            <p style={{fontSize:20,fontWeight:700}}>INVOICE</p>
            <p style={{fontSize:11,color:"#8a8078"}}>{invNum}</p>
            <p style={{fontSize:11,color:"#8a8078",marginTop:4}}>Issued: {now.toLocaleDateString("en-GB")}</p>
          </div>
        </div>
        
        {/* Bill to */}
        <div style={{background:"#f7f3ee",borderRadius:9,padding:13,marginBottom:18}}>
          <p style={{fontSize:10,color:"#8a8078",fontWeight:700,letterSpacing:1}}>BILL TO</p>
          <p style={{fontSize:15,fontWeight:700,marginTop:3}}>{restaurant.restaurant_name}</p>
          <p style={{fontSize:11,color:"#8a8078"}}>Commission period: {monthName}</p>
        </div>
        
        {/* Line items */}
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:12,marginBottom:16}}>
          <thead>
            <tr style={{borderBottom:"2px solid #1a1208"}}>
              <th style={{textAlign:"left",padding:"7px 4px"}}>Description</th>
              <th style={{textAlign:"right",padding:"7px 4px"}}>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{borderBottom:"1px solid #ede8de"}}>
              <td style={{padding:"9px 4px"}}>
                Online order commission - {monthName}<br/>
                <span style={{fontSize:10,color:"#8a8078"}}>{entries.length} online orders {String.fromCharCode(0x2022)} {fmt(orderTotalSum)} total order value {String.fromCharCode(0x2022)} {rate}% commission</span>
              </td>
              <td style={{textAlign:"right",padding:"9px 4px",fontWeight:700}}>{fmt(monthTotal)}</td>
            </tr>
          </tbody>
        </table>
        
        {/* Total */}
        <div style={{display:"flex",justifyContent:"flex-end",marginBottom:20}}>
          <div style={{minWidth:200}}>
            <div style={{display:"flex",justifyContent:"space-between",padding:"5px 0",fontSize:12}}>
              <span style={{color:"#8a8078"}}>Subtotal</span>
              <span>{fmt(monthTotal)}</span>
            </div>
            <div style={{display:"flex",justifyContent:"space-between",padding:"9px 0",borderTop:"2px solid #1a1208",fontSize:15,fontWeight:700}}>
              <span>Total Due</span>
              <span>{fmt(monthTotal)}</span>
            </div>
          </div>
        </div>
        
        {entries.length===0&&<p style={{fontSize:12,color:"#8a8078",textAlign:"center",padding:14,background:"#fffbeb",borderRadius:8}}>No commission charges for {monthName}.</p>}
        
        {/* Payment terms */}
        <div style={{borderTop:"1px solid #ede8de",paddingTop:14,fontSize:10,color:"#8a8078"}}>
          <p style={{fontWeight:700,marginBottom:3}}>Payment Terms</p>
          <p>Payment due within 14 days of invoice date. Commission is charged on online orders (delivery & collection) placed through the La Tavola platform.</p>
          <p style={{marginTop:8}}>Thank you for using La Tavola.</p>
        </div>
      </div>
    </div>
  </div>;
}

function CommissionsTab(){
  var [data,setData]=useState([]);
  var [loading,setLoading]=useState(true);
  var [invoiceFor,setInvoiceFor]=useState(null); // restaurant to show invoice for
  
  var load=function(){
    setLoading(true);
    dbGetAllCommissions().then(function(d){
      setData(d||[]);
      setLoading(false);
    }).catch(function(e){console.error(e);setLoading(false);});
  };
  useEffect(function(){load();},[]);
  
  var markPaid=async function(rest){
    var ok=await window.showConfirm("Mark Commission Paid","Confirm that "+rest.restaurant_name+" has paid "+fmt(rest.unpaid)+" in commission?","Yes, Mark Paid","Cancel","success");
    if(!ok)return;
    var result=await dbMarkRestCommPaid(rest.restaurant_id);
    if(result.error){
      if(window.showAlert)window.showAlert("Could Not Mark Paid",(result.error.message||"Something went wrong. If this keeps happening, run the commission permissions SQL."),"error");
      return;
    }
    if(window.showAlert)window.showAlert("Done",fmt(rest.unpaid)+" marked as paid ("+(result.count||0)+" charges settled).","success");
    load();
  };
  
  var totalUnpaid=data.reduce(function(s,r){return s+r.unpaid;},0);
  var totalPaid=data.reduce(function(s,r){return s+r.paid;},0);
  
  if(loading)return <p style={{color:"#a8956a",textAlign:"center",padding:30}}>Loading commissions...</p>;
  
  return <div>
    {/* Summary */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:11,marginBottom:18}}>
      <div style={{background:"#3d2e22",borderRadius:11,padding:15}}>
        <p style={{fontSize:24,fontWeight:700,color:"#fbbf24"}}>{fmt(totalUnpaid)}</p>
        <p style={{fontSize:11,color:"#a8956a",marginTop:3}}>Commission owed to you</p>
      </div>
      <div style={{background:"#3d2e22",borderRadius:11,padding:15}}>
        <p style={{fontSize:24,fontWeight:700,color:"#10b981"}}>{fmt(totalPaid)}</p>
        <p style={{fontSize:11,color:"#a8956a",marginTop:3}}>Commission collected</p>
      </div>
      <div style={{background:"#3d2e22",borderRadius:11,padding:15}}>
        <p style={{fontSize:24,fontWeight:700,color:"#fff"}}>{data.length}</p>
        <p style={{fontSize:11,color:"#a8956a",marginTop:3}}>Restaurants on commission</p>
      </div>
    </div>
    
    {data.length===0?
      <div style={{background:"#3d2e22",borderRadius:11,padding:30,textAlign:"center"}}>
        <p style={{fontSize:36,marginBottom:8}}>{String.fromCharCode(0xD83D,0xDCB0)}</p>
        <p style={{color:"#fff",fontWeight:700,marginBottom:3}}>No commission charges yet</p>
        <p style={{color:"#a8956a",fontSize:12}}>When restaurants on the commission plan get online orders, charges appear here.</p>
      </div>
      :
      <div style={{display:"grid",gap:10}}>
        {data.map(function(rest){
          return <div key={rest.restaurant_id} style={{background:"#3d2e22",borderRadius:11,padding:15}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:10}}>
              <div>
                <p style={{fontSize:15,fontWeight:700,color:"#fff"}}>{rest.restaurant_name}</p>
                <p style={{fontSize:11,color:"#a8956a",marginTop:3}}>{rest.orderCount} commission charge{rest.orderCount!==1?"s":""} {String.fromCharCode(0x2022)} {fmt(rest.paid)} paid to date</p>
              </div>
              <div style={{textAlign:"right"}}>
                <p style={{fontSize:22,fontWeight:700,color:rest.unpaid>0?"#fbbf24":"#10b981"}}>{fmt(rest.unpaid)}</p>
                <p style={{fontSize:10,color:"#a8956a"}}>owed</p>
              </div>
            </div>
            <div style={{display:"flex",gap:7,marginTop:11,flexWrap:"wrap"}}>
              <button onClick={function(){setInvoiceFor(rest);}} style={{flex:1,minWidth:120,padding:"10px",background:"#3d2e22",color:"#fbbf24",border:"1px solid #fbbf24",borderRadius:8,fontWeight:700,fontSize:13,cursor:"pointer"}}>{String.fromCharCode(0xD83D,0xDCC4)} View Invoice</button>
              {rest.unpaid>0&&<button onClick={function(){markPaid(rest);}} style={{flex:1,minWidth:120,padding:"10px",background:"linear-gradient(135deg,#10b981,#059669)",color:"#fff",border:"none",borderRadius:8,fontWeight:700,fontSize:13,cursor:"pointer"}}>{String.fromCharCode(0x2705)} Mark {fmt(rest.unpaid)} Paid</button>}
            </div>
          </div>;
        })}
      </div>
    }
    
    {invoiceFor&&<CommissionInvoiceModal restaurant={invoiceFor} onClose={function(){setInvoiceFor(null);}}/>}
  </div>;
}

function SuperAdminPanel({onExit,saasOwner}){
  var [restaurants,setRestaurants]=useState([]);
  var [stats,setStats]=useState({});
  var [activity,setActivity]=useState([]);
  var [loading,setLoading]=useState(true);
  var [search,setSearch]=useState("");
  var [activeTab,setActiveTab]=useState("overview");
  // CRUD states
  var [showCreateModal,setShowCreateModal]=useState(false);
  var [showEditModal,setShowEditModal]=useState(null);
  var [showDeleteModal,setShowDeleteModal]=useState(null);
  var [createResult,setCreateResult]=useState(null);
  // SALES REP states
  var [reps,setReps]=useState([]);
  var [showRepForm,setShowRepForm]=useState(false);
  var [editingRep,setEditingRep]=useState(null);
  var [allCommissions,setAllCommissions]=useState([]);
  
  var loadData=()=>{
    setLoading(true);
    Promise.all([
      dbFetchAllRestStats(),
      dbFetchPlatStats(),
      dbFetchPlatActivity(20),
      dbFetchAllReps(),
      dbFetchAllComm(),
    ]).then(([rests,plat,act,repsList,commList])=>{
      setRestaurants(rests||[]);
      setStats(plat||{});
      setActivity(act||[]);
      setReps(repsList||[]);
      setAllCommissions(commList||[]);
      setLoading(false);
    });
  };
  
  useEffect(()=>{loadData();},[]);
  
  var doImpersonate=async(r)=>{
    if(!window.confirm("Login as "+r.name+"?\n\nYou'll see what they see. Click 'Exit Impersonation' (top banner) to come back.")) return;
    var result=await dbImpersonate(r.id,saasOwner.email);
    if(result){
      alert("Now logged in as "+r.name+". Page will reload.");
      window.location.href="/?r="+r.slug;
    }
  };
  
  var doChangePlan=async(r)=>{
    var newPlan=window.prompt("Change plan for "+r.name+":\n\nOptions: trial, starter, pro, enterprise","pro");
    if(!newPlan)return;
    if(!["trial","starter","pro","enterprise"].includes(newPlan)){
      alert("Invalid plan");return;
    }
    var {data,error}=await dbUpdatePlan(r.id,newPlan,saasOwner.email);
    if(error){alert("Failed: "+error.message);return;}
    if(data){alert("Plan changed to "+newPlan);loadData();}
  };
  
  var doToggleActive=async(r)=>{
    var willActivate=r.active===false;
    if(!window.confirm((willActivate?"ACTIVATE":"SUSPEND")+" "+r.name+"?\n\n"+(willActivate?"Restaurant will work normally.":"Restaurant won't be accessible to customers."))) return;
    var {data,error}=await dbToggleActive(r.id,willActivate,saasOwner.email);
    if(error){alert("Failed: "+error.message);return;}
    if(data){alert(willActivate?"Activated":"Suspended");loadData();}
  };
  
  var filtered=restaurants.filter(r=>{
    if(!search.trim())return true;
    var s=search.toLowerCase();
    return r.name?.toLowerCase().includes(s)||r.slug?.toLowerCase().includes(s)||r.stats?.owner_email?.toLowerCase().includes(s);
  });
  
  var planColor=p=>({trial:"#d97706",starter:"#2563eb",pro:"#059669",enterprise:"#7c3aed"})[p]||"#6b7280";
  var planBg=p=>({trial:"#fef3c7",starter:"#dbeafe",pro:"#d1fae5",enterprise:"#ede9fe"})[p]||"#f3f4f6";
  
  var trialColor=s=>({expired:"#dc2626",urgent:"#dc2626",warning:"#d97706",ok:"#059669"})[s]||"#6b7280";
  var trialBg=s=>({expired:"#fee2e2",urgent:"#fee2e2",warning:"#fef3c7",ok:"#d1fae5"})[s]||"#f3f4f6";
  
  return <div style={{minHeight:"100vh",background:"#0f0a05",color:"#fff",fontFamily:"-apple-system,sans-serif"}}>
    {/* Header */}
    <div style={{background:"linear-gradient(135deg,#1a1208,#3d2e22)",padding:"15px 22px",borderBottom:"2px solid #5d3a1f",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:11}}>
      <div>
        <p style={{fontSize:11,color:"#fbbf24",letterSpacing:3,fontWeight:700,marginBottom:3}}>{String.fromCharCode(0xD83D,0xDC51)} SUPER ADMIN PANEL</p>
        <h1 style={{fontSize:22,fontWeight:700,fontFamily:"Georgia,serif"}}>La Tavola Platform Control</h1>
      </div>
      <div style={{display:"flex",gap:9,alignItems:"center"}}>
        <span style={{fontSize:11,color:"#fbbf24",opacity:.8}}>Logged in as: {saasOwner?.email}</span>
        <button onClick={loadData} style={{padding:"7px 13px",background:"rgba(255,255,255,.1)",color:"#fff",border:"1px solid rgba(255,255,255,.2)",borderRadius:7,fontSize:11,cursor:"pointer",fontWeight:700}}>{String.fromCharCode(0xD83D,0xDD04)} Refresh</button>
        <button onClick={onExit} style={{padding:"7px 13px",background:"#dc2626",color:"#fff",border:"none",borderRadius:7,fontSize:11,cursor:"pointer",fontWeight:700}}>Exit Admin</button>
      </div>
    </div>
    
    {/* Stats Cards */}
    <div style={{padding:"22px 22px 0 22px",display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(150px,1fr))",gap:11,maxWidth:1400,margin:"0 auto"}}>
      <div style={{background:"#1a1208",border:"1px solid #5d3a1f",borderRadius:11,padding:14}}>
        <p style={{fontSize:11,color:"#a8956a",letterSpacing:2,fontWeight:700,marginBottom:5}}>RESTAURANTS</p>
        <p style={{fontSize:30,fontWeight:700,color:"#fff",lineHeight:1}}>{stats.total||0}</p>
        <p style={{fontSize:10,color:"#6b5d3f",marginTop:5}}>{stats.signups_last_30d||0} new this month</p>
      </div>
      <div style={{background:"#1a1208",border:"1px solid #5d3a1f",borderRadius:11,padding:14}}>
        <p style={{fontSize:11,color:"#a8956a",letterSpacing:2,fontWeight:700,marginBottom:5}}>ACTIVE</p>
        <p style={{fontSize:30,fontWeight:700,color:"#22c55e",lineHeight:1}}>{stats.active||0}</p>
        <p style={{fontSize:10,color:"#6b5d3f",marginTop:5}}>of {stats.total||0} total</p>
      </div>
      <div style={{background:"#1a1208",border:"1px solid #5d3a1f",borderRadius:11,padding:14}}>
        <p style={{fontSize:11,color:"#a8956a",letterSpacing:2,fontWeight:700,marginBottom:5}}>PAID</p>
        <p style={{fontSize:30,fontWeight:700,color:"#fbbf24",lineHeight:1}}>{stats.paid||0}</p>
        <p style={{fontSize:10,color:"#6b5d3f",marginTop:5}}>{stats.trial||0} on trial</p>
      </div>
      <div style={{background:"#1a1208",border:"1px solid #5d3a1f",borderRadius:11,padding:14}}>
        <p style={{fontSize:11,color:"#a8956a",letterSpacing:2,fontWeight:700,marginBottom:5}}>MRR</p>
        <p style={{fontSize:30,fontWeight:700,color:"#22c55e",lineHeight:1}}>{"\u00A3"}{stats.mrr||0}</p>
        <p style={{fontSize:10,color:"#6b5d3f",marginTop:5}}>recurring revenue</p>
      </div>
      <div style={{background:"#1a1208",border:"1px solid "+(stats.trials_expiring_soon>0?"#dc2626":"#5d3a1f"),borderRadius:11,padding:14}}>
        <p style={{fontSize:11,color:"#a8956a",letterSpacing:2,fontWeight:700,marginBottom:5}}>EXPIRING SOON</p>
        <p style={{fontSize:30,fontWeight:700,color:stats.trials_expiring_soon>0?"#dc2626":"#fff",lineHeight:1}}>{stats.trials_expiring_soon||0}</p>
        <p style={{fontSize:10,color:"#6b5d3f",marginTop:5}}>trials in 3 days</p>
      </div>
    </div>
    
    {/* Tabs */}
    <div style={{padding:"22px 22px 0 22px",maxWidth:1400,margin:"0 auto",display:"flex",gap:6,borderBottom:"1px solid #3d2e22",flexWrap:"wrap"}}>
      {[{id:"overview",label:String.fromCharCode(0xD83C,0xDFEA)+" Restaurants"},{id:"reps",label:String.fromCharCode(0xD83D,0xDCBC)+" Sales Reps"},{id:"commissions",label:String.fromCharCode(0xD83D,0xDCB0)+" Commissions"},{id:"marketing",label:String.fromCharCode(0xD83D,0xDCE3)+" Marketing Payments"},{id:"activity",label:String.fromCharCode(0xD83D,0xDCDC)+" Activity Log"}].map(t=>
        <button key={t.id} onClick={()=>setActiveTab(t.id)} style={{padding:"11px 18px",background:activeTab===t.id?"#3d2e22":"transparent",color:activeTab===t.id?"#fbbf24":"#a8956a",border:"none",borderBottom:"3px solid "+(activeTab===t.id?"#fbbf24":"transparent"),fontSize:13,fontWeight:700,cursor:"pointer"}}>{t.label}</button>
      )}
    </div>
    
    {/* Content */}
    <div style={{padding:22,maxWidth:1400,margin:"0 auto"}}>
      
      {activeTab==="overview"&&<>
        {/* Search */}
        {/* Search + Create */}
        <div style={{display:"flex",gap:9,marginBottom:14,flexWrap:"wrap"}}>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search restaurants by name, slug, or owner email..." style={{flex:1,minWidth:200,padding:"11px 14px",background:"#1a1208",border:"1px solid #5d3a1f",borderRadius:9,color:"#fff",fontSize:13,boxSizing:"border-box"}}/>
          <button onClick={()=>setShowCreateModal(true)} style={{padding:"11px 18px",background:"linear-gradient(135deg,#22c55e,#16a34a)",color:"#fff",border:"none",borderRadius:9,fontSize:13,fontWeight:700,cursor:"pointer",whiteSpace:"nowrap"}}>{String.fromCharCode(0x2795)} Create Restaurant</button>
        </div>
        
        {/* Restaurants */}
        {loading?<p style={{textAlign:"center",color:"#a8956a",padding:50}}>Loading...</p>:
          filtered.length===0?<p style={{textAlign:"center",color:"#a8956a",padding:50}}>No restaurants found</p>:
          <div style={{display:"grid",gap:9}}>
            {filtered.map(r=>{
              var initials=(r.name||"R").split(" ").map(w=>w[0]).join("").substring(0,2).toUpperCase();
              return <div key={r.id} style={{background:"#1a1208",border:"1px solid "+(r.active===false?"#dc2626":"#3d2e22"),borderRadius:11,padding:14,opacity:r.active===false?0.6:1}}>
                <div style={{display:"grid",gridTemplateColumns:"auto 1fr auto",gap:14,alignItems:"center"}}>
                  {/* Avatar */}
                  <div style={{width:46,height:46,borderRadius:11,background:r.brand_color||"#bf4626",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontWeight:700,fontSize:16}}>{initials}</div>
                  
                  {/* Info */}
                  <div style={{minWidth:0}}>
                    <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:3,flexWrap:"wrap"}}>
                      <p style={{fontSize:15,fontWeight:700,color:"#fff"}}>{r.name}</p>
                      <span style={{fontSize:9,padding:"2px 7px",background:planBg(r.plan),color:planColor(r.plan),borderRadius:5,fontWeight:700,letterSpacing:1}}>{(r.plan||"trial").toUpperCase()}</span>
                      {r.plan==="trial"&&r.stats?.trial_status&&<span style={{fontSize:9,padding:"2px 7px",background:trialBg(r.stats.trial_status),color:trialColor(r.stats.trial_status),borderRadius:5,fontWeight:700}}>{r.stats.trial_days_left>=0?r.stats.trial_days_left+" days left":"EXPIRED"}</span>}
                      {r.active===false&&<span style={{fontSize:9,padding:"2px 7px",background:"#fee2e2",color:"#dc2626",borderRadius:5,fontWeight:700,letterSpacing:1}}>SUSPENDED</span>}
                    </div>
                    <p style={{fontSize:11,color:"#a8956a",marginBottom:3}}>{r.stats?.owner_email}{r.cuisine_type?" - "+r.cuisine_type:""}</p>
                    <div style={{display:"flex",gap:11,fontSize:10,color:"#6b5d3f",flexWrap:"wrap"}}>
                      <span>{r.stats?.menu_count||0} menu</span>
                      <span>{r.stats?.table_count||0} tables</span>
                      <span>{r.stats?.orders_total||0} orders</span>
                      <span style={{color:"#22c55e"}}>{"\u00A3"}{(r.stats?.revenue||0).toFixed(2)} revenue</span>
                    </div>
                  </div>
                  
                  {/* Actions */}
                  <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
                    <button onClick={()=>doImpersonate(r)} title="Login as this restaurant" style={{padding:"6px 11px",background:"#7c3aed",color:"#fff",border:"none",borderRadius:6,fontSize:10,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0xD83D,0xDD11)} Login As</button>
                    <button onClick={()=>setShowEditModal(r)} title="Edit details" style={{padding:"6px 11px",background:"#0891b2",color:"#fff",border:"none",borderRadius:6,fontSize:10,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0x270F,0xFE0F)} Edit</button>
                    <button onClick={()=>doChangePlan(r)} title="Change plan" style={{padding:"6px 11px",background:"#1e40af",color:"#fff",border:"none",borderRadius:6,fontSize:10,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0xD83D,0xDCB3)} Plan</button>
                    <button onClick={()=>doToggleActive(r)} title={r.active===false?"Activate":"Suspend"} style={{padding:"6px 11px",background:r.active===false?"#059669":"#dc2626",color:"#fff",border:"none",borderRadius:6,fontSize:10,fontWeight:700,cursor:"pointer"}}>{r.active===false?String.fromCharCode(0x2713)+" Activate":String.fromCharCode(0x26D4)+" Suspend"}</button>
                    <button onClick={()=>setShowDeleteModal(r)} title="Delete restaurant" style={{padding:"6px 11px",background:"#7f1d1d",color:"#fff",border:"none",borderRadius:6,fontSize:10,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0xD83D,0xDDD1,0xFE0F)} Del</button>
                  </div>
                </div>
              </div>;
            })}
          </div>
        }
      </>}
      
      {activeTab==="reps"&&<>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:7}}>
          <div>
            <p style={{fontSize:11,color:"#a8956a",letterSpacing:2,fontWeight:700,marginBottom:3}}>SALES REPRESENTATIVES</p>
            <p style={{fontSize:11,color:"#a8956a"}}>{reps.length} reps {String.fromCharCode(0x2022)} {allCommissions.length} commission records</p>
          </div>
          <button onClick={()=>{setEditingRep(null);setShowRepForm(true);}} style={{padding:"9px 16px",background:"#bf4626",color:"#fff",border:"none",borderRadius:7,fontWeight:700,fontSize:12,cursor:"pointer"}}>+ Add Sales Rep</button>
        </div>
        
        {reps.length===0?<div style={{background:"#1a1208",borderRadius:11,padding:22,textAlign:"center",border:"1px solid #3d2e22"}}>
          <p style={{color:"#a8956a",fontSize:13,marginBottom:11}}>No sales reps added yet</p>
          <p style={{color:"#a8956a",fontSize:11}}>Sales reps can sign up restaurants and earn commissions. They get their own login at /?rep=1</p>
        </div>:<div style={{display:"grid",gap:9}}>
          {reps.map(r=>{
            var repComms=allCommissions.filter(c=>c.rep_id===r.id);
            var totalEarned=repComms.filter(c=>c.status==="paid").reduce((s,c)=>s+parseFloat(c.amount||0),0);
            var pending=repComms.filter(c=>c.status==="pending").reduce((s,c)=>s+parseFloat(c.amount||0),0);
            return <div key={r.id} style={{background:"#1a1208",borderRadius:11,padding:14,border:"1px solid #3d2e22"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:14,flexWrap:"wrap"}}>
                <div style={{flex:1,minWidth:200}}>
                  <div style={{display:"flex",gap:7,alignItems:"center",marginBottom:5}}>
                    <p style={{fontSize:15,fontWeight:700,color:"#fbbf24"}}>{r.full_name}</p>
                    {!r.active&&<span style={{padding:"2px 7px",background:"#7f1d1d",color:"#fecaca",fontSize:9,borderRadius:9,fontWeight:700}}>INACTIVE</span>}
                  </div>
                  <p style={{fontSize:11,color:"#a8956a"}}>{r.email} {r.phone?String.fromCharCode(0x2022)+" "+r.phone:""}</p>
                  <p style={{fontSize:11,color:"#a8956a",marginTop:3}}>
                    {String.fromCharCode(0xD83D,0xDCB0)} {r.commission_type==="percentage"?r.commission_percent+"% commission":r.commission_type==="fixed"?"£"+r.fixed_per_signup+" per signup":r.commission_type==="salary"?"£"+r.base_salary+"/mo salary":"Hybrid: "+r.commission_percent+"% + £"+r.fixed_per_signup}
                    {r.recurring_commission?" (recurring monthly)":""}
                  </p>
                </div>
                <div style={{display:"flex",gap:7}}>
                  <button onClick={()=>{setEditingRep(r);setShowRepForm(true);}} style={{padding:"6px 11px",background:"#1e3a8a",color:"#dbeafe",border:"1px solid #2563eb",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>Edit</button>
                  <button onClick={async()=>{
                    if(!window.confirm("Delete "+r.full_name+"? Their subscriptions will remain but they will lose access."))return;
                    var res=await dbDeleteRep(r.id);
                    if(res.error){alert("Failed: "+res.error.message);return;}
                    loadData();
                  }} style={{padding:"6px 11px",background:"#7f1d1d",color:"#fecaca",border:"1px solid #dc2626",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>Delete</button>
                </div>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(120px,1fr))",gap:7,marginTop:11,padding:11,background:"#0f0a05",borderRadius:7}}>
                <div><p style={{fontSize:9,color:"#a8956a",letterSpacing:1,fontWeight:700}}>EARNED</p><p style={{fontSize:13,fontWeight:700,color:"#22c55e"}}>£{totalEarned.toFixed(2)}</p></div>
                <div><p style={{fontSize:9,color:"#a8956a",letterSpacing:1,fontWeight:700}}>PENDING</p><p style={{fontSize:13,fontWeight:700,color:"#fbbf24"}}>£{pending.toFixed(2)}</p></div>
                <div><p style={{fontSize:9,color:"#a8956a",letterSpacing:1,fontWeight:700}}>COMMISSIONS</p><p style={{fontSize:13,fontWeight:700,color:"#fff"}}>{repComms.length}</p></div>
                <div><p style={{fontSize:9,color:"#a8956a",letterSpacing:1,fontWeight:700}}>LAST LOGIN</p><p style={{fontSize:11,color:"#fff"}}>{r.last_login_at?new Date(r.last_login_at).toLocaleDateString():"Never"}</p></div>
              </div>
            </div>;
          })}
        </div>}
        
        {/* Rep Form Modal */}
        {showRepForm&&<RepFormModal rep={editingRep} onClose={()=>{setShowRepForm(false);setEditingRep(null);}} onSave={async(formData)=>{
          var result;
          try{
            if(editingRep){
              result=await dbUpdateRep(editingRep.id,formData);
            }else{
              result=await dbCreateRep(formData);
            }
            console.log("Rep save result:",result);
            if(result.error){
              var errMsg=result.error.message||JSON.stringify(result.error);
              if(errMsg.includes("duplicate")||errMsg.includes("unique")){
                alert("Email already exists. Use a different email.");
              }else if(errMsg.includes("does not exist")||errMsg.includes("relation")){
                alert("Database tables not set up yet. Please run sales-rep-system.sql in Supabase SQL Editor first.");
              }else{
                alert("Failed to save: "+errMsg);
              }
              return;
            }
            setShowRepForm(false);
            setEditingRep(null);
            loadData();
            alert("Rep saved successfully!");
          }catch(e){
            console.error("Rep save exception:",e);
            alert("Error: "+(e.message||"Unknown error. Check console for details."));
          }
        }}/>}
        
        {/* PENDING COMMISSIONS TO PAY */}
        {allCommissions.filter(c=>c.status==="pending").length>0&&<div style={{marginTop:18,background:"#1a1208",borderRadius:11,padding:14,border:"2px solid #d97706"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:11,flexWrap:"wrap",gap:7}}>
            <div>
              <p style={{fontSize:13,fontWeight:700,color:"#fbbf24"}}>{String.fromCharCode(0xD83D,0xDCB0)} Pending Commissions to Pay</p>
              <p style={{fontSize:11,color:"#a8956a"}}>
                Total: \u00A3{allCommissions.filter(c=>c.status==="pending").reduce((s,c)=>s+parseFloat(c.amount||0),0).toFixed(2)} 
                {String.fromCharCode(0x2022)} {allCommissions.filter(c=>c.status==="pending").length} commission{allCommissions.filter(c=>c.status==="pending").length>1?"s":""}
              </p>
            </div>
          </div>
          
          <div style={{display:"flex",flexDirection:"column",gap:7}}>
            {allCommissions.filter(c=>c.status==="pending").map(c=>{
              var rep=reps.find(r=>r.id===c.rep_id);
              if(!rep)return null;
              return <div key={c.id} style={{padding:11,background:"#0f0a05",borderRadius:7,border:"1px solid #5d3a1f",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:11}}>
                <div style={{flex:1,minWidth:180}}>
                  <p style={{fontSize:13,fontWeight:700,color:"#fff",marginBottom:3}}>{rep.full_name}</p>
                  <p style={{fontSize:11,color:"#a8956a"}}>{c.sales_reps?.email||rep.email}</p>
                  <p style={{fontSize:10,color:"#6b5d3f",marginTop:3}}>
                    {c.type} {String.fromCharCode(0x2022)} {c.rep_subscriptions?.restaurants?.name||"Restaurant"} {String.fromCharCode(0x2022)} {new Date(c.created_at).toLocaleDateString()}
                  </p>
                </div>
                <div style={{textAlign:"right"}}>
                  <p style={{fontSize:18,fontWeight:700,color:"#fbbf24",marginBottom:5}}>\u00A3{parseFloat(c.amount).toFixed(2)}</p>
                  <button onClick={async()=>{
                    var method=window.prompt("Payment method? (e.g. Bank Transfer, PayPal, Cash)","Bank Transfer");
                    if(!method)return;
                    var ref=window.prompt("Transaction reference (optional):","");
                    var r=await dbMarkCommPaid(c.id,method,ref||"");
                    if(r.error){alert("Failed: "+r.error.message);return;}
                    alert("Marked as PAID!\n\nAmount: \u00A3"+parseFloat(c.amount).toFixed(2)+"\nTo: "+rep.full_name+"\nMethod: "+method);
                    loadData();
                  }} style={{padding:"6px 13px",background:"#22c55e",color:"#fff",border:"none",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0x2705)} Mark as Paid</button>
                </div>
              </div>;
            })}
          </div>
          
          <div style={{marginTop:11,padding:9,background:"rgba(217,119,6,.1)",borderRadius:7,fontSize:11,color:"#fbbf24"}}>
            <strong>{String.fromCharCode(0xD83D,0xDCA1)} How to Pay:</strong> Transfer the amount to the rep's bank account via Faster Payments / Bank Transfer, then click "Mark as Paid" with the transaction reference.
          </div>
        </div>}
      </>}
      
      {/* MARKETING PAYMENTS TAB */}
      {activeTab==="commissions"&&<CommissionsTab/>}
      
      {activeTab==="marketing"&&<MarketingPaymentsTab loadData={loadData}/>}
      
      {activeTab==="activity"&&<>
        <p style={{fontSize:11,color:"#a8956a",letterSpacing:2,fontWeight:700,marginBottom:11}}>RECENT PLATFORM ACTIVITY</p>
        {activity.length===0?<p style={{color:"#a8956a"}}>No activity yet</p>:
          <div style={{display:"grid",gap:5}}>
            {activity.map(a=>{
              var dt=new Date(a.created_at);
              var iconColor={impersonate_started:"#7c3aed",impersonate_ended:"#7c3aed",plan_changed:"#1e40af",restaurant_suspended:"#dc2626",restaurant_activated:"#059669",restaurant_signed_up:"#22c55e"}[a.action]||"#6b7280";
              return <div key={a.id} style={{background:"#1a1208",border:"1px solid #3d2e22",borderRadius:9,padding:11,fontSize:12}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:11,flexWrap:"wrap"}}>
                  <div style={{flex:1,minWidth:200}}>
                    <p style={{color:iconColor,fontWeight:700,marginBottom:3,letterSpacing:1,fontSize:11}}>{a.action.replace(/_/g," ").toUpperCase()}</p>
                    <p style={{color:"#fff"}}>{a.target_restaurant_name||"Platform"} {a.admin_email&&a.admin_email!=="system"&&" - by "+a.admin_email}</p>
                    {a.details&&Object.keys(a.details).length>0&&<p style={{color:"#a8956a",fontSize:10,marginTop:3}}>{JSON.stringify(a.details)}</p>}
                  </div>
                  <p style={{color:"#6b5d3f",fontSize:10}}>{dt.toLocaleString("en-GB")}</p>
                </div>
              </div>;
            })}
          </div>
        }
      </>}
      
    </div>
    
    {/* CREATE RESTAURANT MODAL */}
    {showCreateModal&&<CreateRestaurantModal saasOwner={saasOwner} onClose={()=>setShowCreateModal(false)} onSuccess={(result)=>{
      setShowCreateModal(false);
      setCreateResult(result);
      loadData();
    }}/>}
    
    {/* SUCCESS MODAL after creating */}
    {createResult&&<div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:18}} onClick={()=>setCreateResult(null)}>
      <div onClick={e=>e.stopPropagation()} style={{background:"#1a1208",border:"2px solid #22c55e",borderRadius:18,padding:30,maxWidth:540,width:"100%",maxHeight:"90vh",overflow:"auto"}}>
        <div style={{textAlign:"center",marginBottom:18}}>
          <div style={{fontSize:60,marginBottom:9}}>{String.fromCharCode(0xD83C,0xDF89)}</div>
          <h2 style={{color:"#22c55e",fontSize:22,fontWeight:700,marginBottom:5}}>Restaurant Created!</h2>
          <p style={{color:"#a8956a",fontSize:13}}>Send these details to the restaurant owner</p>
        </div>
        
        <div style={{background:"#0f0a05",border:"1px solid #5d3a1f",borderRadius:11,padding:18,marginBottom:14}}>
          <p style={{fontSize:11,color:"#a8956a",letterSpacing:2,fontWeight:700,marginBottom:9}}>LOGIN CREDENTIALS</p>
          <div style={{display:"grid",gap:9}}>
            <div>
              <p style={{fontSize:10,color:"#6b5d3f",marginBottom:3}}>EMAIL:</p>
              <p style={{fontFamily:"monospace",color:"#fff",fontSize:14,wordBreak:"break-all"}}>{createResult.owner?.email}</p>
            </div>
            <div>
              <p style={{fontSize:10,color:"#6b5d3f",marginBottom:3}}>PASSWORD:</p>
              <p style={{fontFamily:"monospace",color:"#fbbf24",fontSize:18,fontWeight:700,letterSpacing:2}}>{createResult.password}</p>
            </div>
            <div>
              <p style={{fontSize:10,color:"#6b5d3f",marginBottom:3}}>CUSTOMER URL:</p>
              <p style={{fontFamily:"monospace",color:"#22c55e",fontSize:13,wordBreak:"break-all"}}>{(typeof window!=="undefined"?window.location.origin:"")}/?r={createResult.slug}</p>
            </div>
            <div>
              <p style={{fontSize:10,color:"#6b5d3f",marginBottom:3}}>OWNER LOGIN URL:</p>
              <p style={{fontFamily:"monospace",color:"#22c55e",fontSize:13,wordBreak:"break-all"}}>{(typeof window!=="undefined"?window.location.origin:"")}/?login=1</p>
            </div>
          </div>
        </div>
        
        <button onClick={()=>{
          var text="Welcome to La Tavola!\n\nLogin URL: "+window.location.origin+"/?login=1\nEmail: "+createResult.owner?.email+"\nPassword: "+createResult.password+"\n\nYour customer ordering page:\n"+window.location.origin+"/?r="+createResult.slug+"\n\nFeel free to login and explore!";
          if(navigator.clipboard)navigator.clipboard.writeText(text);
          alert("Copied to clipboard - paste into WhatsApp/Email!");
        }} style={{width:"100%",padding:"11px 18px",background:"#22c55e",color:"#fff",border:"none",borderRadius:9,fontSize:13,fontWeight:700,cursor:"pointer",marginBottom:9}}>{String.fromCharCode(0xD83D,0xDCCB)} Copy All Details</button>
        
        <button onClick={()=>setCreateResult(null)} style={{width:"100%",padding:"11px 18px",background:"#1a1208",color:"#fff",border:"1px solid #5d3a1f",borderRadius:9,fontSize:13,fontWeight:700,cursor:"pointer"}}>Close</button>
      </div>
    </div>}
    
    {/* EDIT RESTAURANT MODAL */}
    {showEditModal&&<EditRestaurantModal restaurant={showEditModal} saasOwner={saasOwner} onClose={()=>setShowEditModal(null)} onSuccess={()=>{
      setShowEditModal(null);
      loadData();
    }}/>}
    
    {/* DELETE CONFIRMATION MODAL */}
    {showDeleteModal&&<DeleteRestaurantModal restaurant={showDeleteModal} saasOwner={saasOwner} onClose={()=>setShowDeleteModal(null)} onSuccess={()=>{
      setShowDeleteModal(null);
      loadData();
    }}/>}
  </div>;
}

// ============================================================
// CREATE RESTAURANT MODAL (Super Admin)
// ============================================================

function CreateRestaurantModal({saasOwner,onClose,onSuccess}){
  var [name,setName]=useState("");
  var [cuisine,setCuisine]=useState("italian");
  var [color,setColor]=useState("#bf4626");
  var [ownerName,setOwnerName]=useState("");
  var [ownerEmail,setOwnerEmail]=useState("");
  var [phone,setPhone]=useState("");
  var [address,setAddress]=useState("");
  var [postcode,setPostcode]=useState("");
  var [plan,setPlan]=useState("trial");
  var [trialDays,setTrialDays]=useState("30");
  var [autoSetup,setAutoSetup]=useState(true);
  var [creating,setCreating]=useState(false);
  
  var handleCreate=async()=>{
    if(!name.trim()){alert("Restaurant name required");return;}
    if(!ownerName.trim()){alert("Owner name required");return;}
    if(!ownerEmail.trim()||!ownerEmail.includes("@")){alert("Valid email required");return;}
    
    setCreating(true);
    var result=await dbAdminCreate({
      name:name.trim(),
      cuisine_type:cuisine,
      brand_color:color,
      owner_name:ownerName.trim(),
      owner_email:ownerEmail.trim().toLowerCase(),
      phone:phone.trim(),
      address:address.trim(),
      postcode:postcode.trim().toUpperCase(),
      plan:plan,
      trial_days:trialDays,
      auto_setup:autoSetup,
    },saasOwner.email);
    setCreating(false);
    
    if(result.success){
      onSuccess(result);
    }else{
      alert("Failed: "+(result.error||"Unknown error"));
    }
  };
  
  var inputStyle={width:"100%",padding:"9px 11px",background:"#0f0a05",border:"1px solid #5d3a1f",borderRadius:7,color:"#fff",fontSize:13,boxSizing:"border-box"};
  var labelStyle={fontSize:11,color:"#a8956a",letterSpacing:1,fontWeight:700,marginBottom:5,display:"block"};
  
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:18}} onClick={onClose}>
    <div onClick={e=>e.stopPropagation()} style={{background:"#1a1208",border:"1px solid #5d3a1f",borderRadius:18,padding:24,maxWidth:540,width:"100%",maxHeight:"90vh",overflow:"auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
        <h2 style={{color:"#fbbf24",fontSize:20,fontWeight:700,fontFamily:"Georgia,serif"}}>{String.fromCharCode(0x2795)} New Restaurant</h2>
        <button onClick={onClose} style={{background:"none",border:"none",color:"#a8956a",fontSize:22,cursor:"pointer"}}>{String.fromCharCode(0x00D7)}</button>
      </div>
      
      <div style={{display:"grid",gap:11}}>
        {/* Restaurant Info */}
        <div>
          <p style={{fontSize:11,color:"#fbbf24",letterSpacing:2,fontWeight:700,marginBottom:9,paddingBottom:5,borderBottom:"1px solid #3d2e22"}}>RESTAURANT INFO</p>
          <div style={{display:"grid",gap:9}}>
            <div>
              <label style={labelStyle}>NAME *</label>
              <input value={name} onChange={e=>setName(e.target.value)} placeholder="Mario's Pizza" style={inputStyle}/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9}}>
              <div>
                <label style={labelStyle}>CUISINE</label>
                <select value={cuisine} onChange={e=>setCuisine(e.target.value)} style={inputStyle}>
                  <option value="italian">Italian</option>
                  <option value="indian">Indian</option>
                  <option value="chinese">Chinese</option>
                  <option value="mexican">Mexican</option>
                  <option value="american">American</option>
                  <option value="thai">Thai</option>
                  <option value="japanese">Japanese</option>
                  <option value="general">General</option>
                </select>
              </div>
              <div>
                <label style={labelStyle}>BRAND COLOR</label>
                <input type="color" value={color} onChange={e=>setColor(e.target.value)} style={{...inputStyle,padding:5,height:38}}/>
              </div>
            </div>
            <div>
              <label style={labelStyle}>ADDRESS</label>
              <input value={address} onChange={e=>setAddress(e.target.value)} placeholder="123 High Street, London" style={inputStyle}/>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9}}>
              <div>
                <label style={labelStyle}>POSTCODE</label>
                <input value={postcode} onChange={e=>setPostcode(e.target.value)} placeholder="E14 7QH" style={inputStyle}/>
              </div>
              <div>
                <label style={labelStyle}>PHONE</label>
                <input value={phone} onChange={e=>setPhone(e.target.value)} placeholder="020 1234 5678" style={inputStyle}/>
              </div>
            </div>
          </div>
        </div>
        
        {/* Owner Info */}
        <div>
          <p style={{fontSize:11,color:"#fbbf24",letterSpacing:2,fontWeight:700,marginBottom:9,paddingBottom:5,borderBottom:"1px solid #3d2e22",marginTop:9}}>OWNER ACCOUNT</p>
          <div style={{display:"grid",gap:9}}>
            <div>
              <label style={labelStyle}>OWNER NAME *</label>
              <input value={ownerName} onChange={e=>setOwnerName(e.target.value)} placeholder="Mario Rossi" style={inputStyle}/>
            </div>
            <div>
              <label style={labelStyle}>EMAIL *</label>
              <input value={ownerEmail} onChange={e=>setOwnerEmail(e.target.value)} placeholder="mario@example.com" type="email" style={inputStyle}/>
            </div>
            <p style={{fontSize:10,color:"#6b5d3f",fontStyle:"italic"}}>{String.fromCharCode(0xD83D,0xDD11)} Password will be auto-generated and shown after creation</p>
          </div>
        </div>
        
        {/* Plan */}
        <div>
          <p style={{fontSize:11,color:"#fbbf24",letterSpacing:2,fontWeight:700,marginBottom:9,paddingBottom:5,borderBottom:"1px solid #3d2e22",marginTop:9}}>PLAN & SETUP</p>
          <div style={{display:"grid",gap:9}}>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9}}>
              <div>
                <label style={labelStyle}>PLAN</label>
                <select value={plan} onChange={e=>setPlan(e.target.value)} style={inputStyle}>
                  <option value="trial">Trial</option>
                  <option value="starter">Starter (\u00a329/mo)</option>
                  <option value="pro">Pro (\u00a369/mo)</option>
                  <option value="enterprise">Enterprise (\u00a3149/mo)</option>
                </select>
              </div>
              {plan==="trial"&&<div>
                <label style={labelStyle}>TRIAL DAYS</label>
                <input type="number" value={trialDays} onChange={e=>setTrialDays(e.target.value)} style={inputStyle}/>
              </div>}
            </div>
            <label style={{display:"flex",alignItems:"center",gap:9,cursor:"pointer",padding:9,background:"#0f0a05",borderRadius:7,border:"1px solid #3d2e22"}}>
              <input type="checkbox" checked={autoSetup} onChange={e=>setAutoSetup(e.target.checked)}/>
              <div>
                <p style={{fontSize:13,color:"#fff",fontWeight:700,marginBottom:3}}>Auto-setup defaults</p>
                <p style={{fontSize:10,color:"#a8956a"}}>Creates: 4 categories, 5 sample menu items, 6 tables, manager PIN, delivery settings</p>
              </div>
            </label>
          </div>
        </div>
      </div>
      
      <div style={{display:"flex",gap:9,marginTop:18}}>
        <button onClick={onClose} disabled={creating} style={{flex:1,padding:"11px 18px",background:"#0f0a05",color:"#a8956a",border:"1px solid #5d3a1f",borderRadius:9,fontWeight:700,cursor:creating?"not-allowed":"pointer"}}>Cancel</button>
        <button onClick={handleCreate} disabled={creating} style={{flex:2,padding:"11px 18px",background:creating?"#3d2e22":"linear-gradient(135deg,#22c55e,#16a34a)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,cursor:creating?"not-allowed":"pointer"}}>{creating?"Creating...":String.fromCharCode(0x2795)+" Create Restaurant"}</button>
      </div>
    </div>
  </div>;
}

// ============================================================
// EDIT RESTAURANT MODAL
// ============================================================

function EditRestaurantModal({restaurant,saasOwner,onClose,onSuccess}){
  var [name,setName]=useState(restaurant.name||"");
  var [cuisine,setCuisine]=useState(restaurant.cuisine_type||"general");
  var [color,setColor]=useState(restaurant.brand_color||"#bf4626");
  var [phone,setPhone]=useState(restaurant.phone||"");
  var [address,setAddress]=useState(restaurant.address||"");
  var [postcode,setPostcode]=useState(restaurant.postcode||"");
  var [lat,setLat]=useState(restaurant.lat||"");
  var [lng,setLng]=useState(restaurant.lng||"");
  var [plan,setPlan]=useState(restaurant.plan||"starter");
  var [planPrice,setPlanPrice]=useState(restaurant.plan_price||(restaurant.plan==="pro"?79:restaurant.plan==="enterprise"?149:29));
  var [billingType,setBillingType]=useState(restaurant.billing_type||"flat");
  var [commissionRate,setCommissionRate]=useState(restaurant.commission_rate||4);
  var [serviceTypes,setServiceTypes]=useState(restaurant.service_types||{dine_in:true,collection:true,delivery:true,phone_orders:true});
  var [addons,setAddons]=useState(restaurant.addon_features||{marketing:false,loyalty:false,multi_branch:false,custom_domain:false});
  var [locks,setLocks]=useState(restaurant.feature_locks||{dine_in:"allow",collection:"allow",delivery:"allow",phone_orders:"allow",online_ordering:"allow",bookings:"allow",marketing:"allow",loyalty:"allow",multi_branch:"allow",custom_domain:"allow"});
  var [updating,setUpdating]=useState(false);
  
  // SALES REP ASSIGNMENT
  var [reps,setReps]=useState([]);
  var [assignedRepId,setAssignedRepId]=useState(restaurant.assigned_rep_id||"");
  
  // Load reps and current assignment
  useEffect(()=>{
    dbFetchAllReps().then(list=>setReps(list||[]));
  },[]);
  
  // Auto-update plan price when plan changes
  var onPlanChange=(newPlan)=>{
    setPlan(newPlan);
    // Auto-fill price based on plan
    if(newPlan==="starter")setPlanPrice(29);
    else if(newPlan==="pro")setPlanPrice(79);
    else if(newPlan==="enterprise")setPlanPrice(149);
  };
  
  var handleSave=async()=>{
    if(!name.trim()){alert("Name required");return;}
    setUpdating(true);
    var result=await dbAdminUpdate(restaurant.id,{
      name:name.trim(),
      cuisine_type:cuisine,
      brand_color:color,
      phone:phone.trim(),
      address:address.trim(),
      postcode:postcode.trim().toUpperCase(),
      lat:lat||null,
      lng:lng||null,
      plan:plan,
      plan_price:parseFloat(planPrice)||0,
      billing_type:billingType,
      commission_rate:billingType==="commission"?parseFloat(commissionRate)||0:0,
      assigned_rep_id:assignedRepId||null,
      service_types:serviceTypes,
      addon_features:addons,
      feature_locks:locks,
    },saasOwner.email);
    
    // If rep was just assigned (or changed), create the subscription + commission
    if(assignedRepId&&assignedRepId!==restaurant.assigned_rep_id){
      try{
        var rep=reps.find(r=>r.id===assignedRepId);
        if(rep){
          // Calculate commission
          var signupComm=calculateSignupCommission(rep,parseFloat(planPrice)||0);
          var monthlyComm=rep.recurring_commission?signupComm:0;
          
          // Create rep_subscription record
          var subResult=await dbAssignRep(assignedRepId,restaurant.id,signupComm,monthlyComm);
          
          if(!subResult.error&&subResult.data){
            // Create commission record
            await dbCreateComm({
              rep_id:assignedRepId,
              subscription_id:subResult.data.id,
              amount:signupComm,
              type:'signup',
              description:'Signup commission for '+restaurant.name+' ('+plan+' plan @ \u00A3'+planPrice+'/mo)',
            });
            console.log("Rep assigned and commission created:",signupComm);
          }
        }
      }catch(e){console.error("Failed to create commission:",e);}
    }
    
    setUpdating(false);
    if(result.success){
      onSuccess();
    }else{
      alert("Failed: "+(result.error||"Unknown"));
    }
  };
  
  var handleResetPassword=async()=>{
    if(!window.confirm("Generate new password for this restaurant?\n\nOld password will stop working immediately.")) return;
    var result=await dbAdminResetPwd(restaurant.id,null,saasOwner.email);
    if(result.success){
      alert("New password: "+result.password+"\n\n(Send this to the restaurant owner!)");
    }else{
      alert("Failed: "+(result.error||"Unknown"));
    }
  };
  
  var inputStyle={width:"100%",padding:"9px 11px",background:"#0f0a05",border:"1px solid #5d3a1f",borderRadius:7,color:"#fff",fontSize:13,boxSizing:"border-box"};
  var labelStyle={fontSize:11,color:"#a8956a",letterSpacing:1,fontWeight:700,marginBottom:5,display:"block"};
  
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:18}} onClick={onClose}>
    <div onClick={e=>e.stopPropagation()} style={{background:"#1a1208",border:"1px solid #5d3a1f",borderRadius:18,padding:24,maxWidth:540,width:"100%",maxHeight:"90vh",overflow:"auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
        <h2 style={{color:"#fbbf24",fontSize:20,fontWeight:700,fontFamily:"Georgia,serif"}}>{String.fromCharCode(0x270F,0xFE0F)} Edit {restaurant.name}</h2>
        <button onClick={onClose} style={{background:"none",border:"none",color:"#a8956a",fontSize:22,cursor:"pointer"}}>{String.fromCharCode(0x00D7)}</button>
      </div>
      
      <div style={{display:"grid",gap:11}}>
        <div>
          <label style={labelStyle}>NAME</label>
          <input value={name} onChange={e=>setName(e.target.value)} style={inputStyle}/>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9}}>
          <div>
            <label style={labelStyle}>CUISINE</label>
            <select value={cuisine} onChange={e=>setCuisine(e.target.value)} style={inputStyle}>
              <option value="italian">Italian</option>
              <option value="indian">Indian</option>
              <option value="chinese">Chinese</option>
              <option value="mexican">Mexican</option>
              <option value="american">American</option>
              <option value="thai">Thai</option>
              <option value="japanese">Japanese</option>
              <option value="general">General</option>
            </select>
          </div>
          <div>
            <label style={labelStyle}>BRAND COLOR</label>
            <input type="color" value={color} onChange={e=>setColor(e.target.value)} style={{...inputStyle,padding:5,height:38}}/>
          </div>
        </div>
        <div>
          <label style={labelStyle}>ADDRESS</label>
          <input value={address} onChange={e=>setAddress(e.target.value)} style={inputStyle}/>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9}}>
          <div>
            <label style={labelStyle}>POSTCODE</label>
            <input value={postcode} onChange={e=>setPostcode(e.target.value)} style={inputStyle}/>
          </div>
          <div>
            <label style={labelStyle}>PHONE</label>
            <input value={phone} onChange={e=>setPhone(e.target.value)} style={inputStyle}/>
          </div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:9}}>
          <div>
            <label style={labelStyle}>LATITUDE</label>
            <input value={lat} onChange={e=>setLat(e.target.value)} placeholder="51.5074" style={inputStyle}/>
          </div>
          <div>
            <label style={labelStyle}>LONGITUDE</label>
            <input value={lng} onChange={e=>setLng(e.target.value)} placeholder="-0.1278" style={inputStyle}/>
          </div>
        </div>
        <p style={{fontSize:10,color:"#6b5d3f",fontStyle:"italic",marginTop:-3}}>{String.fromCharCode(0xD83D,0xDCA1)} Get coordinates: Google Maps {String.fromCharCode(0x2192)} right-click address {String.fromCharCode(0x2192)} click coordinates</p>
        
        {/* PLAN SECTION */}
        <div style={{marginTop:18,padding:14,background:"#0f0a05",borderRadius:9,border:"1px solid #5d3a1f"}}>
          <p style={{color:"#fbbf24",fontSize:13,fontWeight:700,marginBottom:9}}>{String.fromCharCode(0xD83D,0xDCB3)} Subscription Plan</p>
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:7}}>
            {[["starter","Starter","\u00A329"],["pro","Pro","\u00A369"],["enterprise","Enterprise","\u00A3149"]].map(p=>
              <button key={p[0]} onClick={()=>onPlanChange(p[0])} style={{padding:"11px 5px",background:plan===p[0]?"#0891b2":"#1a1208",color:plan===p[0]?"#fff":"#a8956a",border:"2px solid "+(plan===p[0]?"#0891b2":"#5d3a1f"),borderRadius:7,fontWeight:700,fontSize:12,cursor:"pointer"}}>
                <p style={{textTransform:"uppercase",letterSpacing:1,marginBottom:3}}>{p[1]}</p>
                <p style={{fontSize:10,opacity:.85}}>{p[2]}/month</p>
              </button>
            )}
          </div>
          
          {/* CUSTOM PRICE */}
          <div style={{marginTop:11,padding:11,background:"#0f0a05",borderRadius:7,border:"1px solid #5d3a1f"}}>
            <label style={labelStyle}>{String.fromCharCode(0xD83D,0xDCB0)} CUSTOM MONTHLY PRICE (£)</label>
            <input type="number" value={planPrice} onChange={e=>setPlanPrice(e.target.value)} step="0.01" min="0" placeholder="29.00" style={inputStyle}/>
            <p style={{fontSize:10,color:"#6b5d3f",marginTop:5,fontStyle:"italic"}}>Override the default plan price (used for commission calculation)</p>
          </div>
          
          {/* BILLING TYPE - flat fee vs commission */}
          <div style={{marginTop:11,padding:11,background:"#0f0a05",borderRadius:7,border:"1px solid #5d3a1f"}}>
            <label style={labelStyle}>{String.fromCharCode(0xD83D,0xDCB3)} BILLING MODEL</label>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:7,marginTop:5}}>
              <button type="button" onClick={()=>setBillingType("flat")} style={{padding:"10px 8px",borderRadius:7,border:"2px solid "+(billingType==="flat"?"#fbbf24":"#5d3a1f"),background:billingType==="flat"?"#3d2e1a":"transparent",color:billingType==="flat"?"#fbbf24":"#9b8b6f",cursor:"pointer",fontSize:11,fontWeight:700}}>
                Flat Monthly Fee<br/><span style={{fontSize:9,fontWeight:400}}>0% commission</span>
              </button>
              <button type="button" onClick={()=>setBillingType("commission")} style={{padding:"10px 8px",borderRadius:7,border:"2px solid "+(billingType==="commission"?"#fbbf24":"#5d3a1f"),background:billingType==="commission"?"#3d2e1a":"transparent",color:billingType==="commission"?"#fbbf24":"#9b8b6f",cursor:"pointer",fontSize:11,fontWeight:700}}>
                Commission<br/><span style={{fontSize:9,fontWeight:400}}>% per online order</span>
              </button>
            </div>
            {billingType==="commission"&&<div style={{marginTop:9}}>
              <label style={labelStyle}>COMMISSION RATE (%)</label>
              <input type="number" value={commissionRate} onChange={e=>setCommissionRate(e.target.value)} step="0.5" min="0" max="30" placeholder="4" style={inputStyle}/>
              <p style={{fontSize:10,color:"#6b5d3f",marginTop:5,fontStyle:"italic"}}>Charged on online orders only (delivery & collection placed online). Not on walk-in/phone orders. Typical: 3-5%.</p>
            </div>}
          </div>
        </div>
        
        {/* SALES REP ASSIGNMENT */}
        <div style={{marginTop:11,padding:14,background:"#0f0a05",borderRadius:9,border:"1px solid #5d3a1f"}}>
          <p style={{color:"#fbbf24",fontSize:13,fontWeight:700,marginBottom:5}}>{String.fromCharCode(0xD83D,0xDCBC)} Sales Rep Assignment</p>
          <p style={{color:"#6b5d3f",fontSize:10,marginBottom:11,fontStyle:"italic"}}>Assign a sales rep who signed up this restaurant. Commission will be auto-calculated on save.</p>
          
          <label style={labelStyle}>SALES REP</label>
          <select value={assignedRepId} onChange={e=>setAssignedRepId(e.target.value)} style={inputStyle}>
            <option value="">-- No rep assigned --</option>
            {reps.filter(r=>r.active).map(r=><option key={r.id} value={r.id}>{r.full_name} ({r.commission_type==="percentage"?r.commission_percent+"%":r.commission_type==="fixed"?"\u00A3"+r.fixed_per_signup:r.commission_type==="salary"?"Salary":"Hybrid"})</option>)}
          </select>
          
          {assignedRepId&&(()=>{
            var rep=reps.find(r=>r.id===assignedRepId);
            if(!rep)return null;
            var comm=calculateSignupCommission(rep,parseFloat(planPrice)||0);
            return <div style={{marginTop:9,padding:9,background:"#1a1208",borderRadius:7,border:"1px solid #22c55e"}}>
              <p style={{fontSize:11,color:"#22c55e",fontWeight:700,marginBottom:3}}>{String.fromCharCode(0x2705)} COMMISSION PREVIEW</p>
              <p style={{fontSize:12,color:"#fff"}}>Rep "{rep.full_name}" will earn <strong style={{color:"#fbbf24"}}>£{comm.toFixed(2)}</strong> when you save</p>
              {rep.recurring_commission&&<p style={{fontSize:10,color:"#22c55e",marginTop:3}}>+ £{comm.toFixed(2)}/month recurring</p>}
            </div>;
          })()}
        </div>

        {/* SERVICE TYPES & LOCKS */}
        <div style={{marginTop:11,padding:14,background:"#0f0a05",borderRadius:9,border:"1px solid #5d3a1f"}}>
          <p style={{color:"#fbbf24",fontSize:13,fontWeight:700,marginBottom:5}}>{String.fromCharCode(0xD83C,0xDF7D,0xFE0F)} Services & Lock Controls</p>
          <p style={{color:"#6b5d3f",fontSize:10,marginBottom:11,fontStyle:"italic"}}>{String.fromCharCode(0xD83D,0xDD13)} Allow = Owner can toggle  |  {String.fromCharCode(0xD83D,0xDD12)} Lock ON = Always enabled  |  {String.fromCharCode(0xD83D,0xDEAB)} Lock OFF = Always disabled</p>
          <div style={{display:"flex",flexDirection:"column",gap:7}}>
            {[["dine_in","Dine-in",String.fromCharCode(0xD83C,0xDF7D,0xFE0F)],["collection","Collection",String.fromCharCode(0xD83D,0xDED2)],["delivery","Delivery",String.fromCharCode(0xD83D,0xDEF5)],["phone_orders","Phone Orders",String.fromCharCode(0xD83D,0xDCDE)]].map(s=>{
              var lockState=locks[s[0]]||"allow";
              return <div key={s[0]} style={{padding:9,background:"#1a1208",borderRadius:7,border:"1px solid #5d3a1f"}}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:7}}>
                  <span style={{color:"#fff",fontSize:12,fontWeight:700}}>{s[2]} {s[1]}</span>
                  {lockState==="allow"&&<label style={{display:"flex",alignItems:"center",gap:5,fontSize:11,color:"#a8956a"}}>
                    <input type="checkbox" checked={serviceTypes[s[0]]!==false} onChange={e=>setServiceTypes({...serviceTypes,[s[0]]:e.target.checked})} style={{cursor:"pointer"}}/>
                    <span>Default ON</span>
                  </label>}
                </div>
                <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:5}}>
                  {[["allow","\uD83D\uDD13 Allow","#0891b2"],["lock_on","\uD83D\uDD12 Lock ON","#059669"],["lock_off","\uD83D\uDEAB Lock OFF","#dc2626"]].map(opt=>
                    <button key={opt[0]} onClick={()=>setLocks({...locks,[s[0]]:opt[0]})} style={{padding:"6px 4px",background:lockState===opt[0]?opt[2]:"#0f0a05",color:lockState===opt[0]?"#fff":"#6b5d3f",border:"1px solid "+(lockState===opt[0]?opt[2]:"#3d2818"),borderRadius:5,cursor:"pointer",fontSize:10,fontWeight:700}}>{opt[1]}</button>
                  )}
                </div>
              </div>;
            })}
          </div>
        </div>

        {/* ADDON FEATURES & LOCKS */}
        <div style={{marginTop:11,padding:14,background:"#0f0a05",borderRadius:9,border:"1px solid #5d3a1f"}}>
          <p style={{color:"#fbbf24",fontSize:13,fontWeight:700,marginBottom:5}}>{String.fromCharCode(0x2728)} Add-on Features</p>
          <p style={{color:"#6b5d3f",fontSize:10,marginBottom:11,fontStyle:"italic"}}>Override plan limits and lock features per restaurant</p>
          <div style={{display:"flex",flexDirection:"column",gap:7}}>
            {[["online_ordering","Online Ordering"],["bookings","Bookings"],["marketing","Marketing"],["loyalty","Loyalty Program"],["multi_branch","Multi-Branch"],["custom_domain","Custom Domain"]].map(f=>{
              var lockState=locks[f[0]]||"allow";
              return <div key={f[0]} style={{padding:9,background:"#1a1208",borderRadius:7,border:"1px solid #5d3a1f"}}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:7}}>
                  <span style={{color:"#fff",fontSize:12,fontWeight:700}}>{f[1]}</span>
                  {lockState==="allow"&&<label style={{display:"flex",alignItems:"center",gap:5,fontSize:11,color:"#a8956a"}}>
                    <input type="checkbox" checked={!!addons[f[0]]} onChange={e=>setAddons({...addons,[f[0]]:e.target.checked})} style={{cursor:"pointer"}}/>
                    <span>Override ON</span>
                  </label>}
                </div>
                <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:5}}>
                  {[["allow","\uD83D\uDD13 Allow","#0891b2"],["lock_on","\uD83D\uDD12 Lock ON","#059669"],["lock_off","\uD83D\uDEAB Lock OFF","#dc2626"]].map(opt=>
                    <button key={opt[0]} onClick={()=>setLocks({...locks,[f[0]]:opt[0]})} style={{padding:"6px 4px",background:lockState===opt[0]?opt[2]:"#0f0a05",color:lockState===opt[0]?"#fff":"#6b5d3f",border:"1px solid "+(lockState===opt[0]?opt[2]:"#3d2818"),borderRadius:5,cursor:"pointer",fontSize:10,fontWeight:700}}>{opt[1]}</button>
                  )}
                </div>
              </div>;
            })}
          </div>
        </div>
        
        <button onClick={handleResetPassword} style={{padding:"9px 14px",background:"#7c3aed",color:"#fff",border:"none",borderRadius:7,fontSize:11,fontWeight:700,cursor:"pointer",marginTop:11}}>{String.fromCharCode(0xD83D,0xDD11)} Reset Owner Password</button>
      </div>
      
      <div style={{display:"flex",gap:9,marginTop:18}}>
        <button onClick={onClose} disabled={updating} style={{flex:1,padding:"11px 18px",background:"#0f0a05",color:"#a8956a",border:"1px solid #5d3a1f",borderRadius:9,fontWeight:700,cursor:"pointer"}}>Cancel</button>
        <button onClick={handleSave} disabled={updating} style={{flex:2,padding:"11px 18px",background:updating?"#3d2e22":"#0891b2",color:"#fff",border:"none",borderRadius:9,fontWeight:700,cursor:"pointer"}}>{updating?"Saving...":String.fromCharCode(0xD83D,0xDCBE)+" Save Changes"}</button>
      </div>
    </div>
  </div>;
}

// ============================================================
// DELETE RESTAURANT MODAL (with double confirmation)
// ============================================================

function DeleteRestaurantModal({restaurant,saasOwner,onClose,onSuccess}){
  var [confirmText,setConfirmText]=useState("");
  var [deleting,setDeleting]=useState(false);
  var requiredText="DELETE "+restaurant.name;
  
  var handleDelete=async()=>{
    if(confirmText.trim()!==requiredText){
      alert('Type exactly: '+requiredText);
      return;
    }
    setDeleting(true);
    var result=await dbAdminDelete(restaurant.id,restaurant.name,saasOwner.email);
    setDeleting(false);
    if(result.success){
      alert(restaurant.name+" deleted permanently.");
      onSuccess();
    }else{
      alert("Failed: "+(result.error||"Unknown"));
    }
  };
  
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:18}} onClick={onClose}>
    <div onClick={e=>e.stopPropagation()} style={{background:"#1a1208",border:"2px solid #dc2626",borderRadius:18,padding:24,maxWidth:480,width:"100%"}}>
      <div style={{textAlign:"center",marginBottom:18}}>
        <div style={{fontSize:50,marginBottom:9}}>{String.fromCharCode(0x26A0,0xFE0F)}</div>
        <h2 style={{color:"#dc2626",fontSize:20,fontWeight:700,marginBottom:5}}>Delete Restaurant?</h2>
        <p style={{color:"#a8956a",fontSize:13}}>This will <b style={{color:"#dc2626"}}>PERMANENTLY DELETE</b> all data:</p>
      </div>
      
      <div style={{background:"#0f0a05",border:"1px solid #5d3a1f",borderRadius:9,padding:14,marginBottom:14}}>
        <p style={{fontSize:12,color:"#fff",fontWeight:700,marginBottom:9}}>{restaurant.name}</p>
        <ul style={{fontSize:11,color:"#a8956a",paddingLeft:18,lineHeight:1.6}}>
          <li>{restaurant.stats?.menu_count||0} menu items</li>
          <li>{restaurant.stats?.table_count||0} tables</li>
          <li>{restaurant.stats?.orders_total||0} orders ({"\u00a3"}{(restaurant.stats?.revenue||0).toFixed(2)} revenue history)</li>
          <li>All customer data</li>
          <li>All settings, expenses, reservations</li>
          <li>Owner login account</li>
        </ul>
        <p style={{fontSize:11,color:"#dc2626",fontWeight:700,marginTop:9}}>{String.fromCharCode(0x26A0,0xFE0F)} This cannot be undone!</p>
      </div>
      
      <div style={{marginBottom:14}}>
        <p style={{fontSize:11,color:"#a8956a",marginBottom:5}}>Type to confirm:</p>
        <p style={{fontSize:13,color:"#fbbf24",fontFamily:"monospace",fontWeight:700,marginBottom:9}}>{requiredText}</p>
        <input value={confirmText} onChange={e=>setConfirmText(e.target.value)} placeholder={requiredText} style={{width:"100%",padding:"9px 11px",background:"#0f0a05",border:"1px solid #5d3a1f",borderRadius:7,color:"#fff",fontSize:13,boxSizing:"border-box",fontFamily:"monospace"}}/>
      </div>
      
      <div style={{display:"flex",gap:9}}>
        <button onClick={onClose} disabled={deleting} style={{flex:1,padding:"11px 18px",background:"#0f0a05",color:"#fff",border:"1px solid #5d3a1f",borderRadius:9,fontWeight:700,cursor:"pointer"}}>Cancel</button>
        <button onClick={handleDelete} disabled={deleting||confirmText.trim()!==requiredText} style={{flex:1,padding:"11px 18px",background:confirmText.trim()===requiredText?"#dc2626":"#3d2e22",color:"#fff",border:"none",borderRadius:9,fontWeight:700,cursor:confirmText.trim()===requiredText?"pointer":"not-allowed",opacity:confirmText.trim()===requiredText?1:0.5}}>{deleting?"Deleting...":String.fromCharCode(0xD83D,0xDDD1,0xFE0F)+" DELETE"}</button>
      </div>
    </div>
  </div>;
}


// ============================================================
// SAAS-2: SIGNUP / LOGIN / VERIFICATION SCREENS
// ============================================================

// ============================================================
// OFFLINE LOGIN BOX with PIN security
// ============================================================
function OfflineLoginBox({data,ageHours,isOffline,offlinePin,onAuthSuccess}){
  var [showPin,setShowPin]=useState(false);
  var [pinInput,setPinInput]=useState("");
  var [error,setError]=useState("");
  
  var tryLogin=()=>{
    // If PIN is set, require it
    if(offlinePin){
      if(!showPin){
        setShowPin(true);
        return;
      }
      if(pinInput!==offlinePin){
        setError("Wrong PIN");
        setPinInput("");
        return;
      }
    }
    // PIN matched or not required - log in
    onAuthSuccess(data.owner,data.restaurant);
  };
  
  return <div style={{marginBottom:14,padding:11,background:isOffline?"#fef3c7":"#dbeafe",border:"2px solid "+(isOffline?"#f59e0b":"#3b82f6"),borderRadius:9}}>
    <p style={{fontSize:11,fontWeight:700,color:isOffline?"#92400e":"#1e40af",marginBottom:3}}>{isOffline?String.fromCharCode(0xD83D,0xDCF6)+" OFFLINE":String.fromCharCode(0xD83D,0xDD12)+" QUICK LOGIN"}</p>
    <p style={{fontSize:12,fontWeight:700,marginBottom:3}}>{data.restaurant.name}</p>
    <p style={{fontSize:11,color:"#6b6359",marginBottom:9}}>{data.owner.email} {String.fromCharCode(0x2022)} Cached {ageHours}h ago</p>
    
    {showPin && <div style={{marginBottom:9,padding:11,background:"#fff",borderRadius:7,border:"1px solid #ede8de"}}>
      <p style={{fontSize:11,fontWeight:700,marginBottom:5}}>{String.fromCharCode(0xD83D,0xDD12)} Enter Offline PIN</p>
      <input type="password" inputMode="numeric" pattern="[0-9]*" value={pinInput} onChange={e=>{setPinInput(e.target.value.replace(/\D/g,""));setError("");}} onKeyPress={e=>e.key==="Enter"&&tryLogin()} placeholder="****" autoFocus style={{width:"100%",padding:"11px",border:"2px solid "+(error?"#dc2626":"#ede8de"),borderRadius:7,fontSize:18,letterSpacing:4,textAlign:"center",boxSizing:"border-box"}}/>
      {error&&<p style={{fontSize:11,color:"#dc2626",marginTop:5}}>{error}</p>}
    </div>}
    
    <button onClick={tryLogin} style={{width:"100%",padding:"11px",background:isOffline?"#d97706":"#2563eb",color:"#fff",border:"none",borderRadius:7,fontWeight:700,fontSize:13,cursor:"pointer"}}>
      {showPin?String.fromCharCode(0x2713)+" Verify PIN":(isOffline?String.fromCharCode(0xD83D,0xDCF6)+" Continue Offline as "+data.owner.full_name:String.fromCharCode(0x26A1)+" Quick Login as "+data.owner.full_name)}
    </button>
    {isOffline&&<p style={{fontSize:10,color:"#92400e",marginTop:7,fontStyle:"italic",textAlign:"center"}}>Will sync with cloud when internet returns</p>}
    {offlinePin&&!showPin&&<p style={{fontSize:10,color:"#6b6359",marginTop:5,fontStyle:"italic",textAlign:"center"}}>{String.fromCharCode(0xD83D,0xDD12)} PIN required</p>}
  </div>;
}

function SaaSAuthScreen({onAuthSuccess}){
  var [mode,setMode]=useState("login"); // "login", "signup", "verify"
  var [email,setEmail]=useState("");
  var [password,setPassword]=useState("");
  var [restaurantName,setRestaurantName]=useState("");
  var [ownerName,setOwnerName]=useState("");
  var [phone,setPhone]=useState("");
  var [cuisineType,setCuisineType]=useState("italian");
  var [verifyCode,setVerifyCode]=useState("");
  var [pendingVerifyEmail,setPendingVerifyEmail]=useState("");
  var [demoVerifyCode,setDemoVerifyCode]=useState(""); // shown for demo only
  var [error,setError]=useState("");
  var [loading,setLoading]=useState(false);
  
  var doSignup=async()=>{
    setError("");
    if(!restaurantName.trim()){setError("Enter restaurant name");return;}
    if(!ownerName.trim()){setError("Enter your name");return;}
    if(!email.trim()){setError("Enter email");return;}
    if(password.length<6){setError("Password must be at least 6 characters");return;}
    
    setLoading(true);
    try{
      var r=await dbSignup({
        restaurantName:restaurantName.trim(),
        ownerName:ownerName.trim(),
        email:email.trim(),
        password,
        cuisineType,
        phone:phone.trim()||null,
      });
      setLoading(false);
      if(r.error){setError(r.error.message);return;}
      // Show verification screen
      setPendingVerifyEmail(email.trim());
      setDemoVerifyCode(r.data.verificationCode);
      setMode("verify");
    }catch(e){
      setLoading(false);
      setError("Signup failed: "+e.message);
    }
  };
  
  var doLogin=async()=>{
    setError("");
    if(!email.trim()){setError("Enter email");return;}
    if(!password){setError("Enter password");return;}
    
    setLoading(true);
    try{
      var r=await dbLogin(email.trim(),password);
      setLoading(false);
      if(r.error){
        if(r.error.needsVerification){
          setPendingVerifyEmail(r.error.email);
          setMode("verify");
          return;
        }
        setError(r.error.message);
        return;
      }
      // Save and login
      dbSaveOwner(r.data.owner,r.data.restaurant);
      onAuthSuccess(r.data.owner,r.data.restaurant);
    }catch(e){
      setLoading(false);
      setError("Login failed: "+e.message);
    }
  };
  
  var doVerify=async()=>{
    setError("");
    if(!verifyCode||verifyCode.length!==6){setError("Enter 6-digit code");return;}
    setLoading(true);
    try{
      var r=await dbVerifyEmail(pendingVerifyEmail,verifyCode);
      setLoading(false);
      if(r.error){setError(r.error.message);return;}
      // Auto-login after verification
      var loginR=await dbLogin(pendingVerifyEmail,password);
      if(loginR.data){
        dbSaveOwner(loginR.data.owner,loginR.data.restaurant);
        onAuthSuccess(loginR.data.owner,loginR.data.restaurant);
      }else{
        setMode("login");
        setError("Verified! Please login.");
      }
    }catch(e){
      setLoading(false);
      setError("Verification failed: "+e.message);
    }
  };
  
  var resendCode=async()=>{
    setLoading(true);
    var r=await dbResendVer(pendingVerifyEmail);
    setLoading(false);
    if(r.data)setDemoVerifyCode(r.data.verificationCode);
  };
  
  return <div style={{minHeight:"100vh",background:"linear-gradient(135deg,#1a1208 0%,#3d2e22 50%,#1a1208 100%)",display:"flex",alignItems:"center",justifyContent:"center",padding:14,fontFamily:"-apple-system,sans-serif"}}>
    <div style={{maxWidth:500,width:"100%",background:"#fafaf5",borderRadius:18,boxShadow:"0 30px 80px rgba(0,0,0,.5)",overflow:"hidden"}}>
      {/* Header */}
      <div style={{background:"linear-gradient(135deg,#bf4626,#7c2d12)",color:"#fff",padding:"30px 24px",textAlign:"center"}}>
        <p style={{fontSize:38,marginBottom:5,fontWeight:300,letterSpacing:6,fontFamily:"Georgia,serif"}}>{String.fromCharCode(0xD83C,0xDF7D,0xFE0F)} La Tavola</p>
        <p style={{fontSize:13,opacity:.85,letterSpacing:2}}>RESTAURANT MANAGEMENT PLATFORM</p>
        <p style={{fontSize:11,opacity:.7,marginTop:6}}>For restaurant owners {String.fromCharCode(0x2022)} POS, online ordering, delivery & more</p>
      </div>
      
      <div style={{padding:24}}>
        {error&&<div style={{padding:11,background:"#fee2e2",border:"2px solid #dc2626",borderRadius:7,marginBottom:14,color:"#991b1b",fontSize:13,fontWeight:600}}>{String.fromCharCode(0x26A0,0xFE0F)} {error}</div>}
        
        {/* MODE: VERIFY */}
        {mode==="verify"&&<div>
          <h2 style={{fontSize:22,fontWeight:700,marginBottom:5,textAlign:"center"}}>Verify Your Email</h2>
          <p style={{fontSize:13,color:"#8a8078",textAlign:"center",marginBottom:18}}>We sent a 6-digit code to:<br/><b>{pendingVerifyEmail}</b></p>
          
          {demoVerifyCode&&<div style={{padding:14,background:"#fef3c7",border:"3px dashed #d4952a",borderRadius:9,marginBottom:14,textAlign:"center"}}>
            <p style={{fontSize:11,color:"#92400e",fontWeight:700,letterSpacing:2}}>DEMO MODE - Your Code:</p>
            <p style={{fontSize:32,fontWeight:700,color:"#92400e",fontFamily:"'Courier New',monospace",letterSpacing:8,marginTop:5}}>{demoVerifyCode}</p>
            <p style={{fontSize:10,color:"#92400e",marginTop:5,fontStyle:"italic"}}>(In production this would be emailed to you)</p>
          </div>}
          
          <input value={verifyCode} onChange={e=>setVerifyCode(e.target.value.replace(/[^0-9]/g,"").substring(0,6))} placeholder="000000" autoFocus maxLength="6" style={{width:"100%",padding:"18px",fontSize:30,fontWeight:700,fontFamily:"'Courier New',monospace",textAlign:"center",letterSpacing:14,border:"3px solid #d4952a",borderRadius:9,marginBottom:14,boxSizing:"border-box"}}/>
          
          <button onClick={doVerify} disabled={loading||verifyCode.length!==6} style={{width:"100%",padding:"15px",background:loading||verifyCode.length!==6?"#9ca3af":"linear-gradient(135deg,#059669,#10b981)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:14,cursor:loading?"not-allowed":"pointer",marginBottom:9}}>{loading?"Verifying...":(String.fromCharCode(0x2713)+" Verify Email")}</button>
          
          <div style={{display:"flex",gap:6,fontSize:12}}>
            <button onClick={resendCode} disabled={loading} style={{flex:1,padding:"9px",background:"none",border:"1px solid #ede8de",borderRadius:6,color:"#8a8078",cursor:"pointer"}}>Resend code</button>
            <button onClick={()=>{setMode("login");setError("");}} style={{flex:1,padding:"9px",background:"none",border:"1px solid #ede8de",borderRadius:6,color:"#8a8078",cursor:"pointer"}}>{"<"} Back to login</button>
          </div>
        </div>}
        
        {/* MODE: LOGIN */}
        {mode==="login"&&<div>
          <h2 style={{fontSize:22,fontWeight:700,marginBottom:18,textAlign:"center"}}>Sign In</h2>
          
          {/* OFFLINE LOGIN OPTION - ONLY when actually offline (no Quick Login when online) */}
          {(()=>{
            try{
              var isOffline=navigator.onLine===false;
              // When ONLINE: no quick login - always use email+password below
              if(!isOffline)return null;
              var cached=localStorage.getItem("latavola_offline_login");
              if(!cached)return null;
              var data=JSON.parse(cached);
              var ageHours=Math.round((Date.now()-data.cachedAt)/(1000*60*60));
              var offlinePin=null;
              try{offlinePin=localStorage.getItem("latavola_offline_pin");}catch(e){}
              return <OfflineLoginBox data={data} ageHours={ageHours} isOffline={isOffline} offlinePin={offlinePin} onAuthSuccess={onAuthSuccess}/>;
            }catch(e){return null;}
          })()}
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>EMAIL</p>
          <input value={email} onChange={e=>setEmail(e.target.value)} type="email" placeholder="you@restaurant.com" autoFocus style={{width:"100%",padding:"13px",border:"2px solid #ede8de",borderRadius:7,fontSize:14,marginBottom:11,boxSizing:"border-box"}}/>
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>PASSWORD</p>
          <input value={password} onChange={e=>setPassword(e.target.value)} onKeyPress={e=>e.key==="Enter"&&doLogin()} type="password" placeholder="******" style={{width:"100%",padding:"13px",border:"2px solid #ede8de",borderRadius:7,fontSize:14,marginBottom:14,boxSizing:"border-box"}}/>
          
          <button onClick={doLogin} disabled={loading} style={{width:"100%",padding:"15px",background:loading?"#9ca3af":"linear-gradient(135deg,#bf4626,#7c2d12)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:14,cursor:loading?"not-allowed":"pointer",marginBottom:11}}>{loading?"Signing in...":"Sign In"}</button>
          
          <div style={{textAlign:"center",fontSize:12,color:"#8a8078",marginBottom:11}}>or</div>
          
          <button onClick={()=>{setMode("signup");setError("");}} style={{width:"100%",padding:"13px",background:"#fff",color:"#bf4626",border:"2px solid #bf4626",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>{String.fromCharCode(0x2728)} Start Free 14-day Trial</button>
        </div>}
        
        {/* MODE: SIGNUP */}
        {mode==="signup"&&<div>
          <h2 style={{fontSize:22,fontWeight:700,marginBottom:5,textAlign:"center"}}>Start Your Free Trial</h2>
          <p style={{fontSize:12,color:"#8a8078",textAlign:"center",marginBottom:18}}>14 days free - No credit card required</p>
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>RESTAURANT NAME</p>
          <input value={restaurantName} onChange={e=>setRestaurantName(e.target.value)} placeholder="Mario's Pizza" autoFocus style={{width:"100%",padding:"13px",border:"2px solid #ede8de",borderRadius:7,fontSize:14,marginBottom:11,boxSizing:"border-box"}}/>
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>YOUR FULL NAME</p>
          <input value={ownerName} onChange={e=>setOwnerName(e.target.value)} placeholder="Mario Rossi" style={{width:"100%",padding:"13px",border:"2px solid #ede8de",borderRadius:7,fontSize:14,marginBottom:11,boxSizing:"border-box"}}/>
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>EMAIL</p>
          <input value={email} onChange={e=>setEmail(e.target.value)} type="email" placeholder="you@restaurant.com" style={{width:"100%",padding:"13px",border:"2px solid #ede8de",borderRadius:7,fontSize:14,marginBottom:11,boxSizing:"border-box"}}/>
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>PHONE (OPTIONAL)</p>
          <input value={phone} onChange={e=>setPhone(e.target.value)} type="tel" placeholder="+44 7700 900000" style={{width:"100%",padding:"13px",border:"2px solid #ede8de",borderRadius:7,fontSize:14,marginBottom:11,boxSizing:"border-box"}}/>
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>CUISINE TYPE</p>
          <select value={cuisineType} onChange={e=>setCuisineType(e.target.value)} style={{width:"100%",padding:"13px",border:"2px solid #ede8de",borderRadius:7,fontSize:14,marginBottom:11,boxSizing:"border-box"}}>
            <option value="italian">Italian</option>
            <option value="indian">Indian</option>
            <option value="chinese">Chinese</option>
            <option value="british">British</option>
            <option value="american">American/Burger</option>
            <option value="mexican">Mexican</option>
            <option value="japanese">Japanese/Sushi</option>
            <option value="thai">Thai</option>
            <option value="cafe">Cafe</option>
            <option value="other">Other</option>
          </select>
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>PASSWORD (MIN 6 CHARS)</p>
          <input value={password} onChange={e=>setPassword(e.target.value)} type="password" placeholder="******" style={{width:"100%",padding:"13px",border:"2px solid #ede8de",borderRadius:7,fontSize:14,marginBottom:14,boxSizing:"border-box"}}/>
          
          <button onClick={doSignup} disabled={loading} style={{width:"100%",padding:"15px",background:loading?"#9ca3af":"linear-gradient(135deg,#bf4626,#7c2d12)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:14,cursor:loading?"not-allowed":"pointer",marginBottom:11}}>{loading?"Creating account...":(String.fromCharCode(0x2728)+" Start Free Trial")}</button>
          
          <p style={{fontSize:10,color:"#8a8078",textAlign:"center",marginBottom:11}}>By signing up you agree to our Terms of Service and Privacy Policy.</p>
          
          <button onClick={()=>{setMode("login");setError("");}} style={{width:"100%",padding:"11px",background:"#fff",color:"#8a8078",border:"1px solid #ede8de",borderRadius:9,fontSize:13,cursor:"pointer"}}>Already have an account? Sign in</button>
        </div>}
      </div>
      
      <div style={{padding:14,background:"#1a1208",color:"#fff",textAlign:"center",fontSize:11,opacity:.7}}>
        La Tavola Platform - Multi-Restaurant POS
      </div>
    </div>
  </div>;
}

// ============================================================
// SAAS-2: ONBOARDING WIZARD - new restaurant setup
// ============================================================

function OnboardingWizard({restaurant,onComplete}){
  var [step,setStep]=useState(1);
  var [vatRate,setVatRate]=useState(20);
  var [vatNumber,setVatNumber]=useState("");
  var [brandColor,setBrandColor]=useState(restaurant?.brand_color||"#bf4626");
  var [phone,setPhone]=useState(restaurant?.phone||"");
  var [address,setAddress]=useState(restaurant?.address||"");
  var [saving,setSaving]=useState(false);
  
  var totalSteps=4;
  
  var saveAndComplete=async()=>{
    setSaving(true);
    await dbUpdateRestaurant(restaurant.id,{
      vat_rate:parseFloat(vatRate)||20,
      vat_number:vatNumber||null,
      brand_color:brandColor,
      phone:phone||null,
      address:address||null,
      onboarding_complete:true,
    });
    setSaving(false);
    onComplete();
  };
  
  return <div style={{minHeight:"100vh",background:"linear-gradient(135deg,#fafaf5,#f5f0e8)",display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
    <div style={{maxWidth:540,width:"100%",background:"#fff",borderRadius:14,boxShadow:"0 20px 60px rgba(0,0,0,.15)",overflow:"hidden"}}>
      {/* Header with progress */}
      <div style={{background:"linear-gradient(135deg,"+brandColor+","+brandColor+"99)",color:"#fff",padding:"22px 24px",textAlign:"center"}}>
        <p style={{fontSize:11,opacity:.85,letterSpacing:3,fontWeight:700,marginBottom:6}}>WELCOME TO LA TAVOLA</p>
        <h2 style={{fontSize:24,fontWeight:700,marginBottom:4}}>{restaurant?.name||"Your Restaurant"}</h2>
        <p style={{fontSize:12,opacity:.85}}>Let's get you set up - Step {step} of {totalSteps}</p>
        
        {/* Progress bar */}
        <div style={{height:6,background:"rgba(255,255,255,.2)",borderRadius:3,marginTop:14,overflow:"hidden"}}>
          <div style={{height:"100%",background:"#fff",width:(step/totalSteps*100)+"%",transition:"width 0.3s"}}/>
        </div>
      </div>
      
      <div style={{padding:24}}>
        {/* STEP 1: Welcome */}
        {step===1&&<div>
          <p style={{fontSize:48,textAlign:"center",marginBottom:14}}>{String.fromCharCode(0xD83C,0xDF89)}</p>
          <h3 style={{fontSize:20,fontWeight:700,textAlign:"center",marginBottom:11}}>Welcome aboard!</h3>
          <p style={{fontSize:13,color:"#666",textAlign:"center",marginBottom:18,lineHeight:1.6}}>You're now starting your <b>14-day free trial</b> of La Tavola. Let's spend a few minutes setting up your restaurant for success.</p>
          
          <div style={{padding:14,background:"#f5f3ff",borderRadius:9,marginBottom:14,fontSize:12,color:"#5b21b6"}}>
            <p style={{fontWeight:700,marginBottom:7}}>{String.fromCharCode(0x2728)} What you get during your trial:</p>
            <ul style={{paddingLeft:18,lineHeight:1.8,margin:0}}>
              <li>Full POS system (dine-in, takeaway, delivery)</li>
              <li>Customer ordering app + QR codes</li>
              <li>Menu management & inventory</li>
              <li>Payment processing (cash, card, split)</li>
              <li>Receipts, refunds, vouchers</li>
              <li>Staff shifts & cash drawer</li>
              <li>Reports & analytics</li>
              <li>Profit & Loss statements</li>
              <li>And much more!</li>
            </ul>
          </div>
          
          <button onClick={()=>setStep(2)} style={{width:"100%",padding:"15px",background:"linear-gradient(135deg,"+brandColor+","+brandColor+"99)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:14,cursor:"pointer"}}>Let's Get Started {String.fromCharCode(0x2192)}</button>
        </div>}
        
        {/* STEP 2: Branding */}
        {step===2&&<div>
          <h3 style={{fontSize:18,fontWeight:700,marginBottom:5}}>{String.fromCharCode(0xD83C,0xDFA8)} Brand Your Restaurant</h3>
          <p style={{fontSize:12,color:"#666",marginBottom:18}}>Choose a color that represents your restaurant. This appears on receipts, menus, and customer-facing screens.</p>
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>BRAND COLOR</p>
          <div style={{display:"grid",gridTemplateColumns:"repeat(8,1fr)",gap:6,marginBottom:14}}>
            {["#dc2626","#ea580c","#d97706","#65a30d","#059669","#0891b2","#2563eb","#7c3aed","#bf4626","#0d9488","#1e40af","#be185d","#9333ea","#374151","#ca8a04","#16a34a"].map(c=>
              <button key={c} onClick={()=>setBrandColor(c)} style={{padding:18,background:c,border:"3px solid "+(brandColor===c?"#1a1208":"transparent"),borderRadius:9,cursor:"pointer",transform:brandColor===c?"scale(1.1)":"scale(1)",transition:"all 0.2s"}}/>
            )}
          </div>
          
          <p style={{fontSize:11,color:"#8a8078",marginBottom:11}}>Selected: <b style={{color:brandColor}}>{brandColor}</b></p>
          
          <div style={{padding:18,borderRadius:11,background:"linear-gradient(135deg,"+brandColor+","+brandColor+"99)",color:"#fff",textAlign:"center",marginBottom:18}}>
            <p style={{fontSize:11,opacity:.85,letterSpacing:2,fontWeight:700,marginBottom:5}}>PREVIEW</p>
            <p style={{fontSize:18,fontWeight:700}}>{restaurant?.name}</p>
          </div>
          
          <div style={{display:"flex",gap:7}}>
            <button onClick={()=>setStep(1)} style={{flex:1,padding:"13px",background:"#fff",color:"#666",border:"2px solid #ede8de",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>{"<"} Back</button>
            <button onClick={()=>setStep(3)} style={{flex:2,padding:"13px",background:"linear-gradient(135deg,"+brandColor+","+brandColor+"99)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>Continue {String.fromCharCode(0x2192)}</button>
          </div>
        </div>}
        
        {/* STEP 3: Restaurant Info */}
        {step===3&&<div>
          <h3 style={{fontSize:18,fontWeight:700,marginBottom:5}}>{String.fromCharCode(0xD83C,0xDFE0)} Restaurant Details</h3>
          <p style={{fontSize:12,color:"#666",marginBottom:18}}>This appears on your receipts and customer communications.</p>
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>PHONE</p>
          <input value={phone} onChange={e=>setPhone(e.target.value)} type="tel" placeholder="+44 20 7946 0000" style={{width:"100%",padding:"13px",border:"2px solid #ede8de",borderRadius:7,fontSize:14,marginBottom:11,boxSizing:"border-box"}}/>
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>ADDRESS</p>
          <textarea value={address} onChange={e=>setAddress(e.target.value)} placeholder="123 High Street, London, EC1A 1BB" rows={2} style={{width:"100%",padding:"13px",border:"2px solid #ede8de",borderRadius:7,fontSize:14,fontFamily:"inherit",resize:"vertical",marginBottom:14,boxSizing:"border-box"}}/>
          
          <div style={{display:"flex",gap:7}}>
            <button onClick={()=>setStep(2)} style={{flex:1,padding:"13px",background:"#fff",color:"#666",border:"2px solid #ede8de",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>{"<"} Back</button>
            <button onClick={()=>setStep(4)} style={{flex:2,padding:"13px",background:"linear-gradient(135deg,"+brandColor+","+brandColor+"99)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>Continue {String.fromCharCode(0x2192)}</button>
          </div>
        </div>}
        
        {/* STEP 4: VAT & Tax */}
        {step===4&&<div>
          <h3 style={{fontSize:18,fontWeight:700,marginBottom:5}}>{String.fromCharCode(0xD83D,0xDCB7)} Tax Settings (UK VAT)</h3>
          <p style={{fontSize:12,color:"#666",marginBottom:18}}>Configure your VAT settings. You can change these later in settings.</p>
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>VAT RATE (%)</p>
          <input value={vatRate} onChange={e=>setVatRate(e.target.value)} type="number" min="0" max="50" step="0.5" style={{width:"100%",padding:"13px",border:"2px solid #ede8de",borderRadius:7,fontSize:14,marginBottom:11,boxSizing:"border-box"}}/>
          <p style={{fontSize:10,color:"#8a8078",marginBottom:14}}>UK standard rate is 20%. Set 0 if not VAT registered.</p>
          
          <p style={{fontSize:11,color:"#8a8078",fontWeight:700,letterSpacing:1,marginBottom:5}}>VAT NUMBER (OPTIONAL)</p>
          <input value={vatNumber} onChange={e=>setVatNumber(e.target.value)} placeholder="GB 123 4567 89" style={{width:"100%",padding:"13px",border:"2px solid #ede8de",borderRadius:7,fontSize:14,marginBottom:18,boxSizing:"border-box"}}/>
          
          <div style={{padding:11,background:"#fef3c7",borderRadius:7,fontSize:11,color:"#92400e",marginBottom:14}}>
            <p>{String.fromCharCode(0x2139,0xFE0F)} Don't worry, you can update these settings any time in Admin {String.fromCharCode(0x2192)} Settings.</p>
          </div>
          
          <div style={{display:"flex",gap:7}}>
            <button onClick={()=>setStep(3)} style={{flex:1,padding:"13px",background:"#fff",color:"#666",border:"2px solid #ede8de",borderRadius:9,fontWeight:700,fontSize:13,cursor:"pointer"}}>{"<"} Back</button>
            <button onClick={saveAndComplete} disabled={saving} style={{flex:2,padding:"13px",background:saving?"#9ca3af":"linear-gradient(135deg,#059669,#10b981)",color:"#fff",border:"none",borderRadius:9,fontWeight:700,fontSize:13,cursor:saving?"not-allowed":"pointer"}}>{saving?"Saving...":(String.fromCharCode(0x2713)+" Complete Setup")}</button>
          </div>
        </div>}
      </div>
    </div>
  </div>;
}

// ============================================================
// SAAS-2: RESTAURANT SWITCHER (for testing multi-tenancy)
// ============================================================

function RestaurantSwitcher({currentRestaurant,onSwitch,onClose}){
  var [restaurants,setRestaurants]=useState([]);
  var [loading,setLoading]=useState(true);
  
  useEffect(()=>{
    dbFetchAllRests().then(rs=>{
      setRestaurants(rs||[]);
      setLoading(false);
    });
  },[]);
  
  var doSwitch=async(r)=>{
    var switched=await dbSwitchRest(r.id);
    if(switched){
      // Clear saved branch and user - they belong to the OLD restaurant
      try{
        localStorage.removeItem("latavola_branch");
        localStorage.removeItem("latavola_user");
      }catch(e){}
      onSwitch(switched);
      window.location.reload(); // Reload to refresh all data
    }
  };
  
  return <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",zIndex:9500,display:"flex",alignItems:"center",justifyContent:"center",padding:14}}>
    <div style={{background:"#fafaf5",borderRadius:14,maxWidth:540,width:"100%",maxHeight:"96vh",overflow:"hidden",display:"flex",flexDirection:"column",boxShadow:"0 20px 60px rgba(0,0,0,.4)"}}>
      <div style={{background:"linear-gradient(135deg,#7c3aed,#a855f7)",color:"#fff",padding:"15px 20px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <p style={{fontSize:11,opacity:.85,fontWeight:700,letterSpacing:2}}>SUPER ADMIN</p>
          <h2 style={{fontSize:18,fontWeight:700}}>{String.fromCharCode(0xD83D,0xDD04)} Switch Restaurant</h2>
        </div>
        <button onClick={onClose} style={{width:34,height:34,borderRadius:"50%",background:"rgba(255,255,255,.15)",color:"#fff",border:"none",cursor:"pointer",fontSize:16,fontWeight:700}}>x</button>
      </div>
      
      <div style={{flex:1,overflowY:"auto",padding:18}}>
        <p style={{fontSize:11,color:"#8a8078",marginBottom:11}}>{String.fromCharCode(0x26A0,0xFE0F)} This is a TEST feature. Switch between restaurants to see how multi-tenancy works.</p>
        
        {loading?<p style={{textAlign:"center",color:"#8a8078"}}>Loading...</p>:
          restaurants.map(r=>{
            var isCurrent=r.id===currentRestaurant?.id;
            var trialDays=r.trial_ends_at?Math.ceil((new Date(r.trial_ends_at)-new Date())/(1000*60*60*24)):0;
            return <div key={r.id} style={{padding:14,border:"2px solid "+(isCurrent?(r.brand_color||"#7c3aed"):"#ede8de"),borderRadius:9,marginBottom:7,background:isCurrent?(r.brand_color||"#7c3aed")+"15":"#fff",cursor:isCurrent?"default":"pointer"}} onClick={()=>!isCurrent&&doSwitch(r)}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"start",gap:8}}>
                <div style={{flex:1}}>
                  <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:5}}>
                    <span style={{padding:"3px 9px",background:r.brand_color||"#7c3aed",color:"#fff",borderRadius:5,fontSize:10,fontWeight:700,letterSpacing:1}}>{(r.cuisine_type||"OTHER").toUpperCase()}</span>
                    {isCurrent&&<span style={{padding:"3px 9px",background:"#059669",color:"#fff",borderRadius:5,fontSize:10,fontWeight:700}}>{String.fromCharCode(0x2713)} CURRENT</span>}
                  </div>
                  <p style={{fontSize:15,fontWeight:700}}>{r.name}</p>
                  <p style={{fontSize:11,color:"#8a8078"}}>{r.subdomain}.latavola.app - {r.owner_email}</p>
                  <p style={{fontSize:11,color:"#8a8078",marginTop:3}}>Plan: <b>{(r.plan||"trial").toUpperCase()}</b>{r.plan==="trial"&&trialDays>0?" ("+trialDays+" days left)":""}{r.plan==="trial"&&trialDays<=0?" (EXPIRED)":""}</p>
                </div>
                {!isCurrent&&<button style={{padding:"7px 14px",background:r.brand_color||"#7c3aed",color:"#fff",border:"none",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer",whiteSpace:"nowrap"}}>Switch {String.fromCharCode(0x2192)}</button>}
              </div>
            </div>;
          })
        }
      </div>
    </div>
  </div>;
}


// =================================================================
// PRETTY ALERT / CONFIRM SYSTEM
// Replaces ugly window.alert() with beautiful modals
// =================================================================
function PrettyAlertProvider(){
  var [alertData,setAlertData]=useState(null);
  var [confirmData,setConfirmData]=useState(null);
  
  // Register global functions
  useEffect(()=>{
    window.showAlert=(title,message,type)=>{
      return new Promise(resolve=>{
        setAlertData({title,message,type:type||"info",onClose:()=>{setAlertData(null);resolve();}});
      });
    };
    
    window.showConfirm=(title,message,confirmText,cancelText,type)=>{
      return new Promise(resolve=>{
        setConfirmData({
          title,
          message,
          type:type||"warning",
          confirmText:confirmText||"OK",
          cancelText:cancelText||"Cancel",
          onConfirm:()=>{setConfirmData(null);resolve(true);},
          onCancel:()=>{setConfirmData(null);resolve(false);},
        });
      });
    };
    
    // Also intercept window.alert and window.confirm
    var origAlert=window.alert.bind(window);
    window.alert=(message)=>{
      window.showAlert("Notice",message,"info");
    };
    
    return ()=>{
      delete window.showAlert;
      delete window.showConfirm;
      window.alert=origAlert;
    };
  },[]);
  
  var colors={
    info:{bg:"#dbeafe",border:"#3b82f6",text:"#1e40af",icon:String.fromCharCode(0x2139,0xFE0F)},
    success:{bg:"#d1fae5",border:"#22c55e",text:"#065f46",icon:String.fromCharCode(0x2705)},
    warning:{bg:"#fef3c7",border:"#f59e0b",text:"#92400e",icon:String.fromCharCode(0x26A0,0xFE0F)},
    error:{bg:"#fee2e2",border:"#dc2626",text:"#991b1b",icon:String.fromCharCode(0x274C)},
  };
  
  return <>
    {alertData&&<div onClick={alertData.onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:18}}>
      <div onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:14,padding:0,maxWidth:440,width:"100%",overflow:"hidden",boxShadow:"0 18px 50px rgba(0,0,0,.25)"}}>
        <div style={{padding:"18px 22px",background:colors[alertData.type].bg,borderBottom:"2px solid "+colors[alertData.type].border,display:"flex",alignItems:"center",gap:11}}>
          <span style={{fontSize:24}}>{colors[alertData.type].icon}</span>
          <h3 style={{fontSize:16,fontWeight:700,color:colors[alertData.type].text,flex:1}}>{alertData.title}</h3>
        </div>
        <div style={{padding:18}}>
          <p style={{fontSize:13,color:"#1a1208",whiteSpace:"pre-wrap",lineHeight:1.5}}>{alertData.message}</p>
        </div>
        <div style={{padding:"11px 18px 18px",display:"flex",justifyContent:"flex-end"}}>
          <button onClick={alertData.onClose} style={{padding:"9px 22px",background:colors[alertData.type].border,color:"#fff",border:"none",borderRadius:7,fontSize:13,fontWeight:700,cursor:"pointer"}}>OK</button>
        </div>
      </div>
    </div>}
    
    {confirmData&&<div onClick={confirmData.onCancel} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:99999,display:"flex",alignItems:"center",justifyContent:"center",padding:18}}>
      <div onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:14,padding:0,maxWidth:440,width:"100%",overflow:"hidden",boxShadow:"0 18px 50px rgba(0,0,0,.25)"}}>
        <div style={{padding:"18px 22px",background:colors[confirmData.type].bg,borderBottom:"2px solid "+colors[confirmData.type].border,display:"flex",alignItems:"center",gap:11}}>
          <span style={{fontSize:24}}>{colors[confirmData.type].icon}</span>
          <h3 style={{fontSize:16,fontWeight:700,color:colors[confirmData.type].text,flex:1}}>{confirmData.title}</h3>
        </div>
        <div style={{padding:18}}>
          <p style={{fontSize:13,color:"#1a1208",whiteSpace:"pre-wrap",lineHeight:1.5}}>{confirmData.message}</p>
        </div>
        <div style={{padding:"11px 18px 18px",display:"flex",gap:9,justifyContent:"flex-end"}}>
          <button onClick={confirmData.onCancel} style={{padding:"9px 18px",background:"#fff",color:"#1a1208",border:"2px solid #ede8de",borderRadius:7,fontSize:13,fontWeight:700,cursor:"pointer"}}>{confirmData.cancelText}</button>
          <button onClick={confirmData.onConfirm} style={{padding:"9px 22px",background:colors[confirmData.type].border,color:"#fff",border:"none",borderRadius:7,fontSize:13,fontWeight:700,cursor:"pointer"}}>{confirmData.confirmText}</button>
        </div>
      </div>
    </div>}
  </>;
}

export default function App(){
  var [view,setView]=useState("menu"),[orders,setOrders]=useState([]),[menu,setMenu]=useState([]);
  var [discs,setDiscs]=useState([]);
  // LANGUAGE: re-render when language changes
  // eslint-disable-next-line no-unused-vars
  var [currentLang,setCurrentLang]=useState(getCurrentLanguage());
  useEffect(()=>{
    var handler=()=>setCurrentLang(getCurrentLanguage());
    window.addEventListener("languagechange-custom",handler);
    return ()=>window.removeEventListener("languagechange-custom",handler);
  },[]);
  var [reviews,setReviews]=useState([]);
  var [reservations,setRes]=useState([]);
  var [messages,setMessages]=useState([]);
  var [tables,setTables]=useState([]);
  var [setMeals,setSetMeals]=useState([]);
  var [categories,setCategories]=useState([]);
  var [customers,setCustomers]=useState([]);
  var [stations,setStations]=useState([]);
  // STAFF PIN LOGIN
  var [activeStaff,setActiveStaffState]=useState(()=>{try{return dbGetActiveStaff();}catch(e){return null;}});
  var [showStaffPinModal,setShowStaffPinModal]=useState(false);
  // SAAS: Current restaurant (tenant) info
  var [restaurant,setRestaurant]=useState(()=>{
    try{
      var saved=localStorage.getItem("latavola_saas_restaurant");
      if(saved)return JSON.parse(saved);
    }catch(e){}
    return null;
  });
  // SAAS: Current restaurant's branches (auto-branch using their info)
  // For La Tavola, use 'b3' to match existing data; for others, use 'main'
  var currentBranches=restaurant?[
    {
      id:restaurant.slug==="la-tavola"?"b3":"main",
      name:restaurant.name||"Main",
      addr:restaurant.address||"",
      phone:restaurant.phone||"",
      postcode:restaurant.postcode||"",
      lat:parseFloat(restaurant.lat)||51.5,
      lng:parseFloat(restaurant.lng)||-0.1,
      delivery:{enabled:true,method:"radius",postcodes:[],radius:5,zones:[],flatFee:2.50,freeOver:25,minOrder:15},
      cod:{enabled:true,minOrder:15,maxMiles:5}
    }
  ]:BRANCHES;
  // Restore user and branch from localStorage so refresh doesn't log out
  // PHASE A FIX: If URL has ?r=, don't restore old branch (it's from previous restaurant)
  var [user,setUser]=useState(()=>{
    try{
      var hasUrlRest=window.location.search.includes("r=")||window.location.search.includes("restaurant=");
      if(hasUrlRest)return null; // customer browsing - don't restore old user
      var u=localStorage.getItem("latavola_user");
      return u?JSON.parse(u):null;
    }catch(e){return null;}
  });
  var [branch,setBranch]=useState(()=>{
    try{
      var hasUrlRest=window.location.search.includes("r=")||window.location.search.includes("restaurant=");
      if(hasUrlRest)return null; // customer browsing - don't restore old branch
      var b=localStorage.getItem("latavola_branch");
      return b?JSON.parse(b):null;
    }catch(e){return null;}
  });
  var [showAuth,setAuth]=useState(false),[notifs,setNotifs]=useState([]);
  // PRETTY ALERT & CONFIRM modals
  var [alertModal,setAlertModal]=useState(null); // {title, message, type, onClose}
  var [confirmModal,setConfirmModal]=useState(null); // {title, message, type, onConfirm, onCancel, confirmText, cancelText, destructive}
  var [online,setOnline]=useState(isOnline()),[pendingCount,setPendingCount]=useState(getQueue().length);
  var nid=useRef(0);
  var ordersRef=useRef([]);
  useEffect(()=>{ordersRef.current=orders;},[orders]);
  
  // SAAS-2: Auth state
  var [saasOwner,setSaasOwner]=useState(()=>dbGetOwner());
  var [showOnboarding,setShowOnboarding]=useState(false);
  var [showRestaurantSwitcher,setShowRestaurantSwitcher]=useState(false);
  var [showQRGenerator,setShowQRGenerator]=useState(false);
  // SUPER ADMIN: Platform owner panel
  var [showSuperAdmin,setShowSuperAdmin]=useState(()=>{
    try{
      var p=new URLSearchParams(window.location.search);
      return p.get("admin")==="lt-secret-2026";
    }catch(e){return false;}
  });
  // SALES REP routing
  var [showRepPortal,setShowRepPortal]=useState(()=>{
    try{
      var p=new URLSearchParams(window.location.search);
      return p.get("rep")==="1"||window.location.pathname==="/reps";
    }catch(e){return false;}
  });
  var [currentRep,setCurrentRep]=useState(()=>dbGetRep());
  
  // DRIVER PORTAL routing
  var [showDriverPortal,setShowDriverPortal]=useState(()=>{
    try{
      var p=new URLSearchParams(window.location.search);
      // Show portal if URL says so OR if a driver is already logged in (survives refresh)
      var urlWants=p.get("driver")==="1"||window.location.pathname==="/driver";
      var driverLoggedIn=!!dbGetDriver();
      return urlWants||driverLoggedIn;
    }catch(e){return false;}
  });
  var [currentDriver,setCurrentDriver]=useState(()=>dbGetDriver());
  var [isAdmin,setIsAdmin]=useState(false);
  var [impersonating,setImpersonating]=useState(()=>dbIsImpersonating());
  
  // Check if current user is super admin
  useEffect(()=>{
    if(saasOwner){
      dbIsSuperAdmin().then(result=>setIsAdmin(result));
    }else{
      setIsAdmin(false);
    }
  },[saasOwner]);
  // PHASE A: URL-based restaurant detection (for customers visiting from links/QR)
  var [urlRestaurant,setUrlRestaurant]=useState(null);
  var [urlChecked,setUrlChecked]=useState(false);
  
  // PHASE A: Check URL for restaurant on first load
  useEffect(()=>{
    dbDetectFromUrl().then(result=>{
      if(result&&result.restaurant){
        // Customer arrived via URL with restaurant slug
        setUrlRestaurant(result.restaurant);
        setRestaurant(result.restaurant);
        // For URL-detected restaurants, set as current
        try{window.__currentRestaurant=result.restaurant;}catch(e){}
      }
      setUrlChecked(true);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  
  // Handle Stripe payment success/cancel return
  useEffect(()=>{
    try{
      var p=new URLSearchParams(window.location.search);
      var payment=p.get("payment");
      var purchaseId=p.get("purchase");
      if(payment==="success"){
        if(window.showAlert){
          window.showAlert(
            "Payment Successful!",
            "Your credits have been added to your account."+(purchaseId?"\n\nReference: "+purchaseId.slice(0,8):""),
            "success"
          );
        }
        // Clean URL
        window.history.replaceState({},"",window.location.pathname);
      }else if(payment==="cancelled"){
        if(window.showAlert){
          window.showAlert(
            "Payment Cancelled",
            "Your payment was cancelled. No credits were added.",
            "warning"
          );
        }
        window.history.replaceState({},"",window.location.pathname);
      }
    }catch(e){}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  
  // SAAS: Load current restaurant on mount (only for logged-in owners)
  useEffect(()=>{
    // PHASE A FIX: If URL has ?r= param, the URL detection effect handles it
    // Don't load from localStorage if URL is requesting a specific restaurant
    try{
      var urlParams=new URLSearchParams(window.location.search);
      if(urlParams.get("r")||urlParams.get("restaurant")){
        // URL-based restaurant - URL detection effect will set it
        return;
      }
    }catch(e){}
    
    // First try to load the saved SaaS restaurant from localStorage (for logged-in owners)
    var savedRest=dbGetSaasRest();
    if(savedRest&&saasOwner){
      // Only use saved restaurant if user is actually a SaaS owner
      setRestaurant(savedRest);
      try{window.__currentRestaurant=savedRest;console.log("SaaS Restaurant loaded:",savedRest.name);}catch(e){}
      
      // CRITICAL: Refresh restaurant data from DB to get latest plan/locks/features
      dbFetchRestaurant(savedRest.id).then(freshData=>{
        if(freshData){
          setRestaurant(freshData);
          dbSaveOwner(saasOwner,freshData);
          try{window.__currentRestaurant=freshData;}catch(e){}
          console.log("Restaurant data refreshed from DB:",freshData.name,"locks:",freshData.feature_locks);
        }
      });
      
      // Show onboarding if not complete
      if(!savedRest.onboarding_complete){
        setShowOnboarding(true);
      }
      return;
    }
    // If no saasOwner, don't auto-load any restaurant (customer should see directory)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  
  // SAAS: Show restaurant info in document title
  useEffect(()=>{
    if(restaurant){
      document.title=restaurant.name+" - "+(restaurant.plan==="trial"?"Trial":"POS");
    }
  },[restaurant]);
  
  // SAAS: Auto-login as restaurant owner for POS access
  // When SaaS owner is logged in, treat them as the restaurant's "owner" role staff
  useEffect(()=>{
    if(saasOwner&&!user){
      // Create a virtual staff user from SaaS owner
      var avatarLetters=(saasOwner.full_name||"Owner").split(" ").map(p=>p[0]).join("").substring(0,2).toUpperCase()||"OW";
      var virtualStaff={
        id:"saas-"+saasOwner.id,
        name:saasOwner.full_name||"Owner",
        email:saasOwner.email,
        pw:"",
        avatar:avatarLetters,
        role:"owner",
      };
      setUser(virtualStaff);
      try{localStorage.setItem("latavola_user",JSON.stringify(virtualStaff));}catch(e){}
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[saasOwner]);
  
  // SAAS-2: Handle successful auth
  var handleAuthSuccess=(owner,rest)=>{
    // Clear any cached branch/user from previous restaurant
    try{
      localStorage.removeItem("latavola_branch");
      localStorage.removeItem("latavola_user");
    }catch(e){}
    setBranch(null);
    setUser(null);
    setSaasOwner(owner);
    setRestaurant(rest);
    
    // CRITICAL: Save session so refresh works (offline or online)
    try{
      dbSaveOwner(owner,rest);
      console.log("Session saved for refresh");
    }catch(e){console.error("Failed to save session:",e);}
    
    // CACHE login for offline use (just non-sensitive data)
    try{
      localStorage.setItem("latavola_offline_login",JSON.stringify({
        owner:{
          id:owner.id,
          email:owner.email,
          full_name:owner.full_name,
          phone:owner.phone,
        },
        restaurant:rest,
        cachedAt:Date.now(),
      }));
      console.log("Login cached for offline use");
    }catch(e){console.error("Failed to cache login:",e);}
    
    if(!rest.onboarding_complete){
      setShowOnboarding(true);
    }
  };
  
  // Restore from offline login cache (when offline and no active session)
  useEffect(()=>{
    if(saasOwner||restaurant)return; // Already logged in
    if(navigator.onLine!==false)return; // We have internet, normal login should work
    
    try{
      var cached=localStorage.getItem("latavola_offline_login");
      if(!cached)return;
      var data=JSON.parse(cached);
      // Auto-restore offline session
      console.log("Restoring offline session for:",data.owner.email);
      setSaasOwner(data.owner);
      setRestaurant(data.restaurant);
      // Show notification
      setTimeout(()=>{
        setNotifs(ns=>[...ns.slice(-3),{id:++nid.current,title:"Offline mode",body:"Logged in from cache. Will sync when online.",color:"#d97706"}]);
      },1000);
    }catch(e){console.error("Failed to restore offline login:",e);}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[saasOwner,restaurant]);
  
  // SAAS-2: Logout
  var handleSaasLogout=()=>{
    if(window.confirm("Sign out of La Tavola Platform?")){
      dbLogoutSaaS();
      setSaasOwner(null);
      setRestaurant(null);
      // Also clear regular user
      try{localStorage.removeItem("latavola_user");localStorage.removeItem("latavola_branch");}catch(e){}
      setUser(null);
      setBranch(null);
      window.location.reload();
    }
  };

  // Persist user session so refresh doesn't log out
  useEffect(()=>{
    try{
      if(user)localStorage.setItem("latavola_user",JSON.stringify(user));
      else localStorage.removeItem("latavola_user");
    }catch(e){}
  },[user]);

  useEffect(()=>{
    try{
      if(branch)localStorage.setItem("latavola_branch",JSON.stringify(branch));
      else localStorage.removeItem("latavola_branch");
    }catch(e){}
  },[branch]);

  // Auto-detect branch from QR code URL (customer scans QR at table)
  useEffect(()=>{
    if(typeof window==="undefined")return;
    var params=new URLSearchParams(window.location.search);
    var qrBranch=params.get("branch");
    if(qrBranch&&!branch){
      var b=currentBranches.find(x=>x.id===qrBranch);
      if(b)setBranch(b);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  // Load data from Supabase on app start
  // PHASE A: Wait until URL is checked AND restaurant is set so queries use correct ID
  useEffect(()=>{
    if(!urlChecked)return;
    if(!restaurant)return;
    
    // OFFLINE MODE: Use all cached data
    if(navigator.onLine===false){
      console.log("Offline mode - loading from cache");
      // Load all cached data
      var cachedMenu=getCached(OFFLINE_MENU_KEY);
      if(cachedMenu&&cachedMenu.length){
        setMenu(cachedMenu);
        console.log("Cached menu loaded:",cachedMenu.length,"items");
      }
      var cachedTables=LS.get("latavola_cached_tables");
      if(cachedTables&&cachedTables.length){
        setTables(cachedTables);
        console.log("Cached tables loaded:",cachedTables.length);
      }
      var cachedCats=LS.get("latavola_cached_categories");
      if(cachedCats&&cachedCats.length){
        setCategories(cachedCats);
        console.log("Cached categories loaded:",cachedCats.length);
      }
      var cachedOrders=LS.get("latavola_cached_orders");
      if(cachedOrders&&cachedOrders.length){
        setOrders(cachedOrders);
        console.log("Cached orders loaded:",cachedOrders.length);
      }
      push&&push({title:"Offline mode",body:"Showing cached data. Changes will sync when online.",color:"#d97706"});
      return; // Don't try to load from DB
    }
    
    // ONLINE MODE: Clear and load fresh
    setOrders([]);
    setMenu([]);
    setCategories([]);
    setTables([]);
    setCustomers([]);
    // Load orders from the database
    fetchOrders().then(dbOrders=>{
      if(dbOrders&&dbOrders.length){
        var formatted=dbOrders.map(o=>({
          id:o.order_number,
          branchId:o.branch_id,
          userId:o.customer_id,
          customer:o.customer_name||"Guest",
          phone:o.customer_phone,
          items:o.items||[],
          subtotal:parseFloat(o.subtotal||0),
          deliveryFee:parseFloat(o.delivery_fee||0),
          total:parseFloat(o.total||0),
          status:o.status,
          type:o.type,
          paid:o.paid,
          payMethod:o.pay_method,
          address:o.address,
          slot:o.slot,
          takenBy:o.taken_by,
          source:o.source,
          tableId:o.table_id,stationProgress:o.station_progress||{},deliveryCode:o.delivery_code,codeMethod:o.code_method,deliveredAt:o.delivered_at,deliveredBy:o.delivered_by,cashCollected:o.cash_collected?parseFloat(o.cash_collected):null,cashHandoverId:o.cash_handover_id,serviceCharge:parseFloat(o.service_charge||0),discount:parseFloat(o.discount||0),
          created_at:o.created_at,
          time:new Date(o.created_at).toLocaleTimeString("en-GB",{hour:"2-digit",minute:"2-digit"}),
        }));
        setOrders(formatted);
        try{LS.set("latavola_cached_orders",formatted.slice(0,100));}catch(e){}
      }
    }).catch(e=>console.log("Orders load failed (using demo data):",e));

    // Load menu items - ALWAYS try DB first, cache as fallback
    dbFetchMenu().then(dbMenu=>{
      if(dbMenu&&dbMenu.length){
        // DEDUPE: remove duplicate items by name+category (keep first/oldest)
        var seen=new Set();
        var deduped=dbMenu.filter(m=>{
          var key=(m.name||"").toLowerCase().trim()+"|"+(m.category_name||"").toLowerCase().trim();
          if(seen.has(key))return false;
          seen.add(key);
          return true;
        });
        var formatted=deduped.map(m=>({
          id:m.id,
          dbId:m.id,
          name:m.name,
          desc:m.description||"",
          price:parseFloat(m.price),
          cat:m.category_name||"Mains",
          icon:m.icon,
          stock:m.stock,
          avail:m.available,
          // Convert legacy format (array of strings/ids) to new format (array of objects)
          allergens:Array.isArray(m.allergens)?m.allergens.map(a=>typeof a==="object"?a:{id:"al_"+a,name:a.replace(/^al-/,"").replace(/_/g," ").replace(/\b\w/g,l=>l.toUpperCase())}):[],
          sizes:Array.isArray(m.sizes)?m.sizes.map(s=>typeof s==="object"?s:{id:"sz_"+s,name:s.replace(/^sz-/,"").charAt(0).toUpperCase()+s.replace(/^sz-/,"").slice(1),priceAdj:0}):[],
          extras:Array.isArray(m.extras)?m.extras.map(x=>typeof x==="object"?x:{id:"ex_"+x,name:x.replace(/^ex-/,"").replace(/_/g," ").replace(/\b\w/g,l=>l.toUpperCase()),priceAdj:0}):[],
          cookingOpts:Array.isArray(m.cooking_opts)?m.cooking_opts.map(c=>typeof c==="object"?c:{id:"ck_"+c,name:c.replace(/^ck-/,"").charAt(0).toUpperCase()+c.replace(/^ck-/,"").slice(1)}):[],
          station:m.station||null,
          priceDineIn:m.price_dinein?parseFloat(m.price_dinein):null,
          priceTakeaway:m.price_takeaway?parseFloat(m.price_takeaway):null,
          priceDelivery:m.price_delivery?parseFloat(m.price_delivery):null,
          availDineIn:m.avail_dinein!==false,
          availTakeaway:m.avail_takeaway!==false,
          availDelivery:m.avail_delivery!==false,
          image_url:m.image_url||null,
        }));
        setMenu(formatted);
        // Cache for future offline use
        cacheForOffline(OFFLINE_MENU_KEY,formatted);
        console.log("Menu loaded from DB:",formatted.length,"items");
      } else {
        // DB returned empty - try cache
        var cachedMenu=getCached(OFFLINE_MENU_KEY);
        if(cachedMenu&&cachedMenu.length){
          setMenu(cachedMenu);
          console.log("Menu loaded from cache (DB empty):",cachedMenu.length,"items");
        }
      }
    }).catch(e=>{
      console.log("Menu DB load failed, trying cache:",e);
      // DB failed - fallback to cache
      var cachedMenu=getCached(OFFLINE_MENU_KEY);
      if(cachedMenu&&cachedMenu.length){
        setMenu(cachedMenu);
        push&&push({title:"Using offline menu",body:"Could not connect to server",color:"#d97706"});
      }
    });

    // Load categories from the database
    dbFetchCategories().then(dbCats=>{
      if(dbCats&&dbCats.length){
        var formatted=dbCats.map(c=>({
          id:c.id,
          dbId:c.id,
          name:c.name,
          icon:c.icon,
          order:c.display_order,
        }));
        setCategories(formatted);
        try{LS.set("latavola_cached_categories",formatted);}catch(e){}
      }
    }).catch(e=>console.log("Categories load failed:",e));

    // Load set meals from the database
    dbFetchSetMeals().then(dbMeals=>{
      if(dbMeals&&dbMeals.length){
        var formatted=dbMeals.map(m=>({
          id:m.id,
          dbId:m.id,
          name:m.name,
          desc:m.description||"",
          price:parseFloat(m.price),
          itemIds:m.item_ids||[],
          icon:m.icon,
          avail:m.available,
        }));
        setSetMeals(formatted);
      }
    }).catch(e=>console.log("Set meals load failed:",e));

    // Load customers from the database (for phone order lookups)
    dbFetchCustomers().then(dbCust=>{
      if(dbCust&&dbCust.length){
        var formatted=dbCust.map(c=>({
          id:c.id,
          dbId:c.id,
          phone:c.phone,
          name:c.name,
          email:c.email,
          address:c.address?(typeof c.address==="string"?{line1:c.address,postcode:""}:c.address):{line1:"",postcode:""},
          distance:c.distance?parseFloat(c.distance):0,
          totalOrders:c.total_orders||0,
          totalSpent:parseFloat(c.total_spent||0),
          notes:c.notes||"",
        }));
        setCustomers(formatted);
      }
    }).catch(e=>console.log("Customers load failed:",e));

    // Load reviews from the database
    dbFetchReviews().then(dbReviews=>{
      if(dbReviews&&dbReviews.length){
        var formatted=dbReviews.map(r=>({
          id:r.id,
          name:r.customer_name,
          rating:r.rating,
          comment:r.comment,
          date:new Date(r.created_at).toLocaleDateString("en-GB",{day:"numeric",month:"short"}),
          helpful:0,
        }));
        setReviews(formatted);
      }
    }).catch(e=>console.log("Reviews load failed:",e));

    // Load tables from the database (for all branches - filter per branch in TablesV)
    dbFetchTables().then(dbTables=>{
      if(dbTables&&dbTables.length){
        var formatted=dbTables.map(t=>({
          id:t.table_number||t.id,
          dbId:t.id,
          branchId:t.branch_id,
          seats:t.seats,
          x:t.x_pos!==null&&t.x_pos!==undefined?t.x_pos:(t.position_x||50),
          y:t.y_pos!==null&&t.y_pos!==undefined?t.y_pos:(t.position_y||50),
          status:t.status||"free",
          shape:t.shape||"rectangle",
        }));
        setTables(formatted);
        try{window.__allTables=formatted;LS.set("latavola_cached_tables",formatted);}catch(e){}
      }
    }).catch(e=>console.log("Tables load failed:",e));

    // Load kitchen stations
    dbFetchStations().then(list=>{
      if(list&&list.length){
        setStations(list.map(s=>({
          dbId:s.id,name:s.name,icon:s.icon,color:s.color,
          sortOrder:s.sort_order,active:s.active,
          printerMethod:s.printer_method||"none",
          printerFormat:s.printer_format||"thermal",
          printContent:s.print_content||"station_only",
          autoPrint:s.auto_print||false,
          printnodeId:s.printnode_id||null,
          copies:s.copies||1,
        })));
      }
    }).catch(e=>console.log("Stations load failed:",e));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[urlChecked,restaurant?.id]);

  // Auto-refresh orders every 15 seconds (so customers see status updates and staff sees new orders)
  useEffect(()=>{
    var interval=setInterval(()=>{
      fetchOrders().then(dbOrders=>{
        if(dbOrders&&dbOrders.length){
          var formatted=dbOrders.map(o=>({
            id:o.order_number,branchId:o.branch_id,userId:o.customer_id,
            customer:o.customer_name||"Guest",phone:o.customer_phone,
            items:o.items||[],subtotal:parseFloat(o.subtotal||0),
            deliveryFee:parseFloat(o.delivery_fee||0),total:parseFloat(o.total||0),
            status:o.status,type:o.type,paid:o.paid,payMethod:o.pay_method,
            address:o.address,slot:o.slot,takenBy:o.taken_by,source:o.source,
            tableId:o.table_id,stationProgress:o.station_progress||{},deliveryCode:o.delivery_code,codeMethod:o.code_method,deliveredAt:o.delivered_at,deliveredBy:o.delivered_by,cashCollected:o.cash_collected?parseFloat(o.cash_collected):null,cashHandoverId:o.cash_handover_id,serviceCharge:parseFloat(o.service_charge||0),discount:parseFloat(o.discount||0),
            assignedDriverId:o.assigned_driver_id,assignedDriverName:o.assigned_driver_name,claimedAt:o.claimed_at,handoverId:o.handover_id,
            created_at:o.created_at,
            time:new Date(o.created_at).toLocaleTimeString("en-GB",{hour:"2-digit",minute:"2-digit"}),
          }));
          setOrders(formatted);
        }
      }).catch(e=>console.log("Order auto-refresh failed:",e));
    },15000);
    return()=>clearInterval(interval);
  },[]);

  // Monitor network status - multiple methods
  useEffect(()=>{
    var goOnline=()=>{
      setOnline(true);
      console.log("Online event - triggering sync");
      syncQueue();
    };
    var goOffline=()=>{
      setOnline(false);
      console.log("Offline event");
    };
    
    // Periodic check (every 10 seconds) - catches cases where events don't fire
    var checkInterval=setInterval(()=>{
      var actuallyOnline=navigator.onLine!==false;
      setOnline(prev=>{
        if(prev!==actuallyOnline){
          console.log("State changed:",prev,"->",actuallyOnline);
          if(actuallyOnline){
            // Came online, try sync
            setTimeout(()=>syncQueue(),500);
          }
        }
        return actuallyOnline;
      });
    },10000);
    
    if(typeof window!=="undefined"){
      window.addEventListener("online",goOnline);
      window.addEventListener("offline",goOffline);
      
      // On mount: if we have queued orders and we're online, sync them
      setTimeout(()=>{
        if(navigator.onLine!==false && getQueue().length>0){
          console.log("App started with",getQueue().length,"queued orders - syncing");
          syncQueue();
        }
      },2000);
      
      return()=>{
        window.removeEventListener("online",goOnline);
        window.removeEventListener("offline",goOffline);
        clearInterval(checkInterval);
      };
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  // Sync queued orders when back online - ACTUALLY SAVE TO DB
  var syncQueue=useCallback(async()=>{
    var q=getQueue();
    if(!q.length){
      console.log("No orders to sync");
      return;
    }
    console.log("Syncing",q.length,"queued orders");
    setNotifs(ns=>[...ns.slice(-3),{id:++nid.current,title:"Syncing...",body:"Uploading "+q.length+" offline order"+(q.length>1?"s":""),color:"#0891b2"}]);
    
    // Get CURRENT state of orders (which may have updated status, paid, etc.)
    var currentOrders=ordersRef.current||[];
    
    var successCount=0;
    var failedOrders=[];
    var successIds=[];
    for(let o of q){
      try{
        // Use current state of order (with updated status/paid/etc.)
        let currentOrder=currentOrders.find(co=>co.id===o.id);
        let orderToSave=currentOrder||o;
        
        console.log("Syncing order:",orderToSave.id,"status:",orderToSave.status,"paid:",orderToSave.paid);
        let result=await saveOrderToDb(orderToSave);
        if(result.error){
          console.error("Sync failed for order:",o.id,result.error);
          failedOrders.push(o);
        }else{
          successCount++;
          successIds.push(o.id);
          console.log("Synced order to DB:",o.id);
        }
      }catch(e){
        console.error("Sync exception:",e);
        failedOrders.push(o);
      }
    }
    
    // Remove offline flag from synced orders in local state
    if(successIds.length>0){
      setOrders(prev=>prev.map(o=>successIds.includes(o.id)?{...o,offline:false,synced:true}:o));
      
      // CRITICAL FIX: For each synced order, update DB status to match current local status
      // (e.g., kitchen marked as "ready" while offline - we need to push that to DB)
      var ordersWithUpdates=q.filter(o=>successIds.includes(o.id));
      for(let queuedOrder of ordersWithUpdates){
        try{
          let currentOrder=currentOrders.find(co=>co.id===queuedOrder.id);
          if(currentOrder){
            // Update status if it changed from queue's original
            if(currentOrder.status&&currentOrder.status!==queuedOrder.status){
              await dbUpdateOrderStatus(currentOrder.id,currentOrder.status);
              console.log("Updated DB status for",currentOrder.id,"to",currentOrder.status);
            }
            // Update paid if it changed
            if(currentOrder.paid&&!queuedOrder.paid){
              await dbUpdateOrderPayment(currentOrder.id,true,currentOrder.payMethod||"cash");
              console.log("Updated DB paid status for",currentOrder.id);
            }
          }
        }catch(e){console.error("Failed to update synced order status:",e);}
      }
      
      // Also sync table statuses to DB for dine-in orders
      var dineInOrders=q.filter(o=>successIds.includes(o.id)&&o.type==="dine-in"&&o.tableId);
      
      // Build a map of tableId -> order info for local state update
      var tableUpdates={};
      
      for(let dio of dineInOrders){
        try{
          let allTablesData=window.__allTables||[];
          let tbl=allTablesData.find(t=>String(t.id)===String(dio.tableId)&&(!dio.branchId||!t.branchId||t.branchId===dio.branchId));
          if(tbl&&tbl.dbId){
            await dbUpdateTableStatus(tbl.dbId,"occupied",{});
            console.log("Synced table status to DB for table",dio.tableId);
            tableUpdates[String(dio.tableId)]={
              status:"occupied",
              since:tbl.since||new Date().toLocaleTimeString(),
              guests:tbl.guests||dio.guests||2,
            };
          }
        }catch(te){console.log("Failed to sync table status:",te);}
      }
      
      // Update local tables state with occupied status
      if(Object.keys(tableUpdates).length>0){
        setTables(prev=>prev.map(t=>{
          var update=tableUpdates[String(t.id)];
          return update?{...t,...update}:t;
        }));
        console.log("Local tables state updated after sync");
      }
    }
    
    // Save back the failed ones, clear the successful ones
    if(failedOrders.length>0){
      LS.set(OFFLINE_QUEUE_KEY,failedOrders);
      setPendingCount(failedOrders.length);
      setNotifs(ns=>[...ns.slice(-3),{id:++nid.current,title:"Partial sync",body:successCount+" uploaded, "+failedOrders.length+" failed",color:"#d97706"}]);
    }else{
      clearQueue();
      setPendingCount(0);
      setNotifs(ns=>[...ns.slice(-3),{id:++nid.current,title:"Synced!",body:successCount+" order"+(successCount>1?"s":"")+" uploaded successfully",color:"#059669"}]);
    }
  },[]);
  useEffect(()=>{var s=document.createElement("style");s.textContent=CSS;document.head.appendChild(s);return()=>document.head.removeChild(s);},[]);
  var push=useCallback(n=>{var id=++nid.current;setNotifs(ns=>[...ns.slice(-3),{...n,id}]);setTimeout(()=>setNotifs(ns=>ns.filter(x=>x.id!==id)),5000);},[]);
  
  // PRETTY ALERT - replaces window.alert
  var showAlert=useCallback((title,message,type)=>{
    return new Promise(resolve=>{
      setAlertModal({title:title||"Notice",message:message||"",type:type||"info",onClose:()=>{setAlertModal(null);resolve(true);}});
    });
  },[]);
  
  // PRETTY CONFIRM - replaces window.confirm
  var showConfirm=useCallback((title,message,opts)=>{
    return new Promise(resolve=>{
      setConfirmModal({
        title:title||"Confirm",
        message:message||"",
        confirmText:(opts&&opts.confirmText)||"Confirm",
        cancelText:(opts&&opts.cancelText)||"Cancel",
        type:opts&&opts.type,
        destructive:opts&&opts.destructive,
        onConfirm:()=>{setConfirmModal(null);resolve(true);},
        onCancel:()=>{setConfirmModal(null);resolve(false);},
      });
    });
  },[]);
  
  // Make available globally for any component to use
  useEffect(()=>{
    try{
      window.showAlert=showAlert;
      window.showConfirm=showConfirm;
      // OVERRIDE window.alert and window.confirm globally
      if(!window.__originalAlert)window.__originalAlert=window.alert;
      if(!window.__originalConfirm)window.__originalConfirm=window.confirm;
      window.alert=(msg)=>{showAlert("Notice",String(msg||""),"info");};
      // Note: window.confirm needs synchronous response, but we use async - this is a limitation
      // Components that use window.confirm should switch to showConfirm for pretty UI
    }catch(e){}
  },[showAlert,showConfirm]);
  
  var addOrder=o=>{
    if(!online){
      var count=queueOffline(o);
      setPendingCount(count);
      push({title:"Saved offline",body:"Will sync when online ("+count+" pending)",color:"#d97706"});
      setOrders(os=>[{...o,offline:true},...os]);
      
      // CRITICAL: Update table status locally for dine-in offline orders
      if(o.type==="dine-in"&&o.tableId){
        setTables(ts=>ts.map(t=>{
          var matches=String(t.id)===String(o.tableId)&&(!o.branchId||!t.branchId||t.branchId===o.branchId);
          return matches?{...t,status:"occupied",since:t.since||new Date().toLocaleTimeString(),guests:t.guests||o.guests||2}:t;
        }));
      }
    }else{
      setOrders(os=>[o,...os]);
      // Save to Supabase database
      saveOrderToDb(o).then(result=>{
        if(result.error){
          console.log("DB save failed, but order is in memory:",result.error);
        }else{
          console.log("Order saved to database:",o.id);
          // Commission is now only recorded when order is delivered/collected + paid
          // (see updateOrderStatus / payment confirmation handlers)
          // Award loyalty points if user has account (10 points per pound spent)
          if(o.userId&&o.userId!=="guest"&&o.userId!=="staff"&&o.paid){
            var pts=Math.floor((o.subtotal||o.total||0)*10);
            if(pts>0){
              dbAwardPoints(o.userId,pts,o.id,"Order rewards").then(r=>{
                if(r&&r.points){
                  push({title:"Loyalty rewards!",body:"+"+pts+" points - now "+r.points+" total",color:"#d4952a"});
                }
              }).catch(e=>console.log("Loyalty award failed:",e));
            }
          }
        }
      }).catch(e=>console.log("DB error:",e));
    }
    setMenu(ms=>ms.map(m=>{var f=o.items.find(i=>i.id===m.id);if(!f)return m;var ns=Math.max(0,m.stock-f.qty);if(ns===0)push({title:"Out of stock!",body:m.name,color:"#dc2626"});else if(ns<=5)push({title:"Low stock",body:m.name+" - "+ns+" left",color:"#d97706"});return{...m,stock:ns};}));
    if(o.discCode)setDiscs(ds=>ds.map(d=>d.code===o.discCode?{...d,uses:d.uses+1}:d));
  };
  useEffect(()=>{
    if(user?.role==="kitchen")setView("kitchen");
    else if(user?.role==="driver")setView("driver");
    else if(user?.role==="owner"||user?.role==="manager"||user?.role==="waiter")setView("pos");
  },[user]);
  
  // ALSO check active staff (PIN login) for role-based redirect
  useEffect(()=>{
    var activeStaff=(typeof window!=="undefined")?dbGetActiveStaff():null;
    if(activeStaff?.position==="driver")setView("driver");
    else if(activeStaff?.position==="kitchen")setView("kitchen");
  },[]);
  
  var isStaff=user&&user.role!=="customer";
  
  // Check if logged in user OR active PIN staff is a driver
  var activeStaffData=(typeof window!=="undefined")?dbGetActiveStaff():null;
  var isDriver=user?.role==="driver"||activeStaffData?.position==="driver";
  
  // DRIVERS only see driver tab + account
  var allTabs;
  if(isDriver){
    allTabs=["driver","account"];
  }else if(isStaff){
    allTabs=["pos","phone","tables","bookings","incoming","driver","kitchen","admin","report","chat","account"];
  }else{
    allTabs=["menu","track","book","reviews","account"];
  }
  
  // FILTER nav based on restaurant service types AND staff permissions
  var tabs=allTabs.filter(t=>{
    if(!restaurant)return true;
    
    // Customer-facing filters
    if(t==="book" && !hasService(restaurant,"dine_in"))return false;
    
    // Staff-facing filters
    if(t==="tables" && !hasService(restaurant,"dine_in"))return false;
    if(t==="bookings" && !hasService(restaurant,"dine_in"))return false;
    if(t==="driver" && !hasService(restaurant,"delivery"))return false;
    if(t==="phone" && !hasService(restaurant,"phone_orders"))return false;
    
    // STAFF PERMISSION FILTERING (when a staff member is PIN-logged-in)
    // No active staff = restaurant owner = full access
    if(activeStaff){
      var perms=activeStaff.permissions||{};
      // "account" and "chat" always allowed
      if(t==="account"||t==="chat")return true;
      // POS / phone / tables / bookings / incoming = need take_orders
      if(["pos","phone","tables","bookings","incoming"].includes(t)){
        return perms.take_orders===true;
      }
      // Admin tab = need a MANAGEMENT permission (NOT view_reports - that's just for Reports tab)
      if(t==="admin"){
        return perms.manage_menu===true||perms.manage_staff===true||perms.manage_settings===true||perms.view_finance===true;
      }
      // Reports tab = need view_reports ONLY
      if(t==="report"){
        return perms.view_reports===true;
      }
      // Kitchen / Driver = need take_orders (operational)
      if(t==="kitchen"||t==="driver"){
        return perms.take_orders===true;
      }
    }
    
    return true;
  });
  
  var tl={menu:t("order"),track:t("track"),book:t("book"),reviews:t("reviews"),account:t("account"),chat:t("chat"),kitchen:"Kitchen",admin:"Admin",report:"Reports",pos:"POS",tables:"Tables",phone:"Phone",bookings:"Bookings",incoming:"Incoming",driver:"Driver"};
  var ti={menu:"cart",track:"pin",book:"cal",reviews:"star",account:"person",chat:"chat",kitchen:"cook",admin:"gear",report:"chart",pos:"cart",tables:"pin",phone:"phone",bookings:"cal",incoming:"bag",driver:"pin"};

  // PHASE A: Don't show anything until URL is checked
  if(!urlChecked){
    return <></>;
  }
  
  // SUPER ADMIN: Show panel if URL has admin code AND user is logged in as admin
  if(showSuperAdmin){
    if(!saasOwner){
      // Not logged in - show login first
      return <><style>{CSS}</style><SaaSAuthScreen onAuthSuccess={(o,r)=>{
        handleAuthSuccess(o,r);
        // Will check admin status in next render
      }}/></>;
    }
    if(!isAdmin){
      // Logged in but not admin
      return <div style={{minHeight:"100vh",background:"#0f0a05",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",padding:22,fontFamily:"-apple-system,sans-serif"}}>
        <div style={{textAlign:"center",maxWidth:420}}>
          <p style={{fontSize:60,marginBottom:14}}>{String.fromCharCode(0xD83D,0xDD12)}</p>
          <h2 style={{fontSize:22,marginBottom:9,fontFamily:"Georgia,serif"}}>Access Denied</h2>
          <p style={{color:"#a8956a",marginBottom:18,fontSize:13}}>You don't have super admin permissions. This area is restricted to platform administrators only.</p>
          <button onClick={()=>{setShowSuperAdmin(false);window.history.replaceState({},"","/");}} style={{padding:"11px 22px",background:"#bf4626",color:"#fff",border:"none",borderRadius:9,fontWeight:700,cursor:"pointer"}}>Back to App</button>
        </div>
      </div>;
    }
    // User is admin - show panel
    return <><style>{CSS}</style><SuperAdminPanel saasOwner={saasOwner} onExit={()=>{setShowSuperAdmin(false);window.history.replaceState({},"","/");}}/></>;
  }
  
  // SALES REP PORTAL
  if(showRepPortal){
    if(!currentRep){
      // Show rep login
      return <><style>{CSS}</style>
        <SalesRepLogin onLogin={r=>{setCurrentRep(r);}}/>
      </>;
    }
    // Rep is logged in - show dashboard
    return <><style>{CSS}</style>
      <SalesRepDashboard rep={currentRep} onLogout={()=>{dbLogoutRep();setCurrentRep(null);setShowRepPortal(false);window.history.replaceState({},"","/");}}/>
    </>;
  }
  
  // DRIVER PORTAL
  if(showDriverPortal){
    if(!currentDriver){
      // Show driver login
      return <><style>{CSS}</style>
        <DriverLoginScreen onLogin={d=>{setCurrentDriver(d);}}/>
      </>;
    }
    // Driver is logged in - show standalone driver view (no other tabs)
    return <><style>{CSS}</style>
      <DriverStandaloneView driver={currentDriver} onLogout={()=>{dbLogoutDriver();setCurrentDriver(null);setShowDriverPortal(false);window.history.replaceState({},"","/");}}/>
    </>;
  }
  
  // PHASE A: If customer visited via URL and detected a restaurant, skip auth - go to ordering
  // (customer doesn't need to login - they're a CUSTOMER not a restaurant owner)
  if(urlRestaurant&&!saasOwner){
    // Customer flow - load restaurant data and show menu
    // (continues to normal flow below with restaurant set)
  }else if(!saasOwner){
    // Not logged in AND no URL match
    var params;
    try{params=new URLSearchParams(window.location.search);}catch(e){params=null;}
    // Optional: directory still reachable via ?directory=1
    var wantDirectory=params?(params.get("directory")==="1"):false;
    
    if(wantDirectory&&!restaurant){
      // Explicit directory request - show list of all restaurants
      return <><style>{CSS}</style><RestaurantDirectory onSelectRestaurant={r=>{
        window.location.href="/?r="+r.slug;
      }}/></>;
    }
    
    if(!restaurant){
      // HOMEPAGE = owner signup/login (SaaS landing for restaurant owners)
      return <><style>{CSS}</style><SaaSAuthScreen onAuthSuccess={handleAuthSuccess}/></>;
    }
    
    // Show auth screen
    return <><style>{CSS}</style><SaaSAuthScreen onAuthSuccess={handleAuthSuccess}/></>;
  }
  
  // SAAS-2: AUTH GATE - show login if not authenticated AND not customer view
  if(!restaurant){
    return <><style>{CSS}</style><SaaSAuthScreen onAuthSuccess={handleAuthSuccess}/></>;
  }

  // SUBSCRIPTION GATE - block access if expired/suspended (only for owners, not customers)
  if(saasOwner&&restaurant){
    var subStatus=checkSubscriptionStatus(restaurant);
    if(!subStatus.valid){
      return <><style>{CSS}</style>
        <div style={{minHeight:"100vh",background:"linear-gradient(135deg,#0f0a05,#1a1208)",color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",padding:22,fontFamily:"-apple-system,sans-serif"}}>
          <div style={{maxWidth:480,width:"100%",background:"#1a1208",border:"2px solid #5d3a1f",borderRadius:18,padding:28,textAlign:"center"}}>
            <div style={{fontSize:64,marginBottom:14}}>{subStatus.status==="suspended"?String.fromCharCode(0xD83D,0xDEAB):String.fromCharCode(0x23F0)}</div>
            <h2 style={{fontSize:24,fontWeight:700,marginBottom:9,color:"#fbbf24",fontFamily:"Georgia,serif"}}>{subStatus.status==="suspended"?"Account Suspended":"Subscription Expired"}</h2>
            <p style={{color:"#fff",marginBottom:14,fontSize:15}}><strong>{restaurant.name}</strong></p>
            <p style={{color:"#a8956a",marginBottom:18,fontSize:13,lineHeight:1.5}}>{subStatus.reason}</p>
            
            {subStatus.status==="expired"&&<div style={{padding:14,background:"#0f0a05",borderRadius:9,marginBottom:14,textAlign:"left",border:"1px solid #5d3a1f"}}>
              <p style={{fontSize:11,color:"#fbbf24",fontWeight:700,letterSpacing:1,marginBottom:9}}>{String.fromCharCode(0xD83D,0xDCB3)} TO REACTIVATE:</p>
              <p style={{fontSize:13,color:"#fff",marginBottom:7}}>Please contact us to renew your subscription:</p>
              <p style={{fontSize:13,color:"#0891b2",fontWeight:700}}>{String.fromCharCode(0xD83D,0xDCE7)} support@latavola.app</p>
              <p style={{fontSize:13,color:"#0891b2",fontWeight:700,marginTop:5}}>{String.fromCharCode(0xD83D,0xDCDE)} +44 7XXX XXX XXX</p>
            </div>}
            
            {subStatus.status==="suspended"&&<div style={{padding:14,background:"#0f0a05",borderRadius:9,marginBottom:14,textAlign:"left",border:"1px solid #dc2626"}}>
              <p style={{fontSize:11,color:"#fca5a5",fontWeight:700,letterSpacing:1,marginBottom:9}}>{String.fromCharCode(0x26A0,0xFE0F)} CONTACT SUPPORT:</p>
              <p style={{fontSize:13,color:"#fff",marginBottom:7}}>Your account has been suspended. Please contact us to resolve:</p>
              <p style={{fontSize:13,color:"#0891b2",fontWeight:700}}>{String.fromCharCode(0xD83D,0xDCE7)} support@latavola.app</p>
            </div>}
            
            <div style={{display:"flex",gap:9,marginTop:14}}>
              <button onClick={()=>{
                if(window.confirm("Sign out?")){
                  dbLogoutSaaS();
                  setSaasOwner(null);
                  setRestaurant(null);
                  setUser(null);
                  window.location.href="/";
                }
              }} style={{flex:1,padding:"11px",background:"#0f0a05",color:"#a8956a",border:"1px solid #5d3a1f",borderRadius:9,fontWeight:700,cursor:"pointer",fontSize:13}}>{String.fromCharCode(0x21AA,0xFE0F)} Sign Out</button>
              <button onClick={()=>window.location.reload()} style={{flex:1,padding:"11px",background:"#bf4626",color:"#fff",border:"none",borderRadius:9,fontWeight:700,cursor:"pointer",fontSize:13}}>{String.fromCharCode(0xD83D,0xDD04)} Refresh</button>
            </div>
          </div>
        </div>
      </>;
    }
  }
  
  // SAAS-2: ONBOARDING GATE - show wizard for new restaurants
  if(showOnboarding){
    return <><style>{CSS}</style><OnboardingWizard restaurant={restaurant} onComplete={()=>{
      setShowOnboarding(false);
      // Reload restaurant data
      dbFetchRestaurant(restaurant.id).then(r=>{if(r)setRestaurant(r);});
    }}/></>;
  }
  
  if(!branch) return <>
    <style>{CSS}</style>
    <div style={{minHeight:"100vh",background:"#f7f3ee"}}>
      <div style={{background:"#1a1208",height:56,display:"flex",alignItems:"center",padding:"0 16px",justifyContent:"space-between"}}>
        <span className="nlogo">La Tavola</span>
        {!user?<button onClick={()=>setAuth(true)} style={{border:"1px solid rgba(255,255,255,.2)",color:"#fff",borderRadius:7,padding:"5px 11px",fontSize:11,fontWeight:600,background:"none",cursor:"pointer"}}>Sign in</button>:<div style={{display:"flex",alignItems:"center",gap:7}}><div className="av">{user.avatar}</div><button onClick={()=>setUser(null)} style={{color:"#888",fontSize:11,border:"none",background:"none",cursor:"pointer"}}>Out</button></div>}
      </div>
      {showAuth&&<Auth onLogin={u=>setUser(u)} onClose={()=>setAuth(false)}/>}
      <BranchSel onSelect={setBranch} restaurant={restaurant}/>
    </div>
  </>;

  return <div style={{minHeight:"100vh",background:"#f7f3ee"}}>
    {/* Pretty Alert/Confirm System */}
    <PrettyAlertProvider/>
    
    {/* SUPER ADMIN: Impersonation banner */}
    {impersonating&&<div style={{background:"#7c3aed",color:"#fff",padding:"9px 14px",display:"flex",alignItems:"center",justifyContent:"space-between",gap:11,fontSize:12,fontWeight:700,position:"sticky",top:0,zIndex:9999,flexWrap:"wrap"}}>
      <div style={{display:"flex",alignItems:"center",gap:9,flexWrap:"wrap"}}>
        <span style={{fontSize:14}}>{String.fromCharCode(0xD83D,0xDC51)}</span>
        <span>SUPER ADMIN MODE - Viewing as: {impersonating.target_name}</span>
        <span style={{opacity:.7,fontSize:10}}>({impersonating.admin_email})</span>
      </div>
      <button onClick={async()=>{
        await dbStopImpersonate();
        setImpersonating(null);
        window.location.href="/?admin=lt-secret-2026";
      }} style={{padding:"5px 11px",background:"rgba(255,255,255,.2)",color:"#fff",border:"1px solid rgba(255,255,255,.3)",borderRadius:7,fontSize:11,fontWeight:700,cursor:"pointer"}}>{String.fromCharCode(0x21A9,0xFE0F)} Exit Impersonation</button>
    </div>}
    
    {/* STAFF PIN: Active staff banner */}
    <ActiveStaffBanner activeStaff={activeStaff} onSwitchUser={()=>{
      dbClearActiveStaff();
      setActiveStaffState(null);
      setShowStaffPinModal(true);
    }} onLogout={()=>{
      if(window.confirm("Sign out "+activeStaff.full_name+"?")){
        dbClearActiveStaff();
        setActiveStaffState(null);
      }
    }}/>
    
    {/* STAFF PIN: Login modal */}
    {showStaffPinModal && <StaffPINLoginModal 
      onSuccess={(staff)=>{
        setActiveStaffState(staff);
        setShowStaffPinModal(false);
        push&&push({title:"Welcome, "+staff.full_name+"!",color:"#22c55e"});
      }}
      onCancel={()=>{
        setShowStaffPinModal(false);
      }}
      allowSkip={true}
    />}
    
    <nav className="nav">
      {restaurant?.logo_url?
        <img src={restaurant.logo_url} alt={restaurant.name} style={{height:({small:32,medium:44,large:58,xlarge:74})[restaurant.logo_size||"medium"],maxWidth:220,objectFit:"contain"}}/>
        :
        <span className="nlogo">{restaurant?.name||"La Tavola"}</span>
      }
      {/* STAFF PIN: Login button (only show if logged in as restaurant owner) */}
      {restaurant&&saasOwner&&!activeStaff&&<button onClick={()=>setShowStaffPinModal(true)} title="Switch to staff member" style={{background:"rgba(8,145,178,.2)",color:"#0891b2",borderRadius:7,padding:"4px 9px",fontSize:10,fontWeight:700,border:"1px solid rgba(8,145,178,.3)",cursor:"pointer",whiteSpace:"nowrap"}}>{String.fromCharCode(0xD83D,0xDD10)} STAFF</button>}
      {/* SUPER ADMIN: Show admin button only to admins */}
      {isAdmin&&!impersonating&&<button onClick={()=>{setShowSuperAdmin(true);window.history.replaceState({},"","/?admin=lt-secret-2026");}} title="Super Admin Panel" style={{background:"rgba(251,191,36,.2)",color:"#fbbf24",borderRadius:7,padding:"4px 9px",fontSize:10,fontWeight:700,border:"1px solid rgba(251,191,36,.3)",cursor:"pointer",whiteSpace:"nowrap"}}>{String.fromCharCode(0xD83D,0xDC51)} ADMIN</button>}
      <div className="ntabs">{tabs.map(k=><button key={k} className={"ntab"+(view===k?" on":"")} onClick={()=>setView(k)}>{tl[k]||k}</button>)}</div>
      <div className="nright">
        {notifs.length>0&&<span style={{background:"#bf4626",color:"#fff",borderRadius:"50%",width:17,height:17,display:"flex",alignItems:"center",justifyContent:"center",fontSize:9,fontWeight:700}}>{notifs.length}</span>}
        {/* Customer sign-in/out - only when NOT a restaurant owner (owners use the Logout below) */}
        {!saasOwner&&(user?<><div className="av">{user.avatar}</div><button onClick={()=>{setUser(null);setView("menu");}} style={{color:"#888",fontSize:11,border:"none",background:"none",cursor:"pointer"}}>Out</button></>:<button onClick={()=>setAuth(true)} style={{border:"1px solid rgba(255,255,255,.2)",color:"#fff",borderRadius:7,padding:"5px 10px",fontSize:11,fontWeight:600,background:"none",cursor:"pointer"}}>Sign in</button>)}
        {/* Restaurant owner logout */}
        {saasOwner&&<button onClick={handleSaasLogout} title="Sign out of platform" style={{color:"#dc2626",fontSize:10,border:"1px solid rgba(220,38,38,.3)",background:"none",cursor:"pointer",padding:"3px 7px",borderRadius:5}}>{String.fromCharCode(0x21AA,0xFE0F)} Logout</button>}
      </div>
    </nav>
    {showRestaurantSwitcher&&<RestaurantSwitcher currentRestaurant={restaurant} onSwitch={r=>setRestaurant(r)} onClose={()=>setShowRestaurantSwitcher(false)}/>}
    {showQRGenerator&&restaurant&&<RestaurantQRGenerator restaurant={restaurant} onClose={()=>setShowQRGenerator(false)}/>}
    <div className="mnav">
      {tabs.map(k=><button key={k} className={"mbtn"+(view===k?" on":"")} onClick={()=>setView(k)}>
        <span className="mico">{EM[ti[k]]||""}</span>
        <span>{tl[k]||k}</span>
      </button>)}
    </div>
    {/* OFFLINE STATUS BANNER */}
    {!online && <div style={{position:"fixed",top:0,left:0,right:0,zIndex:9990,background:"linear-gradient(135deg,#dc2626,#991b1b)",color:"#fff",padding:"9px 15px",textAlign:"center",fontSize:12,fontWeight:700,boxShadow:"0 2px 8px rgba(0,0,0,.15)"}}>
      <span style={{fontSize:13,marginRight:6}}>{String.fromCharCode(0xD83D,0xDCF6)}</span>
      OFFLINE MODE
      <span style={{opacity:.85,marginLeft:9,fontWeight:500,fontSize:11}}>{pendingCount>0?"- "+pendingCount+" order"+(pendingCount>1?"s":"")+" queued to sync":"- Orders will save locally and sync when online"}</span>
    </div>}
    
    {/* PENDING SYNC BANNER (Online but has queue) */}
    {online && pendingCount>0 && <div style={{position:"fixed",top:0,left:0,right:0,zIndex:9990,background:"linear-gradient(135deg,#d97706,#92400e)",color:"#fff",padding:"11px 15px",textAlign:"center",fontSize:12,fontWeight:700,boxShadow:"0 2px 8px rgba(0,0,0,.15)",cursor:"pointer"}} onClick={syncQueue}>
      <span style={{fontSize:14,marginRight:6}}>{String.fromCharCode(0x23F3)}</span>
      {pendingCount} OFFLINE ORDER{pendingCount>1?"S":""} WAITING TO SYNC
      <span style={{opacity:.9,marginLeft:9,fontWeight:600,fontSize:11,textDecoration:"underline"}}>{String.fromCharCode(0xD83D,0xDC46)} Click here to sync now</span>
    </div>}
    
    <Toasts list={notifs} dismiss={id=>setNotifs(ns=>ns.filter(n=>n.id!==id))}/>
    {alertModal&&<AlertModal {...alertModal}/>}
    {confirmModal&&<ConfirmModal {...confirmModal}/>}
    {!online&&<div style={{background:"#dc2626",color:"#fff",padding:"8px 14px",display:"flex",alignItems:"center",justifyContent:"center",gap:8,fontSize:12,fontWeight:700,position:"sticky",top:58,zIndex:450}}>
      <span style={{width:8,height:8,borderRadius:"50%",background:"#fff",display:"inline-block",animation:"pulse 1s infinite"}}/>
      OFFLINE MODE - Orders saved locally{pendingCount>0?" ("+pendingCount+" pending sync)":""}
    </div>}
    {online&&pendingCount>0&&<div style={{background:"#059669",color:"#fff",padding:"8px 14px",display:"flex",alignItems:"center",justifyContent:"center",gap:8,fontSize:12,fontWeight:700}}>
      Back online - syncing {pendingCount} order{pendingCount>1?"s":""}...
    </div>}
    {showAuth&&<Auth onLogin={u=>setUser(u)} onClose={()=>setAuth(false)}/>}
    <main style={{paddingBottom:20,zoom:getUIScale()}}>
      {view==="menu"    &&<MenuV    menu={menu} user={user} branch={branch} onOrder={addOrder} push={push} discounts={discs} restaurant={restaurant}/>}
      {view==="pos"     &&<PosV     menu={menu} onOrder={addOrder} push={push} user={user} branch={branch} tables={tables} setTables={setTables} orders={orders} setOrders={setOrders} stations={stations} setView={setView} customers={customers} setCustomers={setCustomers} setUser={setUser} restaurant={restaurant}/>}
      {view==="phone"   &&<PhoneOrderV customers={customers} setCustomers={setCustomers} menu={menu} onOrder={addOrder} push={push} user={user} branch={branch} orders={orders} restaurant={restaurant}/>}
      {view==="tables"  &&<TablesV  tables={tables} setTables={setTables} push={push} branch={branch} orders={orders} setOrders={setOrders} onGoToPos={tableId=>{
        // Store preselected table so POS can pick it up
        window.__preselectedTable=String(tableId);
        setView("pos");
        push({title:"Adding to Table "+tableId,body:"Add items and send to kitchen",color:"#2563eb"});
      }}/>}
      {view==="bookings"&&<StaffBookingsV branch={branch} push={push}/>}
      {view==="incoming"&&<IncomingOrdersV orders={orders} setOrders={setOrders} push={push} branch={branch} customers={customers} tables={tables} setTables={setTables} stations={stations} menu={menu}/>}
      {view==="driver"&&<DriverV orders={orders} setOrders={setOrders} push={push} user={user} branch={branch}/>}
      {view==="track"   &&<TrackV   orders={orders} branches={currentBranches} user={user}/>}
      {view==="book"    &&<BookV    reservations={reservations} setReservations={setRes} user={user} onAuth={()=>setAuth(true)} branches={currentBranches} push={push}/>}
      {view==="reviews" &&<ReviewsV reviews={reviews} setReviews={setReviews} user={user} onAuth={()=>setAuth(true)}/>}
      {view==="account" &&<AccountV user={user} orders={orders} reviews={reviews} reservations={reservations} onAuth={()=>setAuth(true)} branches={currentBranches}/>}
      {view==="chat"    &&<ChatV    messages={messages} setMessages={setMessages} user={user} onAuth={()=>setAuth(true)}/>}
      {view==="kitchen" &&<KitchenV orders={orders} setOrders={setOrders} push={push} stations={stations} menu={menu}/>}
      {view==="admin"   &&<AdminV   orders={orders} setOrders={setOrders} menu={menu} setMenu={setMenu} discounts={discs} setDiscounts={setDiscs} push={push} branches={currentBranches} setMeals={setMeals} setSetMeals={setSetMeals} categories={categories} setCategories={setCategories} tables={tables} setTables={setTables} branch={branch} stations={stations} setStations={setStations} user={user} restaurant={restaurant} setRestaurant={setRestaurant}/>}
      {view==="report"  &&<ReportV  orders={orders}/>}
    </main>
  </div>;
}
